/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import { th } from 'date-fns/locale';
import moment from 'moment';
import { parse } from 'url';
import _ from 'lodash';
import { AnyPtrRecord } from 'dns';
import { inherits } from 'util';



export class SuperBit_swaggerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    private authToken: string | null = null;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAuthToken() {
        if (!this.authToken) {
            this.authToken = localStorage.getItem('AuthToken');
        }

        return this.authToken;
    }

    getDateString(date: Date) {
        const day = date.getDate();
        let dayString = day.toString();
        if (day < 10) {
            dayString = `0${day}`;
        }
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        let monthStr = month.toString()
        if (month < 10) {
            monthStr = `0${month}`;
        }
        const timeString = date.toISOString().split('T')[1];

        const dateString = `${year}-${monthStr}-${dayString}T${timeString}`;
        return dateString;
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    userLogin(body: any): Promise<EmailMessage> {
        let url_ = this.baseUrl + "/api/account/userLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserLogin(_response);
        });
    }

    protected processUserLogin(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response;
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body send OTP code to email by value in boody and identify user
     * @return Success
     */

    userSendOTPCode(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/account/userSendOTPCode";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = /*JSON.stringify*/JSONStringify(body);
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserSendOTPCode(_response);
        });
    }

    protected processUserSendOTPCode(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response;
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body body contains the code to verify
     * @return Success
     * ///
     * ///
     */

    userCheckOTPCode(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/account/userCheckOTPCode";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = /*JSON.stringify*/JSONStringify(body);
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserCheckOTPCode(_response);
        });
    }

    protected processUserCheckOTPCode(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response;
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    DownloadProductionFilesSholomo(): Promise<EmailMessage> {
        let url_ = this.baseUrl + "/api/IgudFiles/DownloadProductionFilesSholomo";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadProductionFilesSholomo(_response);
        });
    }

    protected processDownloadProductionFilesSholomo(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response;
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    SetToken(token: string): Promise<void> {
        let url_ = this.baseUrl + "/api/IgudFiles/SetToken";
        url_ = url_.replace(/[?&]$/, "");
        if (token === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const _token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetToken(_response);
        });
    }

    protected processSetToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    GetShlomoStatus(): Promise<string> {
        let url_ = this.baseUrl + "/api/IgudFiles/GetShlomoStatus";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShlomoStatus(_response);
        });
    }

    protected processGetShlomoStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    GetProductionStatus(): Promise<string> {
        let url_ = this.baseUrl + "/api/IgudFiles/GetProductionStatus";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionStatus(_response);
        });
    }

    protected processGetProductionStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
    * @param body (optional) 
    * @return Success
    */
    userLogout(body: any): Promise<void> {
        let url_ = this.baseUrl + "/api/account/userLogout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);


        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };



        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserLogout(_response);
        });
    }

    protected processUserLogout(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {

                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response;
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    userBreak(body: any): Promise<void> {
        let url_ = this.baseUrl + "/api/account/userBreak";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);


        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };



        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserBreak(_response);
        });
    }

    protected processUserBreak(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response;
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    userBreakEnd(body: any): Promise<void> {
        let url_ = this.baseUrl + "/api/account/userBreakEnd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);


        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };



        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserBreakEnd(_response);
        });
    }

    protected processUserBreakEnd(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response;
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userGetRoles(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/account/userGetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserGetRoles(_response);
        });
    }

    protected processUserGetRoles(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @return Success
     */
    register(): Promise<void> {
        let url_ = this.baseUrl + "/register";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    details(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/details?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    create(): Promise<void> {
        let url_ = this.baseUrl + "/create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param collection (optional) 
     * @return Success
     */
    create2(collection: StringStringValuesKeyValuePair[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (collection === null || collection === undefined)
            throw new Error("The parameter 'collection' cannot be null.");
        else
            content_.append("collection", collection.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate2(_response);
        });
    }

    protected processCreate2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    edit(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/edit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param collection (optional) 
     * @return Success
     */
    edit2(id: number | undefined, collection: StringStringValuesKeyValuePair[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/edit2?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (collection === null || collection === undefined)
            throw new Error("The parameter 'collection' cannot be null.");
        else
            content_.append("collection", collection.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEdit2(_response);
        });
    }

    protected processEdit2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param collection (optional) 
     * @return Success
     */
    delete2(id: number | undefined, collection: StringStringValuesKeyValuePair[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (collection === null || collection === undefined)
            throw new Error("The parameter 'collection' cannot be null.");
        else
            content_.append("collection", collection.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete2(_response);
        });
    }

    protected processDelete2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userSort(body: FilterDataModel | undefined): Promise<UsersModel> {
        let url_ = this.baseUrl + "/api/account/userSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserSort(_response);
        });
    }

    protected processUserSort(response: Response): Promise<UsersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UsersModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    userGet(id: string | undefined): Promise<UserCreateModel> {
        let url_ = this.baseUrl + "/api/account/userGet?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserGet(_response);
        });
    }

    protected processUserGet(response: Response): Promise<UserCreateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserCreateModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCreateModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    userGetTokenForUser(id: string | undefined): Promise<APIServiceUserModel> {
        let url_ = this.baseUrl + "/api/account/userGetTokenForUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserGetTokenForUser(_response);
        });
    }

    protected processUserGetTokenForUser(response: Response): Promise<APIServiceUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = APIServiceUserModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<APIServiceUserModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    userCancelTokenForUser(id: string | undefined): Promise<APIServiceUserModel> {
        let url_ = this.baseUrl + "/api/account/userCancelTokenForUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserCancelTokenForUser(_response);
        });
    }

    protected processUserCancelTokenForUser(response: Response): Promise<APIServiceUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = APIServiceUserModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<APIServiceUserModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userCreate(body: UserCreateModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/account/userCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserCreate(_response);
        });
    }

    protected processUserCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param email (optional) 
     * @param id (optional) 
     * @return Success
     */
    userCheckEmailExists(email: string | undefined, id: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/account/userCheckEmailExists?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserCheckEmailExists(_response);
        });
    }

    protected processUserCheckEmailExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @param id (optional) 
     * @return Success
     */
    userCheckPhoneExists(phone: string | undefined, id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/account/userCheckPhoneExists?";
        if (phone === null)
            throw new Error("The parameter 'phone' cannot be null.");
        else if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserCheckPhoneExists(_response);
        });
    }

    protected processUserCheckPhoneExists(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userUpdate(body: UserModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/account/userUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserUpdate(_response);
        });
    }

    protected processUserUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    userDelete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/account/userDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserDelete(_response);
        });
    }

    protected processUserDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userSaveFilterPageFieldsForUser(body: FilterPageFieldsData | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/account/userSaveFilterPageFieldsForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserSaveFilterPageFieldsForUser(_response);
        });
    }

    protected processUserSaveFilterPageFieldsForUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userUpdateAgents(body: AgentDetailsModel[] | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/account/userUpdateAgents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserUpdateAgents(_response);
        });
    }

    protected processUserUpdateAgents(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param user (optional) 
     * @param pwd (optional) 
     * @return Success
     */
    authenticateAuthenticate(user: string | undefined, pwd: string | undefined): Promise<DynamicObject6> {
        let url_ = this.baseUrl + "/api/account/authenticateAuthenticate?";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (pwd === null)
            throw new Error("The parameter 'pwd' cannot be null.");
        else if (pwd !== undefined)
            url_ += "pwd=" + encodeURIComponent("" + pwd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticateAuthenticate(_response);
        });
    }

    protected processAuthenticateAuthenticate(response: Response): Promise<DynamicObject6> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject6.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject6>(<any>null);
    }

    /**
     * @return Success
     */
    test(): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    test3(body: Test3Data | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/test3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest3(_response);
        });
    }

    protected processTest3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    systemManagementIndex(): Promise<SystemManagementModel> {
        let url_ = this.baseUrl + "/api/admin/systemManagementIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSystemManagementIndex(_response);
        });
    }

    protected processSystemManagementIndex(response: Response): Promise<SystemManagementModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemManagementModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemManagementModel>(<any>null);
    }

    /**
     * @param user (optional) 
     * @param pwd (optional) 
     * @return Success
     */
    authenticate(user: string | undefined, pwd: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/account/authenticate?";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (pwd === null)
            throw new Error("The parameter 'pwd' cannot be null.");
        else if (pwd !== undefined)
            url_ += "pwd=" + encodeURIComponent("" + pwd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getInsuranceTypes(): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        let url_ = this.baseUrl + "/api/Cache/getInsuranceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInsuranceTypes(_response);
        });
    }

    protected processGetInsuranceTypes(response: Response): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {} as any;
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200![key] = resultData200[key] ? IDNameDescriptionItem.fromJS(resultData200[key]) : new IDNameDescriptionItem();
                    }
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: IDNameDescriptionItem; }>(<any>null);
    }

    /**
     * @return Success
     */
    getGenderTypes(): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        let url_ = this.baseUrl + "/api/Cache/getGenderTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGenderTypes(_response);
        });
    }

    protected processGetGenderTypes(response: Response): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {} as any;
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200![key] = resultData200[key] ? IDNameDescriptionItem.fromJS(resultData200[key]) : new IDNameDescriptionItem();
                    }
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: IDNameDescriptionItem; }>(<any>null);
    }

    /**
     * @return Success
     */
    getAuthorizedToDriveItems(): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        let url_ = this.baseUrl + "/api/Cache/getAuthorizedToDriveItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthorizedToDriveItems(_response);
        });
    }

    protected processGetAuthorizedToDriveItems(response: Response): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {} as any;
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200![key] = resultData200[key] ? IDNameDescriptionItem.fromJS(resultData200[key]) : new IDNameDescriptionItem();
                    }
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: IDNameDescriptionItem; }>(<any>null);
    }

    /**
     * @param typeName (optional) 
     * @return Success
     */
    getAppDictionaryList(typeName: string | undefined): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        let url_ = this.baseUrl + "/api/Cache/GetAppDictionaryList?";
        if (typeName === null)
            throw new Error("The parameter 'typeName' cannot be null.");
        else if (typeName !== undefined)
            url_ += "typeName=" + encodeURIComponent("" + typeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppDictionaryList(_response);
        });
    }

    protected processGetAppDictionaryList(response: Response): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {} as any;
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200![key] = resultData200[key] ? IDNameDescriptionItem.fromJS(resultData200[key]) : new IDNameDescriptionItem();
                    }
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: IDNameDescriptionItem; }>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAppDictionaryList2(body: GetAppDictionaryListRequest | undefined): Promise<AppDictionaryListResponse> {
        let url_ = this.baseUrl + "/api/Cache/GetAppDictionaryList2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppDictionaryList2(_response);
        });
    }

    protected processGetAppDictionaryList2(response: Response): Promise<AppDictionaryListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppDictionaryListResponse.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDictionaryListResponse>(<any>null);
    }


    /**
     * @param typeName (optional) 
     * @return Success
     */
    getAppDictionaryLisExpanded(typeName: string | undefined): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        let url_ = this.baseUrl + "/api/Cache/GetAppDictionaryList?";
        if (typeName === null)
            throw new Error("The parameter 'typeName' cannot be null.");
        else if (typeName !== undefined)
            url_ += "typeName=" + encodeURIComponent("" + typeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppDictionaryListExpanded(_response);
        });
    }

    protected processGetAppDictionaryListExpanded(response: Response): Promise<{ [key: string]: IDNameDescriptionItem; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {} as any;
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200![key] = resultData200[key] ? IDNameDescriptionItem.fromJS(resultData200[key]) : new IDNameDescriptionItem();
                    }
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: IDNameDescriptionItem; }>(<any>null);
    }




    getBankList(): Promise<any[]> {
        let url_ = this.baseUrl + "/api/general/GetBanks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankList(_response);
        });
    }

    protected processGetBankList(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.Banks)) {
                    result200 = [] as any;
                    for (let item of resultData200.Banks)
                        result200!.push(item);
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(<any>null);
    }



    /**
     * @return Success
     */
    getAppDictionaryListOptions(): Promise<Int32StringKeyValuePair[]> {
        let url_ = this.baseUrl + "/api/Cache/getAppDictionaryListOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppDictionaryListOptions(_response);
        });
    }

    protected processGetAppDictionaryListOptions(response: Response): Promise<Int32StringKeyValuePair[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Int32StringKeyValuePair.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Int32StringKeyValuePair[]>(<any>null);
    }

    /**
     * @param vehicleModelId (optional) 
     * @return Success
     */
    vehicleInfoGetVehicleSubModelsByVehicleModelId(vehicleModelId: string | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoGetVehicleSubModelsByVehicleModelId?";
        if (vehicleModelId === null)
            throw new Error("The parameter 'vehicleModelId' cannot be null.");
        else if (vehicleModelId !== undefined)
            url_ += "vehicleModelId=" + encodeURIComponent("" + vehicleModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoGetVehicleSubModelsByVehicleModelId(_response);
        });
    }

    protected processVehicleInfoGetVehicleSubModelsByVehicleModelId(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListItem.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(<any>null);
    }

    /**
     * @param manufacturerId (optional) 
     * @return Success
     */
    vehicleInfoGetVehicleModelsByManufacturerId(manufacturerId: string | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoGetVehicleModelsByManufacturerId?";
        if (manufacturerId === null)
            throw new Error("The parameter 'manufacturerId' cannot be null.");
        else if (manufacturerId !== undefined)
            url_ += "manufacturerId=" + encodeURIComponent("" + manufacturerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoGetVehicleModelsByManufacturerId(_response);
        });
    }

    protected processVehicleInfoGetVehicleModelsByManufacturerId(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListItem.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(<any>null);
    }

    /**
     * @param manufacturerId (optional) 
     * @return Success
     */
    vehicleInfoGetYearsByManufacturerId(manufacturerId: string | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoGetYearsByManufacturerId?";
        if (manufacturerId === null)
            throw new Error("The parameter 'manufacturerId' cannot be null.");
        else if (manufacturerId !== undefined)
            url_ += "manufacturerId=" + encodeURIComponent("" + manufacturerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoGetYearsByManufacturerId(_response);
        });
    }

    protected processVehicleInfoGetYearsByManufacturerId(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListItem.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    vehicleInfoGetManufacturers(): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoGetManufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoGetManufacturers(_response);
        });
    }

    protected processVehicleInfoGetManufacturers(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListItem.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    vehicleInfoGetVehicleById(id: string | undefined): Promise<DynamicObject5> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoGetVehicleById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoGetVehicleById(_response);
        });
    }

    protected processVehicleInfoGetVehicleById(response: Response): Promise<DynamicObject5> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject5.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject5>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    vehicleInfoGetVehicleSubModelsById(id: string | undefined): Promise<VehicleSubModel> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoGetVehicleSubModelsById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoGetVehicleSubModelsById(_response);
        });
    }

    protected processVehicleInfoGetVehicleSubModelsById(response: Response): Promise<VehicleSubModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VehicleSubModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleSubModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    vehicleInfoGetVehicleSubModelsByModelCode(modelCode: string | undefined): Promise<VehicleSubModel> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoGetVehicleSubModelsByModelCode?";
        if (modelCode === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (modelCode !== undefined)
            url_ += "modelCode=" + encodeURIComponent("" + modelCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoGetVehicleSubModelsByModelCode(_response);
        });
    }

    protected processVehicleInfoGetVehicleSubModelsByModelCode(response: Response): Promise<VehicleSubModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VehicleSubModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleSubModel>(<any>null);
    }


    /**
     * @param licenseNumber (optional) 
     * @return Success
     */
    vehicleInfoGetVehicleByLicenseNumber(licenseNumber: string | undefined): Promise<VehicleDataModel> {
        let url_ = this.baseUrl + "/api/Cache/vehicleInfoGetVehicleByLicenseNumber?";
        if (licenseNumber === null)
            throw new Error("The parameter 'licenseNumber' cannot be null.");
        else if (licenseNumber !== undefined)
            url_ += "LicenseNumber=" + encodeURIComponent("" + licenseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoGetVehicleByLicenseNumber(_response);
        });
    }

    protected processVehicleInfoGetVehicleByLicenseNumber(response: Response): Promise<VehicleDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VehicleDataModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDataModel>(<any>null);
    }

    /**
     * @param licenseNumber (optional) 
     * @return Success
     */
    getVehicleByLicenseNumber(licenseNumber: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/VehicleInfo/GetVehicleByLicenseNumber?";
        if (licenseNumber === null)
            throw new Error("The parameter 'licenseNumber' cannot be null.");
        else if (licenseNumber !== undefined)
            url_ += "LicenseNumber=" + encodeURIComponent("" + licenseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();
        const body: any = { LicenseNumber: licenseNumber };
        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVehicleByLicenseNumber(_response);
        });
    }

    protected processGetVehicleByLicenseNumber(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VehicleDataModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return {};
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleDataModel>(<any>null);
    }


    /**
     * @return Success
     */
    statusGetStatuses(): Promise<Status[]> {
        let url_ = this.baseUrl + "/api/cache/statusGetStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStatusGetStatuses(_response);
        });
    }

    protected processStatusGetStatuses(response: Response): Promise<Status[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Status.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status[]>(<any>null);
    }


    /**
     * @return Success
     */
    getLeadStatuses(): Promise<any[]> {
        let url_ = this.baseUrl + "/api/cache/getLeadStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeadStatuses(_response);
        });
    }

    protected processGetLeadStatuses(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // if (Array.isArray(resultData200)) {
                //     result200 = [] as any;
                //     for (let item of resultData200)
                //         result200!.push(Status.fromJS(item));
                // }
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status[]>(<any>null);
    }

    /**
     * @return Success
     */

    getOldLeadStatuses(): Promise<any[]> {
        let url_ = this.baseUrl + "/api/leads/getLeadStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOldLeadStatuses(_response);
        });
    }

    protected processGetOldLeadStatuses(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(<any>null);
    }


    /**
     * @return Success
     */
    whatsappIndex(filter?: any): Promise<WhatsAppModel> {
        let url_ = this.baseUrl + "/api/communication/whatsappIndex";
        url_ = url_.replace(/[?&]$/, "");

        const body: any = {};
        if (filter) {
            const fKeys = Object.keys(filter);
            fKeys.forEach((key: string) => {
                body[key] = filter[key];
            })
        }

        const token = this.getAuthToken();
        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappIndex(_response);
        });
    }

    protected processWhatsappIndex(response: Response): Promise<WhatsAppModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WhatsAppModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppModel>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @return Success
     */
    whatsappAddStar(dataObject: any): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/whatsappAddStar";
        //let url_ = this.baseUrl + "/api/communication/whatsappAddStar?";
        //if (dataObject.UserId) {
        //  url_ += "UserId=" + encodeURIComponent("" + dataObject.UserId) + "&";
        //}
        //if (dataObject.CustomerPhoneNumber) {
        //  url_ += "CustomerPhoneNumber=" + encodeURIComponent("" + dataObject.CustomerPhoneNumber) + "&";
        //}


        const content_ = /*JSON.stringify*/JSONStringify(dataObject);




        // if (phone === null)
        //     throw new Error("The parameter 'phone' cannot be null.");
        // else if (phone !== undefined)
        //     url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"

            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappSolidStar(_response);
        });
    }

    protected processWhatsappSolidStar(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @return Success
     */
    whatsappRemoveStar(dataObject: any): Promise<void> {




        let url_ = this.baseUrl + "/api/communication/whatsappRemoveStar?";
        //let url_ = this.baseUrl + "/api/communication/whatsappAddStar?";
        //if (dataObject.UserId) {
        //  url_ += "UserId=" + encodeURIComponent("" + dataObject.UserId) + "&";
        //}
        //if (dataObject.CustomerPhoneNumber) {
        //  url_ += "CustomerPhoneNumber=" + encodeURIComponent("" + dataObject.CustomerPhoneNumber) + "&";
        //}


        const content_ = /*JSON.stringify*/JSONStringify(dataObject);




        // if (phone === null)
        //     throw new Error("The parameter 'phone' cannot be null.");
        // else if (phone !== undefined)
        //     url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"

            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappLightStar(_response);
        });
    }

    protected processWhatsappLightStar(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param searchText (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param type (optional) 
     * @return Success
     */
    whatsappSearchMessage(searchText: string | undefined, fromDate: string | undefined, toDate: string | undefined, type: string | undefined): Promise<WhatsAppModel> {
        let url_ = this.baseUrl + "/api/communication/whatsappSearchMessage";
        const body: any = {};
        if (searchText === null) {
            throw new Error("The parameter 'searchText' cannot be null.");
        }
        else if (searchText !== undefined) {
            // url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
            body.searchText = searchText
        }
        if (fromDate === null) {
            // throw new Error("The parameter 'fromDate' cannot be null.");
        } else if (fromDate !== undefined) {
            // url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
            body.FromDate = fromDate
        }
        if (toDate === null) {
            // throw new Error("The parameter 'toDate' cannot be null.");
        } else if (toDate !== undefined) {
            // url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
            body.ToDate = toDate
        }
        if (type === null) {
            // throw new Error("The parameter 'type' cannot be null.");
            body.type = type
        } else if (type !== undefined) {
            // url_ += "type=" + encodeURIComponent("" + type) + "&";
            body.type = type
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappSearchMessage(_response);
        });
    }

    protected processWhatsappSearchMessage(response: Response): Promise<WhatsAppModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WhatsAppModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppModel>(<any>null);
    }

    /**
     * @return Success
     */
    whatsappRefresh(): Promise<WhatsAppModel> {
        let url_ = this.baseUrl + "/api/communication/whatsappRefresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappRefresh(_response);
        });
    }

    protected processWhatsappRefresh(response: Response): Promise<WhatsAppModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WhatsAppModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    whatsappGetMessage(body: GetWaMessageModel | undefined): Promise<WhatsAppModel> {
        let url_ = this.baseUrl + "/api/communication/whatsappGetMessage";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappGetMessage(_response);
        });
    }

    protected processWhatsappGetMessage(response: Response): Promise<WhatsAppModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WhatsAppModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppModel>(<any>null);
    }



    whatsappSendFollowUpMessage(body: WhatsAppModel | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/communication/whatsappSendFollowUpMessage";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        const content_ = /*JSON.stringify*/JSONStringify(body);
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappSendFollowUpMessage(_response);
        });
    }

    protected processWhatsappSendFollowUpMessage(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                console.log('processWhatsappSendFollowUpMessage', _responseText)
                let resultData200 = _responseText === "" ? null : _responseText
                //JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    whatsappGetIdByPhone(phone: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/communication/whatsappGetIdByPhone?";
        if (phone === null)
            throw new Error("The parameter 'phone' cannot be null.");
        else if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappGetIdByPhone(_response);
        });
    }
    protected processWhatsappGetIdByPhone(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }


    /**
     * @return Success
     */
    whatsappGetNewMessage(): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/whatsappGetNewMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappGetNewMessage(_response);
        });
    }

    protected processWhatsappGetNewMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    whatsappSendPropose(id: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/communication/whatsappSendPropose?";
        const body: any = {}
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
            body.id = id
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappSendPropose(_response);
        });
    }

    protected processWhatsappSendPropose(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                // let resultData200 = _responseText; === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            if (status !== 400) {
                return response.text().then((_responseText) => {
                    // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                    const response = _responseText ? JSON.parse(_responseText) : {
                        error: true,
                        message: 'ERROR'
                    }
                    return response
                });
            } else {
                // const result: any = {
                //     code: status,
                // }
                return response.text();
            }
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    whatsappTransfer(body: SetTransfer | undefined): Promise<WhatsAppModel> {
        let url_ = this.baseUrl + "/api/communication/whatsappTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappTransfer(_response);
        });
    }

    protected processWhatsappTransfer(response: Response): Promise<WhatsAppModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WhatsAppModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    whatsappSendMessageInner(body: SetWaMessageModel | undefined): Promise<WhatsAppModel> {
        let url_ = this.baseUrl + "/api/communication/whatsappSendMessageInner";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappSendMessageInner(_response);
        });
    }

    protected processWhatsappSendMessageInner(response: Response): Promise<WhatsAppModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WhatsAppModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    whatsappSendMessage(body: SetWaMessageModel | undefined): Promise<WhatsAppModel> {

        let url_ = this.baseUrl + "/api/communication/whatsappSendMessage";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappSendMessage(_response);
        });
    }

    protected processWhatsappSendMessage(response: Response): Promise<WhatsAppModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WhatsAppModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    whatsappSaveWhatsAppManagement(body: WhatsAppManagementInput | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/whatsappSaveWhatsAppManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappSaveWhatsAppManagement(_response);
        });
    }

    protected processWhatsappSaveWhatsAppManagement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    whatsappGetWhatsAppManagementAll(): Promise<WhatsAppManagement[]> {
        let url_ = this.baseUrl + "/api/communication/whatsappGetWhatsAppManagement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappGetWhatsAppManagementAll(_response);
        });
    }

    protected processWhatsappGetWhatsAppManagementAll(response: Response): Promise<WhatsAppManagement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(WhatsAppManagement.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppManagement[]>(<any>null);
    }

    /**
     * @return Success
     */
    speakComIndex(): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/speakComIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSpeakComIndex(_response);
        });
    }

    protected processSpeakComIndex(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    speakComBreak(): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/speakComBreak";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSpeakComBreak(_response);
        });
    }

    protected processSpeakComBreak(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    speakComLogin(): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/speakComLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSpeakComLogin(_response);
        });
    }

    protected processSpeakComLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    speakComLogout(): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/speakComLogout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSpeakComLogout(_response);
        });
    }

    protected processSpeakComLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param number (optional) 
     * @return Success
     */
    speakComSendCall(number: string | undefined, id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/speakComSendCall?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "relationId=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");


        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };



        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSpeakComSendCall(_response);
        });
    }

    protected processSpeakComSendCall(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param activeMail (optional) 
     * @return Success
     */
    emailsIndex(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/Communication/emailsIndex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsIndex(_response);
        });
    }

    protected processEmailsIndex(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // if (Array.isArray(resultData200)) {
                //     result200 = [] as any;
                //     for (let item of resultData200)
                //         result200!.push(EmailsModel.fromJS(item));
                // }
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @return Success
     */
    emailsRetrieveFolders(activeEmail: string): Promise<EmailFolderData[]> {
        let url_ = this.baseUrl + "/api/communication/emailsRetrieveFolders?";
        url_ += "ActiveMail=" + encodeURIComponent("" + activeEmail) + "";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsRetrieveFolders(_response);
        });
    }

    protected processEmailsRetrieveFolders(response: Response): Promise<EmailFolderData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(EmailFolderData.fromJS(item));
                }
                // ////console.log('processEmailsRetrieveFolders', result200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailFolderData[]>(<any>null);
    }

    /**
     * @return Success
     */
    emailsLoadNonActiveFolders(): Promise<EmailsModel> {
        let url_ = this.baseUrl + "/api/communication/emailsLoadNonActiveFolders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsLoadNonActiveFolders(_response);
        });
    }

    protected processEmailsLoadNonActiveFolders(response: Response): Promise<EmailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmailsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailsModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsFilter(body: EmailFilterModel | undefined): Promise<EmailsModel> {
        let url_ = this.baseUrl + "/api/communication/emailsFilter";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsFilter(_response);
        });
    }

    protected processEmailsFilter(response: Response): Promise<EmailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmailsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailsModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsAddRemoveStar(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/communication/emailsAddRemoveStar";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsAddRemoveStar(_response);
        });
    }

    protected processEmailsAddRemoveStar(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    // emailsAddRemoveRead

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsAddRemoveRead(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/communication/emailsAddRemoveRead";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsAddRemoveRead(_response);
        });
    }

    protected processEmailsAddRemoveRead(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const res: ResponseObject = {
                    statusCode: -1,
                    statusMessage: 'some error occured'
                }
                return res;
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsRemoveMessage(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/communication/emailsRemoveMessage";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsRemoveMessage(_response);
        });
    }

    protected processEmailsRemoveMessage(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsGetMessage(body: GetMessageModel | undefined): Promise<EmailMessage | ResponseObject> {
        let url_ = this.baseUrl + "/api/communication/emailsGetMessage";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsGetMessage(_response);
        });
    }

    protected processEmailsGetMessage(response: Response): Promise<EmailMessage | ResponseObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.statusCode) {
                    return resultData200 as ResponseObject
                } else {
                    result200 = EmailMessage.fromJS(resultData200);
                    return result200;
                }
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const res: ResponseObject = {
                    statusCode: -1,
                    statusMessage: 'some error occured'
                }
                return res;
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailMessage>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsSaveMessageAsTreatment(body: MessageForTreatmentModel | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/communication/emailsSaveMessageAsTreatment";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsSaveMessageAsTreatment(_response);
        });
    }

    protected processEmailsSaveMessageAsTreatment(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {

                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.statusCode) {
                    return resultData200 as ResponseObject
                } else {
                    const res: ResponseObject = {
                        statusCode: -1,
                        statusMessage: 'some error occured'
                    }
                    return res;
                }
                // return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param messageId (optional) 
     * @return Success
     */
    emailsNewMail(messageId: string | undefined): Promise<NewMailModel[]> {
        let url_ = this.baseUrl + "/api/communication/emailsNewMail?";
        if (messageId === null)
            throw new Error("The parameter 'messageId' cannot be null.");
        else if (messageId !== undefined)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsNewMail(_response);
        });
    }

    protected processEmailsNewMail(response: Response): Promise<NewMailModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(NewMailModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewMailModel[]>(<any>null);
    }

    /**
     * @param folderName (optional) 
     * @return Success
     */
    emailsCreateNewFolder(folderName: string | undefined, activeMail: string): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/emailsCreateNewFolder?";
        if (folderName === null)
            throw new Error("The parameter 'folderName' cannot be null.");
        else if (folderName !== undefined)
            url_ += "FolderName=" + encodeURIComponent("" + folderName) + "&";
        url_ += "ActiveMail=" + encodeURIComponent("" + activeMail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsCreateNewFolder(_response);
        });
    }

    protected processEmailsCreateNewFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param sourceFolder (optional) 
     * @param type (optional) 
     * @param destFolderName (optional) 
     * @param messageId (optional) 
     * @return Success
     */
    emailsMoveEmailToFolder(sourceFolder: string | undefined, type: SpecialFolder | undefined, destFolderName: string | undefined, messageIds: number[] | undefined, activeMail: string): Promise<ResponseObject | void> {
        let url_ = this.baseUrl + "/api/communication/emailsMoveEmailToFolder";
        // if (sourceFolder === null) {
        //     // throw new Error("The parameter 'sourceFolder' cannot be null.");
        //     url_ += "sourceFolder=null&";
        // } else if (sourceFolder !== undefined)
        //     url_ += "sourceFolder=" + encodeURIComponent("" + sourceFolder) + "&";
        // if (type === null) {
        //     // throw new Error("The parameter 'type' cannot be null.");
        // }
        // else if (type !== undefined)
        //     url_ += "Type=" + encodeURIComponent("" + type) + "&";
        // if (destFolderName === null)
        //     throw new Error("The parameter 'destFolderName' cannot be null.");
        // else if (destFolderName !== undefined)
        //     url_ += "destFolderName=" + encodeURIComponent("" + destFolderName) + "&";
        // if (messageIds === null)
        //     throw new Error("The parameter 'messageId' cannot be null.");
        // else if (messageIds !== undefined)
        //     url_ += "messageId=" + encodeURIComponent("" + messageIds) + "&";
        // if (activeMail !== undefined ) {
        //     url_ += "ActiveMail=" + encodeURIComponent("" + activeMail) + "&";
        // }
        url_ = url_.replace(/[?&]$/, "");

        const body: any = {
            "sourceFolder": sourceFolder,
            "ActiveMail": activeMail,
            "destFolderName": destFolderName,
            "messageIds": messageIds
        }
        const content_ = JSON.stringify(body);

        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsMoveEmailToFolder(_response);
        });
    }

    protected processEmailsMoveEmailToFolder(response: Response): Promise<ResponseObject | void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return JSON.parse(_responseText);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const res: ResponseObject = {
                    statusCode: -1,
                    statusMessage: 'some error occured'
                }
                return res;
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsReloadNewMail(body: GetMessageModel | undefined): Promise<NewMailModel> {
        let url_ = this.baseUrl + "/api/communication/emailsReloadNewMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsReloadNewMail(_response);
        });
    }

    protected processEmailsReloadNewMail(response: Response): Promise<NewMailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NewMailModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewMailModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsSendMessage(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/communication/emailsSendMessage";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = body; ///*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsSendMessage(_response);
        });
    }

    protected processEmailsSendMessage(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                console.log('processEmailsSendMessage', result200)
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    emailsGetAddresses(activeEmail: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/communication/emailsGetAddresses?";
        url_ += "ActiveMail=" + encodeURIComponent("" + activeEmail) + "";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsGetAddresses(_response);
        });
    }

    protected processEmailsGetAddresses(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                return [];
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    emailsSettings(): Promise<EmailsSettingsModel> {
        let url_ = this.baseUrl + "/api/communication/emailsSettings";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsSettings(_response);
        });
    }

    protected processEmailsSettings(response: Response): Promise<EmailsSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmailsSettingsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailsSettingsModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailsSettings2(body: EmailsSettingsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/communication/emailsSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsSettings2(_response);
        });
    }

    protected processEmailsSettings2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param accountEmail (optional) 
     * @return Success
     */
    emailsGetNewAccount(accountEmail: string | undefined): Promise<EmailModel> {
        let url_ = this.baseUrl + "/api/communication/emailsGetNewAccount?";
        if (accountEmail === null)
            throw new Error("The parameter 'accountEmail' cannot be null.");
        else if (accountEmail !== undefined)
            url_ += "accountEmail=" + encodeURIComponent("" + accountEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailsGetNewAccount(_response);
        });
    }

    protected processEmailsGetNewAccount(response: Response): Promise<EmailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmailModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailModel>(<any>null);
    }

    /**
     * @return Success
     */
    simulatorForDriver(): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorForDriver";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorForDriver(_response);
        });
    }

    protected processSimulatorForDriver(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param leadId (optional) 
     * @param offerId (optional) 
     * @return Success
     */
    simulatorIndex(leadId: string | undefined, offerId: string | undefined): Promise<SimulatorPageModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorIndex?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        if (offerId === null)
            throw new Error("The parameter 'offerId' cannot be null.");
        else if (offerId !== undefined)
            url_ += "OfferId=" + encodeURIComponent("" + offerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorIndex(_response);
        });
    }

    protected processSimulatorIndex(response: Response): Promise<SimulatorPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SimulatorPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorPageModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorIndex2(body: Simulator | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorIndex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorIndex2(_response);
        });
    }

    protected processSimulatorIndex2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param leadId (optional) 
     * @param offerId (optional) 
     * @return Success
     */
    simulatorLoadSidebar(leadId: string | undefined, offerId: string | undefined): Promise<SimulatorPageModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorLoadSidebar?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        if (offerId === null)
            throw new Error("The parameter 'offerId' cannot be null.");
        else if (offerId !== undefined)
            url_ += "offerId=" + encodeURIComponent("" + offerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorLoadSidebar(_response);
        });
    }

    protected processSimulatorLoadSidebar(response: Response): Promise<SimulatorPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SimulatorPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorPageModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorCalculateSumilator(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/engagement/simulatorCalculateSumilator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorCalculateSumilator(_response);
        });
    }

    protected processSimulatorCalculateSumilator(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorGetLeviItzhakModelCode(body: GetLeviItzhakModelCodeRequest | undefined): Promise<DynamicObject5> {
        let url_ = this.baseUrl + "/api/engagement/simulatorGetLeviItzhakModelCode";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorGetLeviItzhakModelCode(_response);
        });
    }

    protected processSimulatorGetLeviItzhakModelCode(response: Response): Promise<DynamicObject5> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            // 
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject5.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {

                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject5>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorGetVehicleDetails(body: GetVehicleDetailsRequest | undefined): Promise<DynamicObject5> {
        let url_ = this.baseUrl + "/api/engagement/simulatorGetVehicleDetails";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorGetVehicleDetails(_response);
        });
    }

    protected processSimulatorGetVehicleDetails(response: Response): Promise<DynamicObject5> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            // 
            return response.text().then((_responseText) => {

                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject5.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject5>(<any>null);
    }

    simulatorUpdateVehicleSubModel(body: UpdateVehicleSubmodelRequest | undefined): Promise<DynamicObject2> {
        let url_ = this.baseUrl + "/api/engagement/simulatorUpdateVehicleSubModel";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorUpdateVehicleSubModel(_response);
        });
    }

    protected processSimulatorUpdateVehicleSubModel(response: Response): Promise<DynamicObject2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            // 
            return response.text().then((_responseText) => {

                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject5.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject2>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorReCalculateSimulator(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = /*"https://localhost:44333"*/ this.baseUrl + "/api/engagement/simulatorReCalculateSimulator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorReCalculateSimulator(_response);
        });

    }

    protected processSimulatorReCalculateSimulator(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorSaveSimulator(body: SimulatorPageModel | undefined): Promise<string> {

        let url_ = this.baseUrl + "/api/engagement/simulatorSaveSimulator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorSaveSimulator(_response);
        });
    }

    protected processSimulatorSaveSimulator(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }


    renewalUpsertOffer(body: SimulatorOfferModel): Promise<string> {
        let url_ = this.baseUrl + "/api/renewals/renewalUpsertOffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processrenewalUpsertOffer(_response);
        });
    }

    protected processrenewalUpsertOffer(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorPolicyProduction(body: ElementaryPolicyModel | undefined): Promise<void> {
        ////console.log('body', body)
        let url_ = this.baseUrl + "/api/engagement/simulatorPolicyProduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                // "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            ////console.log('_response', _response)
            return this.processSimulatorPolicyProduction(_response);
        });
    }

    protected processSimulatorPolicyProduction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            ////console.log('response', response)

            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return { ...result200, 'status': 200 };
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
    /**
     * @param body (optional) 
     * @return Success
     */
    SigningUpdate(body: any | undefined): Promise<void> {
        console.log('body', body)
        let url_ = this.baseUrl + "/api/signing/SigningUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            console.log('_response', _response)
            return this.processSigningUpdate(_response);
        });
    }

    protected processSigningUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            console.log('response', response)

            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return { ...result200, 'status': 200 };
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    SigningUpdate2(body: any | undefined): Promise<void> {
        console.log('body', body)
        let url_ = this.baseUrl + "/api/signing/SigningUpdate2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                // "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            console.log('_response', _response)
            return this.processSigningUpdate2(_response);
        });
    }

    protected processSigningUpdate2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            console.log('response', response)

            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return { ...result200, 'status': 200 };
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorPolicyProductionPart2(body: SimulatorPageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorPolicyProductionPart2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorPolicyProductionPart2(_response);
        });
    }

    protected processSimulatorPolicyProductionPart2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorOpenProduction(body: SimulatorPageModel | undefined): Promise<ElementaryPolicyModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorOpenProduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorOpenProduction(_response);
        });
    }

    protected processSimulatorOpenProduction(response: Response): Promise<ElementaryPolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ElementaryPolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ElementaryPolicyModel>(<any>null);
    }





    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorOpenGetProduction(offerId: string | undefined): Promise<SimulatorPageModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorOpenProduction?";
        if (offerId === null)
            throw new Error("The parameter 'offerId' cannot be null.");
        else if (offerId !== undefined)
            url_ += "offerId=" + encodeURIComponent("" + offerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSimulatorOpenProduction(_response);
        });
    }

    protected processGetSimulatorOpenProduction(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200
                // SimulatorPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    simulatorLoadProduction(offerId: string | undefined, offerIdToCopy: string | undefined): Promise<SimulatorPageModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorLoadProduction?";
        if (offerId === null)
            throw new Error("The parameter 'offerId' cannot be null.");
        else if (offerId !== undefined)
            url_ += "offerId=" + encodeURIComponent("" + offerId) + "&offerIdToCopy=" + encodeURIComponent("" + offerIdToCopy);
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSimulatorLoadProduction(_response);
        });
    }

    protected processGetSimulatorLoadProduction(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200
                // SimulatorPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /**
     * @param offerId (optional) 
     * @return Success
     */
    simulatorOpenProduction2(offerId: string | undefined): Promise<SimulatorPageModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorOpenProduction?";
        if (offerId === null)
            throw new Error("The parameter 'offerId' cannot be null.");
        else if (offerId !== undefined)
            url_ += "offerId=" + encodeURIComponent("" + offerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();



        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            ////console.log('_response :>> ', _response);

            return this.processSimulatorOpenProduction2(_response);
        });
    }

    protected processSimulatorOpenProduction2(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200
                // SimulatorPageModel.fromJS(resultData200);

                ////console.log('result200 :>> ', result200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    getIsThereOpenProductionByOffer(leadId: string | undefined): Promise<SimulatorPageModel> {
        let url_ = this.baseUrl + "/api/engagement/getIsThereOpenProductionByOffer?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();



        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            ////console.log('_response :>> ', _response);

            return this.processGetIsThereOpenProductionByOffer(_response);
        });
    }

    protected processGetIsThereOpenProductionByOffer(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200
                // SimulatorPageModel.fromJS(resultData200);

                ////console.log('result200 :>> ', result200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    getOpenProductionByLead(leadId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/engagement/getOpenProductionByLead?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();



        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            ////console.log('_response :>> ', _response);

            return this.processGetOpenProductionByLead(_response);
        });
    }

    protected processGetOpenProductionByLead(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200
                // SimulatorPageModel.fromJS(resultData200);

                ////console.log('result200 :>> ', result200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    userGetUserByRoleId(roleId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/account/userGetUserByRoleId?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "";

        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(null);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserGetUserByRoleId(_response);
        });
    }

    protected processUserGetUserByRoleId(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200
                // SimulatorPageModel.fromJS(resultData200);

                ////console.log('result200 :>> ', result200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    deleteFiledAttachment(fileId: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/engagement/simulatorDeleteElementaryPolicyDocument?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "id=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();



        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            ////console.log('_response :>> ', _response);

            return this.processDeleteFiledAttachment(_response);
        });
    }

    protected processDeleteFiledAttachment(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(
            <any>null
        );
    }


    /**
     * @param discountId (optional) 
     * @param insuranceCompanyId (optional) 
     * @return Success
     */
    simulatorGetDiscountForEdit(discountId: string | undefined, insuranceCompanyId: string | undefined): Promise<DiscountModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorGetDiscountForEdit?";
        if (discountId === null)
            throw new Error("The parameter 'discountId' cannot be null.");
        else if (discountId !== undefined)
            url_ += "discountId=" + encodeURIComponent("" + discountId) + "&";
        if (insuranceCompanyId === null)
            throw new Error("The parameter 'insuranceCompanyId' cannot be null.");
        else if (insuranceCompanyId !== undefined)
            url_ += "InsuranceCompanyId=" + encodeURIComponent("" + insuranceCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorGetDiscountForEdit(_response);
        });
    }

    protected processSimulatorGetDiscountForEdit(response: Response): Promise<DiscountModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DiscountModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscountModel>(<any>null);
    }

    /**
     * @param discountId (optional) 
     * @return Success
     */
    simulatorDeleteDiscount(discountId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorDeleteDiscount?";
        if (discountId === null)
            throw new Error("The parameter 'discountId' cannot be null.");
        else if (discountId !== undefined)
            url_ += "discountId=" + encodeURIComponent("" + discountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorDeleteDiscount(_response);
        });
    }

    protected processSimulatorDeleteDiscount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    simulatorSettings(): Promise<SimulatorSettingsModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorSettings(_response);
        });
    }

    protected processSimulatorSettings(response: Response): Promise<SimulatorSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SimulatorSettingsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorSettingsModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorUpdateSimulatorDetails(body: SimulatorDetailsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorUpdateSimulatorDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorUpdateSimulatorDetails(_response);
        });
    }

    protected processSimulatorUpdateSimulatorDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorUpdateLeadCalcDetails(body: DiscountModel | undefined): Promise<SimulatorSettingsModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorUpdateLeadCalcDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorUpdateLeadCalcDetails(_response);
        });
    }

    protected processSimulatorUpdateLeadCalcDetails(response: Response): Promise<SimulatorSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SimulatorSettingsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorSettingsModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorUpdateLeadCalcDetails2(body: SimulatorPageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorUpdateLeadCalcDetails2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorUpdateLeadCalcDetails2(_response);
        });
    }

    protected processSimulatorUpdateLeadCalcDetails2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorGetOffers(body: Simulator | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorGetOffers(_response);
        });
    }

    protected processSimulatorGetOffers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    simulatorUpdate(): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorUpdate(_response);
        });
    }

    protected processSimulatorUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param collection (optional) 
     * @return Success
     */
    simulatorCreate(collection: StringStringValuesKeyValuePair[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (collection === null || collection === undefined)
            throw new Error("The parameter 'collection' cannot be null.");
        else
            content_.append("collection", collection.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorCreate(_response);
        });
    }

    protected processSimulatorCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    simulatorEdit(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorEdit(_response);
        });
    }

    protected processSimulatorEdit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param collection (optional) 
     * @return Success
     */
    simulatorEdit2(id: number | undefined, collection: StringStringValuesKeyValuePair[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (collection === null || collection === undefined)
            throw new Error("The parameter 'collection' cannot be null.");
        else
            content_.append("collection", collection.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorEdit2(_response);
        });
    }

    protected processSimulatorEdit2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    simulatorDelete(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorDelete(_response);
        });
    }

    protected processSimulatorDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param collection (optional) 
     * @return Success
     */
    simulatorDelete2(id: number | undefined, collection: StringStringValuesKeyValuePair[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (collection === null || collection === undefined)
            throw new Error("The parameter 'collection' cannot be null.");
        else
            content_.append("collection", collection.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorDelete2(_response);
        });
    }

    protected processSimulatorDelete2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorChoseOffer(body: CreateOfferModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorChoseOffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorChoseOffer(_response);
        });
    }

    protected processSimulatorChoseOffer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorUpdateRoutes(body: InsuranceCompanyRouteModel[] | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/engagement/simulatorUpdateRoutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorUpdateRoutes(_response);
        });
    }

    protected processSimulatorUpdateRoutes(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param city (optional) 
     * @param street (optional) 
     * @param houseNumber (optional) 
     * @param entrance (optional) 
     * @return Success
     */
    simulatorGetPostalCode(city: string | undefined, street: string | undefined, houseNumber: number | undefined, entrance: string | undefined, mailbox: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorGetPostalCode?";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (street === null) {
            console.log('simulatorGetPostalCode-street', street)
            // throw new Error("The parameter 'street' cannot be null.");
        } else if (street !== undefined)
            url_ += "street=" + encodeURIComponent("" + street) + "&";
        if (houseNumber === null) {
            // throw new Error("The parameter 'houseNumber' cannot be null.");
        } else if (houseNumber !== undefined)
            url_ += "houseNumber=" + encodeURIComponent("" + houseNumber) + "&";
        if (entrance !== undefined && entrance !== null && entrance !== "") {
            url_ += "entrance=" + encodeURIComponent("" + entrance) + "&";
        } else if (entrance === null || entrance === "" || entrance === undefined) {
            // url_ += "entrance=" + encodeURIComponent("" + 0) + "&";
        }
        if (mailbox === null || mailbox === "")
            url_ += "pobox=" + encodeURIComponent("" + 0) + "&";
        else if (mailbox !== undefined && mailbox !== null && mailbox !== "")
            url_ += "pobox=" + encodeURIComponent("" + mailbox) + "&";
        url_ = url_.replace(/[?&]$/, "");
        console.log('url_ :>> ', url_);


        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }

        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorGetPostalCode(_response);
        });
    }

    protected processSimulatorGetPostalCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param postalCode (optional) 
     * @return Success
     */
    simulatorGetAddressByPostalCode(postalCode: string | undefined): Promise<CustomerAddressModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorGetAddressByPostalCode?";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorGetAddressByPostalCode(_response);
        });
    }

    protected processSimulatorGetAddressByPostalCode(response: Response): Promise<DynamicObject12> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {

                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;


            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {

                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject12>(<any>null);
    }

    simulatorGetCityIdByCity(city: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/engagement/simulatorGetCityIdByCity?";
        if (city === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (city !== undefined)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorGetCityIdByCity(_response);
        });
    }

    protected processSimulatorGetCityIdByCity(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {

                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;


            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {

                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorUpdateDiscounts(body: DiscountModel[] | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/engagement/simulatorUpdateDiscounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorUpdateDiscounts(_response);
        });
    }

    protected processSimulatorUpdateDiscounts(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param insuranceCompanyRouteId (optional) 
     * @return Success
     */
    simulatorShowTermsAndCovers(insuranceCompanyRouteId: string | undefined): Promise<InsuranceCompanyRouteModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorShowTermsAndCovers?";
        if (insuranceCompanyRouteId === null)
            throw new Error("The parameter 'insuranceCompanyRouteId' cannot be null.");
        else if (insuranceCompanyRouteId !== undefined)
            url_ += "InsuranceCompanyRouteId=" + encodeURIComponent("" + insuranceCompanyRouteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorShowTermsAndCovers(_response);
        });
    }

    protected processSimulatorShowTermsAndCovers(response: Response): Promise<InsuranceCompanyRouteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InsuranceCompanyRouteModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceCompanyRouteModel>(<any>null);
    }

    /**
     * @param agentDetailsId (optional) 
     * @return Success
     */
    simulatorShowTermsAndCoversAgent(agentDetailsId: string | undefined): Promise<AgentDetailsModel> {
        let url_ = this.baseUrl + "/api/engagement/simulatorShowTermsAndCoversAgent?";
        if (agentDetailsId === null)
            throw new Error("The parameter 'agentDetailsId' cannot be null.");
        else if (agentDetailsId !== undefined)
            url_ += "AgentDetailsId=" + encodeURIComponent("" + agentDetailsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorShowTermsAndCoversAgent(_response);
        });
    }

    protected processSimulatorShowTermsAndCoversAgent(response: Response): Promise<AgentDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AgentDetailsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentDetailsModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorSaveTermsAndCovers(body: InsuranceCompanyRouteModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorSaveTermsAndCovers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorSaveTermsAndCovers(_response);
        });
    }

    protected processSimulatorSaveTermsAndCovers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatorSaveTermsAndCoversForAgent(body: AgentDetailsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/simulatorSaveTermsAndCoversForAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorSaveTermsAndCoversForAgent(_response);
        });
    }

    protected processSimulatorSaveTermsAndCoversForAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shomeraGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/engagement/shomeraGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShomeraGetOffers(_response);
        });
    }

    protected processShomeraGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }


    simulatorSaveLead(body: SimulatorPageModel | undefined): Promise<any> {

        let url_ = this.baseUrl + "/api/engagement/simulatorSaveLead";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorSaveLead(_response);
        });
    }

    protected processSimulatorSaveLead(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shlomoGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/engagement/shlomoGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShlomoGetOffers(_response);
        });
    }

    protected processShlomoGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {

                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) {
                        result200!.push(SimulatorOfferModel.fromJS(item));
                    }
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    migdalGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/engagement/migdalGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigdalGetOffers(_response);
        });
    }

    protected processMigdalGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    harelGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ =/*"https://localhost:44333"*/ this.baseUrl + "/api/engagement/harelGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHarelGetOffers(_response);
        });
    }

    protected processHarelGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    hachsharaGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/engagement/hachsharaGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHachsharaGetOffers(_response);
        });
    }

    protected processHachsharaGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ayalonGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {

        let url_ = this.baseUrl + "/api/engagement/ayalonGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        //const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAyalonGetOffers(_response);
        });
    }

    protected processAyalonGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    ankorGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {

        let url_ = this.baseUrl + "/api/engagement/ankorGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        //const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnkorGetOffers(_response);
        });
    }

    protected processAnkorGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clalGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/engagement/clalGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClalGetOffers(_response);
        });
    }

    protected processClalGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }



    menoraGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/engagement/menoraGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMenoraGetOffers(_response);
        });
    }

    protected processMenoraGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fnxGetOffers(body: SimulatorPageModel | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/engagement/fnxGetOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFnxGetOffers(_response);
        });
    }

    protected processFnxGetOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    ayalonGetAyalonAddressDetails(): Promise<void> {
        let url_ = this.baseUrl + "/api/engagement/ayalonGetAyalonAddressDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAyalonGetAyalonAddressDetails(_response);
        });
    }

    protected processAyalonGetAyalonAddressDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    test2(): Promise<void> {
        let url_ = this.baseUrl + "/api/General/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest2(_response);
        });
    }

    protected processTest2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    test32(body: Test3Data | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/General/test3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest32(_response);
        });
    }

    protected processTest32(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param location (optional) 
     * @param files (optional) 
     * @return Success
     */
    sharedUploadFile(location: string | undefined, files: FileParameter[] | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/general/sharedUploadFile?";
        if (location === null)
            throw new Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSharedUploadFile(_response);
        });
    }

    protected processSharedUploadFile(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @param cKEditorFuncNum (optional) 
     * @param cKEditor (optional) 
     * @param langCode (optional) 
     * @param file (optional) 
     * @return Success
     */
    sharedUploadImage(cKEditorFuncNum: string | undefined, cKEditor: string | undefined, langCode: string | undefined, file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/general/sharedUploadImage?";
        if (cKEditorFuncNum === null)
            throw new Error("The parameter 'cKEditorFuncNum' cannot be null.");
        else if (cKEditorFuncNum !== undefined)
            url_ += "CKEditorFuncNum=" + encodeURIComponent("" + cKEditorFuncNum) + "&";
        if (cKEditor === null)
            throw new Error("The parameter 'cKEditor' cannot be null.");
        else if (cKEditor !== undefined)
            url_ += "CKEditor=" + encodeURIComponent("" + cKEditor) + "&";
        if (langCode === null)
            throw new Error("The parameter 'langCode' cannot be null.");
        else if (langCode !== undefined)
            url_ += "langCode=" + encodeURIComponent("" + langCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSharedUploadImage(_response);
        });
    }

    protected processSharedUploadImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    mainSetScreenWidth(): Promise<void> {
        let url_ = this.baseUrl + "/api/general/mainSetScreenWidth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMainSetScreenWidth(_response);
        });
    }

    protected processMainSetScreenWidth(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param width (optional) 
     * @return Success
     */
    mainSetScreenWidth2(width: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/general/mainSetScreenWidth2?";
        if (width === null)
            throw new Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMainSetScreenWidth2(_response);
        });
    }

    protected processMainSetScreenWidth2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    index(): Promise<void> {
        let url_ = this.baseUrl + "/index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    home(): Promise<void> {
        let url_ = this.baseUrl + "/home";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHome(_response);
        });
    }

    protected processHome(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    stationsHome(): Promise<DashboardStationUserModel> {
        let url_ = this.baseUrl + "/stationsHome";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationsHome(_response);
        });
    }

    protected processStationsHome(response: Response): Promise<DashboardStationUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DashboardStationUserModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardStationUserModel>(<any>null);
    }

    /**
     * @return Success
     */
    privacy(): Promise<void> {
        let url_ = this.baseUrl + "/privacy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrivacy(_response);
        });
    }

    protected processPrivacy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getValidationMetaInfo(): Promise<string> {
        let url_ = this.baseUrl + "/getValidationMetaInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetValidationMetaInfo(_response);
        });
    }

    protected processGetValidationMetaInfo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param quantity (optional) 
     * @param unitPrice (optional) 
     * @param description (optional) 
     * @return Success
     */
    iCreditIndex(quantity: number | undefined, unitPrice: number | undefined, description: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/iCreditIndex?";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "Quantity=" + encodeURIComponent("" + quantity) + "&";
        if (unitPrice === null)
            throw new Error("The parameter 'unitPrice' cannot be null.");
        else if (unitPrice !== undefined)
            url_ += "UnitPrice=" + encodeURIComponent("" + unitPrice) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processICreditIndex(_response);
        });
    }

    protected processICreditIndex(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param saleId (optional) 
     * @param groupPrivateToken (optional) 
     * @param transactionAmount (optional) 
     * @param transactionToken (optional) 
     * @param custom1 (optional) 
     * @param custom2 (optional) 
     * @param documentURL (optional) 
     * @param transactionCardNum (optional) 
     * @param reference (optional) 
     * @return Success
     */
    iCreditVerify(saleId: string | undefined, groupPrivateToken: string | undefined, transactionAmount: string | undefined, transactionToken: string | undefined, custom1: string | undefined, custom2: string | undefined, documentURL: string | undefined, transactionCardNum: string | undefined, reference: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/iCreditVerify?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "SaleId=" + encodeURIComponent("" + saleId) + "&";
        if (groupPrivateToken === null)
            throw new Error("The parameter 'groupPrivateToken' cannot be null.");
        else if (groupPrivateToken !== undefined)
            url_ += "GroupPrivateToken=" + encodeURIComponent("" + groupPrivateToken) + "&";
        if (transactionAmount === null)
            throw new Error("The parameter 'transactionAmount' cannot be null.");
        else if (transactionAmount !== undefined)
            url_ += "TransactionAmount=" + encodeURIComponent("" + transactionAmount) + "&";
        if (transactionToken === null)
            throw new Error("The parameter 'transactionToken' cannot be null.");
        else if (transactionToken !== undefined)
            url_ += "TransactionToken=" + encodeURIComponent("" + transactionToken) + "&";
        if (custom1 === null)
            throw new Error("The parameter 'custom1' cannot be null.");
        else if (custom1 !== undefined)
            url_ += "Custom1=" + encodeURIComponent("" + custom1) + "&";
        if (custom2 === null)
            throw new Error("The parameter 'custom2' cannot be null.");
        else if (custom2 !== undefined)
            url_ += "Custom2=" + encodeURIComponent("" + custom2) + "&";
        if (documentURL === null)
            throw new Error("The parameter 'documentURL' cannot be null.");
        else if (documentURL !== undefined)
            url_ += "DocumentURL=" + encodeURIComponent("" + documentURL) + "&";
        if (transactionCardNum === null)
            throw new Error("The parameter 'transactionCardNum' cannot be null.");
        else if (transactionCardNum !== undefined)
            url_ += "TransactionCardNum=" + encodeURIComponent("" + transactionCardNum) + "&";
        if (reference === null)
            throw new Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processICreditVerify(_response);
        });
    }

    protected processICreditVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param saleId (optional) 
     * @param groupPrivateToken (optional) 
     * @param transactionAmount (optional) 
     * @return Success
     */
    iCreditFailure(saleId: string | undefined, groupPrivateToken: string | undefined, transactionAmount: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/iCreditFailure?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "SaleId=" + encodeURIComponent("" + saleId) + "&";
        if (groupPrivateToken === null)
            throw new Error("The parameter 'groupPrivateToken' cannot be null.");
        else if (groupPrivateToken !== undefined)
            url_ += "GroupPrivateToken=" + encodeURIComponent("" + groupPrivateToken) + "&";
        if (transactionAmount === null)
            throw new Error("The parameter 'transactionAmount' cannot be null.");
        else if (transactionAmount !== undefined)
            url_ += "TransactionAmount=" + encodeURIComponent("" + transactionAmount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processICreditFailure(_response);
        });
    }

    protected processICreditFailure(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    leadsCraeteVehiclesDB(): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsCraeteVehiclesDB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsCraeteVehiclesDB(_response);
        });
    }

    protected processLeadsCraeteVehiclesDB(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    leadsMakeHttpsGetRequest(): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsMakeHttpsGetRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsMakeHttpsGetRequest(_response);
        });
    }

    protected processLeadsMakeHttpsGetRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsIndex(body: LeadsIndexRequest | undefined): Promise<LeadsPageModel> {
        let url_ = this.baseUrl + "/api/leads/leadsIndex";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsIndex(_response);
        });
    }

    protected processLeadsIndex(response: Response): Promise<LeadsPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadsPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadsPageModel>(<any>null);
    }

    /**
     * @return Success
     */
    leadsGetBranches(): Promise<BranchModel[]> {

        let url_ = this.baseUrl + "/api/leads/leadsGetBranches";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsGetBranches(_response);
        });
    }

    protected processLeadsGetBranches(response: Response): Promise<BranchModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.branches) {
                    if (Array.isArray(resultData200.branches)) {
                        result200 = [] as any;
                        for (let item of resultData200.branches)
                            result200!.push(BranchModel.fromJS(item));
                    }
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchModel[]>(<any>null);
    }

    getProjectManagerBranches(): Promise<any> {
        let url_ = this.baseUrl + "/api/maintenance/projectGetProjectManagerBranches";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        }

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProjectManagerBranches(_response);
        });
    }


    protected processGetProjectManagerBranches(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /**
     * @return Success
     */
    leadsGetBranchesAndUsers(): Promise<any> {
        let url_ = this.baseUrl + "/api/leads/leadsGetBranches";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsGetBranchesAndUsers(_response);
        });
    }

    protected processLeadsGetBranchesAndUsers(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // if (resultData200 && resultData200.branches) {
                //     if (Array.isArray(resultData200.branches)) {
                //         result200 = [] as any;
                //         for (let item of resultData200.branches)
                //             result200!.push(BranchModel.fromJS(item));
                //     }
                // }
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsGetLeadPageModel(body: GetLeadPageModelRequest | undefined): Promise<LeadsPageModel> {
        let url_ = this.baseUrl + "/api/leads/leadsGetLeadPageModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsGetLeadPageModel(_response);
        });
    }

    protected processLeadsGetLeadPageModel(response: Response): Promise<LeadsPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadsPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadsPageModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsGetLeadOffers(body: GetLeadOffersRequest | undefined): Promise<SimulatorOfferModel[]> {
        let url_ = this.baseUrl + "/api/leads/leadsGetLeadOffers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsGetLeadOffers(_response);
        });
    }

    protected processLeadsGetLeadOffers(response: Response): Promise<SimulatorOfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SimulatorOfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    RiderCheckActiveVehicle(body: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/riders/riderCheckActiveVehicle?licenseNumber=" + body;
        url_ = url_.replace(/[?&]$/, "");


        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderCheckActiveVehicle(_response);
        });
    }

    protected processRiderCheckActiveVehicle(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return _responseText ? JSON.parse(_responseText) : {
                    "doubleLead": false
                };
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    leadsCheckPhoneForDoubleForPCStation(body: CheckPhoneForDoubleForPCStationRequest | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/leads/leadsCheckPhoneForDoubleForPCStation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsCheckPhoneForDoubleForPCStation(_response);
        });
    }

    protected processLeadsCheckPhoneForDoubleForPCStation(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return _responseText ? JSON.parse(_responseText) : {
                    "doubleLead": false
                };
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    leadsFilter(body: LeadFilterModel | undefined): Promise<LeadsPageModel> {
        let url_ = this.baseUrl + "/api/leads/leadsFilter";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const newFilter: any = {};
        Object.keys((body as any)).forEach((key: string) => {
            const value = (body as any)[key];
            if (typeof value !== 'undefined') {
                (newFilter as any)[key] = value;
            }
        })

        const content_ = JSONStringify(newFilter);
        //const content_ = /*JSON.stringify*/JSONStringify(newFilter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsFilter(_response);
        });
    }

    protected processLeadsFilter(response: Response): Promise<LeadsPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);

                result200 = LeadsPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadsPageModel>(<any>null);
    }


    renewalsFilter(body: LeadFilterModel | undefined): Promise<LeadsPageModel> {
        let url_ = this.baseUrl + "/api/renewals/renewalsFilter";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const newFilter: any = {};
        Object.keys((body as any)).forEach((key: string) => {
            const value = (body as any)[key];
            if (typeof value !== 'undefined') {
                (newFilter as any)[key] = value;
            }
        })

        const content_ = JSONStringify(newFilter);
        //const content_ = /*JSON.stringify*/JSONStringify(newFilter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalsFilter(_response);
        });
    }

    protected processRenewalsFilter(response: Response): Promise<LeadsPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                // 
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadsPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadsPageModel>(<any>null);
    }

    renewalGetSettings(): Promise<RenewalsConfigData> {
        let url_ = this.baseUrl + "/api/renewals/renewalGetSettings";

        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalGetSettings(_response);
        });
    }
    protected processRenewalGetSettings(response: Response): Promise<RenewalsConfigData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                //const result200: RenewalsConfigData[] = resultData200.map((item: any) => RenewalsConfigData.fromJS(item));
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalsConfigData>(<any>null);
    }


    renewalGetAllDetails(renewalId: string | undefined): Promise<LeadModel> {
        let url_ = this.baseUrl + "/api/renewals/renewalGetAllDetails?";
        if (renewalId === null)
            throw new Error("The parameter 'renewalId' cannot be null.");
        else if (renewalId !== undefined)
            url_ += "renewalId=" + encodeURIComponent("" + renewalId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };


        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalGetAllDetails(_response);
        });
    }
    protected processRenewalGetAllDetails(response: Response): Promise<LeadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                //const result200: RenewalsConfigData[] = resultData200.map((item: any) => RenewalsConfigData.fromJS(item));
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadModel>(<any>null);
    }


    renewalsGetYears(): Promise<any> {
        let url_ = this.baseUrl + "/api/renewals/renewalsGetYears";

        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processrenewalsGetYears(_response);
        });
    }
    protected processrenewalsGetYears(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                //const result200: RenewalsConfigData[] = resultData200.map((item: any) => RenewalsConfigData.fromJS(item));
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalsConfigData>(<any>null);
    }


    renewalSetManualAllotment(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/renewals/renewalSetManualAllotment";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();



        const content_ = JSONStringify(body);
        //const content_ = /*JSON.stringify*/JSONStringify(newFilter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalSetManualAllotment(_response);
        });
    }

    protected processRenewalSetManualAllotment(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    renewalUpdateSettings(body: RenewalsConfigData | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/renewals/renewalUpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();



        const content_ = JSONStringify(body);
        //const content_ = /*JSON.stringify*/JSONStringify(newFilter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalUpdateSettings(_response);
        });
    }

    protected processRenewalUpdateSettings(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    renewalLinkSalespersonByFilter(body: LeadFilterModel | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/renewals/renewalLinkSalespersonByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const newFilter: any = {};
        Object.keys((body as any)).forEach((key: string) => {
            const value = (body as any)[key];
            if (typeof value !== 'undefined') {
                (newFilter as any)[key] = value;
            }
        })

        const content_ = JSONStringify(newFilter);
        //const content_ = /*JSON.stringify*/JSONStringify(newFilter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalLinkSalespersonByFilter(_response);
        });
    }

    protected processRenewalLinkSalespersonByFilter(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    renewalSetManualPrices(body: RenewalPrices | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/renewals/renewalSetManualPrices";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const newFilter: any = {};
        Object.keys((body as any)).forEach((key: string) => {
            const value = (body as any)[key];
            if (typeof value !== 'undefined') {
                (newFilter as any)[key] = value;
            }
        })

        const content_ = JSONStringify(newFilter);
        //const content_ = /*JSON.stringify*/JSONStringify(newFilter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalSetManualPrices(_response);
        });
    }

    protected processRenewalSetManualPrices(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    leadsFilterToExcelExport(body: LeadFilterModel | undefined): Promise<LeadsPageModel> {
        let url_ = this.baseUrl + "/api/leads/leadsExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const newFilter: any = {};
        Object.keys((body as any)).forEach((key: string) => {
            const value = (body as any)[key];
            if (typeof value !== 'undefined') {
                (newFilter as any)[key] = value;
            }
        })
        console.log('leadsFilterToExcelExport', newFilter)

        const content_ = JSONStringify(newFilter);
        //const content_ = /*JSON.stringify*/JSONStringify(newFilter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsFilterExcelExport(_response);
        });
    }

    protected async processLeadsFilterExcelExport(response: Response): Promise<LeadsPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let fileName = `${Date.now()}.xlsx`.trim();
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            console.log('response :>> ', response);

            // Clean up after downloading
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadsPageModel>(<any>null);
    }

    /**
     * @return Success
     */
    leadsExport(): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsExport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsExport(_response);
        });
    }

    protected processLeadsExport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    leadsImport(): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsImport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsImport(_response);
        });
    }

    protected processLeadsImport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    leadsImport2(file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsImport2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsImport2(_response);
        });
    }

    protected processLeadsImport2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsUpdateStatus(body: LeadModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsUpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsUpdateStatus(_response);
        });
    }

    protected processLeadsUpdateStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadUpdateStatus(body: any): Promise<ResponseObject> {
        let url_ = this.baseUrl + "/api/leads/leadsUpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadUpdateStatus(_response);
        });
    }

    protected processLeadUpdateStatus(response: Response): Promise<ResponseObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return _responseText === "" ? {
                    statusCode: -1,
                    statusMessage: 'noData'
                } : JSON.parse(_responseText, this.jsonParseReviver);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return {
                    statusCode: -1,
                    statusMessage: 'noData'
                }
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseObject>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsCreate(body: LeadsCreateRequest | undefined): Promise<LeadModel> {
        let url_ = this.baseUrl + "/api/leads/leadsCreate";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsCreate(_response);
        });
    }

    protected processLeadsCreate(response: Response): Promise<LeadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadModel>(<any>null);
    }

    /**
     * @return Success
     */
    leadsCreateTablet(): Promise<LeadModel> {
        let url_ = this.baseUrl + "/api/leads/leadsCreateTablet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsCreateTablet(_response);
        });
    }

    protected processLeadsCreateTablet(response: Response): Promise<LeadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadModel>(<any>null);
    }

    /**
     * @return Success
     */
    leadsTabletHome(): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsTabletHome";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsTabletHome(_response);
        });
    }

    protected processLeadsTabletHome(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    leadsRoadServices(): Promise<LeadModel> {
        let url_ = this.baseUrl + "/api/leads/leadsRoadServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsRoadServices(_response);
        });
    }

    protected processLeadsRoadServices(response: Response): Promise<LeadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadModel>(<any>null);
    }

    /**
     * @return Success
     */
    leadsManufacturersGetAll(): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsManufacturersGetAll";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsManufacturersGetAll(_response);
        });
    }

    protected processLeadsManufacturersGetAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    DynamicColsGetAllModules(): Promise<ModuleModel[]> {
        let url_ = this.baseUrl + "/api/dynamicCols/DynamicColsGetAllModules";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDynamicColsGetAllModules(_response);
        });
    }

    protected processDynamicColsGetAllModules(response: Response): Promise<ModuleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200: ModuleModel[] = resultData200.map((item: any) => ModuleModel.fromJS(item));
                return result200;

            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleModel[]>(<any>null);
    }

    DynamicColsGetDynamicColsByModuleId(moduleId: string): Promise<DynamicColModel[]> {
        let url_ = this.baseUrl + "/api/dynamicCols/DynamicColsGetDynamicColsByModuleId?moduleId=" + encodeURIComponent("" + moduleId);
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDynamicColsGetDynamicColsByModuleId(_response);
        });
    }

    protected processDynamicColsGetDynamicColsByModuleId(response: Response): Promise<DynamicColModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200: DynamicColModel[] = resultData200.map((item: any) => DynamicColModel.fromJS(item));
                return result200;

            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicColModel[]>(<any>null);
    }

    DynamicColsGetUserDynamicColsByModuleId(moduleId: string): Promise<UserDynamicColModel[]> {
        let url_ = this.baseUrl + "/api/dynamicCols/DynamicColsGetUserDynamicColsByModuleId?moduleId=" + encodeURIComponent("" + moduleId);
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDynamicColsGetUserDynamicColsByModuleId(_response);
        });
    }

    protected processDynamicColsGetUserDynamicColsByModuleId(response: Response): Promise<UserDynamicColModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200: UserDynamicColModel[] = resultData200.map((item: any) => UserDynamicColModel.fromJS(item));
                return result200;

            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDynamicColModel[]>(<any>null);
    }

    DynamicColsGetUserDynamicColsNamesByModuleName(moduleId: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/dynamicCols/DynamicColsGetUserDynamicColsNamesByModuleName?ModuleName=" + encodeURIComponent("" + moduleId);
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDynamicColsGetUserDynamicColsNamesByModuleName(_response);
        });
    }

    protected processDynamicColsGetUserDynamicColsNamesByModuleName(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200: string[] = resultData200.map((item: any) => item);
                return result200;

            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    DynamicColsAddUserDynamicCol(DynamicColId: string): Promise<DynamicObject1> {
        let url_ = this.baseUrl + "/api/dynamicCols/DynamicColsAddUserDynamicCol?DynamicColId=" + encodeURIComponent("" + DynamicColId);
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDynamicColsAddUserDynamicCol(_response);
        });
    }

    protected processDynamicColsAddUserDynamicCol(response: Response): Promise<DynamicObject1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200: DynamicObject1 = DynamicObject1.fromJS(resultData200);
                return result200;

            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject1>(<any>null);
    }

    DynamicColsRemoveUserDynamicCol(DynamicColId: string): Promise<DynamicObject1> {
        let url_ = this.baseUrl + "/api/dynamicCols/DynamicColsRemoveUserDynamicCol?DynamicColId=" + encodeURIComponent("" + DynamicColId);
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDynamicColsRemoveUserDynamicCol(_response);
        });
    }

    protected processDynamicColsRemoveUserDynamicCol(response: Response): Promise<DynamicObject1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200: DynamicObject1 = DynamicObject1.fromJS(resultData200);
                return result200;

            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject1>(<any>null);
    }

    /**
         * @param body (optional) 
         * @return Success
         */
    vehicleInfoCreateManufacturer(body: ManufacturerModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoCreateManufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoCreateManufacturer(_response);
        });
    }

    protected processVehicleInfoCreateManufacturer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
         * @param body (optional) 
         * @return Success
         */
    vehicleInfoCreateVehicleModel(body: VehicleModelModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoCreateVehicleModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoCreateVehicleModel(_response);
        });
    }

    protected processVehicleInfoCreateVehicleModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
         * @param body (optional) 
         * @return Success
         */
    vehicleInfoCreateVehicleSubModel(body: SubModelWithDegem | undefined): Promise<VehicleSubModelModel> {
        let url_ = this.baseUrl + "/api/cache/vehicleInfoCreateVehicleSubModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVehicleInfoCreateVehicleSubModel(_response);
        });
    }

    protected processVehicleInfoCreateVehicleSubModel(response: Response): Promise<VehicleSubModelModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200: VehicleSubModelModel = VehicleSubModelModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleSubModelModel>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    leadsManufacturersGet(body: ManufacturersGetRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsManufacturersGet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsManufacturersGet(_response);
        });
    }

    protected processLeadsManufacturersGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    leadsModelCodeFind(search: string | undefined): Promise<DynamicObject1[]> {
        let url_ = this.baseUrl + "/api/leads/leadsModelCodeFind?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsModelCodeFind(_response);
        });
    }

    protected processLeadsModelCodeFind(response: Response): Promise<DynamicObject1[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200: DynamicObject1[] = resultData200.map((item: any) => DynamicObject1.fromJS(item));
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject1[]>(<any>null);
    }

    /**
     * @param vehicleModelId (optional) 
     * @return Success
     */
    leadsManufacturerGetByVehicleModelId(vehicleModelId: string | undefined): Promise<DynamicObject1> {
        let url_ = this.baseUrl + "/api/leads/leadsManufacturerGetByVehicleModelId?";
        if (vehicleModelId === null)
            throw new Error("The parameter 'vehicleModelId' cannot be null.");
        else if (vehicleModelId !== undefined)
            url_ += "VehicleModelId=" + encodeURIComponent("" + vehicleModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsManufacturerGetByVehicleModelId(_response);
        });
    }

    protected processLeadsManufacturerGetByVehicleModelId(response: Response): Promise<DynamicObject1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject1.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject1>(<any>null);
    }

    /**
     * @param search (optional) 
     * @param manufacturerId (optional) 
     * @return Success
     */
    leadsVehicleModelsGet(search: string | undefined, manufacturerId: string | undefined): Promise<DynamicObject1> {
        let url_ = this.baseUrl + "/api/leads/leadsVehicleModelsGet?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (manufacturerId === null)
            throw new Error("The parameter 'manufacturerId' cannot be null.");
        else if (manufacturerId !== undefined)
            url_ += "ManufacturerId=" + encodeURIComponent("" + manufacturerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsVehicleModelsGet(_response);
        });
    }

    protected processLeadsVehicleModelsGet(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200.map((item: any) => {
                    return {
                        value: item.val,
                        text: item.label
                    }
                });
                // result200 = DynamicObject1.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject1>(<any>null);
    }

    /**
     * @param vehicleSubModelId (optional) 
     * @return Success
     */
    leadsVehicleModelGetByVehicleSubModelId(vehicleSubModelId: string | undefined): Promise<DynamicObject1> {
        let url_ = this.baseUrl + "/api/leads/leadsVehicleModelGetByVehicleSubModelId?";
        if (vehicleSubModelId === null)
            throw new Error("The parameter 'vehicleSubModelId' cannot be null.");
        else if (vehicleSubModelId !== undefined)
            url_ += "VehicleSubModelId=" + encodeURIComponent("" + vehicleSubModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsVehicleModelGetByVehicleSubModelId(_response);
        });
    }

    protected processLeadsVehicleModelGetByVehicleSubModelId(response: Response): Promise<DynamicObject1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject1.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject1>(<any>null);
    }

    leadsCreateRidersForLead(offerId: string | undefined): Promise<ResponseObject> {
        let url_ = this.baseUrl + "/api/leads/leadsCreateRidersForLead?";
        if (offerId === null)
            throw new Error("The parameter 'vehicleSubModelId' cannot be null.");
        else if (offerId !== undefined)
            url_ += "offerId=" + encodeURIComponent("" + offerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const body = {};
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsCreateRidersForLead(_response);
        });
    }

    protected processLeadsCreateRidersForLead(response: Response): Promise<ResponseObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? {
                    statusCode: -1,
                    statusMessage: 'noData'
                } : JSON.parse(_responseText, this.jsonParseReviver);
                // result200 = JSON.parse(resultData200);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                const res: ResponseObject = {
                    statusCode: -1,
                    statusMessage: 'some error occured'
                }
                return res;
            });
        }
        return Promise.resolve<ResponseObject>(<any>null);
    }


    /**
     * @param vehicleSubModelId (optional) 
     * @return Success
     */
    leadsGetVehicleDetailsByVehicleSubModelId(vehicleSubModelId: string | undefined): Promise<leadsModelCodeFindResponse> {
        // 
        let url_ = this.baseUrl + "/api/leads/leadsGetVehicleDetailsByVehicleSubModelId?";
        if (vehicleSubModelId === null)
            throw new Error("The parameter 'vehicleSubModelId' cannot be null.");
        else if (vehicleSubModelId !== undefined)
            url_ += "vehicleSubModelId=" + encodeURIComponent("" + vehicleSubModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {

            return this.processLeadsGetVehicleDetailsByVehicleSubModelId(_response);
        });
    }

    protected processLeadsGetVehicleDetailsByVehicleSubModelId(response: Response): Promise<leadsModelCodeFindResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = leadsModelCodeFindResponse.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<leadsModelCodeFindResponse>(<any>null);
    }

    /**
     * @param search (optional) 
     * @param vehicleModelId (optional) 
     * @return Success
     */
    leadsVehicleSubModelsGet(search: string | undefined, vehicleModelId: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/leads/leadsVehicleSubModelsGet?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (vehicleModelId === null)
            throw new Error("The parameter 'vehicleModelId' cannot be null.");
        else if (vehicleModelId !== undefined)
            url_ += "VehicleModelId=" + encodeURIComponent("" + vehicleModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = /*JSON.stringify*/JSONStringify({
            "VehicleModelId": vehicleModelId
        });

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsVehicleSubModelsGet(_response);
        });
    }

    protected processLeadsVehicleSubModelsGet(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200.map((item: any) => {
                    return {
                        value: item.val,
                        text: item.label,
                        code: item.code
                    }
                });
                // result200 = DynamicObject1.fromJS(resultData200);
                return result200;
                // return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param subModelId (optional) 
     * @return Success
     */
    leadsGetModelCodeBySubModel(subModelId: string | undefined): Promise<DynamicObject8> {
        let url_ = this.baseUrl + "/api/leads/leadsGetModelCodeBySubModel?";
        if (subModelId === null)
            throw new Error("The parameter 'subModelId' cannot be null.");
        else if (subModelId !== undefined)
            url_ += "subModelId=" + encodeURIComponent("" + subModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsGetModelCodeBySubModel(_response);
        });
    }

    protected processLeadsGetModelCodeBySubModel(response: Response): Promise<DynamicObject8> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject8.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject8>(<any>null);
    }

    /**
     * @param manufacturerId (optional) 
     * @return Success
     */
    leadsVehicleSubModelsGetByManufacturerId(manufacturerId: string | undefined): Promise<any[]> {
        let url_ = this.baseUrl + "/api/leads/leadsVehicleSubModelsGetByManufacturerId?";
        if (manufacturerId === null)
            throw new Error("The parameter 'manufacturerId' cannot be null.");
        else if (manufacturerId !== undefined)
            url_ += "manufacturerId=" + encodeURIComponent("" + manufacturerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsVehicleSubModelsGetByManufacturerId(_response);
        });
    }

    protected processLeadsVehicleSubModelsGetByManufacturerId(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; // DynamicObject8.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(<any>null);
    }














    /**
     * @param code (optional) 
     * @return Success
     */
    leadsGetModelDetailsByModelCode(code: string | undefined, licenseNumber: string | undefined): Promise<DynamicObject5> {
        let url_ = this.baseUrl + "/api/leads/leadsGetModelDetailsByModelCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ += "licenseNumber=" + encodeURIComponent("" + licenseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsGetModelDetailsByModelCode(_response);
        });
    }

    protected processLeadsGetModelDetailsByModelCode(response: Response): Promise<DynamicObject5> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject5.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject5>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsCreate2(body: LeadModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/leads/leadsCreate2";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsCreate2(_response);
        });
    }

    protected processLeadsCreate2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                if (_responseText === "Success") {
                    _responseText = JSON.stringify({ status: "OK" });
                }

                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsCreateTablet2(body: LeadModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsCreateTablet2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsCreateTablet2(_response);
        });
    }

    protected processLeadsCreateTablet2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    leadsGetLeadById(id: string | undefined): Promise<LeadModel> {
        let url_ = this.baseUrl + "/api/leads/leadsGetLeadById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsGetLeadById(_response);
        });
    }

    protected processLeadsGetLeadById(response: Response): Promise<LeadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsUpdateIdentity(body: LeadModel | undefined): Promise<LeadModel> {
        let url_ = this.baseUrl + "/api/leads/leadsUpdateIdentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsUpdateIdentity(_response);
        });
    }

    protected processLeadsUpdateIdentity(response: Response): Promise<LeadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsDashboardStations(body: DashboardStationsFilter | undefined): Promise<DashBoardStationModel> {
        let url_ = this.baseUrl + "/api/leads/leadsDashboardStations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsDashboardStations(_response);
        });
    }

    protected processLeadsDashboardStations(response: Response): Promise<DashBoardStationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DashBoardStationModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashBoardStationModel>(<any>null);
    }

    /**
     * @return Success
     */
    leadsDashboard(): Promise<DashboardModel> {
        let url_ = this.baseUrl + "/api/leads/leadsDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsDashboard(_response);
        });
    }

    protected processLeadsDashboard(response: Response): Promise<DashboardModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DashboardModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsDashboardFilter(body: DashboardStationsFilter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsDashboardFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsDashboardFilter(_response);
        });
    }

    protected processLeadsDashboardFilter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    leadsDashboardExport(body: DashboardStationsFilter | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/leads/leadsDashboardExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsDashboardExport(_response);
        });
    }

    protected processLeadsDashboardExport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    leadsStationsFilter(): Promise<DashboardStationUserModel> {
        let url_ = this.baseUrl + "/api/leads/leadsStationsFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsStationsFilter(_response);
        });
    }

    protected processLeadsStationsFilter(response: Response): Promise<DashboardStationUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DashboardStationUserModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardStationUserModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    leadsDelete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            body: JSON.stringify({}),
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };


        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsDelete(_response);
        });
    }

    protected processLeadsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param offerId (optional) 
     * @return Success
     */
    leadsDeleteOffer(offerId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/leadsDeleteOffer?";
        if (offerId === null)
            throw new Error("The parameter 'offerId' cannot be null.");
        else if (offerId !== undefined)
            url_ += "offerId=" + encodeURIComponent("" + offerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsDeleteOffer(_response);
        });
    }

    protected processLeadsDeleteOffer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    leadsSendMail(id: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/leads/leadsSendMail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsSendMail(_response);
        });
    }

    protected processLeadsSendMail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                // let result200: any = null;
                // let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param leadId (optional) 
     * @return Success
     */
    leadsPrintLead(leadId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/leads/leadsPrintLead?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsPrintLead(_response);
        });
    }

    protected processLeadsPrintLead(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    leadsAPIServiceDirection(): Promise<LeadAPIDirectionModel> {
        let url_ = this.baseUrl + "/api/leads/leadsAPIServiceDirection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadsAPIServiceDirection(_response);
        });
    }

    protected processLeadsAPIServiceDirection(response: Response): Promise<LeadAPIDirectionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadAPIDirectionModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadAPIDirectionModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    offerFilter(body: CommonCustomerFilterModel | undefined): Promise<OfferModel[]> {
        let url_ = this.baseUrl + "/api/leads/offerFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfferFilter(_response);
        });
    }

    protected processOfferFilter(response: Response): Promise<OfferModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(OfferModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfferModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    offerCreate(body: CreateOfferModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/leads/offerCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfferCreate(_response);
        });
    }

    protected processOfferCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param phoneNumber (optional) 
     * @param year (optional) 
     * @param licenseNumber (optional) 
     * @param modelCode (optional) 
     * @param vehicleSubModelId (optional) 
     * @param stationUserId (optional) 
     * @param deliveryDate (optional) 
     * @param comment (optional) 
     * @return Success
     */
    leadAPINewCreateApi(firstName: string | undefined, lastName: string | undefined, phoneNumber: string | undefined, year: number | undefined, licenseNumber: string | undefined, modelCode: string | undefined, vehicleSubModelId: string | undefined, stationUserId: string | undefined, deliveryDate: Date | undefined, comment: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/leads/leadAPINewCreateApi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (firstName === null || firstName === undefined)
            throw new Error("The parameter 'firstName' cannot be null.");
        else
            content_.append("FirstName", firstName.toString());
        if (lastName === null || lastName === undefined)
            throw new Error("The parameter 'lastName' cannot be null.");
        else
            content_.append("LastName", lastName.toString());
        if (phoneNumber === null || phoneNumber === undefined)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else
            content_.append("PhoneNumber", phoneNumber.toString());
        if (year === null || year === undefined)
            throw new Error("The parameter 'year' cannot be null.");
        else
            content_.append("Year", year.toString());
        if (licenseNumber === null || licenseNumber === undefined)
            throw new Error("The parameter 'licenseNumber' cannot be null.");
        else
            content_.append("LicenseNumber", licenseNumber.toString());
        if (modelCode === null || modelCode === undefined)
            throw new Error("The parameter 'modelCode' cannot be null.");
        else
            content_.append("ModelCode", modelCode.toString());
        if (vehicleSubModelId === null || vehicleSubModelId === undefined)
            throw new Error("The parameter 'vehicleSubModelId' cannot be null.");
        else
            content_.append("VehicleSubModelId", vehicleSubModelId.toString());
        if (stationUserId === null || stationUserId === undefined)
            throw new Error("The parameter 'stationUserId' cannot be null.");
        else
            content_.append("StationUserId", stationUserId.toString());
        if (deliveryDate === null || deliveryDate === undefined)
            throw new Error("The parameter 'deliveryDate' cannot be null.");
        else
            content_.append("DeliveryDate", deliveryDate.toJSON());
        if (comment === null || comment === undefined)
            throw new Error("The parameter 'comment' cannot be null.");
        else
            content_.append("Comment", comment.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeadAPINewCreateApi(_response);
        });
    }

    protected processLeadAPINewCreateApi(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    assignmentsIndex(): Promise<AssignmentGridModel[]> {
        let url_ = this.baseUrl + "/api/leads/assignmentsIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignmentsIndex(_response);
        });
    }

    protected processAssignmentsIndex(response: Response): Promise<AssignmentGridModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(AssignmentGridModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentGridModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignmentsFilter(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/AssignmentFilter";
        url_ = url_.replace(/[?&]$/, "");

        const requestBody = { ...body }
        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const requestKeys = Object.keys(requestBody);
        requestKeys.forEach((key: string) => {
            switch (key) {
                case 'eventDateFrom':
                case 'alertDateFrom':
                case 'createdDateFrom':
                case 'endDateFrom':
                case 'eventDateTo':
                case 'alertDateTo':
                case 'createdDateTo':
                case 'endDateTo':
                    if (requestBody[key]) {
                        let date = new Date(requestBody[key]);
                        let day: string = date.getDate().toString();
                        if (parseInt(day) < 10) {
                            day = `0${day}`;
                        }
                        let month: string = (date.getMonth() + 1).toString();
                        if (parseInt(month) < 10) {
                            month = `0${month}`;
                        }
                        const year = date.getFullYear();
                        const dateString = `${year}-${month}-${day}`;
                        requestBody[key] = dateString;
                    }
                    break;

                default:
                    break;
            }
        })
        if (requestBody.eventDateFrom) {
            let date = new Date(requestBody.eventDateFrom);
            const day = date.getDate();
            let month: string = (date.getMonth() + 1).toString();
            if (parseInt(month) < 10) {
                month = `0${month}`;
            }
            const year = date.getFullYear();
            const dateString = `${year}-${month}-${day}T00:00:00.000Z`;
            requestBody.eventDateFrom = dateString
        }
        if (requestBody.eventDateTo) {
            let date = new Date(requestBody.eventDateTo);
            const day = date.getDate();
            let month: string = (date.getMonth() + 1).toString();
            if (parseInt(month) < 10) {
                month = `0${month}`;
            }
            const year = date.getFullYear();
            const dateString = `${year}-${month}-${day}T23:59:59.000Z`;
            requestBody.eventDateTo = dateString
        }
        const content_ = JSON.stringify(requestBody);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignmentsFilter(_response);
        });
    }

    protected processAssignmentsFilter(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModel>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    setAssignmentStatus(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/AssignmentUpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAssignmentStatus(_response);
        });
    }

    protected processSetAssignmentStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    getAssignmentStatuses(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/AssignmentStatusGetAll";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentStatuses(_response);
        });
    }

    protected processGetAssignmentStatuses(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    addAssignmentStatus(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/AssignmentStatusAdd";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAssignmentStatus(_response);
        });
    }

    protected processAddAssignmentStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id
     * @return Success
     */
    deleteAssignmentStatus(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/AssignmentStatusDelete?";
        if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("deleteAssignmentStatus: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processdeleteAssignmentStatus(_response);
        });
    }

    protected processdeleteAssignmentStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    RenewalLeadCommentAdd(body: LeadCommentModel | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/renewals/RenewalLeadCommentAdd";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalLeadCommentAdd(_response);
        });
    }

    protected processRenewalLeadCommentAdd(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                //result200 = LeadCommentModel.fromJS(resultData200);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadCommentModel>(<any>null);
    }

    RenewalGetLeadComments(leadId: string | undefined): Promise<LeadCommentModel[]> {
        let url_ = this.baseUrl + "/api/renewals/RenewalGetLeadComments?";
        if (leadId !== undefined) {
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        } else {
            throw new Error("deleteAssignmentStatus: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };


        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalGetLeadComments(_response);
        });


    }

    protected processRenewalGetLeadComments(response: Response): Promise<LeadCommentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(LeadCommentModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadCommentModel[]>(<any>null);
    }

    /**
     * @param id
     * @return Success
     */
    RenewalLeadCommentAddDelete(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/renewals/RenewalLeadCommentAddDelete?";
        if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("deleteAssignmentStatus: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalLeadCommentAddDelete(_response);
        });
    }

    protected processRenewalLeadCommentAddDelete(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    /**
     * @param body (optional) 
     * @return Success
     */
    setAssignmentSeen(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/AssignmentUpdateSeen";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAssignmentSeen(_response);
        });
    }

    protected processSetAssignmentSeen(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    /**
     * @param body (optional) 
     * @return Success
     */
    getAssignmentTemplates(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/GetAssignmentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTemplates(_response);
        });
    }

    protected processGetAssignmentTemplates(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    GetLeadStatuses2(leadsource: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/leads/GetLeadStatuses2?leadsource=" + leadsource;
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeadStatuses22(_response);
        });
    }

    protected processGetLeadStatuses22(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    GetLeadStatuses(leadsource: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/leads/GetLeadStatuses?leadsource=" + leadsource;
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeadStatuses2(_response);
        });
    }

    protected processGetLeadStatuses2(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }
    /**
     * @param body (optional) 
     * @return Success
     */
    AddLeadsStatus(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/leads/AddLeadsStatus";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddLeadsStatus(_response);
        });
    }

    protected processAddLeadsStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id
     * @return Success
     */
    DeleteLeadstStatus(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/leads/DeleteLeadstStatus?";
        if (id !== undefined) {
            url_ += "statusId=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("deleteAssignmentStatus: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        // const body = {templateId:id}
        // const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            method: "GET",
            // body: content_,
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLeadstStatus(_response);
        });
    }

    protected processDeleteLeadstStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    addAssignmentTemplate(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/AddAssignmentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAssignmentTemplates(_response);
        });
    }

    protected processAddAssignmentTemplates(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id
     * @return Success
     */
    deleteAssignmentTemplate(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/DeleteAssignmentTemplates?";
        if (id !== undefined) {
            url_ += "templateId=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("deleteAssignmentStatus: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        // const body = {templateId:id}
        // const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            method: "GET",
            // body: content_,
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssignmentTemplates(_response);
        });
    }

    protected processDeleteAssignmentTemplates(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    /**
     * @param body (optional) 
     * @return Success
     */
    signingFilter(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/signingFilter";
        url_ = url_.replace(/[?&]$/, "");

        const requestBody = { ...body }
        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const requestKeys = Object.keys(requestBody);
        requestKeys.forEach((key: string) => {
            switch (key) {
                case 'eventDateFrom':
                case 'alertDateFrom':
                case 'createdDateFrom':
                case 'endDateFrom':
                case 'startDateFrom':
                case 'startDateTo':
                case 'eventDateTo':
                case 'alertDateTo':
                case 'createdDateTo':
                case 'endDateTo':
                    if (requestBody[key]) {
                        let date = new Date(requestBody[key]);
                        let day: string = date.getDate().toString();
                        if (parseInt(day) < 10) {
                            day = `0${day}`;
                        }
                        let month: string = (date.getMonth() + 1).toString();
                        if (parseInt(month) < 10) {
                            month = `0${month}`;
                        }
                        const year = date.getFullYear();
                        const dateString = `${year}-${month}-${day}`;
                        requestBody[key] = dateString;
                    }
                    break;

                default:
                    break;
            }
        })
        if (requestBody.eventDateFrom) {
            let date = new Date(requestBody.eventDateFrom);
            const day = date.getDate();
            let month: string = (date.getMonth() + 1).toString();
            if (parseInt(month) < 10) {
                month = `0${month}`;
            }
            const year = date.getFullYear();
            const dateString = `${year}-${month}-${day}T00:00:00.000Z`;
            requestBody.eventDateFrom = dateString
        }
        if (requestBody.eventDateTo) {
            let date = new Date(requestBody.eventDateTo);
            const day = date.getDate();
            let month: string = (date.getMonth() + 1).toString();
            if (parseInt(month) < 10) {
                month = `0${month}`;
            }
            const year = date.getFullYear();
            const dateString = `${year}-${month}-${day}T23:59:59.000Z`;
            requestBody.eventDateTo = dateString
        }
        const content_ = JSON.stringify(requestBody);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSigningFilter(_response);
        });
    }

    protected processSigningFilter(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModel>(<any>null);
    }

    signingExportToExcel(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/signingExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const requestBody = { ...body }
        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const requestKeys = Object.keys(requestBody);
        requestKeys.forEach((key: string) => {
            switch (key) {
                case 'eventDateFrom':
                case 'alertDateFrom':
                case 'createdDateFrom':
                case 'endDateFrom':
                case 'startDateFrom':
                case 'startDateTo':
                case 'eventDateTo':
                case 'alertDateTo':
                case 'createdDateTo':
                case 'endDateTo':
                    if (requestBody[key]) {
                        let date = new Date(requestBody[key]);
                        let day: string = date.getDate().toString();
                        if (parseInt(day) < 10) {
                            day = `0${day}`;
                        }
                        let month: string = (date.getMonth() + 1).toString();
                        if (parseInt(month) < 10) {
                            month = `0${month}`;
                        }
                        const year = date.getFullYear();
                        const dateString = `${year}-${month}-${day}`;
                        requestBody[key] = dateString;
                    }
                    break;

                default:
                    break;
            }
        })
        if (requestBody.eventDateFrom) {
            let date = new Date(requestBody.eventDateFrom);
            const day = date.getDate();
            let month: string = (date.getMonth() + 1).toString();
            if (parseInt(month) < 10) {
                month = `0${month}`;
            }
            const year = date.getFullYear();
            const dateString = `${year}-${month}-${day}T00:00:00.000Z`;
            requestBody.eventDateFrom = dateString
        }
        if (requestBody.eventDateTo) {
            let date = new Date(requestBody.eventDateTo);
            const day = date.getDate();
            let month: string = (date.getMonth() + 1).toString();
            if (parseInt(month) < 10) {
                month = `0${month}`;
            }
            const year = date.getFullYear();
            const dateString = `${year}-${month}-${day}T23:59:59.000Z`;
            requestBody.eventDateTo = dateString
        }
        const content_ = JSON.stringify(requestBody);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEigningExportToExcel(_response);
        });
    }

    protected async processEigningExportToExcel(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let fileName = `${Date.now()}.xlsx`.trim();
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            console.log('response :>> ', response);

            // Clean up after downloading
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }
    
    GetSigningData(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/GetSigningData";
        url_ = url_.replace(/[?&]$/, "");

        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "?id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSigningData(_response);
        });

    }

    protected processGetSigningData(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModel>(<any>null);
    }

    PrintPolicy(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/PrintPolicy";
        url_ = url_.replace(/[?&]$/, "");

        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "?id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintPolicy(_response);
        });

    }

    protected processPrintPolicy(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModel>(<any>null);
    }

    PrintSue(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesPrintSue";
        url_ = url_.replace(/[?&]$/, "");

        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "?id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintSue(_response);
        });

    }

    protected processPrintSue(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    signingDelete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/signing/signingDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            body: JSON.stringify({}),
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };


        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSigningDelete(_response);
        });
    }



    protected processSigningDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    stationGetStations(): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/maintenance/stationGetStations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationGetStations(_response);
        });
    }

    protected processStationGetStations(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListItem.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stationUpdate(body: StationModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/stationUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationUpdate(_response);
        });
    }

    protected processStationUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stationSort(body: SortModel[] | undefined): Promise<StationModel[]> {
        let url_ = this.baseUrl + "/api/maintenance/stationSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationSort(_response);
        });
    }

    protected processStationSort(response: Response): Promise<StationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(StationModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StationModel[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    stationEdit(id: string | undefined): Promise<StationModelForCreate> {
        let url_ = this.baseUrl + "/api/maintenance/stationEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationEdit(_response);
        });
    }

    protected processStationEdit(response: Response): Promise<StationModelForCreate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = StationModelForCreate.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StationModelForCreate>(<any>null);
    }

    /**
     * @return Success
     */
    stationCreateStation(): Promise<StationModelForCreate> {
        let url_ = this.baseUrl + "/api/maintenance/stationCreateStation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationCreateStation(_response);
        });
    }

    protected processStationCreateStation(response: Response): Promise<StationModelForCreate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = StationModelForCreate.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StationModelForCreate>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stationCreateStation2(body: StationModelForCreate | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/stationCreateStation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationCreateStation2(_response);
        });
    }

    protected processStationCreateStation2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stationUpsert(body: StationModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/stationUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationUpsert(_response);
        });
    }

    protected processStationUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    stationDelete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/stationDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStationDelete(_response);
        });
    }

    protected processStationDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    projectGetProjects(): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/maintenance/projectGetProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectGetProjects(_response);
        });
    }

    protected processProjectGetProjects(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListItem.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    projectUpdate(body: BranchModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/projectUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectUpdate(_response);
        });
    }

    protected processProjectUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    projectSort(body: FilterDataModel | undefined): Promise<ProjectsModel> {
        let url_ = this.baseUrl + "/api/maintenance/projectSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectSort(_response);
        });
    }

    protected processProjectSort(response: Response): Promise<ProjectsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectsModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    projectEdit(id: string | undefined): Promise<ProjectsModel> {
        let url_ = this.baseUrl + "/api/maintenance/projectEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectEdit(_response);
        });
    }

    protected processProjectEdit(response: Response): Promise<ProjectsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectsModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    projectGetAddUsersView(id: string | undefined): Promise<BranchesDepartmentsUsersModel> {
        let url_ = this.baseUrl + "/api/maintenance/projectGetAddUsersView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectGetAddUsersView(_response);
        });
    }

    protected processProjectGetAddUsersView(response: Response): Promise<BranchesDepartmentsUsersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BranchesDepartmentsUsersModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchesDepartmentsUsersModel>(<any>null);
    }

    /**
     * @param parentId (optional) 
     * @return Success
     */
    projectAdd(parentId: string | undefined): Promise<BranchModel> {
        let url_ = this.baseUrl + "/api/maintenance/projectAdd?";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectAdd(_response);
        });
    }

    protected processProjectAdd(response: Response): Promise<BranchModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BranchModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    projectDelete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/projectDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectDelete(_response);
        });
    }

    protected processProjectDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    projectCreate(body: ProjectModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/projectCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectCreate(_response);
        });
    }

    protected processProjectCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    projectAddUsers(body: ProjectUsersModel | undefined): Promise<BranchesModel> {
        let url_ = this.baseUrl + "/api/maintenance/projectAddUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectAddUsers(_response);
        });
    }

    protected processProjectAddUsers(response: Response): Promise<BranchesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BranchesModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchesModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    projectUpsert(body: ProjectModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/projectUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectUpsert(_response);
        });
    }

    protected processProjectUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    packageUpdate(body: PackageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/packageUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackageUpdate(_response);
        });
    }

    protected processPackageUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    packageSort(body: CommonFilterModel | undefined): Promise<PackageModel> {
        let url_ = this.baseUrl + "/api/maintenance/packageSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackageSort(_response);
        });
    }

    protected processPackageSort(response: Response): Promise<PackageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PackageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PackageModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    packageCreate(body: PackageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/packageCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackageCreate(_response);
        });
    }

    protected processPackageCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    groupGet(id: string | undefined): Promise<RoleUpsertModel> {
        let url_ = this.baseUrl + "/api/maintenance/groupGet?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGroupGet(_response);
        });
    }

    protected processGroupGet(response: Response): Promise<RoleUpsertModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleUpsertModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleUpsertModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    groupCreate(body: RoleUpsertModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/groupCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGroupCreate(_response);
        });
    }

    protected processGroupCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    groupSort(body: SortModel[] | undefined): Promise<RoleModel[]> {
        let url_ = this.baseUrl + "/api/maintenance/groupSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGroupSort(_response);
        });
    }

    protected processGroupSort(response: Response): Promise<RoleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(RoleModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    groupDelete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/groupDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGroupDelete(_response);
        });
    }

    protected processGroupDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param relationId (optional) 
     * @param relation (optional) 
     * @return Success
     */
    documentsIndex(relationId: string | undefined, relation: RelationshipType | undefined): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/maintenance/documentsIndex?";
        if (relationId === null)
            throw new Error("The parameter 'relationId' cannot be null.");
        else if (relationId !== undefined)
            url_ += "relationId=" + encodeURIComponent("" + relationId) + "&";
        if (relation === null)
            throw new Error("The parameter 'relation' cannot be null.");
        else if (relation !== undefined)
            url_ += "relation=" + encodeURIComponent("" + relation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentsIndex(_response);
        });
    }

    protected processDocumentsIndex(response: Response): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DocumentModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentModel[]>(<any>null);
    }

    /**
     * @param relationId (optional) 
     * @param relation (optional) 
     * @return Success
     */
    documentsRefresh(relationId: string | undefined, relation: RelationshipType | undefined): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/maintenance/documentsRefresh?";
        if (relationId === null)
            throw new Error("The parameter 'relationId' cannot be null.");
        else if (relationId !== undefined)
            url_ += "relationId=" + encodeURIComponent("" + relationId) + "&";
        if (relation === null)
            throw new Error("The parameter 'relation' cannot be null.");
        else if (relation !== undefined)
            url_ += "relation=" + encodeURIComponent("" + relation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentsRefresh(_response);
        });
    }

    protected processDocumentsRefresh(response: Response): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DocumentModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentsUploadFile(body: DocumentModel | undefined): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/maintenance/documentsUploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentsUploadFile(_response);
        });
    }

    protected processDocumentsUploadFile(response: Response): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DocumentModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    bafiDataIndex(): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/bafiDataIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBafiDataIndex(_response);
        });
    }

    protected processBafiDataIndex(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    officeDepartmentsGetOfficeDepartments(): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/maintenance/officeDepartmentsGetOfficeDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfficeDepartmentsGetOfficeDepartments(_response);
        });
    }

    protected processOfficeDepartmentsGetOfficeDepartments(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListItem.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    officeDepartmentsUpdate(body: OfficeDepartmentModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/officeDepartmentsUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfficeDepartmentsUpdate(_response);
        });
    }

    protected processOfficeDepartmentsUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    officeDepartmentsSort(body: FilterDataModel | undefined): Promise<OfficeDepartmentsModel> {
        let url_ = this.baseUrl + "/api/maintenance/officeDepartmentsSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfficeDepartmentsSort(_response);
        });
    }

    protected processOfficeDepartmentsSort(response: Response): Promise<OfficeDepartmentsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OfficeDepartmentsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeDepartmentsModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    officeDepartmentsEdit(id: string | undefined): Promise<OfficeDepartmentModel> {
        let url_ = this.baseUrl + "/api/maintenance/officeDepartmentsEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfficeDepartmentsEdit(_response);
        });
    }

    protected processOfficeDepartmentsEdit(response: Response): Promise<OfficeDepartmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OfficeDepartmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeDepartmentModel>(<any>null);
    }

    /**
     * @param parentId (optional) 
     * @return Success
     */
    officeDepartmentsAdd(parentId: string | undefined): Promise<OfficeDepartmentModel> {
        let url_ = this.baseUrl + "/api/maintenance/officeDepartmentsAdd?";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfficeDepartmentsAdd(_response);
        });
    }

    protected processOfficeDepartmentsAdd(response: Response): Promise<OfficeDepartmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OfficeDepartmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeDepartmentModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    officeDepartmentsDelete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/officeDepartmentsDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfficeDepartmentsDelete(_response);
        });
    }

    protected processOfficeDepartmentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    officeDepartmentsCreate(body: OfficeDepartmentModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/officeDepartmentsCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfficeDepartmentsCreate(_response);
        });
    }

    protected processOfficeDepartmentsCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    officeDepartmentsUpsert(body: OfficeDepartmentModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/officeDepartmentsUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfficeDepartmentsUpsert(_response);
        });
    }

    protected processOfficeDepartmentsUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    brachGetBranches(): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/maintenance/brachGetBranches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrachGetBranches(_response);
        });
    }

    protected processBrachGetBranches(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListItem.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    brachUpdate(body: BranchModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/brachUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrachUpdate(_response);
        });
    }

    protected processBrachUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    brachSort(body: FilterDataModel | undefined): Promise<BranchesModel> {
        let url_ = this.baseUrl + "/api/maintenance/brachSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrachSort(_response);
        });
    }

    protected processBrachSort(response: Response): Promise<BranchesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BranchesModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchesModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    brachEdit(id: string | undefined): Promise<BranchesModel> {
        let url_ = this.baseUrl + "/api/maintenance/brachEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrachEdit(_response);
        });
    }

    protected processBrachEdit(response: Response): Promise<BranchesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BranchesModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchesModel>(<any>null);
    }

    /**
     * @param parentId (optional) 
     * @return Success
     */
    brachAdd(parentId: string | undefined): Promise<BranchModel> {
        let url_ = this.baseUrl + "/api/maintenance/brachAdd?";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrachAdd(_response);
        });
    }

    protected processBrachAdd(response: Response): Promise<BranchModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BranchModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    brachDelete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/brachDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrachDelete(_response);
        });
    }

    protected processBrachDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    brachCreate(body: BranchModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/brachCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrachCreate(_response);
        });
    }

    protected processBrachCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    brachUpsert(body: BranchModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/maintenance/brachUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrachUpsert(_response);
        });
    }

    protected processBrachUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    treatmentsIndex(): Promise<TreatmentTabModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsIndex(_response);
        });
    }

    protected processTreatmentsIndex(response: Response): Promise<TreatmentTabModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentTabModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentTabModel>(<any>null);
    }

    /**
     * @param relationId (optional) 
     * @param relation (optional) 
     * @return Success
     */
    treatmentsIndexForRelationView(relationId: string | undefined, relation: RelationshipType | undefined): Promise<TreatmentTabModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsIndexForRelationView?";
        if (relationId === null)
            throw new Error("The parameter 'relationId' cannot be null.");
        else if (relationId !== undefined)
            url_ += "RelationId=" + encodeURIComponent("" + relationId) + "&";
        if (relation === null)
            throw new Error("The parameter 'relation' cannot be null.");
        else if (relation !== undefined)
            url_ += "relation=" + encodeURIComponent("" + relation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsIndexForRelationView(_response);
        });
    }

    protected processTreatmentsIndexForRelationView(response: Response): Promise<TreatmentTabModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentTabModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentTabModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    treatmentsFilter(body: any): Promise<TreatmentTabModel> {
        // //console.log('treatmentsFilter');
        let url_ = this.baseUrl + "/api/operation/treatmentsFilter";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsFilter(_response);
        });
    }

    protected processTreatmentsFilter(response: Response): Promise<TreatmentTabModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                console.log('processTreatmentsFilter resultData200', resultData200)
                // result200 = TreatmentTabModel.fromJS(resultData200);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return Promise.resolve<TreatmentTabModel>(<any>null);
            });
        }
        return Promise.resolve<TreatmentTabModel>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    treatmentsPrintTrteatments(body: TreatmentFilterModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/operation/treatmentsPrintTrteatments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsPrintTrteatments(_response);
        });
    }

    protected processTreatmentsPrintTrteatments(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    treatmentsLoadRelations(customerId: string | undefined): Promise<RelationEntitiesModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsLoadRelations?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "elementId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                "Content-Type": "application/json-patch+json",
                "Authorization": `Bearer ${this.getAuthToken()}`
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsLoadRelations(_response);
        });
    }

    protected processTreatmentsLoadRelations(response: Response): Promise<RelationEntitiesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RelationEntitiesModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelationEntitiesModel>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    treatmentsLoadRelationsForCustomer(customerId: string | undefined): Promise<RelationEntitiesModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsLoadRelationsForCustomer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsLoadRelationsForCustomer(_response);
        });
    }

    protected processTreatmentsLoadRelationsForCustomer(response: Response): Promise<RelationEntitiesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RelationEntitiesModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelationEntitiesModel>(<any>null);
    }

    /**
     * @return Success
     */
    treatmentsLoadCustomersForRelations(): Promise<DynamicObject1[]> {
        let url_ = this.baseUrl + "/api/operation/treatmentsLoadCustomersForRelations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsLoadCustomersForRelations(_response);
        });
    }

    protected processTreatmentsLoadCustomersForRelations(response: Response): Promise<DynamicObject1[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DynamicObject1.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject1[]>(<any>null);
    }

    /**
     * @return Success
     */
    treatmentsLoadLeadsForRelations(type: string): Promise<DynamicObject4[]> {
        let url_ = this.baseUrl + "/api/operation/treatmentsLoadLeadsForRelations";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = /*JSON.stringify*/JSONStringify({});

        const token = this.getAuthToken();

        let method: string = 'POST';
        switch (type) {
            case 'lead':
                method = 'POST'
                break;
            case 'user':
                method = 'GET'
                break;
            default:
                break;
        }

        let options_ = <RequestInit>{
            method: method,
            headers: {
                Authorization: `Bearer ${token}`,
                "Accept": "text/plain",
                "Content-Type": "application/json-patch+json",
            }
        };

        if (type == 'lead') {
            options_.body = content_;
        }

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsLoadLeadsForRelations(_response);
        });
    }

    protected processTreatmentsLoadLeadsForRelations(response: Response): Promise<DynamicObject4[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DynamicObject4.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject4[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsUpsertCall(id: string | undefined, customerId: string | undefined, leadId: string | undefined): Promise<CallModelForUpsert> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertCall?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertCall(_response);
        });
    }

    protected processTreatmentsUpsertCall(response: Response): Promise<CallModelForUpsert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CallModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallModelForUpsert>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertCall2(id: string | undefined, body: CallModelForUpsert | undefined): Promise<TreatmentModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertCall?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertCall2(_response);
        });
    }

    protected processTreatmentsUpsertCall2(response: Response): Promise<TreatmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsUpsertAssignment(id: string | undefined, customerId: string | undefined, leadId: string | undefined): Promise<AssignmentModelForUpsert> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertAssignment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertAssignment(_response);
        });
    }

    protected processTreatmentsUpsertAssignment(response: Response): Promise<AssignmentModelForUpsert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssignmentModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModelForUpsert>(<any>null);
    }

    treatmentsGetNewAssignments(id?: string): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/AssignmentGetCounter";
        url_ = url_.replace(/[?&]$/, "");

        const body = {
            id: id
        }

        const token = this.getAuthToken();
        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsGetNewAssignments(_response);
        });
    }

    protected processTreatmentsGetNewAssignments(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);

                // return ResponseObject2.fromJS(result200)
                return result200;


            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);

                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertAssignment2(id: string | undefined, body: AssignmentModelForUpsert | undefined): Promise<Treatment> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertAssignment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertAssignment2(_response);
        });
    }

    protected processTreatmentsUpsertAssignment2(response: Response): Promise<Treatment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Treatment.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Treatment>(<any>null);
    }

    // GetAssignment


    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsGetAssignment(id: string): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/GetAssignment?";

        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";

        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsGetAssignment(_response);
        });
    }

    protected processTreatmentsGetAssignment(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    GetSigningCounter(): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/GetSigningCounter";


        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSigningCounter(_response);
        });
    }

    protected processGetSigningCounter(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    getFilesDetails(): Promise<any> {
        let url_ = this.baseUrl + "/api/Production/getFilesDetails";


        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilesDetails(_response);
        });
    }

    protected processGetFilesDetails(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    tasksUpsertAssignment(body: AssignmentModelForUpsert | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/UpsertAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTasksUpsertAssignment(_response);
        });
    }

    protected processTasksUpsertAssignment(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Treatment.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Treatment>(<any>null);
    }


    treatmentsGetById(id: string): Promise<TreatmentModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsGetById";
        url_ = url_.replace(/[?&]$/, "");
        url_ = url_ + `?id=${id}`;
        // url_ = url_ + `?customerId=${customerId}`;
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsGetById(_response);
        });
    }

    protected processTreatmentsGetById(response: Response): Promise<TreatmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentModel>(<any>null);
    }



    treatmentsForUpsert(body: TreatmentModel): Promise<TreatmentModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsForUpsert";

        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;

        const token = this.getAuthToken();
        let content_ = JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsForUpsert(_response);
        });
    }

    protected processTreatmentsForUpsert(response: Response): Promise<TreatmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentModel>(<any>null);
    }

    hasCycle(obj: any, seen = new WeakSet()) {
        if (obj && typeof obj === 'object') {
            if (seen.has(obj)) return true;
            seen.add(obj);
            for (const key in obj) {
                if (key == 'treatmentActivities') {
                    // 
                }
                if (this.hasCycle(obj[key], seen)) return true;
            }
            seen.delete(obj);
        }
        return false;
    }



    treatmentsUpsertTreatment(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertTreatment";

        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;

        const token = this.getAuthToken();

        var bodyData: any = {}
        bodyData = { ...body };

        for (const key of Object.keys(bodyData)) {
            if (bodyData[key] == undefined) {
                bodyData[key] = null;
            }
        }

        console.log('treatmentsUpsertTreatment after convert', bodyData)

        let content_ = JSONStringify(bodyData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertTreatment(_response);
        });
    }

    protected processTreatmentsUpsertTreatment(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param messageId 
     * @return treatment data
     */

    treatmentGetByMessageId(messageId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/treatmentGetByMessageId";
        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;

        url_ += `?messageId=${messageId}`;

        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentGetByMessageId(_response);
        });
    }

    protected processTreatmentGetByMessageId(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    /**
     * @param body (optional)
     * @return Success
     * */

    customerDocumentsUploadFile(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/maintenance/customerDocumentsUploadFile";

        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;

        const token = this.getAuthToken();
        let content_ = JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsUploadFile(_response);
        });
    }

    protected processCustomerDocumentsUploadFile(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    ////////////

    documentsUploadFile2(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/maintenance/documentsUploadFile2";

        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;

        const token = this.getAuthToken();
        let content_ = JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsUploadFile2(_response);
        });
    }

    protected processCustomerDocumentsUploadFile2(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return _responseText;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /** customerDocumentsCreateFile create file in customer documents genaral
     * @param body
     * @return Success
     * */

    customerDocumentsCreateFile(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsCreate";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            body: JSONStringify(body),
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsCreateFile(_response);
        });
    }

    protected processCustomerDocumentsCreateFile(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v
            );
        };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /** customerDocumentsUpdate update file in customer documents genaral
     * @param body
     * @return Success
     * */
    customerDocumentsUpdate(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsUpdate";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            body: JSONStringify(body),
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsUpdate(_response);
        });
    }

    protected processCustomerDocumentsUpdate(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /** customerDocumentsCreateRelation create relation in customer documents genaral
     * @param body
     * @return Success
     * */

    customerDocumentsCreateRelation(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsCreateRelation";
        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            body: JSONStringify(body),
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsCreateRelation(_response);
        });
    }

    protected processCustomerDocumentsCreateRelation(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /** customerDocumentsDeleteFile delete file in customer documents genaral (delete file from files modal in Client)
     * @param fileId
     * @return Success
     * */

    customerDocumentsDeleteFile(fileId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsDelete";
        url_ = url_.replace(/[?&]$/, "");
        url_ += `?id=${fileId}`;
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsDeleteFile(_response);
        });
    }

    protected processCustomerDocumentsDeleteFile(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /** customerDocumentsGetFoldersForCustomer get folders for customer in customer documents genaral
     * @param customerId
     * @return Success
     * */

    customerDocumentsGetFoldersForCustomer(customerId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsGetFoldersForCustomer";
        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;
        url_ += `?customerId=${customerId}`;
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsGetFoldersForCustomer(_response);
        });
    }

    protected processCustomerDocumentsGetFoldersForCustomer(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    customerDocumentsGetTitles(): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsGetTitles";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsGetTitles(_response);
        });
    }


    protected processCustomerDocumentsGetTitles(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    customerDocumentsCreateTitle(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsCreateTitle";
        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            body: JSONStringify(body),
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }

        }
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsCreateTitle(_response);
        });
    }

    protected processCustomerDocumentsCreateTitle(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    customerDocumentsGetByRelation(relationId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsGetByRelation";
        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;
        url_ += `?relationId=${relationId}`;
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsGetByRelation(_response);
        });
    }

    protected processCustomerDocumentsGetByRelation(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    customerDocumentsCreateFolder(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsCreateFolder";
        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            body: JSONStringify(body),
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsCreateFolder(_response);
        });

    }
    protected processCustomerDocumentsCreateFolder(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /** customerDocumentsDeleteFolder
     * @param folderId
     * @return Success
     * */

    customerDocumentsDeleteFolder(folderId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsDeleteFolder";
        url_ = url_.replace(/[?&]$/, "");
        // url_ = url_ + `?customerId=${customerId}`;
        url_ += `?id=${folderId}`;
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
            }
        }
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsDeleteFolder(_response);
        });
    }

    protected processCustomerDocumentsDeleteFolder(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }



    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsUpsertMeeting(id: string | undefined, customerId: string | undefined, leadId: string | undefined): Promise<MeetingModelForUpsert> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertMeeting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertMeeting(_response);
        });
    }

    protected processTreatmentsUpsertMeeting(response: Response): Promise<MeetingModelForUpsert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MeetingModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingModelForUpsert>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertMeeting2(id: string | undefined, body: MeetingModelForUpsert | undefined): Promise<Treatment> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertMeeting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertMeeting2(_response);
        });
    }

    protected processTreatmentsUpsertMeeting2(response: Response): Promise<Treatment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Treatment.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Treatment>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsUpsertMeetingSummary(id: string | undefined, customerId: string | undefined, leadId: string | undefined): Promise<MeetingSummaryModelForUpsert> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertMeetingSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertMeetingSummary(_response);
        });
    }

    protected processTreatmentsUpsertMeetingSummary(response: Response): Promise<MeetingSummaryModelForUpsert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MeetingSummaryModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingSummaryModelForUpsert>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertMeetingSummary2(id: string | undefined, body: MeetingSummaryModelForUpsert | undefined): Promise<Treatment> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertMeetingSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertMeetingSummary2(_response);
        });
    }

    protected processTreatmentsUpsertMeetingSummary2(response: Response): Promise<Treatment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Treatment.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Treatment>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsUpsertDocumentationOutbox(id: string | undefined, customerId: string | undefined, leadId: string | undefined): Promise<DocumentationOutboxModelForUpsert> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertDocumentationOutbox?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertDocumentationOutbox(_response);
        });
    }

    protected processTreatmentsUpsertDocumentationOutbox(response: Response): Promise<DocumentationOutboxModelForUpsert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DocumentationOutboxModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentationOutboxModelForUpsert>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertDocumentationOutbox2(id: string | undefined, body: DocumentationOutboxModelForUpsert | undefined): Promise<TreatmentModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertDocumentationOutbox?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertDocumentationOutbox2(_response);
        });
    }

    protected processTreatmentsUpsertDocumentationOutbox2(response: Response): Promise<TreatmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsUpsertEmailTreatment(id: string | undefined, customerId: string | undefined, leadId: string | undefined): Promise<EmailTreatmentModelForUpsert> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertEmailTreatment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertEmailTreatment(_response);
        });
    }

    protected processTreatmentsUpsertEmailTreatment(response: Response): Promise<EmailTreatmentModelForUpsert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmailTreatmentModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailTreatmentModelForUpsert>(<any>null);
    }

    /**
     * @param leadId (optional) 
     * @param sueId (optional) 
     * @param policyId (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertEmailTreatment2(leadId: string | undefined, sueId: string | undefined, policyId: string | undefined, body: EmailMessage | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertEmailTreatment2?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        if (sueId === null)
            throw new Error("The parameter 'sueId' cannot be null.");
        else if (sueId !== undefined)
            url_ += "sueId=" + encodeURIComponent("" + sueId) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertEmailTreatment2(_response);
        });
    }

    protected processTreatmentsUpsertEmailTreatment2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertEmailTreatment3(id: string | undefined, body: EmailTreatmentModelForUpsert | undefined): Promise<TreatmentModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertEmailTreatment3?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertEmailTreatment3(_response);
        });
    }

    protected processTreatmentsUpsertEmailTreatment3(response: Response): Promise<TreatmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsUpsertSmsTreatment(id: string | undefined, customerId: string | undefined, leadId: string | undefined): Promise<SmsTreatmentModelForUpsert> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertSmsTreatment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertSmsTreatment(_response);
        });
    }

    protected processTreatmentsUpsertSmsTreatment(response: Response): Promise<SmsTreatmentModelForUpsert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SmsTreatmentModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SmsTreatmentModelForUpsert>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertSmsTreatment2(id: string | undefined, body: SmsTreatmentModelForUpsert | undefined): Promise<TreatmentModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertSmsTreatment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertSmsTreatment2(_response);
        });
    }

    protected processTreatmentsUpsertSmsTreatment2(response: Response): Promise<TreatmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param customerId (optional) 
     * @param leadId (optional) 
     * @return Success
     */
    treatmentsUpsertFaxTreatment(id: string | undefined, customerId: string | undefined, leadId: string | undefined): Promise<FaxTreatmentModelForUpsert> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertFaxTreatment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertFaxTreatment(_response);
        });
    }

    protected processTreatmentsUpsertFaxTreatment(response: Response): Promise<FaxTreatmentModelForUpsert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FaxTreatmentModelForUpsert.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FaxTreatmentModelForUpsert>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsUpsertFaxTreatment2(id: string | undefined, body: FaxTreatmentModelForUpsert | undefined): Promise<TreatmentModel> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertFaxTreatment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsUpsertFaxTreatment2(_response);
        });
    }

    protected processTreatmentsUpsertFaxTreatment2(response: Response): Promise<TreatmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    treatmentsMarkAssignmentAsTreated(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/treatmentsMarkAssignmentAsTreated?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsMarkAssignmentAsTreated(_response);
        });
    }

    protected processTreatmentsMarkAssignmentAsTreated(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsChangeForTreatmentById(id: string | undefined, body: Treatment | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/treatmentsChangeForTreatmentById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsChangeForTreatmentById(_response);
        });
    }

    protected processTreatmentsChangeForTreatmentById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    treatmentsChangeTreatmentRelation(id: string | undefined, body: CallModelForUpsert | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/treatmentsChangeTreatmentRelation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsChangeTreatmentRelation(_response);
        });
    }

    protected processTreatmentsChangeTreatmentRelation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    treatmentsDeleteTreatment(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/treatmentsDeleteTreatment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        const content_ = /*JSON.stringify*/JSONStringify({});

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTreatmentsDeleteTreatment(_response);
        });
    }

    protected processTreatmentsDeleteTreatment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    treatmentsUpsertCommentTreatment(request: any): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/treatmentsUpsertCommentTreatment";
        if (!request)
            throw new Error("The parameter 'id' cannot be null.");
        const token = this.getAuthToken();
        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: any) => {
            return this.processTreatmentsUpsertCommentTreatment(_response);
        });
    }

    protected processTreatmentsUpsertCommentTreatment(response: any): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 201) {
            return response.text().then((_responseText: any) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TreatmentTabModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText: any) => {
                return;
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policyFilter(body: PolicyFilterModel | undefined): Promise<PolicyTabModel> {
        let url_ = this.baseUrl + "/api/operation/policyFilter";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyFilter(_response);
        });
    }

    protected processPolicyFilter(response: Response): Promise<PolicyTabModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PolicyTabModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return Promise.resolve<PolicyTabModel>(<any>null);
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyTabModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policyPrintPolicies(body: PolicyFilterModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/operation/policyPrintPolicies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyPrintPolicies(_response);
        });
    }

    protected processPolicyPrintPolicies(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param policyId (optional) 
     * @return Success
     */
    policyPrintPolicy(policyId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/operation/policyPrintPolicy?";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyPrintPolicy(_response);
        });
    }

    protected processPolicyPrintPolicy(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policySaveElementaryPolicy(body: ElementaryInsurancePolicyModel | undefined): Promise<ElementaryInsurancePolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policySaveElementaryPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicySaveElementaryPolicy(_response);
        });
    }

    protected processPolicySaveElementaryPolicy(response: Response): Promise<ElementaryInsurancePolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ElementaryInsurancePolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ElementaryInsurancePolicyModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policySaveLifePolicy(body: LifeInsurancePolicyModel | undefined): Promise<LifeInsurancePolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policySaveLifePolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicySaveLifePolicy(_response);
        });
    }

    protected processPolicySaveLifePolicy(response: Response): Promise<LifeInsurancePolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LifeInsurancePolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LifeInsurancePolicyModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policySaveCapitalMarketPolicy(body: CapitalMarketInsurancePolicyModel | undefined): Promise<CapitalMarketInsurancePolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policySaveCapitalMarketPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicySaveCapitalMarketPolicy(_response);
        });
    }

    protected processPolicySaveCapitalMarketPolicy(response: Response): Promise<CapitalMarketInsurancePolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CapitalMarketInsurancePolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CapitalMarketInsurancePolicyModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policySaveHealthPolicy(body: HealthInsurancePolicyModel | undefined): Promise<HealthInsurancePolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policySaveHealthPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicySaveHealthPolicy(_response);
        });
    }

    protected processPolicySaveHealthPolicy(response: Response): Promise<HealthInsurancePolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = HealthInsurancePolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthInsurancePolicyModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policySavePortfolioPolicy(body: PortfolioInsurancePolicyModel | undefined): Promise<PortfolioInsurancePolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policySavePortfolioPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicySavePortfolioPolicy(_response);
        });
    }

    protected processPolicySavePortfolioPolicy(response: Response): Promise<PortfolioInsurancePolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PortfolioInsurancePolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioInsurancePolicyModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policySaveSocialLoanP2PPolicy(body: SocialLoanP2PInsurancePolicyModel | undefined): Promise<SocialLoanP2PInsurancePolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policySaveSocialLoanP2PPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicySaveSocialLoanP2PPolicy(_response);
        });
    }

    protected processPolicySaveSocialLoanP2PPolicy(response: Response): Promise<SocialLoanP2PInsurancePolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SocialLoanP2PInsurancePolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SocialLoanP2PInsurancePolicyModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    policyGetEmployerById(id: string | undefined): Promise<EmployerModel> {
        let url_ = this.baseUrl + "/api/operation/policyGetEmployerById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyGetEmployerById(_response);
        });
    }

    protected processPolicyGetEmployerById(response: Response): Promise<EmployerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployerModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployerModel>(<any>null);
    }

    /**
     * @param employerIDNumber (optional) 
     * @return Success
     */
    policyGetEmployerByEmployerIDNumber(employerIDNumber: string | undefined): Promise<EmployerModel> {
        let url_ = this.baseUrl + "/api/operation/policyGetEmployerByEmployerIDNumber?";
        if (employerIDNumber === null)
            throw new Error("The parameter 'employerIDNumber' cannot be null.");
        else if (employerIDNumber !== undefined)
            url_ += "EmployerIDNumber=" + encodeURIComponent("" + employerIDNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyGetEmployerByEmployerIDNumber(_response);
        });
    }

    protected processPolicyGetEmployerByEmployerIDNumber(response: Response): Promise<EmployerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployerModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployerModel>(<any>null);
    }

    /**
     * @param policyType (optional) 
     * @param customer (optional) 
     * @return Success
     */
    policyNewPolicy(policyType: number | undefined, customer: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/policyNewPolicy?";
        if (policyType === null)
            throw new Error("The parameter 'policyType' cannot be null.");
        else if (policyType !== undefined)
            url_ += "policyType=" + encodeURIComponent("" + policyType) + "&";
        if (customer === null)
            throw new Error("The parameter 'customer' cannot be null.");
        else if (customer !== undefined)
            url_ += "customer=" + encodeURIComponent("" + customer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyNewPolicy(_response);
        });
    }

    protected processPolicyNewPolicy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param policyId (optional) 
     * @param addition (optional) 
     * @return Success
     */
    policyEditPolicy(policyId: string | undefined, addition: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/policyEditPolicy?";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        if (addition === null)
            throw new Error("The parameter 'addition' cannot be null.");
        else if (addition !== undefined)
            url_ += "addition=" + encodeURIComponent("" + addition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyEditPolicy(_response);
        });
    }

    protected processPolicyEditPolicy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @param type (optional) 
     * @return Success
     */
    policyGetEmptyElementaryInsurancePolicyModel(customerId: string | undefined, type: number | undefined): Promise<ElementaryInsurancePolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policyGetEmptyElementaryInsurancePolicyModel?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyGetEmptyElementaryInsurancePolicyModel(_response);
        });
    }

    protected processPolicyGetEmptyElementaryInsurancePolicyModel(response: Response): Promise<ElementaryInsurancePolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ElementaryInsurancePolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ElementaryInsurancePolicyModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policyGetElementaryInsurancePolicyModelByPolicy(body: Policy | undefined): Promise<ElementaryInsurancePolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policyGetElementaryInsurancePolicyModelByPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyGetElementaryInsurancePolicyModelByPolicy(_response);
        });
    }

    protected processPolicyGetElementaryInsurancePolicyModelByPolicy(response: Response): Promise<ElementaryInsurancePolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ElementaryInsurancePolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ElementaryInsurancePolicyModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policyAddSelectLists(body: PolicyBaseModel | undefined): Promise<PolicyBaseModel> {
        let url_ = this.baseUrl + "/api/operation/policyAddSelectLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyAddSelectLists(_response);
        });
    }

    protected processPolicyAddSelectLists(response: Response): Promise<PolicyBaseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PolicyBaseModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyBaseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policyReadProductionFile(body: ReadProductionModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/policyReadProductionFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyReadProductionFile(_response);
        });
    }

    protected processPolicyReadProductionFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policyGetPolicyAdditionDetails(body: PolicyModel | undefined): Promise<PolicyBaseModel> {
        let url_ = this.baseUrl + "/api/operation/policyGetPolicyAdditionDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyGetPolicyAdditionDetails(_response);
        });
    }

    protected processPolicyGetPolicyAdditionDetails(response: Response): Promise<PolicyBaseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PolicyBaseModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyBaseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentUpdatePaymentGet(body: UpdatePaymentRequest | undefined): Promise<PaymentModel> {
        let url_ = this.baseUrl + "/api/operation/paymentUpdatePaymentGet";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaymentUpdatePaymentGet(_response);
        });
    }

    protected processPaymentUpdatePaymentGet(response: Response): Promise<PaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentUpdateAmount(body: PaymentModel | undefined): Promise<PaymentModel> {
        let url_ = this.baseUrl + "/api/operation/paymentUpdateAmount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaymentUpdateAmount(_response);
        });
    }

    protected processPaymentUpdateAmount(response: Response): Promise<PaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentUpdatePayment(body: PaymentModel | undefined): Promise<DynamicObject2> {

        let url_ = this.baseUrl + "/api/operation/paymentUpdatePayment";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,

                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaymentUpdatePayment(_response);
        });
    }

    protected processPaymentUpdatePayment(response: Response): Promise<DynamicObject2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DynamicObject2.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject2>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    paymentCancelPayment(paymentId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/paymentCancelPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaymentCancelPayment(_response);
        });
    }

    protected processPaymentCancelPayment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    iCreditIndex2(body: ICreditGetUrlItem | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/iCreditIndex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processICreditIndex2(_response);
        });
    }

    protected processICreditIndex2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    iCreditVerify2(body: ICreditVerifyRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/iCreditVerify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processICreditVerify2(_response);
        });
    }

    protected processICreditVerify2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    iCreditFailure2(body: ICreditFailure | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/iCreditFailure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processICreditFailure2(_response);
        });
    }

    protected processICreditFailure2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    customerDataBid(id: string | undefined): Promise<SimulatorOfferModel> {
        let url_ = this.baseUrl + "/api/operation/customerDataBid?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDataBid(_response);
        });
    }

    protected processCustomerDataBid(response: Response): Promise<SimulatorOfferModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SimulatorOfferModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulatorOfferModel>(<any>null);
    }

    /**
     * @return Success
     */
    customerCardIndex(): Promise<CustomerGridModel> {
        let url_ = this.baseUrl + "/api/operation/customerCardIndex";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardIndex(_response);
        });
    }

    protected processCustomerCardIndex(response: Response): Promise<CustomerGridModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerGridModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return Promise.resolve<CustomerGridModel>(<any>null);
            });
        }
        return Promise.resolve<CustomerGridModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardFilter(body: CustomerFilterModel | undefined): Promise<CustomerGridModel | any> {
        let url_ = this.baseUrl + "/api/operation/customerCardFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardFilter(_response);
        });
    }

    protected processCustomerCardFilter(response: Response): Promise<CustomerGridModel | ResponseObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerGridModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const res: ResponseObject = {
                    statusCode: -1,
                    statusMessage: 'some error occured'
                }
                return res;
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGridModel>(<any>null);
    }

    /**
     * @return Success
     */
    customerCardAddCustomer(): Promise<CustomerDetailsModel> {
        let url_ = this.baseUrl + "/api/operation/customerCardAddCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardAddCustomer(_response);
        });
    }

    protected processCustomerCardAddCustomer(response: Response): Promise<CustomerDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDetailsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDetailsModel>(<any>null);
    }

    policyGetById(id: string): Promise<PolicyModel> {
        let url_ = this.baseUrl + "/api/operation/policyGetById?id=" + id;
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processpolicyGetById(_response);
        });
    }

    protected processpolicyGetById(response: Response): Promise<PolicyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PolicyModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyModel>(<any>null);
    }


    /**
     * @param body (optional)
     * @return Success
     */

    policyGetRoutesByConditions(body: any): Promise<any[]> {
        let url_ = this.baseUrl + "/api/operation/policyGetRoutesByConditions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBranchesByInsuranceCompanyAndPolicyType(_response);
        });
    }

    protected processGetBranchesByInsuranceCompanyAndPolicyType(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(<any>null);
    }


    policyCreate(body: PolicyModel): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/policyCreate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyCreate(_response);
        });
    }

    protected processPolicyCreate(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                console.log('processPolicyCreate-resultData500', resultData500)
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    getElementaryInsurancePolicyId(policyId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/policyById?";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "ElementaryInsurancePolicyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetElementaryInsurancePolicyId(_response);
        });
    }

    protected processGetElementaryInsurancePolicyId(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardAddCustomer2(body: CustomerPersonalModel | undefined): Promise<CustomerModel> {
        let url_ = this.baseUrl + "/api/operation/customerCardAddCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardAddCustomer2(_response);
        });
    }

    protected processCustomerCardAddCustomer2(response: Response): Promise<CustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerModel>(<any>null);
    }

    /**
     * @param identifier (optional) 
     * @return Success
     */
    customerCardGetCustomerById(identifier: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerCardGetCustomerById?";
        if (identifier === null)
            throw new Error("The parameter 'identifier' cannot be null.");
        else if (identifier !== undefined)
            url_ += "Identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardGetCustomerById(_response);
        });
    }

    protected processCustomerCardGetCustomerById(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return JSON.parse(_responseText, this.jsonParseReviver);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param identifier (optional) 
     * @return Success
     */
    customerCardGetCustomerByIdntity(identifier: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/customerCardGetCustomerByIdntity?";
        if (identifier === null)
            throw new Error("The parameter 'identifier' cannot be null.");
        else if (identifier !== undefined)
            url_ += "Identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardGetCustomerByIdntity(_response);
        });
    }

    protected processCustomerCardGetCustomerByIdntity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardCustomerDetails(body: CustomerDetailsRequest | undefined): Promise<CustomerDetailsModel> {
        let url_ = this.baseUrl + "/api/operation/customerCardCustomerDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardCustomerDetails(_response);
        });
    }

    protected processCustomerCardCustomerDetails(response: Response): Promise<CustomerDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDetailsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDetailsModel>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param customeId (optional) 
     * @return Success
     */
    customerCardsearchSpeackCom(fromDate: string | undefined, toDate: string | undefined, customeId: string | undefined): Promise<SpeakComTabModel> {
        let url_ = this.baseUrl + "/api/operation/customerCardsearchSpeackCom?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (customeId === null)
            throw new Error("The parameter 'customeId' cannot be null.");
        else if (customeId !== undefined)
            url_ += "customeId=" + encodeURIComponent("" + customeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardsearchSpeackCom(_response);
        });
    }

    protected processCustomerCardsearchSpeackCom(response: Response): Promise<SpeakComTabModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SpeakComTabModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpeakComTabModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardSearchMessage(body: CustomerCardSearchMessageRequest | undefined): Promise<CustomerWhatsappTabModel> {
        let url_ = this.baseUrl + "/api/operation/customerCardSearchMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardSearchMessage(_response);
        });
    }

    protected processCustomerCardSearchMessage(response: Response): Promise<CustomerWhatsappTabModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerWhatsappTabModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerWhatsappTabModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    customerCardEditPersonalData(id: string | undefined): Promise<CustomerModel> {
        let url_ = this.baseUrl + "/api/operation/customerCardEditPersonalData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");


        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };


        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardEditPersonalData(_response);
        });
    }

    protected processCustomerCardEditPersonalData(response: Response): Promise<CustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardEditPersonalData2(body: CustomerCardEditPersonalDataRequest | undefined): Promise<CustomerRemarkModel> {
        let url_ = this.baseUrl + "/api/operation/customerCardEditPersonalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardEditPersonalData2(_response);
        });
    }

    protected processCustomerCardEditPersonalData2(response: Response): Promise<CustomerRemarkModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerRemarkModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerRemarkModel>(<any>null);
    }

    /**
     * @return Success
     */
    customerCardGetAgents(): Promise<Agent[]> {
        let url_ = this.baseUrl + "/api/operation/customerCardGetAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardGetAgents(_response);
        });
    }

    protected processCustomerCardGetAgents(response: Response): Promise<Agent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Agent.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agent[]>(<any>null);
    }

    /**
     * @return Success
     */
    customerCardGetHandlers(): Promise<User[]> {
        let url_ = this.baseUrl + "/api/operation/customerCardGetHandlers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardGetHandlers(_response);
        });
    }

    protected processCustomerCardGetHandlers(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(User.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }
    /**
     * @return Success
     */
    customerGetAll(): Promise<Customer[]> {
        let url_ = this.baseUrl + "/api/operation/customerGetAll";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerGetAll(_response);
        });
    }

    protected processCustomerGetAll(response: Response): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Customer.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }

    /**
     * @return Success
     */
    customerCardGetUsers(): Promise<User[]> {
        let url_ = this.baseUrl + "/api/operation/customerCardGetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardGetUsers(_response);
        });
    }

    protected processCustomerCardGetUsers(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(User.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }

    /**
     * @param identifier (optional) 
     * @return Success
     */
    customerCardGetRates(identifier: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/operation/customerCardGetRates?";
        if (identifier === null)
            throw new Error("The parameter 'identifier' cannot be null.");
        else if (identifier !== undefined)
            url_ += "Identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardGetRates(_response);
        });
    }

    protected processCustomerCardGetRates(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardCustomerDetailsDelete(body: Input | undefined): Promise<Input> {
        let url_ = this.baseUrl + "/api/operation/customerCardCustomerDetailsDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardCustomerDetailsDelete(_response);
        });
    }

    protected processCustomerCardCustomerDetailsDelete(response: Response): Promise<Input> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Input.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Input>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardCustomerAddressDelete(body: Input | undefined): Promise<Input> {
        let url_ = this.baseUrl + "/api/operation/customerCardCustomerAddressDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardCustomerAddressDelete(_response);
        });
    }

    protected processCustomerCardCustomerAddressDelete(response: Response): Promise<Input> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Input.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Input>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardCustomerDelete(body: Input | undefined): Promise<Input> {
        let url_ = this.baseUrl + "/api/operation/customerCardCustomerDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardCustomerDelete(_response);
        });
    }

    protected processCustomerCardCustomerDelete(response: Response): Promise<Input> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Input.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Input>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardEditPersonalDataNew(body: CustomerModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/operation/customerCardEditPersonalDataNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardEditPersonalDataNew(_response);
        });
    }

    protected processCustomerCardEditPersonalDataNew(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardDeleteCustomer(body: CustomerModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/customerCardDeleteCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardDeleteCustomer(_response);
        });
    }

    protected processCustomerCardDeleteCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardUpdateCustomerContactDetails(body: CustomerContactDetailsModel[] | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/operation/customerCardUpdateCustomerContactDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardUpdateCustomerContactDetails(_response);
        });
    }

    protected processCustomerCardUpdateCustomerContactDetails(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardUpdateCustomerAddress(body: CustomerAddressModel[] | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/operation/customerCardUpdateCustomerAdrress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardUpdateCustomerAdrress(_response);
        });
    }

    protected processCustomerCardUpdateCustomerAdrress(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardUpdateGroups(body: CustomerGroupModel[] | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/operation/customerCardUpdateGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardUpdateGroups(_response);
        });
    }

    protected processCustomerCardUpdateGroups(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    customerCardDeleteRemark(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/customerCardDeleteRemark?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardDeleteRemark(_response);
        });
    }

    protected processCustomerCardDeleteRemark(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    customerCardGetCreators(): Promise<User[]> {
        let url_ = this.baseUrl + "/api/operation/customerCardGetCreators";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardGetCreators(_response);
        });
    }

    protected processCustomerCardGetCreators(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(User.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }


    /**
     * @return Success
     */
    discountBankIndex(): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/discountBankIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiscountBankIndex(_response);
        });
    }

    protected processDiscountBankIndex(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    discountBankGetAllocationDiscountBank(): Promise<DiscountBankManagerData> {
        let url_ = this.baseUrl + "/api/operation/discountBankGetAllocationDiscountBank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiscountBankGetAllocationDiscountBank(_response);
        });
    }

    protected processDiscountBankGetAllocationDiscountBank(response: Response): Promise<DiscountBankManagerData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DiscountBankManagerData.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscountBankManagerData>(<any>null);
    }

    /**
     * @return Success
     */
    discountBankGetAllocationForMonth(): Promise<AllocationDiscountBankModel[]> {
        let url_ = this.baseUrl + "/api/operation/discountBankGetAllocationForMonth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiscountBankGetAllocationForMonth(_response);
        });
    }

    protected processDiscountBankGetAllocationForMonth(response: Response): Promise<AllocationDiscountBankModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(AllocationDiscountBankModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllocationDiscountBankModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discountBankSetAllocationForUser(body: AllocationDiscountBankModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/discountBankSetAllocationForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiscountBankSetAllocationForUser(_response);
        });
    }

    protected processDiscountBankSetAllocationForUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discountBankCreateDiscount(body: CreateDiscountRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/discountBankCreateDiscount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiscountBankCreateDiscount(_response);
        });
    }

    protected processDiscountBankCreateDiscount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    customerDocumentsCreate(id: string | undefined): Promise<CustomerDocumentCreateModel> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsCreate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsCreate(_response);
        });
    }

    protected processCustomerDocumentsCreate(response: Response): Promise<CustomerDocumentCreateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDocumentCreateModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDocumentCreateModel>(<any>null);
    }

    customerDocumentsDelete(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");


        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsDelete(_response);
        });

    }

    protected processCustomerDocumentsDelete(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    policyUpdatePolicy(body: PolicyModel | RiderModel | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/policyUpdatePolicy";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyUpdatePolicy(_response);
        });
    }

    protected processPolicyUpdatePolicy(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerDocumentsCreate2(body: CustomerDocumentCreateModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsCreate2(_response);
        });
    }

    protected processCustomerDocumentsCreate2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerDocumentsFilter(body: CommonCustomerFilterModel | undefined): Promise<any[]> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsFilter";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsFilter(_response);
        });
    }

    protected processCustomerDocumentsFilter(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    customerDocumentsLoadDocumentsForCustomer(customerId: string | undefined): Promise<CustomerDocumentModel[]> {
        let url_ = this.baseUrl + "/api/operation/customerDocumentsLoadDocumentsForCustomer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentsLoadDocumentsForCustomer(_response);
        });
    }

    protected processCustomerDocumentsLoadDocumentsForCustomer(response: Response): Promise<CustomerDocumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CustomerDocumentModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDocumentModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    renewalIndex(): Promise<RenewalPageModel> {
        let url_ = this.baseUrl + "/api/renewals/renewalIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalIndex(_response);
        });
    }

    protected processRenewalIndex(response: Response): Promise<RenewalPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RenewalPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalPageModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renewalFilter(body: SalesPeopleLinksModel | undefined): Promise<LeadsPageModel> {
        let url_ = this.baseUrl + "/api/renewals/renewalFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalFilter(_response);
        });
    }

    protected processRenewalFilter(response: Response): Promise<LeadsPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadsPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadsPageModel>(<any>null);
    }

    /**
     * @return Success
     */
    renewalExport(): Promise<void> {
        let url_ = this.baseUrl + "/api/renewals/renewalExport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalExport(_response);
        });
    }

    protected processRenewalExport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    renewalImport(): Promise<void> {
        let url_ = this.baseUrl + "/api/renewals/renewalImport";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };





        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalImport(_response);
        });
    }

    protected processRenewalImport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    policyReadProductionFile2(content_: FormData): Promise<void> {
        let url_ = this.baseUrl + "/api/operation/policyReadProductionFile";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyReadProductionFile2(_response);
        });
    }

    protected processPolicyReadProductionFile2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }


    renewalImport2(file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/renewals/renewalImport2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalImport2(_response);
        });
    }

    protected processRenewalImport2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    renewalLinkSalesperson(body: RenewalsSalespersonPolicies | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/renewals/renewalLinkSalesperson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();


        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalLinkSalesperson(_response);
        });
    }

    protected processRenewalLinkSalesperson(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }


    renewalLinkSalespersonByLetters(): Promise<void> {
        let url_ = this.baseUrl + "/api/renewals/renewalLinkSalespersonByLetters";
        url_ = url_.replace(/[?&]$/, "");


        const token = this.getAuthToken();


        let options_ = <RequestInit>{
            //body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalLinkSalespersonByLetters(_response);
        });
    }

    protected processRenewalLinkSalespersonByLetters(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renewalGetSalesPeopleLinks(body: SalesPeopleLinksModel | undefined): Promise<SalesPeopleLinksModel> {
        let url_ = this.baseUrl + "/api/renewals/renewalGetSalesPeopleLinks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalGetSalesPeopleLinks(_response);
        });
    }

    protected processRenewalGetSalesPeopleLinks(response: Response): Promise<SalesPeopleLinksModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SalesPeopleLinksModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesPeopleLinksModel>(<any>null);
    }

    /**
     * @return Success
     */
    renewalCreate(): Promise<LeadsShortModel> {
        let url_ = this.baseUrl + "/api/renewals/renewalCreate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalCreate(_response);
        });
    }

    protected processRenewalCreate(response: Response): Promise<LeadsShortModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeadsShortModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadsShortModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renewalCreate2(body: LeadsShortModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/renewals/renewalCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalCreate2(_response);
        });
    }

    protected processRenewalCreate2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param collection (optional) 
     * @return Success
     */
    renewalDelete(id: string | undefined, collection: StringStringValuesKeyValuePair[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/renewals/renewalDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (collection === null || collection === undefined)
            throw new Error("The parameter 'collection' cannot be null.");
        else
            content_.append("collection", collection.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewalDelete(_response);
        });
    }

    protected processRenewalDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    reportsDownloadFile(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/reports/reportsDownloadFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReportsDownloadFile(_response);
        });
    }

    protected processReportsDownloadFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param actionType (optional) 0 = ChangeVehicle, 1 = ChangePackages, 2 = UpdatePayment, 3 = Freeze, 4 = Cancel, 5 = Details
     * @return Success
     */
    riderCreateRiderSubscriber(id: string | undefined, actionType: ActionType | undefined): Promise<RiderModel> {
        let url_ = this.baseUrl + "/riderCreateRiderSubscriber?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (actionType === null)
            throw new Error("The parameter 'actionType' cannot be null.");
        else if (actionType !== undefined)
            url_ += "ActionType=" + encodeURIComponent("" + actionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderCreateRiderSubscriber(_response);
        });
    }

    protected processRiderCreateRiderSubscriber(response: Response): Promise<RiderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RiderModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subscriberSort(body: CommonFilterModel | undefined): Promise<SubscriberModel[]> {
        let url_ = this.baseUrl + "/api/riders/subscriberSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscriberSort(_response);
        });
    }

    protected processSubscriberSort(response: Response): Promise<SubscriberModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SubscriberModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriberModel[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    subscriberGet(id: string | undefined): Promise<SubscriberModel> {
        let url_ = this.baseUrl + "/api/riders/subscriberGet?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscriberGet(_response);
        });
    }

    protected processSubscriberGet(response: Response): Promise<SubscriberModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SubscriberModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriberModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subscriberUpsert(body: SubscriberModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/subscriberUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscriberUpsert(_response);
        });
    }

    protected processSubscriberUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderIndex(body: FilterDataModel | undefined): Promise<RidersList> {
        let url_ = this.baseUrl + "/api/riders/riderIndex";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderIndex(_response);
        });
    }

    protected processRiderIndex(response: Response): Promise<RidersList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RidersList.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RidersList>(<any>null);
    }

    /**
     * @return Success
     */
    riderPaymentSuccess(): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderPaymentSuccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderPaymentSuccess(_response);
        });
    }

    protected processRiderPaymentSuccess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    riderPaymentFail(): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderPaymentFail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderPaymentFail(_response);
        });
    }

    protected processRiderPaymentFail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderFilter(body: RiderFilterDataModel | undefined): Promise<RidersList> {
        let url_ = this.baseUrl + "/api/riders/riderFilter";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderFilter(_response);
        });
    }

    protected processRiderFilter(response: Response): Promise<RidersList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RidersList.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RidersList>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderSortService(body: FilterDataModel | undefined): Promise<SystemManagementModel> {
        let url_ = this.baseUrl + "/api/riders/riderSortService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderSortService(_response);
        });
    }

    protected processRiderSortService(response: Response): Promise<SystemManagementModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemManagementModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemManagementModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderSortPackage(body: FilterDataModel | undefined): Promise<RiderPackageModel[]> {
        let url_ = this.baseUrl + "/api/riders/riderSortPackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderSortPackage(_response);
        });
    }

    protected processRiderSortPackage(response: Response): Promise<RiderPackageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(RiderPackageModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderPackageModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderUpdateIncludeInPolicyPrice(body: RiderPackageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderUpdateIncludeInPolicyPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderUpdateIncludeInPolicyPrice(_response);
        });
    }

    protected processRiderUpdateIncludeInPolicyPrice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderUpdateSideGimel(body: RiderPackageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderUpdateSideGimel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderUpdateSideGimel(_response);
        });
    }

    protected processRiderUpdateSideGimel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderUpdatePrivateIncome(body: RiderPackageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderUpdatePrivateIncome";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderUpdatePrivateIncome(_response);
        });
    }

    protected processRiderUpdatePrivateIncome(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    riderGetService(id: string | undefined): Promise<RiderServiceModel> {
        let url_ = this.baseUrl + "/api/riders/riderGetService?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetService(_response);
        });
    }

    protected processRiderGetService(response: Response): Promise<RiderServiceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RiderServiceModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderServiceModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    riderDeleteRiderSubscriber(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderDeleteRiderSubscriber?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderDeleteRiderSubscriber(_response);
        });
    }

    protected processRiderDeleteRiderSubscriber(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderCreateRiderSubscriber2(body: CreateRiderSubscriberRequest | undefined): Promise<RiderModel> {
        let url_ = this.baseUrl + "/api/riders/riderCreateRiderSubscriber";
        // riderCreateRider
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderCreateRiderSubscriber2(_response);
        });
    }

    protected processRiderCreateRiderSubscriber2(response: Response): Promise<RiderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {

                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RiderModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderCreateRider(body: CreateRiderSubscriberRequest | undefined): Promise<CreateRiderResponse> {

        let url_ = this.baseUrl + "/api/riders/riderCreateRider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderCreateRider(_response);
        });
    }

    protected processRiderCreateRider(response: Response): Promise<CreateRiderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateRiderResponse.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return JSON.parse(_responseText)
            });
        }
        return Promise.resolve<RiderModel>(<any>null);
    }


    riderUpdateDetails(body: RiderModel | undefined): Promise<CreateRiderResponse> {

        let url_ = this.baseUrl + "/api/riders/riderUpdateDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderUpdateDetails(_response);
        });
    }

    protected processRiderUpdateDetails(response: Response): Promise<CreateRiderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateRiderResponse.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderModel>(<any>null);
    }

    RiderFixEndDate(body: RiderModel | undefined): Promise<CreateRiderResponse> {

        let url_ = this.baseUrl + "/api/riders/riderFixEndDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderFixEndDate(_response);
        });
    }

    protected processRiderFixEndDate(response: Response): Promise<CreateRiderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateRiderResponse.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderGetPaymentPage(body: RiderModel | undefined): Promise<PaymentModel> {

        let url_ = this.baseUrl + "/api/riders/riderGetPaymentPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetPaymentPage(_response);
        });
    }

    protected processRiderGetPaymentPage(response: Response): Promise<PaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return JSON.parse(_responseText)
                //     console.log('_responseText', _responseText)
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentModel>(<any>null);
    }

    riderGetPayments(body: RiderGetPaymentPage2Request | undefined): Promise<PaymentModel[]> {

        let url_ = this.baseUrl + "/api/riders/riderGetPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetPayments(_response);
        });
    }

    protected processRiderGetPayments(response: Response): Promise<PaymentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(PaymentModel.fromJS(item));
                }
                return result200;
            });

        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentModel[]>(<any>null);
    }

    riderGetPaymentPage2(body: RiderGetPaymentPage2Request | undefined): Promise<PaymentModel> {

        let url_ = this.baseUrl + "/api/riders/riderGetPaymentPage2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetPaymentPage2(_response);
        });
    }

    protected processRiderGetPaymentPage2(response: Response): Promise<PaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentModel>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    // riderUpdateDetails(body: CreateRiderSubscriberRequest | undefined): Promise<RiderModel> {

    //     let url_ =this.baseUrl + "/api/riders/riderUpdateDetails";
    //     url_ = url_.replace(/[?&]$/, "");

    //     const content_ = /*JSON.stringify*/JSONStringify(body);
    //     const token = this.getAuthToken();
    //     let options_ = <RequestInit>{
    //         body: content_,
    //         method: "POST",
    //         headers: {
    //             'Authorization': `Bearer ${token}`,
    //             "Content-Type": "application/json-patch+json",
    //             "Accept": "text/plain"
    //         }
    //     };

    //     return this.http.fetch(url_, options_).then((_response: Response) => {
    //         return this.processRiderUpdateDetails(_response);
    //     });
    // }

    // protected processRiderUpdateDetails(response: Response): Promise<RiderModel> {
    //     const status = response.status;
    //     let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    //     if (status === 200) {
    //         return response.text().then((_responseText) => {
    //         let result200: any = null;
    //         let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
    //         result200 = RiderModel.fromJS(resultData200);
    //         return result200;
    //         });
    //     } else if (status !== 200 && status !== 204) {
    //         return response.text().then((_responseText) => {
    //         return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    //         });
    //     }
    //     return Promise.resolve<RiderModel>(<any>null);
    // }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderChangePackages(body: any | undefined): Promise<DynamicObject2> {
        let url_ = this.baseUrl + "/api/riders/riderChangePackages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };


        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderChangePackages(_response);
        });
    }

    protected processRiderChangePackages(response: Response): Promise<DynamicObject2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);


                result200 = DynamicObject2.fromJS(resultData200);
                return result200;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject2>(<any>null);
    }

    riderGenerateServiceReporter(id: string | undefined): Promise<DynamicObject2> {
        let url_ = this.baseUrl + "/api/riders/riderGenerateServiceReporter?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };


        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderChangePackages(_response);
        });

    }

    protected processRiderGenerateServiceReporter(response: Response): Promise<CreateRiderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);


                result200 = DynamicObject2.fromJS(resultData200);
                return result200;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject2>(<any>null);
    }

    riderActivateRider(id: string | undefined): Promise<CreateRiderResponse> {
        let url_ = this.baseUrl + "/api/riders/riderActivateRider?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "riderId=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };


        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderActivateRider(_response);
        });

    }

    protected processRiderActivateRider(response: Response): Promise<CreateRiderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);


                result200 = CreateRiderResponse.fromJS(resultData200);
                return result200;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRiderResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderGetPackages(body: GetPackagesRequest | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/riders/riderGetPackages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetPackages(_response);
        });
    }

    protected processRiderGetPackages(response: Response): Promise<string[]> {

        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderChangeVehicle(body: ChangeVehicleRequest | undefined): Promise<DynamicObject2> {
        let url_ = this.baseUrl + "/api/riders/riderChangeVehicle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderChangeVehicle(_response);
        });
    }

    protected processRiderChangeVehicle(response: Response): Promise<DynamicObject2> {

        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);


                result200 = DynamicObject2.fromJS(resultData200);
                return result200;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DynamicObject2>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    riderRenewRiderSubscriber(id: string | undefined): Promise<RiderModel> {
        let url_ = this.baseUrl + "/api/riders/riderRenewRiderSubscriber?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();


        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderRenewRiderSubscriber(_response);
        });
    }

    protected processRiderRenewRiderSubscriber(response: Response): Promise<RiderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RiderModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderCalcRiderDiscountAmount(body: Rider | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/riders/riderCalcRiderDiscountAmount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderCalcRiderDiscountAmount(_response);
        });
    }

    protected processRiderCalcRiderDiscountAmount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    riderGetNewSubscriberNumber(): Promise<number> {
        let url_ = this.baseUrl + "/api/riders/riderGetNewSubscriberNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetNewSubscriberNumber(_response);
        });
    }

    protected processRiderGetNewSubscriberNumber(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    riderGetPackage(id: string | undefined): Promise<RiderPackageModel> {
        let url_ = this.baseUrl + "/api/riders/riderGetPackage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetPackage(_response);
        });
    }

    protected processRiderGetPackage(response: Response): Promise<RiderPackageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RiderPackageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderPackageModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderUpsertService(body: RiderServiceModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderUpsertService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderUpsertService(_response);
        });
    }

    protected processRiderUpsertService(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderUpsertPackage(body: RiderPackageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderUpsertPackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderUpsertPackage(_response);
        });
    }

    protected processRiderUpsertPackage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    riderDeleteService(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderDeleteService?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderDeleteService(_response);
        });
    }

    protected processRiderDeleteService(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderGetRidersByConditions(body: SimulatorPageModel | undefined): Promise<RiderPackageModel[]> {

        let url_ = this.baseUrl + "/api/riders/riderGetRidersByConditions";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetRidersByConditions(_response);
        });
    }

    protected processRiderGetRidersByConditions(response: Response): Promise<RiderPackageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(RiderPackageModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiderPackageModel[]>(<any>null);
    }

    riderGetRidersByConditions2(vehicleId: string): Promise<RiderPackageModel[]> {


        let url_ = this.baseUrl + "/api/riders/riderGetRidersByConditions?";
        if (vehicleId !== undefined) {
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        } else {
            throw new Error("deleteSueDocument: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();


        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderGetRidersByConditions(_response);
        });
    }



    /**
     * @param id (optional) 
     * @return Success
     */
    riderDeletePackage(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/riders/riderDeletePackage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderDeletePackage(_response);
        });
    }

    protected processRiderDeletePackage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderPaymentReport(body: RiderFilterDataModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/riders/riderPaymentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderPaymentReport(_response);
        });
    }

    protected processRiderPaymentReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderOutputReport(body: RiderFilterDataModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/riders/riderOutputReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderOutputReport(_response);
        });
    }

    protected processRiderOutputReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    riderCalcPackageAmount(body: CalcPackageAmountRequest | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/riders/riderCalcPackageAmount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderCalcPackageAmount(_response);
        });
    }

    protected processRiderCalcPackageAmount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    signingIndex(): Promise<SigningPageModel> {
        let url_ = this.baseUrl + "/api/signing/signingIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSigningIndex(_response);
        });
    }

    protected processSigningIndex(response: Response): Promise<SigningPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SigningPageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SigningPageModel>(<any>null);
    }

    // /**
    //  * @param body (optional) 
    //  * @return Success
    //  */
    // signingFilter(body: SigningFilterModel | undefined): Promise<SigningPageModel> {
    //     let url_ = this.baseUrl + "/api/signing/signingFilter";
    //     url_ = url_.replace(/[?&]$/, "");

    //     const content_ = /*JSON.stringify*/JSONStringify(body);

    //     let options_ = <RequestInit>{
    //         body: content_,
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json-patch+json",
    //             "Accept": "text/plain"
    //         }
    //     };

    //     return this.http.fetch(url_, options_).then((_response: Response) => {
    //         return this.processSigningFilter(_response);
    //     });
    // }

    // protected processSigningFilter(response: Response): Promise<SigningPageModel> {
    //     const status = response.status;
    //     let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    //     if (status === 200) {
    //         return response.text().then((_responseText) => {
    //         let result200: any = null;
    //         let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
    //         result200 = SigningPageModel.fromJS(resultData200);
    //         return result200;
    //         });
    //     } else if (status !== 200 && status !== 204) {
    //         return response.text().then((_responseText) => {
    //         return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    //         });
    //     }
    //     return Promise.resolve<SigningPageModel>(<any>null);
    // }

    /**
     * @param body (optional) 
     * @return Success
     */
    signingUpdateDetails(body: SigningModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/signing/signingUpdateDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSigningUpdateDetails(_response);
        });
    }

    protected processSigningUpdateDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signingAssignSignings(body: AssignSigningsData | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/signing/signingAssignSignings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSigningAssignSignings(_response);
        });
    }

    protected processSigningAssignSignings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signingAssignEnd(body: AssignSigningsData | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/signing/signingAssignEnd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSigningAssignEnd(_response);
        });
    }

    protected processSigningAssignEnd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }



    /**
     * @param body (optional) 
     * @return Success
     */
    suesFilter(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesFilter";
        url_ = url_.replace(/[?&]$/, "");

        const requestBody = { ...body }
        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const requestKeys = Object.keys(requestBody);
        requestKeys.forEach((key: string) => {
            switch (key) {
                case 'from':
                case 'to':
                    if (requestBody[key]) {
                        let date = new Date(requestBody[key]);
                        let day: string = date.getDate().toString();
                        if (parseInt(day) < 10) {
                            day = `0${day}`;
                        }
                        let month: string = (date.getMonth() + 1).toString();
                        if (parseInt(month) < 10) {
                            month = `0${month}`;
                        }
                        const year = date.getFullYear();
                        // need to check with sarah
                        const dateString = `${year}-${month}-${day}T${key == 'from' ? '00:00:00.000Z' : '23:59:59.000Z'}`;
                        requestBody[key] = dateString;
                    }
                    break;

                default:
                    break;
            }
        })
        if (requestBody.eventDateFrom) {
            let date = new Date(requestBody.eventDateFrom);
            const day = date.getDate();
            let month: string = (date.getMonth() + 1).toString();
            if (parseInt(month) < 10) {
                month = `0${month}`;
            }
            const year = date.getFullYear();
            const dateString = `${year}-${month}-${day}T00:00:00.000Z`;
            requestBody.eventDateFrom = dateString
        }
        if (requestBody.eventDateTo) {
            let date = new Date(requestBody.eventDateTo);
            const day = date.getDate();
            let month: string = (date.getMonth() + 1).toString();
            if (parseInt(month) < 10) {
                month = `0${month}`;
            }
            const year = date.getFullYear();
            const dateString = `${year}-${month}-${day}T23:59:59.000Z`;
            requestBody.eventDateTo = dateString
        }
        const content_ = JSON.stringify(requestBody);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesFilter(_response);
        });
    }

    protected processSuesFilter(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModel>(<any>null);
    }
    /**
     * @param body (optional) 
     * @return Success
     */
    suesGetById(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesGetForCreate";
        url_ = url_.replace(/[?&]$/, "");

        // const requestBody = {...body}

        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesGetById(_response);
        });
    }

    protected processSuesGetById(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    GetSigningDocuments(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/GetSigningDocuments?";
        if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("deleteSueDocument: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();


        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSigningDocuments(_response);
        });



    }

    protected processGetSigningDocuments(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModel>(<any>null);
    }


    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    sueUpdate(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesUpsertSue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSueUpdate(_response);
        });
    }

    protected processSueUpdate(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        console.log('processSueUpdate-_responseText, status', response, status)
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200;//Treatment.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                return _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver)
            });
        }
        return Promise.resolve<Treatment>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    sueDocumentsCreate(body: any): Promise<SueDocumentModel> {
        let url_ = this.baseUrl + "/api/suits/SueDocumentsCreate?";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSueDocumentsCreate(_response);
        });
    }

    protected processSueDocumentsCreate(response: Response): Promise<SueDocumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SueDocumentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SueDocumentModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sueDocumentsCreate2(body: CreateSueDocumentModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/suits/SueDocumentsCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSueDocumentsCreate2(_response);
        });
    }

    protected processSueDocumentsCreate2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }


    /**
     * @param id
     * @return Success
     */
    deleteSueDocument(id: string): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/SueDocumentsDelete?";
        if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("deleteSueDocument: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSueDocument(_response);
        });
    }

    protected processDeleteSueDocument(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    sueTypeGetAll(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesSueTypeGetAll";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSueTypeGetAll(_response);
        });
    }

    protected processSueTypeGetAll(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suesAddSueType(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesAddSueType";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSueType(_response);
        });
    }

    protected processAddSueType(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id
     * @return Success
     */
    suesDeleteSueType(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesDeleteSueType?";
        if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("suesDeleteSueType: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSueType(_response);
        });
    }

    protected processDeleteSueType(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sueStatusGetAll(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesSueStatusGetAll";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSueStatusGetAll(_response);
        });
    }

    protected processSueStatusGetAll(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suesAddSueStatus(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesAddSueStatus";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSueStatus(_response);
        });
    }

    protected processAddSueStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }
    /**
     * @param id
     * @return Success
     */
    suesDeleteSueStatus(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesDeleteSueStatus?";
        if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("suesDeleteSueType: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSueStatus(_response);
        });
    }

    protected processDeleteSueStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sueActivityStatusGetAll(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesSueActivityStatusGetAll";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSueActivityStatusGetAll(_response);
        });
    }

    protected processSueActivityStatusGetAll(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }
    /**
     * @param body (optional) 
     * @return Success
     */
    suesAddSueActivityStatus(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesAddSueActivityStatus";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSueActivityStatus(_response);
        });
    }

    protected processAddSueActivityStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id
     * @return Success
     */
    suesDeleteSueActivityType(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesDeleteSueActivityType?";
        if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("suesDeleteSueActivityType: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSueActivityType(_response);
        });
    }

    protected processDeleteSueActivityType(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suesFilterByCustomer(body: CommonCustomerFilterModel | undefined): Promise<SueModel[]> {
        let url_ = this.baseUrl + "/api/suits/suesFilterByCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesFilterByCustomer(_response);
        });
    }

    protected processSuesFilterByCustomer(response: Response): Promise<SueModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SueModel.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    suesIndex(): Promise<SuePageModel> {
        let url_ = this.baseUrl + "/api/suits/suesIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesIndex(_response);
        });
    }

    protected processSuesIndex(response: Response): Promise<SuePageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SuePageModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuePageModel>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @param policyId (optional) 
     * @param riderId (optional) 
     * @param sueId (optional) 
     * @return Success
     */
    suesAddSue(customerId: string | undefined, policyId: string | undefined, riderId: string | undefined, sueId: string | undefined): Promise<SueDetailsModel> {
        let url_ = this.baseUrl + "/api/suits/suesAddSue?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        if (riderId === null)
            throw new Error("The parameter 'riderId' cannot be null.");
        else if (riderId !== undefined)
            url_ += "riderId=" + encodeURIComponent("" + riderId) + "&";
        if (sueId === null)
            throw new Error("The parameter 'sueId' cannot be null.");
        else if (sueId !== undefined)
            url_ += "sueId=" + encodeURIComponent("" + sueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesAddSue(_response);
        });
    }

    protected processSuesAddSue(response: Response): Promise<SueDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SueDetailsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SueDetailsModel>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @param body (optional) 
     * @return Success
     */
    suesAddSue2(customerId: string | undefined, body: SueDetailsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/suits/suesAddSue?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesAddSue2(_response);
        });
    }

    protected processSuesAddSue2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param riderId (optional) 
     * @param policyId (optional) 
     * @param sueId (optional) 
     * @return Success
     */
    suesGetDriverDetails(riderId: string | undefined, policyId: string | undefined, sueId: string | undefined): Promise<DriverAndVehicleDetailsTab> {
        let url_ = this.baseUrl + "/api/suits/suesGetDriverDetails?";
        if (riderId === null)
            throw new Error("The parameter 'riderId' cannot be null.");
        else if (riderId !== undefined)
            url_ += "riderId=" + encodeURIComponent("" + riderId) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        if (sueId === null)
            throw new Error("The parameter 'sueId' cannot be null.");
        else if (sueId !== undefined)
            url_ += "sueId=" + encodeURIComponent("" + sueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesGetDriverDetails(_response);
        });
    }

    protected processSuesGetDriverDetails(response: Response): Promise<DriverAndVehicleDetailsTab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DriverAndVehicleDetailsTab.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriverAndVehicleDetailsTab>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suesSueDetails(id: string | undefined): Promise<SueDetailsModel> {
        let url_ = this.baseUrl + "/api/suits/suesSueDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesSueDetails(_response);
        });
    }

    protected processSuesSueDetails(response: Response): Promise<SueDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SueDetailsModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SueDetailsModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suesSueGeneralDetails(id: string | undefined): Promise<GeneralDetailsTab> {
        let url_ = this.baseUrl + "/api/suits/suesSueGeneralDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesSueGeneralDetails(_response);
        });
    }

    protected processSuesSueGeneralDetails(response: Response): Promise<GeneralDetailsTab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDetailsTab.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GeneralDetailsTab>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    suesSueGeneralDetails2(id: string | undefined, body: GeneralDetailsTab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/suits/suesSueGeneralDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesSueGeneralDetails2(_response);
        });
    }

    protected processSuesSueGeneralDetails2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suesDriverAndVehicleDetails(id: string | undefined): Promise<DriverAndVehicleDetailsTab> {
        let url_ = this.baseUrl + "/api/suits/suesDriverAndVehicleDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesDriverAndVehicleDetails(_response);
        });
    }

    protected processSuesDriverAndVehicleDetails(response: Response): Promise<DriverAndVehicleDetailsTab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DriverAndVehicleDetailsTab.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriverAndVehicleDetailsTab>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    suesDriverAndVehicleDetails2(id: string | undefined, body: DriverAndVehicleDetailsTab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/suits/suesDriverAndVehicleDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesDriverAndVehicleDetails2(_response);
        });
    }

    protected processSuesDriverAndVehicleDetails2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suesAccidentAndDamageDetails(id: string | undefined): Promise<AccidentAndDamageDetailsTab> {
        let url_ = this.baseUrl + "/api/suits/suesAccidentAndDamageDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesAccidentAndDamageDetails(_response);
        });
    }

    protected processSuesAccidentAndDamageDetails(response: Response): Promise<AccidentAndDamageDetailsTab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccidentAndDamageDetailsTab.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccidentAndDamageDetailsTab>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    suesAccidentAndDamageDetails2(id: string | undefined, body: AccidentAndDamageDetailsTab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/suits/suesAccidentAndDamageDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesAccidentAndDamageDetails2(_response);
        });
    }

    protected processSuesAccidentAndDamageDetails2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suesInjuredAndWitnesses(id: string | undefined): Promise<InjuredAndWitnessesTab> {
        let url_ = this.baseUrl + "/api/suits/suesInjuredAndWitnesses?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesInjuredAndWitnesses(_response);
        });
    }

    protected processSuesInjuredAndWitnesses(response: Response): Promise<InjuredAndWitnessesTab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InjuredAndWitnessesTab.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InjuredAndWitnessesTab>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    suesInjuredAndWitnesses2(id: string | undefined, body: InjuredAndWitnessesTab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/suits/suesInjuredAndWitnesses?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesInjuredAndWitnesses2(_response);
        });
    }

    protected processSuesInjuredAndWitnesses2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suesInvolvedVehicles(id: string | undefined): Promise<InvolvedVehiclesTab> {
        let url_ = this.baseUrl + "/api/suits/suesInvolvedVehicles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesInvolvedVehicles(_response);
        });
    }

    protected processSuesInvolvedVehicles(response: Response): Promise<InvolvedVehiclesTab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InvolvedVehiclesTab.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvolvedVehiclesTab>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    suesInvolvedVehicles2(id: string | undefined, body: InvolvedVehiclesTab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/suits/suesInvolvedVehicles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesInvolvedVehicles2(_response);
        });
    }

    protected processSuesInvolvedVehicles2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suesGarageDetails(id: string | undefined): Promise<GarageDetailsTab> {
        let url_ = this.baseUrl + "/api/suits/suesGarageDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesGarageDetails(_response);
        });
    }

    protected processSuesGarageDetails(response: Response): Promise<GarageDetailsTab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GarageDetailsTab.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GarageDetailsTab>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    suesGarageDetails2(id: string | undefined, body: GarageDetailsTab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/suits/suesGarageDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesGarageDetails2(_response);
        });
    }

    protected processSuesGarageDetails2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }


    /**
     * @param id (optional) 
     * @return Success
     */
    paymentUpsertPayment(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/paymentUpsertPayment";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaymentUpsertPayment(_response);
        });
    }

    protected processPaymentUpsertPayment(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // result200 = SueDocumentModel.fromJS(resultData200);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suesAddSueComment(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesAddSueComment";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesAddSueComment(_response);
        });
    }

    protected processSuesAddSueComment(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // result200 = SueDocumentModel.fromJS(resultData200);
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }




    suesExportToExcel(filter: any): Promise<any> {
        let url_ = this.baseUrl + "/api/suits/suesExportToExcel";
        url_ = url_.replace(/[?&]$/, "");
        const token = this.getAuthToken();
        const content_ = /*JSON.stringify*/JSONStringify(filter);
        let options_ = <RequestInit>{
            method: "POST",
            body: content_,
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuesExportToExcel(_response);
        });
    }

    protected async processSuesExportToExcel(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let fileName = `${Date.now()}.xlsx`.trim();
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            console.log('response :>> ', response);

            // Clean up after downloading
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @return Success
     */
    whatsappGetWhatsAppManagement(): Promise<WhatsAppManagement[]> {
        let url_ = this.baseUrl + "/whatsappGetWhatsAppManagement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappGetWhatsAppManagement(_response);
        });
    }

    protected processWhatsappGetWhatsAppManagement(response: Response): Promise<WhatsAppManagement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(WhatsAppManagement.fromJS(item));
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsAppManagement[]>(<any>null);
    }

    WhatsappGetNewMessages(): Promise<ResponseObject2> {
        let url_ = this.baseUrl + "/api/communication/whatsappGetNewMessages";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhatsappGetNewMessages(_response);
        });
    }

    protected processWhatsappGetNewMessages(response: Response): Promise<ResponseObject2> {

        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);

                return ResponseObject2.fromJS(result200)


            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);

                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response
            });
        }
        return Promise.resolve<ResponseObject2>(<any>null);
    }

    /**
     * @return Success
     */
    getAddressesAll(): Promise<any> {
        let url_ = this.baseUrl + "/api/Cache/GetAddressesAll";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAddressesAll(_response);
        });
    }

    protected processGetAddressesAll(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    customerCardGetSpeakCom(body: any | undefined): Promise<any> {
        // //console.log('customerCardGetSpeakCom');
        let url_ = this.baseUrl + "/api/operation/customerCardGetSpeackCom";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        const content_ = /*JSON.stringify*/JSONStringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerCardGetSpeakCom(_response);
        });
    }

    protected processCustomerCardGetSpeakCom(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const results: any[] = [];
                if (resultData200.items && resultData200.items.length > 0) {
                    resultData200.items.forEach((item: any) => {
                        if (item.items && item.items.length > 0) {
                            item.items.forEach((i: any) => {
                                results.push(i);
                            })
                        }
                    })
                }
                result200 = results; //TreatmentTabModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                const response = _responseText ? JSON.parse(_responseText) : {
                    error: true,
                    message: 'ERROR'
                }
                return response
                // return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    policyGetPolicyTypes(): Promise<any> {
        let url_ = this.baseUrl + "/api/operation/policyGetPolicyTypes";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);


        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicyGetPolicyTypes(_response);
        });
    }

    protected processPolicyGetPolicyTypes(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentModel>(<any>null);
    }


    /**
     * @param typeName (optional) 
     * @return Success
     */
    simulatorGetRoutesByInsuranceCompany(insuranceCompanyId: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/engagement/simulatorGetRoutesByInsuranceCompany?";
        if (insuranceCompanyId === null)
            throw new Error("The parameter 'insuranceCompanyId' cannot be null.");
        else if (insuranceCompanyId !== undefined)
            url_ += "insuranceCompanyId=" + encodeURIComponent("" + insuranceCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimulatorGetRoutesByInsuranceCompany(_response);
        });
    }

    protected processSimulatorGetRoutesByInsuranceCompany(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                // if (resultData200) {
                //     result200 = {} as any;
                //     for (let key in resultData200) {
                //         if (resultData200.hasOwnProperty(key))
                //             result200![key] = resultData200[key] ? IDNameDescriptionItem.fromJS(resultData200[key]) : new IDNameDescriptionItem();
                //     }
                // }
                return resultData200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: IDNameDescriptionItem; }>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    getElementaryPolicyStatuses(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/ElementaryPolicyStatusGetAll";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetElementaryPolicyStatuses(_response);
        });
    }

    protected processGetElementaryPolicyStatuses(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    addElementaryPolicyStatus(body: any | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/ElementaryPolicyStatusAdd";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = /*JSON.stringify*/JSONStringify(body);
        const content_ = JSON.stringify(body);
        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddElementaryPolicyStatus(_response);
        });
    }

    protected processAddElementaryPolicyStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @param id
     * @return Success
     */
    deleteElementaryPolicyStatus(id: string | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/signing/ElementaryPolicyStatusDelete?";
        if (id !== undefined) {
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        } else {
            throw new Error("deleteElementaryPolicyStatus: The parameter 'id' cannot be null.");
        }
        url_ = url_.replace(/[?&]$/, "");

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processdeleteElementaryPolicyStatus(_response);
        });
    }

    protected processdeleteElementaryPolicyStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }


    riderUpdateStatus(body: any): Promise<any> {
        let url_ = this.baseUrl + "/api/riders/riderUpdateStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = /*JSON.stringify*/JSONStringify(body);

        const token = this.getAuthToken();

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                'Authorization': `Bearer ${token}`,
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRiderUpdateStatus(_response);
        });

    }

    protected processRiderUpdateStatus(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200; //AssignmentModel.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

}

export class AccessRight implements IAccessRight {

    constructor(data?: IAccessRight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AccessRight {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAccessRight {
}

export class AccidentAndDamageDetailsTab implements IAccidentAndDamageDetailsTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    sueAccidentAndDamageInfoId?: string;
    accidentDateTime?: Date;
    isDriverLicensed?: YesNo;
    accidentAddress?: string | undefined;
    accidentDetails?: string | undefined;
    isPoliceNotified?: boolean;
    stationName?: string | undefined;
    caseNumber?: string | undefined;
    insuredCarDamageDescription?: string | undefined;
    thirdPartyCarDamageDescription?: string | undefined;
    booleanSelectList?: SelectListItem[] | undefined;
    hours?: SelectListItem[] | undefined;

    constructor(data?: IAccidentAndDamageDetailsTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sueId = _data["sueId"];
            this.customerModel = _data["customerModel"] ? CustomerModel.fromJS(_data["customerModel"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorPropertyModel.fromJS(item));
            }
            this.sueAccidentAndDamageInfoId = _data["sueAccidentAndDamageInfoId"];
            this.accidentDateTime = _data["accidentDateTime"] ? new Date(_data["accidentDateTime"].toString()) : <any>undefined;
            this.isDriverLicensed = _data["isDriverLicensed"];
            this.accidentAddress = _data["accidentAddress"];
            this.accidentDetails = _data["accidentDetails"];
            this.isPoliceNotified = _data["isPoliceNotified"];
            this.stationName = _data["stationName"];
            this.caseNumber = _data["caseNumber"];
            this.insuredCarDamageDescription = _data["insuredCarDamageDescription"];
            this.thirdPartyCarDamageDescription = _data["thirdPartyCarDamageDescription"];
            if (Array.isArray(_data["booleanSelectList"])) {
                this.booleanSelectList = [] as any;
                for (let item of _data["booleanSelectList"])
                    this.booleanSelectList!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccidentAndDamageDetailsTab {
        data = typeof data === 'object' ? data : {};
        let result = new AccidentAndDamageDetailsTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sueId"] = this.sueId;
        data["customerModel"] = this.customerModel ? this.customerModel.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["sueAccidentAndDamageInfoId"] = this.sueAccidentAndDamageInfoId;
        data["accidentDateTime"] = this.accidentDateTime ? this.accidentDateTime.toISOString() : <any>undefined;
        data["isDriverLicensed"] = this.isDriverLicensed;
        data["accidentAddress"] = this.accidentAddress;
        data["accidentDetails"] = this.accidentDetails;
        data["isPoliceNotified"] = this.isPoliceNotified;
        data["stationName"] = this.stationName;
        data["caseNumber"] = this.caseNumber;
        data["insuredCarDamageDescription"] = this.insuredCarDamageDescription;
        data["thirdPartyCarDamageDescription"] = this.thirdPartyCarDamageDescription;
        if (Array.isArray(this.booleanSelectList)) {
            data["booleanSelectList"] = [];
            for (let item of this.booleanSelectList)
                data["booleanSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccidentAndDamageDetailsTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    sueAccidentAndDamageInfoId?: string;
    accidentDateTime?: Date;
    isDriverLicensed?: YesNo;
    accidentAddress?: string | undefined;
    accidentDetails?: string | undefined;
    isPoliceNotified?: boolean;
    stationName?: string | undefined;
    caseNumber?: string | undefined;
    insuredCarDamageDescription?: string | undefined;
    thirdPartyCarDamageDescription?: string | undefined;
    booleanSelectList?: SelectListItem[] | undefined;
    hours?: SelectListItem[] | undefined;
}

/** 0 = ChangeVehicle, 1 = ChangePackages, 2 = UpdatePayment, 3 = Freeze, 4 = Cancel, 5 = Details */
export enum ActionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** 0 = Active, 1 = Inactive */
export enum ActivityStatus {
    _0 = 0,
    _1 = 1,
}

/** 0 = Unspecified, 1 = Unix, 2 = InterNetwork, 3 = ImpLink, 4 = Pup, 5 = Chaos, 6 = Ipx, 7 = Iso, 8 = Ecma, 9 = DataKit, 10 = Ccitt, 11 = Sna, 12 = DecNet, 13 = DataLink, 14 = Lat, 15 = HyperChannel, 16 = AppleTalk, 17 = NetBios, 18 = VoiceView, 19 = FireFox, 21 = Banyan, 22 = Atm, 23 = InterNetworkV6, 24 = Cluster, 25 = Ieee12844, 26 = Irda, 28 = NetworkDesigners, 29 = Max, 65536 = Packet, 65537 = ControllerAreaNetwork, -1 = Unknown */
export enum AddressFamily {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _25 = 25,
    _26 = 26,
    _28 = 28,
    _29 = 29,
    _65536 = 65536,
    _65537 = 65537,
    __1 = -1,
}

export class Agent implements IAgent {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    parentId?: string | undefined;

    constructor(data?: IAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): Agent {
        data = typeof data === 'object' ? data : {};
        let result = new Agent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IAgent {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
}

export class AgentDetails implements IAgentDetails {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    agentId?: string | undefined;
    agent?: Agent;
    agentNumber?: string | undefined;
    password?: string | undefined;
    routeId?: string | undefined;
    title?: string | undefined;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompany;
    userName?: string | undefined;
    status?: ActivityStatus;
    temsAndCovers?: string | undefined;
    premiumExpansion?: string | undefined;
    temsAndCoversFilePath?: string | undefined;
    specificDetails?: SpecificInsuranceCompanyDetails[] | undefined;

    constructor(data?: IAgentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : <any>undefined;
            this.agentNumber = _data["agentNumber"];
            this.password = _data["password"];
            this.routeId = _data["routeId"];
            this.title = _data["title"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.userName = _data["userName"];
            this.status = _data["status"];
            this.temsAndCovers = _data["temsAndCovers"];
            this.premiumExpansion = _data["premiumExpansion"];
            this.temsAndCoversFilePath = _data["temsAndCoversFilePath"];
            if (Array.isArray(_data["specificDetails"])) {
                this.specificDetails = [] as any;
                for (let item of _data["specificDetails"])
                    this.specificDetails!.push(SpecificInsuranceCompanyDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["agentNumber"] = this.agentNumber;
        data["password"] = this.password;
        data["routeId"] = this.routeId;
        data["title"] = this.title;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["status"] = this.status;
        data["temsAndCovers"] = this.temsAndCovers;
        data["premiumExpansion"] = this.premiumExpansion;
        data["temsAndCoversFilePath"] = this.temsAndCoversFilePath;
        if (Array.isArray(this.specificDetails)) {
            data["specificDetails"] = [];
            for (let item of this.specificDetails)
                data["specificDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentDetails {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    agentId?: string | undefined;
    agent?: Agent;
    agentNumber?: string | undefined;
    password?: string | undefined;
    routeId?: string | undefined;
    title?: string | undefined;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompany;
    userName?: string | undefined;
    status?: ActivityStatus;
    temsAndCovers?: string | undefined;
    premiumExpansion?: string | undefined;
    temsAndCoversFilePath?: string | undefined;
    specificDetails?: SpecificInsuranceCompanyDetails[] | undefined;
}

export class AgentDetailsModel implements IAgentDetailsModel {
    id?: string;
    agentId?: string | undefined;
    agent?: Agent;
    agentNumber?: string | undefined;
    password?: string | undefined;
    title?: string | undefined;
    routeId?: string | undefined;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompanyModel;
    userName?: string | undefined;
    status?: ActivityStatus;
    temsAndCovers?: string | undefined;
    premiumExpansion?: string | undefined;
    temsAndCoversFile?: string | undefined;
    temsAndCoversFilePath?: string | undefined;
    specificDetails?: SpecificInsuranceCompanyDetails[] | undefined;
    readonly agentText?: string | undefined;

    constructor(data?: IAgentDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : <any>undefined;
            this.agentNumber = _data["agentNumber"];
            this.password = _data["password"];
            this.title = _data["title"];
            this.routeId = _data["routeId"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.userName = _data["userName"];
            this.status = _data["status"];
            this.temsAndCovers = _data["temsAndCovers"];
            this.premiumExpansion = _data["premiumExpansion"];
            this.temsAndCoversFile = _data["temsAndCoversFile"];
            this.temsAndCoversFilePath = _data["temsAndCoversFilePath"];
            if (Array.isArray(_data["specificDetails"])) {
                this.specificDetails = [] as any;
                for (let item of _data["specificDetails"])
                    this.specificDetails!.push(SpecificInsuranceCompanyDetails.fromJS(item));
            }
            (<any>this).agentText = _data["agentText"];
        }
    }

    static fromJS(data: any): AgentDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["agentNumber"] = this.agentNumber;
        data["password"] = this.password;
        data["title"] = this.title;
        data["routeId"] = this.routeId;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["status"] = this.status;
        data["temsAndCovers"] = this.temsAndCovers;
        data["premiumExpansion"] = this.premiumExpansion;
        data["temsAndCoversFile"] = this.temsAndCoversFile;
        data["temsAndCoversFilePath"] = this.temsAndCoversFilePath;
        if (Array.isArray(this.specificDetails)) {
            data["specificDetails"] = [];
            for (let item of this.specificDetails)
                data["specificDetails"].push(item.toJSON());
        }
        data["agentText"] = this.agentText;
        return data;
    }
}

export interface IAgentDetailsModel {
    id?: string;
    agentId?: string | undefined;
    agent?: Agent;
    agentNumber?: string | undefined;
    password?: string | undefined;
    title?: string | undefined;
    routeId?: string | undefined;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompanyModel;
    userName?: string | undefined;
    status?: ActivityStatus;
    temsAndCovers?: string | undefined;
    premiumExpansion?: string | undefined;
    temsAndCoversFile?: string | undefined;
    temsAndCoversFilePath?: string | undefined;
    specificDetails?: SpecificInsuranceCompanyDetails[] | undefined;
    agentText?: string | undefined;
}

export class AgentModel implements IAgentModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;

    constructor(data?: IAgentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AgentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IAgentModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
}

export class AllocationDiscountBankModel implements IAllocationDiscountBankModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    date?: Date;
    amount?: number;
    userId?: string | undefined;
    user?: UserModel;
    discounts?: RiderDiscountBankModel[] | undefined;

    constructor(data?: IAllocationDiscountBankModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(RiderDiscountBankModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllocationDiscountBankModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationDiscountBankModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllocationDiscountBankModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    date?: Date;
    amount?: number;
    userId?: string | undefined;
    user?: UserModel;
    discounts?: RiderDiscountBankModel[] | undefined;
}

export class AmountAndFeeModel implements IAmountAndFeeModel {
    id?: string;
    number?: string | undefined;
    netPremium?: number;
    insuranceAmount?: number;
    discountSum?: number;
    discountPercent?: number;
    firstAgentFeePercent?: number;
    firstAgentFeeAmount?: number;
    elementaryInsurancePolicyId?: string;

    constructor(data?: IAmountAndFeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.netPremium = _data["netPremium"];
            this.insuranceAmount = _data["insuranceAmount"];
            this.discountSum = _data["discountSum"];
            this.discountPercent = _data["discountPercent"];
            this.firstAgentFeePercent = _data["firstAgentFeePercent"];
            this.firstAgentFeeAmount = _data["firstAgentFeeAmount"];
            this.elementaryInsurancePolicyId = _data["elementaryInsurancePolicyId"];
        }
    }

    static fromJS(data: any): AmountAndFeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmountAndFeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["netPremium"] = this.netPremium;
        data["insuranceAmount"] = this.insuranceAmount;
        data["discountSum"] = this.discountSum;
        data["discountPercent"] = this.discountPercent;
        data["firstAgentFeePercent"] = this.firstAgentFeePercent;
        data["firstAgentFeeAmount"] = this.firstAgentFeeAmount;
        data["elementaryInsurancePolicyId"] = this.elementaryInsurancePolicyId;
        return data;
    }
}

export interface IAmountAndFeeModel {
    id?: string;
    number?: string | undefined;
    netPremium?: number;
    insuranceAmount?: number;
    discountSum?: number;
    discountPercent?: number;
    firstAgentFeePercent?: number;
    firstAgentFeeAmount?: number;
    elementaryInsurancePolicyId?: string;
}

/** 0 = Sum, 1 = Percent */
export enum AmountType {
    _0 = 0,
    _1 = 1,
}

export enum DiscountType {
    _number = 0,
    _select = 1,
}


export class Amouts implements IAmouts {
    openLeads?: number;
    closeLeads?: number;
    closeLeadsPercent?: number;

    constructor(data?: IAmouts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openLeads = _data["openLeads"];
            this.closeLeads = _data["closeLeads"];
            this.closeLeadsPercent = _data["closeLeadsPercent"];
        }
    }

    static fromJS(data: any): Amouts {
        data = typeof data === 'object' ? data : {};
        let result = new Amouts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openLeads"] = this.openLeads;
        data["closeLeads"] = this.closeLeads;
        data["closeLeadsPercent"] = this.closeLeadsPercent;
        return data;
    }
}

export interface IAmouts {
    openLeads?: number;
    closeLeads?: number;
    closeLeadsPercent?: number;
}

/** 0 = Structure, 1 = Content, 2 = StructureAndContent */
export enum ApartmentCoverType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = Comprehensive, 1 = AllRisks */
export enum ApartmentPolicyType {
    _0 = 0,
    _1 = 1,
}

export class APIServiceUserModel implements IAPIServiceUserModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    users?: UserModel[] | undefined;
    insueanceCompanies?: SelectListItem[] | undefined;

    constructor(data?: IAPIServiceUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["insueanceCompanies"])) {
                this.insueanceCompanies = [] as any;
                for (let item of _data["insueanceCompanies"])
                    this.insueanceCompanies!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIServiceUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new APIServiceUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.insueanceCompanies)) {
            data["insueanceCompanies"] = [];
            for (let item of this.insueanceCompanies)
                data["insueanceCompanies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAPIServiceUserModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    users?: UserModel[] | undefined;
    insueanceCompanies?: SelectListItem[] | undefined;
}

export class AppDictionaryListResponse implements IAppDictionaryListResponse {
    data?: { [key: string]: IDNameDescriptionItem; } | undefined;

    constructor(data?: IAppDictionaryListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? IDNameDescriptionItem.fromJS(_data["data"][key]) : new IDNameDescriptionItem();
                }
            }
        }
    }

    static fromJS(data: any): AppDictionaryListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppDictionaryListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IAppDictionaryListResponse {
    data?: { [key: string]: IDNameDescriptionItem; } | undefined;
}

export class Assembly implements IAssembly {
    readonly definedTypes?: TypeInfo[] | undefined;
    readonly exportedTypes?: Type[] | undefined;
    readonly codeBase?: string | undefined;
    entryPoint?: MethodInfo;
    readonly fullName?: string | undefined;
    readonly imageRuntimeVersion?: string | undefined;
    readonly isDynamic?: boolean;
    readonly location?: string | undefined;
    readonly reflectionOnly?: boolean;
    readonly isCollectible?: boolean;
    readonly isFullyTrusted?: boolean;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly escapedCodeBase?: string | undefined;
    manifestModule?: Module;
    readonly modules?: Module[] | undefined;
    readonly globalAssemblyCache?: boolean;
    readonly hostContext?: number;
    securityRuleSet?: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes!.push(Type.fromJS(item));
            }
            (<any>this).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules!.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item.toJSON());
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes?: TypeInfo[] | undefined;
    exportedTypes?: Type[] | undefined;
    codeBase?: string | undefined;
    entryPoint?: MethodInfo;
    fullName?: string | undefined;
    imageRuntimeVersion?: string | undefined;
    isDynamic?: boolean;
    location?: string | undefined;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    escapedCodeBase?: string | undefined;
    manifestModule?: Module;
    modules?: Module[] | undefined;
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;
}

export class AssignmentFilterModel implements IAssignmentFilterModel {
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    agentId?: string | undefined;
    agents?: SelectListItem[] | undefined;
    status?: AssignmentStatus;
    statuses?: SelectListItem[] | undefined;
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;

    constructor(data?: IAssignmentFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectListItem.fromJS(item));
            }
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.status = _data["status"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(SelectListItem.fromJS(item));
            }
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignmentFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["agentId"] = this.agentId;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["status"] = this.status;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignmentFilterModel {
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    agentId?: string | undefined;
    agents?: SelectListItem[] | undefined;
    status?: AssignmentStatus;
    statuses?: SelectListItem[] | undefined;
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
}

export class AssignmentGridModel implements IAssignmentGridModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    filter?: AssignmentFilterModel;
    items?: AssignmentModel[] | undefined;

    constructor(data?: IAssignmentGridModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.filter = _data["filter"] ? AssignmentFilterModel.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssignmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignmentGridModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentGridModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignmentGridModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    filter?: AssignmentFilterModel;
    items?: AssignmentModel[] | undefined;
}

export class AssignmentModel implements IAssignmentModel {
    treatmentId?: string;
    topic?: string | undefined;
    note?: string | undefined;
    taskStatus?: AssignmentStatus;
    date?: Date;
    endDate?: Date;
    forTreatmentByName?: string | undefined;
    customerName?: string | undefined;
    agentName?: string | undefined;

    constructor(data?: IAssignmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentId = _data["treatmentId"];
            this.topic = _data["topic"];
            this.note = _data["note"];
            this.taskStatus = _data["taskStatus"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.forTreatmentByName = _data["forTreatmentByName"];
            this.customerName = _data["customerName"];
            this.agentName = _data["agentName"];
        }
    }

    static fromJS(data: any): AssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentId"] = this.treatmentId;
        data["topic"] = this.topic;
        data["note"] = this.note;
        data["taskStatus"] = this.taskStatus;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["forTreatmentByName"] = this.forTreatmentByName;
        data["customerName"] = this.customerName;
        data["agentName"] = this.agentName;
        return data;
    }
}

export interface IAssignmentModel {
    treatmentId?: string;
    topic?: string | undefined;
    note?: string | undefined;
    taskStatus?: AssignmentStatus;
    date?: Date;
    endDate?: Date;
    forTreatmentByName?: string | undefined;
    customerName?: string | undefined;
    agentName?: string | undefined;
}

export class AssignmentModelForUpsert implements IAssignmentModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    topic?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    forTreatmentById?: string;
    forTreatmentBySelectList?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    assignmentStatus?: AssignmentStatus;
    assignmentStatuses?: SelectListItem[] | undefined;
    endDate?: Date;
    endHour?: TimeSpan;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    statusChangeEmail?: string | undefined;
    statusChangeSms?: string | undefined;
    employer?: EmployerModel;
    employerId?: string | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
    fileAttachment!: string;

    constructor(data?: IAssignmentModelForUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.alertHour = _data["alertHour"] ? TimeSpan.fromJS(_data["alertHour"]) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.treatmentType = _data["treatmentType"];
            this.customerId = _data["customerId"];
            this.topic = _data["topic"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(SelectListItem.fromJS(item));
            }
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectListItem.fromJS(item));
            }
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.forTreatmentById = _data["forTreatmentById"];
            if (Array.isArray(_data["forTreatmentBySelectList"])) {
                this.forTreatmentBySelectList = [] as any;
                for (let item of _data["forTreatmentBySelectList"])
                    this.forTreatmentBySelectList!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(SelectListItem.fromJS(item));
            }
            this.assignmentStatus = _data["assignmentStatus"];
            if (Array.isArray(_data["assignmentStatuses"])) {
                this.assignmentStatuses = [] as any;
                for (let item of _data["assignmentStatuses"])
                    this.assignmentStatuses!.push(SelectListItem.fromJS(item));
            }
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endHour = _data["endHour"] ? TimeSpan.fromJS(_data["endHour"]) : <any>undefined;
            this.note = _data["note"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
            this.statusChangeEmail = _data["statusChangeEmail"];
            this.statusChangeSms = _data["statusChangeSms"];
            this.employer = _data["employer"] ? EmployerModel.fromJS(_data["employer"]) : <any>undefined;
            this.employerId = _data["employerId"];
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
            this.fileAttachment = _data["fileAttachment"];
        }
    }

    static fromJS(data: any): AssignmentModelForUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentModelForUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["alertHour"] = this.alertHour ? this.alertHour.toJSON() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["treatmentType"] = this.treatmentType;
        data["customerId"] = this.customerId;
        data["topic"] = this.topic;
        data["priority"] = this.priority;
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item.toJSON());
        }
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["agentId"] = this.agentId;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["forTreatmentById"] = this.forTreatmentById;
        if (Array.isArray(this.forTreatmentBySelectList)) {
            data["forTreatmentBySelectList"] = [];
            for (let item of this.forTreatmentBySelectList)
                data["forTreatmentBySelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        data["assignmentStatus"] = this.assignmentStatus;
        if (Array.isArray(this.assignmentStatuses)) {
            data["assignmentStatuses"] = [];
            for (let item of this.assignmentStatuses)
                data["assignmentStatuses"].push(item.toJSON());
        }
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endHour"] = this.endHour ? this.endHour.toJSON() : <any>undefined;
        data["note"] = this.note;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        data["statusChangeEmail"] = this.statusChangeEmail;
        data["statusChangeSms"] = this.statusChangeSms;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["employerId"] = this.employerId;
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        data["fileAttachment"] = this.fileAttachment;
        return data;
    }
}

export interface IAssignmentModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    topic?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    forTreatmentById?: string;
    forTreatmentBySelectList?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    assignmentStatus?: AssignmentStatus;
    assignmentStatuses?: SelectListItem[] | undefined;
    endDate?: Date;
    endHour?: TimeSpan;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    statusChangeEmail?: string | undefined;
    statusChangeSms?: string | undefined;
    employer?: EmployerModel;
    employerId?: string | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
    fileAttachment: string;
}

/** 0 = NotYetPerformed, 1 = Performed, 2 = NotifiedOnly, 3 = Pending, 4 = Canceled */
export enum AssignmentStatus {
    NotYetPerformed = 0, // טרם בוצעה
    Performed = 1, // בוצעה
    NotifiedOnly = 2,
    Pending = 3, // פיגור
    Canceled = 4, // בוטל
}

export class AssignSigningsData implements IAssignSigningsData {
    signingPersonId?: string;
    signings?: string[] | undefined;

    constructor(data?: IAssignSigningsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signingPersonId = _data["signingPersonId"];
            if (Array.isArray(_data["signings"])) {
                this.signings = [] as any;
                for (let item of _data["signings"])
                    this.signings!.push(item);
            }
        }
    }

    static fromJS(data: any): AssignSigningsData {
        data = typeof data === 'object' ? data : {};
        let result = new AssignSigningsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signingPersonId"] = this.signingPersonId;
        if (Array.isArray(this.signings)) {
            data["signings"] = [];
            for (let item of this.signings)
                data["signings"].push(item);
        }
        return data;
    }
}

export interface IAssignSigningsData {
    signingPersonId?: string;
    signings?: string[] | undefined;
}

export class AttachmentFile implements IAttachmentFile {
    name?: string | undefined;
    type?: FileType;
    content?: string | undefined;
    size?: string | undefined;

    constructor(data?: IAttachmentFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.content = _data["content"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): AttachmentFile {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["content"] = this.content;
        data["size"] = this.size;
        return data;
    }
}

export interface IAttachmentFile {
    name?: string | undefined;
    type?: FileType;
    content?: string | undefined;
    size?: string | undefined;
}

/** 0 = OneDriver, 1 = TwoDrivers, 2 = AnyDriver */
export enum AuthorizedToDrive {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class BalanceDetailsModel implements IBalanceDetailsModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    accrualValueDate?: Date;
    balanceType?: number;
    balanceProvisionType?: number;
    cumulativeSavingsSum?: number;
    revenueValuesSum?: Date;

    constructor(data?: IBalanceDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.accrualValueDate = _data["accrualValueDate"] ? new Date(_data["accrualValueDate"].toString()) : <any>undefined;
            this.balanceType = _data["balanceType"];
            this.balanceProvisionType = _data["balanceProvisionType"];
            this.cumulativeSavingsSum = _data["cumulativeSavingsSum"];
            this.revenueValuesSum = _data["revenueValuesSum"] ? new Date(_data["revenueValuesSum"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BalanceDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["accrualValueDate"] = this.accrualValueDate ? this.accrualValueDate.toISOString() : <any>undefined;
        data["balanceType"] = this.balanceType;
        data["balanceProvisionType"] = this.balanceProvisionType;
        data["cumulativeSavingsSum"] = this.cumulativeSavingsSum;
        data["revenueValuesSum"] = this.revenueValuesSum ? this.revenueValuesSum.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBalanceDetailsModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    accrualValueDate?: Date;
    balanceType?: number;
    balanceProvisionType?: number;
    cumulativeSavingsSum?: number;
    revenueValuesSum?: Date;
}

export class BalanceModel implements IBalanceModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    employerId?: string | undefined;
    employer?: EmployerModel;
    accumulationValueDate?: Date;
    balanceType?: number;
    provisionType?: number;
    totalCumulativeSavings?: string | undefined;
    totalRevenueValues?: string | undefined;

    constructor(data?: IBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.employerId = _data["employerId"];
            this.employer = _data["employer"] ? EmployerModel.fromJS(_data["employer"]) : <any>undefined;
            this.accumulationValueDate = _data["accumulationValueDate"] ? new Date(_data["accumulationValueDate"].toString()) : <any>undefined;
            this.balanceType = _data["balanceType"];
            this.provisionType = _data["provisionType"];
            this.totalCumulativeSavings = _data["totalCumulativeSavings"];
            this.totalRevenueValues = _data["totalRevenueValues"];
        }
    }

    static fromJS(data: any): BalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["employerId"] = this.employerId;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["accumulationValueDate"] = this.accumulationValueDate ? this.accumulationValueDate.toISOString() : <any>undefined;
        data["balanceType"] = this.balanceType;
        data["provisionType"] = this.provisionType;
        data["totalCumulativeSavings"] = this.totalCumulativeSavings;
        data["totalRevenueValues"] = this.totalRevenueValues;
        return data;
    }
}

export interface IBalanceModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    employerId?: string | undefined;
    employer?: EmployerModel;
    accumulationValueDate?: Date;
    balanceType?: number;
    provisionType?: number;
    totalCumulativeSavings?: string | undefined;
    totalRevenueValues?: string | undefined;
}

export class BeginningYearDepositDetailsModel implements IBeginningYearDepositDetailsModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    depositValueDate?: Date;
    depositType?: number;
    myProperty?: number;
    clerkType?: number;
    depositLevelSalary?: string | undefined;
    paidSum?: string | undefined;
    wages?: string | undefined;
    forPaymentTime?: string | undefined;

    constructor(data?: IBeginningYearDepositDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.depositValueDate = _data["depositValueDate"] ? new Date(_data["depositValueDate"].toString()) : <any>undefined;
            this.depositType = _data["depositType"];
            this.myProperty = _data["myProperty"];
            this.clerkType = _data["clerkType"];
            this.depositLevelSalary = _data["depositLevelSalary"];
            this.paidSum = _data["paidSum"];
            this.wages = _data["wages"];
            this.forPaymentTime = _data["forPaymentTime"];
        }
    }

    static fromJS(data: any): BeginningYearDepositDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BeginningYearDepositDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["depositValueDate"] = this.depositValueDate ? this.depositValueDate.toISOString() : <any>undefined;
        data["depositType"] = this.depositType;
        data["myProperty"] = this.myProperty;
        data["clerkType"] = this.clerkType;
        data["depositLevelSalary"] = this.depositLevelSalary;
        data["paidSum"] = this.paidSum;
        data["wages"] = this.wages;
        data["forPaymentTime"] = this.forPaymentTime;
        return data;
    }
}

export interface IBeginningYearDepositDetailsModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    depositValueDate?: Date;
    depositType?: number;
    myProperty?: number;
    clerkType?: number;
    depositLevelSalary?: string | undefined;
    paidSum?: string | undefined;
    wages?: string | undefined;
    forPaymentTime?: string | undefined;
}

export class Branch implements IBranch {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    status?: ActivityStatus;
    address?: string | undefined;
    branchManagerId?: string | undefined;
    logo?: string | undefined;
    parentId?: string | undefined;
    parent?: Branch;
    children?: Branch[] | undefined;
    leads?: Lead[] | undefined;
    stations?: Station[] | undefined;

    constructor(data?: IBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.status = _data["status"];
            this.address = _data["address"];
            this.branchManagerId = _data["branchManagerId"];
            this.logo = _data["logo"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? Branch.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Branch.fromJS(item));
            }
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(Lead.fromJS(item));
            }
            if (Array.isArray(_data["stations"])) {
                this.stations = [] as any;
                for (let item of _data["stations"])
                    this.stations!.push(Station.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Branch {
        data = typeof data === 'object' ? data : {};
        let result = new Branch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["status"] = this.status;
        data["address"] = this.address;
        data["branchManagerId"] = this.branchManagerId;
        data["logo"] = this.logo;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (let item of this.stations)
                data["stations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranch {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    status?: ActivityStatus;
    address?: string | undefined;
    branchManagerId?: string | undefined;
    logo?: string | undefined;
    parentId?: string | undefined;
    parent?: Branch;
    children?: Branch[] | undefined;
    leads?: Lead[] | undefined;
    stations?: Station[] | undefined;
}

export class BranchesDepartmentsUsersModel implements IBranchesDepartmentsUsersModel {
    branches?: BranchModel[] | undefined;
    users?: UserModel[] | undefined;
    activeUsers?: string[] | undefined;
    referrerId?: string;
    textTitle?: string | undefined;
    uniquePageId?: string | undefined;
    selectedBranch?: BranchModel;

    constructor(data?: IBranchesDepartmentsUsersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchModel.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["activeUsers"])) {
                this.activeUsers = [] as any;
                for (let item of _data["activeUsers"])
                    this.activeUsers!.push(item);
            }
            this.referrerId = _data["referrerId"];
            this.textTitle = _data["textTitle"];
            this.uniquePageId = _data["uniquePageId"];
            this.selectedBranch = _data["selectedBranch"] ? BranchModel.fromJS(_data["selectedBranch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchesDepartmentsUsersModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchesDepartmentsUsersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.activeUsers)) {
            data["activeUsers"] = [];
            for (let item of this.activeUsers)
                data["activeUsers"].push(item);
        }
        data["referrerId"] = this.referrerId;
        data["textTitle"] = this.textTitle;
        data["uniquePageId"] = this.uniquePageId;
        data["selectedBranch"] = this.selectedBranch ? this.selectedBranch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchesDepartmentsUsersModel {
    branches?: BranchModel[] | undefined;
    users?: UserModel[] | undefined;
    activeUsers?: string[] | undefined;
    referrerId?: string;
    textTitle?: string | undefined;
    uniquePageId?: string | undefined;
    selectedBranch?: BranchModel;
}

export class BranchesModel implements IBranchesModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    branches?: BranchModel[] | undefined;

    constructor(data?: IBranchesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchesModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchesModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    branches?: BranchModel[] | undefined;
}

export class BranchModel implements IBranchModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    address?: string | undefined;
    branchManagerId?: string | undefined;
    branchManager?: UserModel;
    parentId?: string | undefined;
    logo?: string | undefined;
    users?: SelectListItem[] | undefined;
    branches?: SelectListItem[] | undefined;
    usersInBranch?: UserModel[] | undefined;
    fromProjects?: boolean;

    constructor(data?: IBranchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.address = _data["address"];
            this.branchManagerId = _data["branchManagerId"];
            this.branchManager = _data["branchManager"] ? UserModel.fromJS(_data["branchManager"]) : <any>undefined;
            this.parentId = _data["parentId"];
            this.logo = _data["logo"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["usersInBranch"])) {
                this.usersInBranch = [] as any;
                for (let item of _data["usersInBranch"])
                    this.usersInBranch!.push(UserModel.fromJS(item));
            }
            this.fromProjects = _data["fromProjects"];
        }
    }

    static fromJS(data: any): BranchModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["address"] = this.address;
        data["branchManagerId"] = this.branchManagerId;
        data["branchManager"] = this.branchManager ? this.branchManager.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["logo"] = this.logo;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.usersInBranch)) {
            data["usersInBranch"] = [];
            for (let item of this.usersInBranch)
                data["usersInBranch"].push(item.toJSON());
        }
        data["fromProjects"] = this.fromProjects;
        return data;
    }
}

export interface IBranchModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    address?: string | undefined;
    branchManagerId?: string | undefined;
    branchManager?: UserModel;
    parentId?: string | undefined;
    logo?: string | undefined;
    users?: SelectListItem[] | undefined;
    branches?: SelectListItem[] | undefined;
    usersInBranch?: UserModel[] | undefined;
    fromProjects?: boolean;
}

export class ByteReadOnlySpan implements IByteReadOnlySpan {
    length?: number;
    readonly isEmpty?: boolean;

    constructor(data?: IByteReadOnlySpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.length = _data["length"];
            (<any>this).isEmpty = _data["isEmpty"];
        }
    }

    static fromJS(data: any): ByteReadOnlySpan {
        data = typeof data === 'object' ? data : {};
        let result = new ByteReadOnlySpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["isEmpty"] = this.isEmpty;
        return data;
    }
}

export interface IByteReadOnlySpan {
    length?: number;
    isEmpty?: boolean;
}

export class CalcPackageAmountRequest implements ICalcPackageAmountRequest {
    start?: Date;
    end?: Date;
    activeDate?: Date;
    package?: Riders_Packages;

    constructor(data?: ICalcPackageAmountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.activeDate = _data["activeDate"] ? new Date(_data["activeDate"].toString()) : <any>undefined;
            this.package = _data["package"] ? Riders_Packages.fromJS(_data["package"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalcPackageAmountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalcPackageAmountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["package"] = this.package ? this.package.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICalcPackageAmountRequest {
    start?: Date;
    end?: Date;
    activeDate?: Date;
    package?: Riders_Packages;
}

/** 1 = Standard, 2 = VarArgs, 3 = Any, 32 = HasThis, 64 = ExplicitThis */
export enum CallingConventions {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _32 = 32,
    _64 = 64,
}

export class CallModelForUpsert implements ICallModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    callOutcome?: TreatmentOutcome;
    callOutcomes?: SelectListItem[] | undefined;
    eventDate?: Date | undefined;
    eventHour?: TimeSpan;
    hours?: SelectListItem[] | undefined;
    forTreatmentById?: string | undefined;
    forTreatmentBySelectList?: SelectListItem[] | undefined;
    agentId?: string | undefined;
    agents?: SelectListItem[] | undefined;
    belongsToId?: string | undefined;
    belongsToSelectList?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    policiesAndSuesSearchListModel?: RelationEntitiesModel;
    policyRelatedId?: string | undefined;
    policyRelated?: PolicyModel;
    sueRelatedId?: string | undefined;
    sueRelated?: SueModel;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;

    constructor(data?: ICallModelForUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.alertHour = _data["alertHour"] ? TimeSpan.fromJS(_data["alertHour"]) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.treatmentType = _data["treatmentType"];
            this.customerId = _data["customerId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(SelectListItem.fromJS(item));
            }
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectListItem.fromJS(item));
            }
            this.callOutcome = _data["callOutcome"];
            if (Array.isArray(_data["callOutcomes"])) {
                this.callOutcomes = [] as any;
                for (let item of _data["callOutcomes"])
                    this.callOutcomes!.push(SelectListItem.fromJS(item));
            }
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.eventHour = _data["eventHour"] ? TimeSpan.fromJS(_data["eventHour"]) : <any>undefined;
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
            this.forTreatmentById = _data["forTreatmentById"];
            if (Array.isArray(_data["forTreatmentBySelectList"])) {
                this.forTreatmentBySelectList = [] as any;
                for (let item of _data["forTreatmentBySelectList"])
                    this.forTreatmentBySelectList!.push(SelectListItem.fromJS(item));
            }
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.belongsToId = _data["belongsToId"];
            if (Array.isArray(_data["belongsToSelectList"])) {
                this.belongsToSelectList = [] as any;
                for (let item of _data["belongsToSelectList"])
                    this.belongsToSelectList!.push(SelectListItem.fromJS(item));
            }
            this.topic = _data["topic"];
            this.note = _data["note"];
            this.policiesAndSuesSearchListModel = _data["policiesAndSuesSearchListModel"] ? RelationEntitiesModel.fromJS(_data["policiesAndSuesSearchListModel"]) : <any>undefined;
            this.policyRelatedId = _data["policyRelatedId"];
            this.policyRelated = _data["policyRelated"] ? PolicyModel.fromJS(_data["policyRelated"]) : <any>undefined;
            this.sueRelatedId = _data["sueRelatedId"];
            this.sueRelated = _data["sueRelated"] ? SueModel.fromJS(_data["sueRelated"]) : <any>undefined;
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CallModelForUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new CallModelForUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["alertHour"] = this.alertHour ? this.alertHour.toJSON() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["treatmentType"] = this.treatmentType;
        data["customerId"] = this.customerId;
        data["priority"] = this.priority;
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item.toJSON());
        }
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["callOutcome"] = this.callOutcome;
        if (Array.isArray(this.callOutcomes)) {
            data["callOutcomes"] = [];
            for (let item of this.callOutcomes)
                data["callOutcomes"].push(item.toJSON());
        }
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["eventHour"] = this.eventHour ? this.eventHour.toJSON() : <any>undefined;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        data["forTreatmentById"] = this.forTreatmentById;
        if (Array.isArray(this.forTreatmentBySelectList)) {
            data["forTreatmentBySelectList"] = [];
            for (let item of this.forTreatmentBySelectList)
                data["forTreatmentBySelectList"].push(item.toJSON());
        }
        data["agentId"] = this.agentId;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["belongsToId"] = this.belongsToId;
        if (Array.isArray(this.belongsToSelectList)) {
            data["belongsToSelectList"] = [];
            for (let item of this.belongsToSelectList)
                data["belongsToSelectList"].push(item.toJSON());
        }
        data["topic"] = this.topic;
        data["note"] = this.note;
        data["policiesAndSuesSearchListModel"] = this.policiesAndSuesSearchListModel ? this.policiesAndSuesSearchListModel.toJSON() : <any>undefined;
        data["policyRelatedId"] = this.policyRelatedId;
        data["policyRelated"] = this.policyRelated ? this.policyRelated.toJSON() : <any>undefined;
        data["sueRelatedId"] = this.sueRelatedId;
        data["sueRelated"] = this.sueRelated ? this.sueRelated.toJSON() : <any>undefined;
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICallModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    callOutcome?: TreatmentOutcome;
    callOutcomes?: SelectListItem[] | undefined;
    eventDate?: Date | undefined;
    eventHour?: TimeSpan;
    hours?: SelectListItem[] | undefined;
    forTreatmentById?: string | undefined;
    forTreatmentBySelectList?: SelectListItem[] | undefined;
    agentId?: string | undefined;
    agents?: SelectListItem[] | undefined;
    belongsToId?: string | undefined;
    belongsToSelectList?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    policiesAndSuesSearchListModel?: RelationEntitiesModel;
    policyRelatedId?: string | undefined;
    policyRelated?: PolicyModel;
    sueRelatedId?: string | undefined;
    sueRelated?: SueModel;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
}

export class CapitalMarketInsurancePolicyModel implements ICapitalMarketInsurancePolicyModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    productType?: LifeInsuranceProductType;
    programName?: string | undefined;
    manufacturerID?: string | undefined;
    manufacturerName?: string | undefined;
    employer?: EmployerModel;
    employerId?: string | undefined;
    employerStatus?: EmployerStatusType;
    manufacturerContactFirstName?: string | undefined;
    manufacturerContactLastName?: string | undefined;
    manufacturerContactPhone?: string | undefined;
    manufacturerContactFax?: string | undefined;
    finalRecipientFactorCode?: FactorCodeType;
    finalRecipientEmployerType?: EmployerType;
    finalRecipientIdentity?: string | undefined;
    finalRecipientManufacturerId?: string | undefined;
    insuredIdentityType?: IdentityType;
    insuredIdentityNumber?: string | undefined;
    manufacturerDistributorNumber?: string | undefined;
    infoCorrectnessDate?: Date;
    joiningProductDate?: Date;
    firstJoiningProductDate?: Date;
    pensionFundType?: number;
    pensionFundStatus?: number;
    accountStatusUpdateDate?: Date;
    accountStatus?: number;
    temporaryRiskStartDate?: Date;
    temporaryRiskEndDate?: Date;
    policyType?: PolicyType;
    accountPlanType?: number;
    baseIndex?: string | undefined;
    termsLoanLinkage?: YesNo;
    fixedMoney190?: YesNo;
    shippingAddressCountry?: string | undefined;
    shippingAddressLocality?: string | undefined;
    shippingAddressLocalitySymbol?: string | undefined;
    shippingAddressStreet?: string | undefined;
    shippingAddressHousNumber?: string | undefined;
    shippingAddressApartmentEnterNumber?: string | undefined;
    shippingAddressApartmentNumber?: string | undefined;
    shippingAddressPostalCode?: string | undefined;
    shippingAddressMailbox?: string | undefined;
    insuranceTrackPensionFund?: string | undefined;
    insuranceTrackName?: string | undefined;
    imposedLien?: YesNoUnknown;
    imposedForeclosure?: YesNoUnknown;
    isLoanProduct?: boolean;
    isClaimPolicyAccount?: boolean;
    isCollectiveInsuranceCoverageForMembers?: boolean;
    isPowerOfAttorney?: boolean;
    investmentRoutes?: InvestmentRouteModel[] | undefined;
    wageCalculationCode?: number;
    polocySalary?: number;
    wagesLink?: number;
    salaryCorrectnessDate?: Date;
    unconditionalEligibility?: YesNoUnknown;
    section14?: YesNoUnknown;
    startDepositPaymentDate?: Date;
    secretionsDetailsPercent?: number;
    secretionsDetailsSum?: number;
    secretionsDetailsDate?: Date;
    employerLossWorkCapacityPercent?: number;
    employerLossWorkCapacitySum?: number;
    employerLossWorkCapacityDate?: Date;
    employerComparisonFundPercent?: number;
    employerComparisonFundSum?: number;
    employerComparisonFundDate?: Date;
    employerRewardsPercent?: number;
    employerRewardsSum?: number;
    employerRewardsDate?: Date;
    employerOthersPercent?: number;
    employerOthersSum?: number;
    employerOthersDate?: Date;
    workerRewardsPercent?: number;
    workerRewardsSum?: number;
    workerRewardsDate?: Date;
    workerLossWorkCapacityPercent?: number;
    workerLossWorkCapacitySum?: number;
    workerLossWorkCapacityDate?: Date;
    workerComparisonFundPercent?: number;
    workerComparisonFundSum?: number;
    workerComparisonFundDate?: Date;
    workerRewards47Percent?: number;
    workerRewards47Sum?: number;
    workerRewards47Date?: Date;
    workerOthersPercent?: number;
    workerOthersSum?: number;
    workerOthersDate?: Date;
    workerRewardsPrivatePercent?: number;
    workerRewardsPrivateSum?: number;
    workerRewardsPrivateDate?: Date;
    payerName?: string | undefined;
    payerIdentityType?: IdentityType;
    payerIdentity?: string | undefined;
    paymrntFrequency?: number;
    monthFrequency?: number;
    collectionDay?: number;
    paymentMethodType?: PaymentMethodType;
    attachCollectionType?: number;
    percentageSubAnnuals?: number;
    arrearsDebt?: YesNo;
    satrtArrearsDebtDate?: Date;
    arrearsDebtMonthCount?: number;
    debtType?: number;
    arrearsDebtSum?: number;
    unassociatedFunds?: YesNo;
    lastDepositDate?: Date;
    lastDepositSum?: number;
    lastDepositValueDate?: Date;
    depositType?: number;
    lastSepositCumulativeSavingsSum?: string | undefined;
    lastDepositDetailsList?: LastDepositDetailsModel[] | undefined;
    workerDepositsRewardsSum?: number;
    employerDepositsRewardsSum?: number;
    compensationDepositsSum?: number;
    beginningYearDepositDetailsList?: BeginningYearDepositDetailsModel[] | undefined;
    mobilityPullsAndRepairsList?: MobilityPullsAndRepairsModel[] | undefined;
    survivor?: SurvivorModel[] | undefined;
    retirementAge?: string | undefined;
    cumulativeSavingsAmountSum?: string | undefined;
    accumulatedSavingsAccumulation?: string | undefined;
    oldagePensionRateExpected?: string | undefined;
    retirementGuaranteedCoefficient?: string | undefined;
    cashBoxes?: CashBoxModel[] | undefined;
    managementFeeStructureList?: ManagementFeeStructureModel[] | undefined;
    managementFeeDepositRate?: string | undefined;
    managementFeeAccumulationRate?: string | undefined;
    anagementFeeOthers?: string | undefined;
    anagementFeeSum?: string | undefined;
    managementFeeDepositsum?: string | undefined;
    managementFeeAccumulationSum?: string | undefined;
    insurancePremiumsSum?: string | undefined;
    netReturnFromBeginningOfYear?: string | undefined;
    netReturnFromLastMonthSavingsA?: string | undefined;
    netReturnFromLastMonthSavingsB?: string | undefined;
    lastYearBalances?: LastYearBalanceModel[] | undefined;
    balanceDetailsList?: BalanceDetailsModel[] | undefined;
    periodBalances?: PeriodBalanceModel[] | undefined;
    variousBalances?: VariousBalanceModel[] | undefined;
    liquidityRoyaltiesList?: LiquidityRoyaltiesModel[] | undefined;
    covers?: CoverModel[] | undefined;
    provisions?: ProvisionModel[] | undefined;
    balances?: BalanceModel[] | undefined;
    policyTypes?: SelectListItem[] | undefined;
    depositStatusType?: number;
    cashTransfer?: CashTransferModel;
    cashTransferId?: string;
    incomeTaxNumber?: string | undefined;
    accountNumber?: string | undefined;
    transferType?: number;
    transferDate?: Date;
    cashTransfers?: SelectListItem[] | undefined;

    constructor(data?: ICapitalMarketInsurancePolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agentDetailsList"])) {
                this.agentDetailsList = [] as any;
                for (let item of _data["agentDetailsList"])
                    this.agentDetailsList!.push(AgentDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["salespersons"])) {
                this.salespersons = [] as any;
                for (let item of _data["salespersons"])
                    this.salespersons!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(SelectListItem.fromJS(item));
            }
            this.productType = _data["productType"];
            this.programName = _data["programName"];
            this.manufacturerID = _data["manufacturerID"];
            this.manufacturerName = _data["manufacturerName"];
            this.employer = _data["employer"] ? EmployerModel.fromJS(_data["employer"]) : <any>undefined;
            this.employerId = _data["employerId"];
            this.employerStatus = _data["employerStatus"];
            this.manufacturerContactFirstName = _data["manufacturerContactFirstName"];
            this.manufacturerContactLastName = _data["manufacturerContactLastName"];
            this.manufacturerContactPhone = _data["manufacturerContactPhone"];
            this.manufacturerContactFax = _data["manufacturerContactFax"];
            this.finalRecipientFactorCode = _data["finalRecipientFactorCode"];
            this.finalRecipientEmployerType = _data["finalRecipientEmployerType"];
            this.finalRecipientIdentity = _data["finalRecipientIdentity"];
            this.finalRecipientManufacturerId = _data["finalRecipientManufacturerId"];
            this.insuredIdentityType = _data["insuredIdentityType"];
            this.insuredIdentityNumber = _data["insuredIdentityNumber"];
            this.manufacturerDistributorNumber = _data["manufacturerDistributorNumber"];
            this.infoCorrectnessDate = _data["infoCorrectnessDate"] ? new Date(_data["infoCorrectnessDate"].toString()) : <any>undefined;
            this.joiningProductDate = _data["joiningProductDate"] ? new Date(_data["joiningProductDate"].toString()) : <any>undefined;
            this.firstJoiningProductDate = _data["firstJoiningProductDate"] ? new Date(_data["firstJoiningProductDate"].toString()) : <any>undefined;
            this.pensionFundType = _data["pensionFundType"];
            this.pensionFundStatus = _data["pensionFundStatus"];
            this.accountStatusUpdateDate = _data["accountStatusUpdateDate"] ? new Date(_data["accountStatusUpdateDate"].toString()) : <any>undefined;
            this.accountStatus = _data["accountStatus"];
            this.temporaryRiskStartDate = _data["temporaryRiskStartDate"] ? new Date(_data["temporaryRiskStartDate"].toString()) : <any>undefined;
            this.temporaryRiskEndDate = _data["temporaryRiskEndDate"] ? new Date(_data["temporaryRiskEndDate"].toString()) : <any>undefined;
            this.policyType = _data["policyType"] ? PolicyType.fromJS(_data["policyType"]) : <any>undefined;
            this.accountPlanType = _data["accountPlanType"];
            this.baseIndex = _data["baseIndex"];
            this.termsLoanLinkage = _data["termsLoanLinkage"];
            this.fixedMoney190 = _data["fixedMoney190"];
            this.shippingAddressCountry = _data["shippingAddressCountry"];
            this.shippingAddressLocality = _data["shippingAddressLocality"];
            this.shippingAddressLocalitySymbol = _data["shippingAddressLocalitySymbol"];
            this.shippingAddressStreet = _data["shippingAddressStreet"];
            this.shippingAddressHousNumber = _data["shippingAddressHousNumber"];
            this.shippingAddressApartmentEnterNumber = _data["shippingAddressApartmentEnterNumber"];
            this.shippingAddressApartmentNumber = _data["shippingAddressApartmentNumber"];
            this.shippingAddressPostalCode = _data["shippingAddressPostalCode"];
            this.shippingAddressMailbox = _data["shippingAddressMailbox"];
            this.insuranceTrackPensionFund = _data["insuranceTrackPensionFund"];
            this.insuranceTrackName = _data["insuranceTrackName"];
            this.imposedLien = _data["imposedLien"];
            this.imposedForeclosure = _data["imposedForeclosure"];
            this.isLoanProduct = _data["isLoanProduct"];
            this.isClaimPolicyAccount = _data["isClaimPolicyAccount"];
            this.isCollectiveInsuranceCoverageForMembers = _data["isCollectiveInsuranceCoverageForMembers"];
            this.isPowerOfAttorney = _data["isPowerOfAttorney"];
            if (Array.isArray(_data["investmentRoutes"])) {
                this.investmentRoutes = [] as any;
                for (let item of _data["investmentRoutes"])
                    this.investmentRoutes!.push(InvestmentRouteModel.fromJS(item));
            }
            this.wageCalculationCode = _data["wageCalculationCode"];
            this.polocySalary = _data["polocySalary"];
            this.wagesLink = _data["wagesLink"];
            this.salaryCorrectnessDate = _data["salaryCorrectnessDate"] ? new Date(_data["salaryCorrectnessDate"].toString()) : <any>undefined;
            this.unconditionalEligibility = _data["unconditionalEligibility"];
            this.section14 = _data["section14"];
            this.startDepositPaymentDate = _data["startDepositPaymentDate"] ? new Date(_data["startDepositPaymentDate"].toString()) : <any>undefined;
            this.secretionsDetailsPercent = _data["secretionsDetailsPercent"];
            this.secretionsDetailsSum = _data["secretionsDetailsSum"];
            this.secretionsDetailsDate = _data["secretionsDetailsDate"] ? new Date(_data["secretionsDetailsDate"].toString()) : <any>undefined;
            this.employerLossWorkCapacityPercent = _data["employerLossWorkCapacityPercent"];
            this.employerLossWorkCapacitySum = _data["employerLossWorkCapacitySum"];
            this.employerLossWorkCapacityDate = _data["employerLossWorkCapacityDate"] ? new Date(_data["employerLossWorkCapacityDate"].toString()) : <any>undefined;
            this.employerComparisonFundPercent = _data["employerComparisonFundPercent"];
            this.employerComparisonFundSum = _data["employerComparisonFundSum"];
            this.employerComparisonFundDate = _data["employerComparisonFundDate"] ? new Date(_data["employerComparisonFundDate"].toString()) : <any>undefined;
            this.employerRewardsPercent = _data["employerRewardsPercent"];
            this.employerRewardsSum = _data["employerRewardsSum"];
            this.employerRewardsDate = _data["employerRewardsDate"] ? new Date(_data["employerRewardsDate"].toString()) : <any>undefined;
            this.employerOthersPercent = _data["employerOthersPercent"];
            this.employerOthersSum = _data["employerOthersSum"];
            this.employerOthersDate = _data["employerOthersDate"] ? new Date(_data["employerOthersDate"].toString()) : <any>undefined;
            this.workerRewardsPercent = _data["workerRewardsPercent"];
            this.workerRewardsSum = _data["workerRewardsSum"];
            this.workerRewardsDate = _data["workerRewardsDate"] ? new Date(_data["workerRewardsDate"].toString()) : <any>undefined;
            this.workerLossWorkCapacityPercent = _data["workerLossWorkCapacityPercent"];
            this.workerLossWorkCapacitySum = _data["workerLossWorkCapacitySum"];
            this.workerLossWorkCapacityDate = _data["workerLossWorkCapacityDate"] ? new Date(_data["workerLossWorkCapacityDate"].toString()) : <any>undefined;
            this.workerComparisonFundPercent = _data["workerComparisonFundPercent"];
            this.workerComparisonFundSum = _data["workerComparisonFundSum"];
            this.workerComparisonFundDate = _data["workerComparisonFundDate"] ? new Date(_data["workerComparisonFundDate"].toString()) : <any>undefined;
            this.workerRewards47Percent = _data["workerRewards47Percent"];
            this.workerRewards47Sum = _data["workerRewards47Sum"];
            this.workerRewards47Date = _data["workerRewards47Date"] ? new Date(_data["workerRewards47Date"].toString()) : <any>undefined;
            this.workerOthersPercent = _data["workerOthersPercent"];
            this.workerOthersSum = _data["workerOthersSum"];
            this.workerOthersDate = _data["workerOthersDate"] ? new Date(_data["workerOthersDate"].toString()) : <any>undefined;
            this.workerRewardsPrivatePercent = _data["workerRewardsPrivatePercent"];
            this.workerRewardsPrivateSum = _data["workerRewardsPrivateSum"];
            this.workerRewardsPrivateDate = _data["workerRewardsPrivateDate"] ? new Date(_data["workerRewardsPrivateDate"].toString()) : <any>undefined;
            this.payerName = _data["payerName"];
            this.payerIdentityType = _data["payerIdentityType"];
            this.payerIdentity = _data["payerIdentity"];
            this.paymrntFrequency = _data["paymrntFrequency"];
            this.monthFrequency = _data["monthFrequency"];
            this.collectionDay = _data["collectionDay"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.attachCollectionType = _data["attachCollectionType"];
            this.percentageSubAnnuals = _data["percentageSubAnnuals"];
            this.arrearsDebt = _data["arrearsDebt"];
            this.satrtArrearsDebtDate = _data["satrtArrearsDebtDate"] ? new Date(_data["satrtArrearsDebtDate"].toString()) : <any>undefined;
            this.arrearsDebtMonthCount = _data["arrearsDebtMonthCount"];
            this.debtType = _data["debtType"];
            this.arrearsDebtSum = _data["arrearsDebtSum"];
            this.unassociatedFunds = _data["unassociatedFunds"];
            this.lastDepositDate = _data["lastDepositDate"] ? new Date(_data["lastDepositDate"].toString()) : <any>undefined;
            this.lastDepositSum = _data["lastDepositSum"];
            this.lastDepositValueDate = _data["lastDepositValueDate"] ? new Date(_data["lastDepositValueDate"].toString()) : <any>undefined;
            this.depositType = _data["depositType"];
            this.lastSepositCumulativeSavingsSum = _data["lastSepositCumulativeSavingsSum"];
            if (Array.isArray(_data["lastDepositDetailsList"])) {
                this.lastDepositDetailsList = [] as any;
                for (let item of _data["lastDepositDetailsList"])
                    this.lastDepositDetailsList!.push(LastDepositDetailsModel.fromJS(item));
            }
            this.workerDepositsRewardsSum = _data["workerDepositsRewardsSum"];
            this.employerDepositsRewardsSum = _data["employerDepositsRewardsSum"];
            this.compensationDepositsSum = _data["compensationDepositsSum"];
            if (Array.isArray(_data["beginningYearDepositDetailsList"])) {
                this.beginningYearDepositDetailsList = [] as any;
                for (let item of _data["beginningYearDepositDetailsList"])
                    this.beginningYearDepositDetailsList!.push(BeginningYearDepositDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["mobilityPullsAndRepairsList"])) {
                this.mobilityPullsAndRepairsList = [] as any;
                for (let item of _data["mobilityPullsAndRepairsList"])
                    this.mobilityPullsAndRepairsList!.push(MobilityPullsAndRepairsModel.fromJS(item));
            }
            if (Array.isArray(_data["survivor"])) {
                this.survivor = [] as any;
                for (let item of _data["survivor"])
                    this.survivor!.push(SurvivorModel.fromJS(item));
            }
            this.retirementAge = _data["retirementAge"];
            this.cumulativeSavingsAmountSum = _data["cumulativeSavingsAmountSum"];
            this.accumulatedSavingsAccumulation = _data["accumulatedSavingsAccumulation"];
            this.oldagePensionRateExpected = _data["oldagePensionRateExpected"];
            this.retirementGuaranteedCoefficient = _data["retirementGuaranteedCoefficient"];
            if (Array.isArray(_data["cashBoxes"])) {
                this.cashBoxes = [] as any;
                for (let item of _data["cashBoxes"])
                    this.cashBoxes!.push(CashBoxModel.fromJS(item));
            }
            if (Array.isArray(_data["managementFeeStructureList"])) {
                this.managementFeeStructureList = [] as any;
                for (let item of _data["managementFeeStructureList"])
                    this.managementFeeStructureList!.push(ManagementFeeStructureModel.fromJS(item));
            }
            this.managementFeeDepositRate = _data["managementFeeDepositRate"];
            this.managementFeeAccumulationRate = _data["managementFeeAccumulationRate"];
            this.anagementFeeOthers = _data["anagementFeeOthers"];
            this.anagementFeeSum = _data["anagementFeeSum"];
            this.managementFeeDepositsum = _data["managementFeeDepositsum"];
            this.managementFeeAccumulationSum = _data["managementFeeAccumulationSum"];
            this.insurancePremiumsSum = _data["insurancePremiumsSum"];
            this.netReturnFromBeginningOfYear = _data["netReturnFromBeginningOfYear"];
            this.netReturnFromLastMonthSavingsA = _data["netReturnFromLastMonthSavingsA"];
            this.netReturnFromLastMonthSavingsB = _data["netReturnFromLastMonthSavingsB"];
            if (Array.isArray(_data["lastYearBalances"])) {
                this.lastYearBalances = [] as any;
                for (let item of _data["lastYearBalances"])
                    this.lastYearBalances!.push(LastYearBalanceModel.fromJS(item));
            }
            if (Array.isArray(_data["balanceDetailsList"])) {
                this.balanceDetailsList = [] as any;
                for (let item of _data["balanceDetailsList"])
                    this.balanceDetailsList!.push(BalanceDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["periodBalances"])) {
                this.periodBalances = [] as any;
                for (let item of _data["periodBalances"])
                    this.periodBalances!.push(PeriodBalanceModel.fromJS(item));
            }
            if (Array.isArray(_data["variousBalances"])) {
                this.variousBalances = [] as any;
                for (let item of _data["variousBalances"])
                    this.variousBalances!.push(VariousBalanceModel.fromJS(item));
            }
            if (Array.isArray(_data["liquidityRoyaltiesList"])) {
                this.liquidityRoyaltiesList = [] as any;
                for (let item of _data["liquidityRoyaltiesList"])
                    this.liquidityRoyaltiesList!.push(LiquidityRoyaltiesModel.fromJS(item));
            }
            if (Array.isArray(_data["covers"])) {
                this.covers = [] as any;
                for (let item of _data["covers"])
                    this.covers!.push(CoverModel.fromJS(item));
            }
            if (Array.isArray(_data["provisions"])) {
                this.provisions = [] as any;
                for (let item of _data["provisions"])
                    this.provisions!.push(ProvisionModel.fromJS(item));
            }
            if (Array.isArray(_data["balances"])) {
                this.balances = [] as any;
                for (let item of _data["balances"])
                    this.balances!.push(BalanceModel.fromJS(item));
            }
            if (Array.isArray(_data["policyTypes"])) {
                this.policyTypes = [] as any;
                for (let item of _data["policyTypes"])
                    this.policyTypes!.push(SelectListItem.fromJS(item));
            }
            this.depositStatusType = _data["depositStatusType"];
            this.cashTransfer = _data["cashTransfer"] ? CashTransferModel.fromJS(_data["cashTransfer"]) : <any>undefined;
            this.cashTransferId = _data["cashTransferId"];
            this.incomeTaxNumber = _data["incomeTaxNumber"];
            this.accountNumber = _data["accountNumber"];
            this.transferType = _data["transferType"];
            this.transferDate = _data["transferDate"] ? new Date(_data["transferDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["cashTransfers"])) {
                this.cashTransfers = [] as any;
                for (let item of _data["cashTransfers"])
                    this.cashTransfers!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CapitalMarketInsurancePolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CapitalMarketInsurancePolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.agentDetailsList)) {
            data["agentDetailsList"] = [];
            for (let item of this.agentDetailsList)
                data["agentDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.salespersons)) {
            data["salespersons"] = [];
            for (let item of this.salespersons)
                data["salespersons"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        data["productType"] = this.productType;
        data["programName"] = this.programName;
        data["manufacturerID"] = this.manufacturerID;
        data["manufacturerName"] = this.manufacturerName;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["employerId"] = this.employerId;
        data["employerStatus"] = this.employerStatus;
        data["manufacturerContactFirstName"] = this.manufacturerContactFirstName;
        data["manufacturerContactLastName"] = this.manufacturerContactLastName;
        data["manufacturerContactPhone"] = this.manufacturerContactPhone;
        data["manufacturerContactFax"] = this.manufacturerContactFax;
        data["finalRecipientFactorCode"] = this.finalRecipientFactorCode;
        data["finalRecipientEmployerType"] = this.finalRecipientEmployerType;
        data["finalRecipientIdentity"] = this.finalRecipientIdentity;
        data["finalRecipientManufacturerId"] = this.finalRecipientManufacturerId;
        data["insuredIdentityType"] = this.insuredIdentityType;
        data["insuredIdentityNumber"] = this.insuredIdentityNumber;
        data["manufacturerDistributorNumber"] = this.manufacturerDistributorNumber;
        data["infoCorrectnessDate"] = this.infoCorrectnessDate ? this.infoCorrectnessDate.toISOString() : <any>undefined;
        data["joiningProductDate"] = this.joiningProductDate ? this.joiningProductDate.toISOString() : <any>undefined;
        data["firstJoiningProductDate"] = this.firstJoiningProductDate ? this.firstJoiningProductDate.toISOString() : <any>undefined;
        data["pensionFundType"] = this.pensionFundType;
        data["pensionFundStatus"] = this.pensionFundStatus;
        data["accountStatusUpdateDate"] = this.accountStatusUpdateDate ? this.accountStatusUpdateDate.toISOString() : <any>undefined;
        data["accountStatus"] = this.accountStatus;
        data["temporaryRiskStartDate"] = this.temporaryRiskStartDate ? this.temporaryRiskStartDate.toISOString() : <any>undefined;
        data["temporaryRiskEndDate"] = this.temporaryRiskEndDate ? this.temporaryRiskEndDate.toISOString() : <any>undefined;
        data["policyType"] = this.policyType ? this.policyType.toJSON() : <any>undefined;
        data["accountPlanType"] = this.accountPlanType;
        data["baseIndex"] = this.baseIndex;
        data["termsLoanLinkage"] = this.termsLoanLinkage;
        data["fixedMoney190"] = this.fixedMoney190;
        data["shippingAddressCountry"] = this.shippingAddressCountry;
        data["shippingAddressLocality"] = this.shippingAddressLocality;
        data["shippingAddressLocalitySymbol"] = this.shippingAddressLocalitySymbol;
        data["shippingAddressStreet"] = this.shippingAddressStreet;
        data["shippingAddressHousNumber"] = this.shippingAddressHousNumber;
        data["shippingAddressApartmentEnterNumber"] = this.shippingAddressApartmentEnterNumber;
        data["shippingAddressApartmentNumber"] = this.shippingAddressApartmentNumber;
        data["shippingAddressPostalCode"] = this.shippingAddressPostalCode;
        data["shippingAddressMailbox"] = this.shippingAddressMailbox;
        data["insuranceTrackPensionFund"] = this.insuranceTrackPensionFund;
        data["insuranceTrackName"] = this.insuranceTrackName;
        data["imposedLien"] = this.imposedLien;
        data["imposedForeclosure"] = this.imposedForeclosure;
        data["isLoanProduct"] = this.isLoanProduct;
        data["isClaimPolicyAccount"] = this.isClaimPolicyAccount;
        data["isCollectiveInsuranceCoverageForMembers"] = this.isCollectiveInsuranceCoverageForMembers;
        data["isPowerOfAttorney"] = this.isPowerOfAttorney;
        if (Array.isArray(this.investmentRoutes)) {
            data["investmentRoutes"] = [];
            for (let item of this.investmentRoutes)
                data["investmentRoutes"].push(item.toJSON());
        }
        data["wageCalculationCode"] = this.wageCalculationCode;
        data["polocySalary"] = this.polocySalary;
        data["wagesLink"] = this.wagesLink;
        data["salaryCorrectnessDate"] = this.salaryCorrectnessDate ? this.salaryCorrectnessDate.toISOString() : <any>undefined;
        data["unconditionalEligibility"] = this.unconditionalEligibility;
        data["section14"] = this.section14;
        data["startDepositPaymentDate"] = this.startDepositPaymentDate ? this.startDepositPaymentDate.toISOString() : <any>undefined;
        data["secretionsDetailsPercent"] = this.secretionsDetailsPercent;
        data["secretionsDetailsSum"] = this.secretionsDetailsSum;
        data["secretionsDetailsDate"] = this.secretionsDetailsDate ? this.secretionsDetailsDate.toISOString() : <any>undefined;
        data["employerLossWorkCapacityPercent"] = this.employerLossWorkCapacityPercent;
        data["employerLossWorkCapacitySum"] = this.employerLossWorkCapacitySum;
        data["employerLossWorkCapacityDate"] = this.employerLossWorkCapacityDate ? this.employerLossWorkCapacityDate.toISOString() : <any>undefined;
        data["employerComparisonFundPercent"] = this.employerComparisonFundPercent;
        data["employerComparisonFundSum"] = this.employerComparisonFundSum;
        data["employerComparisonFundDate"] = this.employerComparisonFundDate ? this.employerComparisonFundDate.toISOString() : <any>undefined;
        data["employerRewardsPercent"] = this.employerRewardsPercent;
        data["employerRewardsSum"] = this.employerRewardsSum;
        data["employerRewardsDate"] = this.employerRewardsDate ? this.employerRewardsDate.toISOString() : <any>undefined;
        data["employerOthersPercent"] = this.employerOthersPercent;
        data["employerOthersSum"] = this.employerOthersSum;
        data["employerOthersDate"] = this.employerOthersDate ? this.employerOthersDate.toISOString() : <any>undefined;
        data["workerRewardsPercent"] = this.workerRewardsPercent;
        data["workerRewardsSum"] = this.workerRewardsSum;
        data["workerRewardsDate"] = this.workerRewardsDate ? this.workerRewardsDate.toISOString() : <any>undefined;
        data["workerLossWorkCapacityPercent"] = this.workerLossWorkCapacityPercent;
        data["workerLossWorkCapacitySum"] = this.workerLossWorkCapacitySum;
        data["workerLossWorkCapacityDate"] = this.workerLossWorkCapacityDate ? this.workerLossWorkCapacityDate.toISOString() : <any>undefined;
        data["workerComparisonFundPercent"] = this.workerComparisonFundPercent;
        data["workerComparisonFundSum"] = this.workerComparisonFundSum;
        data["workerComparisonFundDate"] = this.workerComparisonFundDate ? this.workerComparisonFundDate.toISOString() : <any>undefined;
        data["workerRewards47Percent"] = this.workerRewards47Percent;
        data["workerRewards47Sum"] = this.workerRewards47Sum;
        data["workerRewards47Date"] = this.workerRewards47Date ? this.workerRewards47Date.toISOString() : <any>undefined;
        data["workerOthersPercent"] = this.workerOthersPercent;
        data["workerOthersSum"] = this.workerOthersSum;
        data["workerOthersDate"] = this.workerOthersDate ? this.workerOthersDate.toISOString() : <any>undefined;
        data["workerRewardsPrivatePercent"] = this.workerRewardsPrivatePercent;
        data["workerRewardsPrivateSum"] = this.workerRewardsPrivateSum;
        data["workerRewardsPrivateDate"] = this.workerRewardsPrivateDate ? this.workerRewardsPrivateDate.toISOString() : <any>undefined;
        data["payerName"] = this.payerName;
        data["payerIdentityType"] = this.payerIdentityType;
        data["payerIdentity"] = this.payerIdentity;
        data["paymrntFrequency"] = this.paymrntFrequency;
        data["monthFrequency"] = this.monthFrequency;
        data["collectionDay"] = this.collectionDay;
        data["paymentMethodType"] = this.paymentMethodType;
        data["attachCollectionType"] = this.attachCollectionType;
        data["percentageSubAnnuals"] = this.percentageSubAnnuals;
        data["arrearsDebt"] = this.arrearsDebt;
        data["satrtArrearsDebtDate"] = this.satrtArrearsDebtDate ? this.satrtArrearsDebtDate.toISOString() : <any>undefined;
        data["arrearsDebtMonthCount"] = this.arrearsDebtMonthCount;
        data["debtType"] = this.debtType;
        data["arrearsDebtSum"] = this.arrearsDebtSum;
        data["unassociatedFunds"] = this.unassociatedFunds;
        data["lastDepositDate"] = this.lastDepositDate ? this.lastDepositDate.toISOString() : <any>undefined;
        data["lastDepositSum"] = this.lastDepositSum;
        data["lastDepositValueDate"] = this.lastDepositValueDate ? this.lastDepositValueDate.toISOString() : <any>undefined;
        data["depositType"] = this.depositType;
        data["lastSepositCumulativeSavingsSum"] = this.lastSepositCumulativeSavingsSum;
        if (Array.isArray(this.lastDepositDetailsList)) {
            data["lastDepositDetailsList"] = [];
            for (let item of this.lastDepositDetailsList)
                data["lastDepositDetailsList"].push(item.toJSON());
        }
        data["workerDepositsRewardsSum"] = this.workerDepositsRewardsSum;
        data["employerDepositsRewardsSum"] = this.employerDepositsRewardsSum;
        data["compensationDepositsSum"] = this.compensationDepositsSum;
        if (Array.isArray(this.beginningYearDepositDetailsList)) {
            data["beginningYearDepositDetailsList"] = [];
            for (let item of this.beginningYearDepositDetailsList)
                data["beginningYearDepositDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.mobilityPullsAndRepairsList)) {
            data["mobilityPullsAndRepairsList"] = [];
            for (let item of this.mobilityPullsAndRepairsList)
                data["mobilityPullsAndRepairsList"].push(item.toJSON());
        }
        if (Array.isArray(this.survivor)) {
            data["survivor"] = [];
            for (let item of this.survivor)
                data["survivor"].push(item.toJSON());
        }
        data["retirementAge"] = this.retirementAge;
        data["cumulativeSavingsAmountSum"] = this.cumulativeSavingsAmountSum;
        data["accumulatedSavingsAccumulation"] = this.accumulatedSavingsAccumulation;
        data["oldagePensionRateExpected"] = this.oldagePensionRateExpected;
        data["retirementGuaranteedCoefficient"] = this.retirementGuaranteedCoefficient;
        if (Array.isArray(this.cashBoxes)) {
            data["cashBoxes"] = [];
            for (let item of this.cashBoxes)
                data["cashBoxes"].push(item.toJSON());
        }
        if (Array.isArray(this.managementFeeStructureList)) {
            data["managementFeeStructureList"] = [];
            for (let item of this.managementFeeStructureList)
                data["managementFeeStructureList"].push(item.toJSON());
        }
        data["managementFeeDepositRate"] = this.managementFeeDepositRate;
        data["managementFeeAccumulationRate"] = this.managementFeeAccumulationRate;
        data["anagementFeeOthers"] = this.anagementFeeOthers;
        data["anagementFeeSum"] = this.anagementFeeSum;
        data["managementFeeDepositsum"] = this.managementFeeDepositsum;
        data["managementFeeAccumulationSum"] = this.managementFeeAccumulationSum;
        data["insurancePremiumsSum"] = this.insurancePremiumsSum;
        data["netReturnFromBeginningOfYear"] = this.netReturnFromBeginningOfYear;
        data["netReturnFromLastMonthSavingsA"] = this.netReturnFromLastMonthSavingsA;
        data["netReturnFromLastMonthSavingsB"] = this.netReturnFromLastMonthSavingsB;
        if (Array.isArray(this.lastYearBalances)) {
            data["lastYearBalances"] = [];
            for (let item of this.lastYearBalances)
                data["lastYearBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.balanceDetailsList)) {
            data["balanceDetailsList"] = [];
            for (let item of this.balanceDetailsList)
                data["balanceDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.periodBalances)) {
            data["periodBalances"] = [];
            for (let item of this.periodBalances)
                data["periodBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.variousBalances)) {
            data["variousBalances"] = [];
            for (let item of this.variousBalances)
                data["variousBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.liquidityRoyaltiesList)) {
            data["liquidityRoyaltiesList"] = [];
            for (let item of this.liquidityRoyaltiesList)
                data["liquidityRoyaltiesList"].push(item.toJSON());
        }
        if (Array.isArray(this.covers)) {
            data["covers"] = [];
            for (let item of this.covers)
                data["covers"].push(item.toJSON());
        }
        if (Array.isArray(this.provisions)) {
            data["provisions"] = [];
            for (let item of this.provisions)
                data["provisions"].push(item.toJSON());
        }
        if (Array.isArray(this.balances)) {
            data["balances"] = [];
            for (let item of this.balances)
                data["balances"].push(item.toJSON());
        }
        if (Array.isArray(this.policyTypes)) {
            data["policyTypes"] = [];
            for (let item of this.policyTypes)
                data["policyTypes"].push(item.toJSON());
        }
        data["depositStatusType"] = this.depositStatusType;
        data["cashTransfer"] = this.cashTransfer ? this.cashTransfer.toJSON() : <any>undefined;
        data["cashTransferId"] = this.cashTransferId;
        data["incomeTaxNumber"] = this.incomeTaxNumber;
        data["accountNumber"] = this.accountNumber;
        data["transferType"] = this.transferType;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        if (Array.isArray(this.cashTransfers)) {
            data["cashTransfers"] = [];
            for (let item of this.cashTransfers)
                data["cashTransfers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICapitalMarketInsurancePolicyModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    productType?: LifeInsuranceProductType;
    programName?: string | undefined;
    manufacturerID?: string | undefined;
    manufacturerName?: string | undefined;
    employer?: EmployerModel;
    employerId?: string | undefined;
    employerStatus?: EmployerStatusType;
    manufacturerContactFirstName?: string | undefined;
    manufacturerContactLastName?: string | undefined;
    manufacturerContactPhone?: string | undefined;
    manufacturerContactFax?: string | undefined;
    finalRecipientFactorCode?: FactorCodeType;
    finalRecipientEmployerType?: EmployerType;
    finalRecipientIdentity?: string | undefined;
    finalRecipientManufacturerId?: string | undefined;
    insuredIdentityType?: IdentityType;
    insuredIdentityNumber?: string | undefined;
    manufacturerDistributorNumber?: string | undefined;
    infoCorrectnessDate?: Date;
    joiningProductDate?: Date;
    firstJoiningProductDate?: Date;
    pensionFundType?: number;
    pensionFundStatus?: number;
    accountStatusUpdateDate?: Date;
    accountStatus?: number;
    temporaryRiskStartDate?: Date;
    temporaryRiskEndDate?: Date;
    policyType?: PolicyType;
    accountPlanType?: number;
    baseIndex?: string | undefined;
    termsLoanLinkage?: YesNo;
    fixedMoney190?: YesNo;
    shippingAddressCountry?: string | undefined;
    shippingAddressLocality?: string | undefined;
    shippingAddressLocalitySymbol?: string | undefined;
    shippingAddressStreet?: string | undefined;
    shippingAddressHousNumber?: string | undefined;
    shippingAddressApartmentEnterNumber?: string | undefined;
    shippingAddressApartmentNumber?: string | undefined;
    shippingAddressPostalCode?: string | undefined;
    shippingAddressMailbox?: string | undefined;
    insuranceTrackPensionFund?: string | undefined;
    insuranceTrackName?: string | undefined;
    imposedLien?: YesNoUnknown;
    imposedForeclosure?: YesNoUnknown;
    isLoanProduct?: boolean;
    isClaimPolicyAccount?: boolean;
    isCollectiveInsuranceCoverageForMembers?: boolean;
    isPowerOfAttorney?: boolean;
    investmentRoutes?: InvestmentRouteModel[] | undefined;
    wageCalculationCode?: number;
    polocySalary?: number;
    wagesLink?: number;
    salaryCorrectnessDate?: Date;
    unconditionalEligibility?: YesNoUnknown;
    section14?: YesNoUnknown;
    startDepositPaymentDate?: Date;
    secretionsDetailsPercent?: number;
    secretionsDetailsSum?: number;
    secretionsDetailsDate?: Date;
    employerLossWorkCapacityPercent?: number;
    employerLossWorkCapacitySum?: number;
    employerLossWorkCapacityDate?: Date;
    employerComparisonFundPercent?: number;
    employerComparisonFundSum?: number;
    employerComparisonFundDate?: Date;
    employerRewardsPercent?: number;
    employerRewardsSum?: number;
    employerRewardsDate?: Date;
    employerOthersPercent?: number;
    employerOthersSum?: number;
    employerOthersDate?: Date;
    workerRewardsPercent?: number;
    workerRewardsSum?: number;
    workerRewardsDate?: Date;
    workerLossWorkCapacityPercent?: number;
    workerLossWorkCapacitySum?: number;
    workerLossWorkCapacityDate?: Date;
    workerComparisonFundPercent?: number;
    workerComparisonFundSum?: number;
    workerComparisonFundDate?: Date;
    workerRewards47Percent?: number;
    workerRewards47Sum?: number;
    workerRewards47Date?: Date;
    workerOthersPercent?: number;
    workerOthersSum?: number;
    workerOthersDate?: Date;
    workerRewardsPrivatePercent?: number;
    workerRewardsPrivateSum?: number;
    workerRewardsPrivateDate?: Date;
    payerName?: string | undefined;
    payerIdentityType?: IdentityType;
    payerIdentity?: string | undefined;
    paymrntFrequency?: number;
    monthFrequency?: number;
    collectionDay?: number;
    paymentMethodType?: PaymentMethodType;
    attachCollectionType?: number;
    percentageSubAnnuals?: number;
    arrearsDebt?: YesNo;
    satrtArrearsDebtDate?: Date;
    arrearsDebtMonthCount?: number;
    debtType?: number;
    arrearsDebtSum?: number;
    unassociatedFunds?: YesNo;
    lastDepositDate?: Date;
    lastDepositSum?: number;
    lastDepositValueDate?: Date;
    depositType?: number;
    lastSepositCumulativeSavingsSum?: string | undefined;
    lastDepositDetailsList?: LastDepositDetailsModel[] | undefined;
    workerDepositsRewardsSum?: number;
    employerDepositsRewardsSum?: number;
    compensationDepositsSum?: number;
    beginningYearDepositDetailsList?: BeginningYearDepositDetailsModel[] | undefined;
    mobilityPullsAndRepairsList?: MobilityPullsAndRepairsModel[] | undefined;
    survivor?: SurvivorModel[] | undefined;
    retirementAge?: string | undefined;
    cumulativeSavingsAmountSum?: string | undefined;
    accumulatedSavingsAccumulation?: string | undefined;
    oldagePensionRateExpected?: string | undefined;
    retirementGuaranteedCoefficient?: string | undefined;
    cashBoxes?: CashBoxModel[] | undefined;
    managementFeeStructureList?: ManagementFeeStructureModel[] | undefined;
    managementFeeDepositRate?: string | undefined;
    managementFeeAccumulationRate?: string | undefined;
    anagementFeeOthers?: string | undefined;
    anagementFeeSum?: string | undefined;
    managementFeeDepositsum?: string | undefined;
    managementFeeAccumulationSum?: string | undefined;
    insurancePremiumsSum?: string | undefined;
    netReturnFromBeginningOfYear?: string | undefined;
    netReturnFromLastMonthSavingsA?: string | undefined;
    netReturnFromLastMonthSavingsB?: string | undefined;
    lastYearBalances?: LastYearBalanceModel[] | undefined;
    balanceDetailsList?: BalanceDetailsModel[] | undefined;
    periodBalances?: PeriodBalanceModel[] | undefined;
    variousBalances?: VariousBalanceModel[] | undefined;
    liquidityRoyaltiesList?: LiquidityRoyaltiesModel[] | undefined;
    covers?: CoverModel[] | undefined;
    provisions?: ProvisionModel[] | undefined;
    balances?: BalanceModel[] | undefined;
    policyTypes?: SelectListItem[] | undefined;
    depositStatusType?: number;
    cashTransfer?: CashTransferModel;
    cashTransferId?: string;
    incomeTaxNumber?: string | undefined;
    accountNumber?: string | undefined;
    transferType?: number;
    transferDate?: Date;
    cashTransfers?: SelectListItem[] | undefined;
}

export class CashBoxModel implements ICashBoxModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    cashBoxType?: number;
    oldagePensionSum?: number;
    oldagePensionExpectedSum?: number;
    forecastReturnPercentage?: string | undefined;
    retirementAgeBalanceExpectedSum?: number;
    capitalExpectedAccumulationSavings?: number;
    retirementAgeCumulativeAmountWithFuturepremiums?: number;
    retirementAgeCumulativeAmountWithoutFuturepremiums?: number;

    constructor(data?: ICashBoxModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.cashBoxType = _data["cashBoxType"];
            this.oldagePensionSum = _data["oldagePensionSum"];
            this.oldagePensionExpectedSum = _data["oldagePensionExpectedSum"];
            this.forecastReturnPercentage = _data["forecastReturnPercentage"];
            this.retirementAgeBalanceExpectedSum = _data["retirementAgeBalanceExpectedSum"];
            this.capitalExpectedAccumulationSavings = _data["capitalExpectedAccumulationSavings"];
            this.retirementAgeCumulativeAmountWithFuturepremiums = _data["retirementAgeCumulativeAmountWithFuturepremiums"];
            this.retirementAgeCumulativeAmountWithoutFuturepremiums = _data["retirementAgeCumulativeAmountWithoutFuturepremiums"];
        }
    }

    static fromJS(data: any): CashBoxModel {
        data = typeof data === 'object' ? data : {};
        let result = new CashBoxModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["cashBoxType"] = this.cashBoxType;
        data["oldagePensionSum"] = this.oldagePensionSum;
        data["oldagePensionExpectedSum"] = this.oldagePensionExpectedSum;
        data["forecastReturnPercentage"] = this.forecastReturnPercentage;
        data["retirementAgeBalanceExpectedSum"] = this.retirementAgeBalanceExpectedSum;
        data["capitalExpectedAccumulationSavings"] = this.capitalExpectedAccumulationSavings;
        data["retirementAgeCumulativeAmountWithFuturepremiums"] = this.retirementAgeCumulativeAmountWithFuturepremiums;
        data["retirementAgeCumulativeAmountWithoutFuturepremiums"] = this.retirementAgeCumulativeAmountWithoutFuturepremiums;
        return data;
    }
}

export interface ICashBoxModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    cashBoxType?: number;
    oldagePensionSum?: number;
    oldagePensionExpectedSum?: number;
    forecastReturnPercentage?: string | undefined;
    retirementAgeBalanceExpectedSum?: number;
    capitalExpectedAccumulationSavings?: number;
    retirementAgeCumulativeAmountWithFuturepremiums?: number;
    retirementAgeCumulativeAmountWithoutFuturepremiums?: number;
}

export class CashTransferModel implements ICashTransferModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: ICashTransferModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CashTransferModel {
        data = typeof data === 'object' ? data : {};
        let result = new CashTransferModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICashTransferModel {
    id?: string;
    name?: string | undefined;
}

export class CheckPhoneForDoubleForPCStationRequest implements ICheckPhoneForDoubleForPCStationRequest {
    phone?: string | undefined;

    constructor(data?: ICheckPhoneForDoubleForPCStationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CheckPhoneForDoubleForPCStationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPhoneForDoubleForPCStationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICheckPhoneForDoubleForPCStationRequest {
    phone?: string | undefined;
}

/** 0 = None, 24576 = Null, 26113 = Des, 26114 = Rc2, 26115 = TripleDes, 26126 = Aes128, 26127 = Aes192, 26128 = Aes256, 26129 = Aes, 26625 = Rc4 */
export enum CipherAlgorithmType {
    _0 = 0,
    _24576 = 24576,
    _26113 = 26113,
    _26114 = 26114,
    _26115 = 26115,
    _26126 = 26126,
    _26127 = 26127,
    _26128 = 26128,
    _26129 = 26129,
    _26625 = 26625,
}

/** 1 = Regular, 2 = OngoingBondage, 3 = Concentrated, 4 = InSociety, 5 = Credit */
export enum CollectionMethodType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** 0 = Cash, 1 = Payments, 2 = Credit */
export enum CollectionRouteType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CommonCustomerFilterModel implements ICommonCustomerFilterModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    page?: number;
    customerId?: string;

    constructor(data?: ICommonCustomerFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.page = _data["page"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): CommonCustomerFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommonCustomerFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface ICommonCustomerFilterModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    page?: number;
    customerId?: string;
}

export class CommonFilterModel implements ICommonFilterModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    page?: number | undefined;

    constructor(data?: ICommonFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): CommonFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommonFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["page"] = this.page;
        return data;
    }
}

export interface ICommonFilterModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    page?: number | undefined;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    memberType?: MemberTypes;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        return data;
    }
}

export interface IConstructorInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
}

export class ContentDisposition implements IContentDisposition {
    disposition?: string | undefined;
    isAttachment?: boolean;
    readonly parameters?: Parameter[] | undefined;
    fileName?: string | undefined;
    creationDate?: Date | undefined;
    modificationDate?: Date | undefined;
    readDate?: Date | undefined;
    size?: number | undefined;

    constructor(data?: IContentDisposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disposition = _data["disposition"];
            this.isAttachment = _data["isAttachment"];
            if (Array.isArray(_data["parameters"])) {
                (<any>this).parameters = [] as any;
                for (let item of _data["parameters"])
                    (<any>this).parameters!.push(Parameter.fromJS(item));
            }
            this.fileName = _data["fileName"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>undefined;
            this.readDate = _data["readDate"] ? new Date(_data["readDate"].toString()) : <any>undefined;
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): ContentDisposition {
        data = typeof data === 'object' ? data : {};
        let result = new ContentDisposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disposition"] = this.disposition;
        data["isAttachment"] = this.isAttachment;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["fileName"] = this.fileName;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        data["readDate"] = this.readDate ? this.readDate.toISOString() : <any>undefined;
        data["size"] = this.size;
        return data;
    }
}

export interface IContentDisposition {
    disposition?: string | undefined;
    isAttachment?: boolean;
    parameters?: Parameter[] | undefined;
    fileName?: string | undefined;
    creationDate?: Date | undefined;
    modificationDate?: Date | undefined;
    readDate?: Date | undefined;
    size?: number | undefined;
}

export class ContentType implements IContentType {
    mediaType?: string | undefined;
    mediaSubtype?: string | undefined;
    readonly parameters?: Parameter[] | undefined;
    boundary?: string | undefined;
    charset?: string | undefined;
    charsetEncoding?: Encoding;
    format?: string | undefined;
    readonly mimeType?: string | undefined;
    name?: string | undefined;

    constructor(data?: IContentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaType = _data["mediaType"];
            this.mediaSubtype = _data["mediaSubtype"];
            if (Array.isArray(_data["parameters"])) {
                (<any>this).parameters = [] as any;
                for (let item of _data["parameters"])
                    (<any>this).parameters!.push(Parameter.fromJS(item));
            }
            this.boundary = _data["boundary"];
            this.charset = _data["charset"];
            this.charsetEncoding = _data["charsetEncoding"] ? Encoding.fromJS(_data["charsetEncoding"]) : <any>undefined;
            this.format = _data["format"];
            (<any>this).mimeType = _data["mimeType"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContentType {
        data = typeof data === 'object' ? data : {};
        let result = new ContentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaType"] = this.mediaType;
        data["mediaSubtype"] = this.mediaSubtype;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["boundary"] = this.boundary;
        data["charset"] = this.charset;
        data["charsetEncoding"] = this.charsetEncoding ? this.charsetEncoding.toJSON() : <any>undefined;
        data["format"] = this.format;
        data["mimeType"] = this.mimeType;
        data["name"] = this.name;
        return data;
    }
}

export interface IContentType {
    mediaType?: string | undefined;
    mediaSubtype?: string | undefined;
    parameters?: Parameter[] | undefined;
    boundary?: string | undefined;
    charset?: string | undefined;
    charsetEncoding?: Encoding;
    format?: string | undefined;
    mimeType?: string | undefined;
    name?: string | undefined;
}

/** 0 = UpTo10PercentOfContent, 1 = Over10PercentOfContent, 2 = Over20PercentOfContent */
export enum CoveragePercentageType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CoverModel implements ICoverModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    number?: string | undefined;
    name?: string | undefined;
    againstPolicyAccountNumber?: string | undefined;
    identityType?: IdentityType;
    identity?: string | undefined;
    insuredMame?: string | undefined;
    insurancePremiumsToPay?: string | undefined;
    linkageType?: number;
    routType?: number;
    includesCumulativeSavingsInPolicy?: boolean | undefined;
    valueInsuranceAmountRouteRequestedInsuranceAmount?: string | undefined;
    valueMultipleSalariesDoubleSalaryTrackType?: string | undefined;
    valueAllocationPercentageSavings?: string | undefined;
    roofCeilingSealedInDeath?: string | undefined;
    roofCeilingLossWorkCapacity?: string | undefined;
    insuranceAmountInDeath?: string | undefined;
    insuredType?: number;
    insuranceCoverType?: number;
    acaIncludesFrancis?: boolean | undefined;
    coverStartDate?: Date;
    coverEndDate?: Date;
    terminationPaymentDate?: Date;
    percentageBasicInsuranceAmount?: string | undefined;
    percentageDoublePay?: string | undefined;
    payInsuranceAmount?: number;
    insuranceSum?: string | undefined;
    coverPayer?: number;
    smokingCode?: YesNoUnknown;
    insuredUnderwriting?: YesNoUnknown;
    underwritingDate?: Date;
    exception?: YesNoUnknown;
    exceptionType?: number;
    qualifyingPeriodInMonths?: string | undefined;
    waitingPeriodInMonths?: string | undefined;
    discountOnInsurancePremiums?: YesNoUnknown;
    conditionForADiscountOnInsurancePremiums?: YesNoUnknown;
    frequencyOfChangeInInsurancePremiumsOverTheYears?: string | undefined;
    dateOfNextUpdateOfInsurancePremiums?: Date;
    costOfDisabilityCoverage?: string | undefined;
    theCostOfCoveringASurvivorsPensionForADisabledPerson?: string | undefined;
    disabilityCoverageRateInTheInsuranceTrack?: string | undefined;
    determiningWagesToCoverDisabilityAndSurvivors?: string | undefined;
    theCorrectnessDateOfTheSalaryDeterminesToCoverDisabilityAndSurvivors?: Date;
    totalDisabilityPension?: string | undefined;
    disabilityDevelops?: boolean | undefined;
    waiverOfDisabilityInsuranceCoverage?: YesNoIrrelevant;
    cosOfCoveringResidues?: string | undefined;
    insuranceCoverageRateForAnOrphanOfAnActiveMemberInTheInsuranceTrack?: string | undefined;
    survivorsPensionForAnActiveFellowWidowerAccordingToAnInsuranceTrack?: string | undefined;
    survivorsPensionForTheOrphanOfSnSctiveMemberAccordingToTheInsuranceTrack?: string | undefined;
    survivorsPensionForASupportedParentOfAnActiveColleagueAccordingToAnInsuranceTrack?: string | undefined;
    insuranceCoverageRateForAFellowWidowerActiveInTheInsuranceTrack?: string | undefined;
    insuranceCoverageRateForASupportedParentOfAnActiveColleague?: string | undefined;
    retirementAgeForOldAgePensionByInsuranceTrack?: string | undefined;
    totalPensionOfAFellowInactiveWidower?: string | undefined;
    severalConsecutiveMonthsOfMembershipInThePensionFund?: string | undefined;
    accumulatedPensionPortion?: string | undefined;
    percentageOfAccruedPension?: string | undefined;
    membershipStartDate?: Date;
    dataValueDate?: Date;
    insuranceBenefit?: YesNoUnknown;

    constructor(data?: ICoverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.againstPolicyAccountNumber = _data["againstPolicyAccountNumber"];
            this.identityType = _data["identityType"];
            this.identity = _data["identity"];
            this.insuredMame = _data["insuredMame"];
            this.insurancePremiumsToPay = _data["insurancePremiumsToPay"];
            this.linkageType = _data["linkageType"];
            this.routType = _data["routType"];
            this.includesCumulativeSavingsInPolicy = _data["includesCumulativeSavingsInPolicy"];
            this.valueInsuranceAmountRouteRequestedInsuranceAmount = _data["valueInsuranceAmountRouteRequestedInsuranceAmount"];
            this.valueMultipleSalariesDoubleSalaryTrackType = _data["valueMultipleSalariesDoubleSalaryTrackType"];
            this.valueAllocationPercentageSavings = _data["valueAllocationPercentageSavings"];
            this.roofCeilingSealedInDeath = _data["roofCeilingSealedInDeath"];
            this.roofCeilingLossWorkCapacity = _data["roofCeilingLossWorkCapacity"];
            this.insuranceAmountInDeath = _data["insuranceAmountInDeath"];
            this.insuredType = _data["insuredType"];
            this.insuranceCoverType = _data["insuranceCoverType"];
            this.acaIncludesFrancis = _data["acaIncludesFrancis"];
            this.coverStartDate = _data["coverStartDate"] ? new Date(_data["coverStartDate"].toString()) : <any>undefined;
            this.coverEndDate = _data["coverEndDate"] ? new Date(_data["coverEndDate"].toString()) : <any>undefined;
            this.terminationPaymentDate = _data["terminationPaymentDate"] ? new Date(_data["terminationPaymentDate"].toString()) : <any>undefined;
            this.percentageBasicInsuranceAmount = _data["percentageBasicInsuranceAmount"];
            this.percentageDoublePay = _data["percentageDoublePay"];
            this.payInsuranceAmount = _data["payInsuranceAmount"];
            this.insuranceSum = _data["insuranceSum"];
            this.coverPayer = _data["coverPayer"];
            this.smokingCode = _data["smokingCode"];
            this.insuredUnderwriting = _data["insuredUnderwriting"];
            this.underwritingDate = _data["underwritingDate"] ? new Date(_data["underwritingDate"].toString()) : <any>undefined;
            this.exception = _data["exception"];
            this.exceptionType = _data["exceptionType"];
            this.qualifyingPeriodInMonths = _data["qualifyingPeriodInMonths"];
            this.waitingPeriodInMonths = _data["waitingPeriodInMonths"];
            this.discountOnInsurancePremiums = _data["discountOnInsurancePremiums"];
            this.conditionForADiscountOnInsurancePremiums = _data["conditionForADiscountOnInsurancePremiums"];
            this.frequencyOfChangeInInsurancePremiumsOverTheYears = _data["frequencyOfChangeInInsurancePremiumsOverTheYears"];
            this.dateOfNextUpdateOfInsurancePremiums = _data["dateOfNextUpdateOfInsurancePremiums"] ? new Date(_data["dateOfNextUpdateOfInsurancePremiums"].toString()) : <any>undefined;
            this.costOfDisabilityCoverage = _data["costOfDisabilityCoverage"];
            this.theCostOfCoveringASurvivorsPensionForADisabledPerson = _data["theCostOfCoveringASurvivorsPensionForADisabledPerson"];
            this.disabilityCoverageRateInTheInsuranceTrack = _data["disabilityCoverageRateInTheInsuranceTrack"];
            this.determiningWagesToCoverDisabilityAndSurvivors = _data["determiningWagesToCoverDisabilityAndSurvivors"];
            this.theCorrectnessDateOfTheSalaryDeterminesToCoverDisabilityAndSurvivors = _data["theCorrectnessDateOfTheSalaryDeterminesToCoverDisabilityAndSurvivors"] ? new Date(_data["theCorrectnessDateOfTheSalaryDeterminesToCoverDisabilityAndSurvivors"].toString()) : <any>undefined;
            this.totalDisabilityPension = _data["totalDisabilityPension"];
            this.disabilityDevelops = _data["disabilityDevelops"];
            this.waiverOfDisabilityInsuranceCoverage = _data["waiverOfDisabilityInsuranceCoverage"];
            this.cosOfCoveringResidues = _data["cosOfCoveringResidues"];
            this.insuranceCoverageRateForAnOrphanOfAnActiveMemberInTheInsuranceTrack = _data["insuranceCoverageRateForAnOrphanOfAnActiveMemberInTheInsuranceTrack"];
            this.survivorsPensionForAnActiveFellowWidowerAccordingToAnInsuranceTrack = _data["survivorsPensionForAnActiveFellowWidowerAccordingToAnInsuranceTrack"];
            this.survivorsPensionForTheOrphanOfSnSctiveMemberAccordingToTheInsuranceTrack = _data["survivorsPensionForTheOrphanOfSnSctiveMemberAccordingToTheInsuranceTrack"];
            this.survivorsPensionForASupportedParentOfAnActiveColleagueAccordingToAnInsuranceTrack = _data["survivorsPensionForASupportedParentOfAnActiveColleagueAccordingToAnInsuranceTrack"];
            this.insuranceCoverageRateForAFellowWidowerActiveInTheInsuranceTrack = _data["insuranceCoverageRateForAFellowWidowerActiveInTheInsuranceTrack"];
            this.insuranceCoverageRateForASupportedParentOfAnActiveColleague = _data["insuranceCoverageRateForASupportedParentOfAnActiveColleague"];
            this.retirementAgeForOldAgePensionByInsuranceTrack = _data["retirementAgeForOldAgePensionByInsuranceTrack"];
            this.totalPensionOfAFellowInactiveWidower = _data["totalPensionOfAFellowInactiveWidower"];
            this.severalConsecutiveMonthsOfMembershipInThePensionFund = _data["severalConsecutiveMonthsOfMembershipInThePensionFund"];
            this.accumulatedPensionPortion = _data["accumulatedPensionPortion"];
            this.percentageOfAccruedPension = _data["percentageOfAccruedPension"];
            this.membershipStartDate = _data["membershipStartDate"] ? new Date(_data["membershipStartDate"].toString()) : <any>undefined;
            this.dataValueDate = _data["dataValueDate"] ? new Date(_data["dataValueDate"].toString()) : <any>undefined;
            this.insuranceBenefit = _data["insuranceBenefit"];
        }
    }

    static fromJS(data: any): CoverModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["number"] = this.number;
        data["name"] = this.name;
        data["againstPolicyAccountNumber"] = this.againstPolicyAccountNumber;
        data["identityType"] = this.identityType;
        data["identity"] = this.identity;
        data["insuredMame"] = this.insuredMame;
        data["insurancePremiumsToPay"] = this.insurancePremiumsToPay;
        data["linkageType"] = this.linkageType;
        data["routType"] = this.routType;
        data["includesCumulativeSavingsInPolicy"] = this.includesCumulativeSavingsInPolicy;
        data["valueInsuranceAmountRouteRequestedInsuranceAmount"] = this.valueInsuranceAmountRouteRequestedInsuranceAmount;
        data["valueMultipleSalariesDoubleSalaryTrackType"] = this.valueMultipleSalariesDoubleSalaryTrackType;
        data["valueAllocationPercentageSavings"] = this.valueAllocationPercentageSavings;
        data["roofCeilingSealedInDeath"] = this.roofCeilingSealedInDeath;
        data["roofCeilingLossWorkCapacity"] = this.roofCeilingLossWorkCapacity;
        data["insuranceAmountInDeath"] = this.insuranceAmountInDeath;
        data["insuredType"] = this.insuredType;
        data["insuranceCoverType"] = this.insuranceCoverType;
        data["acaIncludesFrancis"] = this.acaIncludesFrancis;
        data["coverStartDate"] = this.coverStartDate ? this.coverStartDate.toISOString() : <any>undefined;
        data["coverEndDate"] = this.coverEndDate ? this.coverEndDate.toISOString() : <any>undefined;
        data["terminationPaymentDate"] = this.terminationPaymentDate ? this.terminationPaymentDate.toISOString() : <any>undefined;
        data["percentageBasicInsuranceAmount"] = this.percentageBasicInsuranceAmount;
        data["percentageDoublePay"] = this.percentageDoublePay;
        data["payInsuranceAmount"] = this.payInsuranceAmount;
        data["insuranceSum"] = this.insuranceSum;
        data["coverPayer"] = this.coverPayer;
        data["smokingCode"] = this.smokingCode;
        data["insuredUnderwriting"] = this.insuredUnderwriting;
        data["underwritingDate"] = this.underwritingDate ? this.underwritingDate.toISOString() : <any>undefined;
        data["exception"] = this.exception;
        data["exceptionType"] = this.exceptionType;
        data["qualifyingPeriodInMonths"] = this.qualifyingPeriodInMonths;
        data["waitingPeriodInMonths"] = this.waitingPeriodInMonths;
        data["discountOnInsurancePremiums"] = this.discountOnInsurancePremiums;
        data["conditionForADiscountOnInsurancePremiums"] = this.conditionForADiscountOnInsurancePremiums;
        data["frequencyOfChangeInInsurancePremiumsOverTheYears"] = this.frequencyOfChangeInInsurancePremiumsOverTheYears;
        data["dateOfNextUpdateOfInsurancePremiums"] = this.dateOfNextUpdateOfInsurancePremiums ? this.dateOfNextUpdateOfInsurancePremiums.toISOString() : <any>undefined;
        data["costOfDisabilityCoverage"] = this.costOfDisabilityCoverage;
        data["theCostOfCoveringASurvivorsPensionForADisabledPerson"] = this.theCostOfCoveringASurvivorsPensionForADisabledPerson;
        data["disabilityCoverageRateInTheInsuranceTrack"] = this.disabilityCoverageRateInTheInsuranceTrack;
        data["determiningWagesToCoverDisabilityAndSurvivors"] = this.determiningWagesToCoverDisabilityAndSurvivors;
        data["theCorrectnessDateOfTheSalaryDeterminesToCoverDisabilityAndSurvivors"] = this.theCorrectnessDateOfTheSalaryDeterminesToCoverDisabilityAndSurvivors ? this.theCorrectnessDateOfTheSalaryDeterminesToCoverDisabilityAndSurvivors.toISOString() : <any>undefined;
        data["totalDisabilityPension"] = this.totalDisabilityPension;
        data["disabilityDevelops"] = this.disabilityDevelops;
        data["waiverOfDisabilityInsuranceCoverage"] = this.waiverOfDisabilityInsuranceCoverage;
        data["cosOfCoveringResidues"] = this.cosOfCoveringResidues;
        data["insuranceCoverageRateForAnOrphanOfAnActiveMemberInTheInsuranceTrack"] = this.insuranceCoverageRateForAnOrphanOfAnActiveMemberInTheInsuranceTrack;
        data["survivorsPensionForAnActiveFellowWidowerAccordingToAnInsuranceTrack"] = this.survivorsPensionForAnActiveFellowWidowerAccordingToAnInsuranceTrack;
        data["survivorsPensionForTheOrphanOfSnSctiveMemberAccordingToTheInsuranceTrack"] = this.survivorsPensionForTheOrphanOfSnSctiveMemberAccordingToTheInsuranceTrack;
        data["survivorsPensionForASupportedParentOfAnActiveColleagueAccordingToAnInsuranceTrack"] = this.survivorsPensionForASupportedParentOfAnActiveColleagueAccordingToAnInsuranceTrack;
        data["insuranceCoverageRateForAFellowWidowerActiveInTheInsuranceTrack"] = this.insuranceCoverageRateForAFellowWidowerActiveInTheInsuranceTrack;
        data["insuranceCoverageRateForASupportedParentOfAnActiveColleague"] = this.insuranceCoverageRateForASupportedParentOfAnActiveColleague;
        data["retirementAgeForOldAgePensionByInsuranceTrack"] = this.retirementAgeForOldAgePensionByInsuranceTrack;
        data["totalPensionOfAFellowInactiveWidower"] = this.totalPensionOfAFellowInactiveWidower;
        data["severalConsecutiveMonthsOfMembershipInThePensionFund"] = this.severalConsecutiveMonthsOfMembershipInThePensionFund;
        data["accumulatedPensionPortion"] = this.accumulatedPensionPortion;
        data["percentageOfAccruedPension"] = this.percentageOfAccruedPension;
        data["membershipStartDate"] = this.membershipStartDate ? this.membershipStartDate.toISOString() : <any>undefined;
        data["dataValueDate"] = this.dataValueDate ? this.dataValueDate.toISOString() : <any>undefined;
        data["insuranceBenefit"] = this.insuranceBenefit;
        return data;
    }
}

export interface ICoverModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    number?: string | undefined;
    name?: string | undefined;
    againstPolicyAccountNumber?: string | undefined;
    identityType?: IdentityType;
    identity?: string | undefined;
    insuredMame?: string | undefined;
    insurancePremiumsToPay?: string | undefined;
    linkageType?: number;
    routType?: number;
    includesCumulativeSavingsInPolicy?: boolean | undefined;
    valueInsuranceAmountRouteRequestedInsuranceAmount?: string | undefined;
    valueMultipleSalariesDoubleSalaryTrackType?: string | undefined;
    valueAllocationPercentageSavings?: string | undefined;
    roofCeilingSealedInDeath?: string | undefined;
    roofCeilingLossWorkCapacity?: string | undefined;
    insuranceAmountInDeath?: string | undefined;
    insuredType?: number;
    insuranceCoverType?: number;
    acaIncludesFrancis?: boolean | undefined;
    coverStartDate?: Date;
    coverEndDate?: Date;
    terminationPaymentDate?: Date;
    percentageBasicInsuranceAmount?: string | undefined;
    percentageDoublePay?: string | undefined;
    payInsuranceAmount?: number;
    insuranceSum?: string | undefined;
    coverPayer?: number;
    smokingCode?: YesNoUnknown;
    insuredUnderwriting?: YesNoUnknown;
    underwritingDate?: Date;
    exception?: YesNoUnknown;
    exceptionType?: number;
    qualifyingPeriodInMonths?: string | undefined;
    waitingPeriodInMonths?: string | undefined;
    discountOnInsurancePremiums?: YesNoUnknown;
    conditionForADiscountOnInsurancePremiums?: YesNoUnknown;
    frequencyOfChangeInInsurancePremiumsOverTheYears?: string | undefined;
    dateOfNextUpdateOfInsurancePremiums?: Date;
    costOfDisabilityCoverage?: string | undefined;
    theCostOfCoveringASurvivorsPensionForADisabledPerson?: string | undefined;
    disabilityCoverageRateInTheInsuranceTrack?: string | undefined;
    determiningWagesToCoverDisabilityAndSurvivors?: string | undefined;
    theCorrectnessDateOfTheSalaryDeterminesToCoverDisabilityAndSurvivors?: Date;
    totalDisabilityPension?: string | undefined;
    disabilityDevelops?: boolean | undefined;
    waiverOfDisabilityInsuranceCoverage?: YesNoIrrelevant;
    cosOfCoveringResidues?: string | undefined;
    insuranceCoverageRateForAnOrphanOfAnActiveMemberInTheInsuranceTrack?: string | undefined;
    survivorsPensionForAnActiveFellowWidowerAccordingToAnInsuranceTrack?: string | undefined;
    survivorsPensionForTheOrphanOfSnSctiveMemberAccordingToTheInsuranceTrack?: string | undefined;
    survivorsPensionForASupportedParentOfAnActiveColleagueAccordingToAnInsuranceTrack?: string | undefined;
    insuranceCoverageRateForAFellowWidowerActiveInTheInsuranceTrack?: string | undefined;
    insuranceCoverageRateForASupportedParentOfAnActiveColleague?: string | undefined;
    retirementAgeForOldAgePensionByInsuranceTrack?: string | undefined;
    totalPensionOfAFellowInactiveWidower?: string | undefined;
    severalConsecutiveMonthsOfMembershipInThePensionFund?: string | undefined;
    accumulatedPensionPortion?: string | undefined;
    percentageOfAccruedPension?: string | undefined;
    membershipStartDate?: Date;
    dataValueDate?: Date;
    insuranceBenefit?: YesNoUnknown;
}

export class CreateDiscountRequest implements ICreateDiscountRequest {
    userId?: string;
    amount?: number;
    status?: RiderDiscountBankStatusType;
    riderId?: string | undefined;
    simulatorOfferId?: string | undefined;

    constructor(data?: ICreateDiscountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.riderId = _data["riderId"];
            this.simulatorOfferId = _data["simulatorOfferId"];
        }
    }

    static fromJS(data: any): CreateDiscountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiscountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["riderId"] = this.riderId;
        data["simulatorOfferId"] = this.simulatorOfferId;
        return data;
    }
}

export interface ICreateDiscountRequest {
    userId?: string;
    amount?: number;
    status?: RiderDiscountBankStatusType;
    riderId?: string | undefined;
    simulatorOfferId?: string | undefined;
}

export class CreateOfferModel implements ICreateOfferModel {
    startDate?: Date;
    endDate?: Date;
    customerId?: string;
    createdById?: string | undefined;

    constructor(data?: ICreateOfferModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): CreateOfferModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOfferModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["createdById"] = this.createdById;
        return data;
    }
}

export interface ICreateOfferModel {
    startDate?: Date;
    endDate?: Date;
    customerId?: string;
    createdById?: string | undefined;
}

export class CreateRiderSubscriberRequest implements ICreateRiderSubscriberRequest {
    id?: string | undefined;
    actionType?: ActionType;

    constructor(data?: ICreateRiderSubscriberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): CreateRiderSubscriberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRiderSubscriberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionType"] = this.actionType;
        return data;
    }
}

export interface ICreateRiderSubscriberRequest {
    id?: string | undefined;
    actionType?: ActionType;
}

export class CreateSueDocumentModel implements ICreateSueDocumentModel {
    id?: string | undefined;
    name?: string | undefined;
    createdDate?: Date;
    fileSize?: string | undefined;
    filePath?: string | undefined;
    policyNumber?: string | undefined;
    file?: string | undefined;

    constructor(data?: ICreateSueDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.fileSize = _data["fileSize"];
            this.filePath = _data["filePath"];
            this.policyNumber = _data["policyNumber"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): CreateSueDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSueDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["fileSize"] = this.fileSize;
        data["filePath"] = this.filePath;
        data["policyNumber"] = this.policyNumber;
        data["file"] = this.file;
        return data;
    }
}

export interface ICreateSueDocumentModel {
    id?: string | undefined;
    name?: string | undefined;
    createdDate?: Date;
    fileSize?: string | undefined;
    filePath?: string | undefined;
    policyNumber?: string | undefined;
    file?: string | undefined;
}

/** 0 = Current, 1 = OldVersion */
export enum CreationStatus {
    _0 = 0,
    _1 = 1,
}

/** 0 = Shekel, 1 = Dolar, 2 = Pound, 8 = Mark */
export enum CurrencyType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _8 = 8,
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType?: Type;
    constructor_?: ConstructorInfo;
    readonly constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments?: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : <any>undefined;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : <any>undefined;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType?: Type;
    constructor_?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    namedArguments?: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    readonly memberName?: string | undefined;
    readonly isField?: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string | undefined;
    isField?: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType?: Type;
    value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType?: Type;
    value?: any | undefined;
}

export class Customer implements ICustomer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    customerNumberInAgentComputer?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date;
    identityType?: IdentityType;
    identifier?: string | undefined;
    agentId?: string | undefined;
    handlerId?: string | undefined;
    fileNumber?: string | undefined;
    facebookUrl?: string | undefined;
    websiteUrl?: string | undefined;
    gender?: Gender;
    employerId?: string | undefined;
    isSmoker?: boolean | undefined;
    powerOfAttorneySigned?: boolean | undefined;
    clinic?: string | undefined;
    passportNumber?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicensIssueDate?: Date | undefined;
    driverLicenseType?: string | undefined;
    profession?: string | undefined;
    workplace?: string | undefined;
    jobTitle?: JobTitle;
    workerNumber?: string | undefined;
    salary?: string | undefined;
    identityIssueDate?: Date;
    referrer?: string | undefined;
    maritalStatus?: MaritalStatus;
    agent?: User;
    handler?: User;
    employer?: Employer;
    popupMessage?: string | undefined;
    treatments?: Treatment[] | undefined;
    policies?: Policy[] | undefined;
    documents?: CustomerDocument[] | undefined;
    sues?: Sue[] | undefined;
    customerContactDetails?: CustomerContactDetails[] | undefined;
    customerRemarks?: CustomerRemark[] | undefined;
    customerAddresses?: CustomerAddress[] | undefined;
    customerGroups?: CustomerGroup[] | undefined;
    vehicles?: Vehicle[] | undefined;
    leads?: Lead[] | undefined;
    readonly fullName?: string | undefined;
    comment?: string | undefined;
    group1?: string | undefined;
    group2?: string | undefined;
    group3?: string | undefined;
    customerType?: string | undefined;
    customerNumber?: string | undefined;
    agentName?: string | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.customerNumberInAgentComputer = _data["customerNumberInAgentComputer"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.identityType = _data["identityType"];
            this.identifier = _data["identifier"];
            this.agentId = _data["agentId"];
            this.handlerId = _data["handlerId"];
            this.fileNumber = _data["fileNumber"];
            this.facebookUrl = _data["facebookUrl"];
            this.websiteUrl = _data["websiteUrl"];
            this.gender = _data["gender"];
            this.employerId = _data["employerId"];
            this.isSmoker = _data["isSmoker"];
            this.powerOfAttorneySigned = _data["powerOfAttorneySigned"];
            this.clinic = _data["clinic"];
            this.passportNumber = _data["passportNumber"];
            this.driverLicenseNumber = _data["driverLicenseNumber"];
            this.driverLicensIssueDate = _data["driverLicensIssueDate"] ? new Date(_data["driverLicensIssueDate"].toString()) : <any>undefined;
            this.driverLicenseType = _data["driverLicenseType"];
            this.profession = _data["profession"];
            this.workplace = _data["workplace"];
            this.jobTitle = _data["jobTitle"];
            this.workerNumber = _data["workerNumber"];
            this.salary = _data["salary"];
            this.identityIssueDate = _data["identityIssueDate"] ? new Date(_data["identityIssueDate"].toString()) : <any>undefined;
            this.referrer = _data["referrer"];
            this.maritalStatus = _data["maritalStatus"];
            this.agent = _data["agent"] ? User.fromJS(_data["agent"]) : <any>undefined;
            this.handler = _data["handler"] ? User.fromJS(_data["handler"]) : <any>undefined;
            this.employer = _data["employer"] ? Employer.fromJS(_data["employer"]) : <any>undefined;
            this.popupMessage = _data["popupMessage"];
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(Treatment.fromJS(item));
            }
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(Policy.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(CustomerDocument.fromJS(item));
            }
            if (Array.isArray(_data["sues"])) {
                this.sues = [] as any;
                for (let item of _data["sues"])
                    this.sues!.push(Sue.fromJS(item));
            }
            if (Array.isArray(_data["customerContactDetails"])) {
                this.customerContactDetails = [] as any;
                for (let item of _data["customerContactDetails"])
                    this.customerContactDetails!.push(CustomerContactDetails.fromJS(item));
            }
            if (Array.isArray(_data["customerRemarks"])) {
                this.customerRemarks = [] as any;
                for (let item of _data["customerRemarks"])
                    this.customerRemarks!.push(CustomerRemark.fromJS(item));
            }
            if (Array.isArray(_data["customerAddresses"])) {
                this.customerAddresses = [] as any;
                for (let item of _data["customerAddresses"])
                    this.customerAddresses!.push(CustomerAddress.fromJS(item));
            }
            if (Array.isArray(_data["customerGroups"])) {
                this.customerGroups = [] as any;
                for (let item of _data["customerGroups"])
                    this.customerGroups!.push(CustomerGroup.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(Vehicle.fromJS(item));
            }
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(Lead.fromJS(item));
            }
            (<any>this).fullName = _data["fullName"];
            this.comment = _data["comment"];
            this.group1 = _data["group1"];
            this.group2 = _data["group2"];
            this.group3 = _data["group3"];
            this.customerType = _data["customerType"];
            this.customerNumber = _data["customerNumber"];
            this.agentName = _data["agentName"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["customerNumberInAgentComputer"] = this.customerNumberInAgentComputer;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["identityType"] = this.identityType;
        data["identifier"] = this.identifier;
        data["agentId"] = this.agentId;
        data["handlerId"] = this.handlerId;
        data["fileNumber"] = this.fileNumber;
        data["facebookUrl"] = this.facebookUrl;
        data["websiteUrl"] = this.websiteUrl;
        data["gender"] = this.gender;
        data["employerId"] = this.employerId;
        data["isSmoker"] = this.isSmoker;
        data["powerOfAttorneySigned"] = this.powerOfAttorneySigned;
        data["clinic"] = this.clinic;
        data["passportNumber"] = this.passportNumber;
        data["driverLicenseNumber"] = this.driverLicenseNumber;
        data["driverLicensIssueDate"] = this.driverLicensIssueDate ? this.driverLicensIssueDate.toISOString() : <any>undefined;
        data["driverLicenseType"] = this.driverLicenseType;
        data["profession"] = this.profession;
        data["workplace"] = this.workplace;
        data["jobTitle"] = this.jobTitle;
        data["workerNumber"] = this.workerNumber;
        data["salary"] = this.salary;
        data["identityIssueDate"] = this.identityIssueDate ? this.identityIssueDate.toISOString() : <any>undefined;
        data["referrer"] = this.referrer;
        data["maritalStatus"] = this.maritalStatus;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["handler"] = this.handler ? this.handler.toJSON() : <any>undefined;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["popupMessage"] = this.popupMessage;
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.sues)) {
            data["sues"] = [];
            for (let item of this.sues)
                data["sues"].push(item.toJSON());
        }
        if (Array.isArray(this.customerContactDetails)) {
            data["customerContactDetails"] = [];
            for (let item of this.customerContactDetails)
                data["customerContactDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.customerRemarks)) {
            data["customerRemarks"] = [];
            for (let item of this.customerRemarks)
                data["customerRemarks"].push(item.toJSON());
        }
        if (Array.isArray(this.customerAddresses)) {
            data["customerAddresses"] = [];
            for (let item of this.customerAddresses)
                data["customerAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.customerGroups)) {
            data["customerGroups"] = [];
            for (let item of this.customerGroups)
                data["customerGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        data["fullName"] = this.fullName;
        data["comment"] = this.comment;
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["customerType"] = this.customerType;
        data["customerNumber"] = this.customerNumber;
        data["agentName"] = this.agentName;
        return data;
    }
}

export interface ICustomer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    customerNumberInAgentComputer?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date;
    identityType?: IdentityType;
    identifier?: string | undefined;
    agentId?: string | undefined;
    handlerId?: string | undefined;
    fileNumber?: string | undefined;
    facebookUrl?: string | undefined;
    websiteUrl?: string | undefined;
    gender?: Gender;
    employerId?: string | undefined;
    isSmoker?: boolean | undefined;
    powerOfAttorneySigned?: boolean | undefined;
    clinic?: string | undefined;
    passportNumber?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicensIssueDate?: Date | undefined;
    driverLicenseType?: string | undefined;
    profession?: string | undefined;
    workplace?: string | undefined;
    jobTitle?: JobTitle;
    workerNumber?: string | undefined;
    salary?: string | undefined;
    identityIssueDate?: Date;
    referrer?: string | undefined;
    maritalStatus?: MaritalStatus;
    agent?: User;
    handler?: User;
    employer?: Employer;
    popupMessage?: string | undefined;
    treatments?: Treatment[] | undefined;
    policies?: Policy[] | undefined;
    documents?: CustomerDocument[] | undefined;
    sues?: Sue[] | undefined;
    customerContactDetails?: CustomerContactDetails[] | undefined;
    customerRemarks?: CustomerRemark[] | undefined;
    customerAddresses?: CustomerAddress[] | undefined;
    customerGroups?: CustomerGroup[] | undefined;
    vehicles?: Vehicle[] | undefined;
    leads?: Lead[] | undefined;
    fullName?: string | undefined;
    comment?: string | undefined;
    group1?: string | undefined;
    group2?: string | undefined;
    group3?: string | undefined;
    customerType?: string | undefined;
    customerNumber?: string | undefined;
    agentName?: string | undefined;
}

export class CustomerAddress implements ICustomerAddress {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    street?: string | undefined;
    city?: string | undefined;
    streetId?: number;
    cityId?: number;
    houseNumber?: number;
    apartmentNumber?: number;
    floor?: string;
    postalCode?: string | undefined;
    mailbox?: string | undefined;
    entry?: string | undefined;
    comment?: string | undefined;
    customerId?: string;
    customer?: Customer;
    hasError?: boolean;
    addressType?: string;

    constructor(data?: ICustomerAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.street = _data["street"];
            this.city = _data["city"];
            this.streetId = _data["streetId"];
            this.cityId = _data["cityId"];
            this.houseNumber = _data["houseNumber"];
            this.apartmentNumber = _data["apartmentNumber"];
            this.floor = _data['floor'];
            this.postalCode = _data["postalCode"];
            this.mailbox = _data["mailbox"];
            this.entry = _data["entry"];
            this.comment = _data["comment"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.hasError = _data["hasError"];
            this.addressType = _data["addressType"];
        }
    }

    static fromJS(data: any): CustomerAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["street"] = this.street;
        data["city"] = this.city;
        data["streetId"] = this.streetId;
        data["cityId"] = this.cityId;
        data["houseNumber"] = this.houseNumber;
        data["apartmentNumber"] = this.apartmentNumber;
        data["floor"] = this.floor;
        data["postalCode"] = this.postalCode;
        data["mailbox"] = this.mailbox;
        data["entry"] = this.entry;
        data["comment"] = this.comment;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["hasError"] = this.hasError;
        data["addressType"] = this.addressType;
        return data;
    }
}

export interface ICustomerAddress {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    street?: string | undefined;
    city?: string | undefined;
    streetId?: number;
    cityId?: number;
    houseNumber?: number;
    apartmentNumber?: number;
    postalCode?: string | undefined;
    mailbox?: string | undefined;
    entry?: string | undefined;
    comment?: string | undefined;
    customerId?: string;
    customer?: Customer;
}

export class CustomerAddressModel implements ICustomerAddressModel {
    id?: string;
    street?: string | undefined;
    city?: string | undefined;
    houseNumber?: number;
    apartmentNumber?: number;
    postalCode?: string | undefined;
    mailbox?: string | undefined;
    comment?: string | undefined;
    customerId?: string;
    hasError?: boolean;
    addressType?: string;
    readonly address?: string | undefined;
    entry?: string | undefined;

    constructor(data?: ICustomerAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.houseNumber = _data["houseNumber"];
            this.apartmentNumber = _data["apartmentNumber"];
            this.postalCode = _data["postalCode"];
            this.mailbox = _data["mailbox"];
            this.comment = _data["comment"];
            this.customerId = _data["customerId"];
            (<any>this).address = _data["address"];
            this.addressType = _data["addressType"];
            this.entry = _data["entry"];
        }
    }

    static fromJS(data: any): CustomerAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        // //console.log("address data?????",data);
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["street"] = this.street;
        data["city"] = this.city;
        data["houseNumber"] = this.houseNumber;
        data["apartmentNumber"] = this.apartmentNumber;
        data["postalCode"] = this.postalCode;
        data["mailbox"] = this.mailbox;
        data["comment"] = this.comment;
        data["customerId"] = this.customerId;
        data["address"] = this.address;
        data["addressType"] = this.addressType;
        data["entry"] = this.entry;

        // //console.log("address data?????2",data);
        return data;
    }
}

export interface ICustomerAddressModel {
    id?: string;
    street?: string | undefined;
    city?: string | undefined;
    houseNumber?: number;
    apartmentNumber?: number;
    entry?: string | undefined;
    postalCode?: string | undefined;
    mailbox?: string | undefined;
    comment?: string | undefined;
    customerId?: string;
    address?: string | undefined;
}

export class CustomerCardEditPersonalDataRequest implements ICustomerCardEditPersonalDataRequest {
    id?: string;
    model?: CustomerPersonalModel;

    constructor(data?: ICustomerCardEditPersonalDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.model = _data["model"] ? CustomerPersonalModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerCardEditPersonalDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCardEditPersonalDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerCardEditPersonalDataRequest {
    id?: string;
    model?: CustomerPersonalModel;
}

export class CustomerCardSearchMessageRequest implements ICustomerCardSearchMessageRequest {
    searchText?: string | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    type?: string | undefined;

    constructor(data?: ICustomerCardSearchMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CustomerCardSearchMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCardSearchMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["type"] = this.type;
        return data;
    }
}

export interface ICustomerCardSearchMessageRequest {
    searchText?: string | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    type?: string | undefined;
}

export class CustomerContactDetails implements ICustomerContactDetails {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    emailAddress?: string | undefined;
    isPrimary?: boolean;
    number?: string | undefined;
    title?: string | undefined;
    phoneType?: PhoneType;
    customerId?: string;
    customer?: Customer;

    constructor(data?: ICustomerContactDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.isPrimary = _data["isPrimary"];
            this.number = _data["number"];
            this.title = _data["title"];
            this.phoneType = _data["phoneType"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerContactDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["isPrimary"] = this.isPrimary;
        data["number"] = this.number;
        data["title"] = this.title;
        data["phoneType"] = this.phoneType;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerContactDetails {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    emailAddress?: string | undefined;
    isPrimary?: boolean;
    number?: string | undefined;
    title?: string | undefined;
    phoneType?: PhoneType;
    customerId?: string;
    customer?: Customer;
}

export class CustomerContactDetailsModel implements ICustomerContactDetailsModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    emailAddress?: string | undefined;
    isPrimary?: boolean;
    number?: string | undefined;
    title?: string | undefined;
    phoneType?: PhoneType;
    customer?: CustomerModel;
    customerId?: string;
    hasError?: boolean;
    comment?: string | undefined;

    constructor(data?: ICustomerContactDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.isPrimary = _data["isPrimary"];
            this.number = _data["number"];
            this.title = _data["title"];
            this.phoneType = _data["phoneType"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CustomerContactDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["isPrimary"] = this.isPrimary;
        data["number"] = this.number;
        data["title"] = this.title;
        data["phoneType"] = this.phoneType;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICustomerContactDetailsModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    emailAddress?: string | undefined;
    isPrimary?: boolean;
    number?: string | undefined;
    title?: string | undefined;
    phoneType?: PhoneType;
    customer?: CustomerModel;
    customerId?: string;
}

export class CustomerDetailsModel implements ICustomerDetailsModel {
    personalData?: CustomerPersonalModel;
    treatmentsTab?: TreatmentTabModel;
    policiesTab?: PolicyTabModel;
    offerTab?: OfferTabModel;
    customerDocumentsTab?: CustomerDocumentTabModel;
    customerWhatsappTab?: CustomerWhatsappTabModel;
    speakComTab?: SpeakComTabModel;
    customerSueTab?: SueTabModel;

    constructor(data?: ICustomerDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalData = _data["personalData"] ? CustomerPersonalModel.fromJS(_data["personalData"]) : <any>undefined;
            this.treatmentsTab = _data["treatmentsTab"] ? TreatmentTabModel.fromJS(_data["treatmentsTab"]) : <any>undefined;
            this.policiesTab = _data["policiesTab"] ? PolicyTabModel.fromJS(_data["policiesTab"]) : <any>undefined;
            this.offerTab = _data["offerTab"] ? OfferTabModel.fromJS(_data["offerTab"]) : <any>undefined;
            this.customerDocumentsTab = _data["customerDocumentsTab"] ? CustomerDocumentTabModel.fromJS(_data["customerDocumentsTab"]) : <any>undefined;
            this.customerWhatsappTab = _data["customerWhatsappTab"] ? CustomerWhatsappTabModel.fromJS(_data["customerWhatsappTab"]) : <any>undefined;
            this.speakComTab = _data["speakComTab"] ? SpeakComTabModel.fromJS(_data["speakComTab"]) : <any>undefined;
            this.customerSueTab = _data["customerSueTab"] ? SueTabModel.fromJS(_data["customerSueTab"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalData"] = this.personalData ? this.personalData.toJSON() : <any>undefined;
        data["treatmentsTab"] = this.treatmentsTab ? this.treatmentsTab.toJSON() : <any>undefined;
        data["policiesTab"] = this.policiesTab ? this.policiesTab.toJSON() : <any>undefined;
        data["offerTab"] = this.offerTab ? this.offerTab.toJSON() : <any>undefined;
        data["customerDocumentsTab"] = this.customerDocumentsTab ? this.customerDocumentsTab.toJSON() : <any>undefined;
        data["customerWhatsappTab"] = this.customerWhatsappTab ? this.customerWhatsappTab.toJSON() : <any>undefined;
        data["speakComTab"] = this.speakComTab ? this.speakComTab.toJSON() : <any>undefined;
        data["customerSueTab"] = this.customerSueTab ? this.customerSueTab.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerDetailsModel {
    personalData?: CustomerPersonalModel;
    treatmentsTab?: TreatmentTabModel;
    policiesTab?: PolicyTabModel;
    offerTab?: OfferTabModel;
    customerDocumentsTab?: CustomerDocumentTabModel;
    customerWhatsappTab?: CustomerWhatsappTabModel;
    speakComTab?: SpeakComTabModel;
    customerSueTab?: SueTabModel;
}

export class CustomerDetailsRequest implements ICustomerDetailsRequest {
    id?: string;
    ismobile?: boolean;

    constructor(data?: ICustomerDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ismobile = _data["ismobile"];
        }
    }

    static fromJS(data: any): CustomerDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ismobile"] = this.ismobile;
        return data;
    }
}

export interface ICustomerDetailsRequest {
    id?: string;
    ismobile?: boolean;
}


export class DocumentTypeModel {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    isLock?: boolean | undefined;
    type?: number | undefined;


    constructor(data?: DocumentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.isLock = _data["isLock"];
            this.type = _data["type"];

        }
    }

    static fromJS(data: any): DocumentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["isLock"] = this.isLock;
        data["type"] = this.type;
        return data;
    }
}


export class CustomerDocument implements ICustomerDocument {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    licenseNumber?: string | undefined;
    policyNumber?: string | undefined;
    topicType?: DocumentTopicType;
    fileSize?: string | undefined;
    filePath?: string | undefined;
    customerId?: string;
    customer?: Customer;
    userId?: string;
    user?: User;

    constructor(data?: ICustomerDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.licenseNumber = _data["licenseNumber"];
            this.policyNumber = _data["policyNumber"];
            this.topicType = _data["topicType"];
            this.fileSize = _data["fileSize"];
            this.filePath = _data["filePath"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerDocument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["licenseNumber"] = this.licenseNumber;
        data["policyNumber"] = this.policyNumber;
        data["topicType"] = this.topicType;
        data["fileSize"] = this.fileSize;
        data["filePath"] = this.filePath;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerDocument {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    licenseNumber?: string | undefined;
    policyNumber?: string | undefined;
    topicType?: DocumentTopicType;
    fileSize?: string | undefined;
    filePath?: string | undefined;
    customerId?: string;
    customer?: Customer;
    userId?: string;
    user?: User;
}

export class CustomerDocumentCreateModel implements ICustomerDocumentCreateModel {
    customerId?: string;
    userId?: string;
    topicType?: DocumentTopicType;
    policyNumber?: string | undefined;
    licenseNumber?: string | undefined;
    file?: string | undefined;

    constructor(data?: ICustomerDocumentCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.userId = _data["userId"];
            this.topicType = _data["topicType"];
            this.policyNumber = _data["policyNumber"];
            this.licenseNumber = _data["licenseNumber"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): CustomerDocumentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDocumentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["userId"] = this.userId;
        data["topicType"] = this.topicType;
        data["policyNumber"] = this.policyNumber;
        data["licenseNumber"] = this.licenseNumber;
        data["file"] = this.file;
        return data;
    }
}

export interface ICustomerDocumentCreateModel {
    customerId?: string;
    userId?: string;
    topicType?: DocumentTopicType;
    policyNumber?: string | undefined;
    licenseNumber?: string | undefined;
    file?: string | undefined;
}

export class CustomerDocumentModel implements ICustomerDocumentModel {
    topicType?: DocumentTopicType;
    items?: CustomerDocumentModelItem[] | undefined;

    constructor(data?: ICustomerDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicType = _data["topicType"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerDocumentModelItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicType"] = this.topicType;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerDocumentModel {
    topicType?: DocumentTopicType;
    items?: CustomerDocumentModelItem[] | undefined;
}

export class CustomerDocumentModelItem implements ICustomerDocumentModelItem {
    id?: string;
    name?: string | undefined;
    policyNumber?: string | undefined;
    licenseNumber?: string | undefined;
    createdByName?: string | undefined;
    createdDate?: Date;
    fileSize?: string | undefined;
    filePath?: string | undefined;
    comment?: string | undefined;
    customer?: Customer;
    customerDocumentFolderId?: string;
    customerId?: string;
    documentRelations?: any[];
    documentType?: string;
    isDeleted?: boolean;
    titleId?: string;
    topicType?: number;
    updatedDate?: Date;
    user?: User;
    userId?: string;



    constructor(data?: ICustomerDocumentModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.policyNumber = _data["policyNumber"];
            this.licenseNumber = _data["licenseNumber"];
            this.createdByName = _data["createdByName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.fileSize = _data["fileSize"];
            this.filePath = _data["filePath"];
            this.comment = _data["comment"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.customerDocumentFolderId = _data["customerDocumentFolderId"];
            this.customerId = _data["customerId"];
            // this.documentRelations = _data["documentRelations"] ? _data["documentRelations"] : [];
            if (Array.isArray(_data["documentRelations"])) {
                this.documentRelations = [] as any;
                for (let item of _data["documentRelations"])
                    this.documentRelations!.push(item);
            }
            this.documentType = _data["documentType"];
            this.isDeleted = _data["isDeleted"];
            this.titleId = _data["titleId"];
            this.topicType = _data["topicType"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];

        }
    }

    static fromJS(data: any): CustomerDocumentModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDocumentModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["policyNumber"] = this.policyNumber;
        data["licenseNumber"] = this.licenseNumber;
        data["createdByName"] = this.createdByName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["fileSize"] = this.fileSize;
        data["filePath"] = this.filePath;
        data["comment"] = this.comment;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["customerDocumentFolderId"] = this.customerDocumentFolderId;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.documentRelations)) {
            data["documentRelations"] = [];
            for (let item of this.documentRelations)
                data["documentRelations"].push(item);
        }
        // data["documentRelations"] = this.documentRelations;
        data["documentType"] = this.documentType;
        data["isDeleted"] = this.isDeleted;
        data["titleId"] = this.titleId;
        data["topicType"] = this.topicType;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;

        return data;
    }
}

export interface ICustomerDocumentModelItem {
    id?: string;
    name?: string | undefined;
    policyNumber?: string | undefined;
    licenseNumber?: string | undefined;
    createdByName?: string | undefined;
    createdDate?: Date;
    fileSize?: string | undefined;
    filePath?: string | undefined;
}

export class CustomerDocumentTabModel implements ICustomerDocumentTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: CustomerDocumentModel[] | undefined;

    constructor(data?: ICustomerDocumentTabModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerDocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerDocumentTabModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDocumentTabModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerDocumentTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: CustomerDocumentModel[] | undefined;
}

export class CustomerFilterModel implements ICustomerFilterModel {
    filterSearch?: FilterModel;
    group?: string | undefined;
    agent?: string;
    handler?: string;
    sortBy?: SortModel[] | undefined;
    page?: number;

    constructor(data?: ICustomerFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterSearch = _data["filterSearch"] ? FilterModel.fromJS(_data["filterSearch"]) : <any>undefined;
            this.group = _data["group"];
            this.agent = _data["agent"];
            this.handler = _data["handler"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): CustomerFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterSearch"] = this.filterSearch ? this.filterSearch.toJSON() : <any>undefined;
        data["group"] = this.group;
        data["agent"] = this.agent;
        data["handler"] = this.handler;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["page"] = this.page;
        return data;
    }
}

export interface ICustomerFilterModel {
    filterSearch?: FilterModel;
    group?: string | undefined;
    agent?: string;
    handler?: string;
    sortBy?: SortModel[] | undefined;
    page?: number;
}

export class CustomerGridModel implements ICustomerGridModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customers?: CustomerModel[] | undefined;
    groups?: GroupModel[] | undefined;
    fieldsFilterList?: FieldsFilterListModel;
    agents?: UserModel[] | undefined;
    handlers?: UserModel[] | undefined;

    constructor(data?: ICustomerGridModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerModel.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupModel.fromJS(item));
            }
            this.fieldsFilterList = _data["fieldsFilterList"] ? FieldsFilterListModel.fromJS(_data["fieldsFilterList"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["handlers"])) {
                this.handlers = [] as any;
                for (let item of _data["handlers"])
                    this.handlers!.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerGridModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGridModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["fieldsFilterList"] = this.fieldsFilterList ? this.fieldsFilterList.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.handlers)) {
            data["handlers"] = [];
            for (let item of this.handlers)
                data["handlers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerGridModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customers?: CustomerModel[] | undefined;
    groups?: GroupModel[] | undefined;
    fieldsFilterList?: FieldsFilterListModel;
    agents?: UserModel[] | undefined;
    handlers?: UserModel[] | undefined;
}

export class CustomerGroup implements ICustomerGroup {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    customerId?: string;
    customer?: Customer;
    groupId?: string;
    group?: Group;

    constructor(data?: ICustomerGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.groupId = _data["groupId"];
            this.group = _data["group"] ? Group.fromJS(_data["group"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["groupId"] = this.groupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerGroup {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    customerId?: string;
    customer?: Customer;
    groupId?: string;
    group?: Group;
}

export class CustomerGroupModel implements ICustomerGroupModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    customerId?: string;
    groupId?: string;

    constructor(data?: ICustomerGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CustomerGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ICustomerGroupModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    customerId?: string;
    groupId?: string;
}


/********************************** */
export interface IElementaryPolicyModel {
    id?: string;
    status?: number;
    offerId?: string; // Guid is represented as string in TypeScript
    offer?: SimulatorOfferModel;
    suggestionI?: number;
    protection?: number;
    sequenceId?: number;
    agentDetailsId?: string;
    agentDetails?: AgentDetails;
    insuranceCompanyRouteId?: string;
    insuranceCompanyRoute?: InsuranceCompanyRoute;
    routeId?: number;
    routeComment?: string;
    collectiveId?: number;
    temsAndCovers?: string;
    additionalDetails?: string;
    comprehensiveInsurancePrice?: number;
    compulsoryInsurancePrice?: number;
    compulsoryPremiumPaymentToken?: string;
    comprehensivePremiumPaymentToken?: string;
    comprehensiveInsuranceNumberOfPayments?: number;
    compulsoryInsuranceNumberOfPayments?: number;
    riderNumberOfPayments?: number;
    startDate?: Date;
    endDate?: Date;
    createdDate?: Date;
    updatedDate?: Date;
    ownerFirstName?: string;
    ownerLastName?: string;
    ownerFullName?: string;
    ownerIdentityType?: number;
    ownerIdentifier?: string;
    ownerDateOfBirth?: Date;
    ownerMaritalStatus?: number;
    ownerIdentityIssueDate?: Date;
    ownerGender?: number;
    ownerContactDetailsId?: string;
    ownerContactDetails?: CustomerContactDetailsModel;
    ownerAddressId?: string;
    ownerAddress?: CustomerAddressModel;
    // mainDriverCustomerId?: string;
    // mainDriverCustomer?: Customer;
    // youngDriverCustomerId?: string;
    // youngDriverCustomer?: Customer;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverYoungIdentifier?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungLastName?: string | undefined;
    driverYoungFirstName?: string | undefined;

    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainIdentifier?: string | undefined;
    driverMainGender?: Gender;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainLastName?: string | undefined;
    driverMainFirstName?: string | undefined;

    vehicleId?: string;
    vehicle?: Vehicle;
    authorizedToDrive?: AuthorizedToDrive;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    insuranceType?: InsuranceTypes;
    payerFirstName?: string;
    payerLastName?: string;
    isVehicleEnslaved?: boolean;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string;
    involvedBankBranch?: string;
    involvedName?: string;
    involvedAddress?: string;
    comment?: string;
    riderPackages?: Riders_Packages[];

    shielding?: string;
    underwriterUserId?: string;
    underwriterUser?: User;
    elementaryPolicyDocuments?: ElementaryPolicyDocument[];
    newForOld?: boolean;
    compulsoryPaymentDetails?: string[];
    comprehensivePaymentDetails?: string[];
    ridersPaymentDetails?: string[];
}



export class ElementaryPolicyModel implements IElementaryPolicyModel {
    id?: string;
    status?: number;
    offerId?: string; // Guid is represented as string in TypeScript
    offer?: SimulatorOfferModel;
    suggestionId?: number;
    protection?: number;
    sequenceId?: number;
    agentDetailsId?: string;
    agentDetails?: AgentDetails;
    insuranceCompanyRouteId?: string;
    insuranceCompanyRoute?: InsuranceCompanyRoute;
    routeId?: number;
    routeComment?: string;
    collectiveId?: number;
    temsAndCovers?: string;
    additionalDetails?: string;
    comprehensiveInsurancePrice?: number;
    compulsoryInsurancePrice?: number;
    compulsoryPremiumPaymentToken?: string;
    comprehensivePremiumPaymentToken?: string;
    comprehensiveInsuranceNumberOfPayments?: number;
    compulsoryInsuranceNumberOfPayments?: number;
    riderNumberOfPayments?: number;
    startDate?: Date;
    endDate?: Date;
    createdDate?: Date;
    updatedDate?: Date;
    ownerFirstName?: string;
    ownerLastName?: string;
    ownerFullName?: string;
    ownerIdentityType?: number;
    ownerIdentifier?: string;
    ownerDateOfBirth?: Date;
    ownerMaritalStatus?: number;
    ownerIdentityIssueDate?: Date;
    ownerGender?: number;
    ownerContactDetailsId?: string;
    ownerContactDetails?: CustomerContactDetailsModel;
    ownerAddressId?: string;
    ownerAddress?: CustomerAddressModel;
    // mainDriverCustomerId?: string;
    // mainDriverCustomer?: Customer;
    // youngDriverCustomerId?: string;
    // youngDriverCustomer?: Customer;

    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverYoungIdentifier?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungLastName?: string | undefined;
    driverYoungFirstName?: string | undefined;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainIdentifier?: string | undefined;
    driverMainGender?: Gender;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainLastName?: string | undefined;
    driverMainFirstName?: string | undefined;


    vehicleId?: string;
    vehicle?: Vehicle;
    authorizedToDrive?: AuthorizedToDrive;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    insuranceType?: InsuranceTypes;
    payerFirstName?: string;
    payerLastName?: string;
    isVehicleEnslaved?: boolean;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string;
    involvedBankBranch?: string;
    involvedName?: string;
    involvedAddress?: string;
    comment?: string;
    riderPackages?: Riders_Packages[];
    shielding?: string;
    underwriterUserId?: string;
    underwriterUser?: User;
    elementaryPolicyDocuments?: ElementaryPolicyDocument[];
    compulsoryPremiumPaymentUrl?: string;
    comprehensivePremiumPaymentUrl?: string;
    newForOld?: boolean;
    compulsoryPaymentDetails?: string[];
    comprehensivePaymentDetails?: string[];
    ridersPaymentDetails?: string[];

    constructor(data?: IElementaryPolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];

            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;

            this.offerId = _data["offerId"];
            this.offer = _data["offer"] ? SimulatorOfferModel.fromJS(_data["offer"]) : <any>undefined; // _data["offer"] ? SimulatorOffer.fromJS(_data["offer"]) : <any>undefined;
            this.suggestionId = _data["suggestionId"];
            this.protection = _data["protection"];
            this.sequenceId = _data["sequenceId"];
            this.agentDetailsId = _data["agentDetailsId"];
            this.agentDetails = _data["agentDetails"] ? AgentDetails.fromJS(_data["agentDetails"]) : <any>undefined; //_data["agentDetails"] ? AgentDetailsModel.fromJS(_data["agentDetails"]) : <any>undefined;

            this.insuranceCompanyRouteId = _data["insuranceCompanyRouteId"];
            this.insuranceCompanyRoute = _data["insuranceCompanyRoute"] ? InsuranceCompanyRoute.fromJS(_data["insuranceCompanyRoute"]) : <any>undefined;

            this.routeId = _data["routeId"];
            this.routeComment = _data["routeComment"];
            this.collectiveId = _data["collectiveId"];
            this.temsAndCovers = _data["temsAndCovers"];
            this.additionalDetails = _data["additionalDetails"];
            this.comprehensiveInsurancePrice = _data["comprehensiveInsurancePrice"];
            this.compulsoryInsurancePrice = _data["compulsoryInsurancePrice"];
            this.compulsoryPremiumPaymentToken = _data["compulsoryPremiumPaymentToken"];
            this.comprehensivePremiumPaymentToken = _data["comprehensivePremiumPaymentToken"];
            this.comprehensiveInsuranceNumberOfPayments = _data["comprehensiveInsuranceNumberOfPayments"];
            this.compulsoryInsuranceNumberOfPayments = _data["compulsoryInsuranceNumberOfPayments"];
            this.riderNumberOfPayments = _data["riderNumberOfPayments"];


            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined;




            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerLastName = _data["ownerLastName"];
            this.ownerFullName = _data["ownerFullName"];
            this.ownerIdentityType = _data["ownerIdentityType"];
            this.ownerIdentifier = _data["ownerIdentifier"];
            this.ownerDateOfBirth = _data["ownerDateOfBirth"] ? new Date(_data["ownerDateOfBirth"].toString()) : undefined;
            this.ownerIdentityIssueDate = _data["ownerIdentityIssueDate"] ? new Date(_data["ownerIdentityIssueDate"].toString()) : undefined;
            this.ownerMaritalStatus = _data["ownerMaritalStatus"];
            this.ownerGender = _data["ownerGender"];
            this.ownerContactDetailsId = _data["ownerContactDetailsId"];
            this.ownerAddressId = _data["ownerAddressId"];
            this.ownerContactDetails = _data["ownerContactDetails"] ? CustomerContactDetailsModel.fromJS(_data["ownerContactDetails"]) : <any>undefined// new Customer();
            this.ownerAddress = _data["ownerAddress"] ? CustomerAddressModel.fromJS(_data["ownerAddress"]) : <any>undefined// new Customer();
            // this.mainDriverCustomerId = _data["mainDriverCustomerId"];
            // this.mainDriverCustomer = _data["mainDriverCustomer"] ? Customer.fromJS(_data["mainDriverCustomer"]) : <any>undefined; // new Customer();
            // this.youngDriverCustomerId = _data["youngDriverCustomerId"];
            // this.youngDriverCustomer = _data["youngDriverCustomer"] ? Customer.fromJS(_data["youngDriverCustomer"]) : <any>undefined; // new Customer();


            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverYoungIdentifier = _data["driverYoungIdentifier"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungLastName = _data["driverYoungLastName"];
            this.driverYoungFirstName = _data["driverYoungFirstName"];

            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.driverMainIdentifier = _data["driverMainIdentifier"];
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.driverMainLastName = _data["driverMainLastName"];
            this.driverMainFirstName = _data["driverMainFirstName"];


            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;

            this.authorizedToDrive = _data["authorizedToDrive"]; // _data["authorizedToDrive"] ? AuthorizedToDrive.fromJS(_data["authorizedToDrive"]) : new AuthorizedToDrive();
            this.passedTypeOfInsurance1 = _data["passedTypeOfInsurance1"]; //? PassedTypeOfInsurance.fromJS(_data["passedTypeOfInsurance1"]) : new PassedTypeOfInsurance();
            this.sueNumber1 = _data["sueNumber1"];
            this.insuranceCompanyId1 = _data["insuranceCompanyId1"];
            this.passedTypeOfInsurance2 = _data["passedTypeOfInsurance2"]; //? PassedTypeOfInsurance.fromJS(_data["passedTypeOfInsurance2"]) : new PassedTypeOfInsurance();
            this.sueNumber2 = _data["sueNumber2"];
            this.insuranceCompanyId2 = _data["insuranceCompanyId2"];
            this.passedTypeOfInsurance3 = _data["passedTypeOfInsurance3"]; //? PassedTypeOfInsurance.fromJS(_data["passedTypeOfInsurance3"]) : new PassedTypeOfInsurance();
            this.sueNumber3 = _data["sueNumber3"];
            this.insuranceCompanyId3 = _data["insuranceCompanyId3"];
            this.passedTypeOfInsurance4 = _data["passedTypeOfInsurance4"]; //? PassedTypeOfInsurance.fromJS(_data["passedTypeOfInsurance4"]) : new PassedTypeOfInsurance();
            this.sueNumber4 = _data["sueNumber4"];
            this.insuranceCompanyId4 = _data["insuranceCompanyId4"];
            this.bodyClaimsAmount = _data["bodyClaimsAmount"];
            this.revocationsAmount = _data["revocationsAmount"];
            this.noInsurance = _data["noInsurance"];
            this.newForOld = _data["newForOld"];
            this.insuranceType = _data["insuranceType"];
            this.payerFirstName = _data["payerFirstName"];
            this.payerLastName = _data["payerLastName"];
            this.isVehicleEnslaved = _data["isVehicleEnslaved"];
            this.involvedPartyType = _data["involvedPartyType"];
            this.involvedBank = _data["involvedBank"];
            this.involvedBankBranch = _data["involvedBankBranch"];
            this.involvedName = _data["involvedName"];
            this.involvedAddress = _data["involvedAddress"]; //? CustomerAddress.fromJS(_data["involvedAddress"]) : new CustomerAddress();
            this.comment = _data["comment"];
            this.compulsoryPremiumPaymentUrl = _data["compulsoryPremiumPaymentUrl"];
            this.comprehensivePremiumPaymentUrl = _data["comprehensivePremiumPaymentUrl"];
            this.riderPackages = _data["riderPackages"]; // ? _data["riderPackages"].map((item: any) => Riders_Packages.fromJS(item)) : [];
            //this.rider = _data["rider"]; // ? Rider.fromJS(_data["rider"]) : new Rider();
            this.shielding = _data["shielding"];
            this.underwriterUserId = _data["underwriterUserId"];
            this.underwriterUser = _data["underwriterUser"]; // ? User.fromJS(_data["underwriterUser"]) : new User();
            this.elementaryPolicyDocuments = _data["elementaryPolicyDocuments"]; // ? _data["elementaryPolicyDocuments"].map((item: any) => ElementaryPolicyDocument.fromJS(item)) : [];

            this.compulsoryPaymentDetails = _data["compulsoryPaymentDetails"];
            this.comprehensivePaymentDetails = _data["comprehensivePaymentDetails"];
            this.ridersPaymentDetails = _data["ridersPaymentDetails"];
        }
    }

    static fromJS(data: any): ElementaryPolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ElementaryPolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["offerId"] = this.offerId;
        data["suggestionId"] = this.suggestionId;
        data["protection"] = this.protection;
        data["sequenceId"] = this.sequenceId;
        data["agentDetailsId"] = this.agentDetailsId;
        data["agentDetails"] = this.agentDetails ? this.agentDetails.toJSON() : <any>undefined;
        data["insuranceCompanyRouteId"] = this.insuranceCompanyRouteId;
        data["insuranceCompanyRoute"] = this.insuranceCompanyRoute ? this.insuranceCompanyRoute.toJSON() : <any>undefined;
        data["routeId"] = this.routeId;
        data["routeComment"] = this.routeComment;
        data["collectiveId"] = this.collectiveId;
        data["temsAndCovers"] = this.temsAndCovers;
        data["additionalDetails"] = this.additionalDetails;
        data["comprehensiveInsurancePrice"] = this.comprehensiveInsurancePrice;
        data["compulsoryInsurancePrice"] = this.compulsoryInsurancePrice;
        data["compulsoryPremiumPaymentToken"] = this.compulsoryPremiumPaymentToken;
        data["comprehensivePremiumPaymentToken"] = this.comprehensivePremiumPaymentToken;
        data["comprehensiveInsuranceNumberOfPayments"] = this.comprehensiveInsuranceNumberOfPayments;
        data["compulsoryInsuranceNumberOfPayments"] = this.compulsoryInsuranceNumberOfPayments;
        data["riderNumberOfPayments"] = this.riderNumberOfPayments;

        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerLastName"] = this.ownerLastName;
        data["ownerFullName"] = this.ownerFullName;
        data["ownerIdentityType"] = this.ownerIdentityType;
        data["ownerIdentifier"] = this.ownerIdentifier;
        data["ownerDateOfBirth"] = this.ownerDateOfBirth ? this.ownerDateOfBirth.toISOString() : <any>undefined;
        data["ownerIdentityIssueDate"] = this.ownerIdentityIssueDate ? this.ownerIdentityIssueDate.toISOString() : <any>undefined;
        data["ownerMaritalStatus"] = this.ownerMaritalStatus;
        data["ownerGender"] = this.ownerGender;
        data["ownerContactDetailsId"] = this.ownerContactDetailsId;
        data["ownerAddressId"] = this.ownerAddressId;
        data["ownerContactDetails"] = this.ownerContactDetails ? this.ownerContactDetails.toJSON() : <any>undefined;
        data["ownerAddress"] = this.ownerAddress ? this.ownerAddress.toJSON() : <any>undefined;
        // data["mainDriverCustomerId"] = this.mainDriverCustomerId;
        // data["mainDriverCustomer"] = this.mainDriverCustomer ? this.mainDriverCustomer.toJSON() : <any>undefined;
        // data["youngDriverCustomerId"] = this.youngDriverCustomerId;
        // data["youngDriverCustomer"] = this.youngDriverCustomer ? this.youngDriverCustomer.toJSON() : <any>undefined;

        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverYoungIdentifier"] = this.driverYoungIdentifier;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungLastName"] = this.driverYoungLastName;
        data["driverYoungFirstName"] = this.driverYoungFirstName;

        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["driverMainIdentifier"] = this.driverMainIdentifier;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["driverMainLastName"] = this.driverMainLastName;
        data["driverMainFirstName"] = this.driverMainFirstName;


        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["authorizedToDrive"] = this.authorizedToDrive;
        data["passedTypeOfInsurance1"] = this.passedTypeOfInsurance1;
        data["sueNumber1"] = this.sueNumber1;
        data["insuranceCompanyId1"] = this.insuranceCompanyId1;
        data["passedTypeOfInsurance2"] = this.passedTypeOfInsurance2;
        data["sueNumber2"] = this.sueNumber2;
        data["insuranceCompanyId2"] = this.insuranceCompanyId2;
        data["passedTypeOfInsurance3"] = this.passedTypeOfInsurance3;
        data["sueNumber3"] = this.sueNumber3;
        data["insuranceCompanyId3"] = this.insuranceCompanyId3;
        data["passedTypeOfInsurance4"] = this.passedTypeOfInsurance4;
        data["sueNumber4"] = this.sueNumber4;
        data["insuranceCompanyId4"] = this.insuranceCompanyId4;
        data["bodyClaimsAmount"] = this.bodyClaimsAmount;
        data["revocationsAmount"] = this.revocationsAmount;
        data["noInsurance"] = this.noInsurance;
        data["newForOld"] = this.newForOld;
        data["insuranceType"] = this.insuranceType;
        data["payerFirstName"] = this.payerFirstName;
        data["payerLastName"] = this.payerLastName;
        data["isVehicleEnslaved"] = this.isVehicleEnslaved;
        data["involvedPartyType"] = this.involvedPartyType;
        data["involvedBank"] = this.involvedBank;
        data["involvedBankBranch"] = this.involvedBankBranch;
        data["involvedName"] = this.involvedName;
        data["involvedAddress"] = this.involvedAddress;
        data["comment"] = this.comment;
        data["compulsoryPremiumPaymentUrl"] = this.compulsoryPremiumPaymentUrl;
        data["comprehensivePremiumPaymentUrl"] = this.comprehensivePremiumPaymentUrl;
        data["riderPackages"] = this.riderPackages; // ? this.riderPackages.map((item: any) => item.toJSON()) : [];
        //data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["shielding"] = this.shielding;
        data["underwriterUserId"] = this.underwriterUserId;
        data["underwriterUser"] = this.underwriterUser ? this.underwriterUser.toJSON() : <any>undefined;
        data["elementaryPolicyDocuments"] = this.elementaryPolicyDocuments; // ? this.elementaryPolicyDocuments.map((item: any) => item.toJSON()) : [];
        data["compulsoryPaymentDetails"] = this.compulsoryPaymentDetails;
        data["comprehensivePaymentDetails"] = this.comprehensivePaymentDetails;
        data["ridersPaymentDetails"] = this.ridersPaymentDetails;

        return data;
    }
}


export class ElementaryPolicyDocument {
    id?: string; // Guid is represented as string in TypeScript
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    elementaryPolicyId?: string; // Guid is represented as string in TypeScript
    elementaryPolicy?: ElementaryPolicyModel;
    elementaryPolicyDocumentType?: number;
    fileSize?: string;
    filePath?: string;
    userId?: string; // Guid is represented as string in TypeScript
    user?: User;
}
/******************************** */



export class CustomerModel implements ICustomerModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    firstName?: string | undefined;
    lastName!: string;
    fullName!: string;
    dateOfBirth?: Date;
    identifier!: string;
    identityType?: IdentityType;
    agent!: User;
    handler!: User;
    fileNumber?: string | undefined;
    facebookUrl?: string | undefined;
    profession?: string | undefined;
    websiteUrl?: string | undefined;
    note?: string | undefined;
    gender?: Gender;
    employer?: Employer;
    popupMessage?: string | undefined;
    isSmoker?: boolean | undefined;
    clinic?: string | undefined;
    passportNumber?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicensIssueDate?: Date | undefined;
    driverLicenseType?: string | undefined;
    workplace?: string | undefined;
    businessTitle: string | undefined;
    jobTitle?: JobTitle;
    workerNumber?: string | undefined;
    ownerIsMainDriver?: boolean;
    salary?: string | undefined;
    identityIssueDate?: Date;
    powerOfAttorneySigned?: boolean | undefined;
    referrer?: string | undefined;
    maritalStatus?: MaritalStatus;
    customerContactDetails?: CustomerContactDetailsModel[] | undefined;
    customerAddresses?: CustomerAddressModel[] | undefined;
    customerGroups?: CustomerGroupModel[] | undefined;
    customerRemarks?: CustomerRemarkModel[] | undefined;
    vehicles?: VehicleDataModel[] | undefined;
    companyType?: string | undefined;
    policiesCount?: number | undefined;
    driverLicensSeniority?: number;
    age?: number;

    constructor(data?: ICustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agent = new User();
            this.handler = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.identifier = _data["identifier"];
            this.identityType = _data["identityType"];
            this.agent = _data["agent"] ? User.fromJS(_data["agent"]) : new User();
            this.handler = _data["handler"] ? User.fromJS(_data["handler"]) : new User();
            this.fileNumber = _data["fileNumber"];
            this.facebookUrl = _data["facebookUrl"];
            this.profession = _data["profession"];
            this.websiteUrl = _data["websiteUrl"];
            this.note = _data["note"];
            this.gender = _data["gender"];
            this.employer = _data["employer"] ? Employer.fromJS(_data["employer"]) : <any>undefined;
            this.popupMessage = _data["popupMessage"];
            this.isSmoker = _data["isSmoker"];
            this.clinic = _data["clinic"];
            this.passportNumber = _data["passportNumber"];
            this.driverLicenseNumber = _data["driverLicenseNumber"];
            this.driverLicensIssueDate = _data["driverLicensIssueDate"] ? new Date(_data["driverLicensIssueDate"].toString()) : <any>undefined;
            this.driverLicenseType = _data["driverLicenseType"];
            this.workplace = _data["workplace"];
            this.jobTitle = _data["jobTitle"];
            this.businessTitle = _data["businessTitle"];
            this.workerNumber = _data["workerNumber"];
            this.ownerIsMainDriver = _data["ownerIsMainDriver"];
            this.salary = _data["salary"];
            this.identityIssueDate = _data["identityIssueDate"] ? new Date(_data["identityIssueDate"].toString()) : <any>undefined;
            this.powerOfAttorneySigned = _data["powerOfAttorneySigned"];
            this.referrer = _data["referrer"];
            this.maritalStatus = _data["maritalStatus"];
            this.companyType = _data['companyType'];
            this.policiesCount = _data['policiesCount'];
            this.driverLicensSeniority = _data["driverLicensSeniority"];
            if (Array.isArray(_data["customerContactDetails"])) {
                this.customerContactDetails = [] as any;
                for (let item of _data["customerContactDetails"])
                    this.customerContactDetails!.push(CustomerContactDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["customerAddresses"])) {
                this.customerAddresses = [] as any;
                for (let item2 of _data["customerAddresses"])
                    this.customerAddresses!.push(CustomerAddressModel.fromJS(item2));
            }
            if (Array.isArray(_data["customerGroups"])) {
                this.customerGroups = [] as any;
                for (let item of _data["customerGroups"])
                    this.customerGroups!.push(CustomerGroupModel.fromJS(item));
            }
            if (Array.isArray(_data["customerRemarks"])) {
                this.customerRemarks = [] as any;
                for (let item of _data["customerRemarks"])
                    this.customerRemarks!.push(CustomerRemarkModel.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(VehicleDataModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["identifier"] = this.identifier;
        data["identityType"] = this.identityType;
        data["agent"] = this.agent && this.agent.toJSON ? this.agent.toJSON() : <any>undefined;
        data["handler"] = this.handler && this.handler.toJSON ? this.handler.toJSON() : <any>undefined;
        data["fileNumber"] = this.fileNumber;
        data["facebookUrl"] = this.facebookUrl;
        data["profession"] = this.profession;
        data["websiteUrl"] = this.websiteUrl;
        data["note"] = this.note;
        data["gender"] = this.gender;
        data["employer"] = this.employer && this.employer.toJSON ? this.employer.toJSON() : <any>undefined;
        data["popupMessage"] = this.popupMessage;
        data["isSmoker"] = this.isSmoker;
        data["clinic"] = this.clinic;
        data["passportNumber"] = this.passportNumber;
        data["driverLicenseNumber"] = this.driverLicenseNumber;
        data["driverLicensIssueDate"] = this.driverLicensIssueDate ? this.driverLicensIssueDate.toISOString() : <any>undefined;
        data["driverLicenseType"] = this.driverLicenseType;
        data["workplace"] = this.workplace;
        data["jobTitle"] = this.jobTitle;
        data["businessTitle"] = this.businessTitle;
        data["workerNumber"] = this.workerNumber;
        data["ownerIsMainDriver"] = this.ownerIsMainDriver;
        data["salary"] = this.salary;
        data["identityIssueDate"] = this.identityIssueDate ? this.identityIssueDate.toISOString() : <any>undefined;
        data["powerOfAttorneySigned"] = this.powerOfAttorneySigned;
        data["referrer"] = this.referrer;
        data["maritalStatus"] = this.maritalStatus;
        data['companyType'] = this.companyType;
        data['policiesCount'] = this.companyType;
        data["driverLicensSeniority"] = this.driverLicensSeniority;

        if (Array.isArray(this.customerContactDetails)) {
            data["customerContactDetails"] = [];
            for (let item of this.customerContactDetails) {
                if (item && item.toJSON) {
                    data["customerContactDetails"].push(item.toJSON());
                }
            }
        }
        if (Array.isArray(this.customerAddresses)) {
            data["customerAddresses"] = [];
            for (let item2 of this.customerAddresses) {
                const address: CustomerAddressModel = new CustomerAddressModel(item2);
                if (address && address.toJSON) {
                    // //console.log("Current item:", item2);
                    // //console.log("Current item:", address.toJSON());
                    data["customerAddresses"].push(address.toJSON());
                }
            }
        }
        if (Array.isArray(this.customerGroups)) {
            data["customerGroups"] = [];
            for (let item of this.customerGroups)
                data["customerGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.customerRemarks)) {
            data["customerRemarks"] = [];
            for (let item of this.customerRemarks)
                data["customerRemarks"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    firstName?: string | undefined;
    lastName: string;
    fullName: string;
    dateOfBirth?: Date;
    identifier: string;
    identityType?: IdentityType;
    agent: User;
    handler: User;
    fileNumber?: string | undefined;
    facebookUrl?: string | undefined;
    profession?: string | undefined;
    websiteUrl?: string | undefined;
    note?: string | undefined;
    gender?: Gender;
    employer?: Employer;
    popupMessage?: string | undefined;
    isSmoker?: boolean | undefined;
    clinic?: string | undefined;
    passportNumber?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicensIssueDate?: Date | undefined;
    driverLicenseType?: string | undefined;
    workplace?: string | undefined;
    jobTitle?: JobTitle;
    workerNumber?: string | undefined;
    ownerIsMainDriver?: boolean;
    salary?: string | undefined;
    identityIssueDate?: Date;
    powerOfAttorneySigned?: boolean | undefined;
    referrer?: string | undefined;
    maritalStatus?: MaritalStatus;
    customerContactDetails?: CustomerContactDetailsModel[] | undefined;
    customerAddresses?: CustomerAddressModel[] | undefined;
    customerGroups?: CustomerGroupModel[] | undefined;
    customerRemarks?: CustomerRemarkModel[] | undefined;
    vehicles?: VehicleDataModel[] | undefined;
    policiesCount?: number | undefined;
}

export class RenewalPrices {
    id?: string | undefined;
    priceCasco?: number | undefined;
    priceCompulsory?: number | undefined;

    constructor(data?: RenewalPrices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {

            this.id = _data["id"];
            this.priceCasco = _data["priceCasco"];
            this.priceCompulsory = _data["priceCompulsory"];

        }
    }

    static fromJS(data: any): CustomerPersonalModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPersonalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};

        data["id"] = this.id;
        data["priceCasco"] = this.priceCasco;
        data["priceCompulsory"] = this.priceCompulsory;

        return data;
    }
}

export class CustomerPersonalModel implements ICustomerPersonalModel {
    customerData?: CustomerModel;
    agents?: UserModel[] | undefined;
    handlers?: UserModel[] | undefined;
    employers?: EmployerModel[] | undefined;
    groups?: GroupModel[] | undefined;
    customerRemarks?: CustomerRemarkModel[] | undefined;
    newRemark?: string | undefined;
    policyCount?: number | undefined;

    constructor(data?: ICustomerPersonalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerData = _data["customerData"] ? CustomerModel.fromJS(_data["customerData"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["handlers"])) {
                this.handlers = [] as any;
                for (let item of _data["handlers"])
                    this.handlers!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(EmployerModel.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupModel.fromJS(item));
            }
            if (Array.isArray(_data["customerRemarks"])) {
                this.customerRemarks = [] as any;
                for (let item of _data["customerRemarks"])
                    this.customerRemarks!.push(CustomerRemarkModel.fromJS(item));
            }
            this.newRemark = _data["newRemark"];
            this.policyCount = _data["policyCount"];

        }
    }

    static fromJS(data: any): CustomerPersonalModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPersonalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerData"] = this.customerData ? this.customerData.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.handlers)) {
            data["handlers"] = [];
            for (let item of this.handlers)
                data["handlers"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.customerRemarks)) {
            data["customerRemarks"] = [];
            for (let item of this.customerRemarks)
                data["customerRemarks"].push(item.toJSON());
        }
        data["newRemark"] = this.newRemark;
        data["policyCount"] = this.policyCount;

        return data;
    }
}

export interface ICustomerPersonalModel {
    customerData?: CustomerModel;
    agents?: UserModel[] | undefined;
    handlers?: UserModel[] | undefined;
    employers?: EmployerModel[] | undefined;
    groups?: GroupModel[] | undefined;
    customerRemarks?: CustomerRemarkModel[] | undefined;
    newRemark?: string | undefined;
    policyCount?: number | undefined;

}

export class CustomerRemark implements ICustomerRemark {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    text?: string | undefined;
    userId?: string;
    user?: User;
    creationDate?: Date;
    customerId?: string;
    customer?: Customer;

    constructor(data?: ICustomerRemark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.text = _data["text"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerRemark {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRemark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["text"] = this.text;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerRemark {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    text?: string | undefined;
    userId?: string;
    user?: User;
    creationDate?: Date;
    customerId?: string;
    customer?: Customer;
}

export class CustomerRemarkModel implements ICustomerRemarkModel {
    id?: string;
    customerId?: string;
    text?: string | undefined;
    user?: UserModel;
    creationDate?: Date;

    constructor(data?: ICustomerRemarkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.text = _data["text"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerRemarkModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRemarkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["text"] = this.text;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomerRemarkModel {
    id?: string;
    customerId?: string;
    text?: string | undefined;
    user?: UserModel;
    creationDate?: Date;
}

export class CustomerWhatsappModel implements ICustomerWhatsappModel {
    items?: CustomerWhatsappModelItem[] | undefined;

    constructor(data?: ICustomerWhatsappModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerWhatsappModelItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerWhatsappModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWhatsappModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerWhatsappModel {
    items?: CustomerWhatsappModelItem[] | undefined;
}

export class CustomerWhatsappModelItem implements ICustomerWhatsappModelItem {
    id?: string;
    createdDate?: Date;
    text?: string | undefined;
    reciveOrSent?: boolean;

    constructor(data?: ICustomerWhatsappModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.text = _data["text"];
            this.reciveOrSent = _data["reciveOrSent"];
        }
    }

    static fromJS(data: any): CustomerWhatsappModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWhatsappModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["text"] = this.text;
        data["reciveOrSent"] = this.reciveOrSent;
        return data;
    }
}

export interface ICustomerWhatsappModelItem {
    id?: string;
    createdDate?: Date;
    text?: string | undefined;
    reciveOrSent?: boolean;
}

export class CustomerWhatsappTabModel implements ICustomerWhatsappTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: CustomerWhatsappModel[] | undefined;

    constructor(data?: ICustomerWhatsappTabModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerWhatsappModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerWhatsappTabModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWhatsappTabModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerWhatsappTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: CustomerWhatsappModel[] | undefined;
}

export class DashboardBranchModel implements IDashboardBranchModel {
    branch?: BranchModel;
    new?: Amouts;
    used?: Amouts;
    selected?: Amouts;
    all?: Amouts;
    manager?: DashboardManagerUserModel;

    constructor(data?: IDashboardBranchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branch = _data["branch"] ? BranchModel.fromJS(_data["branch"]) : <any>undefined;
            this.new = _data["new"] ? Amouts.fromJS(_data["new"]) : <any>undefined;
            this.used = _data["used"] ? Amouts.fromJS(_data["used"]) : <any>undefined;
            this.selected = _data["selected"] ? Amouts.fromJS(_data["selected"]) : <any>undefined;
            this.all = _data["all"] ? Amouts.fromJS(_data["all"]) : <any>undefined;
            this.manager = _data["manager"] ? DashboardManagerUserModel.fromJS(_data["manager"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardBranchModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardBranchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["new"] = this.new ? this.new.toJSON() : <any>undefined;
        data["used"] = this.used ? this.used.toJSON() : <any>undefined;
        data["selected"] = this.selected ? this.selected.toJSON() : <any>undefined;
        data["all"] = this.all ? this.all.toJSON() : <any>undefined;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardBranchModel {
    branch?: BranchModel;
    new?: Amouts;
    used?: Amouts;
    selected?: Amouts;
    all?: Amouts;
    manager?: DashboardManagerUserModel;
}

export class DashboardManagerUserModel implements IDashboardManagerUserModel {
    user?: UserModel;
    newLeads?: Amouts;
    usedLeads?: Amouts;
    selectLeads?: Amouts;
    allLeads?: Amouts;

    constructor(data?: IDashboardManagerUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.newLeads = _data["newLeads"] ? Amouts.fromJS(_data["newLeads"]) : <any>undefined;
            this.usedLeads = _data["usedLeads"] ? Amouts.fromJS(_data["usedLeads"]) : <any>undefined;
            this.selectLeads = _data["selectLeads"] ? Amouts.fromJS(_data["selectLeads"]) : <any>undefined;
            this.allLeads = _data["allLeads"] ? Amouts.fromJS(_data["allLeads"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardManagerUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardManagerUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["newLeads"] = this.newLeads ? this.newLeads.toJSON() : <any>undefined;
        data["usedLeads"] = this.usedLeads ? this.usedLeads.toJSON() : <any>undefined;
        data["selectLeads"] = this.selectLeads ? this.selectLeads.toJSON() : <any>undefined;
        data["allLeads"] = this.allLeads ? this.allLeads.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardManagerUserModel {
    user?: UserModel;
    newLeads?: Amouts;
    usedLeads?: Amouts;
    selectLeads?: Amouts;
    allLeads?: Amouts;
}

export class DashboardModel implements IDashboardModel {
    mainBranches?: DashboardBranchModel[] | undefined;
    branches?: DashboardBranchModel[] | undefined;
    stationUsers?: DashboardUserModel[] | undefined;
    leads?: LeadModel[] | undefined;
    allBranchesFromRoot?: boolean;

    constructor(data?: IDashboardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mainBranches"])) {
                this.mainBranches = [] as any;
                for (let item of _data["mainBranches"])
                    this.mainBranches!.push(DashboardBranchModel.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(DashboardBranchModel.fromJS(item));
            }
            if (Array.isArray(_data["stationUsers"])) {
                this.stationUsers = [] as any;
                for (let item of _data["stationUsers"])
                    this.stationUsers!.push(DashboardUserModel.fromJS(item));
            }
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(LeadModel.fromJS(item));
            }
            this.allBranchesFromRoot = _data["allBranchesFromRoot"];
        }
    }

    static fromJS(data: any): DashboardModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mainBranches)) {
            data["mainBranches"] = [];
            for (let item of this.mainBranches)
                data["mainBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.stationUsers)) {
            data["stationUsers"] = [];
            for (let item of this.stationUsers)
                data["stationUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        data["allBranchesFromRoot"] = this.allBranchesFromRoot;
        return data;
    }
}

export interface IDashboardModel {
    mainBranches?: DashboardBranchModel[] | undefined;
    branches?: DashboardBranchModel[] | undefined;
    stationUsers?: DashboardUserModel[] | undefined;
    leads?: LeadModel[] | undefined;
    allBranchesFromRoot?: boolean;
}

export class DashBoardStationModel implements IDashBoardStationModel {
    details?: DashboardStationUserModel1[] | undefined;
    branches?: BranchesDepartmentsUsersModel;
    branchId?: string;

    constructor(data?: IDashBoardStationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DashboardStationUserModel1.fromJS(item));
            }
            this.branches = _data["branches"] ? BranchesDepartmentsUsersModel.fromJS(_data["branches"]) : <any>undefined;
            this.branchId = _data["branchId"];
        }
    }

    static fromJS(data: any): DashBoardStationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashBoardStationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["branches"] = this.branches ? this.branches.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        return data;
    }
}

export interface IDashBoardStationModel {
    details?: DashboardStationUserModel1[] | undefined;
    branches?: BranchesDepartmentsUsersModel;
    branchId?: string;
}

export class DashboardStationsFilter implements IDashboardStationsFilter {
    branchId?: string;
    createDateFrom?: Date | undefined;
    createDateTo?: Date | undefined;
    closeDateFrom?: Date | undefined;
    closeDateTo?: Date | undefined;
    deliveryDateFrom?: Date | undefined;
    deliveryDateTo?: Date | undefined;
    openBranches?: string[] | undefined;

    constructor(data?: IDashboardStationsFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.createDateFrom = _data["createDateFrom"] ? new Date(_data["createDateFrom"].toString()) : <any>undefined;
            this.createDateTo = _data["createDateTo"] ? new Date(_data["createDateTo"].toString()) : <any>undefined;
            this.closeDateFrom = _data["closeDateFrom"] ? new Date(_data["closeDateFrom"].toString()) : <any>undefined;
            this.closeDateTo = _data["closeDateTo"] ? new Date(_data["closeDateTo"].toString()) : <any>undefined;
            this.deliveryDateFrom = _data["deliveryDateFrom"] ? new Date(_data["deliveryDateFrom"].toString()) : <any>undefined;
            this.deliveryDateTo = _data["deliveryDateTo"] ? new Date(_data["deliveryDateTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["openBranches"])) {
                this.openBranches = [] as any;
                for (let item of _data["openBranches"])
                    this.openBranches!.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardStationsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStationsFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["createDateFrom"] = this.createDateFrom ? this.createDateFrom.toISOString() : <any>undefined;
        data["createDateTo"] = this.createDateTo ? this.createDateTo.toISOString() : <any>undefined;
        data["closeDateFrom"] = this.closeDateFrom ? this.closeDateFrom.toISOString() : <any>undefined;
        data["closeDateTo"] = this.closeDateTo ? this.closeDateTo.toISOString() : <any>undefined;
        data["deliveryDateFrom"] = this.deliveryDateFrom ? this.deliveryDateFrom.toISOString() : <any>undefined;
        data["deliveryDateTo"] = this.deliveryDateTo ? this.deliveryDateTo.toISOString() : <any>undefined;
        if (Array.isArray(this.openBranches)) {
            data["openBranches"] = [];
            for (let item of this.openBranches)
                data["openBranches"].push(item);
        }
        return data;
    }
}

export interface IDashboardStationsFilter {
    branchId?: string;
    createDateFrom?: Date | undefined;
    createDateTo?: Date | undefined;
    closeDateFrom?: Date | undefined;
    closeDateTo?: Date | undefined;
    deliveryDateFrom?: Date | undefined;
    deliveryDateTo?: Date | undefined;
    openBranches?: string[] | undefined;
}

export class DashboardStationUserModel implements IDashboardStationUserModel {
    user?: UserModel;
    openLeads?: number;
    closeLeads?: number;
    closeLeadsPercent?: number;

    constructor(data?: IDashboardStationUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.openLeads = _data["openLeads"];
            this.closeLeads = _data["closeLeads"];
            this.closeLeadsPercent = _data["closeLeadsPercent"];
        }
    }

    static fromJS(data: any): DashboardStationUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStationUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["openLeads"] = this.openLeads;
        data["closeLeads"] = this.closeLeads;
        data["closeLeadsPercent"] = this.closeLeadsPercent;
        return data;
    }
}

export interface IDashboardStationUserModel {
    user?: UserModel;
    openLeads?: number;
    closeLeads?: number;
    closeLeadsPercent?: number;
}

export class DashboardStationUserModel1 implements IDashboardStationUserModel1 {
    user?: UserModel;
    newLeads?: Amouts;
    usedLeads?: Amouts;
    selectLeads?: Amouts;
    all?: Amouts;

    constructor(data?: IDashboardStationUserModel1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.newLeads = _data["newLeads"] ? Amouts.fromJS(_data["newLeads"]) : <any>undefined;
            this.usedLeads = _data["usedLeads"] ? Amouts.fromJS(_data["usedLeads"]) : <any>undefined;
            this.selectLeads = _data["selectLeads"] ? Amouts.fromJS(_data["selectLeads"]) : <any>undefined;
            this.all = _data["all"] ? Amouts.fromJS(_data["all"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardStationUserModel1 {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStationUserModel1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["newLeads"] = this.newLeads ? this.newLeads.toJSON() : <any>undefined;
        data["usedLeads"] = this.usedLeads ? this.usedLeads.toJSON() : <any>undefined;
        data["selectLeads"] = this.selectLeads ? this.selectLeads.toJSON() : <any>undefined;
        data["all"] = this.all ? this.all.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardStationUserModel1 {
    user?: UserModel;
    newLeads?: Amouts;
    usedLeads?: Amouts;
    selectLeads?: Amouts;
    all?: Amouts;
}

export class DashboardUserModel implements IDashboardUserModel {
    user?: UserModel;
    openLeads?: number;
    closeLeads?: number;
    closeLeadsPercent?: number;

    constructor(data?: IDashboardUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.openLeads = _data["openLeads"];
            this.closeLeads = _data["closeLeads"];
            this.closeLeadsPercent = _data["closeLeadsPercent"];
        }
    }

    static fromJS(data: any): DashboardUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["openLeads"] = this.openLeads;
        data["closeLeads"] = this.closeLeads;
        data["closeLeadsPercent"] = this.closeLeadsPercent;
        return data;
    }
}

export interface IDashboardUserModel {
    user?: UserModel;
    openLeads?: number;
    closeLeads?: number;
    closeLeadsPercent?: number;
}

export class DecoderFallback implements IDecoderFallback {
    readonly maxCharCount?: number;

    constructor(data?: IDecoderFallback) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).maxCharCount = _data["maxCharCount"];
        }
    }

    static fromJS(data: any): DecoderFallback {
        data = typeof data === 'object' ? data : {};
        let result = new DecoderFallback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxCharCount"] = this.maxCharCount;
        return data;
    }
}

export interface IDecoderFallback {
    maxCharCount?: number;
}

export class Discount implements IDiscount {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompany;
    routes?: string | undefined;
    sum?: number;
    amountType?: AmountType;
    defaultValue?: number;
    autoActive?: boolean;
    branchId?: number;
    commercialVehicle?: boolean;
    privateVehicle?: boolean;
    comprehensiveInsurance?: boolean;
    thirdPartyInsurance?: boolean;
    noPassedInsurance?: boolean;
    sueExists?: boolean;
    newDrivers?: boolean;
    driverAgeMin?: number;
    driverAgeMax?: number;
    sequenceId?: number;
    feeParticipation?: number;
    ayalonHanachatHatama?: number;
    ayalonHanachatSochen?: number;
    shlomoDiscountType?: ShlomoDiscountType;
    collectiveNumber?: number | undefined;

    constructor(data?: IDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.routes = _data["routes"];
            this.sum = _data["sum"];
            this.amountType = _data["amountType"];
            this.defaultValue = _data["defaultValue"];
            this.autoActive = _data["autoActive"];
            this.branchId = _data["branchId"];
            this.commercialVehicle = _data["commercialVehicle"];
            this.privateVehicle = _data["privateVehicle"];
            this.comprehensiveInsurance = _data["comprehensiveInsurance"];
            this.thirdPartyInsurance = _data["thirdPartyInsurance"];
            this.noPassedInsurance = _data["noPassedInsurance"];
            this.sueExists = _data["sueExists"];
            this.newDrivers = _data["newDrivers"];
            this.driverAgeMin = _data["driverAgeMin"];
            this.driverAgeMax = _data["driverAgeMax"];
            this.sequenceId = _data["sequenceId"];
            this.feeParticipation = _data["feeParticipation"];
            this.ayalonHanachatHatama = _data["ayalonHanachatHatama"];
            this.ayalonHanachatSochen = _data["ayalonHanachatSochen"];
            this.shlomoDiscountType = _data["shlomoDiscountType"];
            this.collectiveNumber = _data["collectiveNumber"];
        }
    }

    static fromJS(data: any): Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["routes"] = this.routes;
        data["sum"] = this.sum;
        data["amountType"] = this.amountType;
        data["defaultValue"] = this.defaultValue;
        data["autoActive"] = this.autoActive;
        data["branchId"] = this.branchId;
        data["commercialVehicle"] = this.commercialVehicle;
        data["privateVehicle"] = this.privateVehicle;
        data["comprehensiveInsurance"] = this.comprehensiveInsurance;
        data["thirdPartyInsurance"] = this.thirdPartyInsurance;
        data["noPassedInsurance"] = this.noPassedInsurance;
        data["sueExists"] = this.sueExists;
        data["newDrivers"] = this.newDrivers;
        data["driverAgeMin"] = this.driverAgeMin;
        data["driverAgeMax"] = this.driverAgeMax;
        data["sequenceId"] = this.sequenceId;
        data["feeParticipation"] = this.feeParticipation;
        data["ayalonHanachatHatama"] = this.ayalonHanachatHatama;
        data["ayalonHanachatSochen"] = this.ayalonHanachatSochen;
        data["shlomoDiscountType"] = this.shlomoDiscountType;
        data["collectiveNumber"] = this.collectiveNumber;
        return data;
    }
}

export interface IDiscount {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompany;
    routes?: string | undefined;
    sum?: number;
    amountType?: AmountType;
    defaultValue?: number;
    autoActive?: boolean;
    branchId?: number;
    commercialVehicle?: boolean;
    privateVehicle?: boolean;
    comprehensiveInsurance?: boolean;
    thirdPartyInsurance?: boolean;
    noPassedInsurance?: boolean;
    sueExists?: boolean;
    newDrivers?: boolean;
    driverAgeMin?: number;
    driverAgeMax?: number;
    sequenceId?: number;
    feeParticipation?: number;
    ayalonHanachatHatama?: number;
    ayalonHanachatSochen?: number;
    shlomoDiscountType?: ShlomoDiscountType;
    collectiveNumber?: number | undefined;
}

export class DiscountBankManagerData implements IDiscountBankManagerData {
    allocations?: AllocationDiscountBankModel[] | undefined;
    canAllocate?: boolean;

    constructor(data?: IDiscountBankManagerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(AllocationDiscountBankModel.fromJS(item));
            }
            this.canAllocate = _data["canAllocate"];
        }
    }

    static fromJS(data: any): DiscountBankManagerData {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountBankManagerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item.toJSON());
        }
        data["canAllocate"] = this.canAllocate;
        return data;
    }
}

export interface IDiscountBankManagerData {
    allocations?: AllocationDiscountBankModel[] | undefined;
    canAllocate?: boolean;
}

export class DiscountModel implements IDiscountModel {
    id?: string;
    name?: string | undefined;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompanyModel;
    routes?: string[] | undefined;
    routeDatas?: InsuranceCompanyRouteModel[] | undefined;
    sum?: number;
    minSum?: number;
    forceActive?: boolean;
    discountType?: DiscountType;
    selectValue?: string;
    amountType?: AmountType;
    defaultValue?: number;
    autoActive?: YesNo;
    branchId?: number;
    commercialVehicle?: boolean;
    privateVehicle?: boolean;
    comprehensiveInsurance?: boolean;
    thirdPartyInsurance?: boolean;
    noPassedInsurance?: YesNo;
    sueExists?: YesNo;
    newDrivers?: YesNo;
    driverAgeMin?: number;
    driverAgeMax?: number;
    sequenceId?: number;
    feeParticipation?: number;
    ayalonHanachatHatama?: number;
    ayalonHanachatSochen?: number;
    shlomoDiscountType?: ShlomoDiscountType;
    collectiveNumber?: number | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    routesList?: SelectListItem[] | undefined;
    companies?: InsuranceCompanyModel[] | undefined;

    constructor(data?: IDiscountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["insuranceCompany"]) : <any>undefined;
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(item);
            }
            if (Array.isArray(_data["routeDatas"])) {
                this.routeDatas = [] as any;
                for (let item of _data["routeDatas"])
                    this.routeDatas!.push(InsuranceCompanyRouteModel.fromJS(item));
            }
            this.sum = _data["sum"];
            this.minSum = _data["minSum"];
            this.forceActive = _data["forceActive"];
            this.discountType = _data["discountType"];
            this.selectValue = _data["selectValue"];
            this.amountType = _data["amountType"];
            this.defaultValue = _data["defaultValue"];
            this.autoActive = _data["autoActive"];
            this.branchId = _data["branchId"];
            this.commercialVehicle = _data["commercialVehicle"];
            this.privateVehicle = _data["privateVehicle"];
            this.comprehensiveInsurance = _data["comprehensiveInsurance"];
            this.thirdPartyInsurance = _data["thirdPartyInsurance"];
            this.noPassedInsurance = _data["noPassedInsurance"];
            this.sueExists = _data["sueExists"];
            this.newDrivers = _data["newDrivers"];
            this.driverAgeMin = _data["driverAgeMin"];
            this.driverAgeMax = _data["driverAgeMax"];
            this.sequenceId = _data["sequenceId"];
            this.feeParticipation = _data["feeParticipation"];
            this.ayalonHanachatHatama = _data["ayalonHanachatHatama"];
            this.ayalonHanachatSochen = _data["ayalonHanachatSochen"];
            this.shlomoDiscountType = _data["shlomoDiscountType"];
            this.collectiveNumber = _data["collectiveNumber"];
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["routesList"])) {
                this.routesList = [] as any;
                for (let item of _data["routesList"])
                    this.routesList!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(InsuranceCompanyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiscountModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item);
        }
        if (Array.isArray(this.routeDatas)) {
            data["routeDatas"] = [];
            for (let item of this.routeDatas)
                data["routeDatas"].push(item.toJSON());
        }
        data["sum"] = this.sum;
        data["minSum"] = this.minSum;
        data["forceActive"] = this.forceActive;
        data["discountType"] = this.discountType;
        data["selectValue"] = this.selectValue;
        data["amountType"] = this.amountType;
        data["defaultValue"] = this.defaultValue;
        data["autoActive"] = this.autoActive;
        data["branchId"] = this.branchId;
        data["commercialVehicle"] = this.commercialVehicle;
        data["privateVehicle"] = this.privateVehicle;
        data["comprehensiveInsurance"] = this.comprehensiveInsurance;
        data["thirdPartyInsurance"] = this.thirdPartyInsurance;
        data["noPassedInsurance"] = this.noPassedInsurance;
        data["sueExists"] = this.sueExists;
        data["newDrivers"] = this.newDrivers;
        data["driverAgeMin"] = this.driverAgeMin;
        data["driverAgeMax"] = this.driverAgeMax;
        data["sequenceId"] = this.sequenceId;
        data["feeParticipation"] = this.feeParticipation;
        data["ayalonHanachatHatama"] = this.ayalonHanachatHatama;
        data["ayalonHanachatSochen"] = this.ayalonHanachatSochen;
        data["shlomoDiscountType"] = this.shlomoDiscountType;
        data["collectiveNumber"] = this.collectiveNumber;
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.routesList)) {
            data["routesList"] = [];
            for (let item of this.routesList)
                data["routesList"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDiscountModel {
    id?: string;
    name?: string | undefined;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompanyModel;
    routes?: string[] | undefined;
    routeDatas?: InsuranceCompanyRouteModel[] | undefined;
    sum?: number;
    amountType?: AmountType;
    defaultValue?: number;
    autoActive?: YesNo;
    branchId?: number;
    commercialVehicle?: boolean;
    privateVehicle?: boolean;
    comprehensiveInsurance?: boolean;
    thirdPartyInsurance?: boolean;
    noPassedInsurance?: YesNo;
    sueExists?: YesNo;
    newDrivers?: YesNo;
    driverAgeMin?: number;
    driverAgeMax?: number;
    sequenceId?: number;
    feeParticipation?: number;
    ayalonHanachatHatama?: number;
    ayalonHanachatSochen?: number;
    shlomoDiscountType?: ShlomoDiscountType;
    collectiveNumber?: number | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    routesList?: SelectListItem[] | undefined;
    companies?: InsuranceCompanyModel[] | undefined;
}

export class Document implements IDocument {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    path?: string | undefined;
    size?: string | undefined;
    documentType?: DocumentType;
    createdById?: string;
    createdBy?: User;
    policyId?: string | undefined;
    policy?: Policy;
    sueId?: string | undefined;
    customer?: Customer;
    customerId?: string | undefined;
    sue?: Sue;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.path = _data["path"];
            this.size = _data["size"];
            this.documentType = _data["documentType"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
            this.policyId = _data["policyId"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"]) : <any>undefined;
            this.sueId = _data["sueId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.sue = _data["sue"] ? Sue.fromJS(_data["sue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["path"] = this.path;
        data["size"] = this.size;
        data["documentType"] = this.documentType;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["sueId"] = this.sueId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["sue"] = this.sue ? this.sue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocument {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    path?: string | undefined;
    size?: string | undefined;
    documentType?: DocumentType;
    createdById?: string;
    createdBy?: User;
    policyId?: string | undefined;
    policy?: Policy;
    sueId?: string | undefined;
    customer?: Customer;
    customerId?: string | undefined;
    sue?: Sue;
}

export class DocumentationOutboxModelForUpsert implements IDocumentationOutboxModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    startDate?: Date;
    startTime?: TimeSpan;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;

    constructor(data?: IDocumentationOutboxModelForUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.alertHour = _data["alertHour"] ? TimeSpan.fromJS(_data["alertHour"]) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.treatmentType = _data["treatmentType"];
            this.customerId = _data["customerId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(SelectListItem.fromJS(item));
            }
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectListItem.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.topic = _data["topic"];
            this.note = _data["note"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentationOutboxModelForUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationOutboxModelForUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["alertHour"] = this.alertHour ? this.alertHour.toJSON() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["treatmentType"] = this.treatmentType;
        data["customerId"] = this.customerId;
        data["priority"] = this.priority;
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item.toJSON());
        }
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["topic"] = this.topic;
        data["note"] = this.note;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentationOutboxModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    startDate?: Date;
    startTime?: TimeSpan;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
}

export class DocumentModel implements IDocumentModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    path?: string | undefined;
    size?: string | undefined;
    documentType?: DocumentType;
    createdById?: string;
    createdBy?: UserModel;
    policyId?: string | undefined;
    policy?: PolicyModel;
    sueId?: string | undefined;
    sue?: SueModel;
    file?: string | undefined;

    constructor(data?: IDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.path = _data["path"];
            this.size = _data["size"];
            this.documentType = _data["documentType"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? UserModel.fromJS(_data["createdBy"]) : <any>undefined;
            this.policyId = _data["policyId"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            this.sueId = _data["sueId"];
            this.sue = _data["sue"] ? SueModel.fromJS(_data["sue"]) : <any>undefined;
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["path"] = this.path;
        data["size"] = this.size;
        data["documentType"] = this.documentType;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["sueId"] = this.sueId;
        data["sue"] = this.sue ? this.sue.toJSON() : <any>undefined;
        data["file"] = this.file;
        return data;
    }
}

export interface IDocumentModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    path?: string | undefined;
    size?: string | undefined;
    documentType?: DocumentType;
    createdById?: string;
    createdBy?: UserModel;
    policyId?: string | undefined;
    policy?: PolicyModel;
    sueId?: string | undefined;
    sue?: SueModel;
    file?: string | undefined;
}

export class DocumentsTab implements IDocumentsTab {
    sueId?: string | undefined;
    policyId?: string | undefined;
    documents?: DocumentModel[] | undefined;

    constructor(data?: IDocumentsTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sueId = _data["sueId"];
            this.policyId = _data["policyId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentsTab {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sueId"] = this.sueId;
        data["policyId"] = this.policyId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentsTab {
    sueId?: string | undefined;
    policyId?: string | undefined;
    documents?: DocumentModel[] | undefined;
}

/** 0 = Thorough, 1 = RoadServices, 2 = Claims, 3 = AdditionalInsurance, 4 = General */
export enum DocumentTopicType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

/** 0 = PDF, 1 = JPG */
export enum DocumentType {
    _0 = 0,
    _1 = 1,
}

export class DriverAndVehicleDetailsTab implements IDriverAndVehicleDetailsTab {
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    sueId?: string;
    sueCarAndDriverInfoId?: string;
    driverFullName?: string | undefined;
    driverIdentity?: string | undefined;
    driverBirthDate?: Date;
    driverAddress?: string | undefined;
    driverPhoneNumber?: string | undefined;
    driverMobileNumber?: string | undefined;
    driverOwnerRelation?: string | undefined;
    driverLicensIssueDate?: Date | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicenseType?: string | undefined;
    vehicleId?: string;
    vehicle?: VehicleDataModel;
    vehicleType?: string | undefined;
    vehicleYearOfProduction?: number;
    vehicleLicensePlate?: string | undefined;
    vehicleGearboxType?: GearboxType;
    licenseTypes?: SelectListItem[] | undefined;
    yearsOfProduction?: SelectListItem[] | undefined;
    gearboxTypes?: SelectListItem[] | undefined;
    vehicleTypes?: SelectListItem[] | undefined;
    extrasMultiSelect?: SelectListItem[] | undefined;

    constructor(data?: IDriverAndVehicleDetailsTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerModel = _data["customerModel"] ? CustomerModel.fromJS(_data["customerModel"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorPropertyModel.fromJS(item));
            }
            this.sueId = _data["sueId"];
            this.sueCarAndDriverInfoId = _data["sueCarAndDriverInfoId"];
            this.driverFullName = _data["driverFullName"];
            this.driverIdentity = _data["driverIdentity"];
            this.driverBirthDate = _data["driverBirthDate"] ? new Date(_data["driverBirthDate"].toString()) : <any>undefined;
            this.driverAddress = _data["driverAddress"];
            this.driverPhoneNumber = _data["driverPhoneNumber"];
            this.driverMobileNumber = _data["driverMobileNumber"];
            this.driverOwnerRelation = _data["driverOwnerRelation"];
            this.driverLicensIssueDate = _data["driverLicensIssueDate"] ? new Date(_data["driverLicensIssueDate"].toString()) : <any>undefined;
            this.driverLicenseNumber = _data["driverLicenseNumber"];
            this.driverLicenseType = _data["driverLicenseType"];
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? VehicleDataModel.fromJS(_data["vehicle"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.vehicleYearOfProduction = _data["vehicleYearOfProduction"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleGearboxType = _data["vehicleGearboxType"];
            if (Array.isArray(_data["licenseTypes"])) {
                this.licenseTypes = [] as any;
                for (let item of _data["licenseTypes"])
                    this.licenseTypes!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["yearsOfProduction"])) {
                this.yearsOfProduction = [] as any;
                for (let item of _data["yearsOfProduction"])
                    this.yearsOfProduction!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["gearboxTypes"])) {
                this.gearboxTypes = [] as any;
                for (let item of _data["gearboxTypes"])
                    this.gearboxTypes!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["vehicleTypes"])) {
                this.vehicleTypes = [] as any;
                for (let item of _data["vehicleTypes"])
                    this.vehicleTypes!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["extrasMultiSelect"])) {
                this.extrasMultiSelect = [] as any;
                for (let item of _data["extrasMultiSelect"])
                    this.extrasMultiSelect!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DriverAndVehicleDetailsTab {
        data = typeof data === 'object' ? data : {};
        let result = new DriverAndVehicleDetailsTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerModel"] = this.customerModel ? this.customerModel.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["sueId"] = this.sueId;
        data["sueCarAndDriverInfoId"] = this.sueCarAndDriverInfoId;
        data["driverFullName"] = this.driverFullName;
        data["driverIdentity"] = this.driverIdentity;
        data["driverBirthDate"] = this.driverBirthDate ? this.driverBirthDate.toISOString() : <any>undefined;
        data["driverAddress"] = this.driverAddress;
        data["driverPhoneNumber"] = this.driverPhoneNumber;
        data["driverMobileNumber"] = this.driverMobileNumber;
        data["driverOwnerRelation"] = this.driverOwnerRelation;
        data["driverLicensIssueDate"] = this.driverLicensIssueDate ? this.driverLicensIssueDate.toISOString() : <any>undefined;
        data["driverLicenseNumber"] = this.driverLicenseNumber;
        data["driverLicenseType"] = this.driverLicenseType;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["vehicleYearOfProduction"] = this.vehicleYearOfProduction;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleGearboxType"] = this.vehicleGearboxType;
        if (Array.isArray(this.licenseTypes)) {
            data["licenseTypes"] = [];
            for (let item of this.licenseTypes)
                data["licenseTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.yearsOfProduction)) {
            data["yearsOfProduction"] = [];
            for (let item of this.yearsOfProduction)
                data["yearsOfProduction"].push(item.toJSON());
        }
        if (Array.isArray(this.gearboxTypes)) {
            data["gearboxTypes"] = [];
            for (let item of this.gearboxTypes)
                data["gearboxTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleTypes)) {
            data["vehicleTypes"] = [];
            for (let item of this.vehicleTypes)
                data["vehicleTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.extrasMultiSelect)) {
            data["extrasMultiSelect"] = [];
            for (let item of this.extrasMultiSelect)
                data["extrasMultiSelect"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDriverAndVehicleDetailsTab {
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    sueId?: string;
    sueCarAndDriverInfoId?: string;
    driverFullName?: string | undefined;
    driverIdentity?: string | undefined;
    driverBirthDate?: Date;
    driverAddress?: string | undefined;
    driverPhoneNumber?: string | undefined;
    driverMobileNumber?: string | undefined;
    driverOwnerRelation?: string | undefined;
    driverLicensIssueDate?: Date | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicenseType?: string | undefined;
    vehicleId?: string;
    vehicle?: VehicleDataModel;
    vehicleType?: string | undefined;
    vehicleYearOfProduction?: number;
    vehicleLicensePlate?: string | undefined;
    vehicleGearboxType?: GearboxType;
    licenseTypes?: SelectListItem[] | undefined;
    yearsOfProduction?: SelectListItem[] | undefined;
    gearboxTypes?: SelectListItem[] | undefined;
    vehicleTypes?: SelectListItem[] | undefined;
    extrasMultiSelect?: SelectListItem[] | undefined;
}

export class leadsModelCodeFindResponse implements IleadsModelCodeFindResponse {
    manufacturer?: DynamicObject1;
    vehicleModel?: DynamicObject1;
    vehicleSubModel?: DynamicObject3;
    id?: string;

    constructor(data?: IleadsModelCodeFindResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.vehicleModel = _data["vehicleModel"];
            this.vehicleSubModel = _data["vehicleSubModel"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): leadsModelCodeFindResponse {
        data = typeof data === 'object' ? data : {};
        let result = new leadsModelCodeFindResponse();
        result.init(data);
        return result;
    }


    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["vehicleModel"] = this.vehicleModel;
        data["vehicleSubModel"] = this.vehicleSubModel;
        data["id"] = this.id;
        return data;
    }
}
export interface IleadsModelCodeFindResponse {
    manufacturer?: DynamicObject1;
    vehicleModel?: DynamicObject1;
    vehicleSubModel?: DynamicObject3;
    id?: string;
}


export class DynamicObject3 implements IDynamicObject3 {
    label?: string | undefined;
    val?: string;
    code?: string | undefined;

    constructor(data?: IDynamicObject3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.val = _data["val"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): DynamicObject3 {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["val"] = this.val;
        data["code"] = this.code;
        return data;
    }
}


export class DynamicObject1 implements IDynamicObject1 {
    label?: string | undefined;
    val?: string;

    constructor(data?: IDynamicObject1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.val = _data["val"];
        }
    }

    static fromJS(data: any): DynamicObject1 {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["val"] = this.val;
        return data;
    }
}

export class DynamicObject12 {
    address?: string | undefined;
    city?: string | undefined;
    cityId?: string | undefined;

    constructor(data?: IDynamicObject1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.cityId = _data["cityId"];

        }
    }

    static fromJS(data: any): DynamicObject1 {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["cityId"] = this.cityId;
        return data;
    }
}


export class ResponseObject2 {
    statusCode?: number;
    statusMessage?: string | undefined;

    constructor(data?: ResponseObject2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
        }
    }

    static fromJS(data: any): DynamicObject1 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseObject2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        return data;
    }
}


export interface ResponseObject {
    statusCode: number;
    statusMessage: string | undefined
}

export interface IDynamicObject1 {
    label?: string | undefined;
    val?: string;
}

export interface IDynamicObject3 {
    label?: string | undefined;
    val?: string;
    code?: string | undefined;
}

export class DynamicObject2 implements IDynamicObject2 {
    label?: string | undefined;
    val?: string;
    code?: string | undefined;
    entryToRoad?: string | undefined;

    constructor(data?: IDynamicObject2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.val = _data["val"];
            this.code = _data["code"];
            this.entryToRoad = _data["entryToRoad"];
        }
    }

    static fromJS(data: any): DynamicObject2 {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["val"] = this.val;
        data["code"] = this.code;
        return data;
    }
}

export interface IDynamicObject2 {
    label?: string | undefined;
    val?: string;
    code?: string | undefined;
}

export class DynamicObject4 implements IDynamicObject4 {
    label?: string | undefined;
    val?: string;
    date?: Date;

    constructor(data?: IDynamicObject4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.val = _data["val"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DynamicObject4 {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["val"] = this.val;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDynamicObject4 {
    label?: string | undefined;
    val?: string;
    date?: Date;
}

export class DynamicObject5 implements IDynamicObject5 {
    manufacturer?: DynamicObject1;
    vehicleModel?: DynamicObject1;
    vehicleSubModel?: DynamicObject2;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    id?: string;
    carYear?: number;
    entryToRoad?: Date;
    error?: any;
    vehicleOwnership?: number;
    tozeretCd?: number;
    degemCd?: number;

    constructor(data?: IDynamicObject5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturer = _data["manufacturer"] ? DynamicObject1.fromJS(_data["manufacturer"]) : <any>undefined;
            this.vehicleModel = _data["vehicleModel"] ? DynamicObject1.fromJS(_data["vehicleModel"]) : <any>undefined;
            this.vehicleSubModel = _data["vehicleSubModel"] ? DynamicObject2.fromJS(_data["vehicleSubModel"]) : <any>undefined;
            this.carYear = _data["carYear"] ? _data["carYear"] : undefined;
            this.entryToRoad = _data["entryToRoad"] ? new Date(_data["entryToRoad"].toString()) : <any>undefined;
            this.error = _data["error"] ? DynamicObject2.fromJS(_data["error"]) : <any>undefined;
            this.vehicleOwnership = _data["vehicleOwnership"] ? _data["vehicleOwnership"] : undefined;
            this.esp = _data["esp"] ? _data["esp"] : false;
            this.ldw = _data["ldw"] ? _data["ldw"] : false;
            this.fcw = _data["fcw"] ? _data["fcw"] : false;
            this.id = _data["id"];
            this.tozeretCd = _data["tozeretCd"];
            this.degemCd = _data["degemCd"];
        }
    }

    static fromJS(data: any): DynamicObject5 {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : <any>undefined;
        data["vehicleModel"] = this.vehicleModel ? this.vehicleModel.toJSON() : <any>undefined;
        data["vehicleSubModel"] = this.vehicleSubModel ? this.vehicleSubModel.toJSON() : <any>undefined;
        data["carYear"] = this.carYear ? this.carYear : <any>undefined;
        data["entryToRoad"] = this.entryToRoad ? this.entryToRoad : <any>undefined;
        data["error"] = this.error ? this.error : <any>undefined;
        data["vehicleOwnership"] = this.vehicleOwnership ? this.vehicleOwnership : <any>undefined;
        data['esp'] = this.esp ? this.esp : undefined;
        data['ldw'] = this.ldw ? this.ldw : undefined;
        data['fcw'] = this.fcw ? this.fcw : undefined;
        data["id"] = this.id;
        data["tozeretCd"] = this.tozeretCd;
        data["degemCd"] = this.degemCd;
        return data;
    }
}

export interface IDynamicObject5 {
    manufacturer?: DynamicObject1;
    vehicleModel?: DynamicObject1;
    vehicleSubModel?: DynamicObject2;
    id?: string;
    vehicleOwnership?: number
    tozeretCd?: number
    degemCd?: number
}

export class DynamicObject6 implements IDynamicObject6 {
    token?: string | undefined;

    constructor(data?: IDynamicObject6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): DynamicObject6 {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IDynamicObject6 {
    token?: string | undefined;
}

export class DynamicObject8 implements IDynamicObject8 {
    modelCode?: string | undefined;

    constructor(data?: IDynamicObject8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelCode = _data["modelCode"];
        }
    }

    static fromJS(data: any): DynamicObject8 {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelCode"] = this.modelCode;
        return data;
    }
}

export interface IDynamicObject8 {
    modelCode?: string | undefined;
}


export class ElementaryInsurancePolicyModel implements IElementaryInsurancePolicyModel {
    id?: string;
    status?: number;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    bordroDate?: Date;
    branchName?: string | undefined;
    branchNumber?: string | undefined;
    route?: InsuranceCompanyRouteModel;
    routeId?: string | undefined;
    bidNumber?: string | undefined;
    bidDate?: Date;
    lastCompanyId?: string | undefined;
    lastCompany?: EmployerModel;
    lastPolicyNumber?: string | undefined;
    eventType?: EventType;
    eventDate?: Date;
    noveltyType?: NoveltyType;
    linkageTypeInsuranceAmount?: LinkageType;
    currencyTypeInsuranceAmount?: CurrencyType;
    agentFeeSum?: number;
    agentFeePercent?: number;
    policyBranches?: PolicyBranchModel[] | undefined;
    amountsAndFees?: AmountAndFeeModel[] | undefined;
    collectionMethodType?: CollectionMethodType;
    collectionRoute?: CollectionRouteType;
    collectionLinkageType?: LinkageType;
    collectionCurrencyType?: CurrencyType;
    indexRate?: string | undefined;
    firstCollectionDate?: Date;
    collectionDay?: number;
    numberOfPayments?: number;
    bankAccountNumber?: string | undefined;
    bankNumber?: string | undefined;
    bankBranchNumber?: string | undefined;
    bankAccountOwner?: string | undefined;
    commitmentNumber?: string | undefined;
    netPremium?: number;
    registrationFees?: number;
    levyFee?: number;
    stampsFee?: number;
    policyFees?: number;
    treatmentFee?: number;
    creditFees?: number;
    extraPremium1?: number;
    extraPremium2?: number;
    premiumSum?: number;
    premiumPaid?: number;
    premiumBalance?: number;
    text?: string | undefined;
    vehiclePolicyType?: InsuranceTypes;
    deductible?: ImpairmentDeductible;
    drivingOnShabbat?: boolean;
    roadServicesProvider?: ServicesProvider;
    windshieldServicesProvider?: ServicesProvider;
    driversType?: AuthorizedToDrive;
    yungestDriverAge?: number;
    seniority?: number;
    passedInsuranceTypeLastYear?: PassedTypeOfInsurance;
    yearsLastYear?: number;
    yearLastYear?: number;
    passedInsuranceType2YearsAgo?: PassedTypeOfInsurance;
    years2YearsAgo?: number;
    year2YearsAgo?: number;
    passedInsuranceType3YearsAgo?: PassedTypeOfInsurance;
    years3YearsAgo?: number;
    year3YearsAgo?: number;
    passedInsuranceType4YearsAgo?: PassedTypeOfInsurance;
    years4YearsAgo?: number;
    year4YearsAgo?: number;
    vehicle?: VehicleDataModel;
    vehicleId?: string | undefined;
    apartmentPolicyType?: ApartmentPolicyType;
    coverType?: ApartmentCoverType;
    address?: string | undefined;
    structure?: string | undefined;
    earthquakeStructure?: boolean | undefined;
    structureSize?: number;
    content?: string | undefined;
    earthquakeContent?: boolean | undefined;
    jewelry?: string | undefined;
    coveragePercentageType?: CoveragePercentageType;
    surveyDate?: Date;
    reviewerName?: string | undefined;
    thirdParty?: boolean | undefined;
    employersLiability?: boolean | undefined;
    orderPlumberType?: OrderPlumberType;
    electricalAppliancesFixes?: boolean | undefined;
    businessName?: string | undefined;
    businessThirdParty?: string | undefined;
    businessEmployersLiability?: string | undefined;
    goodsInTransit?: string | undefined;
    earthquake?: boolean;
    professionalLiabilityType?: ProfessionalLiabilityType;
    daysSum?: string | undefined;
    referrerName?: string | undefined;
    fullName?: string | undefined;
    identifier?: string | undefined;
    relation?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    foreignWorkersServiceProviderType?: ForeignWorkersServiceProviderType;
    foreignWorkerInsuredNumber?: string | undefined;
    foreignWorkerFirstName?: string | undefined;
    foreignWorkerLastName?: string | undefined;
    foreignWorkerGender?: Gender;
    foreignWorkerMobile?: string | undefined;
    foreignWorkerPassportNumber?: string | undefined;
    foreignWorkerPassportExpirationDate?: Date;
    foreignWorkerCountry?: string | undefined;
    foreignWorkerEntryToIsraelDate?: Date;
    feePercent?: string | undefined;
    feeDollar?: string | undefined;
    paymentMethodType?: PaymentMethodType;
    dollarRate?: number;
    dailyPremium?: number;
    days?: number;
    shekelPremium?: number;
    dollarPremium?: number;
    employers?: SelectListItem[] | undefined;

    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverYoungIdentifier?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungLastName?: string | undefined;
    driverYoungFirstName?: string | undefined;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainIdentifier?: string | undefined;
    driverMainGender?: Gender;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainLastName?: string | undefined;
    driverMainFirstName?: string | undefined;
    paymentDetails?: string[];

    constructor(data?: IElementaryInsurancePolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agentDetailsList"])) {
                this.agentDetailsList = [] as any;
                for (let item of _data["agentDetailsList"])
                    this.agentDetailsList!.push(AgentDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["salespersons"])) {
                this.salespersons = [] as any;
                for (let item of _data["salespersons"])
                    this.salespersons!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            this.bordroDate = _data["bordroDate"] ? new Date(_data["bordroDate"].toString()) : <any>undefined;
            this.branchName = _data["branchName"];
            this.branchNumber = _data["branchNumber"];
            this.route = _data["route"] ? InsuranceCompanyRouteModel.fromJS(_data["route"]) : <any>undefined;
            this.routeId = _data["routeId"];
            this.bidNumber = _data["bidNumber"];
            this.bidDate = _data["bidDate"] ? new Date(_data["bidDate"].toString()) : <any>undefined;
            this.lastCompanyId = _data["lastCompanyId"];
            this.lastCompany = _data["lastCompany"] ? EmployerModel.fromJS(_data["lastCompany"]) : <any>undefined;
            this.lastPolicyNumber = _data["lastPolicyNumber"];
            this.eventType = _data["eventType"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.noveltyType = _data["noveltyType"];
            this.linkageTypeInsuranceAmount = _data["linkageTypeInsuranceAmount"];
            this.currencyTypeInsuranceAmount = _data["currencyTypeInsuranceAmount"];
            this.agentFeeSum = _data["agentFeeSum"];
            this.agentFeePercent = _data["agentFeePercent"];
            if (Array.isArray(_data["policyBranches"])) {
                this.policyBranches = [] as any;
                for (let item of _data["policyBranches"])
                    this.policyBranches!.push(PolicyBranchModel.fromJS(item));
            }
            if (Array.isArray(_data["amountsAndFees"])) {
                this.amountsAndFees = [] as any;
                for (let item of _data["amountsAndFees"])
                    this.amountsAndFees!.push(AmountAndFeeModel.fromJS(item));
            }
            this.collectionMethodType = _data["collectionMethodType"];
            this.collectionRoute = _data["collectionRoute"];
            this.collectionLinkageType = _data["collectionLinkageType"];
            this.collectionCurrencyType = _data["collectionCurrencyType"];
            this.indexRate = _data["indexRate"];
            this.firstCollectionDate = _data["firstCollectionDate"] ? new Date(_data["firstCollectionDate"].toString()) : <any>undefined;
            this.collectionDay = _data["collectionDay"];
            this.numberOfPayments = _data["numberOfPayments"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankNumber = _data["bankNumber"];
            this.bankBranchNumber = _data["bankBranchNumber"];
            this.bankAccountOwner = _data["bankAccountOwner"];
            this.commitmentNumber = _data["commitmentNumber"];
            this.netPremium = _data["netPremium"];
            this.registrationFees = _data["registrationFees"];
            this.levyFee = _data["levyFee"];
            this.stampsFee = _data["stampsFee"];
            this.policyFees = _data["policyFees"];
            this.treatmentFee = _data["treatmentFee"];
            this.creditFees = _data["creditFees"];
            this.extraPremium1 = _data["extraPremium1"];
            this.extraPremium2 = _data["extraPremium2"];
            this.premiumSum = _data["premiumSum"];
            this.premiumPaid = _data["premiumPaid"];
            this.premiumBalance = _data["premiumBalance"];
            this.text = _data["text"];
            this.vehiclePolicyType = _data["vehiclePolicyType"];
            this.deductible = _data["deductible"];
            this.drivingOnShabbat = _data["drivingOnShabbat"];
            this.roadServicesProvider = _data["roadServicesProvider"];
            this.windshieldServicesProvider = _data["windshieldServicesProvider"];
            this.driversType = _data["driversType"];
            this.yungestDriverAge = _data["yungestDriverAge"];
            this.seniority = _data["seniority"];
            this.passedInsuranceTypeLastYear = _data["passedInsuranceTypeLastYear"];
            this.yearsLastYear = _data["yearsLastYear"];
            this.yearLastYear = _data["yearLastYear"];
            this.passedInsuranceType2YearsAgo = _data["passedInsuranceType2YearsAgo"];
            this.years2YearsAgo = _data["years2YearsAgo"];
            this.year2YearsAgo = _data["year2YearsAgo"];
            this.passedInsuranceType3YearsAgo = _data["passedInsuranceType3YearsAgo"];
            this.years3YearsAgo = _data["years3YearsAgo"];
            this.year3YearsAgo = _data["year3YearsAgo"];
            this.passedInsuranceType4YearsAgo = _data["passedInsuranceType4YearsAgo"];
            this.years4YearsAgo = _data["years4YearsAgo"];
            this.year4YearsAgo = _data["year4YearsAgo"];
            this.vehicle = _data["vehicle"] ? VehicleDataModel.fromJS(_data["vehicle"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.apartmentPolicyType = _data["apartmentPolicyType"];
            this.coverType = _data["coverType"];
            this.address = _data["address"];
            this.structure = _data["structure"];
            this.earthquakeStructure = _data["earthquakeStructure"];
            this.structureSize = _data["structureSize"];
            this.content = _data["content"];
            this.earthquakeContent = _data["earthquakeContent"];
            this.jewelry = _data["jewelry"];
            this.coveragePercentageType = _data["coveragePercentageType"];
            this.surveyDate = _data["surveyDate"] ? new Date(_data["surveyDate"].toString()) : <any>undefined;
            this.reviewerName = _data["reviewerName"];
            this.thirdParty = _data["thirdParty"];
            this.employersLiability = _data["employersLiability"];
            this.orderPlumberType = _data["orderPlumberType"];
            this.electricalAppliancesFixes = _data["electricalAppliancesFixes"];
            this.businessName = _data["businessName"];
            this.businessThirdParty = _data["businessThirdParty"];
            this.businessEmployersLiability = _data["businessEmployersLiability"];
            this.goodsInTransit = _data["goodsInTransit"];
            this.earthquake = _data["earthquake"];
            this.professionalLiabilityType = _data["professionalLiabilityType"];
            this.daysSum = _data["daysSum"];
            this.referrerName = _data["referrerName"];
            this.fullName = _data["fullName"];
            this.identifier = _data["identifier"];
            this.relation = _data["relation"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.foreignWorkersServiceProviderType = _data["foreignWorkersServiceProviderType"];
            this.foreignWorkerInsuredNumber = _data["foreignWorkerInsuredNumber"];
            this.foreignWorkerFirstName = _data["foreignWorkerFirstName"];
            this.foreignWorkerLastName = _data["foreignWorkerLastName"];
            this.foreignWorkerGender = _data["foreignWorkerGender"];
            this.foreignWorkerMobile = _data["foreignWorkerMobile"];
            this.foreignWorkerPassportNumber = _data["foreignWorkerPassportNumber"];
            this.foreignWorkerPassportExpirationDate = _data["foreignWorkerPassportExpirationDate"] ? new Date(_data["foreignWorkerPassportExpirationDate"].toString()) : <any>undefined;
            this.foreignWorkerCountry = _data["foreignWorkerCountry"];
            this.foreignWorkerEntryToIsraelDate = _data["foreignWorkerEntryToIsraelDate"] ? new Date(_data["foreignWorkerEntryToIsraelDate"].toString()) : <any>undefined;
            this.feePercent = _data["feePercent"];
            this.feeDollar = _data["feeDollar"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.dollarRate = _data["dollarRate"];
            this.dailyPremium = _data["dailyPremium"];
            this.days = _data["days"];
            this.shekelPremium = _data["shekelPremium"];
            this.dollarPremium = _data["dollarPremium"];
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(SelectListItem.fromJS(item));
            }

            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverYoungIdentifier = _data["driverYoungIdentifier"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungLastName = _data["driverYoungLastName"];
            this.driverYoungFirstName = _data["driverYoungFirstName"];

            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.driverMainIdentifier = _data["driverMainIdentifier"];
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.driverMainLastName = _data["driverMainLastName"];
            this.driverMainFirstName = _data["driverMainFirstName"];
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any): ElementaryInsurancePolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ElementaryInsurancePolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.agentDetailsList)) {
            data["agentDetailsList"] = [];
            for (let item of this.agentDetailsList)
                data["agentDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.salespersons)) {
            data["salespersons"] = [];
            for (let item of this.salespersons)
                data["salespersons"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        data["bordroDate"] = this.bordroDate ? this.bordroDate.toISOString() : <any>undefined;
        data["branchName"] = this.branchName;
        data["branchNumber"] = this.branchNumber;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        data["routeId"] = this.routeId;
        data["bidNumber"] = this.bidNumber;
        data["bidDate"] = this.bidDate ? this.bidDate.toISOString() : <any>undefined;
        data["lastCompanyId"] = this.lastCompanyId;
        data["lastCompany"] = this.lastCompany ? this.lastCompany.toJSON() : <any>undefined;
        data["lastPolicyNumber"] = this.lastPolicyNumber;
        data["eventType"] = this.eventType;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["noveltyType"] = this.noveltyType;
        data["linkageTypeInsuranceAmount"] = this.linkageTypeInsuranceAmount;
        data["currencyTypeInsuranceAmount"] = this.currencyTypeInsuranceAmount;
        data["agentFeeSum"] = this.agentFeeSum;
        data["agentFeePercent"] = this.agentFeePercent;
        if (Array.isArray(this.policyBranches)) {
            data["policyBranches"] = [];
            for (let item of this.policyBranches)
                data["policyBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.amountsAndFees)) {
            data["amountsAndFees"] = [];
            for (let item of this.amountsAndFees)
                data["amountsAndFees"].push(item.toJSON());
        }
        data["collectionMethodType"] = this.collectionMethodType;
        data["collectionRoute"] = this.collectionRoute;
        data["collectionLinkageType"] = this.collectionLinkageType;
        data["collectionCurrencyType"] = this.collectionCurrencyType;
        data["indexRate"] = this.indexRate;
        data["firstCollectionDate"] = this.firstCollectionDate ? this.firstCollectionDate.toISOString() : <any>undefined;
        data["collectionDay"] = this.collectionDay;
        data["numberOfPayments"] = this.numberOfPayments;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankNumber"] = this.bankNumber;
        data["bankBranchNumber"] = this.bankBranchNumber;
        data["bankAccountOwner"] = this.bankAccountOwner;
        data["commitmentNumber"] = this.commitmentNumber;
        data["netPremium"] = this.netPremium;
        data["registrationFees"] = this.registrationFees;
        data["levyFee"] = this.levyFee;
        data["stampsFee"] = this.stampsFee;
        data["policyFees"] = this.policyFees;
        data["treatmentFee"] = this.treatmentFee;
        data["creditFees"] = this.creditFees;
        data["extraPremium1"] = this.extraPremium1;
        data["extraPremium2"] = this.extraPremium2;
        data["premiumSum"] = this.premiumSum;
        data["premiumPaid"] = this.premiumPaid;
        data["premiumBalance"] = this.premiumBalance;
        data["text"] = this.text;
        data["vehiclePolicyType"] = this.vehiclePolicyType;
        data["deductible"] = this.deductible;
        data["drivingOnShabbat"] = this.drivingOnShabbat;
        data["roadServicesProvider"] = this.roadServicesProvider;
        data["windshieldServicesProvider"] = this.windshieldServicesProvider;
        data["driversType"] = this.driversType;
        data["yungestDriverAge"] = this.yungestDriverAge;
        data["seniority"] = this.seniority;
        data["passedInsuranceTypeLastYear"] = this.passedInsuranceTypeLastYear;
        data["yearsLastYear"] = this.yearsLastYear;
        data["yearLastYear"] = this.yearLastYear;
        data["passedInsuranceType2YearsAgo"] = this.passedInsuranceType2YearsAgo;
        data["years2YearsAgo"] = this.years2YearsAgo;
        data["year2YearsAgo"] = this.year2YearsAgo;
        data["passedInsuranceType3YearsAgo"] = this.passedInsuranceType3YearsAgo;
        data["years3YearsAgo"] = this.years3YearsAgo;
        data["year3YearsAgo"] = this.year3YearsAgo;
        data["passedInsuranceType4YearsAgo"] = this.passedInsuranceType4YearsAgo;
        data["years4YearsAgo"] = this.years4YearsAgo;
        data["year4YearsAgo"] = this.year4YearsAgo;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["apartmentPolicyType"] = this.apartmentPolicyType;
        data["coverType"] = this.coverType;
        data["address"] = this.address;
        data["structure"] = this.structure;
        data["earthquakeStructure"] = this.earthquakeStructure;
        data["structureSize"] = this.structureSize;
        data["content"] = this.content;
        data["earthquakeContent"] = this.earthquakeContent;
        data["jewelry"] = this.jewelry;
        data["coveragePercentageType"] = this.coveragePercentageType;
        data["surveyDate"] = this.surveyDate ? this.surveyDate.toISOString() : <any>undefined;
        data["reviewerName"] = this.reviewerName;
        data["thirdParty"] = this.thirdParty;
        data["employersLiability"] = this.employersLiability;
        data["orderPlumberType"] = this.orderPlumberType;
        data["electricalAppliancesFixes"] = this.electricalAppliancesFixes;
        data["businessName"] = this.businessName;
        data["businessThirdParty"] = this.businessThirdParty;
        data["businessEmployersLiability"] = this.businessEmployersLiability;
        data["goodsInTransit"] = this.goodsInTransit;
        data["earthquake"] = this.earthquake;
        data["professionalLiabilityType"] = this.professionalLiabilityType;
        data["daysSum"] = this.daysSum;
        data["referrerName"] = this.referrerName;
        data["fullName"] = this.fullName;
        data["identifier"] = this.identifier;
        data["relation"] = this.relation;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["street"] = this.street;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["foreignWorkersServiceProviderType"] = this.foreignWorkersServiceProviderType;
        data["foreignWorkerInsuredNumber"] = this.foreignWorkerInsuredNumber;
        data["foreignWorkerFirstName"] = this.foreignWorkerFirstName;
        data["foreignWorkerLastName"] = this.foreignWorkerLastName;
        data["foreignWorkerGender"] = this.foreignWorkerGender;
        data["foreignWorkerMobile"] = this.foreignWorkerMobile;
        data["foreignWorkerPassportNumber"] = this.foreignWorkerPassportNumber;
        data["foreignWorkerPassportExpirationDate"] = this.foreignWorkerPassportExpirationDate ? this.foreignWorkerPassportExpirationDate.toISOString() : <any>undefined;
        data["foreignWorkerCountry"] = this.foreignWorkerCountry;
        data["foreignWorkerEntryToIsraelDate"] = this.foreignWorkerEntryToIsraelDate ? this.foreignWorkerEntryToIsraelDate.toISOString() : <any>undefined;
        data["feePercent"] = this.feePercent;
        data["feeDollar"] = this.feeDollar;
        data["paymentMethodType"] = this.paymentMethodType;
        data["dollarRate"] = this.dollarRate;
        data["dailyPremium"] = this.dailyPremium;
        data["days"] = this.days;
        data["shekelPremium"] = this.shekelPremium;
        data["dollarPremium"] = this.dollarPremium;
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }


        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverYoungIdentifier"] = this.driverYoungIdentifier;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungLastName"] = this.driverYoungLastName;
        data["driverYoungFirstName"] = this.driverYoungFirstName;

        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["driverMainIdentifier"] = this.driverMainIdentifier;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["driverMainLastName"] = this.driverMainLastName;
        data["driverMainFirstName"] = this.driverMainFirstName;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IElementaryInsurancePolicyModel {
    id?: string;
    status?: number;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    bordroDate?: Date;
    branchName?: string | undefined;
    branchNumber?: string | undefined;
    route?: InsuranceCompanyRouteModel;
    routeId?: string | undefined;
    bidNumber?: string | undefined;
    bidDate?: Date;
    lastCompanyId?: string | undefined;
    lastCompany?: EmployerModel;
    lastPolicyNumber?: string | undefined;
    eventType?: EventType;
    eventDate?: Date;
    noveltyType?: NoveltyType;
    linkageTypeInsuranceAmount?: LinkageType;
    currencyTypeInsuranceAmount?: CurrencyType;
    agentFeeSum?: number;
    agentFeePercent?: number;
    policyBranches?: PolicyBranchModel[] | undefined;
    amountsAndFees?: AmountAndFeeModel[] | undefined;
    collectionMethodType?: CollectionMethodType;
    collectionRoute?: CollectionRouteType;
    collectionLinkageType?: LinkageType;
    collectionCurrencyType?: CurrencyType;
    indexRate?: string | undefined;
    firstCollectionDate?: Date;
    collectionDay?: number;
    numberOfPayments?: number;
    bankAccountNumber?: string | undefined;
    bankNumber?: string | undefined;
    bankBranchNumber?: string | undefined;
    bankAccountOwner?: string | undefined;
    commitmentNumber?: string | undefined;
    netPremium?: number;
    registrationFees?: number;
    levyFee?: number;
    stampsFee?: number;
    policyFees?: number;
    treatmentFee?: number;
    creditFees?: number;
    extraPremium1?: number;
    extraPremium2?: number;
    premiumSum?: number;
    premiumPaid?: number;
    premiumBalance?: number;
    text?: string | undefined;
    vehiclePolicyType?: InsuranceTypes;
    deductible?: ImpairmentDeductible;
    drivingOnShabbat?: boolean;
    roadServicesProvider?: ServicesProvider;
    windshieldServicesProvider?: ServicesProvider;
    driversType?: AuthorizedToDrive;
    yungestDriverAge?: number;
    seniority?: number;
    passedInsuranceTypeLastYear?: PassedTypeOfInsurance;
    yearsLastYear?: number;
    yearLastYear?: number;
    passedInsuranceType2YearsAgo?: PassedTypeOfInsurance;
    years2YearsAgo?: number;
    year2YearsAgo?: number;
    passedInsuranceType3YearsAgo?: PassedTypeOfInsurance;
    years3YearsAgo?: number;
    year3YearsAgo?: number;
    passedInsuranceType4YearsAgo?: PassedTypeOfInsurance;
    years4YearsAgo?: number;
    year4YearsAgo?: number;
    vehicle?: VehicleDataModel;
    vehicleId?: string | undefined;
    apartmentPolicyType?: ApartmentPolicyType;
    coverType?: ApartmentCoverType;
    address?: string | undefined;
    structure?: string | undefined;
    earthquakeStructure?: boolean | undefined;
    structureSize?: number;
    content?: string | undefined;
    earthquakeContent?: boolean | undefined;
    jewelry?: string | undefined;
    coveragePercentageType?: CoveragePercentageType;
    surveyDate?: Date;
    reviewerName?: string | undefined;
    thirdParty?: boolean | undefined;
    employersLiability?: boolean | undefined;
    orderPlumberType?: OrderPlumberType;
    electricalAppliancesFixes?: boolean | undefined;
    businessName?: string | undefined;
    businessThirdParty?: string | undefined;
    businessEmployersLiability?: string | undefined;
    goodsInTransit?: string | undefined;
    earthquake?: boolean;
    professionalLiabilityType?: ProfessionalLiabilityType;
    daysSum?: string | undefined;
    referrerName?: string | undefined;
    fullName?: string | undefined;
    identifier?: string | undefined;
    relation?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    foreignWorkersServiceProviderType?: ForeignWorkersServiceProviderType;
    foreignWorkerInsuredNumber?: string | undefined;
    foreignWorkerFirstName?: string | undefined;
    foreignWorkerLastName?: string | undefined;
    foreignWorkerGender?: Gender;
    foreignWorkerMobile?: string | undefined;
    foreignWorkerPassportNumber?: string | undefined;
    foreignWorkerPassportExpirationDate?: Date;
    foreignWorkerCountry?: string | undefined;
    foreignWorkerEntryToIsraelDate?: Date;
    feePercent?: string | undefined;
    feeDollar?: string | undefined;
    paymentMethodType?: PaymentMethodType;
    dollarRate?: number;
    dailyPremium?: number;
    days?: number;
    shekelPremium?: number;
    dollarPremium?: number;
    employers?: SelectListItem[] | undefined;
}

export class Email implements IEmail {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    userId?: string;
    user?: User;
    emailAddress?: string | undefined;
    password?: string | undefined;
    inboxServer?: string | undefined;
    inboxPort?: number;
    outboxServer?: string | undefined;
    outboxPort?: number;
    name?: string | undefined;
    replyMail?: string | undefined;
    main?: boolean;
    electronicSignature?: string | undefined;
    displaySettings?: EmailDisplaySettings;
    font?: string | undefined;
    size?: string | undefined;
    amount?: number;

    constructor(data?: IEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.inboxServer = _data["inboxServer"];
            this.inboxPort = _data["inboxPort"];
            this.outboxServer = _data["outboxServer"];
            this.outboxPort = _data["outboxPort"];
            this.name = _data["name"];
            this.replyMail = _data["replyMail"];
            this.main = _data["main"];
            this.electronicSignature = _data["electronicSignature"];
            this.displaySettings = _data["displaySettings"];
            this.font = _data["font"];
            this.size = _data["size"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): Email {
        data = typeof data === 'object' ? data : {};
        let result = new Email();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["inboxServer"] = this.inboxServer;
        data["inboxPort"] = this.inboxPort;
        data["outboxServer"] = this.outboxServer;
        data["outboxPort"] = this.outboxPort;
        data["name"] = this.name;
        data["replyMail"] = this.replyMail;
        data["main"] = this.main;
        data["electronicSignature"] = this.electronicSignature;
        data["displaySettings"] = this.displaySettings;
        data["font"] = this.font;
        data["size"] = this.size;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IEmail {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    userId?: string;
    user?: User;
    emailAddress?: string | undefined;
    password?: string | undefined;
    inboxServer?: string | undefined;
    inboxPort?: number;
    outboxServer?: string | undefined;
    outboxPort?: number;
    name?: string | undefined;
    replyMail?: string | undefined;
    main?: boolean;
    electronicSignature?: string | undefined;
    displaySettings?: EmailDisplaySettings;
    font?: string | undefined;
    size?: string | undefined;
    amount?: number;
}

/** 0 = Registered, 1 = Package, 2 = Express, 3 = Email */
export enum EmailDeliveryType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** 0 = Horizontal, 1 = Vertical, 2 = Hide */
export enum EmailDisplaySettings {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class EmailFilterModel implements IEmailFilterModel {
    page?: number;
    searchText?: string | undefined;
    searchOption?: string[] | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    folder?: SpecialFolder;
    folderName?: string | undefined;
    readUnread?: ReadUnread;
    activeMail: string | undefined;
    SearchOption?: string[] | undefined;

    constructor(data?: IEmailFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["searchOption"])) {
                this.searchOption = [] as any;
                for (let item of _data["searchOption"])
                    this.searchOption!.push(item);
            }
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.folder = _data["folder"];
            this.folderName = _data["folderName"];
            this.readUnread = _data["readUnread"];
            this.activeMail = _data["activeMail"];
            this.SearchOption = _data["SearchOption"] ? _data["SearchOption"] : <any>undefined;
        }
    }

    static fromJS(data: any): EmailFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailFilterModel();
        result.init(data);
        return result;
    }

    dateToString(date: Date): string {
        const day = date.getDate();
        let dayString = day.toString();
        if (day < 10) {
            dayString = `0${day}`;
        }
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        let monthStr = month.toString()
        if (month < 10) {
            monthStr = `0${month}`;
        }
        const timeString = date.toISOString().split('T')[1];

        const dateString = `${year}-${monthStr}-${dayString}T${timeString}`;
        return dateString;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.searchOption)) {
            data["searchOption"] = [];
            for (let item of this.searchOption)
                data["searchOption"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.dateToString(this.fromDate) : <any>undefined;
        data["toDate"] = this.toDate ? this.dateToString(this.toDate) : <any>undefined;
        data["folder"] = this.folder;
        data["folderName"] = this.folderName;
        data["readUnread"] = this.readUnread;
        data["activeMail"] = this.activeMail;
        data["SearchOption"] = this.SearchOption ? this.SearchOption : <any>undefined;
        return data;
    }
}

export interface IEmailFilterModel {
    page?: number;
    activeMail?: string | undefined;
    searchText?: string | undefined;
    searchOption?: string[] | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    folder?: SpecialFolder;
    folderName?: string | undefined;
    readUnread?: ReadUnread;
}

export class EmailFolderData implements IEmailFolderData {
    name?: string | undefined;
    type?: SpecialFolder;
    new?: number;
    parent?: string;
    isSystemFolder?: boolean;

    constructor(data?: IEmailFolderData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.new = _data["new"];
            this.parent = _data["parent"];
            this.isSystemFolder = _data["isSystemFolder"];
        }
    }

    static fromJS(data: any): EmailFolderData {
        data = typeof data === 'object' ? data : {};
        let result = new EmailFolderData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["new"] = this.new;
        data["parent"] = this.parent;
        data["isSystemFolder"] = this.isSystemFolder;
        return data;
    }
}

export interface IEmailFolderData {
    name?: string | undefined;
    type?: SpecialFolder;
    new?: number;
}

export class EmailListData implements IEmailListData {
    id?: UniqueId;
    subject?: string | undefined;
    from?: string | undefined;
    date?: Date;
    read?: boolean;
    star?: boolean;
    attachments?: boolean;

    constructor(data?: IEmailListData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? UniqueId.fromJS(_data["id"]) : <any>undefined;
            this.subject = _data["subject"];
            this.from = _data["from"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.read = _data["read"];
            this.star = _data["star"];
            this.attachments = _data["attachments"];
        }
    }

    static fromJS(data: any): EmailListData {
        data = typeof data === 'object' ? data : {};
        let result = new EmailListData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["subject"] = this.subject;
        data["from"] = this.from;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["read"] = this.read;
        data["star"] = this.star;
        data["attachments"] = this.attachments;
        return data;
    }
}

export interface IEmailListData {
    id?: UniqueId;
    subject?: string | undefined;
    from?: string | undefined;
    date?: Date;
    read?: boolean;
    star?: boolean;
    attachments?: boolean;
}

export class EmailMessage implements IEmailMessage {
    uid?: number;
    messageId?: string | undefined;
    htmlBody?: string | undefined;
    textBody?: string | undefined;
    subject?: string | undefined;
    from?: string | undefined;
    fromName?: string | undefined;
    date?: Date;
    attachments?: AttachmentFile[] | undefined;
    envelope?: Envelope;
    replyDetails?: NewMailModel;

    constructor(data?: IEmailMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.messageId = _data["messageId"];
            this.htmlBody = _data["htmlBody"];
            this.textBody = _data["textBody"];
            this.subject = _data["subject"];
            this.from = _data["from"];
            this.fromName = _data["fromName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentFile.fromJS(item));
            }
            this.envelope = _data["envelope"] ? Envelope.fromJS(_data["envelope"]) : <any>undefined;
            this.replyDetails = _data["replyDetails"] ? NewMailModel.fromJS(_data["replyDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailMessage {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["messageId"] = this.messageId;
        data["htmlBody"] = this.htmlBody;
        data["textBody"] = this.textBody;
        data["subject"] = this.subject;
        data["from"] = this.from;
        data["fromName"] = this.fromName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["replyDetails"] = this.replyDetails ? this.replyDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmailMessage {
    uid?: number;
    messageId?: string | undefined;
    htmlBody?: string | undefined;
    textBody?: string | undefined;
    subject?: string | undefined;
    from?: string | undefined;
    fromName?: string | undefined;
    date?: Date;
    attachments?: AttachmentFile[] | undefined;
    envelope?: Envelope;
    replyDetails?: NewMailModel;
}

export class EmailModel implements IEmailModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    userId?: string;
    user?: UserModel;
    emailAddress?: string | undefined;
    password?: string | undefined;
    inboxServer?: string | undefined;
    inboxPort?: number;
    outboxServer?: string | undefined;
    outboxPort?: number;
    name?: string | undefined;
    replyMail?: string | undefined;
    main?: boolean;
    electronicSignature?: string | undefined;
    displaySettings?: EmailDisplaySettings;
    font?: string | undefined;
    size?: string | undefined;
    amount?: number;

    constructor(data?: IEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.inboxServer = _data["inboxServer"];
            this.inboxPort = _data["inboxPort"];
            this.outboxServer = _data["outboxServer"];
            this.outboxPort = _data["outboxPort"];
            this.name = _data["name"];
            this.replyMail = _data["replyMail"];
            this.main = _data["main"];
            this.electronicSignature = _data["electronicSignature"];
            this.displaySettings = _data["displaySettings"];
            this.font = _data["font"];
            this.size = _data["size"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): EmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["inboxServer"] = this.inboxServer;
        data["inboxPort"] = this.inboxPort;
        data["outboxServer"] = this.outboxServer;
        data["outboxPort"] = this.outboxPort;
        data["name"] = this.name;
        data["replyMail"] = this.replyMail;
        data["main"] = this.main;
        data["electronicSignature"] = this.electronicSignature;
        data["displaySettings"] = this.displaySettings;
        data["font"] = this.font;
        data["size"] = this.size;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IEmailModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    userId?: string;
    user?: UserModel;
    emailAddress?: string | undefined;
    password?: string | undefined;
    inboxServer?: string | undefined;
    inboxPort?: number;
    outboxServer?: string | undefined;
    outboxPort?: number;
    name?: string | undefined;
    replyMail?: string | undefined;
    main?: boolean;
    electronicSignature?: string | undefined;
    displaySettings?: EmailDisplaySettings;
    font?: string | undefined;
    size?: string | undefined;
    amount?: number;
}

export class EmailsModel implements IEmailsModel {
    emailAddress?: string | undefined;
    emailPassword?: string | undefined;
    userId?: string;
    client?: ImapClient;
    foldersNames?: EmailFolderData[] | undefined;
    messages?: EmailListData[] | undefined;
    email?: Email;
    allMailsCounter?: number;
    currentPage?: number;
    maxPage?: number;
    pagE_SIZE?: number;
    folder?: string | undefined;
    folderName?: string | undefined;

    constructor(data?: IEmailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.emailPassword = _data["emailPassword"];
            this.userId = _data["userId"];
            this.client = _data["client"] ? ImapClient.fromJS(_data["client"]) : <any>undefined;
            if (Array.isArray(_data["foldersNames"])) {
                this.foldersNames = [] as any;
                for (let item of _data["foldersNames"])
                    this.foldersNames!.push(EmailFolderData.fromJS(item));
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(EmailListData.fromJS(item));
            }
            this.email = _data["email"] ? Email.fromJS(_data["email"]) : <any>undefined;
            this.allMailsCounter = _data["allMailsCounter"];
            this.currentPage = _data["currentPage"];
            this.maxPage = _data["maxPage"];
            this.folder = _data["folder"];
            this.folderName = _data["folderName"];
            this.pagE_SIZE = _data["pagE_SIZE"]

        }
    }

    static fromJS(data: any): EmailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["emailPassword"] = this.emailPassword;
        data["userId"] = this.userId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        if (Array.isArray(this.foldersNames)) {
            data["foldersNames"] = [];
            for (let item of this.foldersNames)
                data["foldersNames"].push(item.toJSON());
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["allMailsCounter"] = this.allMailsCounter;
        data["currentPage"] = this.currentPage;
        data["maxPage"] = this.maxPage;
        data["folder"] = this.folder;
        data["folderName"] = this.folderName;
        return data;
    }
}

export interface IEmailsModel {
    emailAddress?: string | undefined;
    emailPassword?: string | undefined;
    userId?: string;
    client?: ImapClient;
    foldersNames?: EmailFolderData[] | undefined;
    messages?: EmailListData[] | undefined;
    email?: Email;
    allMailsCounter?: number;
    currentPage?: number;
    maxPage?: number;
    folder?: string | undefined;
    folderName?: string | undefined;
}

export class EmailsSettingsModel implements IEmailsSettingsModel {
    emails?: EmailModel[] | undefined;
    displaySettings?: EmailDisplaySettings;
    font?: string | undefined;
    size?: string | undefined;
    amount?: number;
    allAccounts?: SelectListItem[] | undefined;

    constructor(data?: IEmailsSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(EmailModel.fromJS(item));
            }
            this.displaySettings = _data["displaySettings"];
            this.font = _data["font"];
            this.size = _data["size"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["allAccounts"])) {
                this.allAccounts = [] as any;
                for (let item of _data["allAccounts"])
                    this.allAccounts!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailsSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailsSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["displaySettings"] = this.displaySettings;
        data["font"] = this.font;
        data["size"] = this.size;
        data["amount"] = this.amount;
        if (Array.isArray(this.allAccounts)) {
            data["allAccounts"] = [];
            for (let item of this.allAccounts)
                data["allAccounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailsSettingsModel {
    emails?: EmailModel[] | undefined;
    displaySettings?: EmailDisplaySettings;
    font?: string | undefined;
    size?: string | undefined;
    amount?: number;
    allAccounts?: SelectListItem[] | undefined;
}

export class EmailTreatmentModelForUpsert implements IEmailTreatmentModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    emailDeliveryType?: EmailDeliveryType;
    emailDeliveryTypes?: SelectListItem[] | undefined;
    startDate?: Date;
    startTime?: TimeSpan;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    address?: string | undefined;
    addresses?: SelectListItem[] | undefined;
    hours?: SelectListItem[] | undefined;
    emailBody?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    statusChangeEmail?: string | undefined;
    statusChangeSms?: string | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;

    constructor(data?: IEmailTreatmentModelForUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.alertHour = _data["alertHour"] ? TimeSpan.fromJS(_data["alertHour"]) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.treatmentType = _data["treatmentType"];
            this.customerId = _data["customerId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(SelectListItem.fromJS(item));
            }
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectListItem.fromJS(item));
            }
            this.emailDeliveryType = _data["emailDeliveryType"];
            if (Array.isArray(_data["emailDeliveryTypes"])) {
                this.emailDeliveryTypes = [] as any;
                for (let item of _data["emailDeliveryTypes"])
                    this.emailDeliveryTypes!.push(SelectListItem.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.topic = _data["topic"];
            this.note = _data["note"];
            this.address = _data["address"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
            this.emailBody = _data["emailBody"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.statusChangeEmail = _data["statusChangeEmail"];
            this.statusChangeSms = _data["statusChangeSms"];
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailTreatmentModelForUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTreatmentModelForUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["alertHour"] = this.alertHour ? this.alertHour.toJSON() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["treatmentType"] = this.treatmentType;
        data["customerId"] = this.customerId;
        data["priority"] = this.priority;
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item.toJSON());
        }
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["emailDeliveryType"] = this.emailDeliveryType;
        if (Array.isArray(this.emailDeliveryTypes)) {
            data["emailDeliveryTypes"] = [];
            for (let item of this.emailDeliveryTypes)
                data["emailDeliveryTypes"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["topic"] = this.topic;
        data["note"] = this.note;
        data["address"] = this.address;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        data["emailBody"] = this.emailBody;
        data["from"] = this.from;
        data["to"] = this.to;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["statusChangeEmail"] = this.statusChangeEmail;
        data["statusChangeSms"] = this.statusChangeSms;
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmailTreatmentModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    emailDeliveryType?: EmailDeliveryType;
    emailDeliveryTypes?: SelectListItem[] | undefined;
    startDate?: Date;
    startTime?: TimeSpan;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    address?: string | undefined;
    addresses?: SelectListItem[] | undefined;
    hours?: SelectListItem[] | undefined;
    emailBody?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    statusChangeEmail?: string | undefined;
    statusChangeSms?: string | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
}

export class Employer implements IEmployer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    employerNumber?: number;
    employerType?: EmployerType;
    employerIDNumber?: string | undefined;

    constructor(data?: IEmployer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.employerNumber = _data["employerNumber"];
            this.employerType = _data["employerType"];
            this.employerIDNumber = _data["employerIDNumber"];
        }
    }

    static fromJS(data: any): Employer {
        data = typeof data === 'object' ? data : {};
        let result = new Employer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["employerNumber"] = this.employerNumber;
        data["employerType"] = this.employerType;
        data["employerIDNumber"] = this.employerIDNumber;
        return data;
    }
}

export interface IEmployer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    employerNumber?: number;
    employerType?: EmployerType;
    employerIDNumber?: string | undefined;
}

export class EmployerModel implements IEmployerModel {
    id?: string;
    name?: string | undefined;
    employerNumber?: number;
    employerType?: EmployerType;
    employerIDNumber?: string | undefined;

    constructor(data?: IEmployerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.employerNumber = _data["employerNumber"];
            this.employerType = _data["employerType"];
            this.employerIDNumber = _data["employerIDNumber"];
        }
    }

    static fromJS(data: any): EmployerModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["employerNumber"] = this.employerNumber;
        data["employerType"] = this.employerType;
        data["employerIDNumber"] = this.employerIDNumber;
        return data;
    }
}

export interface IEmployerModel {
    id?: string;
    name?: string | undefined;
    employerNumber?: number;
    employerType?: EmployerType;
    employerIDNumber?: string | undefined;
}

/** 0 = CurentEmployer, 1 = LastEmployer */
export enum EmployerStatusType {
    _0 = 0,
    _1 = 1,
}

/** 0 = PrivateCompany, 1 = PublicCompany */
export enum EmployerType {
    _0 = 0,
    _1 = 1,
}

export class EncoderFallback implements IEncoderFallback {
    readonly maxCharCount?: number;

    constructor(data?: IEncoderFallback) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).maxCharCount = _data["maxCharCount"];
        }
    }

    static fromJS(data: any): EncoderFallback {
        data = typeof data === 'object' ? data : {};
        let result = new EncoderFallback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxCharCount"] = this.maxCharCount;
        return data;
    }
}

export interface IEncoderFallback {
    maxCharCount?: number;
}

export class Encoding implements IEncoding {
    preamble?: ByteReadOnlySpan;
    readonly bodyName?: string | undefined;
    readonly encodingName?: string | undefined;
    readonly headerName?: string | undefined;
    readonly webName?: string | undefined;
    readonly windowsCodePage?: number;
    readonly isBrowserDisplay?: boolean;
    readonly isBrowserSave?: boolean;
    readonly isMailNewsDisplay?: boolean;
    readonly isMailNewsSave?: boolean;
    readonly isSingleByte?: boolean;
    encoderFallback?: EncoderFallback;
    decoderFallback?: DecoderFallback;
    readonly isReadOnly?: boolean;
    readonly codePage?: number;

    constructor(data?: IEncoding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preamble = _data["preamble"] ? ByteReadOnlySpan.fromJS(_data["preamble"]) : <any>undefined;
            (<any>this).bodyName = _data["bodyName"];
            (<any>this).encodingName = _data["encodingName"];
            (<any>this).headerName = _data["headerName"];
            (<any>this).webName = _data["webName"];
            (<any>this).windowsCodePage = _data["windowsCodePage"];
            (<any>this).isBrowserDisplay = _data["isBrowserDisplay"];
            (<any>this).isBrowserSave = _data["isBrowserSave"];
            (<any>this).isMailNewsDisplay = _data["isMailNewsDisplay"];
            (<any>this).isMailNewsSave = _data["isMailNewsSave"];
            (<any>this).isSingleByte = _data["isSingleByte"];
            this.encoderFallback = _data["encoderFallback"] ? EncoderFallback.fromJS(_data["encoderFallback"]) : <any>undefined;
            this.decoderFallback = _data["decoderFallback"] ? DecoderFallback.fromJS(_data["decoderFallback"]) : <any>undefined;
            (<any>this).isReadOnly = _data["isReadOnly"];
            (<any>this).codePage = _data["codePage"];
        }
    }

    static fromJS(data: any): Encoding {
        data = typeof data === 'object' ? data : {};
        let result = new Encoding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preamble"] = this.preamble ? this.preamble.toJSON() : <any>undefined;
        data["bodyName"] = this.bodyName;
        data["encodingName"] = this.encodingName;
        data["headerName"] = this.headerName;
        data["webName"] = this.webName;
        data["windowsCodePage"] = this.windowsCodePage;
        data["isBrowserDisplay"] = this.isBrowserDisplay;
        data["isBrowserSave"] = this.isBrowserSave;
        data["isMailNewsDisplay"] = this.isMailNewsDisplay;
        data["isMailNewsSave"] = this.isMailNewsSave;
        data["isSingleByte"] = this.isSingleByte;
        data["encoderFallback"] = this.encoderFallback ? this.encoderFallback.toJSON() : <any>undefined;
        data["decoderFallback"] = this.decoderFallback ? this.decoderFallback.toJSON() : <any>undefined;
        data["isReadOnly"] = this.isReadOnly;
        data["codePage"] = this.codePage;
        return data;
    }
}

export interface IEncoding {
    preamble?: ByteReadOnlySpan;
    bodyName?: string | undefined;
    encodingName?: string | undefined;
    headerName?: string | undefined;
    webName?: string | undefined;
    windowsCodePage?: number;
    isBrowserDisplay?: boolean;
    isBrowserSave?: boolean;
    isMailNewsDisplay?: boolean;
    isMailNewsSave?: boolean;
    isSingleByte?: boolean;
    encoderFallback?: EncoderFallback;
    decoderFallback?: DecoderFallback;
    isReadOnly?: boolean;
    codePage?: number;
}

export class Envelope implements IEnvelope {
    readonly from?: InternetAddress[] | undefined;
    readonly sender?: InternetAddress[] | undefined;
    readonly replyTo?: InternetAddress[] | undefined;
    readonly to?: InternetAddress[] | undefined;
    readonly cc?: InternetAddress[] | undefined;
    readonly bcc?: InternetAddress[] | undefined;
    inReplyTo?: string | undefined;
    date?: Date | undefined;
    messageId?: string | undefined;
    subject?: string | undefined;

    constructor(data?: IEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["from"])) {
                (<any>this).from = [] as any;
                for (let item of _data["from"])
                    (<any>this).from!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["sender"])) {
                (<any>this).sender = [] as any;
                for (let item of _data["sender"])
                    (<any>this).sender!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["replyTo"])) {
                (<any>this).replyTo = [] as any;
                for (let item of _data["replyTo"])
                    (<any>this).replyTo!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["to"])) {
                (<any>this).to = [] as any;
                for (let item of _data["to"])
                    (<any>this).to!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["cc"])) {
                (<any>this).cc = [] as any;
                for (let item of _data["cc"])
                    (<any>this).cc!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["bcc"])) {
                (<any>this).bcc = [] as any;
                for (let item of _data["bcc"])
                    (<any>this).bcc!.push(InternetAddress.fromJS(item));
            }
            this.inReplyTo = _data["inReplyTo"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.messageId = _data["messageId"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item.toJSON());
        }
        if (Array.isArray(this.sender)) {
            data["sender"] = [];
            for (let item of this.sender)
                data["sender"].push(item.toJSON());
        }
        if (Array.isArray(this.replyTo)) {
            data["replyTo"] = [];
            for (let item of this.replyTo)
                data["replyTo"].push(item.toJSON());
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item.toJSON());
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item.toJSON());
        }
        data["inReplyTo"] = this.inReplyTo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["messageId"] = this.messageId;
        data["subject"] = this.subject;
        return data;
    }
}

export interface IEnvelope {
    from?: InternetAddress[] | undefined;
    sender?: InternetAddress[] | undefined;
    replyTo?: InternetAddress[] | undefined;
    to?: InternetAddress[] | undefined;
    cc?: InternetAddress[] | undefined;
    bcc?: InternetAddress[] | undefined;
    inReplyTo?: string | undefined;
    date?: Date | undefined;
    messageId?: string | undefined;
    subject?: string | undefined;
}

export class ErrorPropertyModel implements IErrorPropertyModel {
    propertyName?: string | undefined;
    message?: string | undefined;

    constructor(data?: IErrorPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorPropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorPropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorPropertyModel {
    propertyName?: string | undefined;
    message?: string | undefined;
}

/** 0 = None, 512 = SpecialName, 1024 = RTSpecialName */
export enum EventAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
}

export class EventInfo implements IEventInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    readonly isSpecialName?: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    readonly isMulticast?: boolean;
    eventHandlerType?: Type;

    constructor(data?: IEventInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : <any>undefined;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : <any>undefined;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : <any>undefined;
            (<any>this).isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : <any>undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : <any>undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : <any>undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    isSpecialName?: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    isMulticast?: boolean;
    eventHandlerType?: Type;
}

/** 1 = Policy, 2 = Novelty, 3 = Extension, 4 = Cancel, 5 = ShorteningPeriod, 6 = Storno */
export enum EventType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

/** 0 = None, 9216 = RsaSign, 41984 = RsaKeyX, 43522 = DiffieHellman */
export enum ExchangeAlgorithmType {
    _0 = 0,
    _9216 = 9216,
    _41984 = 41984,
    _43522 = 43522,
}

/** 0 = Exist, 1 = NotExist */
export enum ExistNotExist {
    _0 = 0,
    _1 = 1,
}

/** 0 = Manufacturer */
export enum FactorCodeType {
    _0 = 0,
}

export class FaxTreatmentModelForUpsert implements IFaxTreatmentModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    faxPhone?: string | undefined;
    sentByFax?: string | undefined;
    faxBy?: string | undefined;
    faxInHonorOf?: string | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    fileAttachment!: string;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;

    constructor(data?: IFaxTreatmentModelForUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.alertHour = _data["alertHour"] ? TimeSpan.fromJS(_data["alertHour"]) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.treatmentType = _data["treatmentType"];
            this.customerId = _data["customerId"];
            this.faxPhone = _data["faxPhone"];
            this.sentByFax = _data["sentByFax"];
            this.faxBy = _data["faxBy"];
            this.faxInHonorOf = _data["faxInHonorOf"];
            this.topic = _data["topic"];
            this.note = _data["note"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
            this.fileAttachment = _data["fileAttachment"];
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FaxTreatmentModelForUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new FaxTreatmentModelForUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["alertHour"] = this.alertHour ? this.alertHour.toJSON() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["treatmentType"] = this.treatmentType;
        data["customerId"] = this.customerId;
        data["faxPhone"] = this.faxPhone;
        data["sentByFax"] = this.sentByFax;
        data["faxBy"] = this.faxBy;
        data["faxInHonorOf"] = this.faxInHonorOf;
        data["topic"] = this.topic;
        data["note"] = this.note;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        data["fileAttachment"] = this.fileAttachment;
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFaxTreatmentModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    faxPhone?: string | undefined;
    sentByFax?: string | undefined;
    faxBy?: string | undefined;
    faxInHonorOf?: string | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    fileAttachment: string;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
}

export class Field implements IField {
    fieldName?: string | undefined;
    title?: string | undefined;
    isSubject?: boolean;

    constructor(data?: IField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.title = _data["title"];
            this.isSubject = _data["isSubject"];
        }
    }

    static fromJS(data: any): Field {
        data = typeof data === 'object' ? data : {};
        let result = new Field();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["title"] = this.title;
        data["isSubject"] = this.isSubject;
        return data;
    }
}

export interface IField {
    fieldName?: string | undefined;
    title?: string | undefined;
    isSubject?: boolean;
}

/** 0 = PrivateScope, 1 = Private, 2 = FamANDAssem, 3 = Assembly, 4 = Family, 5 = FamORAssem, 6 = Public, 7 = FieldAccessMask, 16 = Static, 32 = InitOnly, 64 = Literal, 128 = NotSerialized, 256 = HasFieldRVA, 512 = SpecialName, 1024 = RTSpecialName, 4096 = HasFieldMarshal, 8192 = PinvokeImpl, 32768 = HasDefault, 38144 = ReservedMask */
export enum FieldAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _32768 = 32768,
    _38144 = 38144,
}

export class FieldInfo implements IFieldInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: Type;
    readonly isInitOnly?: boolean;
    readonly isLiteral?: boolean;
    readonly isNotSerialized?: boolean;
    readonly isPinvokeImpl?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;

    constructor(data?: IFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : <any>undefined;
            (<any>this).isInitOnly = _data["isInitOnly"];
            (<any>this).isLiteral = _data["isLiteral"];
            (<any>this).isNotSerialized = _data["isNotSerialized"];
            (<any>this).isPinvokeImpl = _data["isPinvokeImpl"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : <any>undefined;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: Type;
    isInitOnly?: boolean;
    isLiteral?: boolean;
    isNotSerialized?: boolean;
    isPinvokeImpl?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;
}

export class FieldsFilterListModel implements IFieldsFilterListModel {
    fieldsFilter?: UserFieldsFilterModel[] | undefined;
    pageName?: string | undefined;
    readonly pageFields?: { [key: string]: Field[]; } | undefined;
    readonly defaultFieldsFilter?: UserFieldsFilterModel[] | undefined;

    constructor(data?: IFieldsFilterListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fieldsFilter"])) {
                this.fieldsFilter = [] as any;
                for (let item of _data["fieldsFilter"])
                    this.fieldsFilter!.push(UserFieldsFilterModel.fromJS(item));
            }
            this.pageName = _data["pageName"];
            if (_data["pageFields"]) {
                (<any>this).pageFields = {} as any;
                for (let key in _data["pageFields"]) {
                    if (_data["pageFields"].hasOwnProperty(key))
                        (<any>this).pageFields![key] = _data["pageFields"][key] ? _data["pageFields"][key].map((i: any) => Field.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["defaultFieldsFilter"])) {
                (<any>this).defaultFieldsFilter = [] as any;
                for (let item of _data["defaultFieldsFilter"])
                    (<any>this).defaultFieldsFilter!.push(UserFieldsFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldsFilterListModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldsFilterListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldsFilter)) {
            data["fieldsFilter"] = [];
            for (let item of this.fieldsFilter)
                data["fieldsFilter"].push(item.toJSON());
        }
        data["pageName"] = this.pageName;
        if (this.pageFields) {
            data["pageFields"] = {};
            for (let key in this.pageFields) {
                if (this.pageFields.hasOwnProperty(key))
                    data["pageFields"][key] = this.pageFields[key];
            }
        }
        if (Array.isArray(this.defaultFieldsFilter)) {
            data["defaultFieldsFilter"] = [];
            for (let item of this.defaultFieldsFilter)
                data["defaultFieldsFilter"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldsFilterListModel {
    fieldsFilter?: UserFieldsFilterModel[] | undefined;
    pageName?: string | undefined;
    pageFields?: { [key: string]: Field[]; } | undefined;
    defaultFieldsFilter?: UserFieldsFilterModel[] | undefined;
}

/** 0 = PDF, 1 = WORD, 2 = EXCEL, 3 = POWERPOINT, 4 = ACCESS, 5 = IMAGE, 6 = AUDIO, 7 = VIDEO, 8 = APPLICATION, 9 = MAIL, 10 = TEXT, 11 = ZIP, 12 = OTHER */
export enum FileType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
}

export class FilterDataModel implements IFilterDataModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    roleId?: string | undefined;
    officeDepartmentId?: string | undefined;
    branchId?: string | undefined;
    status?: ActivityStatus;
    page?: number;

    constructor(data?: IFilterDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.roleId = _data["roleId"];
            this.officeDepartmentId = _data["officeDepartmentId"];
            this.branchId = _data["branchId"];
            this.status = _data["status"];
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): FilterDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["roleId"] = this.roleId;
        data["officeDepartmentId"] = this.officeDepartmentId;
        data["branchId"] = this.branchId;
        data["status"] = this.status;
        data["page"] = this.page;
        return data;
    }
}

export interface IFilterDataModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    roleId?: string | undefined;
    officeDepartmentId?: string | undefined;
    branchId?: string | undefined;
    status?: ActivityStatus;
    page?: number;
}

export class FilterModel implements IFilterModel {
    property?: string | undefined;
    searchText?: string | undefined;

    constructor(data?: IFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): FilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IFilterModel {
    property?: string | undefined;
    searchText?: string | undefined;
}

export class FilterPageFieldsData implements IFilterPageFieldsData {
    fields?: string[] | undefined;
    pageName?: string | undefined;

    constructor(data?: IFilterPageFieldsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
            this.pageName = _data["pageName"];
        }
    }

    static fromJS(data: any): FilterPageFieldsData {
        data = typeof data === 'object' ? data : {};
        let result = new FilterPageFieldsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        data["pageName"] = this.pageName;
        return data;
    }
}

export interface IFilterPageFieldsData {
    fields?: string[] | undefined;
    pageName?: string | undefined;
}

export class FolderNamespace implements IFolderNamespace {

    constructor(data?: IFolderNamespace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FolderNamespace {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNamespace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IFolderNamespace {
}

/** 0 = Public, 1 = Femi, 2 = National */
export enum ForeignWorkersServiceProviderType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GarageDetailsTab implements IGarageDetailsTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    garageDetailsModel?: SueGarageDetailsModel;

    constructor(data?: IGarageDetailsTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sueId = _data["sueId"];
            this.customerModel = _data["customerModel"] ? CustomerModel.fromJS(_data["customerModel"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorPropertyModel.fromJS(item));
            }
            this.garageDetailsModel = _data["garageDetailsModel"] ? SueGarageDetailsModel.fromJS(_data["garageDetailsModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GarageDetailsTab {
        data = typeof data === 'object' ? data : {};
        let result = new GarageDetailsTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sueId"] = this.sueId;
        data["customerModel"] = this.customerModel ? this.customerModel.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["garageDetailsModel"] = this.garageDetailsModel ? this.garageDetailsModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGarageDetailsTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    garageDetailsModel?: SueGarageDetailsModel;
}

/** 0 = Manual, 1 = Robotic, 2 = Automatic */
export enum GearboxType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = Automatic, 1 = Regular */
export enum GearsType {
    _0 = 0,
    _1 = 1,
}

/** 0 = Male, 1 = Female */
export enum Gender {
    _0 = 0,
    _1 = 1,
}

export class GeneralDetailsTab implements IGeneralDetailsTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    sue?: SueModel;
    handlers?: SelectListItem[] | undefined;
    insueanceCompanies?: SelectListItem[] | undefined;
    customerPolicies?: SelectListItem[] | undefined;
    customerPoliciesList?: PolicyModel[] | undefined;
    customerRidersList?: RiderModel[] | undefined;
    riderCompaniesList?: RiderCompanies[] | undefined;

    constructor(data?: IGeneralDetailsTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sueId = _data["sueId"];
            this.customerModel = _data["customerModel"] ? CustomerModel.fromJS(_data["customerModel"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorPropertyModel.fromJS(item));
            }
            this.sue = _data["sue"] ? SueModel.fromJS(_data["sue"]) : <any>undefined;
            if (Array.isArray(_data["handlers"])) {
                this.handlers = [] as any;
                for (let item of _data["handlers"])
                    this.handlers!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insueanceCompanies"])) {
                this.insueanceCompanies = [] as any;
                for (let item of _data["insueanceCompanies"])
                    this.insueanceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["customerPolicies"])) {
                this.customerPolicies = [] as any;
                for (let item of _data["customerPolicies"])
                    this.customerPolicies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["customerPoliciesList"])) {
                this.customerPoliciesList = [] as any;
                for (let item of _data["customerPoliciesList"])
                    this.customerPoliciesList!.push(PolicyModel.fromJS(item));
            }
            if (Array.isArray(_data["customerRidersList"])) {
                this.customerRidersList = [] as any;
                for (let item of _data["customerRidersList"])
                    this.customerRidersList!.push(RiderModel.fromJS(item));
            }
            if (Array.isArray(_data["riderCompaniesList"])) {
                this.riderCompaniesList = [] as any;
                for (let item of _data["riderCompaniesList"])
                    this.riderCompaniesList!.push(RiderCompanies.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralDetailsTab {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDetailsTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sueId"] = this.sueId;
        data["customerModel"] = this.customerModel ? this.customerModel.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["sue"] = this.sue ? this.sue.toJSON() : <any>undefined;
        if (Array.isArray(this.handlers)) {
            data["handlers"] = [];
            for (let item of this.handlers)
                data["handlers"].push(item.toJSON());
        }
        if (Array.isArray(this.insueanceCompanies)) {
            data["insueanceCompanies"] = [];
            for (let item of this.insueanceCompanies)
                data["insueanceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.customerPolicies)) {
            data["customerPolicies"] = [];
            for (let item of this.customerPolicies)
                data["customerPolicies"].push(item.toJSON());
        }
        if (Array.isArray(this.customerPoliciesList)) {
            data["customerPoliciesList"] = [];
            for (let item of this.customerPoliciesList)
                data["customerPoliciesList"].push(item.toJSON());
        }
        if (Array.isArray(this.customerRidersList)) {
            data["customerRidersList"] = [];
            for (let item of this.customerRidersList)
                data["customerRidersList"].push(item.toJSON());
        }
        if (Array.isArray(this.riderCompaniesList)) {
            data["riderCompaniesList"] = [];
            for (let item of this.riderCompaniesList)
                data["riderCompaniesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneralDetailsTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    sue?: SueModel;
    handlers?: SelectListItem[] | undefined;
    insueanceCompanies?: SelectListItem[] | undefined;
    customerPolicies?: SelectListItem[] | undefined;
    customerPoliciesList?: PolicyModel[] | undefined;
    customerRidersList?: RiderModel[] | undefined;
    riderCompaniesList?: RiderCompanies[] | undefined;
}

/** 0 = None, 1 = Covariant, 2 = Contravariant, 3 = VarianceMask, 4 = ReferenceTypeConstraint, 8 = NotNullableValueTypeConstraint, 16 = DefaultConstructorConstraint, 28 = SpecialConstraintMask */
export enum GenericParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _28 = 28,
}

export class GetAppDictionaryListRequest implements IGetAppDictionaryListRequest {
    type?: KnownDictionaryListTypes;

    constructor(data?: IGetAppDictionaryListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetAppDictionaryListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppDictionaryListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface IGetAppDictionaryListRequest {
    type?: KnownDictionaryListTypes;
}

export class GetLeadOffersRequest implements IGetLeadOffersRequest {
    leadId?: string;

    constructor(data?: IGetLeadOffersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
        }
    }

    static fromJS(data: any): GetLeadOffersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeadOffersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        return data;
    }
}

export interface IGetLeadOffersRequest {
    leadId?: string;
}

export class GetLeadPageModelRequest implements IGetLeadPageModelRequest {
    branchId?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    customerId?: string | undefined;

    constructor(data?: IGetLeadPageModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): GetLeadPageModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeadPageModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IGetLeadPageModelRequest {
    branchId?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    customerId?: string | undefined;
}

export class GetLeviItzhakModelCodeRequest implements IGetLeviItzhakModelCodeRequest {
    licenseNumber?: string | undefined;
    year?: number;

    constructor(data?: IGetLeviItzhakModelCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseNumber = _data["licenseNumber"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): GetLeviItzhakModelCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeviItzhakModelCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseNumber"] = this.licenseNumber;
        data["year"] = this.year;
        return data;
    }
}

export class GetVehicleDetailsRequest implements IGetVehicleDetailsRequest {
    licenseNumber?: string | undefined;
    year?: number;
    modelCode?: string | undefined;

    constructor(data?: IGetVehicleDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseNumber = _data["licenseNumber"];
            this.year = _data["year"];
            this.modelCode = _data["modelCode"];
        }
    }

    static fromJS(data: any): GetVehicleDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetVehicleDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseNumber"] = this.licenseNumber;
        data["year"] = this.year;
        data["modelCode"] = this.modelCode;
        return data;
    }
}

export interface IGetVehicleDetailsRequest {
    licenseNumber?: string | undefined;
    year?: number;
    modelCode?: string | undefined;
}

/************* */
export class UpdateVehicleSubmodelRequest implements IGetVehicleDetailsRequest {
    licenseNumber?: string | undefined;
    VehicleSubmodelId?: string | undefined;

    constructor(data?: IUpdateVehicleSubmodelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseNumber = _data["licenseNumber"];
            this.VehicleSubmodelId = _data["VehicleSubmodelId"];

        }
    }

    static fromJS(data: any): UpdateVehicleSubmodelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleSubmodelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseNumber"] = this.licenseNumber;
        data["VehicleSubmodelId"] = this.VehicleSubmodelId;
        return data;
    }
}

export interface IUpdateVehicleSubmodelRequest {
    licenseNumber?: string | undefined;
    VehicleSubmodelId?: string | undefined;
}
/********** */

export interface IGetLeviItzhakModelCodeRequest {
    licenseNumber?: string | undefined;
    year?: number;
}



export class GetMessageModel implements IGetMessageModel {
    uid?: number;
    type?: SpecialFolder;
    folderName?: string | undefined | null;
    activeMail?: string | undefined;

    constructor(data?: IGetMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.type = _data["type"];
            this.folderName = _data["folderName"];
        }
    }

    static fromJS(data: any): GetMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["type"] = this.type;
        data["folderName"] = this.folderName;
        return data;
    }
}

export interface IGetMessageModel {
    uid?: number;
    type?: SpecialFolder;
    folderName?: string | undefined | null;
}

export class GetPackagesRequest implements IGetPackagesRequest {
    carYear?: number;
    modelCode?: string | undefined;
    vehicleOwnership?: VehicleOwnership;

    constructor(data?: IGetPackagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carYear = _data["carYear"];
            this.modelCode = _data["modelCode"];
            this.vehicleOwnership = _data["vehicleOwnership"];
        }
    }

    static fromJS(data: any): GetPackagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carYear"] = this.carYear;
        data["modelCode"] = this.modelCode;
        data["vehicleOwnership"] = this.vehicleOwnership;
        return data;
    }
}

export interface IGetPackagesRequest {
    carYear?: number;
    modelCode?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
}



export class GetWaMessageModel implements IGetWaMessageModel {
    customerPhoneNumber?: string | undefined;

    constructor(data?: IGetWaMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerPhoneNumber = _data["customerPhoneNumber"];
        }
    }

    static fromJS(data: any): GetWaMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetWaMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        return data;
    }
}

export interface IGetWaMessageModel {
    customerPhoneNumber?: string | undefined;
}

export class Group implements IGroup {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        return data;
    }
}

export interface IGroup {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;
}

////////////////
export class ChangePackagesRequest implements IChangePackagesRequest {
    riderId?: string;
    riderPackages?: Riders_PackagesModel[];
    updateStartDate?: Date;
    updateEndDate?: Date;
    additionNumber?: number;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riderId = _data["riderId"];

            if (Array.isArray(_data["riderPackages"])) {
                this.riderPackages = [] as any;
                for (let item of _data["riderPackages"])
                    this.riderPackages!.push(Riders_PackagesModel.fromJS(item));
            }

            this.updateStartDate = _data["updateStartDate"] ? new Date(_data["updateStartDate"].toString()) : <any>undefined;
            this.updateEndDate = _data["updateEndDate"] ? new Date(_data["updateEndDate"].toString()) : <any>undefined;
            this.additionNumber = _data["additionNumber"];
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riderId"] = this.riderId;
        if (Array.isArray(this.riderPackages)) {
            data["riderPackages"] = [];
            for (let item of this.riderPackages)
                data["riderPackages"].push(item.toJSON());
        }

        data["updateStartDate"] = this.updateStartDate ? this.updateStartDate.toISOString() : <any>undefined;
        data["updateEndDate"] = this.updateEndDate ? this.updateEndDate.toISOString() : <any>undefined;
        data["additionNumber"] = this.additionNumber;
        return data;
    }
}

export interface IChangePackagesRequest {
    riderId?: string;
    riderPackages?: Riders_PackagesModel[];
    updateStartDate?: Date;
    updateEndDate?: Date;
    additionNumber?: number;
}
////////////
////////////////
export class ChangeVehicleRequest implements IChangeVehicleRequest {
    riderId?: string;
    vehicle?: VehicleDataModel;
    updateStartDate?: Date;
    updateEndDate?: Date;
    additionNumber?: number;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riderId = _data["riderId"];
            this.vehicle = _data["vehicle"] ? VehicleDataModel.fromJS(_data["vehicle"]) : <any>undefined;
            this.updateStartDate = _data["updateStartDate"] ? new Date(_data["updateStartDate"].toString()) : <any>undefined;
            this.updateEndDate = _data["updateEndDate"] ? new Date(_data["updateEndDate"].toString()) : <any>undefined;
            this.additionNumber = _data["additionNumber"];
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riderId"] = this.riderId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["riderPackages"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["updateStartDate"] = this.updateStartDate ? this.updateStartDate.toISOString() : <any>undefined;
        data["updateEndDate"] = this.updateEndDate ? this.updateEndDate.toISOString() : <any>undefined;
        data["additionNumber"] = this.additionNumber;
        return data;
    }
}

export interface IChangeVehicleRequest {
    riderId?: string;
    vehicle?: VehicleDataModel;
    updateStartDate?: Date;
    updateEndDate?: Date;
    additionNumber?: number;
}
////////////

export class GroupModel implements IGroupModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;

    constructor(data?: IGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): GroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        return data;
    }
}

export interface IGroupModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;
}

/** 0 = None, 32771 = Md5, 32772 = Sha1, 32780 = Sha256, 32781 = Sha384, 32782 = Sha512 */
export enum HashAlgorithmType {
    _0 = 0,
    _32771 = 32771,
    _32772 = 32772,
    _32780 = 32780,
    _32781 = 32781,
    _32782 = 32782,
}

export class Header implements IHeader {
    readonly offset?: number | undefined;
    field?: string | undefined;
    id?: HeaderId;
    readonly rawField?: string | undefined;
    readonly rawValue?: string | undefined;
    value?: string | undefined;

    constructor(data?: IHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).offset = _data["offset"];
            this.field = _data["field"];
            this.id = _data["id"];
            (<any>this).rawField = _data["rawField"];
            (<any>this).rawValue = _data["rawValue"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Header {
        data = typeof data === 'object' ? data : {};
        let result = new Header();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["field"] = this.field;
        data["id"] = this.id;
        data["rawField"] = this.rawField;
        data["rawValue"] = this.rawValue;
        data["value"] = this.value;
        return data;
    }
}

export interface IHeader {
    offset?: number | undefined;
    field?: string | undefined;
    id?: HeaderId;
    rawField?: string | undefined;
    rawValue?: string | undefined;
    value?: string | undefined;
}

/** 0 = AcceptLanguage, 1 = AdHoc, 2 = AlternateRecipient, 3 = ApparentlyTo, 4 = Approved, 5 = ArcAuthenticationResults, 6 = ArcMessageSignature, 7 = ArcSeal, 8 = Archive, 9 = ArchivedAt, 10 = Article, 11 = AuthenticationResults, 12 = Autocrypt, 13 = AutocryptGossip, 14 = AutocryptSetupMessage, 15 = Autoforwarded, 16 = AutoSubmitted, 17 = Autosubmitted, 18 = Base, 19 = Bcc, 20 = Body, 21 = Bytes, 22 = Cc, 23 = Comments, 24 = ContentAlternative, 25 = ContentBase, 26 = ContentClass, 27 = ContentDescription, 28 = ContentDisposition, 29 = ContentDuration, 30 = ContentFeatures, 31 = ContentId, 32 = ContentIdentifier, 33 = ContentLanguage, 34 = ContentLength, 35 = ContentLocation, 36 = ContentMd5, 37 = ContentReturn, 38 = ContentTransferEncoding, 39 = ContentTranslationType, 40 = ContentType, 41 = Control, 42 = Conversion, 43 = ConversionWithLoss, 44 = Date, 45 = DateReceived, 46 = DeferredDelivery, 47 = DeliveryDate, 48 = DiscloseRecipients, 49 = DispositionNotificationOptions, 50 = DispositionNotificationTo, 51 = Distribution, 52 = DkimSignature, 53 = DomainKeySignature, 54 = Encoding, 55 = Encrypted, 56 = Expires, 57 = ExpiryDate, 58 = FollowupTo, 59 = From, 60 = GenerateDeliveryReport, 61 = Importance, 62 = InjectionDate, 63 = InjectionInfo, 64 = InReplyTo, 65 = Keywords, 66 = Language, 67 = LatestDeliveryTime, 68 = Lines, 69 = ListArchive, 70 = ListHelp, 71 = ListId, 72 = ListOwner, 73 = ListPost, 74 = ListSubscribe, 75 = ListUnsubscribe, 76 = ListUnsubscribePost, 77 = MessageId, 78 = MimeVersion, 79 = Newsgroups, 80 = NntpPostingHost, 81 = Organization, 82 = OriginalFrom, 83 = OriginalMessageId, 84 = OriginalRecipient, 85 = OriginalReturnAddress, 86 = OriginalSubject, 87 = Path, 88 = Precedence, 89 = PreventNonDeliveryReport, 90 = Priority, 91 = Received, 92 = ReceivedSPF, 93 = References, 94 = RelayVersion, 95 = ReplyBy, 96 = ReplyTo, 97 = RequireRecipientValidSince, 98 = ResentBcc, 99 = ResentCc, 100 = ResentDate, 101 = ResentFrom, 102 = ResentMessageId, 103 = ResentReplyTo, 104 = ResentSender, 105 = ResentTo, 106 = ReturnPath, 107 = ReturnReceiptTo, 108 = SeeAlso, 109 = Sender, 110 = Sensitivity, 111 = Solicitation, 112 = Status, 113 = Subject, 114 = Summary, 115 = Supersedes, 116 = TLSRequired, 117 = To, 118 = UserAgent, 119 = X400ContentIdentifier, 120 = X400ContentReturn, 121 = X400ContentType, 122 = X400MTSIdentifier, 123 = X400Originator, 124 = X400Received, 125 = X400Recipients, 126 = X400Trace, 127 = XMailer, 128 = XMSMailPriority, 129 = XPriority, 130 = XStatus, -1 = Unknown */
export enum HeaderId {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _25 = 25,
    _26 = 26,
    _27 = 27,
    _28 = 28,
    _29 = 29,
    _30 = 30,
    _31 = 31,
    _32 = 32,
    _33 = 33,
    _34 = 34,
    _35 = 35,
    _36 = 36,
    _37 = 37,
    _38 = 38,
    _39 = 39,
    _40 = 40,
    _41 = 41,
    _42 = 42,
    _43 = 43,
    _44 = 44,
    _45 = 45,
    _46 = 46,
    _47 = 47,
    _48 = 48,
    _49 = 49,
    _50 = 50,
    _51 = 51,
    _52 = 52,
    _53 = 53,
    _54 = 54,
    _55 = 55,
    _56 = 56,
    _57 = 57,
    _58 = 58,
    _59 = 59,
    _60 = 60,
    _61 = 61,
    _62 = 62,
    _63 = 63,
    _64 = 64,
    _65 = 65,
    _66 = 66,
    _67 = 67,
    _68 = 68,
    _69 = 69,
    _70 = 70,
    _71 = 71,
    _72 = 72,
    _73 = 73,
    _74 = 74,
    _75 = 75,
    _76 = 76,
    _77 = 77,
    _78 = 78,
    _79 = 79,
    _80 = 80,
    _81 = 81,
    _82 = 82,
    _83 = 83,
    _84 = 84,
    _85 = 85,
    _86 = 86,
    _87 = 87,
    _88 = 88,
    _89 = 89,
    _90 = 90,
    _91 = 91,
    _92 = 92,
    _93 = 93,
    _94 = 94,
    _95 = 95,
    _96 = 96,
    _97 = 97,
    _98 = 98,
    _99 = 99,
    _100 = 100,
    _101 = 101,
    _102 = 102,
    _103 = 103,
    _104 = 104,
    _105 = 105,
    _106 = 106,
    _107 = 107,
    _108 = 108,
    _109 = 109,
    _110 = 110,
    _111 = 111,
    _112 = 112,
    _113 = 113,
    _114 = 114,
    _115 = 115,
    _116 = 116,
    _117 = 117,
    _118 = 118,
    _119 = 119,
    _120 = 120,
    _121 = 121,
    _122 = 122,
    _123 = 123,
    _124 = 124,
    _125 = 125,
    _126 = 126,
    _127 = 127,
    _128 = 128,
    _129 = 129,
    _130 = 130,
    __1 = -1,
}

export class HealthInsurancePolicyModel implements IHealthInsurancePolicyModel {
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    id?: string;
    primaryInsuredName?: string | undefined;
    policyOwner?: string;
    primaryInsuredIdentity?: string | undefined;
    primaryInsuredDateOfBirth?: Date;
    primaryInsuredSmoking?: boolean;
    secondaryInsuredName?: string | undefined;
    secondaryInsuredIdentity?: string | undefined;
    secondaryInsuredDateOfBirth?: Date;
    secondaryInsuredSmoking?: boolean;
    premiumFromOffer?: string | undefined;
    discount?: string | undefined;
    kid1Name?: string | undefined;
    kid1Identity?: string | undefined;
    kid2Name?: string | undefined;
    kid2Identity?: string | undefined;
    kid3Name?: string | undefined;
    kid3Identity?: string | undefined;
    kid4Name?: string | undefined;
    kid4Identity?: string | undefined;
    insuranceStartDate?: string | undefined;
    healthInsurancePolicyType?: number;
    healthInsuranceStatus?: number;
    programName?: string | undefined;
    offerDate?: Date;
    cancellationLetter?: ExistNotExist;
    asOf?: Date;
    endOfPeriodAge?: string | undefined;
    endOfPeriodStatusDate?: Date;
    pensionFundTrack?: string | undefined;
    transferringPensionFund?: number;
    firstCollection?: YesNoLag;
    premiumDebt?: string | undefined;
    numberOfDebtMonths?: string | undefined;
    fundamentalIndex?: string | undefined;
    linkageType?: LinkageType;
    collectionFormType?: number;
    collectionFrequency?: number;
    accountNumber?: string | undefined;
    clearingHouse?: string | undefined;
    bankNumber?: string | undefined;
    currentIndex?: string | undefined;
    currentIndexDate?: Date;
    healthPremiumComponents?: HealthPremiumComponentModel[] | undefined;
    insuredInPolicyList?: HealthInsuredInPolicyModel[] | undefined;
    repaids?: RepaidModel[] | undefined;

    constructor(data?: IHealthInsurancePolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agentDetailsList"])) {
                this.agentDetailsList = [] as any;
                for (let item of _data["agentDetailsList"])
                    this.agentDetailsList!.push(AgentDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["salespersons"])) {
                this.salespersons = [] as any;
                for (let item of _data["salespersons"])
                    this.salespersons!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(SelectListItem.fromJS(item));
            }
            this.id = _data["id"];
            this.primaryInsuredName = _data["primaryInsuredName"];
            this.policyOwner = _data["policyOwner"];
            this.primaryInsuredIdentity = _data["primaryInsuredIdentity"];
            this.primaryInsuredDateOfBirth = _data["primaryInsuredDateOfBirth"] ? new Date(_data["primaryInsuredDateOfBirth"].toString()) : <any>undefined;
            this.primaryInsuredSmoking = _data["primaryInsuredSmoking"];
            this.secondaryInsuredName = _data["secondaryInsuredName"];
            this.secondaryInsuredIdentity = _data["secondaryInsuredIdentity"];
            this.secondaryInsuredDateOfBirth = _data["secondaryInsuredDateOfBirth"] ? new Date(_data["secondaryInsuredDateOfBirth"].toString()) : <any>undefined;
            this.secondaryInsuredSmoking = _data["secondaryInsuredSmoking"];
            this.premiumFromOffer = _data["premiumFromOffer"];
            this.discount = _data["discount"];
            this.kid1Name = _data["kid1Name"];
            this.kid1Identity = _data["kid1Identity"];
            this.kid2Name = _data["kid2Name"];
            this.kid2Identity = _data["kid2Identity"];
            this.kid3Name = _data["kid3Name"];
            this.kid3Identity = _data["kid3Identity"];
            this.kid4Name = _data["kid4Name"];
            this.kid4Identity = _data["kid4Identity"];
            this.insuranceStartDate = _data["insuranceStartDate"];
            this.healthInsurancePolicyType = _data["healthInsurancePolicyType"];
            this.healthInsuranceStatus = _data["healthInsuranceStatus"];
            this.programName = _data["programName"];
            this.offerDate = _data["offerDate"] ? new Date(_data["offerDate"].toString()) : <any>undefined;
            this.cancellationLetter = _data["cancellationLetter"];
            this.asOf = _data["asOf"] ? new Date(_data["asOf"].toString()) : <any>undefined;
            this.endOfPeriodAge = _data["endOfPeriodAge"];
            this.endOfPeriodStatusDate = _data["endOfPeriodStatusDate"] ? new Date(_data["endOfPeriodStatusDate"].toString()) : <any>undefined;
            this.pensionFundTrack = _data["pensionFundTrack"];
            this.transferringPensionFund = _data["transferringPensionFund"];
            this.firstCollection = _data["firstCollection"];
            this.premiumDebt = _data["premiumDebt"];
            this.numberOfDebtMonths = _data["numberOfDebtMonths"];
            this.fundamentalIndex = _data["fundamentalIndex"];
            this.linkageType = _data["linkageType"];
            this.collectionFormType = _data["collectionFormType"];
            this.collectionFrequency = _data["collectionFrequency"];
            this.accountNumber = _data["accountNumber"];
            this.clearingHouse = _data["clearingHouse"];
            this.bankNumber = _data["bankNumber"];
            this.currentIndex = _data["currentIndex"];
            this.currentIndexDate = _data["currentIndexDate"] ? new Date(_data["currentIndexDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["healthPremiumComponents"])) {
                this.healthPremiumComponents = [] as any;
                for (let item of _data["healthPremiumComponents"])
                    this.healthPremiumComponents!.push(HealthPremiumComponentModel.fromJS(item));
            }
            if (Array.isArray(_data["insuredInPolicyList"])) {
                this.insuredInPolicyList = [] as any;
                for (let item of _data["insuredInPolicyList"])
                    this.insuredInPolicyList!.push(HealthInsuredInPolicyModel.fromJS(item));
            }
            if (Array.isArray(_data["repaids"])) {
                this.repaids = [] as any;
                for (let item of _data["repaids"])
                    this.repaids!.push(RepaidModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthInsurancePolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthInsurancePolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.agentDetailsList)) {
            data["agentDetailsList"] = [];
            for (let item of this.agentDetailsList)
                data["agentDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.salespersons)) {
            data["salespersons"] = [];
            for (let item of this.salespersons)
                data["salespersons"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["primaryInsuredName"] = this.primaryInsuredName;
        data["policyOwner"] = this.policyOwner;
        data["primaryInsuredIdentity"] = this.primaryInsuredIdentity;
        data["primaryInsuredDateOfBirth"] = this.primaryInsuredDateOfBirth ? this.primaryInsuredDateOfBirth.toISOString() : <any>undefined;
        data["primaryInsuredSmoking"] = this.primaryInsuredSmoking;
        data["secondaryInsuredName"] = this.secondaryInsuredName;
        data["secondaryInsuredIdentity"] = this.secondaryInsuredIdentity;
        data["secondaryInsuredDateOfBirth"] = this.secondaryInsuredDateOfBirth ? this.secondaryInsuredDateOfBirth.toISOString() : <any>undefined;
        data["secondaryInsuredSmoking"] = this.secondaryInsuredSmoking;
        data["premiumFromOffer"] = this.premiumFromOffer;
        data["discount"] = this.discount;
        data["kid1Name"] = this.kid1Name;
        data["kid1Identity"] = this.kid1Identity;
        data["kid2Name"] = this.kid2Name;
        data["kid2Identity"] = this.kid2Identity;
        data["kid3Name"] = this.kid3Name;
        data["kid3Identity"] = this.kid3Identity;
        data["kid4Name"] = this.kid4Name;
        data["kid4Identity"] = this.kid4Identity;
        data["insuranceStartDate"] = this.insuranceStartDate;
        data["healthInsurancePolicyType"] = this.healthInsurancePolicyType;
        data["healthInsuranceStatus"] = this.healthInsuranceStatus;
        data["programName"] = this.programName;
        data["offerDate"] = this.offerDate ? this.offerDate.toISOString() : <any>undefined;
        data["cancellationLetter"] = this.cancellationLetter;
        data["asOf"] = this.asOf ? this.asOf.toISOString() : <any>undefined;
        data["endOfPeriodAge"] = this.endOfPeriodAge;
        data["endOfPeriodStatusDate"] = this.endOfPeriodStatusDate ? this.endOfPeriodStatusDate.toISOString() : <any>undefined;
        data["pensionFundTrack"] = this.pensionFundTrack;
        data["transferringPensionFund"] = this.transferringPensionFund;
        data["firstCollection"] = this.firstCollection;
        data["premiumDebt"] = this.premiumDebt;
        data["numberOfDebtMonths"] = this.numberOfDebtMonths;
        data["fundamentalIndex"] = this.fundamentalIndex;
        data["linkageType"] = this.linkageType;
        data["collectionFormType"] = this.collectionFormType;
        data["collectionFrequency"] = this.collectionFrequency;
        data["accountNumber"] = this.accountNumber;
        data["clearingHouse"] = this.clearingHouse;
        data["bankNumber"] = this.bankNumber;
        data["currentIndex"] = this.currentIndex;
        data["currentIndexDate"] = this.currentIndexDate ? this.currentIndexDate.toISOString() : <any>undefined;
        if (Array.isArray(this.healthPremiumComponents)) {
            data["healthPremiumComponents"] = [];
            for (let item of this.healthPremiumComponents)
                data["healthPremiumComponents"].push(item.toJSON());
        }
        if (Array.isArray(this.insuredInPolicyList)) {
            data["insuredInPolicyList"] = [];
            for (let item of this.insuredInPolicyList)
                data["insuredInPolicyList"].push(item.toJSON());
        }
        if (Array.isArray(this.repaids)) {
            data["repaids"] = [];
            for (let item of this.repaids)
                data["repaids"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHealthInsurancePolicyModel {
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    id?: string;
    primaryInsuredName?: string | undefined;
    policyOwner?: string;
    primaryInsuredIdentity?: string | undefined;
    primaryInsuredDateOfBirth?: Date;
    primaryInsuredSmoking?: boolean;
    secondaryInsuredName?: string | undefined;
    secondaryInsuredIdentity?: string | undefined;
    secondaryInsuredDateOfBirth?: Date;
    secondaryInsuredSmoking?: boolean;
    premiumFromOffer?: string | undefined;
    discount?: string | undefined;
    kid1Name?: string | undefined;
    kid1Identity?: string | undefined;
    kid2Name?: string | undefined;
    kid2Identity?: string | undefined;
    kid3Name?: string | undefined;
    kid3Identity?: string | undefined;
    kid4Name?: string | undefined;
    kid4Identity?: string | undefined;
    insuranceStartDate?: string | undefined;
    healthInsurancePolicyType?: number;
    healthInsuranceStatus?: number;
    programName?: string | undefined;
    offerDate?: Date;
    cancellationLetter?: ExistNotExist;
    asOf?: Date;
    endOfPeriodAge?: string | undefined;
    endOfPeriodStatusDate?: Date;
    pensionFundTrack?: string | undefined;
    transferringPensionFund?: number;
    firstCollection?: YesNoLag;
    premiumDebt?: string | undefined;
    numberOfDebtMonths?: string | undefined;
    fundamentalIndex?: string | undefined;
    linkageType?: LinkageType;
    collectionFormType?: number;
    collectionFrequency?: number;
    accountNumber?: string | undefined;
    clearingHouse?: string | undefined;
    bankNumber?: string | undefined;
    currentIndex?: string | undefined;
    currentIndexDate?: Date;
    healthPremiumComponents?: HealthPremiumComponentModel[] | undefined;
    insuredInPolicyList?: HealthInsuredInPolicyModel[] | undefined;
    repaids?: RepaidModel[] | undefined;
}

export class HealthInsuredInPolicyModel implements IHealthInsuredInPolicyModel {
    id?: string;
    healthInsurancePolicyId?: string;
    insuredCustomer?: string | undefined;
    monthlyPremium?: string | undefined;
    yearlyPremium?: string | undefined;

    constructor(data?: IHealthInsuredInPolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.healthInsurancePolicyId = _data["healthInsurancePolicyId"];
            this.insuredCustomer = _data["insuredCustomer"];
            this.monthlyPremium = _data["monthlyPremium"];
            this.yearlyPremium = _data["yearlyPremium"];
        }
    }

    static fromJS(data: any): HealthInsuredInPolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthInsuredInPolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["healthInsurancePolicyId"] = this.healthInsurancePolicyId;
        data["insuredCustomer"] = this.insuredCustomer;
        data["monthlyPremium"] = this.monthlyPremium;
        data["yearlyPremium"] = this.yearlyPremium;
        return data;
    }
}

export interface IHealthInsuredInPolicyModel {
    id?: string;
    healthInsurancePolicyId?: string;
    insuredCustomer?: string | undefined;
    monthlyPremium?: string | undefined;
    yearlyPremium?: string | undefined;
}

export class HealthPremiumComponentModel implements IHealthPremiumComponentModel {
    id?: string;
    healthInsurancePolicyId?: string;
    coverNumber?: string | undefined;
    coverType?: string | undefined;
    insuredIdentity?: string | undefined;
    insuredName?: string | undefined;
    date?: string | undefined;
    insuranceAmount?: number;
    monthlyPremium?: number;
    extraProfessionalism?: number;
    medicalSupplement?: number;

    constructor(data?: IHealthPremiumComponentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.healthInsurancePolicyId = _data["healthInsurancePolicyId"];
            this.coverNumber = _data["coverNumber"];
            this.coverType = _data["coverType"];
            this.insuredIdentity = _data["insuredIdentity"];
            this.insuredName = _data["insuredName"];
            this.date = _data["date"];
            this.insuranceAmount = _data["insuranceAmount"];
            this.monthlyPremium = _data["monthlyPremium"];
            this.extraProfessionalism = _data["extraProfessionalism"];
            this.medicalSupplement = _data["medicalSupplement"];
        }
    }

    static fromJS(data: any): HealthPremiumComponentModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPremiumComponentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["healthInsurancePolicyId"] = this.healthInsurancePolicyId;
        data["coverNumber"] = this.coverNumber;
        data["coverType"] = this.coverType;
        data["insuredIdentity"] = this.insuredIdentity;
        data["insuredName"] = this.insuredName;
        data["date"] = this.date;
        data["insuranceAmount"] = this.insuranceAmount;
        data["monthlyPremium"] = this.monthlyPremium;
        data["extraProfessionalism"] = this.extraProfessionalism;
        data["medicalSupplement"] = this.medicalSupplement;
        return data;
    }
}

export interface IHealthPremiumComponentModel {
    id?: string;
    healthInsurancePolicyId?: string;
    coverNumber?: string | undefined;
    coverType?: string | undefined;
    insuredIdentity?: string | undefined;
    insuredName?: string | undefined;
    date?: string | undefined;
    insuranceAmount?: number;
    monthlyPremium?: number;
    extraProfessionalism?: number;
    medicalSupplement?: number;
}

export class IAuthenticationSecretDetector implements IIAuthenticationSecretDetector {

    constructor(data?: IIAuthenticationSecretDetector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IAuthenticationSecretDetector {
        data = typeof data === 'object' ? data : {};
        let result = new IAuthenticationSecretDetector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIAuthenticationSecretDetector {
}

export class ICreditFailure implements IICreditFailure {
    saleId?: string | undefined;
    groupPrivateToken?: string | undefined;
    transactionAmount?: string | undefined;

    constructor(data?: IICreditFailure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saleId = _data["saleId"];
            this.groupPrivateToken = _data["groupPrivateToken"];
            this.transactionAmount = _data["transactionAmount"];
        }
    }

    static fromJS(data: any): ICreditFailure {
        data = typeof data === 'object' ? data : {};
        let result = new ICreditFailure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleId"] = this.saleId;
        data["groupPrivateToken"] = this.groupPrivateToken;
        data["transactionAmount"] = this.transactionAmount;
        return data;
    }
}

export interface IICreditFailure {
    saleId?: string | undefined;
    groupPrivateToken?: string | undefined;
    transactionAmount?: string | undefined;
}

export class ICreditGetUrlItem implements IICreditGetUrlItem {
    quantity?: number;
    unitPrice?: number;
    description?: string | undefined;

    constructor(data?: IICreditGetUrlItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ICreditGetUrlItem {
        data = typeof data === 'object' ? data : {};
        let result = new ICreditGetUrlItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["description"] = this.description;
        return data;
    }
}

export interface IICreditGetUrlItem {
    quantity?: number;
    unitPrice?: number;
    description?: string | undefined;
}

export class ICreditVerifyRequest implements IICreditVerifyRequest {
    saleId?: string | undefined;
    groupPrivateToken?: string | undefined;
    transactionAmount?: string | undefined;
    transactionToken?: string | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    documentUrl?: string | undefined;
    transactionCardNum?: string | undefined;
    reference?: string | undefined;

    constructor(data?: IICreditVerifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saleId = _data["saleId"];
            this.groupPrivateToken = _data["groupPrivateToken"];
            this.transactionAmount = _data["transactionAmount"];
            this.transactionToken = _data["transactionToken"];
            this.custom1 = _data["custom1"];
            this.custom2 = _data["custom2"];
            this.documentUrl = _data["documentUrl"];
            this.transactionCardNum = _data["transactionCardNum"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): ICreditVerifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ICreditVerifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleId"] = this.saleId;
        data["groupPrivateToken"] = this.groupPrivateToken;
        data["transactionAmount"] = this.transactionAmount;
        data["transactionToken"] = this.transactionToken;
        data["custom1"] = this.custom1;
        data["custom2"] = this.custom2;
        data["documentUrl"] = this.documentUrl;
        data["transactionCardNum"] = this.transactionCardNum;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IICreditVerifyRequest {
    saleId?: string | undefined;
    groupPrivateToken?: string | undefined;
    transactionAmount?: string | undefined;
    transactionToken?: string | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    documentUrl?: string | undefined;
    transactionCardNum?: string | undefined;
    reference?: string | undefined;
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

/** 1 = IDNumber, 2 = PassportNumber, 3 = CompanyNumber, 4 = AssociationNumber */
export enum IdentityType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class IDNameDescriptionItem implements IIDNameDescriptionItem {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IIDNameDescriptionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IDNameDescriptionItem {
        data = typeof data === 'object' ? data : {};
        let result = new IDNameDescriptionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IIDNameDescriptionItem {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

/** 0 = None, 1 = IMAP4, 2 = IMAP4rev1, 4 = IMAP4rev2, 8 = Status, 16 = Acl, 32 = Quota, 64 = LiteralPlus, 128 = Idle, 256 = MailboxReferrals, 512 = LoginReferrals, 1024 = Namespace, 2048 = Id, 4096 = Children, 8192 = LoginDisabled, 16384 = StartTLS, 32768 = MultiAppend, 65536 = Binary, 131072 = Unselect, 262144 = UidPlus, 524288 = Catenate, 1048576 = CondStore, 2097152 = ESearch, 4194304 = SaslIR, 8388608 = Compress, 16777216 = Within, 33554432 = Enable, 67108864 = QuickResync, 134217728 = SearchResults, 268435456 = Sort, 536870912 = Thread, 1073741824 = Annotate */
export enum ImapCapabilities {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _65536 = 65536,
    _131072 = 131072,
    _262144 = 262144,
    _524288 = 524288,
    _1048576 = 1048576,
    _2097152 = 2097152,
    _4194304 = 4194304,
    _8388608 = 8388608,
    _16777216 = 16777216,
    _33554432 = 33554432,
    _67108864 = 67108864,
    _134217728 = 134217728,
    _268435456 = 268435456,
    _536870912 = 536870912,
    _1073741824 = 1073741824,
    _2147483648 = 2147483648,
    _4294967296 = 4294967296,
    _8589934592 = 8589934592,
    _17179869184 = 17179869184,
    _34359738368 = 34359738368,
    _68719476736 = 68719476736,
    _137438953472 = 137438953472,
    _274877906944 = 274877906944,
    _549755813888 = 549755813888,
    _1099511627776 = 1099511627776,
    _2199023255552 = 2199023255552,
    _4398046511104 = 4398046511104,
    _8796093022208 = 8796093022208,
    _17592186044416 = 17592186044416,
    _35184372088832 = 35184372088832,
    _70368744177664 = 70368744177664,
    _140737488355328 = 140737488355328,
    _281474976710656 = 281474976710656,
    _562949953421312 = 562949953421312,
    _1125899906842624 = 1125899906842624,
    _2251799813685248 = 2251799813685248,
    _4503599627370496 = 4503599627370496,
    _9007199254740992 = 9007199254740992,
    _18014398509481984 = 18014398509481984,
    _36028797018963968 = 36028797018963968,
    _72057594037927936 = 72057594037927936,
    _144115188075855872 = 144115188075855872,
    _1152921504606846976 = 1152921504606846976,
    _2305843009213693952 = 2305843009213693952,
}

export class ImapClient implements IImapClient {
    protocolLogger?: IProtocolLogger;
    sslProtocols?: SslProtocols;
    clientCertificates?: any[] | undefined;
    checkCertificateRevocation?: boolean;
    serverCertificateValidationCallback?: RemoteCertificateValidationCallback;
    localEndPoint?: IPEndPoint;
    proxyClient?: IProxyClient;
    readonly syncRoot?: any | undefined;
    capabilities?: ImapCapabilities;
    readonly appendLimit?: number | undefined;
    readonly internationalizationLevel?: number;
    readonly rights?: AccessRight[] | undefined;
    readonly authenticationMechanisms?: string[] | undefined;
    readonly threadingAlgorithms?: ThreadingAlgorithm[] | undefined;
    timeout?: number;
    readonly isConnected?: boolean;
    readonly isSecure?: boolean;
    readonly isEncrypted?: boolean;
    readonly isSigned?: boolean;
    sslProtocol?: SslProtocols;
    sslCipherAlgorithm?: CipherAlgorithmType;
    readonly sslCipherStrength?: number | undefined;
    sslHashAlgorithm?: HashAlgorithmType;
    readonly sslHashStrength?: number | undefined;
    sslKeyExchangeAlgorithm?: ExchangeAlgorithmType;
    readonly sslKeyExchangeStrength?: number | undefined;
    readonly isAuthenticated?: boolean;
    readonly isIdle?: boolean;
    readonly personalNamespaces?: FolderNamespace[] | undefined;
    readonly sharedNamespaces?: FolderNamespace[] | undefined;
    readonly otherNamespaces?: FolderNamespace[] | undefined;
    readonly supportsQuotas?: boolean;
    readonly inbox?: MimeMessage[] | undefined;

    constructor(data?: IImapClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.protocolLogger = _data["protocolLogger"] ? IProtocolLogger.fromJS(_data["protocolLogger"]) : <any>undefined;
            this.sslProtocols = _data["sslProtocols"];
            if (Array.isArray(_data["clientCertificates"])) {
                this.clientCertificates = [] as any;
                for (let item of _data["clientCertificates"])
                    this.clientCertificates!.push(item);
            }
            this.checkCertificateRevocation = _data["checkCertificateRevocation"];
            this.serverCertificateValidationCallback = _data["serverCertificateValidationCallback"] ? RemoteCertificateValidationCallback.fromJS(_data["serverCertificateValidationCallback"]) : <any>undefined;
            this.localEndPoint = _data["localEndPoint"] ? IPEndPoint.fromJS(_data["localEndPoint"]) : <any>undefined;
            this.proxyClient = _data["proxyClient"] ? IProxyClient.fromJS(_data["proxyClient"]) : <any>undefined;
            (<any>this).syncRoot = _data["syncRoot"];
            this.capabilities = _data["capabilities"];
            (<any>this).appendLimit = _data["appendLimit"];
            (<any>this).internationalizationLevel = _data["internationalizationLevel"];
            if (Array.isArray(_data["rights"])) {
                (<any>this).rights = [] as any;
                for (let item of _data["rights"])
                    (<any>this).rights!.push(AccessRight.fromJS(item));
            }
            if (Array.isArray(_data["authenticationMechanisms"])) {
                (<any>this).authenticationMechanisms = [] as any;
                for (let item of _data["authenticationMechanisms"])
                    (<any>this).authenticationMechanisms!.push(item);
            }
            if (Array.isArray(_data["threadingAlgorithms"])) {
                (<any>this).threadingAlgorithms = [] as any;
                for (let item of _data["threadingAlgorithms"])
                    (<any>this).threadingAlgorithms!.push(item);
            }
            this.timeout = _data["timeout"];
            (<any>this).isConnected = _data["isConnected"];
            (<any>this).isSecure = _data["isSecure"];
            (<any>this).isEncrypted = _data["isEncrypted"];
            (<any>this).isSigned = _data["isSigned"];
            this.sslProtocol = _data["sslProtocol"];
            this.sslCipherAlgorithm = _data["sslCipherAlgorithm"];
            (<any>this).sslCipherStrength = _data["sslCipherStrength"];
            this.sslHashAlgorithm = _data["sslHashAlgorithm"];
            (<any>this).sslHashStrength = _data["sslHashStrength"];
            this.sslKeyExchangeAlgorithm = _data["sslKeyExchangeAlgorithm"];
            (<any>this).sslKeyExchangeStrength = _data["sslKeyExchangeStrength"];
            (<any>this).isAuthenticated = _data["isAuthenticated"];
            (<any>this).isIdle = _data["isIdle"];
            if (Array.isArray(_data["personalNamespaces"])) {
                (<any>this).personalNamespaces = [] as any;
                for (let item of _data["personalNamespaces"])
                    (<any>this).personalNamespaces!.push(FolderNamespace.fromJS(item));
            }
            if (Array.isArray(_data["sharedNamespaces"])) {
                (<any>this).sharedNamespaces = [] as any;
                for (let item of _data["sharedNamespaces"])
                    (<any>this).sharedNamespaces!.push(FolderNamespace.fromJS(item));
            }
            if (Array.isArray(_data["otherNamespaces"])) {
                (<any>this).otherNamespaces = [] as any;
                for (let item of _data["otherNamespaces"])
                    (<any>this).otherNamespaces!.push(FolderNamespace.fromJS(item));
            }
            (<any>this).supportsQuotas = _data["supportsQuotas"];
            if (Array.isArray(_data["inbox"])) {
                (<any>this).inbox = [] as any;
                for (let item of _data["inbox"])
                    (<any>this).inbox!.push(MimeMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImapClient {
        data = typeof data === 'object' ? data : {};
        let result = new ImapClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protocolLogger"] = this.protocolLogger ? this.protocolLogger.toJSON() : <any>undefined;
        data["sslProtocols"] = this.sslProtocols;
        if (Array.isArray(this.clientCertificates)) {
            data["clientCertificates"] = [];
            for (let item of this.clientCertificates)
                data["clientCertificates"].push(item);
        }
        data["checkCertificateRevocation"] = this.checkCertificateRevocation;
        data["serverCertificateValidationCallback"] = this.serverCertificateValidationCallback ? this.serverCertificateValidationCallback.toJSON() : <any>undefined;
        data["localEndPoint"] = this.localEndPoint ? this.localEndPoint.toJSON() : <any>undefined;
        data["proxyClient"] = this.proxyClient ? this.proxyClient.toJSON() : <any>undefined;
        data["syncRoot"] = this.syncRoot;
        data["capabilities"] = this.capabilities;
        data["appendLimit"] = this.appendLimit;
        data["internationalizationLevel"] = this.internationalizationLevel;
        if (Array.isArray(this.rights)) {
            data["rights"] = [];
            for (let item of this.rights)
                data["rights"].push(item.toJSON());
        }
        if (Array.isArray(this.authenticationMechanisms)) {
            data["authenticationMechanisms"] = [];
            for (let item of this.authenticationMechanisms)
                data["authenticationMechanisms"].push(item);
        }
        if (Array.isArray(this.threadingAlgorithms)) {
            data["threadingAlgorithms"] = [];
            for (let item of this.threadingAlgorithms)
                data["threadingAlgorithms"].push(item);
        }
        data["timeout"] = this.timeout;
        data["isConnected"] = this.isConnected;
        data["isSecure"] = this.isSecure;
        data["isEncrypted"] = this.isEncrypted;
        data["isSigned"] = this.isSigned;
        data["sslProtocol"] = this.sslProtocol;
        data["sslCipherAlgorithm"] = this.sslCipherAlgorithm;
        data["sslCipherStrength"] = this.sslCipherStrength;
        data["sslHashAlgorithm"] = this.sslHashAlgorithm;
        data["sslHashStrength"] = this.sslHashStrength;
        data["sslKeyExchangeAlgorithm"] = this.sslKeyExchangeAlgorithm;
        data["sslKeyExchangeStrength"] = this.sslKeyExchangeStrength;
        data["isAuthenticated"] = this.isAuthenticated;
        data["isIdle"] = this.isIdle;
        if (Array.isArray(this.personalNamespaces)) {
            data["personalNamespaces"] = [];
            for (let item of this.personalNamespaces)
                data["personalNamespaces"].push(item.toJSON());
        }
        if (Array.isArray(this.sharedNamespaces)) {
            data["sharedNamespaces"] = [];
            for (let item of this.sharedNamespaces)
                data["sharedNamespaces"].push(item.toJSON());
        }
        if (Array.isArray(this.otherNamespaces)) {
            data["otherNamespaces"] = [];
            for (let item of this.otherNamespaces)
                data["otherNamespaces"].push(item.toJSON());
        }
        data["supportsQuotas"] = this.supportsQuotas;
        if (Array.isArray(this.inbox)) {
            data["inbox"] = [];
            for (let item of this.inbox)
                data["inbox"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImapClient {
    protocolLogger?: IProtocolLogger;
    sslProtocols?: SslProtocols;
    clientCertificates?: any[] | undefined;
    checkCertificateRevocation?: boolean;
    serverCertificateValidationCallback?: RemoteCertificateValidationCallback;
    localEndPoint?: IPEndPoint;
    proxyClient?: IProxyClient;
    syncRoot?: any | undefined;
    capabilities?: ImapCapabilities;
    appendLimit?: number | undefined;
    internationalizationLevel?: number;
    rights?: AccessRight[] | undefined;
    authenticationMechanisms?: string[] | undefined;
    threadingAlgorithms?: ThreadingAlgorithm[] | undefined;
    timeout?: number;
    isConnected?: boolean;
    isSecure?: boolean;
    isEncrypted?: boolean;
    isSigned?: boolean;
    sslProtocol?: SslProtocols;
    sslCipherAlgorithm?: CipherAlgorithmType;
    sslCipherStrength?: number | undefined;
    sslHashAlgorithm?: HashAlgorithmType;
    sslHashStrength?: number | undefined;
    sslKeyExchangeAlgorithm?: ExchangeAlgorithmType;
    sslKeyExchangeStrength?: number | undefined;
    isAuthenticated?: boolean;
    isIdle?: boolean;
    personalNamespaces?: FolderNamespace[] | undefined;
    sharedNamespaces?: FolderNamespace[] | undefined;
    otherNamespaces?: FolderNamespace[] | undefined;
    supportsQuotas?: boolean;
    inbox?: MimeMessage[] | undefined;
}

/** 0 = NoDeductible, 1 = P_1_5, 2 = P_3, 3 = P_5 */
export enum ImpairmentDeductible {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** 0 = Include, 1 = NotInclude */
export enum IncludeNotInclude {
    _0 = 0,
    _1 = 1,
}

export class InjuredAndWitnessesTab implements IInjuredAndWitnessesTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    participant1?: SueParticipantModel;
    participant2?: SueParticipantModel;
    participant3?: SueParticipantModel;
    participant4?: SueParticipantModel;
    participant5?: SueParticipantModel;
    participant6?: SueParticipantModel;
    sueWitness1?: SueWitnessModel;
    sueWitness2?: SueWitnessModel;

    constructor(data?: IInjuredAndWitnessesTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sueId = _data["sueId"];
            this.customerModel = _data["customerModel"] ? CustomerModel.fromJS(_data["customerModel"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorPropertyModel.fromJS(item));
            }
            this.participant1 = _data["participant1"] ? SueParticipantModel.fromJS(_data["participant1"]) : <any>undefined;
            this.participant2 = _data["participant2"] ? SueParticipantModel.fromJS(_data["participant2"]) : <any>undefined;
            this.participant3 = _data["participant3"] ? SueParticipantModel.fromJS(_data["participant3"]) : <any>undefined;
            this.participant4 = _data["participant4"] ? SueParticipantModel.fromJS(_data["participant4"]) : <any>undefined;
            this.participant5 = _data["participant5"] ? SueParticipantModel.fromJS(_data["participant5"]) : <any>undefined;
            this.participant6 = _data["participant6"] ? SueParticipantModel.fromJS(_data["participant6"]) : <any>undefined;
            this.sueWitness1 = _data["sueWitness1"] ? SueWitnessModel.fromJS(_data["sueWitness1"]) : <any>undefined;
            this.sueWitness2 = _data["sueWitness2"] ? SueWitnessModel.fromJS(_data["sueWitness2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InjuredAndWitnessesTab {
        data = typeof data === 'object' ? data : {};
        let result = new InjuredAndWitnessesTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sueId"] = this.sueId;
        data["customerModel"] = this.customerModel ? this.customerModel.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["participant1"] = this.participant1 ? this.participant1.toJSON() : <any>undefined;
        data["participant2"] = this.participant2 ? this.participant2.toJSON() : <any>undefined;
        data["participant3"] = this.participant3 ? this.participant3.toJSON() : <any>undefined;
        data["participant4"] = this.participant4 ? this.participant4.toJSON() : <any>undefined;
        data["participant5"] = this.participant5 ? this.participant5.toJSON() : <any>undefined;
        data["participant6"] = this.participant6 ? this.participant6.toJSON() : <any>undefined;
        data["sueWitness1"] = this.sueWitness1 ? this.sueWitness1.toJSON() : <any>undefined;
        data["sueWitness2"] = this.sueWitness2 ? this.sueWitness2.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInjuredAndWitnessesTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    participant1?: SueParticipantModel;
    participant2?: SueParticipantModel;
    participant3?: SueParticipantModel;
    participant4?: SueParticipantModel;
    participant5?: SueParticipantModel;
    participant6?: SueParticipantModel;
    sueWitness1?: SueWitnessModel;
    sueWitness2?: SueWitnessModel;
}

export class Input implements IInput {
    id?: string;

    constructor(data?: IInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Input {
        data = typeof data === 'object' ? data : {};
        let result = new Input();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IInput {
    id?: string;
}

export class InsuranceCompany implements IInsuranceCompany {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;

    constructor(data?: IInsuranceCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InsuranceCompany {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IInsuranceCompany {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
}

export class InsuranceCompanyModel implements IInsuranceCompanyModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: IInsuranceCompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InsuranceCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IInsuranceCompanyModel {
    id?: string;
    name?: string | undefined;
}

export class InsuranceCompanyRoute implements IInsuranceCompanyRoute {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompany;
    routeId?: number;
    status?: ActivityStatus;
    comment?: string | undefined;
    temsAndCovers?: string | undefined;
    premiumExpansion?: string | undefined;
    temsAndCoversFilePath?: string | undefined;
    specificDetails?: SpecificInsuranceCompanyDetails[] | undefined;

    constructor(data?: IInsuranceCompanyRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.routeId = _data["routeId"];
            this.status = _data["status"];
            this.comment = _data["comment"];
            this.temsAndCovers = _data["temsAndCovers"];
            this.premiumExpansion = _data["premiumExpansion"];
            this.temsAndCoversFilePath = _data["temsAndCoversFilePath"];
            if (Array.isArray(_data["specificDetails"])) {
                this.specificDetails = [] as any;
                for (let item of _data["specificDetails"])
                    this.specificDetails!.push(SpecificInsuranceCompanyDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuranceCompanyRoute {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["routeId"] = this.routeId;
        data["status"] = this.status;
        data["comment"] = this.comment;
        data["temsAndCovers"] = this.temsAndCovers;
        data["premiumExpansion"] = this.premiumExpansion;
        data["temsAndCoversFilePath"] = this.temsAndCoversFilePath;
        if (Array.isArray(this.specificDetails)) {
            data["specificDetails"] = [];
            for (let item of this.specificDetails)
                data["specificDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsuranceCompanyRoute {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompany;
    routeId?: number;
    status?: ActivityStatus;
    comment?: string | undefined;
    temsAndCovers?: string | undefined;
    premiumExpansion?: string | undefined;
    temsAndCoversFilePath?: string | undefined;
    specificDetails?: SpecificInsuranceCompanyDetails[] | undefined;
}


export class InsuranceCompanyRouteModel implements IInsuranceCompanyRouteModel {
    id?: string;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompanyModel;
    routeId?: number;
    status?: ActivityStatus;
    comment?: string | undefined;
    temsAndCovers?: string | undefined;
    premiumExpansion?: string | undefined;
    temsAndCoversFile?: string | undefined;
    temsAndCoversFilePath?: string | undefined;
    specificDetails?: SpecificInsuranceCompanyDetails[] | undefined;
    compulsoryRouteId?: number;

    constructor(data?: IInsuranceCompanyRouteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.routeId = _data["routeId"];
            this.status = _data["status"];
            this.comment = _data["comment"];
            this.temsAndCovers = _data["temsAndCovers"];
            this.premiumExpansion = _data["premiumExpansion"];
            this.temsAndCoversFile = _data["temsAndCoversFile"];
            this.temsAndCoversFilePath = _data["temsAndCoversFilePath"];
            this.compulsoryRouteId = _data["compulsoryRouteId"];
            if (Array.isArray(_data["specificDetails"])) {
                this.specificDetails = [] as any;
                for (let item of _data["specificDetails"])
                    this.specificDetails!.push(SpecificInsuranceCompanyDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuranceCompanyRouteModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyRouteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["routeId"] = this.routeId;
        data["status"] = this.status;
        data["comment"] = this.comment;
        data["temsAndCovers"] = this.temsAndCovers;
        data["premiumExpansion"] = this.premiumExpansion;
        data["temsAndCoversFile"] = this.temsAndCoversFile;
        data["temsAndCoversFilePath"] = this.temsAndCoversFilePath;
        data["compulsoryRouteId"] = this.compulsoryRouteId;
        if (Array.isArray(this.specificDetails)) {
            data["specificDetails"] = [];
            for (let item of this.specificDetails)
                data["specificDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsuranceCompanyRouteModel {
    id?: string;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompanyModel;
    routeId?: number;
    status?: ActivityStatus;
    comment?: string | undefined;
    temsAndCovers?: string | undefined;
    premiumExpansion?: string | undefined;
    temsAndCoversFile?: string | undefined;
    temsAndCoversFilePath?: string | undefined;
    specificDetails?: SpecificInsuranceCompanyDetails[] | undefined;
}

/** 1 = Today, 2 = FirstInTheMonth */
export enum InsuranceStartDate {
    _1 = 1,
    _2 = 2,
}

export class InsuranceType implements IInsuranceType {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    policies?: Policy[] | undefined;

    constructor(data?: IInsuranceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(Policy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuranceType {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsuranceType {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    policies?: Policy[] | undefined;
}

/** 0 = Comprehensive, 1 = ThirdParty, 2 = Compulsory, 3 = CompulsoryComprehensive, 4 = CompulsoryThirdParty */
export enum InsuranceTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class Int32StringKeyValuePair implements IInt32StringKeyValuePair {
    key?: number;
    value?: string | undefined;

    constructor(data?: IInt32StringKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Int32StringKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new Int32StringKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IInt32StringKeyValuePair {
    key?: number;
    value?: string | undefined;
}

export class InternetAddress implements IInternetAddress {
    encoding?: Encoding;
    name?: string | undefined;
    route?: any[];
    address?: string;

    constructor(data?: IInternetAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encoding = _data["encoding"] ? Encoding.fromJS(_data["encoding"]) : <any>undefined;
            this.name = _data["name"];
            this.route = _data["route"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): InternetAddress {
        data = typeof data === 'object' ? data : {};
        let result = new InternetAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encoding"] = this.encoding ? this.encoding.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IInternetAddress {
    encoding?: Encoding;
    name?: string | undefined;
}

export class IntPtr implements IIntPtr {

    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIntPtr {
}

export class InvestmentRouteModel implements IInvestmentRouteModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    routeType?: number;
    provisionType?: number;
    currentDepositPercentage?: string | undefined;
    accrualTrackAmount?: string | undefined;
    investmentTrackName?: string | undefined;
    managementFeeRateActualDeposit?: string | undefined;
    managementFeeRateActualSavings?: string | undefined;
    managementFeeRateStructureSavings?: string | undefined;
    otherManagementFees?: string | undefined;
    netReturn?: string | undefined;
    investmentRouteCode?: string | undefined;

    constructor(data?: IInvestmentRouteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.routeType = _data["routeType"];
            this.provisionType = _data["provisionType"];
            this.currentDepositPercentage = _data["currentDepositPercentage"];
            this.accrualTrackAmount = _data["accrualTrackAmount"];
            this.investmentTrackName = _data["investmentTrackName"];
            this.managementFeeRateActualDeposit = _data["managementFeeRateActualDeposit"];
            this.managementFeeRateActualSavings = _data["managementFeeRateActualSavings"];
            this.managementFeeRateStructureSavings = _data["managementFeeRateStructureSavings"];
            this.otherManagementFees = _data["otherManagementFees"];
            this.netReturn = _data["netReturn"];
            this.investmentRouteCode = _data["investmentRouteCode"];
        }
    }

    static fromJS(data: any): InvestmentRouteModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentRouteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["routeType"] = this.routeType;
        data["provisionType"] = this.provisionType;
        data["currentDepositPercentage"] = this.currentDepositPercentage;
        data["accrualTrackAmount"] = this.accrualTrackAmount;
        data["investmentTrackName"] = this.investmentTrackName;
        data["managementFeeRateActualDeposit"] = this.managementFeeRateActualDeposit;
        data["managementFeeRateActualSavings"] = this.managementFeeRateActualSavings;
        data["managementFeeRateStructureSavings"] = this.managementFeeRateStructureSavings;
        data["otherManagementFees"] = this.otherManagementFees;
        data["netReturn"] = this.netReturn;
        data["investmentRouteCode"] = this.investmentRouteCode;
        return data;
    }
}

export interface IInvestmentRouteModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    routeType?: number;
    provisionType?: number;
    currentDepositPercentage?: string | undefined;
    accrualTrackAmount?: string | undefined;
    investmentTrackName?: string | undefined;
    managementFeeRateActualDeposit?: string | undefined;
    managementFeeRateActualSavings?: string | undefined;
    managementFeeRateStructureSavings?: string | undefined;
    otherManagementFees?: string | undefined;
    netReturn?: string | undefined;
    investmentRouteCode?: string | undefined;
}

/** 0 = Bank, 1 = Other */
export enum InvolvedPartyType {
    _0 = 0,
    _1 = 1,
}

export class InvolvedVehiclesTab implements IInvolvedVehiclesTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    involvedVehicles?: SueInvolvedVehiclesModel;
    insueanceCompanies?: SelectListItem[] | undefined;

    constructor(data?: IInvolvedVehiclesTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sueId = _data["sueId"];
            this.customerModel = _data["customerModel"] ? CustomerModel.fromJS(_data["customerModel"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorPropertyModel.fromJS(item));
            }
            this.involvedVehicles = _data["involvedVehicles"] ? SueInvolvedVehiclesModel.fromJS(_data["involvedVehicles"]) : <any>undefined;
            if (Array.isArray(_data["insueanceCompanies"])) {
                this.insueanceCompanies = [] as any;
                for (let item of _data["insueanceCompanies"])
                    this.insueanceCompanies!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvolvedVehiclesTab {
        data = typeof data === 'object' ? data : {};
        let result = new InvolvedVehiclesTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sueId"] = this.sueId;
        data["customerModel"] = this.customerModel ? this.customerModel.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["involvedVehicles"] = this.involvedVehicles ? this.involvedVehicles.toJSON() : <any>undefined;
        if (Array.isArray(this.insueanceCompanies)) {
            data["insueanceCompanies"] = [];
            for (let item of this.insueanceCompanies)
                data["insueanceCompanies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvolvedVehiclesTab {
    sueId?: string;
    customerModel?: CustomerModel;
    errors?: ErrorPropertyModel[] | undefined;
    involvedVehicles?: SueInvolvedVehiclesModel;
    insueanceCompanies?: SelectListItem[] | undefined;
}

export class IPAddress implements IIPAddress {
    addressFamily?: AddressFamily;
    scopeId?: number;
    readonly isIPv6Multicast?: boolean;
    readonly isIPv6LinkLocal?: boolean;
    readonly isIPv6SiteLocal?: boolean;
    readonly isIPv6Teredo?: boolean;
    readonly isIPv4MappedToIPv6?: boolean;
    address?: number;

    constructor(data?: IIPAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressFamily = _data["addressFamily"];
            this.scopeId = _data["scopeId"];
            (<any>this).isIPv6Multicast = _data["isIPv6Multicast"];
            (<any>this).isIPv6LinkLocal = _data["isIPv6LinkLocal"];
            (<any>this).isIPv6SiteLocal = _data["isIPv6SiteLocal"];
            (<any>this).isIPv6Teredo = _data["isIPv6Teredo"];
            (<any>this).isIPv4MappedToIPv6 = _data["isIPv4MappedToIPv6"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): IPAddress {
        data = typeof data === 'object' ? data : {};
        let result = new IPAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressFamily"] = this.addressFamily;
        data["scopeId"] = this.scopeId;
        data["isIPv6Multicast"] = this.isIPv6Multicast;
        data["isIPv6LinkLocal"] = this.isIPv6LinkLocal;
        data["isIPv6SiteLocal"] = this.isIPv6SiteLocal;
        data["isIPv6Teredo"] = this.isIPv6Teredo;
        data["isIPv4MappedToIPv6"] = this.isIPv4MappedToIPv6;
        data["address"] = this.address;
        return data;
    }
}

export interface IIPAddress {
    addressFamily?: AddressFamily;
    scopeId?: number;
    isIPv6Multicast?: boolean;
    isIPv6LinkLocal?: boolean;
    isIPv6SiteLocal?: boolean;
    isIPv6Teredo?: boolean;
    isIPv4MappedToIPv6?: boolean;
    address?: number;
}

export class IPEndPoint implements IIPEndPoint {
    addressFamily?: AddressFamily;
    address?: IPAddress;
    port?: number;

    constructor(data?: IIPEndPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressFamily = _data["addressFamily"];
            this.address = _data["address"] ? IPAddress.fromJS(_data["address"]) : <any>undefined;
            this.port = _data["port"];
        }
    }

    static fromJS(data: any): IPEndPoint {
        data = typeof data === 'object' ? data : {};
        let result = new IPEndPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressFamily"] = this.addressFamily;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["port"] = this.port;
        return data;
    }
}

export interface IIPEndPoint {
    addressFamily?: AddressFamily;
    address?: IPAddress;
    port?: number;
}

export class IProtocolLogger implements IIProtocolLogger {
    authenticationSecretDetector?: IAuthenticationSecretDetector;

    constructor(data?: IIProtocolLogger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationSecretDetector = _data["authenticationSecretDetector"] ? IAuthenticationSecretDetector.fromJS(_data["authenticationSecretDetector"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IProtocolLogger {
        data = typeof data === 'object' ? data : {};
        let result = new IProtocolLogger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationSecretDetector"] = this.authenticationSecretDetector ? this.authenticationSecretDetector.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIProtocolLogger {
    authenticationSecretDetector?: IAuthenticationSecretDetector;
}

export class IProxyClient implements IIProxyClient {
    proxyCredentials?: NetworkCredential;
    readonly proxyHost?: string | undefined;
    readonly proxyPort?: number;
    localEndPoint?: IPEndPoint;

    constructor(data?: IIProxyClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proxyCredentials = _data["proxyCredentials"] ? NetworkCredential.fromJS(_data["proxyCredentials"]) : <any>undefined;
            (<any>this).proxyHost = _data["proxyHost"];
            (<any>this).proxyPort = _data["proxyPort"];
            this.localEndPoint = _data["localEndPoint"] ? IPEndPoint.fromJS(_data["localEndPoint"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IProxyClient {
        data = typeof data === 'object' ? data : {};
        let result = new IProxyClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proxyCredentials"] = this.proxyCredentials ? this.proxyCredentials.toJSON() : <any>undefined;
        data["proxyHost"] = this.proxyHost;
        data["proxyPort"] = this.proxyPort;
        data["localEndPoint"] = this.localEndPoint ? this.localEndPoint.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIProxyClient {
    proxyCredentials?: NetworkCredential;
    proxyHost?: string | undefined;
    proxyPort?: number;
    localEndPoint?: IPEndPoint;
}

/** 0 = Programmer, 1 = Agriculture, 2 = Business, 3 = Cosmetology, 4 = CustomerService, 5 = Creative, 6 = Education, 7 = Engineering, 8 = Finance, 9 = Healthcare, 10 = Hospitality, 11 = None */
export enum JobTitle {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

/** 0 = Unspecified, 1 = InsuranceTypes, 2 = Gender, 3 = MaritalStatus, 4 = PassedTypeOfInsurance, 5 = AuthorizedToDrive, 6 = ImpairmentDeductible, 7 = VehicleOwnership, 8 = RenovationAgentsOffice, 9 = RenovationCompany, 10 = IdentityType */
export enum KnownDictionaryListTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
}

export class LastDepositDetailsModel implements ILastDepositDetailsModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    depositType?: number;
    myProperty?: number;
    clerkType?: number;
    depositLevelSalary?: string | undefined;
    paidSum?: string | undefined;
    wages?: string | undefined;

    constructor(data?: ILastDepositDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.depositType = _data["depositType"];
            this.myProperty = _data["myProperty"];
            this.clerkType = _data["clerkType"];
            this.depositLevelSalary = _data["depositLevelSalary"];
            this.paidSum = _data["paidSum"];
            this.wages = _data["wages"];
        }
    }

    static fromJS(data: any): LastDepositDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new LastDepositDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["depositType"] = this.depositType;
        data["myProperty"] = this.myProperty;
        data["clerkType"] = this.clerkType;
        data["depositLevelSalary"] = this.depositLevelSalary;
        data["paidSum"] = this.paidSum;
        data["wages"] = this.wages;
        return data;
    }
}

export interface ILastDepositDetailsModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    depositType?: number;
    myProperty?: number;
    clerkType?: number;
    depositLevelSalary?: string | undefined;
    paidSum?: string | undefined;
    wages?: string | undefined;
}

export class LastYearBalanceModel implements ILastYearBalanceModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    lastYearBalancesSum?: number;
    policyValueEndOfYear?: number;
    policyClearedValueEndOfYear?: number;
    updateActuarialBalance?: number;

    constructor(data?: ILastYearBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.lastYearBalancesSum = _data["lastYearBalancesSum"];
            this.policyValueEndOfYear = _data["policyValueEndOfYear"];
            this.policyClearedValueEndOfYear = _data["policyClearedValueEndOfYear"];
            this.updateActuarialBalance = _data["updateActuarialBalance"];
        }
    }

    static fromJS(data: any): LastYearBalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new LastYearBalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["lastYearBalancesSum"] = this.lastYearBalancesSum;
        data["policyValueEndOfYear"] = this.policyValueEndOfYear;
        data["policyClearedValueEndOfYear"] = this.policyClearedValueEndOfYear;
        data["updateActuarialBalance"] = this.updateActuarialBalance;
        return data;
    }
}

export interface ILastYearBalanceModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    lastYearBalancesSum?: number;
    policyValueEndOfYear?: number;
    policyClearedValueEndOfYear?: number;
    updateActuarialBalance?: number;
}

/** 0 = Sequential, 2 = Explicit, 3 = Auto */
export enum LayoutKind {
    _0 = 0,
    _2 = 2,
    _3 = 3,
}

export class Lead implements ILead {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadSource?: LeadSource;
    branchId?: string | undefined;
    stationUserId?: string | undefined;
    stationUser?: User;
    handlerId?: string | undefined;
    handler?: User;
    agentId?: string | undefined;
    agent?: Agent;
    signingUserId?: string | undefined;
    signingUser?: User;
    fullName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    firstName2?: string | undefined;
    lastName2?: string | undefined;
    firstName3?: string | undefined;
    lastName3?: string | undefined;
    phoneNumber1?: string | undefined;
    phoneNumber2?: string | undefined;
    phoneNumber12?: string | undefined;
    phoneNumber22?: string | undefined;
    phoneNumber13?: string | undefined;
    phoneNumber23?: string | undefined;
    email?: string | undefined;
    signature?: string | undefined;
    doubleLead?: boolean;
    identityCardIssueDate?: Date | undefined;
    carLicenseFilePath?: string | undefined;
    comment?: string | undefined;
    internalComment?: string | undefined;
    leadStatuses?: LeadStatus[] | undefined;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    productionType?: ProductionType;
    deliveryDate?: Date | undefined;
    leadAdditions?: LeadAdditionRelation[] | undefined;
    signingPersonId?: string | undefined;
    signingPerson?: User;
    renewalMonth?: number;
    identityType?: IdentityType;
    identifier?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    deductible?: YesNo;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    address?: string | undefined;
    driverYoungIdentifier?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    carLicensePlate?: string | undefined;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    customerId?: string | undefined;
    customer?: Customer;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: boolean;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string | undefined;
    involvedAddress?: CustomerAddress;
    vehicleId?: string | undefined;
    vehicle?: Vehicle;
    offers?: SimulatorOffer[] | undefined;
    riders?: LeadRider[] | undefined;
    simulatorOfferStage?: number;
    simulatorOfferStageDate?: Date;

    constructor(data?: ILead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.driveInShabbat = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.leadSource = _data["leadSource"];
            this.branchId = _data["branchId"];
            this.stationUserId = _data["stationUserId"];
            this.stationUser = _data["stationUser"] ? User.fromJS(_data["stationUser"]) : <any>undefined;
            this.handlerId = _data["handlerId"];
            this.handler = _data["handler"] ? User.fromJS(_data["handler"]) : <any>undefined;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : <any>undefined;
            this.signingUserId = _data["signingUserId"];
            this.signingUser = _data["signingUser"] ? User.fromJS(_data["signingUser"]) : <any>undefined;
            this.fullName = _data["fullName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.firstName2 = _data["firstName2"];
            this.lastName2 = _data["lastName2"];
            this.firstName3 = _data["firstName3"];
            this.lastName3 = _data["lastName3"];
            this.phoneNumber1 = _data["phoneNumber1"];
            this.phoneNumber2 = _data["phoneNumber2"];
            this.phoneNumber12 = _data["phoneNumber12"];
            this.phoneNumber22 = _data["phoneNumber22"];
            this.phoneNumber13 = _data["phoneNumber13"];
            this.phoneNumber23 = _data["phoneNumber23"];
            this.email = _data["email"];
            this.signature = _data["signature"];
            this.doubleLead = _data["doubleLead"];
            this.identityCardIssueDate = _data["identityCardIssueDate"] ? new Date(_data["identityCardIssueDate"].toString()) : <any>undefined;
            this.carLicenseFilePath = _data["carLicenseFilePath"];
            this.comment = _data["comment"];
            this.internalComment = _data["internalComment"];
            if (Array.isArray(_data["leadStatuses"])) {
                this.leadStatuses = [] as any;
                for (let item of _data["leadStatuses"])
                    this.leadStatuses!.push(LeadStatus.fromJS(item));
            }
            this.leadType = _data["leadType"];
            this.productionType = _data["productionType"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["leadAdditions"])) {
                this.leadAdditions = [] as any;
                for (let item of _data["leadAdditions"])
                    this.leadAdditions!.push(LeadAdditionRelation.fromJS(item));
            }
            this.signingPersonId = _data["signingPersonId"];
            this.signingPerson = _data["signingPerson"] ? User.fromJS(_data["signingPerson"]) : <any>undefined;
            this.renewalMonth = _data["renewalMonth"];
            this.identityType = _data["identityType"];
            this.identifier = _data["identifier"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.insuranceType = _data["insuranceType"];
            this.deductible = _data["deductible"];
            this.authorizedToDrive = _data["authorizedToDrive"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.address = _data["address"];
            this.driverYoungIdentifier = _data["driverYoungIdentifier"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.carLicensePlate = _data["carLicensePlate"];
            this.passedTypeOfInsurance1 = _data["passedTypeOfInsurance1"];
            this.sueNumber1 = _data["sueNumber1"];
            this.insuranceCompanyId1 = _data["insuranceCompanyId1"];
            this.passedTypeOfInsurance2 = _data["passedTypeOfInsurance2"];
            this.sueNumber2 = _data["sueNumber2"];
            this.insuranceCompanyId2 = _data["insuranceCompanyId2"];
            this.passedTypeOfInsurance3 = _data["passedTypeOfInsurance3"];
            this.sueNumber3 = _data["sueNumber3"];
            this.insuranceCompanyId3 = _data["insuranceCompanyId3"];
            this.passedTypeOfInsurance4 = _data["passedTypeOfInsurance4"];
            this.sueNumber4 = _data["sueNumber4"];
            this.insuranceCompanyId4 = _data["insuranceCompanyId4"];
            this.bodyClaimsAmount = _data["bodyClaimsAmount"];
            this.revocationsAmount = _data["revocationsAmount"];
            this.noInsurance = _data["noInsurance"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.impairmentDeductible = _data["impairmentDeductible"];
            this.renovationAgentsOffice = _data["renovationAgentsOffice"];
            this.renovationCompany = _data["renovationCompany"];
            this.mainVehicle = _data["mainVehicle"];
            this.autodirection = _data["autodirection"];
            this.driveInShabbat = _data["driveInShabbat"] !== undefined ? _data["driveInShabbat"] : true;
            this.newForOld = _data["newForOld"];
            this.automaticInd = _data["automaticInd"];
            this.engineVolume = _data["engineVolume"];
            this.isVehicleEnslaved = _data["isVehicleEnslaved"];
            this.involvedPartyType = _data["involvedPartyType"];
            this.involvedBank = _data["involvedBank"];
            this.involvedBankBranch = _data["involvedBankBranch"];
            this.involvedName = _data["involvedName"];
            this.involvedAddressId = _data["involvedAddressId"];
            this.involvedAddress = _data["involvedAddress"] ? CustomerAddress.fromJS(_data["involvedAddress"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(SimulatorOffer.fromJS(item));
            }
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders!.push(LeadRider.fromJS(item));
            }
            this.simulatorOfferStage = _data["simulatorOfferStage"];
            this.simulatorOfferStageDate = _data["simulatorOfferStageDate"] ? new Date(_data["simulatorOfferStageDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Lead {
        data = typeof data === 'object' ? data : {};
        let result = new Lead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["leadSource"] = this.leadSource;
        data["branchId"] = this.branchId;
        data["stationUserId"] = this.stationUserId;
        data["stationUser"] = this.stationUser ? this.stationUser.toJSON() : <any>undefined;
        data["handlerId"] = this.handlerId;
        data["handler"] = this.handler ? this.handler.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["signingUserId"] = this.signingUserId;
        data["signingUser"] = this.signingUser ? this.signingUser.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["firstName2"] = this.firstName2;
        data["lastName2"] = this.lastName2;
        data["firstName3"] = this.firstName3;
        data["lastName3"] = this.lastName3;
        data["phoneNumber1"] = this.phoneNumber1;
        data["phoneNumber2"] = this.phoneNumber2;
        data["phoneNumber12"] = this.phoneNumber12;
        data["phoneNumber22"] = this.phoneNumber22;
        data["phoneNumber13"] = this.phoneNumber13;
        data["phoneNumber23"] = this.phoneNumber23;
        data["email"] = this.email;
        data["signature"] = this.signature;
        data["doubleLead"] = this.doubleLead;
        data["identityCardIssueDate"] = this.identityCardIssueDate ? this.identityCardIssueDate.toISOString() : <any>undefined;
        data["carLicenseFilePath"] = this.carLicenseFilePath;
        data["comment"] = this.comment;
        data["internalComment"] = this.internalComment;
        if (Array.isArray(this.leadStatuses)) {
            data["leadStatuses"] = [];
            for (let item of this.leadStatuses)
                data["leadStatuses"].push(item.toJSON());
        }
        data["leadType"] = this.leadType;
        data["productionType"] = this.productionType;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.leadAdditions)) {
            data["leadAdditions"] = [];
            for (let item of this.leadAdditions)
                data["leadAdditions"].push(item.toJSON());
        }
        data["signingPersonId"] = this.signingPersonId;
        data["signingPerson"] = this.signingPerson ? this.signingPerson.toJSON() : <any>undefined;
        data["renewalMonth"] = this.renewalMonth;
        data["identityType"] = this.identityType;
        data["identifier"] = this.identifier;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["insuranceType"] = this.insuranceType;
        data["deductible"] = this.deductible;
        data["authorizedToDrive"] = this.authorizedToDrive;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["address"] = this.address;
        data["driverYoungIdentifier"] = this.driverYoungIdentifier;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["carLicensePlate"] = this.carLicensePlate;
        data["passedTypeOfInsurance1"] = this.passedTypeOfInsurance1;
        data["sueNumber1"] = this.sueNumber1;
        data["insuranceCompanyId1"] = this.insuranceCompanyId1;
        data["passedTypeOfInsurance2"] = this.passedTypeOfInsurance2;
        data["sueNumber2"] = this.sueNumber2;
        data["insuranceCompanyId2"] = this.insuranceCompanyId2;
        data["passedTypeOfInsurance3"] = this.passedTypeOfInsurance3;
        data["sueNumber3"] = this.sueNumber3;
        data["insuranceCompanyId3"] = this.insuranceCompanyId3;
        data["passedTypeOfInsurance4"] = this.passedTypeOfInsurance4;
        data["sueNumber4"] = this.sueNumber4;
        data["insuranceCompanyId4"] = this.insuranceCompanyId4;
        data["bodyClaimsAmount"] = this.bodyClaimsAmount;
        data["revocationsAmount"] = this.revocationsAmount;
        data["noInsurance"] = this.noInsurance;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["impairmentDeductible"] = this.impairmentDeductible;
        data["renovationAgentsOffice"] = this.renovationAgentsOffice;
        data["renovationCompany"] = this.renovationCompany;
        data["mainVehicle"] = this.mainVehicle;
        data["autodirection"] = this.autodirection;
        data["driveInShabbat"] = this.driveInShabbat;
        data["newForOld"] = this.newForOld;
        data["automaticInd"] = this.automaticInd;
        data["engineVolume"] = this.engineVolume;
        data["isVehicleEnslaved"] = this.isVehicleEnslaved;
        data["involvedPartyType"] = this.involvedPartyType;
        data["involvedBank"] = this.involvedBank;
        data["involvedBankBranch"] = this.involvedBankBranch;
        data["involvedName"] = this.involvedName;
        data["involvedAddressId"] = this.involvedAddressId;
        data["involvedAddress"] = this.involvedAddress ? this.involvedAddress.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }
        data["simulatorOfferStage"] = this.simulatorOfferStage;
        data["simulatorOfferStageDate"] = this.simulatorOfferStageDate ? this.simulatorOfferStageDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILead {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadSource?: LeadSource;
    branchId?: string | undefined;
    stationUserId?: string | undefined;
    stationUser?: User;
    handlerId?: string | undefined;
    handler?: User;
    agentId?: string | undefined;
    agent?: Agent;
    signingUserId?: string | undefined;
    signingUser?: User;
    fullName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    firstName2?: string | undefined;
    lastName2?: string | undefined;
    firstName3?: string | undefined;
    lastName3?: string | undefined;
    phoneNumber1?: string | undefined;
    phoneNumber2?: string | undefined;
    phoneNumber12?: string | undefined;
    phoneNumber22?: string | undefined;
    phoneNumber13?: string | undefined;
    phoneNumber23?: string | undefined;
    email?: string | undefined;
    signature?: string | undefined;
    doubleLead?: boolean;
    identityCardIssueDate?: Date | undefined;
    carLicenseFilePath?: string | undefined;
    comment?: string | undefined;
    internalComment?: string | undefined;
    leadStatuses?: LeadStatus[] | undefined;
    leadType?: LeadType;
    productionType?: ProductionType;
    deliveryDate?: Date | undefined;
    leadAdditions?: LeadAdditionRelation[] | undefined;
    signingPersonId?: string | undefined;
    signingPerson?: User;
    renewalMonth?: number;
    identityType?: IdentityType;
    identifier?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    deductible?: YesNo;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    address?: string | undefined;
    driverYoungIdentifier?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    carLicensePlate?: string | undefined;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    customerId?: string | undefined;
    customer?: Customer;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: boolean;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string | undefined;
    involvedAddress?: CustomerAddress;
    vehicleId?: string | undefined;
    vehicle?: Vehicle;
    offers?: SimulatorOffer[] | undefined;
    riders?: LeadRider[] | undefined;
    simulatorOfferStage?: number;
    simulatorOfferStageDate?: Date;
}

export class LeadAddition implements ILeadAddition {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;

    constructor(data?: ILeadAddition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LeadAddition {
        data = typeof data === 'object' ? data : {};
        let result = new LeadAddition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface ILeadAddition {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
}

export class LeadAdditionModel implements ILeadAdditionModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: ILeadAdditionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LeadAdditionModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadAdditionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILeadAdditionModel {
    id?: string;
    name?: string | undefined;
}

export class LeadAdditionRelation implements ILeadAdditionRelation {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    leadAdditionId?: string;
    leadAddition?: LeadAddition;

    constructor(data?: ILeadAdditionRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.leadAdditionId = _data["leadAdditionId"];
            this.leadAddition = _data["leadAddition"] ? LeadAddition.fromJS(_data["leadAddition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LeadAdditionRelation {
        data = typeof data === 'object' ? data : {};
        let result = new LeadAdditionRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["leadAdditionId"] = this.leadAdditionId;
        data["leadAddition"] = this.leadAddition ? this.leadAddition.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILeadAdditionRelation {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    leadAdditionId?: string;
    leadAddition?: LeadAddition;
}

export class LeadAdditionRelationModel implements ILeadAdditionRelationModel {
    id?: string | undefined;
    leadId?: string | undefined;
    leadAdditionId?: string;

    constructor(data?: ILeadAdditionRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.leadAdditionId = _data["leadAdditionId"];
        }
    }

    static fromJS(data: any): LeadAdditionRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadAdditionRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["leadAdditionId"] = this.leadAdditionId;
        return data;
    }
}

export interface ILeadAdditionRelationModel {
    id?: string | undefined;
    leadId?: string | undefined;
    leadAdditionId?: string;
}

export class LeadAPIDirectionModel implements ILeadAPIDirectionModel {
    token?: string | undefined;
    stationUserId?: string;

    constructor(data?: ILeadAPIDirectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.stationUserId = _data["stationUserId"];
        }
    }

    static fromJS(data: any): LeadAPIDirectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadAPIDirectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["stationUserId"] = this.stationUserId;
        return data;
    }
}

export interface ILeadAPIDirectionModel {
    token?: string | undefined;
    stationUserId?: string;
}


export class RenewalsFilterModel implements IRenewalsFilterModel {
    manufacturerId?: string | undefined;
    vehicleModelId?: string | undefined;
    vehicleSubModelId?: string | undefined;
    carYear?: number | undefined;
    StatusIdSearch?: string | undefined | null;
    createDateFrom?: Date | undefined;
    createDateTo?: Date | undefined;
    startDateMonth?: number | undefined;
    startDateYear?: number | undefined;
    branchId?: string | undefined;
    branchType?: number | undefined;
    BranchType?: number | undefined;
    BranchId?: string | undefined;
    stationUserId?: string | undefined;
    insuranceCompanyId?: string | undefined;
    insuranceType?: number;
    salesUserId?: string | undefined;
    creator?: string | undefined;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    polycyType?: number;
    page?: number | undefined;
    searchText?: string | undefined;
    sortBy?: SortModel[] | undefined;
    mobile?: boolean;
    numbeR_OF_OBJECTS_PER_PAGE?: number;
    LeadId?: string | undefined;
    customerId?: string | undefined;
    referrerId?: string | undefined;
    noHandler?: boolean;
    handlerToLink?: string | undefined;

    constructor(data?: ILeadFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerId = _data["manufacturerId"];
            this.vehicleModelId = _data["vehicleModelId"];
            this.vehicleSubModelId = _data["vehicleSubModelId"];
            this.startDateMonth = _data["startDateMonth"];
            this.startDateYear = _data["startDateYear"];
            this.carYear = _data["carYear"];
            this.StatusIdSearch = _data["StatusIdSearch"];
            this.createDateFrom = _data["createDateFrom"] ? new Date(_data["createDateFrom"].toString()) : <any>undefined;
            this.createDateTo = _data["createDateTo"] ? new Date(_data["createDateTo"].toString()) : <any>undefined;
            this.branchId = _data["branchId"];
            this.branchType = _data["branchType"];
            this.stationUserId = _data["stationUserId"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceType = _data["insuranceType"];

            this.salesUserId = _data["salesUserId"];
            this.leadType = _data["leadType"];
            this.page = _data["page"];
            this.searchText = _data["searchText"];
            this.LeadId = _data["LeadId"];
            this.customerId = _data['customerId'];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.mobile = _data["mobile"];
            this.numbeR_OF_OBJECTS_PER_PAGE = _data["numbeR_OF_OBJECTS_PER_PAGE"];
            this.referrerId = _data['referrerId'];
            this.noHandler = _data['noHandler'];
            this.handlerToLink = _data['handlerToLink'];


        }
    }

    static fromJS(data: any): LeadFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerId"] = this.manufacturerId;
        data["vehicleModelId"] = this.vehicleModelId;
        data["vehicleSubModelId"] = this.vehicleSubModelId;
        data["carYear"] = this.carYear;
        data["startDateMonth"] = this.startDateMonth;
        data["startDateYear"] = this.startDateYear;
        data["StatusIdSearch"] = this.StatusIdSearch;
        data["createDateFrom"] = this.createDateFrom ? this.createDateFrom.toISOString() : <any>undefined;
        data["createDateTo"] = this.createDateTo ? this.createDateTo.toISOString() : <any>undefined;
        data["branchId"] = this.branchId;
        data["branchType"] = this.branchType;
        data["stationUserId"] = this.stationUserId;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceType"] = this.insuranceType;

        data["salesUserId"] = this.salesUserId;
        data["leadType"] = this.leadType;
        data["page"] = this.page;
        data["searchText"] = this.searchText;
        data["LeadId"] = this.LeadId;
        data['customerId'] = this.customerId;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["mobile"] = this.mobile;
        data["numbeR_OF_OBJECTS_PER_PAGE"] = this.numbeR_OF_OBJECTS_PER_PAGE;
        data["referrerId"] = this.referrerId;
        data["noHandler"] = this.noHandler;
        data["handlerToLink"] = this.handlerToLink;


        return data;
    }
}

export interface IRenewalsFilterModel {
    manufacturerId?: string | undefined;
    vehicleModelId?: string | undefined;
    vehicleSubModelId?: string | undefined;
    carYear?: number | undefined;
    startDateMonth?: number | undefined;
    startDateYear?: number | undefined;
    StatusIdSearch?: string | undefined | null;
    createDateFrom?: Date | undefined;
    createDateTo?: Date | undefined;
    branchId?: string | undefined;
    branchType?: number | undefined;
    BranchType?: number | undefined;
    BranchId?: string | undefined;
    stationUserId?: string | undefined;
    insuranceCompanyId?: string | undefined;
    insuranceType?: number;
    salesUserId?: string | undefined;
    creator?: string | undefined;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    polycyType?: number;
    page?: number | undefined;
    searchText?: string | undefined;
    sortBy?: SortModel[] | undefined;
    mobile?: boolean;
    numbeR_OF_OBJECTS_PER_PAGE?: number;
    LeadId?: string | undefined;
    customerId?: string | undefined;
    noHandler?: boolean;
    handlerToLink?: string | undefined;
}





export class LeadFilterModel implements ILeadFilterModel {
    manufacturerId?: string | undefined;
    vehicleModelId?: string | undefined;
    vehicleSubModelId?: string | undefined;
    carYear?: number | undefined;
    StatusIdSearch?: string | undefined | null;
    StatusIdsSearch?: string[] | undefined;
    createDateFrom?: Date | undefined;
    createDateTo?: Date | undefined;
    closeDateFrom?: Date | undefined;
    closeDateTo?: Date | undefined;
    deliveryDateFrom?: Date | undefined;
    deliveryDateTo?: Date | undefined;
    branchId?: string | undefined;
    branchType?: number | undefined;
    BranchType?: number | undefined;
    BranchId?: string | undefined;
    stationUserId?: string | undefined;
    salesUserId?: string | undefined;
    creator?: string | undefined;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    polycyType?: number;
    page?: number | undefined;
    searchText?: string | undefined;
    sortBy?: SortModel[] | undefined;
    mobile?: boolean;
    numbeR_OF_OBJECTS_PER_PAGE?: number;
    LeadId?: string | undefined;
    customerId?: string | undefined;
    referrerId?: string | undefined;

    constructor(data?: ILeadFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerId = _data["manufacturerId"];
            this.vehicleModelId = _data["vehicleModelId"];
            this.vehicleSubModelId = _data["vehicleSubModelId"];
            this.carYear = _data["carYear"];
            this.StatusIdSearch = _data["StatusIdSearch"];
            this.createDateFrom = _data["createDateFrom"] ? new Date(_data["createDateFrom"].toString()) : <any>undefined;
            this.createDateTo = _data["createDateTo"] ? new Date(_data["createDateTo"].toString()) : <any>undefined;
            this.closeDateFrom = _data["closeDateFrom"] ? new Date(_data["closeDateFrom"].toString()) : <any>undefined;
            this.closeDateTo = _data["closeDateTo"] ? new Date(_data["closeDateTo"].toString()) : <any>undefined;
            this.deliveryDateFrom = _data["deliveryDateFrom"] ? new Date(_data["deliveryDateFrom"].toString()) : <any>undefined;
            this.deliveryDateTo = _data["deliveryDateTo"] ? new Date(_data["deliveryDateTo"].toString()) : <any>undefined;
            this.branchId = _data["branchId"];
            this.branchType = _data["branchType"];
            this.stationUserId = _data["stationUserId"];
            this.salesUserId = _data["salesUserId"];
            this.leadType = _data["leadType"];
            this.page = _data["page"];
            this.searchText = _data["searchText"];
            this.LeadId = _data["LeadId"];
            this.customerId = _data['customerId'];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.mobile = _data["mobile"];
            this.numbeR_OF_OBJECTS_PER_PAGE = _data["numbeR_OF_OBJECTS_PER_PAGE"];
            this.referrerId = _data['referrerId'];
            // set StatusIdSearch
            if (Array.isArray(_data["StatusIdsSearch"])) {
                this.StatusIdsSearch = [];
                for (let item of _data["StatusIdsSearch"])
                    this.StatusIdsSearch!.push(item);
            }
        }
    }

    static fromJS(data: any): LeadFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerId"] = this.manufacturerId;
        data["vehicleModelId"] = this.vehicleModelId;
        data["vehicleSubModelId"] = this.vehicleSubModelId;
        data["carYear"] = this.carYear;
        data["StatusIdSearch"] = this.StatusIdSearch;
        data["createDateFrom"] = this.createDateFrom ? this.createDateFrom.toISOString() : <any>undefined;
        data["createDateTo"] = this.createDateTo ? this.createDateTo.toISOString() : <any>undefined;
        data["closeDateFrom"] = this.closeDateFrom ? this.closeDateFrom.toISOString() : <any>undefined;
        data["closeDateTo"] = this.closeDateTo ? this.closeDateTo.toISOString() : <any>undefined;
        data["deliveryDateFrom"] = this.deliveryDateFrom ? this.deliveryDateFrom.toISOString() : <any>undefined;
        data["deliveryDateTo"] = this.deliveryDateTo ? this.deliveryDateTo.toISOString() : <any>undefined;
        data["branchId"] = this.branchId;
        data["branchType"] = this.branchType;
        data["stationUserId"] = this.stationUserId;
        data["salesUserId"] = this.salesUserId;
        data["leadType"] = this.leadType;
        data["page"] = this.page;
        data["searchText"] = this.searchText;
        data["LeadId"] = this.LeadId;
        data['customerId'] = this.customerId;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["mobile"] = this.mobile;
        data["numbeR_OF_OBJECTS_PER_PAGE"] = this.numbeR_OF_OBJECTS_PER_PAGE;
        data["referrerId"] = this.referrerId;
        if (Array.isArray(this.StatusIdsSearch)) {
            data["StatusIdsSearch"] = [];
            for (let item of this.StatusIdsSearch)
                data["StatusIdsSearch"].push(item);
        }

        return data;
    }
}

export interface ILeadFilterModel {
    manufacturerId?: string | undefined;
    vehicleModelId?: string | undefined;
    vehicleSubModelId?: string | undefined;
    carYear?: number | undefined;
    StatusIdSearch?: string | undefined | null;
    StatusIdsSearch?: string[] | undefined;
    createDateFrom?: Date | undefined;
    createDateTo?: Date | undefined;
    closeDateFrom?: Date | undefined;
    closeDateTo?: Date | undefined;
    deliveryDateFrom?: Date | undefined;
    deliveryDateTo?: Date | undefined;
    branchId?: string | undefined;
    branchType?: number | undefined;
    BranchType?: number | undefined;
    BranchId?: string | undefined;
    stationUserId?: string | undefined;
    salesUserId?: string | undefined;
    creator?: string | undefined;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    polycyType?: number;
    page?: number | undefined;
    searchText?: string | undefined;
    sortBy?: SortModel[] | undefined;
    mobile?: boolean;
    numbeR_OF_OBJECTS_PER_PAGE?: number;
    LeadId?: string | undefined;
    customerId?: string | undefined;
}

export class LeadModel implements ILeadModel {
    id?: string;
    branchId?: string | undefined;
    loginUser?: UserModel;
    createdDate?: Date;
    updatedDate?: Date;
    leadSource?: LeadSource;
    stationUserId?: string | undefined;
    stationUser?: UserModel;
    signingUserId?: string | undefined;
    signingUser?: UserModel;
    branch?: BranchModel;
    handlerId?: string | undefined;
    handler?: UserModel;
    agentId?: string | undefined;
    agent?: AgentModel;
    fullName?: string | undefined;
    firstName!: string;
    firstName2?: string | undefined;
    lastName2?: string | undefined;
    firstName3?: string | undefined;
    lastName3?: string | undefined;
    phoneNumber12?: string | undefined;
    phoneNumber22?: string | undefined;
    phoneNumber13?: string | undefined;
    phoneNumber23?: string | undefined;
    lastName?: string | undefined;
    phoneNumber1!: string;
    phoneNumber2?: string | undefined;
    signature?: string | undefined;
    simulatorOfferStage?: number;
    simulatorOfferStageDate?: Date;
    doubleLead?: boolean;
    identityCardIssueDate?: Date;
    carLicenseFilePath?: string | undefined;
    hasCarLicenseFile?: boolean;
    comment?: string | undefined;
    internalComment?: string | undefined;
    renewalMonth?: number;
    identityType?: IdentityType;
    identifier?: string | undefined;
    leadStatuses?: LeadStatusModel[] | undefined;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    productionType?: ProductionType;
    lastStatusId?: string;
    lastStatus?: LeadStatusModel;
    carLicenseFile?: any | undefined;
    statuses?: SelectListItem[] | undefined;
    salesPeople?: UserModel[] | undefined;
    agents?: SelectListItem[] | undefined;
    branches?: BranchModel[] | undefined;
    leadComments?: LeadCommentModel[] | undefined;
    users?: UserModel[] | undefined;
    manufacturers?: ManufacturerModel[] | undefined;
    vehicleModels?: VehicleModelModel[] | undefined;
    vehicleSubModels?: VehicleSubModelModel[] | undefined;
    deliveryDate?: Date | undefined;
    leadAdditions?: LeadAdditionRelationModel[] | undefined;
    hasAdditionRelations?: boolean;
    leadAdditionsFromRelation?: LeadAdditionModel[] | undefined;
    additionName?: string | undefined;
    offers?: SimulatorOfferModel[] | undefined;
    roadServices?: boolean;
    treatments?: TreatmentModel[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    policyType: number | undefined;
    deductible?: boolean;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    city?: string | undefined;
    cityId?: number;
    mailBox?: number;
    address?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverYoungIdentifier?: string | undefined;
    driverYoungBirthDateSpecificDate?: boolean | undefined;
    driverYoungSeniorityDateSpecificDate?: boolean | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainIdentifier?: string | undefined;
    driverMainBirthDateSpecificDate?: boolean | undefined;
    driverMainSeniorityDateSpecificDate?: boolean | undefined;
    carLicensePlate?: string | undefined;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    customerId?: string | undefined;
    customer?: CustomerModel;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: YesNo;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string | undefined;
    involvedAddress?: CustomerAddress;
    email?: string | undefined;
    vehicle?: VehicleDataModel;
    vehicleId?: string;
    selectedOfferId?: string | undefined;
    selectedOffer?: SimulatorOfferModel;
    creator?: UserModel;
    propertyType?: number;
    referrerId?: string | undefined;
    policy?: PolicyModel;
    compulsoryPolicy?: PolicyModel;
    rider?: RiderModel;
    renewalRoute?: InsuranceCompanyRouteModel;
    hasSue?: boolean;
    street?: string;
    houseNumber?: string;
    whatsappCarNum?:string;
    constructor(data?: ILeadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchId = _data["branchId"];
            this.loginUser = _data["loginUser"] ? UserModel.fromJS(_data["loginUser"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.leadSource = _data["leadSource"];
            this.stationUserId = _data["stationUserId"];
            this.stationUser = _data["stationUser"] ? UserModel.fromJS(_data["stationUser"]) : <any>undefined;
            this.signingUserId = _data["signingUserId"];
            this.signingUser = _data["signingUser"] ? UserModel.fromJS(_data["signingUser"]) : <any>undefined;
            this.branch = _data["branch"] ? BranchModel.fromJS(_data["branch"]) : <any>undefined;
            this.handlerId = _data["handlerId"];
            this.handler = _data["handler"] ? UserModel.fromJS(_data["handler"]) : <any>undefined;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? AgentModel.fromJS(_data["agent"]) : <any>undefined;
            this.fullName = _data["fullName"];
            this.firstName = _data["firstName"];
            this.firstName2 = _data["firstName2"];
            this.lastName2 = _data["lastName2"];
            this.firstName3 = _data["firstName3"];
            this.lastName3 = _data["lastName3"];
            this.phoneNumber12 = _data["phoneNumber12"];
            this.phoneNumber22 = _data["phoneNumber22"];
            this.phoneNumber13 = _data["phoneNumber13"];
            this.phoneNumber23 = _data["phoneNumber23"];
            this.lastName = _data["lastName"];
            this.phoneNumber1 = _data["phoneNumber1"];
            this.phoneNumber2 = _data["phoneNumber2"];
            this.signature = _data["signature"];
            this.simulatorOfferStage = _data["simulatorOfferStage"];
            this.simulatorOfferStageDate = _data["simulatorOfferStageDate"] ? new Date(_data["simulatorOfferStageDate"].toString()) : <any>undefined;
            this.doubleLead = _data["doubleLead"];
            this.identityCardIssueDate = _data["identityCardIssueDate"] ? new Date(_data["identityCardIssueDate"].toString()) : <any>undefined;
            this.carLicenseFilePath = _data["carLicenseFilePath"];
            this.hasCarLicenseFile = _data["hasCarLicenseFile"];
            this.comment = _data["comment"];
            this.internalComment = _data["internalComment"];
            this.renewalMonth = _data["renewalMonth"];
            this.identityType = _data["identityType"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["leadStatuses"])) {
                this.leadStatuses = [] as any;
                for (let item of _data["leadStatuses"])
                    this.leadStatuses!.push(LeadStatusModel.fromJS(item));
            }
            this.leadType = _data["leadType"];
            this.leadTopType = _data["leadTopType"];
            this.productionType = _data["productionType"];
            this.lastStatusId = _data["lastStatusId"];
            this.lastStatus = _data["lastStatus"] ? LeadStatusModel.fromJS(_data["lastStatus"]) : <any>undefined;
            this.carLicenseFile = _data["carLicenseFile"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["salesPeople"])) {
                this.salesPeople = [] as any;
                for (let item of _data["salesPeople"])
                    this.salesPeople!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchModel.fromJS(item));
            }
            if (Array.isArray(_data["leadComments"])) {
                this.leadComments = [] as any;
                for (let item of _data["leadComments"])
                    this.leadComments!.push(LeadCommentModel.fromJS(item));
            }

            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(ManufacturerModel.fromJS(item));
            }
            if (Array.isArray(_data["vehicleModels"])) {
                this.vehicleModels = [] as any;
                for (let item of _data["vehicleModels"])
                    this.vehicleModels!.push(VehicleModelModel.fromJS(item));
            }
            if (Array.isArray(_data["vehicleSubModels"])) {
                this.vehicleSubModels = [] as any;
                for (let item of _data["vehicleSubModels"])
                    this.vehicleSubModels!.push(VehicleSubModelModel.fromJS(item));
            }
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["leadAdditions"])) {
                this.leadAdditions = [] as any;
                for (let item of _data["leadAdditions"])
                    this.leadAdditions!.push(LeadAdditionRelationModel.fromJS(item));
            }
            this.hasAdditionRelations = _data["hasAdditionRelations"];
            if (Array.isArray(_data["leadAdditionsFromRelation"])) {
                this.leadAdditionsFromRelation = [] as any;
                for (let item of _data["leadAdditionsFromRelation"])
                    this.leadAdditionsFromRelation!.push(LeadAdditionModel.fromJS(item));
            }
            this.additionName = _data["additionName"];
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(SimulatorOfferModel.fromJS(item));
            }
            this.roadServices = _data["roadServices"];
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(TreatmentModel.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.insuranceType = _data["insuranceType"];
            this.policyType = _data["policyType"];
            this.deductible = _data["deductible"];
            this.authorizedToDrive = _data["authorizedToDrive"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.cityId = _data["cityId"];

            this.address = _data["address"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverYoungIdentifier = _data["driverYoungIdentifier"];
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.driverMainIdentifier = _data["driverMainIdentifier"];
            this.carLicensePlate = _data["carLicensePlate"];
            this.passedTypeOfInsurance1 = _data["passedTypeOfInsurance1"];
            this.sueNumber1 = _data["sueNumber1"];
            this.insuranceCompanyId1 = _data["insuranceCompanyId1"];
            this.passedTypeOfInsurance2 = _data["passedTypeOfInsurance2"];
            this.sueNumber2 = _data["sueNumber2"];
            this.insuranceCompanyId2 = _data["insuranceCompanyId2"];
            this.passedTypeOfInsurance3 = _data["passedTypeOfInsurance3"];
            this.sueNumber3 = _data["sueNumber3"];
            this.insuranceCompanyId3 = _data["insuranceCompanyId3"];
            this.passedTypeOfInsurance4 = _data["passedTypeOfInsurance4"];
            this.sueNumber4 = _data["sueNumber4"];
            this.insuranceCompanyId4 = _data["insuranceCompanyId4"];
            this.bodyClaimsAmount = _data["bodyClaimsAmount"];
            this.revocationsAmount = _data["revocationsAmount"];
            this.noInsurance = _data["noInsurance"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.impairmentDeductible = _data["impairmentDeductible"];
            this.renovationAgentsOffice = _data["renovationAgentsOffice"];
            this.renovationCompany = _data["renovationCompany"];
            this.mainVehicle = _data["mainVehicle"];
            this.autodirection = _data["autodirection"];
            this.driveInShabbat = _data["driveInShabbat"];
            this.newForOld = _data["newForOld"];
            this.automaticInd = _data["automaticInd"];
            this.engineVolume = _data["engineVolume"];
            this.isVehicleEnslaved = _data["isVehicleEnslaved"];
            this.involvedPartyType = _data["involvedPartyType"];
            this.involvedBank = _data["involvedBank"];
            this.involvedBankBranch = _data["involvedBankBranch"];
            this.involvedName = _data["involvedName"];
            this.involvedAddressId = _data["involvedAddressId"];
            this.involvedAddress = _data["involvedAddress"] ? CustomerAddress.fromJS(_data["involvedAddress"]) : <any>undefined;
            this.email = _data["email"];
            this.vehicle = _data["vehicle"] ? VehicleDataModel.fromJS(_data["vehicle"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.selectedOfferId = _data["selectedOfferId"];
            this.selectedOffer = _data["selectedOffer"] ? SimulatorOfferModel.fromJS(_data["selectedOffer"]) : <any>undefined;
            this.creator = _data["creator"] ? UserModel.fromJS(_data["creator"]) : <any>undefined;
            this.propertyType = _data["propertyType"];
            this.referrerId = _data["referrerId"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            this.compulsoryPolicy = _data["compulsoryPolicy"] ? PolicyModel.fromJS(_data["compulsoryPolicy"]) : <any>undefined;
            this.rider = _data["rider"] ? RiderModel.fromJS(_data["rider"]) : <any>undefined;
            this.renewalRoute = _data["renewalRoute"] ? InsuranceCompanyRouteModel.fromJS(_data["renewalRoute"]) : <any>undefined;
            this.hasSue = _data["hasSue"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.mailBox = _data["mailBox"];
            this.whatsappCarNum = _data["whatsappCarNum"];

            this.driverYoungBirthDateSpecificDate = _data["driverYoungBirthDateSpecificDate"];
            this.driverYoungSeniorityDateSpecificDate = _data["driverYoungSeniorityDateSpecificDate"];
            this.driverMainBirthDateSpecificDate = _data["driverMainBirthDateSpecificDate"];
            this.driverMainSeniorityDateSpecificDate = _data["driverMainSeniorityDateSpecificDate"];
        }
    }

    static fromJS(data: any): LeadModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleId"] = this.vehicleId;
        data["branchId"] = this.branchId;
        data["loginUser"] = this.loginUser ? this.loginUser.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["leadSource"] = this.leadSource;
        data["stationUserId"] = this.stationUserId;
        data["stationUser"] = this.stationUser ? this.stationUser.toJSON() : <any>undefined;
        data["signingUserId"] = this.signingUserId;
        data["signingUser"] = this.signingUser ? this.signingUser.toJSON() : <any>undefined;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["handlerId"] = this.handlerId;
        data["handler"] = this.handler ? this.handler.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["firstName"] = this.firstName;
        data["firstName2"] = this.firstName2;
        data["lastName2"] = this.lastName2;
        data["firstName3"] = this.firstName3;
        data["lastName3"] = this.lastName3;
        data["phoneNumber12"] = this.phoneNumber12;
        data["phoneNumber22"] = this.phoneNumber22;
        data["phoneNumber13"] = this.phoneNumber13;
        data["phoneNumber23"] = this.phoneNumber23;
        data["lastName"] = this.lastName;
        data["phoneNumber1"] = this.phoneNumber1;
        data["phoneNumber2"] = this.phoneNumber2;
        data["signature"] = this.signature;
        data["simulatorOfferStage"] = this.simulatorOfferStage;
        data["simulatorOfferStageDate"] = this.simulatorOfferStageDate ? this.simulatorOfferStageDate.toISOString() : <any>undefined;
        data["doubleLead"] = this.doubleLead;
        data["identityCardIssueDate"] = this.identityCardIssueDate ? this.identityCardIssueDate.toISOString() : <any>undefined;
        data["carLicenseFilePath"] = this.carLicenseFilePath;
        data["hasCarLicenseFile"] = this.hasCarLicenseFile;
        data["comment"] = this.comment;
        data["internalComment"] = this.internalComment;
        data["renewalMonth"] = this.renewalMonth;
        data["identityType"] = this.identityType;
        data["identifier"] = this.identifier;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        if (Array.isArray(this.leadStatuses)) {
            data["leadStatuses"] = [];
            for (let item of this.leadStatuses)
                data["leadStatuses"].push(item.toJSON());
        }
        data["leadType"] = this.leadType;
        data["leadTopType"] = this.leadTopType;
        data["productionType"] = this.productionType;
        data["lastStatusId"] = this.lastStatusId;
        data["lastStatus"] = this.lastStatus ? this.lastStatus.toJSON() : <any>undefined;
        data["carLicenseFile"] = this.carLicenseFile;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.salesPeople)) {
            data["salesPeople"] = [];
            for (let item of this.salesPeople)
                data["salesPeople"].push(item.toJSON());
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.leadComments)) {
            data["leadComments"] = [];
            for (let item of this.leadComments)
                data["leadComments"].push(item.toJSON());
        }

        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleModels)) {
            data["vehicleModels"] = [];
            for (let item of this.vehicleModels)
                data["vehicleModels"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleSubModels)) {
            data["vehicleSubModels"] = [];
            for (let item of this.vehicleSubModels)
                data["vehicleSubModels"].push(item.toJSON());
        }
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.leadAdditions)) {
            data["leadAdditions"] = [];
            for (let item of this.leadAdditions) {
                // //console.log(item,typeof(item), typeof(item.toJSON));
                data["leadAdditions"].push(item.toJSON());
            }
        }
        data["hasAdditionRelations"] = this.hasAdditionRelations;
        if (Array.isArray(this.leadAdditionsFromRelation)) {
            data["leadAdditionsFromRelation"] = [];
            for (let item of this.leadAdditionsFromRelation)
                data["leadAdditionsFromRelation"].push(item.toJSON());
        }
        data["additionName"] = this.additionName;
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        data["roadServices"] = this.roadServices;
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["insuranceType"] = this.insuranceType;
        data["policyType"] = this.policyType;
        data["deductible"] = this.deductible;
        data["authorizedToDrive"] = this.authorizedToDrive;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["cityId"] = this.cityId;
        data["address"] = this.address;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverYoungIdentifier"] = this.driverYoungIdentifier;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["driverMainIdentifier"] = this.driverMainIdentifier;
        data["carLicensePlate"] = this.carLicensePlate;
        data["passedTypeOfInsurance1"] = this.passedTypeOfInsurance1;
        data["sueNumber1"] = this.sueNumber1;
        data["insuranceCompanyId1"] = this.insuranceCompanyId1;
        data["passedTypeOfInsurance2"] = this.passedTypeOfInsurance2;
        data["sueNumber2"] = this.sueNumber2;
        data["insuranceCompanyId2"] = this.insuranceCompanyId2;
        data["passedTypeOfInsurance3"] = this.passedTypeOfInsurance3;
        data["sueNumber3"] = this.sueNumber3;
        data["insuranceCompanyId3"] = this.insuranceCompanyId3;
        data["passedTypeOfInsurance4"] = this.passedTypeOfInsurance4;
        data["sueNumber4"] = this.sueNumber4;
        data["insuranceCompanyId4"] = this.insuranceCompanyId4;
        data["bodyClaimsAmount"] = this.bodyClaimsAmount;
        data["revocationsAmount"] = this.revocationsAmount;
        data["noInsurance"] = this.noInsurance;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["impairmentDeductible"] = this.impairmentDeductible;
        data["renovationAgentsOffice"] = this.renovationAgentsOffice;
        data["renovationCompany"] = this.renovationCompany;
        data["mainVehicle"] = this.mainVehicle;
        data["autodirection"] = this.autodirection;
        data["driveInShabbat"] = this.driveInShabbat;
        data["newForOld"] = this.newForOld;
        data["automaticInd"] = this.automaticInd;
        data["engineVolume"] = this.engineVolume;
        data["isVehicleEnslaved"] = this.isVehicleEnslaved;
        data["involvedPartyType"] = this.involvedPartyType;
        data["involvedBank"] = this.involvedBank;
        data["involvedBankBranch"] = this.involvedBankBranch;
        data["involvedName"] = this.involvedName;
        data["involvedAddressId"] = this.involvedAddressId;
        data["involvedAddress"] = this.involvedAddress ? CustomerAddress.fromJS(this.involvedAddress).toJSON() : <any>undefined;
        data["email"] = this.email;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["selectedOfferId"] = this.selectedOfferId;
        data["selectedOffer"] = this.selectedOffer ? this.selectedOffer.toJSON() : <any>undefined;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["propertyType"] = this.propertyType;
        data["referrerId"] = this.referrerId;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["compulsoryPolicy"] = this.compulsoryPolicy ? this.compulsoryPolicy.toJSON() : <any>undefined;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["renewalRoute"] = this.renewalRoute ? this.renewalRoute.toJSON() : <any>undefined;
        data["hasSue"] = this.hasSue;
        data["street"] = this.street;
        data["mailBox"] = this.mailBox;
        data["houseNumber"] = this.houseNumber;

        data["driverYoungBirthDateSpecificDate"] = this.driverYoungBirthDateSpecificDate;
        data["driverYoungSeniorityDateSpecificDate"] = this.driverYoungSeniorityDateSpecificDate;
        data["driverMainBirthDateSpecificDate"] = this.driverMainBirthDateSpecificDate;
        data["driverMainSeniorityDateSpecificDate"] = this.driverMainSeniorityDateSpecificDate;
        data["whatsappCarNum"] = this.whatsappCarNum;
        return data;
    }
}

export interface ILeadModel {
    id?: string;
    branchId?: string | undefined;
    loginUser?: UserModel;
    createdDate?: Date;
    updatedDate?: Date;
    leadSource?: LeadSource;
    stationUserId?: string | undefined;
    stationUser?: UserModel;
    signingUserId?: string | undefined;
    signingUser?: UserModel;
    branch?: BranchModel;
    handlerId?: string | undefined;
    handler?: UserModel;
    agentId?: string | undefined;
    agent?: AgentModel;
    fullName?: string | undefined;
    firstName: string;
    firstName2?: string | undefined;
    lastName2?: string | undefined;
    firstName3?: string | undefined;
    lastName3?: string | undefined;
    phoneNumber12?: string | undefined;
    phoneNumber22?: string | undefined;
    phoneNumber13?: string | undefined;
    phoneNumber23?: string | undefined;
    lastName?: string | undefined;
    phoneNumber1: string;
    phoneNumber2?: string | undefined;
    signature?: string | undefined;
    simulatorOfferStage?: number;
    simulatorOfferStageDate?: Date;
    doubleLead?: boolean;
    identityCardIssueDate?: Date;
    carLicenseFilePath?: string | undefined;
    hasCarLicenseFile?: boolean;
    comment?: string | undefined;
    internalComment?: string | undefined;
    renewalMonth?: number;
    identityType?: IdentityType;
    identifier?: string | undefined;
    leadStatuses?: LeadStatusModel[] | undefined;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    productionType?: ProductionType;
    lastStatusId?: string;
    lastStatus?: LeadStatusModel;
    carLicenseFile?: any | undefined;
    statuses?: SelectListItem[] | undefined;
    salesPeople?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    branches?: BranchModel[] | undefined;
    users?: UserModel[] | undefined;
    manufacturers?: ManufacturerModel[] | undefined;
    vehicleModels?: VehicleModelModel[] | undefined;
    vehicleSubModels?: VehicleSubModelModel[] | undefined;
    deliveryDate?: Date | undefined;
    leadAdditions?: LeadAdditionRelationModel[] | undefined;
    hasAdditionRelations?: boolean;
    leadAdditionsFromRelation?: LeadAdditionModel[] | undefined;
    additionName?: string | undefined;
    offers?: SimulatorOfferModel[] | undefined;
    roadServices?: boolean;
    treatments?: TreatmentModel[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    policyType?: number;
    deductible?: boolean;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverYoungIdentifier?: string | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainIdentifier?: string | undefined;
    carLicensePlate?: string | undefined;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    customerId?: string | undefined;
    customer?: CustomerModel;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: YesNo;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string | undefined;
    involvedAddress?: CustomerAddress;
    email?: string | undefined;
    vehicle?: VehicleDataModel;
    vehicleId?: string;
    selectedOfferId?: string | undefined;
    selectedOffer?: SimulatorOfferModel;
    creator?: UserModel;
    propertyType?: number;
    policy?: PolicyModel;
    compulsoryPolicy?: PolicyModel;
    rider?: RiderModel;
    renewalRoute?: InsuranceCompanyRouteModel;
    hasSue?: boolean;
    street?: string;
    mailBox?: number;
    houseNumber?: string;
}

export class LeadRider implements ILeadRider {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    simulatorOfferId?: string | undefined;
    simulatorOffer?: SimulatorOffer;
    riderPackageId?: string;
    riderPackage?: RiderPackage;
    price?: number;

    constructor(data?: ILeadRider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.simulatorOfferId = _data["simulatorOfferId"];
            this.simulatorOffer = _data["simulatorOffer"] ? SimulatorOffer.fromJS(_data["simulatorOffer"]) : <any>undefined;
            this.riderPackageId = _data["riderPackageId"];
            this.riderPackage = _data["riderPackage"] ? RiderPackage.fromJS(_data["riderPackage"]) : <any>undefined;
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): LeadRider {
        data = typeof data === 'object' ? data : {};
        let result = new LeadRider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["simulatorOfferId"] = this.simulatorOfferId;
        data["simulatorOffer"] = this.simulatorOffer ? this.simulatorOffer.toJSON() : <any>undefined;
        data["riderPackageId"] = this.riderPackageId;
        data["riderPackage"] = this.riderPackage ? this.riderPackage.toJSON() : <any>undefined;
        data["price"] = this.price;
        return data;
    }
}

export interface ILeadRider {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    simulatorOfferId?: string | undefined;
    simulatorOffer?: SimulatorOffer;
    riderPackageId?: string;
    riderPackage?: RiderPackage;
    price?: number;
}

export class LeadsCreateRequest implements ILeadsCreateRequest {
    id?: string | undefined;

    constructor(data?: ILeadsCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LeadsCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LeadsCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILeadsCreateRequest {
    id?: string | undefined;
}

export class LeadsIndexRequest implements ILeadsIndexRequest {
    pageCount?: number;
    type?: string | undefined;
    status?: string | undefined;
    branchId?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    closefrom?: Date | undefined;
    closeto?: Date | undefined;

    constructor(data?: ILeadsIndexRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.branchId = _data["branchId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.closefrom = _data["closefrom"] ? new Date(_data["closefrom"].toString()) : <any>undefined;
            this.closeto = _data["closeto"] ? new Date(_data["closeto"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LeadsIndexRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LeadsIndexRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["type"] = this.type;
        data["status"] = this.status;
        data["branchId"] = this.branchId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["closefrom"] = this.closefrom ? this.closefrom.toISOString() : <any>undefined;
        data["closeto"] = this.closeto ? this.closeto.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILeadsIndexRequest {
    pageCount?: number;
    type?: string | undefined;
    status?: string | undefined;
    branchId?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    closefrom?: Date | undefined;
    closeto?: Date | undefined;
}

/** 0 = New, 1 = Renew */
export enum LeadSource {
    _0 = 0,
    _1 = 1,
}

export class LeadsPageModel implements ILeadsPageModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    leads?: SPLeadModel[] | undefined;
    statuses?: SelectListItem[] | undefined;
    searchStatuses?: SelectListItem[] | undefined;
    branches?: BranchesDepartmentsUsersModel;
    salesPeople?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    selectedBranch?: BranchModel;
    from?: Date | undefined;
    to?: Date | undefined;
    closeFrom?: Date | undefined;
    closeTo?: Date | undefined;
    deliveryDateFrom?: Date | undefined;
    deliveryDateTo?: Date | undefined;
    isStationUser?: boolean;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    statusId?: string | undefined;
    modulePermissionType?: PermissionType;
    currentUser?: UserModel;
    level?: number;
    pageSize?: number;
    riders?: RiderLeadModel[] | undefined;

    constructor(data?: ILeadsPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(SPLeadModel.fromJS(item));
            }
            // 
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders!.push(RiderLeadModel.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["searchStatuses"])) {
                this.searchStatuses = [] as any;
                for (let item of _data["searchStatuses"])
                    this.searchStatuses!.push(SelectListItem.fromJS(item));
            }
            this.branches = _data["branches"] ? BranchesDepartmentsUsersModel.fromJS(_data["branches"]) : <any>undefined;
            if (Array.isArray(_data["salesPeople"])) {
                this.salesPeople = [] as any;
                for (let item of _data["salesPeople"])
                    this.salesPeople!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.selectedBranch = _data["selectedBranch"] ? BranchModel.fromJS(_data["selectedBranch"]) : <any>undefined;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.closeFrom = _data["closeFrom"] ? new Date(_data["closeFrom"].toString()) : <any>undefined;
            this.closeTo = _data["closeTo"] ? new Date(_data["closeTo"].toString()) : <any>undefined;
            this.deliveryDateFrom = _data["deliveryDateFrom"] ? new Date(_data["deliveryDateFrom"].toString()) : <any>undefined;
            this.deliveryDateTo = _data["deliveryDateTo"] ? new Date(_data["deliveryDateTo"].toString()) : <any>undefined;
            this.isStationUser = _data["isStationUser"];
            this.leadType = _data["leadType"];
            this.statusId = _data["statusId"];
            this.pageSize = _data["pageSize"];
            this.level = _data["level"];

            this.modulePermissionType = _data["modulePermissionType"];
            this.currentUser = _data["currentUser"] ? UserModel.fromJS(_data["currentUser"]) : <any>undefined;

        }
    }

    static fromJS(data: any): LeadsPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadsPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }

        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.searchStatuses)) {
            data["searchStatuses"] = [];
            for (let item of this.searchStatuses)
                data["searchStatuses"].push(item.toJSON());
        }
        data["branches"] = this.branches ? this.branches.toJSON() : <any>undefined;
        if (Array.isArray(this.salesPeople)) {
            data["salesPeople"] = [];
            for (let item of this.salesPeople)
                data["salesPeople"].push(item.toJSON());
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["selectedBranch"] = this.selectedBranch ? this.selectedBranch.toJSON() : <any>undefined;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["closeFrom"] = this.closeFrom ? this.closeFrom.toISOString() : <any>undefined;
        data["closeTo"] = this.closeTo ? this.closeTo.toISOString() : <any>undefined;
        data["deliveryDateFrom"] = this.deliveryDateFrom ? this.deliveryDateFrom.toISOString() : <any>undefined;
        data["deliveryDateTo"] = this.deliveryDateTo ? this.deliveryDateTo.toISOString() : <any>undefined;
        data["isStationUser"] = this.isStationUser;
        data["leadType"] = this.leadType;
        data["statusId"] = this.statusId;
        data["pageSize"] = this.pageSize;
        data["level"] = this.level;

        data["modulePermissionType"] = this.modulePermissionType;
        data["currentUser"] = this.currentUser ? this.currentUser.toJSON() : <any>undefined;



        return data;
    }
}

export interface ILeadsPageModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    leads?: SPLeadModel[] | undefined;
    statuses?: SelectListItem[] | undefined;
    searchStatuses?: SelectListItem[] | undefined;
    branches?: BranchesDepartmentsUsersModel;
    salesPeople?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    selectedBranch?: BranchModel;
    from?: Date | undefined;
    to?: Date | undefined;
    closeFrom?: Date | undefined;
    closeTo?: Date | undefined;
    deliveryDateFrom?: Date | undefined;
    deliveryDateTo?: Date | undefined;
    isStationUser?: boolean;
    leadType?: LeadType;
    leadTopType?: LeadTopType;
    statusId?: string | undefined;
    modulePermissionType?: PermissionType;
    currentUser?: UserModel;
    riders?: RiderLeadModel[] | undefined;
    level?: number;

}

export class Credential {
    username?: string;
    password?: string;

    constructor(data?: Credential) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];

        }
    }

    static fromJS(data: any): Credential {
        data = typeof data === 'object' ? data : {};
        let result = new Credential();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;

        return data;
    }
};

export class CredentialShlomo extends Credential {
    identity?: string;

    constructor(data?: CredentialShlomo) {
        super();
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identity = _data["identity"];
            this.username = _data["username"];
            this.password = _data["password"];

        }
    }

    static fromJS(data: any): CredentialShlomo {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialShlomo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identity"] = this.identity;
        data["username"] = this.username;
        data["password"] = this.password;

        return data;
    }
};
export class RenewalsConfigData {
    Ayalon?: Credential;
    Hachshara?: Credential;
    Fnx?: Credential;
    Clal?: Credential;
    Migdal?: Credential;
    Menora?: Credential;
    Shomera?: Credential;
    Shlomo?: CredentialShlomo;
    Harel?: Credential;

    constructor(data?: RenewalsConfigData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Ayalon = _data["Ayalon"];
            this.Hachshara = _data["Hachshara"];
            this.Fnx = _data["Fnx"];
            this.Clal = _data["Clal"];
            this.Migdal = _data["Migdal"];
            this.Menora = _data["Menora"];
            this.Shomera = _data["Shomera"];
            this.Shlomo = _data["Shlomo"];
            this.Harel = _data["Harel"];

        }
    }

    static fromJS(data: any): RenewalsConfigData {
        const result = new RenewalsConfigData();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = typeof data === 'object' ? data : {};
        data["Ayalon"] = this.Ayalon;
        data["Hachshara"] = this.Hachshara;
        data["Fnx"] = this.Fnx;
        data["Clal"] = this.Clal;
        data["Migdal"] = this.Migdal;
        data["Menora"] = this.Menora;
        data["Shomera"] = this.Shomera;
        data["Shlomo"] = this.Shlomo;
        data["Harel"] = this.Harel;

        return data;
    }
}

export class LeadsShortModel implements ILeadsShortModel {
    id?: string;
    changeStatusDate?: Date;
    statusId?: string | undefined;
    statusName?: string | undefined;
    year?: number;
    model?: string | undefined;
    phoneNumber?: string | undefined;
    nameOfCustomer?: string | undefined;
    nameOfUser?: string | undefined;
    branchId?: string | undefined;
    branchName?: string | undefined;
    stationId?: string | undefined;
    stationName?: string | undefined;
    date?: Date;
    notes?: string | undefined;

    constructor(data?: ILeadsShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.changeStatusDate = _data["changeStatusDate"] ? new Date(_data["changeStatusDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.year = _data["year"];
            this.model = _data["model"];
            this.phoneNumber = _data["phoneNumber"];
            this.nameOfCustomer = _data["nameOfCustomer"];
            this.nameOfUser = _data["nameOfUser"];
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
            this.stationId = _data["stationId"];
            this.stationName = _data["stationName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): LeadsShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadsShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["changeStatusDate"] = this.changeStatusDate ? this.changeStatusDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["year"] = this.year;
        data["model"] = this.model;
        data["phoneNumber"] = this.phoneNumber;
        data["nameOfCustomer"] = this.nameOfCustomer;
        data["nameOfUser"] = this.nameOfUser;
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        data["stationId"] = this.stationId;
        data["stationName"] = this.stationName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ILeadsShortModel {
    id?: string;
    changeStatusDate?: Date;
    statusId?: string | undefined;
    statusName?: string | undefined;
    year?: number;
    model?: string | undefined;
    phoneNumber?: string | undefined;
    nameOfCustomer?: string | undefined;
    nameOfUser?: string | undefined;
    branchId?: string | undefined;
    branchName?: string | undefined;
    stationId?: string | undefined;
    stationName?: string | undefined;
    date?: Date;
    notes?: string | undefined;
}

export class LeadStatus implements ILeadStatus {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    lead?: Lead;
    statusId?: string;
    status?: LeadStatusType;

    constructor(data?: ILeadStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.lead = _data["lead"] ? Lead.fromJS(_data["lead"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? LeadStatusType.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LeadStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LeadStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILeadStatus {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    lead?: Lead;
    statusId?: string;
    status?: LeadStatusType;
}

export class LeadStatusModel implements ILeadStatusModel {
    id?: string;
    leadId?: string;
    lead?: LeadModel;
    statusId?: string;
    status?: LeadStatusTypeModel;
    createdDate?: Date;
    updatedDate?: Date;

    constructor(data?: ILeadStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.lead = _data["lead"] ? LeadModel.fromJS(_data["lead"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? LeadStatusTypeModel.fromJS(_data["status"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LeadStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILeadStatusModel {
    id?: string;
    leadId?: string;
    lead?: LeadModel;
    statusId?: string;
    status?: LeadStatusTypeModel;
    createdDate?: Date;
    updatedDate?: Date;
}

export class LeadStatusType implements ILeadStatusType {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    sequance?: number;
    auto?: number | undefined;

    constructor(data?: ILeadStatusType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.sequance = _data["sequance"];
            this.auto = _data["auto"];
        }
    }

    static fromJS(data: any): LeadStatusType {
        data = typeof data === 'object' ? data : {};
        let result = new LeadStatusType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["sequance"] = this.sequance;
        data["auto"] = this.auto;
        return data;
    }
}

export interface ILeadStatusType {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    sequance?: number;
    auto?: number | undefined;
}

export class LeadStatusTypeModel implements ILeadStatusTypeModel {
    id?: string;
    name?: string | undefined;
    sequance?: number;
    auto?: number | undefined;

    constructor(data?: ILeadStatusTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequance = _data["sequance"];
            this.auto = _data["auto"];
        }
    }

    static fromJS(data: any): LeadStatusTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadStatusTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequance"] = this.sequance;
        data["auto"] = this.auto;
        return data;
    }
}

export interface ILeadStatusTypeModel {
    id?: string;
    name?: string | undefined;
    sequance?: number;
    auto?: number | undefined;
}

/** 0 = New, 1 = Used, 2 = Select */
export enum LeadType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum LeadTopType {
    _0 = 0, // Vehicle
    _1 = 1, // Appartment
    _2 = 2, // Other
}

export class LifeInsurancePolicyModel implements ILifeInsurancePolicyModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    productType?: LifeInsuranceProductType;
    programName?: string | undefined;
    manufacturerID?: string | undefined;
    manufacturerName?: string | undefined;
    employer?: EmployerModel;
    employerId?: string | undefined;
    employerStatus?: EmployerStatusType;
    manufacturerContactFirstName?: string | undefined;
    manufacturerContactLastName?: string | undefined;
    manufacturerContactPhone?: string | undefined;
    manufacturerContactFax?: string | undefined;
    finalRecipientFactorCode?: FactorCodeType;
    finalRecipientEmployerType?: EmployerType;
    finalRecipientIdentity?: string | undefined;
    finalRecipientManufacturerId?: string | undefined;
    insuredIdentityType?: IdentityType;
    insuredIdentityNumber?: string | undefined;
    manufacturerDistributorNumber?: string | undefined;
    infoCorrectnessDate?: Date;
    joiningProductDate?: Date;
    firstJoiningProductDate?: Date;
    pensionFundType?: number;
    pensionFundStatus?: number;
    accountStatusUpdateDate?: Date;
    accountStatus?: number;
    temporaryRiskStartDate?: Date;
    temporaryRiskEndDate?: Date;
    policyType?: PolicyType;
    accountPlanType?: number;
    baseIndex?: string | undefined;
    termsLoanLinkage?: YesNo;
    fixedMoney190?: YesNo;
    shippingAddressCountry?: string | undefined;
    shippingAddressLocality?: string | undefined;
    shippingAddressLocalitySymbol?: string | undefined;
    shippingAddressStreet?: string | undefined;
    shippingAddressHousNumber?: string | undefined;
    shippingAddressApartmentEnterNumber?: string | undefined;
    shippingAddressApartmentNumber?: string | undefined;
    shippingAddressPostalCode?: string | undefined;
    shippingAddressMailbox?: string | undefined;
    insuranceTrackPensionFund?: string | undefined;
    insuranceTrackName?: string | undefined;
    imposedLien?: YesNoUnknown;
    imposedForeclosure?: YesNoUnknown;
    isLoanProduct?: boolean;
    isClaimPolicyAccount?: boolean;
    isCollectiveInsuranceCoverageForMembers?: boolean;
    isPowerOfAttorney?: boolean;
    investmentRoutes?: InvestmentRouteModel[] | undefined;
    wageCalculationCode?: number;
    polocySalary?: number;
    wagesLink?: number;
    salaryCorrectnessDate?: Date;
    unconditionalEligibility?: YesNoUnknown;
    section14?: YesNoUnknown;
    startDepositPaymentDate?: Date;
    secretionsDetailsPercent?: number;
    secretionsDetailsSum?: number;
    secretionsDetailsDate?: Date;
    employerLossWorkCapacityPercent?: number;
    employerLossWorkCapacitySum?: number;
    employerLossWorkCapacityDate?: Date;
    employerComparisonFundPercent?: number;
    employerComparisonFundSum?: number;
    employerComparisonFundDate?: Date;
    employerRewardsPercent?: number;
    employerRewardsSum?: number;
    employerRewardsDate?: Date;
    employerOthersPercent?: number;
    employerOthersSum?: number;
    employerOthersDate?: Date;
    workerRewardsPercent?: number;
    workerRewardsSum?: number;
    workerRewardsDate?: Date;
    workerLossWorkCapacityPercent?: number;
    workerLossWorkCapacitySum?: number;
    workerLossWorkCapacityDate?: Date;
    workerComparisonFundPercent?: number;
    workerComparisonFundSum?: number;
    workerComparisonFundDate?: Date;
    workerRewards47Percent?: number;
    workerRewards47Sum?: number;
    workerRewards47Date?: Date;
    workerOthersPercent?: number;
    workerOthersSum?: number;
    workerOthersDate?: Date;
    workerRewardsPrivatePercent?: number;
    workerRewardsPrivateSum?: number;
    workerRewardsPrivateDate?: Date;
    payerName?: string | undefined;
    payerIdentityType?: IdentityType;
    payerIdentity?: string | undefined;
    paymrntFrequency?: number;
    monthFrequency?: number;
    collectionDay?: number;
    paymentMethodType?: PaymentMethodType;
    attachCollectionType?: number;
    percentageSubAnnuals?: number;
    arrearsDebt?: YesNo;
    satrtArrearsDebtDate?: Date;
    arrearsDebtMonthCount?: number;
    debtType?: number;
    arrearsDebtSum?: number;
    unassociatedFunds?: YesNo;
    lastDepositDate?: Date;
    lastDepositSum?: number;
    lastDepositValueDate?: Date;
    depositType?: number;
    lastSepositCumulativeSavingsSum?: string | undefined;
    lastDepositDetailsList?: LastDepositDetailsModel[] | undefined;
    workerDepositsRewardsSum?: number;
    employerDepositsRewardsSum?: number;
    compensationDepositsSum?: number;
    beginningYearDepositDetailsList?: BeginningYearDepositDetailsModel[] | undefined;
    mobilityPullsAndRepairsList?: MobilityPullsAndRepairsModel[] | undefined;
    survivor?: SurvivorModel[] | undefined;
    retirementAge?: string | undefined;
    cumulativeSavingsAmountSum?: string | undefined;
    accumulatedSavingsAccumulation?: string | undefined;
    oldagePensionRateExpected?: string | undefined;
    retirementGuaranteedCoefficient?: string | undefined;
    cashBoxes?: CashBoxModel[] | undefined;
    managementFeeStructureList?: ManagementFeeStructureModel[] | undefined;
    managementFeeDepositRate?: string | undefined;
    managementFeeAccumulationRate?: string | undefined;
    anagementFeeOthers?: string | undefined;
    anagementFeeSum?: string | undefined;
    managementFeeDepositsum?: string | undefined;
    managementFeeAccumulationSum?: string | undefined;
    insurancePremiumsSum?: string | undefined;
    netReturnFromBeginningOfYear?: string | undefined;
    netReturnFromLastMonthSavingsA?: string | undefined;
    netReturnFromLastMonthSavingsB?: string | undefined;
    lastYearBalances?: LastYearBalanceModel[] | undefined;
    balanceDetailsList?: BalanceDetailsModel[] | undefined;
    periodBalances?: PeriodBalanceModel[] | undefined;
    variousBalances?: VariousBalanceModel[] | undefined;
    liquidityRoyaltiesList?: LiquidityRoyaltiesModel[] | undefined;
    covers?: CoverModel[] | undefined;
    provisions?: ProvisionModel[] | undefined;
    balances?: BalanceModel[] | undefined;
    policyTypes?: SelectListItem[] | undefined;

    constructor(data?: ILifeInsurancePolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agentDetailsList"])) {
                this.agentDetailsList = [] as any;
                for (let item of _data["agentDetailsList"])
                    this.agentDetailsList!.push(AgentDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["salespersons"])) {
                this.salespersons = [] as any;
                for (let item of _data["salespersons"])
                    this.salespersons!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(SelectListItem.fromJS(item));
            }
            this.productType = _data["productType"];
            this.programName = _data["programName"];
            this.manufacturerID = _data["manufacturerID"];
            this.manufacturerName = _data["manufacturerName"];
            this.employer = _data["employer"] ? EmployerModel.fromJS(_data["employer"]) : <any>undefined;
            this.employerId = _data["employerId"];
            this.employerStatus = _data["employerStatus"];
            this.manufacturerContactFirstName = _data["manufacturerContactFirstName"];
            this.manufacturerContactLastName = _data["manufacturerContactLastName"];
            this.manufacturerContactPhone = _data["manufacturerContactPhone"];
            this.manufacturerContactFax = _data["manufacturerContactFax"];
            this.finalRecipientFactorCode = _data["finalRecipientFactorCode"];
            this.finalRecipientEmployerType = _data["finalRecipientEmployerType"];
            this.finalRecipientIdentity = _data["finalRecipientIdentity"];
            this.finalRecipientManufacturerId = _data["finalRecipientManufacturerId"];
            this.insuredIdentityType = _data["insuredIdentityType"];
            this.insuredIdentityNumber = _data["insuredIdentityNumber"];
            this.manufacturerDistributorNumber = _data["manufacturerDistributorNumber"];
            this.infoCorrectnessDate = _data["infoCorrectnessDate"] ? new Date(_data["infoCorrectnessDate"].toString()) : <any>undefined;
            this.joiningProductDate = _data["joiningProductDate"] ? new Date(_data["joiningProductDate"].toString()) : <any>undefined;
            this.firstJoiningProductDate = _data["firstJoiningProductDate"] ? new Date(_data["firstJoiningProductDate"].toString()) : <any>undefined;
            this.pensionFundType = _data["pensionFundType"];
            this.pensionFundStatus = _data["pensionFundStatus"];
            this.accountStatusUpdateDate = _data["accountStatusUpdateDate"] ? new Date(_data["accountStatusUpdateDate"].toString()) : <any>undefined;
            this.accountStatus = _data["accountStatus"];
            this.temporaryRiskStartDate = _data["temporaryRiskStartDate"] ? new Date(_data["temporaryRiskStartDate"].toString()) : <any>undefined;
            this.temporaryRiskEndDate = _data["temporaryRiskEndDate"] ? new Date(_data["temporaryRiskEndDate"].toString()) : <any>undefined;
            this.policyType = _data["policyType"] ? PolicyType.fromJS(_data["policyType"]) : <any>undefined;
            this.accountPlanType = _data["accountPlanType"];
            this.baseIndex = _data["baseIndex"];
            this.termsLoanLinkage = _data["termsLoanLinkage"];
            this.fixedMoney190 = _data["fixedMoney190"];
            this.shippingAddressCountry = _data["shippingAddressCountry"];
            this.shippingAddressLocality = _data["shippingAddressLocality"];
            this.shippingAddressLocalitySymbol = _data["shippingAddressLocalitySymbol"];
            this.shippingAddressStreet = _data["shippingAddressStreet"];
            this.shippingAddressHousNumber = _data["shippingAddressHousNumber"];
            this.shippingAddressApartmentEnterNumber = _data["shippingAddressApartmentEnterNumber"];
            this.shippingAddressApartmentNumber = _data["shippingAddressApartmentNumber"];
            this.shippingAddressPostalCode = _data["shippingAddressPostalCode"];
            this.shippingAddressMailbox = _data["shippingAddressMailbox"];
            this.insuranceTrackPensionFund = _data["insuranceTrackPensionFund"];
            this.insuranceTrackName = _data["insuranceTrackName"];
            this.imposedLien = _data["imposedLien"];
            this.imposedForeclosure = _data["imposedForeclosure"];
            this.isLoanProduct = _data["isLoanProduct"];
            this.isClaimPolicyAccount = _data["isClaimPolicyAccount"];
            this.isCollectiveInsuranceCoverageForMembers = _data["isCollectiveInsuranceCoverageForMembers"];
            this.isPowerOfAttorney = _data["isPowerOfAttorney"];
            if (Array.isArray(_data["investmentRoutes"])) {
                this.investmentRoutes = [] as any;
                for (let item of _data["investmentRoutes"])
                    this.investmentRoutes!.push(InvestmentRouteModel.fromJS(item));
            }
            this.wageCalculationCode = _data["wageCalculationCode"];
            this.polocySalary = _data["polocySalary"];
            this.wagesLink = _data["wagesLink"];
            this.salaryCorrectnessDate = _data["salaryCorrectnessDate"] ? new Date(_data["salaryCorrectnessDate"].toString()) : <any>undefined;
            this.unconditionalEligibility = _data["unconditionalEligibility"];
            this.section14 = _data["section14"];
            this.startDepositPaymentDate = _data["startDepositPaymentDate"] ? new Date(_data["startDepositPaymentDate"].toString()) : <any>undefined;
            this.secretionsDetailsPercent = _data["secretionsDetailsPercent"];
            this.secretionsDetailsSum = _data["secretionsDetailsSum"];
            this.secretionsDetailsDate = _data["secretionsDetailsDate"] ? new Date(_data["secretionsDetailsDate"].toString()) : <any>undefined;
            this.employerLossWorkCapacityPercent = _data["employerLossWorkCapacityPercent"];
            this.employerLossWorkCapacitySum = _data["employerLossWorkCapacitySum"];
            this.employerLossWorkCapacityDate = _data["employerLossWorkCapacityDate"] ? new Date(_data["employerLossWorkCapacityDate"].toString()) : <any>undefined;
            this.employerComparisonFundPercent = _data["employerComparisonFundPercent"];
            this.employerComparisonFundSum = _data["employerComparisonFundSum"];
            this.employerComparisonFundDate = _data["employerComparisonFundDate"] ? new Date(_data["employerComparisonFundDate"].toString()) : <any>undefined;
            this.employerRewardsPercent = _data["employerRewardsPercent"];
            this.employerRewardsSum = _data["employerRewardsSum"];
            this.employerRewardsDate = _data["employerRewardsDate"] ? new Date(_data["employerRewardsDate"].toString()) : <any>undefined;
            this.employerOthersPercent = _data["employerOthersPercent"];
            this.employerOthersSum = _data["employerOthersSum"];
            this.employerOthersDate = _data["employerOthersDate"] ? new Date(_data["employerOthersDate"].toString()) : <any>undefined;
            this.workerRewardsPercent = _data["workerRewardsPercent"];
            this.workerRewardsSum = _data["workerRewardsSum"];
            this.workerRewardsDate = _data["workerRewardsDate"] ? new Date(_data["workerRewardsDate"].toString()) : <any>undefined;
            this.workerLossWorkCapacityPercent = _data["workerLossWorkCapacityPercent"];
            this.workerLossWorkCapacitySum = _data["workerLossWorkCapacitySum"];
            this.workerLossWorkCapacityDate = _data["workerLossWorkCapacityDate"] ? new Date(_data["workerLossWorkCapacityDate"].toString()) : <any>undefined;
            this.workerComparisonFundPercent = _data["workerComparisonFundPercent"];
            this.workerComparisonFundSum = _data["workerComparisonFundSum"];
            this.workerComparisonFundDate = _data["workerComparisonFundDate"] ? new Date(_data["workerComparisonFundDate"].toString()) : <any>undefined;
            this.workerRewards47Percent = _data["workerRewards47Percent"];
            this.workerRewards47Sum = _data["workerRewards47Sum"];
            this.workerRewards47Date = _data["workerRewards47Date"] ? new Date(_data["workerRewards47Date"].toString()) : <any>undefined;
            this.workerOthersPercent = _data["workerOthersPercent"];
            this.workerOthersSum = _data["workerOthersSum"];
            this.workerOthersDate = _data["workerOthersDate"] ? new Date(_data["workerOthersDate"].toString()) : <any>undefined;
            this.workerRewardsPrivatePercent = _data["workerRewardsPrivatePercent"];
            this.workerRewardsPrivateSum = _data["workerRewardsPrivateSum"];
            this.workerRewardsPrivateDate = _data["workerRewardsPrivateDate"] ? new Date(_data["workerRewardsPrivateDate"].toString()) : <any>undefined;
            this.payerName = _data["payerName"];
            this.payerIdentityType = _data["payerIdentityType"];
            this.payerIdentity = _data["payerIdentity"];
            this.paymrntFrequency = _data["paymrntFrequency"];
            this.monthFrequency = _data["monthFrequency"];
            this.collectionDay = _data["collectionDay"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.attachCollectionType = _data["attachCollectionType"];
            this.percentageSubAnnuals = _data["percentageSubAnnuals"];
            this.arrearsDebt = _data["arrearsDebt"];
            this.satrtArrearsDebtDate = _data["satrtArrearsDebtDate"] ? new Date(_data["satrtArrearsDebtDate"].toString()) : <any>undefined;
            this.arrearsDebtMonthCount = _data["arrearsDebtMonthCount"];
            this.debtType = _data["debtType"];
            this.arrearsDebtSum = _data["arrearsDebtSum"];
            this.unassociatedFunds = _data["unassociatedFunds"];
            this.lastDepositDate = _data["lastDepositDate"] ? new Date(_data["lastDepositDate"].toString()) : <any>undefined;
            this.lastDepositSum = _data["lastDepositSum"];
            this.lastDepositValueDate = _data["lastDepositValueDate"] ? new Date(_data["lastDepositValueDate"].toString()) : <any>undefined;
            this.depositType = _data["depositType"];
            this.lastSepositCumulativeSavingsSum = _data["lastSepositCumulativeSavingsSum"];
            if (Array.isArray(_data["lastDepositDetailsList"])) {
                this.lastDepositDetailsList = [] as any;
                for (let item of _data["lastDepositDetailsList"])
                    this.lastDepositDetailsList!.push(LastDepositDetailsModel.fromJS(item));
            }
            this.workerDepositsRewardsSum = _data["workerDepositsRewardsSum"];
            this.employerDepositsRewardsSum = _data["employerDepositsRewardsSum"];
            this.compensationDepositsSum = _data["compensationDepositsSum"];
            if (Array.isArray(_data["beginningYearDepositDetailsList"])) {
                this.beginningYearDepositDetailsList = [] as any;
                for (let item of _data["beginningYearDepositDetailsList"])
                    this.beginningYearDepositDetailsList!.push(BeginningYearDepositDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["mobilityPullsAndRepairsList"])) {
                this.mobilityPullsAndRepairsList = [] as any;
                for (let item of _data["mobilityPullsAndRepairsList"])
                    this.mobilityPullsAndRepairsList!.push(MobilityPullsAndRepairsModel.fromJS(item));
            }
            if (Array.isArray(_data["survivor"])) {
                this.survivor = [] as any;
                for (let item of _data["survivor"])
                    this.survivor!.push(SurvivorModel.fromJS(item));
            }
            this.retirementAge = _data["retirementAge"];
            this.cumulativeSavingsAmountSum = _data["cumulativeSavingsAmountSum"];
            this.accumulatedSavingsAccumulation = _data["accumulatedSavingsAccumulation"];
            this.oldagePensionRateExpected = _data["oldagePensionRateExpected"];
            this.retirementGuaranteedCoefficient = _data["retirementGuaranteedCoefficient"];
            if (Array.isArray(_data["cashBoxes"])) {
                this.cashBoxes = [] as any;
                for (let item of _data["cashBoxes"])
                    this.cashBoxes!.push(CashBoxModel.fromJS(item));
            }
            if (Array.isArray(_data["managementFeeStructureList"])) {
                this.managementFeeStructureList = [] as any;
                for (let item of _data["managementFeeStructureList"])
                    this.managementFeeStructureList!.push(ManagementFeeStructureModel.fromJS(item));
            }
            this.managementFeeDepositRate = _data["managementFeeDepositRate"];
            this.managementFeeAccumulationRate = _data["managementFeeAccumulationRate"];
            this.anagementFeeOthers = _data["anagementFeeOthers"];
            this.anagementFeeSum = _data["anagementFeeSum"];
            this.managementFeeDepositsum = _data["managementFeeDepositsum"];
            this.managementFeeAccumulationSum = _data["managementFeeAccumulationSum"];
            this.insurancePremiumsSum = _data["insurancePremiumsSum"];
            this.netReturnFromBeginningOfYear = _data["netReturnFromBeginningOfYear"];
            this.netReturnFromLastMonthSavingsA = _data["netReturnFromLastMonthSavingsA"];
            this.netReturnFromLastMonthSavingsB = _data["netReturnFromLastMonthSavingsB"];
            if (Array.isArray(_data["lastYearBalances"])) {
                this.lastYearBalances = [] as any;
                for (let item of _data["lastYearBalances"])
                    this.lastYearBalances!.push(LastYearBalanceModel.fromJS(item));
            }
            if (Array.isArray(_data["balanceDetailsList"])) {
                this.balanceDetailsList = [] as any;
                for (let item of _data["balanceDetailsList"])
                    this.balanceDetailsList!.push(BalanceDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["periodBalances"])) {
                this.periodBalances = [] as any;
                for (let item of _data["periodBalances"])
                    this.periodBalances!.push(PeriodBalanceModel.fromJS(item));
            }
            if (Array.isArray(_data["variousBalances"])) {
                this.variousBalances = [] as any;
                for (let item of _data["variousBalances"])
                    this.variousBalances!.push(VariousBalanceModel.fromJS(item));
            }
            if (Array.isArray(_data["liquidityRoyaltiesList"])) {
                this.liquidityRoyaltiesList = [] as any;
                for (let item of _data["liquidityRoyaltiesList"])
                    this.liquidityRoyaltiesList!.push(LiquidityRoyaltiesModel.fromJS(item));
            }
            if (Array.isArray(_data["covers"])) {
                this.covers = [] as any;
                for (let item of _data["covers"])
                    this.covers!.push(CoverModel.fromJS(item));
            }
            if (Array.isArray(_data["provisions"])) {
                this.provisions = [] as any;
                for (let item of _data["provisions"])
                    this.provisions!.push(ProvisionModel.fromJS(item));
            }
            if (Array.isArray(_data["balances"])) {
                this.balances = [] as any;
                for (let item of _data["balances"])
                    this.balances!.push(BalanceModel.fromJS(item));
            }
            if (Array.isArray(_data["policyTypes"])) {
                this.policyTypes = [] as any;
                for (let item of _data["policyTypes"])
                    this.policyTypes!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifeInsurancePolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new LifeInsurancePolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.agentDetailsList)) {
            data["agentDetailsList"] = [];
            for (let item of this.agentDetailsList)
                data["agentDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.salespersons)) {
            data["salespersons"] = [];
            for (let item of this.salespersons)
                data["salespersons"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        data["productType"] = this.productType;
        data["programName"] = this.programName;
        data["manufacturerID"] = this.manufacturerID;
        data["manufacturerName"] = this.manufacturerName;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["employerId"] = this.employerId;
        data["employerStatus"] = this.employerStatus;
        data["manufacturerContactFirstName"] = this.manufacturerContactFirstName;
        data["manufacturerContactLastName"] = this.manufacturerContactLastName;
        data["manufacturerContactPhone"] = this.manufacturerContactPhone;
        data["manufacturerContactFax"] = this.manufacturerContactFax;
        data["finalRecipientFactorCode"] = this.finalRecipientFactorCode;
        data["finalRecipientEmployerType"] = this.finalRecipientEmployerType;
        data["finalRecipientIdentity"] = this.finalRecipientIdentity;
        data["finalRecipientManufacturerId"] = this.finalRecipientManufacturerId;
        data["insuredIdentityType"] = this.insuredIdentityType;
        data["insuredIdentityNumber"] = this.insuredIdentityNumber;
        data["manufacturerDistributorNumber"] = this.manufacturerDistributorNumber;
        data["infoCorrectnessDate"] = this.infoCorrectnessDate ? this.infoCorrectnessDate.toISOString() : <any>undefined;
        data["joiningProductDate"] = this.joiningProductDate ? this.joiningProductDate.toISOString() : <any>undefined;
        data["firstJoiningProductDate"] = this.firstJoiningProductDate ? this.firstJoiningProductDate.toISOString() : <any>undefined;
        data["pensionFundType"] = this.pensionFundType;
        data["pensionFundStatus"] = this.pensionFundStatus;
        data["accountStatusUpdateDate"] = this.accountStatusUpdateDate ? this.accountStatusUpdateDate.toISOString() : <any>undefined;
        data["accountStatus"] = this.accountStatus;
        data["temporaryRiskStartDate"] = this.temporaryRiskStartDate ? this.temporaryRiskStartDate.toISOString() : <any>undefined;
        data["temporaryRiskEndDate"] = this.temporaryRiskEndDate ? this.temporaryRiskEndDate.toISOString() : <any>undefined;
        data["policyType"] = this.policyType ? this.policyType.toJSON() : <any>undefined;
        data["accountPlanType"] = this.accountPlanType;
        data["baseIndex"] = this.baseIndex;
        data["termsLoanLinkage"] = this.termsLoanLinkage;
        data["fixedMoney190"] = this.fixedMoney190;
        data["shippingAddressCountry"] = this.shippingAddressCountry;
        data["shippingAddressLocality"] = this.shippingAddressLocality;
        data["shippingAddressLocalitySymbol"] = this.shippingAddressLocalitySymbol;
        data["shippingAddressStreet"] = this.shippingAddressStreet;
        data["shippingAddressHousNumber"] = this.shippingAddressHousNumber;
        data["shippingAddressApartmentEnterNumber"] = this.shippingAddressApartmentEnterNumber;
        data["shippingAddressApartmentNumber"] = this.shippingAddressApartmentNumber;
        data["shippingAddressPostalCode"] = this.shippingAddressPostalCode;
        data["shippingAddressMailbox"] = this.shippingAddressMailbox;
        data["insuranceTrackPensionFund"] = this.insuranceTrackPensionFund;
        data["insuranceTrackName"] = this.insuranceTrackName;
        data["imposedLien"] = this.imposedLien;
        data["imposedForeclosure"] = this.imposedForeclosure;
        data["isLoanProduct"] = this.isLoanProduct;
        data["isClaimPolicyAccount"] = this.isClaimPolicyAccount;
        data["isCollectiveInsuranceCoverageForMembers"] = this.isCollectiveInsuranceCoverageForMembers;
        data["isPowerOfAttorney"] = this.isPowerOfAttorney;
        if (Array.isArray(this.investmentRoutes)) {
            data["investmentRoutes"] = [];
            for (let item of this.investmentRoutes)
                data["investmentRoutes"].push(item.toJSON());
        }
        data["wageCalculationCode"] = this.wageCalculationCode;
        data["polocySalary"] = this.polocySalary;
        data["wagesLink"] = this.wagesLink;
        data["salaryCorrectnessDate"] = this.salaryCorrectnessDate ? this.salaryCorrectnessDate.toISOString() : <any>undefined;
        data["unconditionalEligibility"] = this.unconditionalEligibility;
        data["section14"] = this.section14;
        data["startDepositPaymentDate"] = this.startDepositPaymentDate ? this.startDepositPaymentDate.toISOString() : <any>undefined;
        data["secretionsDetailsPercent"] = this.secretionsDetailsPercent;
        data["secretionsDetailsSum"] = this.secretionsDetailsSum;
        data["secretionsDetailsDate"] = this.secretionsDetailsDate ? this.secretionsDetailsDate.toISOString() : <any>undefined;
        data["employerLossWorkCapacityPercent"] = this.employerLossWorkCapacityPercent;
        data["employerLossWorkCapacitySum"] = this.employerLossWorkCapacitySum;
        data["employerLossWorkCapacityDate"] = this.employerLossWorkCapacityDate ? this.employerLossWorkCapacityDate.toISOString() : <any>undefined;
        data["employerComparisonFundPercent"] = this.employerComparisonFundPercent;
        data["employerComparisonFundSum"] = this.employerComparisonFundSum;
        data["employerComparisonFundDate"] = this.employerComparisonFundDate ? this.employerComparisonFundDate.toISOString() : <any>undefined;
        data["employerRewardsPercent"] = this.employerRewardsPercent;
        data["employerRewardsSum"] = this.employerRewardsSum;
        data["employerRewardsDate"] = this.employerRewardsDate ? this.employerRewardsDate.toISOString() : <any>undefined;
        data["employerOthersPercent"] = this.employerOthersPercent;
        data["employerOthersSum"] = this.employerOthersSum;
        data["employerOthersDate"] = this.employerOthersDate ? this.employerOthersDate.toISOString() : <any>undefined;
        data["workerRewardsPercent"] = this.workerRewardsPercent;
        data["workerRewardsSum"] = this.workerRewardsSum;
        data["workerRewardsDate"] = this.workerRewardsDate ? this.workerRewardsDate.toISOString() : <any>undefined;
        data["workerLossWorkCapacityPercent"] = this.workerLossWorkCapacityPercent;
        data["workerLossWorkCapacitySum"] = this.workerLossWorkCapacitySum;
        data["workerLossWorkCapacityDate"] = this.workerLossWorkCapacityDate ? this.workerLossWorkCapacityDate.toISOString() : <any>undefined;
        data["workerComparisonFundPercent"] = this.workerComparisonFundPercent;
        data["workerComparisonFundSum"] = this.workerComparisonFundSum;
        data["workerComparisonFundDate"] = this.workerComparisonFundDate ? this.workerComparisonFundDate.toISOString() : <any>undefined;
        data["workerRewards47Percent"] = this.workerRewards47Percent;
        data["workerRewards47Sum"] = this.workerRewards47Sum;
        data["workerRewards47Date"] = this.workerRewards47Date ? this.workerRewards47Date.toISOString() : <any>undefined;
        data["workerOthersPercent"] = this.workerOthersPercent;
        data["workerOthersSum"] = this.workerOthersSum;
        data["workerOthersDate"] = this.workerOthersDate ? this.workerOthersDate.toISOString() : <any>undefined;
        data["workerRewardsPrivatePercent"] = this.workerRewardsPrivatePercent;
        data["workerRewardsPrivateSum"] = this.workerRewardsPrivateSum;
        data["workerRewardsPrivateDate"] = this.workerRewardsPrivateDate ? this.workerRewardsPrivateDate.toISOString() : <any>undefined;
        data["payerName"] = this.payerName;
        data["payerIdentityType"] = this.payerIdentityType;
        data["payerIdentity"] = this.payerIdentity;
        data["paymrntFrequency"] = this.paymrntFrequency;
        data["monthFrequency"] = this.monthFrequency;
        data["collectionDay"] = this.collectionDay;
        data["paymentMethodType"] = this.paymentMethodType;
        data["attachCollectionType"] = this.attachCollectionType;
        data["percentageSubAnnuals"] = this.percentageSubAnnuals;
        data["arrearsDebt"] = this.arrearsDebt;
        data["satrtArrearsDebtDate"] = this.satrtArrearsDebtDate ? this.satrtArrearsDebtDate.toISOString() : <any>undefined;
        data["arrearsDebtMonthCount"] = this.arrearsDebtMonthCount;
        data["debtType"] = this.debtType;
        data["arrearsDebtSum"] = this.arrearsDebtSum;
        data["unassociatedFunds"] = this.unassociatedFunds;
        data["lastDepositDate"] = this.lastDepositDate ? this.lastDepositDate.toISOString() : <any>undefined;
        data["lastDepositSum"] = this.lastDepositSum;
        data["lastDepositValueDate"] = this.lastDepositValueDate ? this.lastDepositValueDate.toISOString() : <any>undefined;
        data["depositType"] = this.depositType;
        data["lastSepositCumulativeSavingsSum"] = this.lastSepositCumulativeSavingsSum;
        if (Array.isArray(this.lastDepositDetailsList)) {
            data["lastDepositDetailsList"] = [];
            for (let item of this.lastDepositDetailsList)
                data["lastDepositDetailsList"].push(item.toJSON());
        }
        data["workerDepositsRewardsSum"] = this.workerDepositsRewardsSum;
        data["employerDepositsRewardsSum"] = this.employerDepositsRewardsSum;
        data["compensationDepositsSum"] = this.compensationDepositsSum;
        if (Array.isArray(this.beginningYearDepositDetailsList)) {
            data["beginningYearDepositDetailsList"] = [];
            for (let item of this.beginningYearDepositDetailsList)
                data["beginningYearDepositDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.mobilityPullsAndRepairsList)) {
            data["mobilityPullsAndRepairsList"] = [];
            for (let item of this.mobilityPullsAndRepairsList)
                data["mobilityPullsAndRepairsList"].push(item.toJSON());
        }
        if (Array.isArray(this.survivor)) {
            data["survivor"] = [];
            for (let item of this.survivor)
                data["survivor"].push(item.toJSON());
        }
        data["retirementAge"] = this.retirementAge;
        data["cumulativeSavingsAmountSum"] = this.cumulativeSavingsAmountSum;
        data["accumulatedSavingsAccumulation"] = this.accumulatedSavingsAccumulation;
        data["oldagePensionRateExpected"] = this.oldagePensionRateExpected;
        data["retirementGuaranteedCoefficient"] = this.retirementGuaranteedCoefficient;
        if (Array.isArray(this.cashBoxes)) {
            data["cashBoxes"] = [];
            for (let item of this.cashBoxes)
                data["cashBoxes"].push(item.toJSON());
        }
        if (Array.isArray(this.managementFeeStructureList)) {
            data["managementFeeStructureList"] = [];
            for (let item of this.managementFeeStructureList)
                data["managementFeeStructureList"].push(item.toJSON());
        }
        data["managementFeeDepositRate"] = this.managementFeeDepositRate;
        data["managementFeeAccumulationRate"] = this.managementFeeAccumulationRate;
        data["anagementFeeOthers"] = this.anagementFeeOthers;
        data["anagementFeeSum"] = this.anagementFeeSum;
        data["managementFeeDepositsum"] = this.managementFeeDepositsum;
        data["managementFeeAccumulationSum"] = this.managementFeeAccumulationSum;
        data["insurancePremiumsSum"] = this.insurancePremiumsSum;
        data["netReturnFromBeginningOfYear"] = this.netReturnFromBeginningOfYear;
        data["netReturnFromLastMonthSavingsA"] = this.netReturnFromLastMonthSavingsA;
        data["netReturnFromLastMonthSavingsB"] = this.netReturnFromLastMonthSavingsB;
        if (Array.isArray(this.lastYearBalances)) {
            data["lastYearBalances"] = [];
            for (let item of this.lastYearBalances)
                data["lastYearBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.balanceDetailsList)) {
            data["balanceDetailsList"] = [];
            for (let item of this.balanceDetailsList)
                data["balanceDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.periodBalances)) {
            data["periodBalances"] = [];
            for (let item of this.periodBalances)
                data["periodBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.variousBalances)) {
            data["variousBalances"] = [];
            for (let item of this.variousBalances)
                data["variousBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.liquidityRoyaltiesList)) {
            data["liquidityRoyaltiesList"] = [];
            for (let item of this.liquidityRoyaltiesList)
                data["liquidityRoyaltiesList"].push(item.toJSON());
        }
        if (Array.isArray(this.covers)) {
            data["covers"] = [];
            for (let item of this.covers)
                data["covers"].push(item.toJSON());
        }
        if (Array.isArray(this.provisions)) {
            data["provisions"] = [];
            for (let item of this.provisions)
                data["provisions"].push(item.toJSON());
        }
        if (Array.isArray(this.balances)) {
            data["balances"] = [];
            for (let item of this.balances)
                data["balances"].push(item.toJSON());
        }
        if (Array.isArray(this.policyTypes)) {
            data["policyTypes"] = [];
            for (let item of this.policyTypes)
                data["policyTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILifeInsurancePolicyModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    productType?: LifeInsuranceProductType;
    programName?: string | undefined;
    manufacturerID?: string | undefined;
    manufacturerName?: string | undefined;
    employer?: EmployerModel;
    employerId?: string | undefined;
    employerStatus?: EmployerStatusType;
    manufacturerContactFirstName?: string | undefined;
    manufacturerContactLastName?: string | undefined;
    manufacturerContactPhone?: string | undefined;
    manufacturerContactFax?: string | undefined;
    finalRecipientFactorCode?: FactorCodeType;
    finalRecipientEmployerType?: EmployerType;
    finalRecipientIdentity?: string | undefined;
    finalRecipientManufacturerId?: string | undefined;
    insuredIdentityType?: IdentityType;
    insuredIdentityNumber?: string | undefined;
    manufacturerDistributorNumber?: string | undefined;
    infoCorrectnessDate?: Date;
    joiningProductDate?: Date;
    firstJoiningProductDate?: Date;
    pensionFundType?: number;
    pensionFundStatus?: number;
    accountStatusUpdateDate?: Date;
    accountStatus?: number;
    temporaryRiskStartDate?: Date;
    temporaryRiskEndDate?: Date;
    policyType?: PolicyType;
    accountPlanType?: number;
    baseIndex?: string | undefined;
    termsLoanLinkage?: YesNo;
    fixedMoney190?: YesNo;
    shippingAddressCountry?: string | undefined;
    shippingAddressLocality?: string | undefined;
    shippingAddressLocalitySymbol?: string | undefined;
    shippingAddressStreet?: string | undefined;
    shippingAddressHousNumber?: string | undefined;
    shippingAddressApartmentEnterNumber?: string | undefined;
    shippingAddressApartmentNumber?: string | undefined;
    shippingAddressPostalCode?: string | undefined;
    shippingAddressMailbox?: string | undefined;
    insuranceTrackPensionFund?: string | undefined;
    insuranceTrackName?: string | undefined;
    imposedLien?: YesNoUnknown;
    imposedForeclosure?: YesNoUnknown;
    isLoanProduct?: boolean;
    isClaimPolicyAccount?: boolean;
    isCollectiveInsuranceCoverageForMembers?: boolean;
    isPowerOfAttorney?: boolean;
    investmentRoutes?: InvestmentRouteModel[] | undefined;
    wageCalculationCode?: number;
    polocySalary?: number;
    wagesLink?: number;
    salaryCorrectnessDate?: Date;
    unconditionalEligibility?: YesNoUnknown;
    section14?: YesNoUnknown;
    startDepositPaymentDate?: Date;
    secretionsDetailsPercent?: number;
    secretionsDetailsSum?: number;
    secretionsDetailsDate?: Date;
    employerLossWorkCapacityPercent?: number;
    employerLossWorkCapacitySum?: number;
    employerLossWorkCapacityDate?: Date;
    employerComparisonFundPercent?: number;
    employerComparisonFundSum?: number;
    employerComparisonFundDate?: Date;
    employerRewardsPercent?: number;
    employerRewardsSum?: number;
    employerRewardsDate?: Date;
    employerOthersPercent?: number;
    employerOthersSum?: number;
    employerOthersDate?: Date;
    workerRewardsPercent?: number;
    workerRewardsSum?: number;
    workerRewardsDate?: Date;
    workerLossWorkCapacityPercent?: number;
    workerLossWorkCapacitySum?: number;
    workerLossWorkCapacityDate?: Date;
    workerComparisonFundPercent?: number;
    workerComparisonFundSum?: number;
    workerComparisonFundDate?: Date;
    workerRewards47Percent?: number;
    workerRewards47Sum?: number;
    workerRewards47Date?: Date;
    workerOthersPercent?: number;
    workerOthersSum?: number;
    workerOthersDate?: Date;
    workerRewardsPrivatePercent?: number;
    workerRewardsPrivateSum?: number;
    workerRewardsPrivateDate?: Date;
    payerName?: string | undefined;
    payerIdentityType?: IdentityType;
    payerIdentity?: string | undefined;
    paymrntFrequency?: number;
    monthFrequency?: number;
    collectionDay?: number;
    paymentMethodType?: PaymentMethodType;
    attachCollectionType?: number;
    percentageSubAnnuals?: number;
    arrearsDebt?: YesNo;
    satrtArrearsDebtDate?: Date;
    arrearsDebtMonthCount?: number;
    debtType?: number;
    arrearsDebtSum?: number;
    unassociatedFunds?: YesNo;
    lastDepositDate?: Date;
    lastDepositSum?: number;
    lastDepositValueDate?: Date;
    depositType?: number;
    lastSepositCumulativeSavingsSum?: string | undefined;
    lastDepositDetailsList?: LastDepositDetailsModel[] | undefined;
    workerDepositsRewardsSum?: number;
    employerDepositsRewardsSum?: number;
    compensationDepositsSum?: number;
    beginningYearDepositDetailsList?: BeginningYearDepositDetailsModel[] | undefined;
    mobilityPullsAndRepairsList?: MobilityPullsAndRepairsModel[] | undefined;
    survivor?: SurvivorModel[] | undefined;
    retirementAge?: string | undefined;
    cumulativeSavingsAmountSum?: string | undefined;
    accumulatedSavingsAccumulation?: string | undefined;
    oldagePensionRateExpected?: string | undefined;
    retirementGuaranteedCoefficient?: string | undefined;
    cashBoxes?: CashBoxModel[] | undefined;
    managementFeeStructureList?: ManagementFeeStructureModel[] | undefined;
    managementFeeDepositRate?: string | undefined;
    managementFeeAccumulationRate?: string | undefined;
    anagementFeeOthers?: string | undefined;
    anagementFeeSum?: string | undefined;
    managementFeeDepositsum?: string | undefined;
    managementFeeAccumulationSum?: string | undefined;
    insurancePremiumsSum?: string | undefined;
    netReturnFromBeginningOfYear?: string | undefined;
    netReturnFromLastMonthSavingsA?: string | undefined;
    netReturnFromLastMonthSavingsB?: string | undefined;
    lastYearBalances?: LastYearBalanceModel[] | undefined;
    balanceDetailsList?: BalanceDetailsModel[] | undefined;
    periodBalances?: PeriodBalanceModel[] | undefined;
    variousBalances?: VariousBalanceModel[] | undefined;
    liquidityRoyaltiesList?: LiquidityRoyaltiesModel[] | undefined;
    covers?: CoverModel[] | undefined;
    provisions?: ProvisionModel[] | undefined;
    balances?: BalanceModel[] | undefined;
    policyTypes?: SelectListItem[] | undefined;
}

/** 0 = PensionFund, 1 = ProvidentFund */
export enum LifeInsuranceProductType {
    _0 = 0,
    _1 = 1,
}

/** 0 = NoLinkage, 1 = CPILinkage, 2 = ForexLinkage, 3 = vehicleLinkage */
export enum LinkageType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class LiquidityRoyaltiesModel implements ILiquidityRoyaltiesModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    accrualValueDate?: Date;
    liquidityRoyaltiesDate?: Date;
    liquidityRoyaltiesBalance?: string | undefined;

    constructor(data?: ILiquidityRoyaltiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.accrualValueDate = _data["accrualValueDate"] ? new Date(_data["accrualValueDate"].toString()) : <any>undefined;
            this.liquidityRoyaltiesDate = _data["liquidityRoyaltiesDate"] ? new Date(_data["liquidityRoyaltiesDate"].toString()) : <any>undefined;
            this.liquidityRoyaltiesBalance = _data["liquidityRoyaltiesBalance"];
        }
    }

    static fromJS(data: any): LiquidityRoyaltiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new LiquidityRoyaltiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["accrualValueDate"] = this.accrualValueDate ? this.accrualValueDate.toISOString() : <any>undefined;
        data["liquidityRoyaltiesDate"] = this.liquidityRoyaltiesDate ? this.liquidityRoyaltiesDate.toISOString() : <any>undefined;
        data["liquidityRoyaltiesBalance"] = this.liquidityRoyaltiesBalance;
        return data;
    }
}

export interface ILiquidityRoyaltiesModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    accrualValueDate?: Date;
    liquidityRoyaltiesDate?: Date;
    liquidityRoyaltiesBalance?: string | undefined;
}

export class ListItem implements IListItem {
    value?: string;
    text?: string | undefined;

    constructor(data?: IListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data;
    }
}

export interface IListItem {
    value?: string;
    text?: string | undefined;
}

export class MailboxAddress implements IMailboxAddress {
    encoding?: Encoding;
    name?: string | undefined;
    route?: string[] | undefined;
    address?: string | undefined;
    readonly isInternational?: boolean;

    constructor(data?: IMailboxAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.encoding = _data["encoding"] ? Encoding.fromJS(_data["encoding"]) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["route"])) {
                this.route = [] as any;
                for (let item of _data["route"])
                    this.route!.push(item);
            }
            this.address = _data["address"];
            (<any>this).isInternational = _data["isInternational"];
        }
    }

    static fromJS(data: any): MailboxAddress {
        data = typeof data === 'object' ? data : {};
        let result = new MailboxAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encoding"] = this.encoding ? this.encoding.toJSON() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.route)) {
            data["route"] = [];
            for (let item of this.route)
                data["route"].push(item);
        }
        data["address"] = this.address;
        data["isInternational"] = this.isInternational;
        return data;
    }
}

export interface IMailboxAddress {
    encoding?: Encoding;
    name?: string | undefined;
    route?: string[] | undefined;
    address?: string | undefined;
    isInternational?: boolean;
}

export class ManagementFeeStructureModel implements IManagementFeeStructureModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    actualExpenses?: boolean | undefined;
    expensesType?: number;
    managementFeeTrackCode?: boolean | undefined;
    managementFeeTrackCharacteristic?: number;
    managementFeeRate?: string | undefined;
    managementFeeRateLastUpdateDate?: boolean | undefined;
    managementFeeUniform?: YesNoIrrelevant;
    investmentRouteCode?: string | undefined;
    excretionMode?: number;
    depositMnagementFeeMaxSum?: string | undefined;
    mnagementFeeForRoutSum?: string | undefined;
    othernagementFee?: string | undefined;
    withdrawalFines?: string | undefined;
    managementFeeBenefit?: number;
    benefitType?: number;
    managementFeeBenefitPercentage?: string | undefined;
    managementFeeBenefitEndDate?: string | undefined;

    constructor(data?: IManagementFeeStructureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.actualExpenses = _data["actualExpenses"];
            this.expensesType = _data["expensesType"];
            this.managementFeeTrackCode = _data["managementFeeTrackCode"];
            this.managementFeeTrackCharacteristic = _data["managementFeeTrackCharacteristic"];
            this.managementFeeRate = _data["managementFeeRate"];
            this.managementFeeRateLastUpdateDate = _data["managementFeeRateLastUpdateDate"];
            this.managementFeeUniform = _data["managementFeeUniform"];
            this.investmentRouteCode = _data["investmentRouteCode"];
            this.excretionMode = _data["excretionMode"];
            this.depositMnagementFeeMaxSum = _data["depositMnagementFeeMaxSum"];
            this.mnagementFeeForRoutSum = _data["mnagementFeeForRoutSum"];
            this.othernagementFee = _data["othernagementFee"];
            this.withdrawalFines = _data["withdrawalFines"];
            this.managementFeeBenefit = _data["managementFeeBenefit"];
            this.benefitType = _data["benefitType"];
            this.managementFeeBenefitPercentage = _data["managementFeeBenefitPercentage"];
            this.managementFeeBenefitEndDate = _data["managementFeeBenefitEndDate"];
        }
    }

    static fromJS(data: any): ManagementFeeStructureModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementFeeStructureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["actualExpenses"] = this.actualExpenses;
        data["expensesType"] = this.expensesType;
        data["managementFeeTrackCode"] = this.managementFeeTrackCode;
        data["managementFeeTrackCharacteristic"] = this.managementFeeTrackCharacteristic;
        data["managementFeeRate"] = this.managementFeeRate;
        data["managementFeeRateLastUpdateDate"] = this.managementFeeRateLastUpdateDate;
        data["managementFeeUniform"] = this.managementFeeUniform;
        data["investmentRouteCode"] = this.investmentRouteCode;
        data["excretionMode"] = this.excretionMode;
        data["depositMnagementFeeMaxSum"] = this.depositMnagementFeeMaxSum;
        data["mnagementFeeForRoutSum"] = this.mnagementFeeForRoutSum;
        data["othernagementFee"] = this.othernagementFee;
        data["withdrawalFines"] = this.withdrawalFines;
        data["managementFeeBenefit"] = this.managementFeeBenefit;
        data["benefitType"] = this.benefitType;
        data["managementFeeBenefitPercentage"] = this.managementFeeBenefitPercentage;
        data["managementFeeBenefitEndDate"] = this.managementFeeBenefitEndDate;
        return data;
    }
}

export interface IManagementFeeStructureModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    actualExpenses?: boolean | undefined;
    expensesType?: number;
    managementFeeTrackCode?: boolean | undefined;
    managementFeeTrackCharacteristic?: number;
    managementFeeRate?: string | undefined;
    managementFeeRateLastUpdateDate?: boolean | undefined;
    managementFeeUniform?: YesNoIrrelevant;
    investmentRouteCode?: string | undefined;
    excretionMode?: number;
    depositMnagementFeeMaxSum?: string | undefined;
    mnagementFeeForRoutSum?: string | undefined;
    othernagementFee?: string | undefined;
    withdrawalFines?: string | undefined;
    managementFeeBenefit?: number;
    benefitType?: number;
    managementFeeBenefitPercentage?: string | undefined;
    managementFeeBenefitEndDate?: string | undefined;
}

export class Manufacturer implements IManufacturer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    vehicles?: Vehicle[] | undefined;
    vehicleModels?: VehicleModel[] | undefined;

    constructor(data?: IManufacturer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(Vehicle.fromJS(item));
            }
            if (Array.isArray(_data["vehicleModels"])) {
                this.vehicleModels = [] as any;
                for (let item of _data["vehicleModels"])
                    this.vehicleModels!.push(VehicleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Manufacturer {
        data = typeof data === 'object' ? data : {};
        let result = new Manufacturer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleModels)) {
            data["vehicleModels"] = [];
            for (let item of this.vehicleModels)
                data["vehicleModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManufacturer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    vehicles?: Vehicle[] | undefined;
    vehicleModels?: VehicleModel[] | undefined;
}

export class ManufacturerModel implements IManufacturerModel {
    id?: string;
    name?: string | undefined;
    checked?: number | undefined;
    vehicleModels?: VehicleModelModel[] | undefined;

    constructor(data?: IManufacturerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.checked = _data["checked"];
            if (Array.isArray(_data["vehicleModels"])) {
                this.vehicleModels = [] as any;
                for (let item of _data["vehicleModels"])
                    this.vehicleModels!.push(VehicleModelModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManufacturerModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["checked"] = this.checked;
        if (Array.isArray(this.vehicleModels)) {
            data["vehicleModels"] = [];
            for (let item of this.vehicleModels)
                data["vehicleModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManufacturerModel {
    id?: string;
    name?: string | undefined;
    checked?: number | undefined;
    vehicleModels?: VehicleModelModel[] | undefined;
}

export class ManufacturersGetRequest implements IManufacturersGetRequest {
    search?: string | undefined;

    constructor(data?: IManufacturersGetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): ManufacturersGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturersGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        return data;
    }
}

export interface IManufacturersGetRequest {
    search?: string | undefined;
}

/** 0 = Single, 1 = Married, 2 = Divorcee, 3 = Widower */
export enum MaritalStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class MeetingModelForUpsert implements IMeetingModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    topic?: string | undefined;
    location?: string | undefined;
    startDate?: Date;
    startTime?: TimeSpan;
    endDate?: Date;
    endTime?: TimeSpan;
    isFullDay?: boolean;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;

    constructor(data?: IMeetingModelForUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.alertHour = _data["alertHour"] ? TimeSpan.fromJS(_data["alertHour"]) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.treatmentType = _data["treatmentType"];
            this.customerId = _data["customerId"];
            this.topic = _data["topic"];
            this.location = _data["location"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"]) : <any>undefined;
            this.isFullDay = _data["isFullDay"];
            this.note = _data["note"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MeetingModelForUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingModelForUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["alertHour"] = this.alertHour ? this.alertHour.toJSON() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["treatmentType"] = this.treatmentType;
        data["customerId"] = this.customerId;
        data["topic"] = this.topic;
        data["location"] = this.location;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : <any>undefined;
        data["isFullDay"] = this.isFullDay;
        data["note"] = this.note;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeetingModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    topic?: string | undefined;
    location?: string | undefined;
    startDate?: Date;
    startTime?: TimeSpan;
    endDate?: Date;
    endTime?: TimeSpan;
    isFullDay?: boolean;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
}

export class MeetingSummaryModelForUpsert implements IMeetingSummaryModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    startDate?: Date;
    startTime?: TimeSpan;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    meetingOutcome?: TreatmentOutcome;
    meetingOutcomes?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;

    constructor(data?: IMeetingSummaryModelForUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.alertHour = _data["alertHour"] ? TimeSpan.fromJS(_data["alertHour"]) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.treatmentType = _data["treatmentType"];
            this.customerId = _data["customerId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(SelectListItem.fromJS(item));
            }
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectListItem.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.meetingOutcome = _data["meetingOutcome"];
            if (Array.isArray(_data["meetingOutcomes"])) {
                this.meetingOutcomes = [] as any;
                for (let item of _data["meetingOutcomes"])
                    this.meetingOutcomes!.push(SelectListItem.fromJS(item));
            }
            this.topic = _data["topic"];
            this.note = _data["note"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MeetingSummaryModelForUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingSummaryModelForUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["alertHour"] = this.alertHour ? this.alertHour.toJSON() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["treatmentType"] = this.treatmentType;
        data["customerId"] = this.customerId;
        data["priority"] = this.priority;
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item.toJSON());
        }
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["meetingOutcome"] = this.meetingOutcome;
        if (Array.isArray(this.meetingOutcomes)) {
            data["meetingOutcomes"] = [];
            for (let item of this.meetingOutcomes)
                data["meetingOutcomes"].push(item.toJSON());
        }
        data["topic"] = this.topic;
        data["note"] = this.note;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeetingSummaryModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    startDate?: Date;
    startTime?: TimeSpan;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    meetingOutcome?: TreatmentOutcome;
    meetingOutcomes?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    hours?: SelectListItem[] | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
}

export class MemberInfo implements IMemberInfo {
    memberType?: MemberTypes;
    declaringType?: Type;
    reflectedType?: Type;
    readonly name?: string | undefined;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType?: MemberTypes;
    declaringType?: Type;
    reflectedType?: Type;
    name?: string | undefined;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
}

/** 1 = Constructor, 2 = Event, 4 = Field, 8 = Method, 16 = Property, 32 = TypeInfo, 64 = Custom, 128 = NestedType, 191 = All */
export enum MemberTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _191 = 191,
}

export class MessageForTreatmentModel implements IMessageForTreatmentModel {
    getMessageModel?: GetMessageModel;
    leadId?: string | undefined;
    sueId?: string | undefined;
    policyId?: string | undefined;
    folderName?: string | undefined;

    constructor(data?: IMessageForTreatmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getMessageModel = _data["getMessageModel"] ? GetMessageModel.fromJS(_data["getMessageModel"]) : <any>undefined;
            this.leadId = _data["leadId"];
            this.sueId = _data["sueId"];
            this.policyId = _data["policyId"];
            this.folderName = _data["folderName"];
        }
    }

    static fromJS(data: any): MessageForTreatmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageForTreatmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getMessageModel"] = this.getMessageModel ? this.getMessageModel.toJSON() : <any>undefined;
        data["leadId"] = this.leadId;
        data["sueId"] = this.sueId;
        data["policyId"] = this.policyId;
        data["folderName"] = this.folderName;
        return data;
    }
}

export interface IMessageForTreatmentModel {
    getMessageModel?: GetMessageModel;
    leadId?: string | undefined;
    sueId?: string | undefined;
    policyId?: string | undefined;
    folderName?: string | undefined;
}

/** 0 = Low, 1 = Normal, 2 = High */
export enum MessageImportance {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = NonUrgent, 1 = Normal, 2 = Urgent */
export enum MessagePriority {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = ReuseSlot, 1 = Private, 2 = FamANDAssem, 3 = Assembly, 4 = Family, 5 = FamORAssem, 6 = Public, 7 = MemberAccessMask, 8 = UnmanagedExport, 16 = Static, 32 = Final, 64 = Virtual, 128 = HideBySig, 256 = NewSlot, 512 = CheckAccessOnOverride, 1024 = Abstract, 2048 = SpecialName, 4096 = RTSpecialName, 8192 = PinvokeImpl, 16384 = HasSecurity, 32768 = RequireSecObject, 53248 = ReservedMask */
export enum MethodAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _53248 = 53248,
}

export class MethodBase implements IMethodBase {
    memberType?: MemberTypes;
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;

    constructor(data?: IMethodBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        return data;
    }
}

export interface IMethodBase {
    memberType?: MemberTypes;
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
}

/** 0 = Managed, 1 = Native, 2 = OPTIL, 3 = CodeTypeMask, 4 = Unmanaged, 8 = NoInlining, 16 = ForwardRef, 32 = Synchronized, 64 = NoOptimization, 128 = PreserveSig, 256 = AggressiveInlining, 512 = AggressiveOptimization, 4096 = InternalCall, 65535 = MaxMethodImplVal */
export enum MethodImplAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _4096 = 4096,
    _65535 = 65535,
}

export class MethodInfo implements IMethodInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: Type;
    returnTypeCustomAttributes?: ICustomAttributeProvider;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : <any>undefined;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : <any>undefined;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMethodInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: Type;
    returnTypeCustomAttributes?: ICustomAttributeProvider;
}

export class MimeEntity implements IMimeEntity {
    readonly headers?: Header[] | undefined;
    contentDisposition?: ContentDisposition;
    contentType?: ContentType;
    contentBase?: string | undefined;
    contentLocation?: string | undefined;
    contentId?: string | undefined;
    isAttachment?: boolean;

    constructor(data?: IMimeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(Header.fromJS(item));
            }
            this.contentDisposition = _data["contentDisposition"] ? ContentDisposition.fromJS(_data["contentDisposition"]) : <any>undefined;
            this.contentType = _data["contentType"] ? ContentType.fromJS(_data["contentType"]) : <any>undefined;
            this.contentBase = _data["contentBase"];
            this.contentLocation = _data["contentLocation"];
            this.contentId = _data["contentId"];
            this.isAttachment = _data["isAttachment"];
        }
    }

    static fromJS(data: any): MimeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new MimeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        data["contentDisposition"] = this.contentDisposition ? this.contentDisposition.toJSON() : <any>undefined;
        data["contentType"] = this.contentType ? this.contentType.toJSON() : <any>undefined;
        data["contentBase"] = this.contentBase;
        data["contentLocation"] = this.contentLocation;
        data["contentId"] = this.contentId;
        data["isAttachment"] = this.isAttachment;
        return data;
    }
}

export interface IMimeEntity {
    headers?: Header[] | undefined;
    contentDisposition?: ContentDisposition;
    contentType?: ContentType;
    contentBase?: string | undefined;
    contentLocation?: string | undefined;
    contentId?: string | undefined;
    isAttachment?: boolean;
}

export class MimeMessage implements IMimeMessage {
    readonly headers?: Header[] | undefined;
    importance?: MessageImportance;
    priority?: MessagePriority;
    xPriority?: XMessagePriority;
    sender?: MailboxAddress;
    resentSender?: MailboxAddress;
    from?: InternetAddress[] | undefined;
    readonly resentFrom?: InternetAddress[] | undefined;
    readonly replyTo?: InternetAddress[] | undefined;
    readonly resentReplyTo?: InternetAddress[] | undefined;
    to?: InternetAddress[] | undefined;
    readonly resentTo?: InternetAddress[] | undefined;
    readonly cc?: InternetAddress[] | undefined;
    readonly resentCc?: InternetAddress[] | undefined;
    readonly bcc?: InternetAddress[] | undefined;
    readonly resentBcc?: InternetAddress[] | undefined;
    subject?: string | undefined;
    date?: Date;
    resentDate?: Date;
    readonly references?: string[] | undefined;
    inReplyTo?: string | undefined;
    messageId?: string | undefined;
    resentMessageId?: string | undefined;
    mimeVersion?: Version;
    body?: MimeEntity;
    readonly textBody?: string | undefined;
    readonly htmlBody?: string | undefined;
    readonly bodyParts?: MimeEntity[] | undefined;
    readonly attachments?: MimeEntity[] | undefined;

    constructor(data?: IMimeMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(Header.fromJS(item));
            }
            this.importance = _data["importance"];
            this.priority = _data["priority"];
            this.xPriority = _data["xPriority"];
            this.sender = _data["sender"] ? MailboxAddress.fromJS(_data["sender"]) : <any>undefined;
            this.resentSender = _data["resentSender"] ? MailboxAddress.fromJS(_data["resentSender"]) : <any>undefined;
            if (Array.isArray(_data["from"])) {
                this.from = [] as any;
                for (let item of _data["from"])
                    this.from!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["resentFrom"])) {
                (<any>this).resentFrom = [] as any;
                for (let item of _data["resentFrom"])
                    (<any>this).resentFrom!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["replyTo"])) {
                (<any>this).replyTo = [] as any;
                for (let item of _data["replyTo"])
                    (<any>this).replyTo!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["resentReplyTo"])) {
                (<any>this).resentReplyTo = [] as any;
                for (let item of _data["resentReplyTo"])
                    (<any>this).resentReplyTo!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["resentTo"])) {
                (<any>this).resentTo = [] as any;
                for (let item of _data["resentTo"])
                    (<any>this).resentTo!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["cc"])) {
                (<any>this).cc = [] as any;
                for (let item of _data["cc"])
                    (<any>this).cc!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["resentCc"])) {
                (<any>this).resentCc = [] as any;
                for (let item of _data["resentCc"])
                    (<any>this).resentCc!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["bcc"])) {
                (<any>this).bcc = [] as any;
                for (let item of _data["bcc"])
                    (<any>this).bcc!.push(InternetAddress.fromJS(item));
            }
            if (Array.isArray(_data["resentBcc"])) {
                (<any>this).resentBcc = [] as any;
                for (let item of _data["resentBcc"])
                    (<any>this).resentBcc!.push(InternetAddress.fromJS(item));
            }
            this.subject = _data["subject"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.resentDate = _data["resentDate"] ? new Date(_data["resentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["references"])) {
                (<any>this).references = [] as any;
                for (let item of _data["references"])
                    (<any>this).references!.push(item);
            }
            this.inReplyTo = _data["inReplyTo"];
            this.messageId = _data["messageId"];
            this.resentMessageId = _data["resentMessageId"];
            this.mimeVersion = _data["mimeVersion"] ? Version.fromJS(_data["mimeVersion"]) : <any>undefined;
            this.body = _data["body"] ? MimeEntity.fromJS(_data["body"]) : <any>undefined;
            (<any>this).textBody = _data["textBody"];
            (<any>this).htmlBody = _data["htmlBody"];
            if (Array.isArray(_data["bodyParts"])) {
                (<any>this).bodyParts = [] as any;
                for (let item of _data["bodyParts"])
                    (<any>this).bodyParts!.push(MimeEntity.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                (<any>this).attachments = [] as any;
                for (let item of _data["attachments"])
                    (<any>this).attachments!.push(MimeEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MimeMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MimeMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        data["importance"] = this.importance;
        data["priority"] = this.priority;
        data["xPriority"] = this.xPriority;
        data["sender"] = this.sender ? this.sender.toJSON() : <any>undefined;
        data["resentSender"] = this.resentSender ? this.resentSender.toJSON() : <any>undefined;
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item.toJSON());
        }
        if (Array.isArray(this.resentFrom)) {
            data["resentFrom"] = [];
            for (let item of this.resentFrom)
                data["resentFrom"].push(item.toJSON());
        }
        if (Array.isArray(this.replyTo)) {
            data["replyTo"] = [];
            for (let item of this.replyTo)
                data["replyTo"].push(item.toJSON());
        }
        if (Array.isArray(this.resentReplyTo)) {
            data["resentReplyTo"] = [];
            for (let item of this.resentReplyTo)
                data["resentReplyTo"].push(item.toJSON());
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        if (Array.isArray(this.resentTo)) {
            data["resentTo"] = [];
            for (let item of this.resentTo)
                data["resentTo"].push(item.toJSON());
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item.toJSON());
        }
        if (Array.isArray(this.resentCc)) {
            data["resentCc"] = [];
            for (let item of this.resentCc)
                data["resentCc"].push(item.toJSON());
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item.toJSON());
        }
        if (Array.isArray(this.resentBcc)) {
            data["resentBcc"] = [];
            for (let item of this.resentBcc)
                data["resentBcc"].push(item.toJSON());
        }
        data["subject"] = this.subject;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["resentDate"] = this.resentDate ? this.resentDate.toISOString() : <any>undefined;
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item);
        }
        data["inReplyTo"] = this.inReplyTo;
        data["messageId"] = this.messageId;
        data["resentMessageId"] = this.resentMessageId;
        data["mimeVersion"] = this.mimeVersion ? this.mimeVersion.toJSON() : <any>undefined;
        data["body"] = this.body ? this.body.toJSON() : <any>undefined;
        data["textBody"] = this.textBody;
        data["htmlBody"] = this.htmlBody;
        if (Array.isArray(this.bodyParts)) {
            data["bodyParts"] = [];
            for (let item of this.bodyParts)
                data["bodyParts"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMimeMessage {
    headers?: Header[] | undefined;
    importance?: MessageImportance;
    priority?: MessagePriority;
    xPriority?: XMessagePriority;
    sender?: MailboxAddress;
    resentSender?: MailboxAddress;
    from?: InternetAddress[] | undefined;
    resentFrom?: InternetAddress[] | undefined;
    replyTo?: InternetAddress[] | undefined;
    resentReplyTo?: InternetAddress[] | undefined;
    to?: InternetAddress[] | undefined;
    resentTo?: InternetAddress[] | undefined;
    cc?: InternetAddress[] | undefined;
    resentCc?: InternetAddress[] | undefined;
    bcc?: InternetAddress[] | undefined;
    resentBcc?: InternetAddress[] | undefined;
    subject?: string | undefined;
    date?: Date;
    resentDate?: Date;
    references?: string[] | undefined;
    inReplyTo?: string | undefined;
    messageId?: string | undefined;
    resentMessageId?: string | undefined;
    mimeVersion?: Version;
    body?: MimeEntity;
    textBody?: string | undefined;
    htmlBody?: string | undefined;
    bodyParts?: MimeEntity[] | undefined;
    attachments?: MimeEntity[] | undefined;
}

export class MobilityPullsAndRepairsModel implements IMobilityPullsAndRepairsModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    mobilityPullsAndRepairsActionType?: number;
    mobilityPullsAndRepairsType?: number;
    amout?: string | undefined;
    depositDtae?: Date;
    valueDate?: string | undefined;
    report?: string | undefined;

    constructor(data?: IMobilityPullsAndRepairsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.mobilityPullsAndRepairsActionType = _data["mobilityPullsAndRepairsActionType"];
            this.mobilityPullsAndRepairsType = _data["mobilityPullsAndRepairsType"];
            this.amout = _data["amout"];
            this.depositDtae = _data["depositDtae"] ? new Date(_data["depositDtae"].toString()) : <any>undefined;
            this.valueDate = _data["valueDate"];
            this.report = _data["report"];
        }
    }

    static fromJS(data: any): MobilityPullsAndRepairsModel {
        data = typeof data === 'object' ? data : {};
        let result = new MobilityPullsAndRepairsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["mobilityPullsAndRepairsActionType"] = this.mobilityPullsAndRepairsActionType;
        data["mobilityPullsAndRepairsType"] = this.mobilityPullsAndRepairsType;
        data["amout"] = this.amout;
        data["depositDtae"] = this.depositDtae ? this.depositDtae.toISOString() : <any>undefined;
        data["valueDate"] = this.valueDate;
        data["report"] = this.report;
        return data;
    }
}

export interface IMobilityPullsAndRepairsModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    mobilityPullsAndRepairsActionType?: number;
    mobilityPullsAndRepairsType?: number;
    amout?: string | undefined;
    depositDtae?: Date;
    valueDate?: string | undefined;
    report?: string | undefined;
}

export class Module implements IModule {
    assembly?: Assembly;
    readonly fullyQualifiedName?: string | undefined;
    readonly name?: string | undefined;
    readonly mdStreamVersion?: number;
    readonly moduleVersionId?: string;
    readonly scopeName?: string | undefined;
    moduleHandle?: ModuleHandle;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly?: Assembly;
    fullyQualifiedName?: string | undefined;
    name?: string | undefined;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string | undefined;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion?: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion?: number;
}

export class NetworkCredential implements INetworkCredential {
    userName?: string | undefined;
    password?: string | undefined;
    securePassword?: SecureString;
    domain?: string | undefined;

    constructor(data?: INetworkCredential) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.securePassword = _data["securePassword"] ? SecureString.fromJS(_data["securePassword"]) : <any>undefined;
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): NetworkCredential {
        data = typeof data === 'object' ? data : {};
        let result = new NetworkCredential();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["securePassword"] = this.securePassword ? this.securePassword.toJSON() : <any>undefined;
        data["domain"] = this.domain;
        return data;
    }
}

export interface INetworkCredential {
    userName?: string | undefined;
    password?: string | undefined;
    securePassword?: SecureString;
    domain?: string | undefined;
}

export class NewMailModel implements INewMailModel {
    mailId?: string;
    replyToId?: UniqueId;
    toForReply?: string[] | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    bcc?: string[] | undefined;
    repSubject?: string | undefined;
    fwSubject?: string | undefined;
    inReplyTo?: string | undefined;
    references?: string[] | undefined;
    repBody?: string | undefined;
    fwBody?: string | undefined;
    font?: string | undefined;
    size?: number;

    constructor(data?: INewMailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailId = _data["mailId"];
            this.replyToId = _data["replyToId"] ? UniqueId.fromJS(_data["replyToId"]) : <any>undefined;
            if (Array.isArray(_data["toForReply"])) {
                this.toForReply = [] as any;
                for (let item of _data["toForReply"])
                    this.toForReply!.push(item);
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(item);
            }
            this.repSubject = _data["repSubject"];
            this.fwSubject = _data["fwSubject"];
            this.inReplyTo = _data["inReplyTo"];
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(item);
            }
            this.repBody = _data["repBody"];
            this.fwBody = _data["fwBody"];
            this.font = _data["font"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): NewMailModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewMailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailId"] = this.mailId;
        data["replyToId"] = this.replyToId ? this.replyToId.toJSON() : <any>undefined;
        if (Array.isArray(this.toForReply)) {
            data["toForReply"] = [];
            for (let item of this.toForReply)
                data["toForReply"].push(item);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item);
        }
        data["repSubject"] = this.repSubject;
        data["fwSubject"] = this.fwSubject;
        data["inReplyTo"] = this.inReplyTo;
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item);
        }
        data["repBody"] = this.repBody;
        data["fwBody"] = this.fwBody;
        data["font"] = this.font;
        data["size"] = this.size;
        return data;
    }
}

export interface INewMailModel {
    mailId?: string;
    replyToId?: UniqueId;
    toForReply?: string[] | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    bcc?: string[] | undefined;
    repSubject?: string | undefined;
    fwSubject?: string | undefined;
    inReplyTo?: string | undefined;
    references?: string[] | undefined;
    repBody?: string | undefined;
    fwBody?: string | undefined;
    font?: string | undefined;
    size?: number;
}

/** 1 = Automatic, 2 = NoNovelty */
export enum NoveltyType {
    _1 = 1,
    _2 = 2,
}

export class Offer implements IOffer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    creationDate?: Date;
    status?: OfferStatus;
    typeOfInsurance?: string | undefined;
    policyKind?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    notes?: string | undefined;
    policyTypeId?: string | undefined;
    policyType?: PolicyType;
    companyId?: string | undefined;
    company?: InsuranceCompany;
    customerId?: string;
    customer?: Customer;
    createdById?: string | undefined;
    createdBy?: User;

    constructor(data?: IOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.typeOfInsurance = _data["typeOfInsurance"];
            this.policyKind = _data["policyKind"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.policyTypeId = _data["policyTypeId"];
            this.policyType = _data["policyType"] ? PolicyType.fromJS(_data["policyType"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? InsuranceCompany.fromJS(_data["company"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Offer {
        data = typeof data === 'object' ? data : {};
        let result = new Offer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["typeOfInsurance"] = this.typeOfInsurance;
        data["policyKind"] = this.policyKind;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["policyTypeId"] = this.policyTypeId;
        data["policyType"] = this.policyType ? this.policyType.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOffer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    creationDate?: Date;
    status?: OfferStatus;
    typeOfInsurance?: string | undefined;
    policyKind?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    notes?: string | undefined;
    policyTypeId?: string | undefined;
    policyType?: PolicyType;
    companyId?: string | undefined;
    company?: InsuranceCompany;
    customerId?: string;
    customer?: Customer;
    createdById?: string | undefined;
    createdBy?: User;
}

export class OfferDiscount implements IOfferDiscount {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    simulatorOfferId?: string | undefined;
    simulatorOffer?: SimulatorOffer;
    discountId?: string | undefined;
    discount?: Discount;
    sum?: number;
    feeParticipation?: number;
    ayalonHanachatHatama?: number;
    ayalonHanachatSochen?: number;

    constructor(data?: IOfferDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.simulatorOfferId = _data["simulatorOfferId"];
            this.simulatorOffer = _data["simulatorOffer"] ? SimulatorOffer.fromJS(_data["simulatorOffer"]) : <any>undefined;
            this.discountId = _data["discountId"];
            this.discount = _data["discount"] ? Discount.fromJS(_data["discount"]) : <any>undefined;
            this.sum = _data["sum"];
            this.feeParticipation = _data["feeParticipation"];
            this.ayalonHanachatHatama = _data["ayalonHanachatHatama"];
            this.ayalonHanachatSochen = _data["ayalonHanachatSochen"];
        }
    }

    static fromJS(data: any): OfferDiscount {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDiscount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["simulatorOfferId"] = this.simulatorOfferId;
        data["simulatorOffer"] = this.simulatorOffer ? this.simulatorOffer.toJSON() : <any>undefined;
        data["discountId"] = this.discountId;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["sum"] = this.sum;
        data["feeParticipation"] = this.feeParticipation;
        data["ayalonHanachatHatama"] = this.ayalonHanachatHatama;
        data["ayalonHanachatSochen"] = this.ayalonHanachatSochen;
        return data;
    }
}

export interface IOfferDiscount {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    simulatorOfferId?: string | undefined;
    simulatorOffer?: SimulatorOffer;
    discountId?: string | undefined;
    discount?: Discount;
    sum?: number;
    feeParticipation?: number;
    ayalonHanachatHatama?: number;
    ayalonHanachatSochen?: number;
}

export class OfferDiscountModel implements IOfferDiscountModel {
    id?: string;
    simulatorOfferId?: string | undefined;
    simulatorOffer?: SimulatorOfferModel;
    discountId?: string | undefined;
    discount?: DiscountModel;
    sum?: number;
    feeParticipation?: number;
    ayalonHanachatHatama?: number;
    ayalonHanachatSochen?: number;

    constructor(data?: IOfferDiscountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.simulatorOfferId = _data["simulatorOfferId"];
            this.simulatorOffer = _data["simulatorOffer"] ? SimulatorOfferModel.fromJS(_data["simulatorOffer"]) : <any>undefined;
            this.discountId = _data["discountId"];
            this.discount = _data["discount"] ? DiscountModel.fromJS(_data["discount"]) : <any>undefined;
            this.sum = _data["sum"];
            this.feeParticipation = _data["feeParticipation"];
            this.ayalonHanachatHatama = _data["ayalonHanachatHatama"];
            this.ayalonHanachatSochen = _data["ayalonHanachatSochen"];
        }
    }

    static fromJS(data: any): OfferDiscountModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDiscountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["simulatorOfferId"] = this.simulatorOfferId;
        data["simulatorOffer"] = this.simulatorOffer ? this.simulatorOffer.toJSON() : <any>undefined;
        data["discountId"] = this.discountId;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["sum"] = this.sum;
        data["feeParticipation"] = this.feeParticipation;
        data["ayalonHanachatHatama"] = this.ayalonHanachatHatama;
        data["ayalonHanachatSochen"] = this.ayalonHanachatSochen;
        return data;
    }
}

export interface IOfferDiscountModel {
    id?: string;
    simulatorOfferId?: string | undefined;
    simulatorOffer?: SimulatorOfferModel;
    discountId?: string | undefined;
    discount?: DiscountModel;
    sum?: number;
    feeParticipation?: number;
    ayalonHanachatHatama?: number;
    ayalonHanachatSochen?: number;
}

export class OfferModel implements IOfferModel {
    id?: string;
    creationDate?: Date;
    status?: OfferStatus;
    policyTypeName?: string | undefined;
    policyTypeIcon?: string | undefined;
    typeOfInsurance?: string | undefined;
    policyKind?: string | undefined;
    companyName?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    notes?: string | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;

    constructor(data?: IOfferModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.policyTypeName = _data["policyTypeName"];
            this.policyTypeIcon = _data["policyTypeIcon"];
            this.typeOfInsurance = _data["typeOfInsurance"];
            this.policyKind = _data["policyKind"];
            this.companyName = _data["companyName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
        }
    }

    static fromJS(data: any): OfferModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfferModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["policyTypeName"] = this.policyTypeName;
        data["policyTypeIcon"] = this.policyTypeIcon;
        data["typeOfInsurance"] = this.typeOfInsurance;
        data["policyKind"] = this.policyKind;
        data["companyName"] = this.companyName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        return data;
    }
}

export interface IOfferModel {
    id?: string;
    creationDate?: Date;
    status?: OfferStatus;
    policyTypeName?: string | undefined;
    policyTypeIcon?: string | undefined;
    typeOfInsurance?: string | undefined;
    policyKind?: string | undefined;
    companyName?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    notes?: string | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
}

/** 0 = RenewalProposal, 1 = Closure, 2 = Rejection */
export enum OfferStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class OfferTabModel implements IOfferTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: OfferModel[] | undefined;
    leadPage?: LeadsPageModel;

    constructor(data?: IOfferTabModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OfferModel.fromJS(item));
            }
            this.leadPage = _data["leadPage"] ? LeadsPageModel.fromJS(_data["leadPage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OfferTabModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfferTabModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["leadPage"] = this.leadPage ? this.leadPage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOfferTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: OfferModel[] | undefined;
    leadPage?: LeadsPageModel;
}

export class OfficeDepartment implements IOfficeDepartment {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    status?: ActivityStatus;
    departmentManagerId?: string | undefined;
    parentId?: string | undefined;
    parent?: OfficeDepartment;
    children?: OfficeDepartment[] | undefined;

    constructor(data?: IOfficeDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.status = _data["status"];
            this.departmentManagerId = _data["departmentManagerId"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? OfficeDepartment.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(OfficeDepartment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfficeDepartment {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeDepartment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["status"] = this.status;
        data["departmentManagerId"] = this.departmentManagerId;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfficeDepartment {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    status?: ActivityStatus;
    departmentManagerId?: string | undefined;
    parentId?: string | undefined;
    parent?: OfficeDepartment;
    children?: OfficeDepartment[] | undefined;
}

export class OfficeDepartmentModel implements IOfficeDepartmentModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    departmentManagerId?: string | undefined;
    departmentManager?: UserModel;
    parentId?: string | undefined;
    users?: SelectListItem[] | undefined;
    departments?: SelectListItem[] | undefined;
    usersInDepartment?: UserModel[] | undefined;
    fromProjects?: boolean;

    constructor(data?: IOfficeDepartmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.departmentManagerId = _data["departmentManagerId"];
            this.departmentManager = _data["departmentManager"] ? UserModel.fromJS(_data["departmentManager"]) : <any>undefined;
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["usersInDepartment"])) {
                this.usersInDepartment = [] as any;
                for (let item of _data["usersInDepartment"])
                    this.usersInDepartment!.push(UserModel.fromJS(item));
            }
            this.fromProjects = _data["fromProjects"];
        }
    }

    static fromJS(data: any): OfficeDepartmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeDepartmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["departmentManagerId"] = this.departmentManagerId;
        data["departmentManager"] = this.departmentManager ? this.departmentManager.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        if (Array.isArray(this.usersInDepartment)) {
            data["usersInDepartment"] = [];
            for (let item of this.usersInDepartment)
                data["usersInDepartment"].push(item.toJSON());
        }
        data["fromProjects"] = this.fromProjects;
        return data;
    }
}

export interface IOfficeDepartmentModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    departmentManagerId?: string | undefined;
    departmentManager?: UserModel;
    parentId?: string | undefined;
    users?: SelectListItem[] | undefined;
    departments?: SelectListItem[] | undefined;
    usersInDepartment?: UserModel[] | undefined;
    fromProjects?: boolean;
}

export class OfficeDepartmentsModel implements IOfficeDepartmentsModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    officeDepartments?: OfficeDepartmentModel[] | undefined;

    constructor(data?: IOfficeDepartmentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["officeDepartments"])) {
                this.officeDepartments = [] as any;
                for (let item of _data["officeDepartments"])
                    this.officeDepartments!.push(OfficeDepartmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfficeDepartmentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeDepartmentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.officeDepartments)) {
            data["officeDepartments"] = [];
            for (let item of this.officeDepartments)
                data["officeDepartments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfficeDepartmentsModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    officeDepartments?: OfficeDepartmentModel[] | undefined;
}

/** 0 = Private, 1 = Company */
export enum OrderPlumberType {
    _0 = 0,
    _1 = 1,
}

export class PackageModel implements IPackageModel {
    id?: string | undefined;
    status?: ActivityStatus;
    name?: string | undefined;
    description?: string | undefined;
    solventCode?: number | undefined;
    yearsOfValidity?: number | undefined;
    costForCustomer?: number | undefined;
    cost?: number | undefined;
    isPrivateUpto4Tons?: boolean | undefined;
    isCommercialUpTo4Tons?: boolean | undefined;
    isTruck?: boolean | undefined;
    isCab?: boolean | undefined;
    isMinibus?: boolean | undefined;
    isTractor?: boolean | undefined;
    isTrailed?: boolean | undefined;
    isMotorcycle?: boolean | undefined;
    isOther?: boolean | undefined;

    constructor(data?: IPackageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.solventCode = _data["solventCode"];
            this.yearsOfValidity = _data["yearsOfValidity"];
            this.costForCustomer = _data["costForCustomer"];
            this.cost = _data["cost"];
            this.isPrivateUpto4Tons = _data["isPrivateUpto4Tons"];
            this.isCommercialUpTo4Tons = _data["isCommercialUpTo4Tons"];
            this.isTruck = _data["isTruck"];
            this.isCab = _data["isCab"];
            this.isMinibus = _data["isMinibus"];
            this.isTractor = _data["isTractor"];
            this.isTrailed = _data["isTrailed"];
            this.isMotorcycle = _data["isMotorcycle"];
            this.isOther = _data["isOther"];
        }
    }

    static fromJS(data: any): PackageModel {
        data = typeof data === 'object' ? data : {};
        let result = new PackageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["name"] = this.name;
        data["description"] = this.description;
        data["solventCode"] = this.solventCode;
        data["yearsOfValidity"] = this.yearsOfValidity;
        data["costForCustomer"] = this.costForCustomer;
        data["cost"] = this.cost;
        data["isPrivateUpto4Tons"] = this.isPrivateUpto4Tons;
        data["isCommercialUpTo4Tons"] = this.isCommercialUpTo4Tons;
        data["isTruck"] = this.isTruck;
        data["isCab"] = this.isCab;
        data["isMinibus"] = this.isMinibus;
        data["isTractor"] = this.isTractor;
        data["isTrailed"] = this.isTrailed;
        data["isMotorcycle"] = this.isMotorcycle;
        data["isOther"] = this.isOther;
        return data;
    }
}

export interface IPackageModel {
    id?: string | undefined;
    status?: ActivityStatus;
    name?: string | undefined;
    description?: string | undefined;
    solventCode?: number | undefined;
    yearsOfValidity?: number | undefined;
    costForCustomer?: number | undefined;
    cost?: number | undefined;
    isPrivateUpto4Tons?: boolean | undefined;
    isCommercialUpTo4Tons?: boolean | undefined;
    isTruck?: boolean | undefined;
    isCab?: boolean | undefined;
    isMinibus?: boolean | undefined;
    isTractor?: boolean | undefined;
    isTrailed?: boolean | undefined;
    isMotorcycle?: boolean | undefined;
    isOther?: boolean | undefined;
}

export class Parameter implements IParameter {
    name?: string | undefined;
    encoding?: Encoding;
    encodingMethod?: ParameterEncodingMethod;
    alwaysQuote?: boolean;
    value?: string | undefined;

    constructor(data?: IParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.encoding = _data["encoding"] ? Encoding.fromJS(_data["encoding"]) : <any>undefined;
            this.encodingMethod = _data["encodingMethod"];
            this.alwaysQuote = _data["alwaysQuote"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Parameter {
        data = typeof data === 'object' ? data : {};
        let result = new Parameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["encoding"] = this.encoding ? this.encoding.toJSON() : <any>undefined;
        data["encodingMethod"] = this.encodingMethod;
        data["alwaysQuote"] = this.alwaysQuote;
        data["value"] = this.value;
        return data;
    }
}

export interface IParameter {
    name?: string | undefined;
    encoding?: Encoding;
    encodingMethod?: ParameterEncodingMethod;
    alwaysQuote?: boolean;
    value?: string | undefined;
}

/** 0 = None, 1 = In, 2 = Out, 4 = Lcid, 8 = Retval, 16 = Optional, 4096 = HasDefault, 8192 = HasFieldMarshal, 16384 = Reserved3, 32768 = Reserved4, 61440 = ReservedMask */
export enum ParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _61440 = 61440,
}

/** 0 = Default, 1 = Rfc2231, 2 = Rfc2047 */
export enum ParameterEncodingMethod {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ParameterInfo implements IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    readonly name?: string | undefined;
    parameterType?: Type;
    readonly position?: number;
    readonly isIn?: boolean;
    readonly isLcid?: boolean;
    readonly isOptional?: boolean;
    readonly isOut?: boolean;
    readonly isRetval?: boolean;
    readonly defaultValue?: any | undefined;
    readonly rawDefaultValue?: any | undefined;
    readonly hasDefaultValue?: boolean;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : <any>undefined;
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: Type;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number;
}

/** 0 = Comprehensive, 1 = ThisrtParty, 2 = NoInsurance */
export enum PassedTypeOfInsurance {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Payment implements IPayment {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    title?: string | undefined;
    amount?: number;
    paymentMethodType?: PaymentMethodType;
    paymentsNumber?: number;
    paymentStatus?: PaymentStatus;
    creationStatus?: CreationStatus;
    transactionToken?: string | undefined;
    icreditIdentity?: string | undefined;
    bankNumber?: number;
    branchNumber?: number;
    accountNumber?: number;
    referenceNumber?: string | undefined;
    bankTransferDate?: Date;
    paymentChecks?: PaymentCheck[] | undefined;
    riderId?: string | undefined;
    rider?: Rider;
    maxPayments?: number;
    invoiceUrl?: string | undefined;
    ccNumber?: string | undefined;
    paymentItems?: PaymentItem[] | undefined;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.paymentsNumber = _data["paymentsNumber"];
            this.paymentStatus = _data["paymentStatus"];
            this.creationStatus = _data["creationStatus"];
            this.transactionToken = _data["transactionToken"];
            this.icreditIdentity = _data["icreditIdentity"];
            this.bankNumber = _data["bankNumber"];
            this.branchNumber = _data["branchNumber"];
            this.accountNumber = _data["accountNumber"];
            this.referenceNumber = _data["referenceNumber"];
            this.bankTransferDate = _data["bankTransferDate"] ? new Date(_data["bankTransferDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["paymentChecks"])) {
                this.paymentChecks = [] as any;
                for (let item of _data["paymentChecks"])
                    this.paymentChecks!.push(PaymentCheck.fromJS(item));
            }
            this.riderId = _data["riderId"];
            this.rider = _data["rider"] ? Rider.fromJS(_data["rider"]) : <any>undefined;
            this.maxPayments = _data["maxPayments"];
            this.invoiceUrl = _data["invoiceUrl"];
            this.ccNumber = _data["ccNumber"];
            if (Array.isArray(_data["paymentItems"])) {
                this.paymentItems = [] as any;
                for (let item of _data["paymentItems"])
                    this.paymentItems!.push(PaymentItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["paymentMethodType"] = this.paymentMethodType;
        data["paymentsNumber"] = this.paymentsNumber;
        data["paymentStatus"] = this.paymentStatus;
        data["creationStatus"] = this.creationStatus;
        data["transactionToken"] = this.transactionToken;
        data["icreditIdentity"] = this.icreditIdentity;
        data["bankNumber"] = this.bankNumber;
        data["branchNumber"] = this.branchNumber;
        data["accountNumber"] = this.accountNumber;
        data["referenceNumber"] = this.referenceNumber;
        data["bankTransferDate"] = this.bankTransferDate ? this.bankTransferDate.toISOString() : <any>undefined;
        if (Array.isArray(this.paymentChecks)) {
            data["paymentChecks"] = [];
            for (let item of this.paymentChecks)
                data["paymentChecks"].push(item.toJSON());
        }
        data["riderId"] = this.riderId;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["maxPayments"] = this.maxPayments;
        data["invoiceUrl"] = this.invoiceUrl;
        data["ccNumber"] = this.ccNumber;
        if (Array.isArray(this.paymentItems)) {
            data["paymentItems"] = [];
            for (let item of this.paymentItems)
                data["paymentItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPayment {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    title?: string | undefined;
    amount?: number;
    paymentMethodType?: PaymentMethodType;
    paymentsNumber?: number;
    paymentStatus?: PaymentStatus;
    creationStatus?: CreationStatus;
    transactionToken?: string | undefined;
    icreditIdentity?: string | undefined;
    bankNumber?: number;
    branchNumber?: number;
    accountNumber?: number;
    referenceNumber?: string | undefined;
    bankTransferDate?: Date;
    paymentChecks?: PaymentCheck[] | undefined;
    riderId?: string | undefined;
    rider?: Rider;
    maxPayments?: number;
    invoiceUrl?: string | undefined;
    ccNumber?: string | undefined;
    paymentItems?: PaymentItem[] | undefined;
}

/** 0 = Create, 1 = Delete */
export enum PaymentActionType {
    _0 = 0,
    _1 = 1,
}

export class PaymentCheck implements IPaymentCheck {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    paymentId?: string;
    payment?: Payment;
    checkNumber?: string | undefined;
    dueDate?: Date;
    amount?: number;
    bankNumber?: number;
    branchNumber?: number;
    accountNumber?: number;
    paymentStatus?: PaymentStatus;

    constructor(data?: IPaymentCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : <any>undefined;
            this.checkNumber = _data["checkNumber"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.bankNumber = _data["bankNumber"];
            this.branchNumber = _data["branchNumber"];
            this.accountNumber = _data["accountNumber"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): PaymentCheck {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["checkNumber"] = this.checkNumber;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["bankNumber"] = this.bankNumber;
        data["branchNumber"] = this.branchNumber;
        data["accountNumber"] = this.accountNumber;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IPaymentCheck {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    paymentId?: string;
    payment?: Payment;
    checkNumber?: string | undefined;
    dueDate?: Date;
    amount?: number;
    bankNumber?: number;
    branchNumber?: number;
    accountNumber?: number;
    paymentStatus?: PaymentStatus;
}

export class PaymentCheckModel implements IPaymentCheckModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    paymentId?: string;
    payment?: PaymentModel;
    checkNumber?: string | undefined;
    dueDate?: Date;
    amount?: number;
    bankNumber?: number;
    branchNumber?: number;
    accountNumber?: number;
    paymentStatus?: PaymentStatus;

    constructor(data?: IPaymentCheckModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.payment = _data["payment"] ? PaymentModel.fromJS(_data["payment"]) : <any>undefined;
            this.checkNumber = _data["checkNumber"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.bankNumber = _data["bankNumber"];
            this.branchNumber = _data["branchNumber"];
            this.accountNumber = _data["accountNumber"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): PaymentCheckModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCheckModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["checkNumber"] = this.checkNumber;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["bankNumber"] = this.bankNumber;
        data["branchNumber"] = this.branchNumber;
        data["accountNumber"] = this.accountNumber;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IPaymentCheckModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    paymentId?: string;
    payment?: PaymentModel;
    checkNumber?: string | undefined;
    dueDate?: Date;
    amount?: number;
    bankNumber?: number;
    branchNumber?: number;
    accountNumber?: number;
    paymentStatus?: PaymentStatus;
}

export class PaymentItem implements IPaymentItem {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    paymentId?: string;
    payment?: Payment;
    title?: string | undefined;
    amount?: number;
    quantity?: number;
    actionType?: PaymentActionType;
    description?: string | undefined;

    constructor(data?: IPaymentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : <any>undefined;
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.actionType = _data["actionType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PaymentItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["actionType"] = this.actionType;
        data["description"] = this.description;
        return data;
    }
}

export interface IPaymentItem {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    paymentId?: string;
    payment?: Payment;
    title?: string | undefined;
    amount?: number;
    quantity?: number;
    actionType?: PaymentActionType;
    description?: string | undefined;
}

export class PaymentItemModel implements IPaymentItemModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    paymentId?: string;
    payment?: PaymentModel;
    title?: string | undefined;
    amount?: number;
    quantity?: number;
    actionType?: PaymentActionType;
    description?: string | undefined;

    constructor(data?: IPaymentItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.payment = _data["payment"] ? PaymentModel.fromJS(_data["payment"]) : <any>undefined;
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.actionType = _data["actionType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PaymentItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["actionType"] = this.actionType;
        data["description"] = this.description;
        return data;
    }
}

export interface IPaymentItemModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    paymentId?: string;
    payment?: PaymentModel;
    title?: string | undefined;
    amount?: number;
    quantity?: number;
    actionType?: PaymentActionType;
    description?: string | undefined;
}

/** 0 = CreditCard, 1 = Check, 2 = BankTransfer, 3 = Other */
export enum PaymentMethodType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PaymentModel implements IPaymentModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    title?: string | undefined;
    comment?: string | undefined;
    paymentDetails?: string | undefined;
    amount?: number;
    paymentMethodType?: PaymentMethodType;
    paymentsNumber?: number;
    paymentStatus?: PaymentStatus;
    creationStatus?: CreationStatus;
    transactionToken?: string | undefined;
    icreditIdentity?: string | undefined;
    bankNumber?: number;
    branchNumber?: number;
    accountNumber?: number;
    referenceNumber?: string | undefined;
    bankTransferDate?: Date;
    riderId?: string | undefined;
    paymentChecks?: PaymentCheckModel[] | undefined;
    paymentItems?: PaymentItemModel[] | undefined;
    cancelPaymentId?: string | undefined;
    cancelPayment?: PaymentModel;
    ccNumber?: string | undefined;
    iCerditUrl?: string | undefined;
    hasChargeCredit?: boolean;
    maxPayments?: number;
    invoiceUrl?: string | undefined;
    ccChargeCredit?: SelectListItem[] | undefined;
    ccChargeCreditId?: string;
    errMsg?: string
    constructor(data?: IPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.comment = _data["comment"];
            this.paymentDetails = _data["paymentDetails"];

            this.amount = _data["amount"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.paymentsNumber = _data["paymentsNumber"];
            this.paymentStatus = _data["paymentStatus"];
            this.creationStatus = _data["creationStatus"];
            this.transactionToken = _data["transactionToken"];
            this.icreditIdentity = _data["icreditIdentity"];
            this.bankNumber = _data["bankNumber"];
            this.branchNumber = _data["branchNumber"];
            this.accountNumber = _data["accountNumber"];
            this.referenceNumber = _data["referenceNumber"];
            this.bankTransferDate = _data["bankTransferDate"] ? new Date(_data["bankTransferDate"].toString()) : <any>undefined;
            this.riderId = _data["riderId"];
            this.errMsg = _data["errMsg"];
            if (Array.isArray(_data["paymentChecks"])) {
                this.paymentChecks = [] as any;
                for (let item of _data["paymentChecks"])
                    this.paymentChecks!.push(PaymentCheckModel.fromJS(item));
            }
            if (Array.isArray(_data["paymentItems"])) {
                this.paymentItems = [] as any;
                for (let item of _data["paymentItems"])
                    this.paymentItems!.push(PaymentItemModel.fromJS(item));
            }
            this.cancelPaymentId = _data["cancelPaymentId"];
            this.cancelPayment = _data["cancelPayment"] ? PaymentModel.fromJS(_data["cancelPayment"]) : <any>undefined;
            this.ccNumber = _data["ccNumber"];
            this.iCerditUrl = _data["iCerditUrl"];
            this.hasChargeCredit = _data["hasChargeCredit"];
            this.maxPayments = _data["maxPayments"];
            this.invoiceUrl = _data["invoiceUrl"];
            if (Array.isArray(_data["ccChargeCredit"])) {
                this.ccChargeCredit = [] as any;
                for (let item of _data["ccChargeCredit"])
                    this.ccChargeCredit!.push(SelectListItem.fromJS(item));
            }
            this.ccChargeCreditId = _data["ccChargeCreditId"];
        }
    }

    static fromJS(data: any): PaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["comment"] = this.comment;
        data["paymentDetails"] = this.paymentDetails;

        data["amount"] = this.amount;
        data["paymentMethodType"] = this.paymentMethodType;
        data["paymentsNumber"] = this.paymentsNumber;
        data["paymentStatus"] = this.paymentStatus;
        data["creationStatus"] = this.creationStatus;
        data["transactionToken"] = this.transactionToken;
        data["icreditIdentity"] = this.icreditIdentity;
        data["bankNumber"] = this.bankNumber;
        data["branchNumber"] = this.branchNumber;
        data["accountNumber"] = this.accountNumber;
        data["referenceNumber"] = this.referenceNumber;
        data["bankTransferDate"] = this.bankTransferDate ? this.bankTransferDate.toISOString() : <any>undefined;
        data["riderId"] = this.riderId;
        data["errMsg"] = this.errMsg;
        if (Array.isArray(this.paymentChecks)) {
            data["paymentChecks"] = [];
            for (let item of this.paymentChecks)
                data["paymentChecks"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentItems)) {
            data["paymentItems"] = [];
            for (let item of this.paymentItems)
                data["paymentItems"].push(item.toJSON());
        }
        data["cancelPaymentId"] = this.cancelPaymentId;
        data["cancelPayment"] = this.cancelPayment ? this.cancelPayment.toJSON() : <any>undefined;
        data["ccNumber"] = this.ccNumber;
        data["iCerditUrl"] = this.iCerditUrl;
        data["hasChargeCredit"] = this.hasChargeCredit;
        data["maxPayments"] = this.maxPayments;
        data["invoiceUrl"] = this.invoiceUrl;
        if (Array.isArray(this.ccChargeCredit)) {
            data["ccChargeCredit"] = [];
            for (let item of this.ccChargeCredit)
                data["ccChargeCredit"].push(item.toJSON());
        }
        data["ccChargeCreditId"] = this.ccChargeCreditId;
        return data;
    }
}

export interface IPaymentModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    title?: string | undefined;
    comment?: string | undefined;
    paymentDetails?: string | undefined;
    amount?: number;
    paymentMethodType?: PaymentMethodType;
    paymentsNumber?: number;
    paymentStatus?: PaymentStatus;
    creationStatus?: CreationStatus;
    transactionToken?: string | undefined;
    icreditIdentity?: string | undefined;
    bankNumber?: number;
    branchNumber?: number;
    accountNumber?: number;
    referenceNumber?: string | undefined;
    bankTransferDate?: Date;
    riderId?: string | undefined;
    paymentChecks?: PaymentCheckModel[] | undefined;
    paymentItems?: PaymentItemModel[] | undefined;
    cancelPaymentId?: string | undefined;
    cancelPayment?: PaymentModel;
    ccNumber?: string | undefined;
    iCerditUrl?: string | undefined;
    hasChargeCredit?: boolean;
    maxPayments?: number;
    invoiceUrl?: string | undefined;
    ccChargeCredit?: SelectListItem[] | undefined;
    ccChargeCreditId?: string;
}

/** 0 = NotPayed, 1 = Payed, 2 = Canceled, 3 = Frozen, 4 = Error, 5 = Created */
export enum PaymentStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class PeriodBalanceModel implements IPeriodBalanceModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    accrualValueDate?: Date;
    layerContentType?: number;
    periodBalances?: number;
    balanceType?: number;
    sumBalance?: number;

    constructor(data?: IPeriodBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.accrualValueDate = _data["accrualValueDate"] ? new Date(_data["accrualValueDate"].toString()) : <any>undefined;
            this.layerContentType = _data["layerContentType"];
            this.periodBalances = _data["periodBalances"];
            this.balanceType = _data["balanceType"];
            this.sumBalance = _data["sumBalance"];
        }
    }

    static fromJS(data: any): PeriodBalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodBalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["accrualValueDate"] = this.accrualValueDate ? this.accrualValueDate.toISOString() : <any>undefined;
        data["layerContentType"] = this.layerContentType;
        data["periodBalances"] = this.periodBalances;
        data["balanceType"] = this.balanceType;
        data["sumBalance"] = this.sumBalance;
        return data;
    }
}

export interface IPeriodBalanceModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    accrualValueDate?: Date;
    layerContentType?: number;
    periodBalances?: number;
    balanceType?: number;
    sumBalance?: number;
}

/** 0 = View, 1 = Edit, 2 = CreateEdit */
export enum PermissionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PersonalData implements IPersonalData {
    id?: string | undefined;
    identifier?: string | undefined;
    identityIssueDate?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: string | undefined;
    maritalStatus?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string[] | undefined;
    getPhonesListString?: string | undefined;
    title?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    addressComments?: string | undefined;
    mailbox?: string | undefined;
    postalCode?: string | undefined;
    comment?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicenseType?: string | undefined;
    driverLicensIssueDate?: string | undefined;
    workplace?: string | undefined;
    jobTitle?: string | undefined;
    workerNumber?: string | undefined;
    profession?: string | undefined;
    referrer?: string | undefined;
    websiteUrl?: string | undefined;
    facebookUrl?: string | undefined;
    clinic?: string | undefined;
    customerRemarks?: string | undefined;
    customerAddresses?: string[] | undefined;
    customerContactDetails?: string[] | undefined;

    constructor(data?: IPersonalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.identityIssueDate = _data["identityIssueDate"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.gender = _data["gender"];
            this.maritalStatus = _data["maritalStatus"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["emailAddress"])) {
                this.emailAddress = [] as any;
                for (let item of _data["emailAddress"])
                    this.emailAddress!.push(item);
            }
            this.getPhonesListString = _data["getPhonesListString"];
            this.title = _data["title"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.addressComments = _data["addressComments"];
            this.mailbox = _data["mailbox"];
            this.postalCode = _data["postalCode"];
            this.comment = _data["comment"];
            this.driverLicenseNumber = _data["driverLicenseNumber"];
            this.driverLicenseType = _data["driverLicenseType"];
            this.driverLicensIssueDate = _data["driverLicensIssueDate"];
            this.workplace = _data["workplace"];
            this.jobTitle = _data["jobTitle"];
            this.workerNumber = _data["workerNumber"];
            this.profession = _data["profession"];
            this.referrer = _data["referrer"];
            this.websiteUrl = _data["websiteUrl"];
            this.facebookUrl = _data["facebookUrl"];
            this.clinic = _data["clinic"];
            this.customerRemarks = _data["customerRemarks"];
            if (Array.isArray(_data["customerAddresses"])) {
                this.customerAddresses = [] as any;
                for (let item of _data["customerAddresses"])
                    this.customerAddresses!.push(item);
            }
            if (Array.isArray(_data["customerContactDetails"])) {
                this.customerContactDetails = [] as any;
                for (let item of _data["customerContactDetails"])
                    this.customerContactDetails!.push(item);
            }
        }
    }

    static fromJS(data: any): PersonalData {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["identityIssueDate"] = this.identityIssueDate;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["gender"] = this.gender;
        data["maritalStatus"] = this.maritalStatus;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.emailAddress)) {
            data["emailAddress"] = [];
            for (let item of this.emailAddress)
                data["emailAddress"].push(item);
        }
        data["getPhonesListString"] = this.getPhonesListString;
        data["title"] = this.title;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["addressComments"] = this.addressComments;
        data["mailbox"] = this.mailbox;
        data["postalCode"] = this.postalCode;
        data["comment"] = this.comment;
        data["driverLicenseNumber"] = this.driverLicenseNumber;
        data["driverLicenseType"] = this.driverLicenseType;
        data["driverLicensIssueDate"] = this.driverLicensIssueDate;
        data["workplace"] = this.workplace;
        data["jobTitle"] = this.jobTitle;
        data["workerNumber"] = this.workerNumber;
        data["profession"] = this.profession;
        data["referrer"] = this.referrer;
        data["websiteUrl"] = this.websiteUrl;
        data["facebookUrl"] = this.facebookUrl;
        data["clinic"] = this.clinic;
        data["customerRemarks"] = this.customerRemarks;
        if (Array.isArray(this.customerAddresses)) {
            data["customerAddresses"] = [];
            for (let item of this.customerAddresses)
                data["customerAddresses"].push(item);
        }
        if (Array.isArray(this.customerContactDetails)) {
            data["customerContactDetails"] = [];
            for (let item of this.customerContactDetails)
                data["customerContactDetails"].push(item);
        }
        return data;
    }
}

export interface IPersonalData {
    id?: string | undefined;
    identifier?: string | undefined;
    identityIssueDate?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: string | undefined;
    maritalStatus?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string[] | undefined;
    getPhonesListString?: string | undefined;
    title?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    addressComments?: string | undefined;
    mailbox?: string | undefined;
    postalCode?: string | undefined;
    comment?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicenseType?: string | undefined;
    driverLicensIssueDate?: string | undefined;
    workplace?: string | undefined;
    jobTitle?: string | undefined;
    workerNumber?: string | undefined;
    profession?: string | undefined;
    referrer?: string | undefined;
    websiteUrl?: string | undefined;
    facebookUrl?: string | undefined;
    clinic?: string | undefined;
    customerRemarks?: string | undefined;
    customerAddresses?: string[] | undefined;
    customerContactDetails?: string[] | undefined;
}

/** 0 = Phone, 1 = Fax */
export enum PhoneType {
    _0 = 0,
    _1 = 1,
}

export class Policy implements IPolicy {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    policyNumber?: string | undefined;
    additionNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    extensionStartDate?: Date;
    extensionEndDate?: Date;
    mandatoryCertificateNumber?: number;
    status?: ActivityStatus;
    insuranceCompanyId?: string | undefined;
    insuranceCompany?: InsuranceCompany;
    agentDetails?: AgentDetails;
    agentDetailsId?: string | undefined;
    agentId?: string | undefined;
    agent?: Agent;
    salespersonId?: string | undefined;
    salesperson?: User;
    customerId?: string;
    customer?: Customer;
    policyTypeId?: string | undefined;
    policyType?: PolicyType;
    comments?: string | undefined;
    insuranceTypeId?: string | undefined;
    insuranceType?: InsuranceType;
    userId?: string | undefined;
    user?: User;
    treatments?: Treatment[] | undefined;
    renewalLeadId?: string | undefined;
    renewalLead?: Lead;

    constructor(data?: IPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.policyNumber = _data["policyNumber"];
            this.additionNumber = _data["additionNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.extensionStartDate = _data["extensionStartDate"] ? new Date(_data["extensionStartDate"].toString()) : <any>undefined;
            this.extensionEndDate = _data["extensionEndDate"] ? new Date(_data["extensionEndDate"].toString()) : <any>undefined;
            this.mandatoryCertificateNumber = _data["mandatoryCertificateNumber"];
            this.status = _data["status"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.agentDetails = _data["agentDetails"] ? AgentDetails.fromJS(_data["agentDetails"]) : <any>undefined;
            this.agentDetailsId = _data["agentDetailsId"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : <any>undefined;
            this.salespersonId = _data["salespersonId"];
            this.salesperson = _data["salesperson"] ? User.fromJS(_data["salesperson"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.policyTypeId = _data["policyTypeId"];
            this.policyType = _data["policyType"] ? PolicyType.fromJS(_data["policyType"]) : <any>undefined;
            this.comments = _data["comments"];
            this.insuranceTypeId = _data["insuranceTypeId"];
            this.insuranceType = _data["insuranceType"] ? InsuranceType.fromJS(_data["insuranceType"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(Treatment.fromJS(item));
            }
            this.renewalLeadId = _data["renewalLeadId"];
            this.renewalLead = _data["renewalLead"] ? Lead.fromJS(_data["renewalLead"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Policy {
        data = typeof data === 'object' ? data : {};
        let result = new Policy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["policyNumber"] = this.policyNumber;
        data["additionNumber"] = this.additionNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["extensionStartDate"] = this.extensionStartDate ? this.extensionStartDate.toISOString() : <any>undefined;
        data["extensionEndDate"] = this.extensionEndDate ? this.extensionEndDate.toISOString() : <any>undefined;
        data["mandatoryCertificateNumber"] = this.mandatoryCertificateNumber;
        data["status"] = this.status;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["agentDetails"] = this.agentDetails ? this.agentDetails.toJSON() : <any>undefined;
        data["agentDetailsId"] = this.agentDetailsId;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["salespersonId"] = this.salespersonId;
        data["salesperson"] = this.salesperson ? this.salesperson.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["policyTypeId"] = this.policyTypeId;
        data["policyType"] = this.policyType ? this.policyType.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        data["insuranceTypeId"] = this.insuranceTypeId;
        data["insuranceType"] = this.insuranceType ? this.insuranceType.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        data["renewalLeadId"] = this.renewalLeadId;
        data["renewalLead"] = this.renewalLead ? this.renewalLead.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPolicy {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    policyNumber?: string | undefined;
    additionNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    extensionStartDate?: Date;
    extensionEndDate?: Date;
    mandatoryCertificateNumber?: number;
    status?: ActivityStatus;
    insuranceCompanyId?: string | undefined;
    insuranceCompany?: InsuranceCompany;
    agentDetails?: AgentDetails;
    agentDetailsId?: string | undefined;
    agentId?: string | undefined;
    agent?: Agent;
    salespersonId?: string | undefined;
    salesperson?: User;
    customerId?: string;
    customer?: Customer;
    policyTypeId?: string | undefined;
    policyType?: PolicyType;
    comments?: string | undefined;
    insuranceTypeId?: string | undefined;
    insuranceType?: InsuranceType;
    userId?: string | undefined;
    user?: User;
    treatments?: Treatment[] | undefined;
    renewalLeadId?: string | undefined;
    renewalLead?: Lead;
}

export class PolicyBaseModel implements IPolicyBaseModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    route?: InsuranceCompanyRouteModel;
    vehicle?: Vehicle;
    premiumSum?: number;
    eventType?: EventType;
    driversType?: AuthorizedToDrive;
    numberOfPayments?: number;
    agentNumber?: string | undefined;
    vehiclePolicyType?: number;
    eventDate?: Date;
    apartmentPolicyType?: ApartmentPolicyType;
    coverType?: any;
    structure?: string;
    earthquakeStructure?: boolean;
    structureSize?: number;
    content?: string;
    earthquakeContent?: boolean;
    jewelry?: string;
    coveragePercentageType?: CoveragePercentageType;
    coveragePercentageDate?: Date;
    reviewerName?: string;
    condominium?: boolean;
    lien?: boolean;
    floor?: number;
    numberOfFloors: number = 0;
    bankAccountNumber?: string | undefined;
    bankNumber?: string | undefined;
    bankBranchNumber?: string | undefined;
    thirdParty?: boolean;
    employersLiability?: boolean;
    orderPlumberType?: OrderPlumberType;
    electricalAppliancesFixes?: boolean;
    roadServicesProvider?: ServicesProvider;
    passedInsuranceTypeLastYear?: PassedTypeOfInsurance
    passedInsuranceType2YearsAgo?: PassedTypeOfInsurance
    passedInsuranceType3YearsAgo?: PassedTypeOfInsurance
    yearLastYear?: number;
    year2YearsAgo?: number;
    year3YearsAgo?: number;
    lastCompanyId?: string;
    // youngDriverCustomer?: CustomerModel;
    // mainDriverCustomer?: CustomerModel;
    protection?: number;
    address?: string;
    distributor?: string;
    creatorUserId?: string;
    policyId?: string;
    autodirection?: boolean;
    newForOld?: boolean;

    addition1?: number;
    addition2?: number;
    addition3?: number;
    additionalDetails?: string | undefined;
    agentFeePercent?: number;
    agentFeeSum?: number;
    agentNumber2?: string | undefined;
    agentNumber2_DiscountPercent?: number;
    agentNumber2_Fee1?: number;
    agentNumber2_Fee2?: number;
    agentNumber2_Fee3?: number;
    bankAccountOwner?: string | undefined;
    bidDate?: Date;
    bidNumber?: string | undefined;
    bodyClaimsAmount?: number;
    bordroDate?: Date;
    branchName?: string | undefined;
    branchNumber?: string | undefined;
    businessEmployersLiability?: string;
    amountsAndFees?: AmountAndFeeModel[] | undefined;
    businessName?: string | undefined;
    businessThirdParty?: string;
    ccIdentifier?: string | undefined;
    ccNumber?: string | undefined;
    ccType?: string | undefined;
    ccValidityDate?: Date;
    checkbox1?: boolean;
    checkbox2?: boolean;
    checkbox3?: boolean;
    city?: string | undefined;
    collectionCurrencyType?: string | undefined;
    collectionDay?: number;
    collectionLinkageType?: string;
    collectionMethodType?: string;
    collectionRoute?: string
    collectionStep?: boolean;
    collectiveId?: number;
    collectiveNumber?: number;
    comment?: string | undefined;
    comments?: string | undefined;
    commission?: number;
    commitmentNumber?: string | undefined;
    createdDate?: Date;
    creditFees?: number;
    currencyTypeInsuranceAmount?: string | undefined;
    creatorUser?: string | undefined;
    dailyPremium?: number;
    days?: number;
    daysSum?: string;
    deductible?: number;
    departmentNumber?: number;
    discountPercent?: number;
    documentsStep?: boolean;
    dollarPremium?: number;
    dollarRate?: number;
    draftNumber?: number;
    drivingOnShabbat?: boolean;
    earthquake?: boolean;
    elementaryPolicy?: ElementaryPolicyModel;
    elementaryPolicyId?: string | undefined;
    elementaryPolicyDocuments?: string[] | undefined;
    elementaryPolicyStatus?: any;
    elementaryPolicyStatusId?: string | undefined;
    email?: string | undefined;
    endDate?: Date;
    extraPremium1?: number;
    extraPremium2?: number;
    fee1?: number;
    fee2?: number;
    fee3?: number;
    feeDollar?: number;
    feePercent?: number;
    fileAttachments?: string[] | undefined;
    firstCollectionDate?: Date;
    foreignWorker?: any;
    foreignWorkerCountry?: string | undefined;
    foreignWorkerEntryToIsraelDate?: Date;
    foreignWorkerFirstName?: string | undefined;
    foreignWorkerGender?: number;
    foreignWorkerInsuredNumber?: string | undefined;
    foreignWorkerLastName?: string | undefined;
    foreignWorkerMobile?: string | undefined;
    foreignWorkerPassportExpirationDate?: Date;
    foreignWorkerPassportNumber?: string | undefined;
    foreignWorkersServiceProviderType?: number;
    fullName?: string | undefined;
    goodsInTransit?: string | undefined;
    identifier?: string | undefined;
    indexRate?: number;
    insuranceCompanyId1?: string | undefined;
    insuranceCompanyId2?: string | undefined;
    insuranceCompanyId3?: string | undefined;
    insuranceCompanyId4?: string | undefined;
    involvedAddress?: string | undefined;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedPartyType?: InvolvedPartyType;
    isVehicleEnslaved?: boolean;
    lackOfClaimsStep?: boolean;
    lastCompany?: EmployerModel;
    lastPolicyNumber?: string | undefined;
    levyFee?: number;
    linkageTypeInsuranceAmount?: number;
    //mainDriverCustomerId?: string | undefined;
    mobile?: string | undefined;
    netPremium?: number;
    netPremium2?: number;
    netPremium3?: number;
    noInsurance?: boolean;
    noveltyType?: NoveltyType;
    noveltyTypeId?: string | undefined;
    ownerIsMainDriver?: boolean;
    passedInsuranceType4YearsAgo?: PassedTypeOfInsurance;
    paymentMethodType?: PaymentMethodType;
    phone?: string | undefined;
    policyBranches?: PolicyBranchModel[] | undefined;
    policyFees?: number;
    policyNumber?: string | undefined;
    postalCode?: string | undefined;
    premiumBalance?: number;
    premiumPaid?: number;
    productionMode?: number;
    productionStep?: boolean;
    professionalLiabilityType?: ProfessionalLiabilityType;
    protectionStep?: boolean;


    referrerName?: string | undefined;
    registrationFees?: number;
    relation?: string | undefined;
    revocationsAmount?: number;
    rider?: RiderModel;
    riderId?: string | undefined;
    riderPackages?: RiderPackageModel[] | undefined;
    routeComment?: string | undefined;
    routeId?: string | undefined;
    sendingToCustomerStep?: boolean;
    seniority?: number;
    shekelPremium?: number;
    shielding?: string;
    stampsFee?: number;
    street?: string | undefined;
    sueNumber1?: number;
    sueNumber2?: number;
    sueNumber3?: number;
    sueNumber4?: number;
    surveyDate?: Date;
    temsAndCovers?: string | undefined;
    text?: string | undefined;
    treatmentFee?: number;
    treatments?: TreatmentModel[] | undefined;
    underwriterUser?: User;
    underwriterUserId?: string | undefined;
    updatedDate?: Date;
    vehicleId?: string | undefined;
    windshieldServicesProvider?: ServicesProvider;
    year4YearsAgo?: number;
    years2YearsAgo?: number;
    years3YearsAgo?: number;
    years4YearsAgo?: number;
    yearsLastYear?: number;
    //youngDriverCustomerId?: string | undefined;
    yungestDriverAge?: number;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverYoungIdentifier?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungLastName?: string | undefined;
    driverYoungFirstName?: string | undefined;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainIdentifier?: string | undefined;
    driverMainGender?: Gender;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainLastName?: string | undefined;
    driverMainFirstName?: string | undefined;
    paymentDetails?: string[];



    constructor(data?: IPolicyBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            this.route = _data["route"] ? InsuranceCompanyRouteModel.fromJS(_data["route"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.premiumSum = _data["premiumSum"];
            this.eventType = _data["eventType"];
            this.driversType = _data["driversType"];
            this.numberOfPayments = _data["numberOfPayments"];
            this.agentNumber = _data["agentNumber"];
            this.vehiclePolicyType = _data["vehiclePolicyType"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.apartmentPolicyType = _data["apartmentPolicyType"];
            this.coverType = _data["coverType"];
            this.structure = _data["structure"];
            this.earthquakeStructure = _data["earthquakeStructure"];
            this.structureSize = _data["structureSize"];
            this.content = _data["content"];
            this.earthquakeContent = _data["earthquakeContent"];
            this.jewelry = _data["jewelry"];
            this.coveragePercentageType = _data["coveragePercentageType"];
            this.coveragePercentageDate = _data["coveragePercentageDate"] ? new Date(_data["coveragePercentageDate"].toString()) : <any>undefined;
            this.reviewerName = _data["reviewerName"];
            this.thirdParty = _data["thirdParty"];
            this.employersLiability = _data["employersLiability"];
            this.orderPlumberType = _data["orderPlumberType"];
            this.electricalAppliancesFixes = _data["electricalAppliancesFixes"];
            this.condominium = _data["condominium"];
            this.lien = _data["lien"];
            this.floor = _data["floor"];
            this.numberOfFloors = _data["numberOfFloors"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankNumber = _data["bankNumber"];
            this.bankBranchNumber = _data["bankBranchNumber"];
            this.roadServicesProvider = _data["roadServicesProvider"];
            this.passedInsuranceTypeLastYear = _data["passedInsuranceTypeLastYear"];
            this.passedInsuranceType2YearsAgo = _data["passedInsuranceType2YearsAgo"];
            this.passedInsuranceType3YearsAgo = _data["passedInsuranceType3YearsAgo"];
            this.yearLastYear = _data["yearLastYear"];
            this.year2YearsAgo = _data["year2YearsAgo"];
            this.year3YearsAgo = _data["year3YearsAgo"];
            this.lastCompanyId = _data["lastCompanyId"];
            // this.youngDriverCustomer = _data["youngDriverCustomer"] ? CustomerModel.fromJS(_data["youngDriverCustomer"]) : <any>undefined;
            // this.mainDriverCustomer = _data["mainDriverCustomer"] ? CustomerModel.fromJS(_data["mainDriverCustomer"]) : <any>undefined; // new Customer();

            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverYoungIdentifier = _data["driverYoungIdentifier"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungLastName = _data["driverYoungLastName"];
            this.driverYoungFirstName = _data["driverYoungFirstName"];

            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.driverMainIdentifier = _data["driverMainIdentifier"];
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.driverMainLastName = _data["driverMainLastName"];
            this.driverMainFirstName = _data["driverMainFirstName"];




            this.protection = _data["protection"];
            this.address = _data["address"];
            this.distributor = _data["distributor"];
            this.creatorUserId = _data["creatorUserId"];
            this.policyId = _data["policyId"];
            this.autodirection = _data["autodirection"];
            this.newForOld = _data["newForOld"];

            this.addition1 = _data["addition1"];
            this.addition2 = _data["addition2"];
            this.addition3 = _data["addition3"];
            this.additionalDetails = _data["additionalDetails"];
            this.agentFeePercent = _data["agentFeePercent"];
            this.agentFeeSum = _data["agentFeeSum"];
            this.agentNumber2 = _data["agentNumber2"];
            this.agentNumber2_DiscountPercent = _data["agentNumber2_DiscountPercent"];
            this.agentNumber2_Fee1 = _data["agentNumber2_Fee1"];
            this.agentNumber2_Fee2 = _data["agentNumber2_Fee2"];
            this.agentNumber2_Fee3 = _data["agentNumber2_Fee3"];
            this.bankAccountOwner = _data["bankAccountOwner"];
            this.bidDate = _data["bidDate"] ? new Date(_data["bidDate"].toString()) : <any>undefined;
            this.bidNumber = _data["bidNumber"];
            this.bodyClaimsAmount = _data["bodyClaimsAmount"];
            this.bordroDate = _data["bordroDate"] ? new Date(_data["bordroDate"].toString()) : <any>undefined;
            this.branchName = _data["branchName"];
            this.branchNumber = _data["branchNumber"];
            this.businessEmployersLiability = _data["businessEmployersLiability"];
            if (Array.isArray(_data["amountsAndFees"])) {
                this.amountsAndFees = [] as any;
                for (let item of _data["amountsAndFees"])
                    this.amountsAndFees!.push(AmountAndFeeModel.fromJS(item));
            }
            this.businessName = _data["businessName"];
            this.businessThirdParty = _data["businessThirdParty"];
            this.ccIdentifier = _data["ccIdentifier"];
            this.ccNumber = _data["ccNumber"];
            this.ccType = _data["ccType"];
            this.ccValidityDate = _data["ccValidityDate"] ? new Date(_data["ccValidityDate"].toString()) : <any>undefined;
            this.checkbox1 = _data["checkbox1"];
            this.checkbox2 = _data["checkbox2"];
            this.checkbox3 = _data["checkbox3"];
            this.city = _data["city"];
            this.collectionCurrencyType = _data["collectionCurrencyType"];
            this.collectionDay = _data["collectionDay"];
            this.collectionLinkageType = _data["collectionLinkageType"];
            this.collectionMethodType = _data["collectionMethodType"];
            this.collectionRoute = _data["collectionRoute"];
            this.collectionStep = _data["collectionStep"];
            this.collectiveId = _data["collectiveId"];
            this.collectiveNumber = _data["collectiveNumber"];
            this.comment = _data["comment"];
            this.comments = _data["comments"];
            this.commission = _data["commission"];
            this.commitmentNumber = _data["commitmentNumber"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.creditFees = _data["creditFees"];
            this.currencyTypeInsuranceAmount = _data["currencyTypeInsuranceAmount"];
            this.creatorUser = _data["creatorUser"];
            this.dailyPremium = _data["dailyPremium"];
            this.days = _data["days"];
            this.daysSum = _data["daysSum"];
            this.deductible = _data["deductible"];
            this.departmentNumber = _data["departmentNumber"];
            this.discountPercent = _data["discountPercent"];
            this.documentsStep = _data["documentsStep"];
            this.dollarPremium = _data["dollarPremium"];
            this.dollarRate = _data["dollarRate"];
            this.draftNumber = _data["draftNumber"];
            this.drivingOnShabbat = _data["drivingOnShabbat"];
            this.earthquake = _data["earthquake"];
            this.elementaryPolicy = _data["elementaryPolicy"] ? ElementaryPolicyModel.fromJS(_data["elementaryPolicy"]) : <any>undefined;
            this.elementaryPolicyId = _data["elementaryPolicyId"];
            if (Array.isArray(_data["elementaryPolicyDocuments"])) {
                this.elementaryPolicyDocuments = [] as any;
                for (let item of _data["elementaryPolicyDocuments"])
                    this.elementaryPolicyDocuments!.push(item);
            }
            this.elementaryPolicyStatus = _data["elementaryPolicyStatus"];
            this.elementaryPolicyStatusId = _data["elementaryPolicyStatusId"];
            this.email = _data["email"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.extraPremium1 = _data["extraPremium1"];
            this.extraPremium2 = _data["extraPremium2"];
            this.fee1 = _data["fee1"];
            this.fee2 = _data["fee2"];
            this.fee3 = _data["fee3"];
            this.feeDollar = _data["feeDollar"];
            this.feePercent = _data["feePercent"];
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments!.push(item);
            }
            this.firstCollectionDate = _data["firstCollectionDate"] ? new Date(_data["firstCollectionDate"].toString()) : <any>undefined;
            this.foreignWorker = _data["foreignWorker"];
            this.foreignWorkerCountry = _data["foreignWorkerCountry"];
            this.foreignWorkerEntryToIsraelDate = _data["foreignWorkerEntryToIsraelDate"] ? new Date(_data["foreignWorkerEntryToIsraelDate"].toString()) : <any>undefined;
            this.foreignWorkerFirstName = _data["foreignWorkerFirstName"];
            this.foreignWorkerGender = _data["foreignWorkerGender"];
            this.foreignWorkerInsuredNumber = _data["foreignWorkerInsuredNumber"];
            this.foreignWorkerLastName = _data["foreignWorkerLastName"];
            this.foreignWorkerMobile = _data["foreignWorkerMobile"];
            this.foreignWorkerPassportExpirationDate = _data["foreignWorkerPassportExpirationDate"] ? new Date(_data["foreignWorkerPassportExpirationDate"].toString()) : <any>undefined;
            this.foreignWorkerPassportNumber = _data["foreignWorkerPassportNumber"];
            this.foreignWorkersServiceProviderType = _data["foreignWorkersServiceProviderType"];
            this.fullName = _data["fullName"];
            this.goodsInTransit = _data["goodsInTransit"];
            this.identifier = _data["identifier"];
            this.indexRate = _data["indexRate"];
            this.insuranceCompanyId1 = _data["insuranceCompanyId1"];
            this.insuranceCompanyId2 = _data["insuranceCompanyId2"];
            this.insuranceCompanyId3 = _data["insuranceCompanyId3"];
            this.insuranceCompanyId4 = _data["insuranceCompanyId4"];
            this.involvedAddress = _data["involvedAddress"];
            this.involvedBank = _data["involvedBank"];
            this.involvedBankBranch = _data["involvedBankBranch"];
            this.involvedName = _data["involvedName"];
            this.involvedPartyType = _data["involvedPartyType"];
            this.isVehicleEnslaved = _data["isVehicleEnslaved"];
            this.lackOfClaimsStep = _data["lackOfClaimsStep"];
            this.lastCompany = _data["lastCompany"] ? EmployerModel.fromJS(_data[" lastCompany"]) : <any>undefined;
            this.lastPolicyNumber = _data["lastPolicyNumber"];
            this.levyFee = _data["levyFee"];
            this.linkageTypeInsuranceAmount = _data["linkageTypeInsuranceAmount"];
            //this.mainDriverCustomerId = _data["mainDriverCustomerId"];
            this.mobile = _data["mobile"];
            this.netPremium = _data["netPremium"];
            this.netPremium2 = _data["netPremium2"];
            this.netPremium3 = _data["netPremium3"];
            this.noInsurance = _data["noInsurance"];
            this.noveltyType = _data["noveltyType"];
            this.noveltyTypeId = _data["noveltyTypeId"];
            this.ownerIsMainDriver = _data["ownerIsMainDriver"];
            this.passedInsuranceType4YearsAgo = _data["passedInsuranceType4YearsAgo"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["policyBranches"])) {
                this.policyBranches = [] as any;
                for (let item of _data["policyBranches"])
                    this.policyBranches!.push(PolicyBranchModel.fromJS(item));
            }
            this.policyFees = _data["policyFees"];
            this.policyNumber = _data["policyNumber"];
            this.postalCode = _data["postalCode"];
            this.premiumBalance = _data["premiumBalance"];
            this.premiumPaid = _data["premiumPaid"];
            this.productionMode = _data["productionMode"];
            this.productionStep = _data["productionStep"];
            this.professionalLiabilityType = _data["professionalLiabilityType"];
            this.protectionStep = _data["protectionStep"];
            this.referrerName = _data["referrerName"];
            this.registrationFees = _data["registrationFees"];
            this.relation = _data["relation"];
            this.revocationsAmount = _data["revocationsAmount"];
            this.rider = _data["rider"] ? RiderModel.fromJS(_data["rider"]) : <any>undefined;
            this.riderId = _data["riderId"];
            if (Array.isArray(_data["riderPackages"])) {
                this.riderPackages = [] as any;
                for (let item of _data["riderPackages"])
                    this.riderPackages!.push(RiderPackageModel.fromJS(item));
            }
            this.routeComment = _data["routeComment"];
            this.routeId = _data["routeId"];
            this.sendingToCustomerStep = _data["sendingToCustomerStep"];
            this.seniority = _data["seniority"];
            this.shekelPremium = _data["shekelPremium"];
            this.shielding = _data["shielding"];
            this.stampsFee = _data["stampsFee"];
            this.street = _data["street"];
            this.sueNumber1 = _data["sueNumber1"];
            this.sueNumber2 = _data["sueNumber2"];
            this.sueNumber3 = _data["sueNumber3"];
            this.sueNumber4 = _data["sueNumber4"];
            this.surveyDate = _data["surveyDate"] ? new Date(_data["surveyDate"].toString()) : <any>undefined;
            this.temsAndCovers = _data["temsAndCovers"];
            this.text = _data["text"];
            this.treatmentFee = _data["treatmentFee"];
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(TreatmentModel.fromJS(item));
            }
            this.underwriterUser = _data["underwriterUser"] ? User.fromJS(_data["underwriterUser"]) : <any>undefined;
            this.underwriterUserId = _data["underwriterUserId"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.windshieldServicesProvider = _data["windshieldServicesProvider"];
            this.year4YearsAgo = _data["year4YearsAgo"];
            this.years2YearsAgo = _data["years2YearsAgo"];
            this.years3YearsAgo = _data["years3YearsAgo"];
            this.years4YearsAgo = _data["years4YearsAgo"];
            this.yearsLastYear = _data["yearsLastYear"];
            //this.youngDriverCustomerId = _data["youngDriverCustomerId"];
            this.yungestDriverAge = _data["yungestDriverAge"];
            this.paymentDetails = _data["paymentDetails"];


            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agentDetailsList"])) {
                this.agentDetailsList = [] as any;
                for (let item of _data["agentDetailsList"])
                    this.agentDetailsList!.push(AgentDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["salespersons"])) {
                this.salespersons = [] as any;
                for (let item of _data["salespersons"])
                    this.salespersons!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(SelectListItem.fromJS(item));
            }

        }
    }

    static fromJS(data: any): PolicyBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["premiumSum"] = this.premiumSum;
        data["eventType"] = this.eventType;
        data["driversType"] = this.driversType;
        data["numberOfPayments"] = this.numberOfPayments;
        data["agentNumber"] = this.agentNumber;
        data["vehiclePolicyType"] = this.vehiclePolicyType;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["apartmentPolicyType"] = this.apartmentPolicyType;
        data["coverType"] = this.coverType;
        data["structure"] = this.structure;
        data["earthquakeStructure"] = this.earthquakeStructure;
        data["structureSize"] = this.structureSize;
        data["content"] = this.content;
        data["earthquakeContent"] = this.earthquakeContent;
        data["jewelry"] = this.jewelry;
        data["coveragePercentageType"] = this.coveragePercentageType;
        data["coveragePercentageDate"] = this.coveragePercentageDate ? this.coveragePercentageDate.toISOString() : <any>undefined;
        data["reviewerName"] = this.reviewerName;
        data["thirdParty"] = this.thirdParty;
        data["employersLiability"] = this.employersLiability;
        data["orderPlumberType"] = this.orderPlumberType;
        data["electricalAppliancesFixes"] = this.electricalAppliancesFixes;
        data["condominium"] = this.condominium;
        data["lien"] = this.lien;
        data["floor"] = this.floor;
        data["numberOfFloors"] = this.numberOfFloors;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankNumber"] = this.bankNumber;
        data["bankBranchNumber"] = this.bankBranchNumber;
        data["roadServicesProvider"] = this.roadServicesProvider;
        data["passedInsuranceTypeLastYear"] = this.passedInsuranceTypeLastYear;
        data["passedInsuranceType2YearsAgo"] = this.passedInsuranceType2YearsAgo;
        data["passedInsuranceType3YearsAgo"] = this.passedInsuranceType3YearsAgo;
        data["yearLastYear"] = this.yearLastYear;
        data["year2YearsAgo"] = this.year2YearsAgo;
        data["year3YearsAgo"] = this.year3YearsAgo;
        data["lastCompanyId"] = this.lastCompanyId;
        // data["youngDriverCustomer"] = this.youngDriverCustomer ? this.youngDriverCustomer.toJSON() : <any>undefined;
        // data["mainDriverCustomer"] = this.mainDriverCustomer ? this.mainDriverCustomer.toJSON() : <any>undefined;


        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverYoungIdentifier"] = this.driverYoungIdentifier;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungLastName"] = this.driverYoungLastName;
        data["driverYoungFirstName"] = this.driverYoungFirstName;

        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["driverMainIdentifier"] = this.driverMainIdentifier;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["driverMainLastName"] = this.driverMainLastName;
        data["driverMainFirstName"] = this.driverMainFirstName;


        data["protection"] = this.protection;
        data["address"] = this.address;
        data["distributor"] = this.distributor;
        data["creatorUserId"] = this.creatorUserId;
        data["policyId"] = this.policyId;
        data["autodirection"] = this.autodirection;
        data["newForOld"] = this.newForOld;
        data["addition1"] = this.addition1;
        data["addition2"] = this.addition2;
        data["addition3"] = this.addition3;
        data["additionalDetails"] = this.additionalDetails;
        data["agentFeePercent"] = this.agentFeePercent;
        data["agentFeeSum"] = this.agentFeeSum;
        data["agentNumber2"] = this.agentNumber2;
        data["agentNumber2_DiscountPercent"] = this.agentNumber2_DiscountPercent;
        data["agentNumber2_Fee1"] = this.agentNumber2_Fee1;
        data["agentNumber2_Fee2"] = this.agentNumber2_Fee2;
        data["agentNumber2_Fee3"] = this.agentNumber2_Fee3;
        data["bankAccountOwner"] = this.bankAccountOwner;
        data["bidDate"] = this.bidDate ? this.bidDate.toISOString() : <any>undefined;
        data["bidNumber"] = this.bidNumber;
        data["bodyClaimsAmount"] = this.bodyClaimsAmount;
        data["bordroDate"] = this.bordroDate ? this.bordroDate.toISOString() : <any>undefined;
        data["branchName"] = this.branchName;
        data["branchNumber"] = this.branchNumber;
        data["businessEmployersLiability"] = this.businessEmployersLiability;
        if (Array.isArray(this.amountsAndFees)) {
            data["amountsAndFees"] = [];
            for (let item of this.amountsAndFees)
                data["amountsAndFees"].push(item.toJSON());
        }
        data["businessName"] = this.businessName;
        data["businessThirdParty"] = this.businessThirdParty;
        data["ccIdentifier"] = this.ccIdentifier;
        data["ccNumber"] = this.ccNumber;
        data["ccType"] = this.ccType;
        data["ccValidityDate"] = this.ccValidityDate ? this.ccValidityDate.toISOString() : <any>undefined;
        data["checkbox1"] = this.checkbox1;
        data["checkbox2"] = this.checkbox2;
        data["checkbox3"] = this.checkbox3;
        data["city"] = this.city;
        data["collectionCurrencyType"] = this.collectionCurrencyType;
        data["collectionDay"] = this.collectionDay;
        data["collectionLinkageType"] = this.collectionLinkageType;
        data["collectionMethodType"] = this.collectionMethodType;
        data["collectionRoute"] = this.collectionRoute;
        data["collectionStep"] = this.collectionStep;
        data["collectiveId"] = this.collectiveId;
        data["collectiveNumber"] = this.collectiveNumber;
        data["comment"] = this.comment;
        data["comments"] = this.comments;
        data["commission"] = this.commission;
        data["commitmentNumber"] = this.commitmentNumber;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["creditFees"] = this.creditFees;
        data["currencyTypeInsuranceAmount"] = this.currencyTypeInsuranceAmount;
        data["creatorUser"] = this.creatorUser;
        data["dailyPremium"] = this.dailyPremium;
        data["days"] = this.days;
        data["daysSum"] = this.daysSum;
        data["deductible"] = this.deductible;
        data["departmentNumber"] = this.departmentNumber;
        data["discountPercent"] = this.discountPercent;
        data["documentsStep"] = this.documentsStep;
        data["dollarPremium"] = this.dollarPremium;
        data["dollarRate"] = this.dollarRate;
        data["draftNumber"] = this.draftNumber;
        data["drivingOnShabbat"] = this.drivingOnShabbat;
        data["earthquake"] = this.earthquake;
        data["elementaryPolicy"] = this.elementaryPolicy ? this.elementaryPolicy.toJSON() : <any>undefined;
        data["elementaryPolicyId"] = this.elementaryPolicyId;
        if (Array.isArray(this.elementaryPolicyDocuments)) {
            data["elementaryPolicyDocuments"] = [];
            for (let item of this.elementaryPolicyDocuments)
                data["elementaryPolicyDocuments"].push(item);
        }
        data["elementaryPolicyStatus"] = this.elementaryPolicyStatus;
        data["elementaryPolicyStatusId"] = this.elementaryPolicyStatusId;
        data["email"] = this.email;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["extraPremium1"] = this.extraPremium1;
        data["extraPremium2"] = this.extraPremium2;
        data["fee1"] = this.fee1;
        data["fee2"] = this.fee2;
        data["fee3"] = this.fee3;
        data["feeDollar"] = this.feeDollar;
        data["feePercent"] = this.feePercent;
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item);
        }
        data["firstCollectionDate"] = this.firstCollectionDate ? this.firstCollectionDate.toISOString() : <any>undefined;
        data["foreignWorker"] = this.foreignWorker;
        data["foreignWorkerCountry"] = this.foreignWorkerCountry;
        data["foreignWorkerEntryToIsraelDate"] = this.foreignWorkerEntryToIsraelDate ? this.foreignWorkerEntryToIsraelDate.toISOString() : <any>undefined;
        data["foreignWorkerFirstName"] = this.foreignWorkerFirstName;
        data["foreignWorkerGender"] = this.foreignWorkerGender;
        data["foreignWorkerInsuredNumber"] = this.foreignWorkerInsuredNumber;
        data["foreignWorkerLastName"] = this.foreignWorkerLastName;
        data["foreignWorkerMobile"] = this.foreignWorkerMobile;
        data["foreignWorkerPassportExpirationDate"] = this.foreignWorkerPassportExpirationDate ? this.foreignWorkerPassportExpirationDate.toISOString() : <any>undefined;
        data["foreignWorkerPassportNumber"] = this.foreignWorkerPassportNumber;
        data["foreignWorkersServiceProviderType"] = this.foreignWorkersServiceProviderType;
        data["fullName"] = this.fullName;
        data["goodsInTransit"] = this.goodsInTransit;
        data["identifier"] = this.identifier;
        data["indexRate"] = this.indexRate;
        data["insuranceCompanyId1"] = this.insuranceCompanyId1;
        data["insuranceCompanyId2"] = this.insuranceCompanyId2;
        data["insuranceCompanyId3"] = this.insuranceCompanyId3;
        data["insuranceCompanyId4"] = this.insuranceCompanyId4;
        data["involvedAddress"] = this.involvedAddress;
        data["involvedBank"] = this.involvedBank;
        data["involvedBankBranch"] = this.involvedBankBranch;
        data["involvedName"] = this.involvedName;
        data["involvedPartyType"] = this.involvedPartyType;
        data["isVehicleEnslaved"] = this.isVehicleEnslaved;
        data["lackOfClaimsStep"] = this.lackOfClaimsStep;
        data["lastCompany"] = this.lastCompany ? this.lastCompany.toJSON() : <any>undefined;
        data["lastPolicyNumber"] = this.lastPolicyNumber;
        data["levyFee"] = this.levyFee;
        data["linkageTypeInsuranceAmount"] = this.linkageTypeInsuranceAmount;
        //data["mainDriverCustomerId"] = this.mainDriverCustomerId;
        data["mobile"] = this.mobile;
        data["netPremium"] = this.netPremium;
        data["netPremium2"] = this.netPremium2;
        data["netPremium3"] = this.netPremium3;
        data["noInsurance"] = this.noInsurance;
        data["noveltyType"] = this.noveltyType;
        data["noveltyTypeId"] = this.noveltyTypeId;
        data["ownerIsMainDriver"] = this.ownerIsMainDriver;
        data["passedInsuranceType4YearsAgo"] = this.passedInsuranceType4YearsAgo;
        data["paymentMethodType"] = this.paymentMethodType;
        data["phone"] = this.phone;
        if (Array.isArray(this.policyBranches)) {
            data["policyBranches"] = [];
            for (let item of this.policyBranches)
                data["policyBranches"].push(item.toJSON());
        }
        data["policyFees"] = this.policyFees;
        data["policyNumber"] = this.policyNumber;
        data["postalCode"] = this.postalCode;
        data["premiumBalance"] = this.premiumBalance;
        data["premiumPaid"] = this.premiumPaid;
        data["productionMode"] = this.productionMode;
        data["productionStep"] = this.productionStep;
        data["professionalLiabilityType"] = this.professionalLiabilityType;
        data["protectionStep"] = this.protectionStep;
        data["referrerName"] = this.referrerName;
        data["registrationFees"] = this.registrationFees;
        data["relation"] = this.relation;
        data["revocationsAmount"] = this.revocationsAmount;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["riderId"] = this.riderId;
        if (Array.isArray(this.riderPackages)) {
            data["riderPackages"] = [];
            for (let item of this.riderPackages)
                data["riderPackages"].push(item.toJSON());
        }
        data["routeComment"] = this.routeComment;
        data["routeId"] = this.routeId;
        data["sendingToCustomerStep"] = this.sendingToCustomerStep;
        data["seniority"] = this.seniority;
        data["shekelPremium"] = this.shekelPremium;
        data["shielding"] = this.shielding;
        data["stampsFee"] = this.stampsFee;
        data["street"] = this.street;
        data["sueNumber1"] = this.sueNumber1;
        data["sueNumber2"] = this.sueNumber2;
        data["sueNumber3"] = this.sueNumber3;
        data["sueNumber4"] = this.sueNumber4;
        data["surveyDate"] = this.surveyDate ? this.surveyDate.toISOString() : <any>undefined;
        data["temsAndCovers"] = this.temsAndCovers;
        data["text"] = this.text;
        data["treatmentFee"] = this.treatmentFee;
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        data["underwriterUser"] = this.underwriterUser ? this.underwriterUser.toJSON() : <any>undefined;
        data["underwriterUserId"] = this.underwriterUserId;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["windshieldServicesProvider"] = this.windshieldServicesProvider;
        data["year4YearsAgo"] = this.year4YearsAgo;
        data["years2YearsAgo"] = this.years2YearsAgo;
        data["years3YearsAgo"] = this.years3YearsAgo;
        data["years4YearsAgo"] = this.years4YearsAgo;
        data["yearsLastYear"] = this.yearsLastYear;
        //data["youngDriverCustomerId"] = this.youngDriverCustomerId;
        data["yungestDriverAge"] = this.yungestDriverAge;
        data["paymentDetails"] = this.paymentDetails;


        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.agentDetailsList)) {
            data["agentDetailsList"] = [];
            for (let item of this.agentDetailsList)
                data["agentDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.salespersons)) {
            data["salespersons"] = [];
            for (let item of this.salespersons)
                data["salespersons"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPolicyBaseModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
}

export class PolicyBranchModel implements IPolicyBranchModel {
    id?: string;
    number?: number;
    name?: string | undefined;
    insuranceAmount?: number;
    rate?: number;
    annualPremium?: number;
    premiumSum?: number;
    elementaryInsurancePolicyId?: string;

    constructor(data?: IPolicyBranchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.insuranceAmount = _data["insuranceAmount"];
            this.rate = _data["rate"];
            this.annualPremium = _data["annualPremium"];
            this.premiumSum = _data["premiumSum"];
            this.elementaryInsurancePolicyId = _data["elementaryInsurancePolicyId"];
        }
    }

    static fromJS(data: any): PolicyBranchModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyBranchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["name"] = this.name;
        data["insuranceAmount"] = this.insuranceAmount;
        data["rate"] = this.rate;
        data["annualPremium"] = this.annualPremium;
        data["premiumSum"] = this.premiumSum;
        data["elementaryInsurancePolicyId"] = this.elementaryInsurancePolicyId;
        return data;
    }
}

export interface IPolicyBranchModel {
    id?: string;
    number?: number;
    name?: string | undefined;
    insuranceAmount?: number;
    rate?: number;
    annualPremium?: number;
    premiumSum?: number;
    elementaryInsurancePolicyId?: string;
}

export class PolicyFilterModel implements IPolicyFilterModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    page?: number;
    customerId?: string;
    policyTypeId?: number;
    relation?: number;

    constructor(data?: IPolicyFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.page = _data["page"];
            this.customerId = _data["customerId"];
            this.policyTypeId = _data["policyTypeId"];
            this.relation = _data["relation"];
        }
    }

    static fromJS(data: any): PolicyFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["customerId"] = this.customerId;
        data["policyTypeId"] = this.policyTypeId;
        data["relation"] = this.relation;
        return data;
    }
}

export interface IPolicyFilterModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    page?: number;
    customerId?: string;
    policyTypeId?: number;
    relation?: number;
}

export class PolicyModel implements IPolicyModel {
    id?: string;
    policyNumber?: string | undefined;
    additionNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    status?: ActivityStatus;
    insuranceCompany?: InsuranceCompanyModel;
    insuranceCompanyId?: string | undefined;
    agentDetails?: AgentDetailsModel;
    agentDetailsId?: string | undefined;
    agent?: AgentModel;
    agentId?: string | undefined;
    salesperson?: UserModel;
    salespersonId?: string | undefined;
    customer?: CustomerModel;
    customerId?: string;
    policyTypeId?: string | undefined;
    policyType?: PolicyType;
    comments?: string | undefined;
    insuranceType?: InsuranceTypes;
    isAddition?: boolean;
    userId?: string;
    user?: User;
    policyAdditionDetails?: PolicyBaseModel;
    extensionStartDate?: Date;
    extensionEndDate?: Date;
    vehicle?: any;
    creatorUserId?: string;
    editorUserId?: string;
    hasSues?: boolean;
    route?: InsuranceCompanyRouteModel;
    constructor(data?: IPolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policyNumber = _data["policyNumber"];
            this.additionNumber = _data["additionNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.agentDetails = _data["agentDetails"] ? AgentDetailsModel.fromJS(_data["agentDetails"]) : <any>undefined;
            this.agentDetailsId = _data["agentDetailsId"];
            this.agent = _data["agent"] ? AgentModel.fromJS(_data["agent"]) : <any>undefined;
            this.agentId = _data["agentId"];
            this.salesperson = _data["salesperson"] ? UserModel.fromJS(_data["salesperson"]) : <any>undefined;
            this.salespersonId = _data["salespersonId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.policyTypeId = _data["policyTypeId"];
            this.policyType = _data["policyType"] ? PolicyType.fromJS(_data["policyType"]) : <any>undefined;
            this.comments = _data["comments"];
            this.insuranceType = _data["insuranceType"];
            this.isAddition = _data["isAddition"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.policyAdditionDetails = _data["policyAdditionDetails"] ? PolicyBaseModel.fromJS(_data["policyAdditionDetails"]) : <any>undefined;
            this.extensionStartDate = _data["extensionStartDate"] ? new Date(_data["extensionStartDate"].toString()) : <any>undefined;
            this.extensionEndDate = _data["extensionEndDate"] ? new Date(_data["extensionEndDate"].toString()) : <any>undefined;
            this.vehicle = _data["vehicle"];
            this.creatorUserId = _data["creatorUserId"];
            this.editorUserId = _data["editorUserId"];
            this.hasSues = _data["hasSues"];
            this.route = _data["route"] ? InsuranceCompanyRouteModel.fromJS(_data["route"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policyNumber"] = this.policyNumber;
        data["additionNumber"] = this.additionNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["agentDetails"] = this.agentDetails ? this.agentDetails.toJSON() : <any>undefined;
        data["agentDetailsId"] = this.agentDetailsId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        data["salesperson"] = this.salesperson ? this.salesperson.toJSON() : <any>undefined;
        data["salespersonId"] = this.salespersonId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["policyTypeId"] = this.policyTypeId;
        data["policyType"] = this.policyType ? this.policyType.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        data["insuranceType"] = this.insuranceType;
        data["isAddition"] = this.isAddition;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["policyAdditionDetails"] = this.policyAdditionDetails ? this.policyAdditionDetails.toJSON() : <any>undefined;
        data["extensionStartDate"] = this.extensionStartDate ? this.extensionStartDate.toISOString() : <any>undefined;
        data["extensionEndDate"] = this.extensionEndDate ? this.extensionEndDate.toISOString() : <any>undefined;
        data["vehicle"] = this.vehicle;
        data["creatorUserId"] = this.creatorUserId;
        data["editorUserId"] = this.editorUserId;
        data["hasSues"] = this.hasSues;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPolicyModel {
    id?: string;
    policyNumber?: string | undefined;
    additionNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    status?: ActivityStatus;
    insuranceCompany?: InsuranceCompanyModel;
    insuranceCompanyId?: string | undefined;
    agentDetails?: AgentDetailsModel;
    agentDetailsId?: string | undefined;
    agent?: AgentModel;
    agentId?: string | undefined;
    salesperson?: UserModel;
    salespersonId?: string | undefined;
    customer?: CustomerModel;
    customerId?: string;
    policyTypeId?: string | undefined;
    policyType?: PolicyType;
    comments?: string | undefined;
    insuranceType?: InsuranceTypes;
    isAddition?: boolean;
    userId?: string;
    user?: User;
    policyAdditionDetails?: PolicyBaseModel;
    extensionStartDate?: Date;
    extensionEndDate?: Date;
}

export class PolicyTabModel implements IPolicyTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: PolicyModel[] | undefined;
    riders?: RiderModel[] | undefined;
    readonly policyTypeItems?: PolicyTypeItem[] | undefined;
    policyTypes?: SelectListItem[] | undefined;
    subPolicies?: PolicyModel[] | undefined;
    fieldsFilterList?: FieldsFilterListModel;

    constructor(data?: IPolicyTabModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolicyModel.fromJS(item));
            }
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders!.push(RiderModel.fromJS(item));
            }
            if (Array.isArray(_data["policyTypeItems"])) {
                (<any>this).policyTypeItems = [] as any;
                for (let item of _data["policyTypeItems"])
                    (<any>this).policyTypeItems!.push(PolicyTypeItem.fromJS(item));
            }
            if (Array.isArray(_data["policyTypes"])) {
                this.policyTypes = [] as any;
                for (let item of _data["policyTypes"])
                    this.policyTypes!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["subPolicies"])) {
                this.subPolicies = [] as any;
                for (let item of _data["subPolicies"])
                    this.subPolicies!.push(PolicyModel.fromJS(item));
            }
            this.fieldsFilterList = _data["fieldsFilterList"] ? FieldsFilterListModel.fromJS(_data["fieldsFilterList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PolicyTabModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyTabModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }
        if (Array.isArray(this.policyTypeItems)) {
            data["policyTypeItems"] = [];
            for (let item of this.policyTypeItems)
                data["policyTypeItems"].push(item.toJSON());
        }
        if (Array.isArray(this.policyTypes)) {
            data["policyTypes"] = [];
            for (let item of this.policyTypes)
                data["policyTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.subPolicies)) {
            data["subPolicies"] = [];
            for (let item of this.subPolicies)
                data["subPolicies"].push(item.toJSON());
        }
        data["fieldsFilterList"] = this.fieldsFilterList ? this.fieldsFilterList.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPolicyTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: PolicyModel[] | undefined;
    riders?: RiderModel[] | undefined;
    policyTypeItems?: PolicyTypeItem[] | undefined;
    policyTypes?: SelectListItem[] | undefined;
    subPolicies?: PolicyModel[] | undefined;
    fieldsFilterList?: FieldsFilterListModel;
}

export class PolicyType implements IPolicyType {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    configuration?: PolicyTypeConfig;
    policyTypeId?: number;
    policies?: Policy[] | undefined;

    constructor(data?: IPolicyType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.configuration = _data["configuration"] ? PolicyTypeConfig.fromJS(_data["configuration"]) : <any>undefined;
            this.policyTypeId = _data["policyTypeId"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(Policy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PolicyType {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        data["policyTypeId"] = this.policyTypeId;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPolicyType {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    configuration?: PolicyTypeConfig;
    policyTypeId?: number;
    policies?: Policy[] | undefined;
}

export class PolicyTypeConfig implements IPolicyTypeConfig {
    icon?: string | undefined;

    constructor(data?: IPolicyTypeConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): PolicyTypeConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyTypeConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon;
        return data;
    }
}

export interface IPolicyTypeConfig {
    icon?: string | undefined;
}

export class PolicyTypeItem implements IPolicyTypeItem {
    id?: number;
    name?: string | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IPolicyTypeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): PolicyTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IPolicyTypeItem {
    id?: number;
    name?: string | undefined;
    imageUrl?: string | undefined;
}

export class PortfolioInsurancePolicyModel implements IPortfolioInsurancePolicyModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    accountName?: string | undefined;
    accountIdentity?: string | undefined;
    policyText?: string | undefined;
    accountBranchBank?: string | undefined;
    asOf?: Date;
    prtfolioValuePercentage?: number;
    prtfolioValueAmount?: number;
    shekelsPrtfolioValuePercentage?: number;
    shekelsPrtfolioValueAmount?: number;
    currentPrtfolioValuePercentage?: number;
    currentPrtfolioValueAmount?: number;
    measurePrtfolioValuePercentage?: number;
    measurePrtfolioValueAmount?: number;
    salvoPrtfolioValuePercentage?: number;
    salvoPrtfolioValueAmount?: number;
    stockPrtfolioValuePercentage?: number;
    stockPrtfolioValueAmount?: number;

    constructor(data?: IPortfolioInsurancePolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agentDetailsList"])) {
                this.agentDetailsList = [] as any;
                for (let item of _data["agentDetailsList"])
                    this.agentDetailsList!.push(AgentDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["salespersons"])) {
                this.salespersons = [] as any;
                for (let item of _data["salespersons"])
                    this.salespersons!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(SelectListItem.fromJS(item));
            }
            this.accountName = _data["accountName"];
            this.accountIdentity = _data["accountIdentity"];
            this.policyText = _data["policyText"];
            this.accountBranchBank = _data["accountBranchBank"];
            this.asOf = _data["asOf"] ? new Date(_data["asOf"].toString()) : <any>undefined;
            this.prtfolioValuePercentage = _data["prtfolioValuePercentage"];
            this.prtfolioValueAmount = _data["prtfolioValueAmount"];
            this.shekelsPrtfolioValuePercentage = _data["shekelsPrtfolioValuePercentage"];
            this.shekelsPrtfolioValueAmount = _data["shekelsPrtfolioValueAmount"];
            this.currentPrtfolioValuePercentage = _data["currentPrtfolioValuePercentage"];
            this.currentPrtfolioValueAmount = _data["currentPrtfolioValueAmount"];
            this.measurePrtfolioValuePercentage = _data["measurePrtfolioValuePercentage"];
            this.measurePrtfolioValueAmount = _data["measurePrtfolioValueAmount"];
            this.salvoPrtfolioValuePercentage = _data["salvoPrtfolioValuePercentage"];
            this.salvoPrtfolioValueAmount = _data["salvoPrtfolioValueAmount"];
            this.stockPrtfolioValuePercentage = _data["stockPrtfolioValuePercentage"];
            this.stockPrtfolioValueAmount = _data["stockPrtfolioValueAmount"];
        }
    }

    static fromJS(data: any): PortfolioInsurancePolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PortfolioInsurancePolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.agentDetailsList)) {
            data["agentDetailsList"] = [];
            for (let item of this.agentDetailsList)
                data["agentDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.salespersons)) {
            data["salespersons"] = [];
            for (let item of this.salespersons)
                data["salespersons"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        data["accountName"] = this.accountName;
        data["accountIdentity"] = this.accountIdentity;
        data["policyText"] = this.policyText;
        data["accountBranchBank"] = this.accountBranchBank;
        data["asOf"] = this.asOf ? this.asOf.toISOString() : <any>undefined;
        data["prtfolioValuePercentage"] = this.prtfolioValuePercentage;
        data["prtfolioValueAmount"] = this.prtfolioValueAmount;
        data["shekelsPrtfolioValuePercentage"] = this.shekelsPrtfolioValuePercentage;
        data["shekelsPrtfolioValueAmount"] = this.shekelsPrtfolioValueAmount;
        data["currentPrtfolioValuePercentage"] = this.currentPrtfolioValuePercentage;
        data["currentPrtfolioValueAmount"] = this.currentPrtfolioValueAmount;
        data["measurePrtfolioValuePercentage"] = this.measurePrtfolioValuePercentage;
        data["measurePrtfolioValueAmount"] = this.measurePrtfolioValueAmount;
        data["salvoPrtfolioValuePercentage"] = this.salvoPrtfolioValuePercentage;
        data["salvoPrtfolioValueAmount"] = this.salvoPrtfolioValueAmount;
        data["stockPrtfolioValuePercentage"] = this.stockPrtfolioValuePercentage;
        data["stockPrtfolioValueAmount"] = this.stockPrtfolioValueAmount;
        return data;
    }
}

export interface IPortfolioInsurancePolicyModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    accountName?: string | undefined;
    accountIdentity?: string | undefined;
    policyText?: string | undefined;
    accountBranchBank?: string | undefined;
    asOf?: Date;
    prtfolioValuePercentage?: number;
    prtfolioValueAmount?: number;
    shekelsPrtfolioValuePercentage?: number;
    shekelsPrtfolioValueAmount?: number;
    currentPrtfolioValuePercentage?: number;
    currentPrtfolioValueAmount?: number;
    measurePrtfolioValuePercentage?: number;
    measurePrtfolioValueAmount?: number;
    salvoPrtfolioValuePercentage?: number;
    salvoPrtfolioValueAmount?: number;
    stockPrtfolioValuePercentage?: number;
    stockPrtfolioValueAmount?: number;
}

/** 0 = Low, 1 = Medium, 2 = High */
export enum Priority {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = Manual, 1 = Auto */
export enum ProductionType {
    _0 = 0,
    _1 = 1,
}

/** 0 = Doctor */
export enum ProfessionalLiabilityType {
    _0 = 0,
}

export class Project implements IProject {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    status?: ActivityStatus;
    projectManagerId?: string | undefined;
    projectManager?: User;
    projectUsers?: ProjectUser[] | undefined;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.status = _data["status"];
            this.projectManagerId = _data["projectManagerId"];
            this.projectManager = _data["projectManager"] ? User.fromJS(_data["projectManager"]) : <any>undefined;
            if (Array.isArray(_data["projectUsers"])) {
                this.projectUsers = [] as any;
                for (let item of _data["projectUsers"])
                    this.projectUsers!.push(ProjectUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["status"] = this.status;
        data["projectManagerId"] = this.projectManagerId;
        data["projectManager"] = this.projectManager ? this.projectManager.toJSON() : <any>undefined;
        if (Array.isArray(this.projectUsers)) {
            data["projectUsers"] = [];
            for (let item of this.projectUsers)
                data["projectUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProject {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    status?: ActivityStatus;
    projectManagerId?: string | undefined;
    projectManager?: User;
    projectUsers?: ProjectUser[] | undefined;
}

export class ProjectModel implements IProjectModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    projectManagerId?: string | undefined;
    projectManager?: UserModel;
    projectUsers?: ProjectUserModel[] | undefined;
    usersBranches?: BranchModel[] | undefined;
    usersInProject?: UserModel[] | undefined;
    users?: SelectListItem[] | undefined;

    constructor(data?: IProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.projectManagerId = _data["projectManagerId"];
            this.projectManager = _data["projectManager"] ? UserModel.fromJS(_data["projectManager"]) : <any>undefined;
            if (Array.isArray(_data["projectUsers"])) {
                this.projectUsers = [] as any;
                for (let item of _data["projectUsers"])
                    this.projectUsers!.push(ProjectUserModel.fromJS(item));
            }
            if (Array.isArray(_data["usersBranches"])) {
                this.usersBranches = [] as any;
                for (let item of _data["usersBranches"])
                    this.usersBranches!.push(BranchModel.fromJS(item));
            }
            if (Array.isArray(_data["usersInProject"])) {
                this.usersInProject = [] as any;
                for (let item of _data["usersInProject"])
                    this.usersInProject!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["projectManagerId"] = this.projectManagerId;
        data["projectManager"] = this.projectManager ? this.projectManager.toJSON() : <any>undefined;
        if (Array.isArray(this.projectUsers)) {
            data["projectUsers"] = [];
            for (let item of this.projectUsers)
                data["projectUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.usersBranches)) {
            data["usersBranches"] = [];
            for (let item of this.usersBranches)
                data["usersBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.usersInProject)) {
            data["usersInProject"] = [];
            for (let item of this.usersInProject)
                data["usersInProject"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    projectManagerId?: string | undefined;
    projectManager?: UserModel;
    projectUsers?: ProjectUserModel[] | undefined;
    usersBranches?: BranchModel[] | undefined;
    usersInProject?: UserModel[] | undefined;
    users?: SelectListItem[] | undefined;
}

export class ProjectsModel implements IProjectsModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    projects?: ProjectModel[] | undefined;

    constructor(data?: IProjectsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectsModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    projects?: ProjectModel[] | undefined;
}

export class ProjectUser implements IProjectUser {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    userId?: string | undefined;
    user?: User;
    branchId?: string | undefined;
    branch?: Branch;
    projectId?: string;
    project?: Project;

    constructor(data?: IProjectUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.branchId = _data["branchId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectUser {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectUser {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    userId?: string | undefined;
    user?: User;
    branchId?: string | undefined;
    branch?: Branch;
    projectId?: string;
    project?: Project;
}

export class ProjectUserModel implements IProjectUserModel {
    id?: string;
    userId?: string | undefined;
    user?: UserModel;
    branchId?: string | undefined;
    branch?: BranchModel;
    projectId?: string;
    project?: ProjectModel;

    constructor(data?: IProjectUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.branchId = _data["branchId"];
            this.branch = _data["branch"] ? BranchModel.fromJS(_data["branch"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? ProjectModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectUserModel {
    id?: string;
    userId?: string | undefined;
    user?: UserModel;
    branchId?: string | undefined;
    branch?: BranchModel;
    projectId?: string;
    project?: ProjectModel;
}

export class ProjectUsersModel implements IProjectUsersModel {
    users?: string[] | undefined;
    branches?: string[] | undefined;
    projectId?: string;

    constructor(data?: IProjectUsersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(item);
            }
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectUsersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUsersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item);
        }
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectUsersModel {
    users?: string[] | undefined;
    branches?: string[] | undefined;
    projectId?: string;
}

/** 0 = None, 512 = SpecialName, 1024 = RTSpecialName, 4096 = HasDefault, 8192 = Reserved2, 16384 = Reserved3, 32768 = Reserved4, 62464 = ReservedMask */
export enum PropertyAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _62464 = 62464,
}

export class PropertyInfo implements IPropertyInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    propertyType?: Type;
    attributes?: PropertyAttributes;
    readonly isSpecialName?: boolean;
    readonly canRead?: boolean;
    readonly canWrite?: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : <any>undefined;
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : <any>undefined;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : <any>undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    propertyType?: Type;
    attributes?: PropertyAttributes;
    isSpecialName?: boolean;
    canRead?: boolean;
    canWrite?: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;
}

export class ProvisionModel implements IProvisionModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    employerId?: string | undefined;
    employer?: EmployerModel;
    policyWage?: string | undefined;
    willingnessToPayDate?: Date;
    wageCalculationType?: number;
    linkWagesType?: number;
    compensationPercentage?: string | undefined;
    compensationSum?: string | undefined;
    dateCompensationIndex?: Date;
    percentageBenefitsWorker?: string | undefined;
    amountBenefitsWorker?: string | undefined;
    remunerationIndexDateWorker?: string | undefined;
    lossOfWorkVapacityPercentage?: string | undefined;
    lossOfWorkVapacityAmount?: string | undefined;
    lossOfWorkVapacityIndexDate?: Date;
    percentageVarietyWorker?: string | undefined;
    amountageVarietyWorker?: string | undefined;
    varietyWorkerIndexDate?: Date;

    constructor(data?: IProvisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.employerId = _data["employerId"];
            this.employer = _data["employer"] ? EmployerModel.fromJS(_data["employer"]) : <any>undefined;
            this.policyWage = _data["policyWage"];
            this.willingnessToPayDate = _data["willingnessToPayDate"] ? new Date(_data["willingnessToPayDate"].toString()) : <any>undefined;
            this.wageCalculationType = _data["wageCalculationType"];
            this.linkWagesType = _data["linkWagesType"];
            this.compensationPercentage = _data["compensationPercentage"];
            this.compensationSum = _data["compensationSum"];
            this.dateCompensationIndex = _data["dateCompensationIndex"] ? new Date(_data["dateCompensationIndex"].toString()) : <any>undefined;
            this.percentageBenefitsWorker = _data["percentageBenefitsWorker"];
            this.amountBenefitsWorker = _data["amountBenefitsWorker"];
            this.remunerationIndexDateWorker = _data["remunerationIndexDateWorker"];
            this.lossOfWorkVapacityPercentage = _data["lossOfWorkVapacityPercentage"];
            this.lossOfWorkVapacityAmount = _data["lossOfWorkVapacityAmount"];
            this.lossOfWorkVapacityIndexDate = _data["lossOfWorkVapacityIndexDate"] ? new Date(_data["lossOfWorkVapacityIndexDate"].toString()) : <any>undefined;
            this.percentageVarietyWorker = _data["percentageVarietyWorker"];
            this.amountageVarietyWorker = _data["amountageVarietyWorker"];
            this.varietyWorkerIndexDate = _data["varietyWorkerIndexDate"] ? new Date(_data["varietyWorkerIndexDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProvisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["employerId"] = this.employerId;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["policyWage"] = this.policyWage;
        data["willingnessToPayDate"] = this.willingnessToPayDate ? this.willingnessToPayDate.toISOString() : <any>undefined;
        data["wageCalculationType"] = this.wageCalculationType;
        data["linkWagesType"] = this.linkWagesType;
        data["compensationPercentage"] = this.compensationPercentage;
        data["compensationSum"] = this.compensationSum;
        data["dateCompensationIndex"] = this.dateCompensationIndex ? this.dateCompensationIndex.toISOString() : <any>undefined;
        data["percentageBenefitsWorker"] = this.percentageBenefitsWorker;
        data["amountBenefitsWorker"] = this.amountBenefitsWorker;
        data["remunerationIndexDateWorker"] = this.remunerationIndexDateWorker;
        data["lossOfWorkVapacityPercentage"] = this.lossOfWorkVapacityPercentage;
        data["lossOfWorkVapacityAmount"] = this.lossOfWorkVapacityAmount;
        data["lossOfWorkVapacityIndexDate"] = this.lossOfWorkVapacityIndexDate ? this.lossOfWorkVapacityIndexDate.toISOString() : <any>undefined;
        data["percentageVarietyWorker"] = this.percentageVarietyWorker;
        data["amountageVarietyWorker"] = this.amountageVarietyWorker;
        data["varietyWorkerIndexDate"] = this.varietyWorkerIndexDate ? this.varietyWorkerIndexDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProvisionModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    employerId?: string | undefined;
    employer?: EmployerModel;
    policyWage?: string | undefined;
    willingnessToPayDate?: Date;
    wageCalculationType?: number;
    linkWagesType?: number;
    compensationPercentage?: string | undefined;
    compensationSum?: string | undefined;
    dateCompensationIndex?: Date;
    percentageBenefitsWorker?: string | undefined;
    amountBenefitsWorker?: string | undefined;
    remunerationIndexDateWorker?: string | undefined;
    lossOfWorkVapacityPercentage?: string | undefined;
    lossOfWorkVapacityAmount?: string | undefined;
    lossOfWorkVapacityIndexDate?: Date;
    percentageVarietyWorker?: string | undefined;
    amountageVarietyWorker?: string | undefined;
    varietyWorkerIndexDate?: Date;
}

export class ReadProductionModel implements IReadProductionModel {
    file?: string | undefined;
    insuranceCompanyId?: string;

    constructor(data?: IReadProductionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
        }
    }

    static fromJS(data: any): ReadProductionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadProductionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        return data;
    }
}

export interface IReadProductionModel {
    file?: string | undefined;
    insuranceCompanyId?: string;
}

/** 0 = All, 1 = Unread, 2 = Read, 3 = NotReply */
export enum ReadUnread {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class RelationEntitiesModel implements IRelationEntitiesModel {
    policies?: PolicyModel[] | undefined;
    sues?: SueModel[] | undefined;
    leads?: LeadModel[] | undefined;
    policyRelated?: PolicyModel;
    sueRelated?: SueModel;
    leadRelated?: LeadModel;
    open?: boolean;
    riders?: RiderModel[] | undefined;

    constructor(data?: IRelationEntitiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(PolicyModel.fromJS(item));
            }
            if (Array.isArray(_data["sues"])) {
                this.sues = [] as any;
                for (let item of _data["sues"])
                    this.sues!.push(SueModel.fromJS(item));
            }
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(LeadModel.fromJS(item));
            }
            this.policyRelated = _data["policyRelated"] ? PolicyModel.fromJS(_data["policyRelated"]) : <any>undefined;
            this.sueRelated = _data["sueRelated"] ? SueModel.fromJS(_data["sueRelated"]) : <any>undefined;
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
            this.open = _data["open"];
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders!.push(RiderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RelationEntitiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new RelationEntitiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        if (Array.isArray(this.sues)) {
            data["sues"] = [];
            for (let item of this.sues)
                data["sues"].push(item.toJSON());
        }
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }
        data["policyRelated"] = this.policyRelated ? this.policyRelated.toJSON() : <any>undefined;
        data["sueRelated"] = this.sueRelated ? this.sueRelated.toJSON() : <any>undefined;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        data["open"] = this.open;
        return data;
    }
}

export interface IRelationEntitiesModel {
    policies?: PolicyModel[] | undefined;
    sues?: SueModel[] | undefined;
    leads?: LeadModel[] | undefined;
    policyRelated?: PolicyModel;
    sueRelated?: SueModel;
    leadRelated?: LeadModel;
    open?: boolean;
}

/** 0 = Lead, 1 = Policy, 2 = Sue */
export enum RelationshipType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RemoteCertificateValidationCallback implements IRemoteCertificateValidationCallback {
    readonly target?: any | undefined;
    method?: MethodInfo;

    constructor(data?: IRemoteCertificateValidationCallback) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).target = _data["target"];
            this.method = _data["method"] ? MethodInfo.fromJS(_data["method"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoteCertificateValidationCallback {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteCertificateValidationCallback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRemoteCertificateValidationCallback {
    target?: any | undefined;
    method?: MethodInfo;
}

export class RenewalPageModel implements IRenewalPageModel {
    insuranceCompanies?: SelectListItem[] | undefined;
    salesPeople?: SelectListItem[] | undefined;
    handlers?: SelectListItem[] | undefined;
    leadStatuses?: SelectListItem[] | undefined;
    leadsModel?: LeadsPageModel;

    constructor(data?: IRenewalPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["salesPeople"])) {
                this.salesPeople = [] as any;
                for (let item of _data["salesPeople"])
                    this.salesPeople!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["handlers"])) {
                this.handlers = [] as any;
                for (let item of _data["handlers"])
                    this.handlers!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["leadStatuses"])) {
                this.leadStatuses = [] as any;
                for (let item of _data["leadStatuses"])
                    this.leadStatuses!.push(SelectListItem.fromJS(item));
            }
            this.leadsModel = _data["leadsModel"] ? LeadsPageModel.fromJS(_data["leadsModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RenewalPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.salesPeople)) {
            data["salesPeople"] = [];
            for (let item of this.salesPeople)
                data["salesPeople"].push(item.toJSON());
        }
        if (Array.isArray(this.handlers)) {
            data["handlers"] = [];
            for (let item of this.handlers)
                data["handlers"].push(item.toJSON());
        }
        if (Array.isArray(this.leadStatuses)) {
            data["leadStatuses"] = [];
            for (let item of this.leadStatuses)
                data["leadStatuses"].push(item.toJSON());
        }
        data["leadsModel"] = this.leadsModel ? this.leadsModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRenewalPageModel {
    insuranceCompanies?: SelectListItem[] | undefined;
    salesPeople?: SelectListItem[] | undefined;
    handlers?: SelectListItem[] | undefined;
    leadStatuses?: SelectListItem[] | undefined;
    leadsModel?: LeadsPageModel;
}

export class RenewalsSalesperson implements IRenewalsSalesperson {
    salesperson?: UserModel;
    count?: number;

    constructor(data?: IRenewalsSalesperson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesperson = _data["salesperson"] ? UserModel.fromJS(_data["salesperson"]) : <any>undefined;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): RenewalsSalesperson {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalsSalesperson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesperson"] = this.salesperson ? this.salesperson.toJSON() : <any>undefined;
        data["count"] = this.count;
        return data;
    }
}

export interface IRenewalsSalesperson {
    salesperson?: UserModel;
    count?: number;
}

export class RenewalsSalespersonPolicies implements IRenewalsSalespersonPolicies {
    salespersonId?: string;
    leads?: string[] | undefined;

    constructor(data?: IRenewalsSalespersonPolicies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salespersonId = _data["salespersonId"];
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(item);
            }
        }
    }

    static fromJS(data: any): RenewalsSalespersonPolicies {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalsSalespersonPolicies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salespersonId"] = this.salespersonId;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item);
        }
        return data;
    }
}

export interface IRenewalsSalespersonPolicies {
    salespersonId?: string;
    leads?: string[] | undefined;
}

export class RenewalsSorting implements IRenewalsSorting {
    name?: string | undefined;
    count?: number;
    policies?: string[] | undefined;

    constructor(data?: IRenewalsSorting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(item);
            }
        }
    }

    static fromJS(data: any): RenewalsSorting {
        data = typeof data === 'object' ? data : {};
        let result = new RenewalsSorting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item);
        }
        return data;
    }
}

export interface IRenewalsSorting {
    name?: string | undefined;
    count?: number;
    policies?: string[] | undefined;
}

/** 0 = Companies, 1 = Letters, 2 = Branches */
export enum RenewalsSortingType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = Migdal */
export enum RenovationAgentsOffice {
    _0 = 0,
}

/** 0 = Migdal, 1 = Ayalon, 2 = fnx, 3 = Shomera, 4 = ShomeraA, 5 = ShomeraAA, 6 = ShomeraAAA */
export enum RenovationCompany {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class RepaidModel implements IRepaidModel {
    id?: string;
    healthInsurancePolicyId?: string;
    paymentDate?: Date;
    payingType?: number;
    payerNumber?: string | undefined;
    employer?: EmployerModel;
    employerId?: string;
    taxYear?: string | undefined;
    insuredSalary?: string | undefined;
    employerCompensationPercentage?: string | undefined;
    employerCompensationAmount?: string | undefined;
    employerRewardsPercentage?: string | undefined;
    employerRewardsAmount?: string | undefined;
    employerLossOfWorkCapacityPercentage?: string | undefined;
    employerLossOfWorkCapacityAmount?: string | undefined;
    employerOthersPercentage?: string | undefined;
    employerOthersAmount?: string | undefined;
    employerSumPercentage?: string | undefined;
    employerSumAmount?: string | undefined;
    workerRewards45Percentage?: string | undefined;
    workerRewards45Amount?: string | undefined;
    workerRewards47Percentage?: string | undefined;
    workerRewards47Amount?: string | undefined;
    workerLossOfWorkCapacityPercentage?: string | undefined;
    workerLossOfWorkCapacityAmount?: string | undefined;
    workerOthersPercentage?: string | undefined;
    workerOthersAmount?: string | undefined;
    workerSumPercentage?: string | undefined;
    workerSumAmount?: string | undefined;
    sumPercentage?: string | undefined;
    sumAmount?: string | undefined;
    collectionFees?: string | undefined;
    commission?: string | undefined;

    constructor(data?: IRepaidModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.healthInsurancePolicyId = _data["healthInsurancePolicyId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.payingType = _data["payingType"];
            this.payerNumber = _data["payerNumber"];
            this.employer = _data["employer"] ? EmployerModel.fromJS(_data["employer"]) : <any>undefined;
            this.employerId = _data["employerId"];
            this.taxYear = _data["taxYear"];
            this.insuredSalary = _data["insuredSalary"];
            this.employerCompensationPercentage = _data["employerCompensationPercentage"];
            this.employerCompensationAmount = _data["employerCompensationAmount"];
            this.employerRewardsPercentage = _data["employerRewardsPercentage"];
            this.employerRewardsAmount = _data["employerRewardsAmount"];
            this.employerLossOfWorkCapacityPercentage = _data["employerLossOfWorkCapacityPercentage"];
            this.employerLossOfWorkCapacityAmount = _data["employerLossOfWorkCapacityAmount"];
            this.employerOthersPercentage = _data["employerOthersPercentage"];
            this.employerOthersAmount = _data["employerOthersAmount"];
            this.employerSumPercentage = _data["employerSumPercentage"];
            this.employerSumAmount = _data["employerSumAmount"];
            this.workerRewards45Percentage = _data["workerRewards45Percentage"];
            this.workerRewards45Amount = _data["workerRewards45Amount"];
            this.workerRewards47Percentage = _data["workerRewards47Percentage"];
            this.workerRewards47Amount = _data["workerRewards47Amount"];
            this.workerLossOfWorkCapacityPercentage = _data["workerLossOfWorkCapacityPercentage"];
            this.workerLossOfWorkCapacityAmount = _data["workerLossOfWorkCapacityAmount"];
            this.workerOthersPercentage = _data["workerOthersPercentage"];
            this.workerOthersAmount = _data["workerOthersAmount"];
            this.workerSumPercentage = _data["workerSumPercentage"];
            this.workerSumAmount = _data["workerSumAmount"];
            this.sumPercentage = _data["sumPercentage"];
            this.sumAmount = _data["sumAmount"];
            this.collectionFees = _data["collectionFees"];
            this.commission = _data["commission"];
        }
    }

    static fromJS(data: any): RepaidModel {
        data = typeof data === 'object' ? data : {};
        let result = new RepaidModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["healthInsurancePolicyId"] = this.healthInsurancePolicyId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["payingType"] = this.payingType;
        data["payerNumber"] = this.payerNumber;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["employerId"] = this.employerId;
        data["taxYear"] = this.taxYear;
        data["insuredSalary"] = this.insuredSalary;
        data["employerCompensationPercentage"] = this.employerCompensationPercentage;
        data["employerCompensationAmount"] = this.employerCompensationAmount;
        data["employerRewardsPercentage"] = this.employerRewardsPercentage;
        data["employerRewardsAmount"] = this.employerRewardsAmount;
        data["employerLossOfWorkCapacityPercentage"] = this.employerLossOfWorkCapacityPercentage;
        data["employerLossOfWorkCapacityAmount"] = this.employerLossOfWorkCapacityAmount;
        data["employerOthersPercentage"] = this.employerOthersPercentage;
        data["employerOthersAmount"] = this.employerOthersAmount;
        data["employerSumPercentage"] = this.employerSumPercentage;
        data["employerSumAmount"] = this.employerSumAmount;
        data["workerRewards45Percentage"] = this.workerRewards45Percentage;
        data["workerRewards45Amount"] = this.workerRewards45Amount;
        data["workerRewards47Percentage"] = this.workerRewards47Percentage;
        data["workerRewards47Amount"] = this.workerRewards47Amount;
        data["workerLossOfWorkCapacityPercentage"] = this.workerLossOfWorkCapacityPercentage;
        data["workerLossOfWorkCapacityAmount"] = this.workerLossOfWorkCapacityAmount;
        data["workerOthersPercentage"] = this.workerOthersPercentage;
        data["workerOthersAmount"] = this.workerOthersAmount;
        data["workerSumPercentage"] = this.workerSumPercentage;
        data["workerSumAmount"] = this.workerSumAmount;
        data["sumPercentage"] = this.sumPercentage;
        data["sumAmount"] = this.sumAmount;
        data["collectionFees"] = this.collectionFees;
        data["commission"] = this.commission;
        return data;
    }
}

export interface IRepaidModel {
    id?: string;
    healthInsurancePolicyId?: string;
    paymentDate?: Date;
    payingType?: number;
    payerNumber?: string | undefined;
    employer?: EmployerModel;
    employerId?: string;
    taxYear?: string | undefined;
    insuredSalary?: string | undefined;
    employerCompensationPercentage?: string | undefined;
    employerCompensationAmount?: string | undefined;
    employerRewardsPercentage?: string | undefined;
    employerRewardsAmount?: string | undefined;
    employerLossOfWorkCapacityPercentage?: string | undefined;
    employerLossOfWorkCapacityAmount?: string | undefined;
    employerOthersPercentage?: string | undefined;
    employerOthersAmount?: string | undefined;
    employerSumPercentage?: string | undefined;
    employerSumAmount?: string | undefined;
    workerRewards45Percentage?: string | undefined;
    workerRewards45Amount?: string | undefined;
    workerRewards47Percentage?: string | undefined;
    workerRewards47Amount?: string | undefined;
    workerLossOfWorkCapacityPercentage?: string | undefined;
    workerLossOfWorkCapacityAmount?: string | undefined;
    workerOthersPercentage?: string | undefined;
    workerOthersAmount?: string | undefined;
    workerSumPercentage?: string | undefined;
    workerSumAmount?: string | undefined;
    sumPercentage?: string | undefined;
    sumAmount?: string | undefined;
    collectionFees?: string | undefined;
    commission?: string | undefined;
}

export class Rider implements IRider {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    stationUserId?: string | undefined;
    stationUser?: User;
    handlerId?: string | undefined;
    handler?: User;
    agentId?: string | undefined;
    agent?: Agent;
    subscriberNumber?: number | undefined;
    additionNumber?: number | undefined;
    customerId?: string;
    customer?: Customer;
    startDate?: Date;
    endDate?: Date;
    updateStartDate?: Date;
    updateEndDate?: Date;
    productionDate?: Date;
    packageDescription?: string | undefined;
    riderPackages?: Riders_Packages[] | undefined;
    agentCost?: number;
    customerCost?: number;
    paymentMethodType?: PaymentMethodType;
    riderStatusType?: RiderStatusType;
    agentUserId?: string | undefined;
    agentUser?: User;
    handlerUserId?: string | undefined;
    handlerUser?: User;
    vehicleId?: string | undefined;
    vehicle?: Vehicle;
    comment?: string | undefined;
    payments?: Payment[] | undefined;

    constructor(data?: IRider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.stationUserId = _data["stationUserId"];
            this.stationUser = _data["stationUser"] ? User.fromJS(_data["stationUser"]) : <any>undefined;
            this.handlerId = _data["handlerId"];
            this.handler = _data["handler"] ? User.fromJS(_data["handler"]) : <any>undefined;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : <any>undefined;
            this.subscriberNumber = _data["subscriberNumber"];
            this.additionNumber = _data["additionNumber"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updateStartDate = _data["updateStartDate"] ? new Date(_data["updateStartDate"].toString()) : <any>undefined;
            this.updateEndDate = _data["updateEndDate"] ? new Date(_data["updateEndDate"].toString()) : <any>undefined;
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.packageDescription = _data["packageDescription"];
            if (Array.isArray(_data["riderPackages"])) {
                this.riderPackages = [] as any;
                for (let item of _data["riderPackages"])
                    this.riderPackages!.push(Riders_Packages.fromJS(item));
            }
            this.agentCost = _data["agentCost"];
            this.customerCost = _data["customerCost"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.riderStatusType = _data["riderStatusType"];
            this.agentUserId = _data["agentUserId"];
            this.agentUser = _data["agentUser"] ? User.fromJS(_data["agentUser"]) : <any>undefined;
            this.handlerUserId = _data["handlerUserId"];
            this.handlerUser = _data["handlerUser"] ? User.fromJS(_data["handlerUser"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(Payment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Rider {
        data = typeof data === 'object' ? data : {};
        let result = new Rider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["stationUserId"] = this.stationUserId;
        data["stationUser"] = this.stationUser ? this.stationUser.toJSON() : <any>undefined;
        data["handlerId"] = this.handlerId;
        data["handler"] = this.handler ? this.handler.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["subscriberNumber"] = this.subscriberNumber;
        data["additionNumber"] = this.additionNumber;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updateStartDate"] = this.updateStartDate ? this.updateStartDate.toISOString() : <any>undefined;
        data["updateEndDate"] = this.updateEndDate ? this.updateEndDate.toISOString() : <any>undefined;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["packageDescription"] = this.packageDescription;
        if (Array.isArray(this.riderPackages)) {
            data["riderPackages"] = [];
            for (let item of this.riderPackages)
                data["riderPackages"].push(item.toJSON());
        }
        data["agentCost"] = this.agentCost;
        data["customerCost"] = this.customerCost;
        data["paymentMethodType"] = this.paymentMethodType;
        data["riderStatusType"] = this.riderStatusType;
        data["agentUserId"] = this.agentUserId;
        data["agentUser"] = this.agentUser ? this.agentUser.toJSON() : <any>undefined;
        data["handlerUserId"] = this.handlerUserId;
        data["handlerUser"] = this.handlerUser ? this.handlerUser.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRider {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    stationUserId?: string | undefined;
    stationUser?: User;
    handlerId?: string | undefined;
    handler?: User;
    agentId?: string | undefined;
    agent?: Agent;
    subscriberNumber?: number | undefined;
    additionNumber?: number | undefined;
    customerId?: string;
    customer?: Customer;
    startDate?: Date;
    endDate?: Date;
    updateStartDate?: Date;
    updateEndDate?: Date;
    productionDate?: Date;
    packageDescription?: string | undefined;
    riderPackages?: Riders_Packages[] | undefined;
    agentCost?: number;
    customerCost?: number;
    paymentMethodType?: PaymentMethodType;
    riderStatusType?: RiderStatusType;
    agentUserId?: string | undefined;
    agentUser?: User;
    handlerUserId?: string | undefined;
    handlerUser?: User;
    vehicleId?: string | undefined;
    vehicle?: Vehicle;
    comment?: string | undefined;
    payments?: Payment[] | undefined;
}

export class RiderComapny implements IRiderComapny {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;

    constructor(data?: IRiderComapny) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RiderComapny {
        data = typeof data === 'object' ? data : {};
        let result = new RiderComapny();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IRiderComapny {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
}

export class RiderComapnyModel implements IRiderComapnyModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: IRiderComapnyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RiderComapnyModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderComapnyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRiderComapnyModel {
    id?: string;
    name?: string | undefined;
}

export class RiderCompanies implements IRiderCompanies {
    rider?: RiderModel;
    companies?: RiderComapnyModel[] | undefined;

    constructor(data?: IRiderCompanies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rider = _data["rider"] ? RiderModel.fromJS(_data["rider"]) : <any>undefined;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(RiderComapnyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RiderCompanies {
        data = typeof data === 'object' ? data : {};
        let result = new RiderCompanies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRiderCompanies {
    rider?: RiderModel;
    companies?: RiderComapnyModel[] | undefined;
}

export class RiderDiscountBankModel implements IRiderDiscountBankModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    amount?: number;
    riderDiscountBankStatusType?: RiderDiscountBankStatusType;
    date?: Date;
    riderId?: string;
    rider?: RiderModel;
    userId?: string;
    user?: UserModel;

    constructor(data?: IRiderDiscountBankModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.riderDiscountBankStatusType = _data["riderDiscountBankStatusType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.riderId = _data["riderId"];
            this.rider = _data["rider"] ? RiderModel.fromJS(_data["rider"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RiderDiscountBankModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderDiscountBankModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["riderDiscountBankStatusType"] = this.riderDiscountBankStatusType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["riderId"] = this.riderId;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRiderDiscountBankModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    amount?: number;
    riderDiscountBankStatusType?: RiderDiscountBankStatusType;
    date?: Date;
    riderId?: string;
    rider?: RiderModel;
    userId?: string;
    user?: UserModel;
}

/** 0 = SentToCustomer, 1 = Realized */
export enum RiderDiscountBankStatusType {
    _0 = 0,
    _1 = 1,
}

export class RiderFilterDataModel implements IRiderFilterDataModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    roleId?: string | undefined;
    officeDepartmentId?: string | undefined;
    branchId?: string | undefined;
    status?: ActivityStatus;
    page?: number;
    riderStatusType?: RiderStatusTypeFilter;
    paymentStatusType?: PaymentStatus;
    createDateFrom?: Date | undefined;
    createDateTo?: Date | undefined;
    startDateFrom?: Date | undefined;
    startDateTo?: Date | undefined;

    constructor(data?: IRiderFilterDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.roleId = _data["roleId"];
            this.officeDepartmentId = _data["officeDepartmentId"];
            this.branchId = _data["branchId"];
            this.status = _data["status"];
            this.page = _data["page"];
            this.riderStatusType = _data["riderStatusType"];
            this.paymentStatusType = _data["paymentStatusType"];
            this.createDateFrom = _data["createDateFrom"] ? new Date(_data["createDateFrom"].toString()) : <any>undefined;
            this.createDateTo = _data["createDateTo"] ? new Date(_data["createDateTo"].toString()) : <any>undefined;
            this.startDateFrom = _data["startDateFrom"] ? new Date(_data["startDateFrom"].toString()) : <any>undefined;
            this.startDateTo = _data["startDateTo"] ? new Date(_data["startDateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RiderFilterDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderFilterDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["roleId"] = this.roleId;
        data["officeDepartmentId"] = this.officeDepartmentId;
        data["branchId"] = this.branchId;
        data["status"] = this.status;
        data["page"] = this.page;
        data["riderStatusType"] = this.riderStatusType;
        data["paymentStatusType"] = this.paymentStatusType;
        data["createDateFrom"] = this.createDateFrom ? this.createDateFrom.toISOString() : <any>undefined;
        data["createDateTo"] = this.createDateTo ? this.createDateTo.toISOString() : <any>undefined;
        data["startDateFrom"] = this.startDateFrom ? this.startDateFrom.toISOString() : <any>undefined;
        data["startDateTo"] = this.startDateTo ? this.startDateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRiderFilterDataModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    roleId?: string | undefined;
    officeDepartmentId?: string | undefined;
    branchId?: string | undefined;
    status?: ActivityStatus;
    page?: number;
    riderStatusType?: RiderStatusTypeFilter;
    paymentStatusType?: PaymentStatus;
    createDateFrom?: Date | undefined;
    createDateTo?: Date | undefined;
    startDateFrom?: Date | undefined;
    startDateTo?: Date | undefined;
}

export class RiderModel implements IRiderModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    stationUserId?: string | undefined;
    stationUser?: UserModel;
    handlerId?: string | undefined;
    handler?: UserModel;
    agentId?: string | undefined;
    agent?: AgentModel;
    myProperty?: string;
    subscriberNumber?: number | undefined;
    additionNumber?: number | undefined;
    renew?: boolean;
    lastEnd?: Date;
    customerId?: string;
    customer?: CustomerModel;
    startDate?: Date;
    endDate?: Date;
    updateStartDate?: Date;
    updateEndDate?: Date;
    productionDate?: Date;
    packageDescription?: string | undefined;
    riderPackages?: Riders_PackagesModel[] | undefined;
    agentCost?: number;
    customerCost?: number;
    paymentMethodType?: PaymentMethodType;
    riderStatusType?: RiderStatusType;
    agentUserId?: string | undefined;
    agentUser?: UserModel;
    handlerName?: string | undefined;
    handlerUserId?: string | undefined;
    handlerUser?: UserModel;
    vehicleId?: string | undefined;
    vehicle?: VehicleDataModel;
    comment?: string | undefined;
    packages?: RiderPackageModel[] | undefined;
    iCreditUrl?: string | undefined;
    payments?: PaymentModel[] | undefined;
    newPayment?: PaymentModel;
    actionType?: ActionType;
    salesPeople?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    branches?: BranchModel[] | undefined;
    users?: UserModel[] | undefined;
    adminCurUser?: boolean;
    usedPackagesForCencelRider: string[];
    roadServicesProvider?: ServicesProvider;
    hasSues?: boolean;


    constructor(data?: IRiderModel) {
        this.usedPackagesForCencelRider = [];
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.stationUserId = _data["stationUserId"];
            this.stationUser = _data["stationUser"] ? UserModel.fromJS(_data["stationUser"]) : <any>undefined;
            this.handlerId = _data["handlerId"];
            this.handler = _data["handler"] ? UserModel.fromJS(_data["handler"]) : <any>undefined;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? AgentModel.fromJS(_data["agent"]) : <any>undefined;
            this.myProperty = _data["myProperty"];
            this.subscriberNumber = _data["subscriberNumber"];
            this.additionNumber = _data["additionNumber"];
            this.renew = _data["renew"];
            this.lastEnd = _data["lastEnd"] ? new Date(_data["lastEnd"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updateStartDate = _data["updateStartDate"] ? new Date(_data["updateStartDate"].toString()) : <any>undefined;
            this.updateEndDate = _data["updateEndDate"] ? new Date(_data["updateEndDate"].toString()) : <any>undefined;
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
            this.packageDescription = _data["packageDescription"];
            if (Array.isArray(_data["riderPackages"])) {
                this.riderPackages = [] as any;
                for (let item of _data["riderPackages"])
                    this.riderPackages!.push(Riders_PackagesModel.fromJS(item));
            }
            this.agentCost = _data["agentCost"];
            this.customerCost = _data["customerCost"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.riderStatusType = _data["riderStatusType"];
            this.agentUserId = _data["agentUserId"];
            this.agentUser = _data["agentUser"] ? UserModel.fromJS(_data["agentUser"]) : <any>undefined;
            this.handlerName = _data["handlerName"];
            this.handlerUserId = _data["handlerUserId"];
            this.handlerUser = _data["handlerUser"] ? UserModel.fromJS(_data["handlerUser"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? VehicleDataModel.fromJS(_data["vehicle"]) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(RiderPackageModel.fromJS(item));
            }
            this.iCreditUrl = _data["iCreditUrl"];
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(PaymentModel.fromJS(item));
            }
            this.newPayment = _data["newPayment"] ? PaymentModel.fromJS(_data["newPayment"]) : <any>undefined;
            this.actionType = _data["actionType"];
            if (Array.isArray(_data["salesPeople"])) {
                this.salesPeople = [] as any;
                for (let item of _data["salesPeople"])
                    this.salesPeople!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchModel.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
            this.adminCurUser = _data["adminCurUser"];
            this.usedPackagesForCencelRider = _data["usedPackagesForCencelRider"];
            this.hasSues = _data["hasSues"];
        }
    }

    static fromJS(data: any): RiderModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["stationUserId"] = this.stationUserId;
        data["stationUser"] = this.stationUser ? this.stationUser.toJSON() : <any>undefined;
        data["handlerId"] = this.handlerId;
        data["handler"] = this.handler ? this.handler.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["myProperty"] = this.myProperty;
        data["subscriberNumber"] = this.subscriberNumber;
        data["additionNumber"] = this.additionNumber;
        data["renew"] = this.renew;
        data["lastEnd"] = this.lastEnd ? this.lastEnd.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updateStartDate"] = this.updateStartDate ? this.updateStartDate.toISOString() : <any>undefined;
        data["updateEndDate"] = this.updateEndDate ? this.updateEndDate.toISOString() : <any>undefined;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : <any>undefined;
        data["packageDescription"] = this.packageDescription;
        if (Array.isArray(this.riderPackages)) {
            data["riderPackages"] = [];
            for (let item of this.riderPackages)
                data["riderPackages"].push(item.toJSON());
        }
        data["agentCost"] = this.agentCost;
        data["customerCost"] = this.customerCost;
        data["paymentMethodType"] = this.paymentMethodType;
        data["riderStatusType"] = this.riderStatusType;
        data["agentUserId"] = this.agentUserId;
        data["agentUser"] = this.agentUser ? this.agentUser.toJSON() : <any>undefined;
        data["handlerName"] = this.handlerName;
        data["handlerUserId"] = this.handlerUserId;
        data["handlerUser"] = this.handlerUser ? this.handlerUser.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["iCreditUrl"] = this.iCreditUrl;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["newPayment"] = this.newPayment ? this.newPayment.toJSON() : <any>undefined;
        data["actionType"] = this.actionType;
        if (Array.isArray(this.salesPeople)) {
            data["salesPeople"] = [];
            for (let item of this.salesPeople)
                data["salesPeople"].push(item.toJSON());
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["adminCurUser"] = this.adminCurUser;
        data["usedPackagesForCencelRider"] = this.usedPackagesForCencelRider;
        data["hasSues"] = this.hasSues;

        return data;
    }
}

export interface IRiderModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    stationUserId?: string | undefined;
    stationUser?: UserModel;
    handlerId?: string | undefined;
    handler?: UserModel;
    agentId?: string | undefined;
    agent?: AgentModel;
    myProperty?: string;
    subscriberNumber?: number | undefined;
    additionNumber?: number | undefined;
    renew?: boolean;
    lastEnd?: Date;
    customerId?: string;
    customer?: CustomerModel;
    startDate?: Date;
    endDate?: Date;
    updateStartDate?: Date;
    updateEndDate?: Date;
    productionDate?: Date;
    packageDescription?: string | undefined;
    riderPackages?: Riders_PackagesModel[] | undefined;
    agentCost?: number;
    customerCost?: number;
    paymentMethodType?: PaymentMethodType;
    riderStatusType?: RiderStatusType;
    agentUserId?: string | undefined;
    agentUser?: UserModel;
    handlerName?: string | undefined;
    handlerUserId?: string | undefined;
    handlerUser?: UserModel;
    vehicleId?: string | undefined;
    vehicle?: VehicleDataModel;
    comment?: string | undefined;
    packages?: RiderPackageModel[] | undefined;
    iCreditUrl?: string | undefined;
    payments?: PaymentModel[] | undefined;
    newPayment?: PaymentModel;
    actionType?: ActionType;
    salesPeople?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    branches?: BranchModel[] | undefined;
    users?: UserModel[] | undefined;
    adminCurUser?: boolean;
    usedPackagesForCencelRider: string[];
}


export class RiderGetPaymentPage2Request implements IRiderGetPaymentPage2Request {
    RiderId?: string;
    PaymentId?: string;


    constructor(data?: IRiderGetPaymentPage2Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.RiderId = _data["RiderId"];
            this.PaymentId = _data["PaymentId"];

        }
    }

    static fromJS(data: any): RiderModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RiderId"] = this.RiderId;
        data["PaymentId"] = this.PaymentId;

        return data;
    }
}

export interface IRiderGetPaymentPage2Request {
    RiderId?: string;
    PaymentId?: string;
}

export class CreateRiderResponse implements ICreateRiderResponse {
    rider?: RiderModel;
    responseCode?: number;
    responseMessage?: string;


    constructor(data?: ICreateRiderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rider = RiderModel.fromJS(_data["rider"]);
            this.responseCode = _data["responseCode"];
            this.responseMessage = _data["responseMessage"];

        }
    }

    static fromJS(data: any): CreateRiderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRiderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rider"] = this.rider;
        data["responseCode"] = this.responseCode;
        data["responseMessage"] = this.responseMessage;

        return data;
    }
}

export interface ICreateRiderResponse {
    rider?: RiderModel;
    responseCode?: number;
    responseMessage?: string;
}

export class RiderPackage implements IRiderPackage {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    riderServiceBranch?: RiderServiceBranch;
    broadcastCode?: string | undefined;
    status?: ActivityStatus;
    agentCost?: number;
    recommendedCost?: number;
    serviceReporter?: string | undefined;
    autoActive?: boolean;
    privateUpTo4Tons?: boolean;
    commercialUpTo4Tons?: boolean;
    truck?: boolean;
    taxi?: boolean;
    littleBus?: boolean;
    tractor?: boolean;
    dragged?: boolean;
    motorcycle?: boolean;
    other?: boolean;
    includeInPolicyPrice?: boolean;
    sideGimel?: boolean;
    privateIncome?: boolean;
    maxVehicleAge?: number;
    vehicleOwnership?: VehicleOwnership;
    vehicles?: RiderPackageVehicle[] | undefined;
    allVehicles?: boolean;
    riderPackageServices?: RiderPackageService[] | undefined;

    constructor(data?: IRiderPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.riderServiceBranch = _data["riderServiceBranch"];
            this.broadcastCode = _data["broadcastCode"];
            this.status = _data["status"];
            this.agentCost = _data["agentCost"];
            this.recommendedCost = _data["recommendedCost"];
            this.serviceReporter = _data["serviceReporter"];
            this.autoActive = _data["autoActive"];
            this.privateUpTo4Tons = _data["privateUpTo4Tons"];
            this.commercialUpTo4Tons = _data["commercialUpTo4Tons"];
            this.truck = _data["truck"];
            this.taxi = _data["taxi"];
            this.littleBus = _data["littleBus"];
            this.tractor = _data["tractor"];
            this.dragged = _data["dragged"];
            this.motorcycle = _data["motorcycle"];
            this.other = _data["other"];
            this.includeInPolicyPrice = _data["includeInPolicyPrice"];
            this.sideGimel = _data["sideGimel"];
            this.privateIncome = _data["privateIncome"];
            this.maxVehicleAge = _data["maxVehicleAge"];
            this.vehicleOwnership = _data["vehicleOwnership"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(RiderPackageVehicle.fromJS(item));
            }
            this.allVehicles = _data["allVehicles"];
            if (Array.isArray(_data["riderPackageServices"])) {
                this.riderPackageServices = [] as any;
                for (let item of _data["riderPackageServices"])
                    this.riderPackageServices!.push(RiderPackageService.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RiderPackage {
        data = typeof data === 'object' ? data : {};
        let result = new RiderPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["riderServiceBranch"] = this.riderServiceBranch;
        data["broadcastCode"] = this.broadcastCode;
        data["status"] = this.status;
        data["agentCost"] = this.agentCost;
        data["recommendedCost"] = this.recommendedCost;
        data["serviceReporter"] = this.serviceReporter;
        data["autoActive"] = this.autoActive;
        data["privateUpTo4Tons"] = this.privateUpTo4Tons;
        data["commercialUpTo4Tons"] = this.commercialUpTo4Tons;
        data["truck"] = this.truck;
        data["taxi"] = this.taxi;
        data["littleBus"] = this.littleBus;
        data["tractor"] = this.tractor;
        data["dragged"] = this.dragged;
        data["motorcycle"] = this.motorcycle;
        data["other"] = this.other;
        data["includeInPolicyPrice"] = this.includeInPolicyPrice;
        data["sideGimel"] = this.sideGimel;
        data["privateIncome"] = this.privateIncome;
        data["maxVehicleAge"] = this.maxVehicleAge;
        data["vehicleOwnership"] = this.vehicleOwnership;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["allVehicles"] = this.allVehicles;
        if (Array.isArray(this.riderPackageServices)) {
            data["riderPackageServices"] = [];
            for (let item of this.riderPackageServices)
                data["riderPackageServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRiderPackage {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    riderServiceBranch?: RiderServiceBranch;
    broadcastCode?: string | undefined;
    status?: ActivityStatus;
    agentCost?: number;
    recommendedCost?: number;
    serviceReporter?: string | undefined;
    autoActive?: boolean;
    privateUpTo4Tons?: boolean;
    commercialUpTo4Tons?: boolean;
    truck?: boolean;
    taxi?: boolean;
    littleBus?: boolean;
    tractor?: boolean;
    dragged?: boolean;
    motorcycle?: boolean;
    other?: boolean;
    includeInPolicyPrice?: boolean;
    sideGimel?: boolean;
    privateIncome?: boolean;
    maxVehicleAge?: number;
    vehicleOwnership?: VehicleOwnership;
    vehicles?: RiderPackageVehicle[] | undefined;
    allVehicles?: boolean;
    riderPackageServices?: RiderPackageService[] | undefined;
}

export class RiderPackageModel implements IRiderPackageModel {
    id?: string;
    name?: string | undefined;
    riderServiceBranch?: RiderServiceBranch;
    broadcastCode?: string | undefined;
    status?: ActivityStatus;
    agentCost?: number;
    recommendedCost?: number;
    serviceReporter?: string | undefined;
    autoActive?: YesNo;
    privateUpTo4Tons?: boolean;
    commercialUpTo4Tons?: boolean;
    truck?: boolean;
    taxi?: boolean;
    littleBus?: boolean;
    tractor?: boolean;
    dragged?: boolean;
    motorcycle?: boolean;
    other?: boolean;
    includeInPolicyPrice?: boolean;
    sideGimel?: boolean;
    privateIncome?: boolean;
    maxVehicleAge?: number;
    vehicleOwnership?: VehicleOwnership;
    vehicleOwnershipList?: VehicleOwnership2[] | undefined;
    vehicles?: RiderPackageVehicleModel[] | undefined;
    allVehicles?: boolean;
    riderPackageServices?: RiderPackageServiceModel[] | undefined;
    allCompanies?: RiderComapnyModel[] | undefined;
    allCompaniesSelectList?: SelectListItem[] | undefined;
    allSuppliers?: RiderServiceSupplierModel[] | undefined;
    allServices?: RiderServiceModel[] | undefined;
    vehicleDetails?: ManufacturerModel[] | undefined;
    vehiclesS?: string | undefined;
    offerId?: string | undefined;
    comment?: string | undefined;
    readonly riderPackageServicesString?: string | undefined;

    constructor(data?: IRiderPackageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.riderServiceBranch = _data["riderServiceBranch"];
            this.broadcastCode = _data["broadcastCode"];
            this.status = _data["status"];
            this.agentCost = _data["agentCost"];
            this.recommendedCost = _data["recommendedCost"];
            this.serviceReporter = _data["serviceReporter"];
            this.autoActive = _data["autoActive"];
            this.privateUpTo4Tons = _data["privateUpTo4Tons"];
            this.commercialUpTo4Tons = _data["commercialUpTo4Tons"];
            this.truck = _data["truck"];
            this.taxi = _data["taxi"];
            this.littleBus = _data["littleBus"];
            this.tractor = _data["tractor"];
            this.dragged = _data["dragged"];
            this.motorcycle = _data["motorcycle"];
            this.other = _data["other"];
            this.includeInPolicyPrice = _data["includeInPolicyPrice"];
            this.sideGimel = _data["sideGimel"];
            this.privateIncome = _data["privateIncome"];
            this.maxVehicleAge = _data["maxVehicleAge"];
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.comment = _data["comment"];

            if (Array.isArray(_data["vehicleOwnershipList"])) {
                this.vehicleOwnershipList = [] as any;
                for (let item of _data["vehicleOwnershipList"])
                    this.vehicleOwnershipList!.push(item);
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(RiderPackageVehicleModel.fromJS(item));
            }
            this.allVehicles = _data["allVehicles"];
            if (Array.isArray(_data["riderPackageServices"])) {
                this.riderPackageServices = [] as any;
                for (let item of _data["riderPackageServices"])
                    this.riderPackageServices!.push(RiderPackageServiceModel.fromJS(item));
            }
            if (Array.isArray(_data["allCompanies"])) {
                this.allCompanies = [] as any;
                for (let item of _data["allCompanies"])
                    this.allCompanies!.push(RiderComapnyModel.fromJS(item));
            }
            if (Array.isArray(_data["allCompaniesSelectList"])) {
                this.allCompaniesSelectList = [] as any;
                for (let item of _data["allCompaniesSelectList"])
                    this.allCompaniesSelectList!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["allSuppliers"])) {
                this.allSuppliers = [] as any;
                for (let item of _data["allSuppliers"])
                    this.allSuppliers!.push(RiderServiceSupplierModel.fromJS(item));
            }
            if (Array.isArray(_data["allServices"])) {
                this.allServices = [] as any;
                for (let item of _data["allServices"])
                    this.allServices!.push(RiderServiceModel.fromJS(item));
            }
            if (Array.isArray(_data["vehicleDetails"])) {
                this.vehicleDetails = [] as any;
                for (let item of _data["vehicleDetails"])
                    this.vehicleDetails!.push(ManufacturerModel.fromJS(item));
            }
            this.vehiclesS = _data["vehiclesS"];
            this.offerId = _data["offerId"];
            (<any>this).riderPackageServicesString = _data["riderPackageServicesString"];
        }
    }

    static fromJS(data: any): RiderPackageModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderPackageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["riderServiceBranch"] = this.riderServiceBranch;
        data["broadcastCode"] = this.broadcastCode;
        data["status"] = this.status;
        data["agentCost"] = this.agentCost;
        data["recommendedCost"] = this.recommendedCost;
        data["serviceReporter"] = this.serviceReporter;
        data["autoActive"] = this.autoActive;
        data["privateUpTo4Tons"] = this.privateUpTo4Tons;
        data["commercialUpTo4Tons"] = this.commercialUpTo4Tons;
        data["truck"] = this.truck;
        data["taxi"] = this.taxi;
        data["littleBus"] = this.littleBus;
        data["tractor"] = this.tractor;
        data["dragged"] = this.dragged;
        data["motorcycle"] = this.motorcycle;
        data["other"] = this.other;
        data["includeInPolicyPrice"] = this.includeInPolicyPrice;
        data["sideGimel"] = this.sideGimel;
        data["privateIncome"] = this.privateIncome;
        data["maxVehicleAge"] = this.maxVehicleAge;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["comment"] = this.comment;

        if (Array.isArray(this.vehicleOwnershipList)) {
            data["vehicleOwnershipList"] = [];
            for (let item of this.vehicleOwnershipList)
                data["vehicleOwnershipList"].push(item);
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["allVehicles"] = this.allVehicles;
        if (Array.isArray(this.riderPackageServices)) {
            data["riderPackageServices"] = [];
            for (let item of this.riderPackageServices)
                data["riderPackageServices"].push(item.toJSON());
        }
        if (Array.isArray(this.allCompanies)) {
            data["allCompanies"] = [];
            for (let item of this.allCompanies)
                data["allCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.allCompaniesSelectList)) {
            data["allCompaniesSelectList"] = [];
            for (let item of this.allCompaniesSelectList)
                data["allCompaniesSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.allSuppliers)) {
            data["allSuppliers"] = [];
            for (let item of this.allSuppliers)
                data["allSuppliers"].push(item.toJSON());
        }
        if (Array.isArray(this.allServices)) {
            data["allServices"] = [];
            for (let item of this.allServices)
                data["allServices"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleDetails)) {
            data["vehicleDetails"] = [];
            for (let item of this.vehicleDetails)
                data["vehicleDetails"].push(item.toJSON());
        }
        data["vehiclesS"] = this.vehiclesS;
        data["offerId"] = this.offerId;
        data["riderPackageServicesString"] = this.riderPackageServicesString;
        return data;
    }
}

export interface IRiderPackageModel {
    id?: string;
    name?: string | undefined;
    riderServiceBranch?: RiderServiceBranch;
    broadcastCode?: string | undefined;
    status?: ActivityStatus;
    agentCost?: number;
    recommendedCost?: number;
    serviceReporter?: string | undefined;
    autoActive?: YesNo;
    privateUpTo4Tons?: boolean;
    commercialUpTo4Tons?: boolean;
    truck?: boolean;
    taxi?: boolean;
    littleBus?: boolean;
    tractor?: boolean;
    dragged?: boolean;
    motorcycle?: boolean;
    other?: boolean;
    includeInPolicyPrice?: boolean;
    sideGimel?: boolean;
    privateIncome?: boolean;
    maxVehicleAge?: number;
    vehicleOwnership?: VehicleOwnership;
    vehicleOwnershipList?: VehicleOwnership2[] | undefined;
    vehicles?: RiderPackageVehicleModel[] | undefined;
    allVehicles?: boolean;
    riderPackageServices?: RiderPackageServiceModel[] | undefined;
    allCompanies?: RiderComapnyModel[] | undefined;
    allCompaniesSelectList?: SelectListItem[] | undefined;
    allSuppliers?: RiderServiceSupplierModel[] | undefined;
    allServices?: RiderServiceModel[] | undefined;
    vehicleDetails?: ManufacturerModel[] | undefined;
    vehiclesS?: string | undefined;
    offerId?: string | undefined;
    riderPackageServicesString?: string | undefined;
    comment?: string | undefined;
}

export class RiderPackageService implements IRiderPackageService {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riderPackageId?: string;
    riderPackage?: RiderPackage;
    riderServiceCompanyId?: string;
    riderServiceCompany?: RiderServiceCompany;
    riderServiceSupplierId?: string | undefined;
    riderServiceSupplier?: RiderServiceSupplier;

    constructor(data?: IRiderPackageService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.riderPackageId = _data["riderPackageId"];
            this.riderPackage = _data["riderPackage"] ? RiderPackage.fromJS(_data["riderPackage"]) : <any>undefined;
            this.riderServiceCompanyId = _data["riderServiceCompanyId"];
            this.riderServiceCompany = _data["riderServiceCompany"] ? RiderServiceCompany.fromJS(_data["riderServiceCompany"]) : <any>undefined;
            this.riderServiceSupplierId = _data["riderServiceSupplierId"];
            this.riderServiceSupplier = _data["riderServiceSupplier"] ? RiderServiceSupplier.fromJS(_data["riderServiceSupplier"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RiderPackageService {
        data = typeof data === 'object' ? data : {};
        let result = new RiderPackageService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["riderPackageId"] = this.riderPackageId;
        data["riderPackage"] = this.riderPackage ? this.riderPackage.toJSON() : <any>undefined;
        data["riderServiceCompanyId"] = this.riderServiceCompanyId;
        data["riderServiceCompany"] = this.riderServiceCompany ? this.riderServiceCompany.toJSON() : <any>undefined;
        data["riderServiceSupplierId"] = this.riderServiceSupplierId;
        data["riderServiceSupplier"] = this.riderServiceSupplier ? this.riderServiceSupplier.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRiderPackageService {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riderPackageId?: string;
    riderPackage?: RiderPackage;
    riderServiceCompanyId?: string;
    riderServiceCompany?: RiderServiceCompany;
    riderServiceSupplierId?: string | undefined;
    riderServiceSupplier?: RiderServiceSupplier;
}

export class RiderPackageServiceModel implements IRiderPackageServiceModel {
    id?: string;
    riderPackageId?: string;
    riderPackage?: RiderPackageModel;
    riderServiceCompanyId?: string;
    riderServiceCompany?: RiderServiceCompanyModel;
    riderServiceSupplierId?: string | undefined;
    riderServiceSupplier?: RiderServiceSupplierModel;

    constructor(data?: IRiderPackageServiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.riderPackageId = _data["riderPackageId"];
            this.riderPackage = _data["riderPackage"] ? RiderPackageModel.fromJS(_data["riderPackage"]) : <any>undefined;
            this.riderServiceCompanyId = _data["riderServiceCompanyId"];
            this.riderServiceCompany = _data["riderServiceCompany"] ? RiderServiceCompanyModel.fromJS(_data["riderServiceCompany"]) : <any>undefined;
            this.riderServiceSupplierId = _data["riderServiceSupplierId"];
            this.riderServiceSupplier = _data["riderServiceSupplier"] ? RiderServiceSupplierModel.fromJS(_data["riderServiceSupplier"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RiderPackageServiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderPackageServiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["riderPackageId"] = this.riderPackageId;
        data["riderPackage"] = this.riderPackage ? this.riderPackage.toJSON() : <any>undefined;
        data["riderServiceCompanyId"] = this.riderServiceCompanyId;
        data["riderServiceCompany"] = this.riderServiceCompany ? this.riderServiceCompany.toJSON() : <any>undefined;
        data["riderServiceSupplierId"] = this.riderServiceSupplierId;
        data["riderServiceSupplier"] = this.riderServiceSupplier ? this.riderServiceSupplier.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRiderPackageServiceModel {
    id?: string;
    riderPackageId?: string;
    riderPackage?: RiderPackageModel;
    riderServiceCompanyId?: string;
    riderServiceCompany?: RiderServiceCompanyModel;
    riderServiceSupplierId?: string | undefined;
    riderServiceSupplier?: RiderServiceSupplierModel;
}

export class RiderPackageVehicle implements IRiderPackageVehicle {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riderPackageId?: string;
    vehicleSubModelId?: string;

    constructor(data?: IRiderPackageVehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.riderPackageId = _data["riderPackageId"];
            this.vehicleSubModelId = _data["vehicleSubModelId"];
        }
    }

    static fromJS(data: any): RiderPackageVehicle {
        data = typeof data === 'object' ? data : {};
        let result = new RiderPackageVehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["riderPackageId"] = this.riderPackageId;
        data["vehicleSubModelId"] = this.vehicleSubModelId;
        return data;
    }
}

export interface IRiderPackageVehicle {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riderPackageId?: string;
    vehicleSubModelId?: string;
}

export class RiderPackageVehicleModel implements IRiderPackageVehicleModel {
    riderPackageId?: string;
    vehicleSubModelId?: string;

    constructor(data?: IRiderPackageVehicleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riderPackageId = _data["riderPackageId"];
            this.vehicleSubModelId = _data["vehicleSubModelId"];
        }
    }

    static fromJS(data: any): RiderPackageVehicleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderPackageVehicleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riderPackageId"] = this.riderPackageId;
        data["vehicleSubModelId"] = this.vehicleSubModelId;
        return data;
    }
}

export interface IRiderPackageVehicleModel {
    riderPackageId?: string;
    vehicleSubModelId?: string;
}

export class Riders_Packages implements IRiders_Packages {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riderId?: string;
    rider?: Rider;
    riderPackageId?: string;
    riderPackage?: RiderPackage;
    agentCost?: number;
    customerCost?: number;
    packageDescription?: string | undefined;
    authorizationNumbers?: Riders_PackagesAuthorizationNumber[] | undefined;
    log?: string | undefined;

    constructor(data?: IRiders_Packages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.riderId = _data["riderId"];
            this.rider = _data["rider"] ? Rider.fromJS(_data["rider"]) : <any>undefined;
            this.riderPackageId = _data["riderPackageId"];
            this.riderPackage = _data["riderPackage"] ? RiderPackage.fromJS(_data["riderPackage"]) : <any>undefined;
            this.agentCost = _data["agentCost"];
            this.customerCost = _data["customerCost"];
            this.packageDescription = _data["packageDescription"];
            if (Array.isArray(_data["authorizationNumbers"])) {
                this.authorizationNumbers = [] as any;
                for (let item of _data["authorizationNumbers"])
                    this.authorizationNumbers!.push(Riders_PackagesAuthorizationNumber.fromJS(item));
            }
            this.log = _data["log"];
        }
    }

    static fromJS(data: any): Riders_Packages {
        data = typeof data === 'object' ? data : {};
        let result = new Riders_Packages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["riderId"] = this.riderId;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["riderPackageId"] = this.riderPackageId;
        data["riderPackage"] = this.riderPackage ? this.riderPackage.toJSON() : <any>undefined;
        data["agentCost"] = this.agentCost;
        data["customerCost"] = this.customerCost;
        data["packageDescription"] = this.packageDescription;
        if (Array.isArray(this.authorizationNumbers)) {
            data["authorizationNumbers"] = [];
            for (let item of this.authorizationNumbers)
                data["authorizationNumbers"].push(item.toJSON());
        }
        data["log"] = this.log;
        return data;
    }
}

export interface IRiders_Packages {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riderId?: string;
    rider?: Rider;
    riderPackageId?: string;
    riderPackage?: RiderPackage;
    agentCost?: number;
    customerCost?: number;
    packageDescription?: string | undefined;
    authorizationNumbers?: Riders_PackagesAuthorizationNumber[] | undefined;
    log?: string | undefined;
}

export class Riders_PackagesAuthorizationNumber implements IRiders_PackagesAuthorizationNumber {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riders_PackagesId?: string;
    riders_Packages?: Riders_Packages;
    riderPackageServiceId?: string;
    authorizationNumber?: number | undefined;
    log?: string | undefined;

    constructor(data?: IRiders_PackagesAuthorizationNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.riders_PackagesId = _data["riders_PackagesId"];
            this.riders_Packages = _data["riders_Packages"] ? Riders_Packages.fromJS(_data["riders_Packages"]) : <any>undefined;
            this.riderPackageServiceId = _data["riderPackageServiceId"];
            this.authorizationNumber = _data["authorizationNumber"];
            this.log = _data["log"];
        }
    }

    static fromJS(data: any): Riders_PackagesAuthorizationNumber {
        data = typeof data === 'object' ? data : {};
        let result = new Riders_PackagesAuthorizationNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["riders_PackagesId"] = this.riders_PackagesId;
        data["riders_Packages"] = this.riders_Packages ? this.riders_Packages.toJSON() : <any>undefined;
        data["riderPackageServiceId"] = this.riderPackageServiceId;
        data["authorizationNumber"] = this.authorizationNumber;
        data["log"] = this.log;
        return data;
    }
}

export interface IRiders_PackagesAuthorizationNumber {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riders_PackagesId?: string;
    riders_Packages?: Riders_Packages;
    riderPackageServiceId?: string;
    authorizationNumber?: number | undefined;
    log?: string | undefined;
}

export class Riders_PackagesAuthorizationNumberModel implements IRiders_PackagesAuthorizationNumberModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    riders_PackagesId?: string;
    riders_Packages?: Riders_PackagesModel;
    riderPackageServiceId?: string;
    authorizationNumber?: number | undefined;
    log?: string | undefined;

    constructor(data?: IRiders_PackagesAuthorizationNumberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.riders_PackagesId = _data["riders_PackagesId"];
            this.riders_Packages = _data["riders_Packages"] ? Riders_PackagesModel.fromJS(_data["riders_Packages"]) : <any>undefined;
            this.riderPackageServiceId = _data["riderPackageServiceId"];
            this.authorizationNumber = _data["authorizationNumber"];
            this.log = _data["log"];
        }
    }

    static fromJS(data: any): Riders_PackagesAuthorizationNumberModel {
        data = typeof data === 'object' ? data : {};
        let result = new Riders_PackagesAuthorizationNumberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["riders_PackagesId"] = this.riders_PackagesId;
        data["riders_Packages"] = this.riders_Packages ? this.riders_Packages.toJSON() : <any>undefined;
        data["riderPackageServiceId"] = this.riderPackageServiceId;
        data["authorizationNumber"] = this.authorizationNumber;
        data["log"] = this.log;
        return data;
    }
}

export interface IRiders_PackagesAuthorizationNumberModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    riders_PackagesId?: string;
    riders_Packages?: Riders_PackagesModel;
    riderPackageServiceId?: string;
    authorizationNumber?: number | undefined;
    log?: string | undefined;
}

export class Riders_PackagesModel implements IRiders_PackagesModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    riderId?: string;
    rider?: RiderModel;
    riderPackageId?: string;
    riderPackage?: RiderPackageModel;
    agentCost?: number;
    customerCost?: number;
    packageDescription?: string | undefined;
    authorizationNumbers?: Riders_PackagesAuthorizationNumberModel[] | undefined;
    activityStatus?: number;
    constructor(data?: IRiders_PackagesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.riderId = _data["riderId"];
            this.rider = _data["rider"] ? RiderModel.fromJS(_data["rider"]) : <any>undefined;
            this.riderPackageId = _data["riderPackageId"];
            this.riderPackage = _data["riderPackage"] ? RiderPackageModel.fromJS(_data["riderPackage"]) : <any>undefined;
            this.agentCost = _data["agentCost"];
            this.customerCost = _data["customerCost"];
            this.packageDescription = _data["packageDescription"];
            if (Array.isArray(_data["authorizationNumbers"])) {
                this.authorizationNumbers = [] as any;
                for (let item of _data["authorizationNumbers"])
                    this.authorizationNumbers!.push(Riders_PackagesAuthorizationNumberModel.fromJS(item));
            }
            this.activityStatus = _data["activityStatus"];

        }
    }

    static fromJS(data: any): Riders_PackagesModel {
        data = typeof data === 'object' ? data : {};
        let result = new Riders_PackagesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["riderId"] = this.riderId;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["riderPackageId"] = this.riderPackageId;
        data["riderPackage"] = this.riderPackage ? this.riderPackage.toJSON() : <any>undefined;
        data["agentCost"] = this.agentCost;
        data["customerCost"] = this.customerCost;
        data["packageDescription"] = this.packageDescription;
        if (Array.isArray(this.authorizationNumbers)) {
            data["authorizationNumbers"] = [];
            for (let item of this.authorizationNumbers)
                data["authorizationNumbers"].push(item.toJSON());
        }
        data["activityStatus"] = this.activityStatus;
        return data;
    }
}

export interface IRiders_PackagesModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    riderId?: string;
    rider?: RiderModel;
    riderPackageId?: string;
    riderPackage?: RiderPackageModel;
    agentCost?: number;
    customerCost?: number;
    packageDescription?: string | undefined;
    authorizationNumbers?: Riders_PackagesAuthorizationNumberModel[] | undefined;
}

export class RiderService implements IRiderService {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    title?: string | undefined;
    riderServiceBranch?: RiderServiceBranch;
    riderServiceCompanies?: RiderServiceCompany[] | undefined;
    serviceReporterLink?: string | undefined;

    constructor(data?: IRiderService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.riderServiceBranch = _data["riderServiceBranch"];
            if (Array.isArray(_data["riderServiceCompanies"])) {
                this.riderServiceCompanies = [] as any;
                for (let item of _data["riderServiceCompanies"])
                    this.riderServiceCompanies!.push(RiderServiceCompany.fromJS(item));
            }
            this.serviceReporterLink = _data["serviceReporterLink"];
        }
    }

    static fromJS(data: any): RiderService {
        data = typeof data === 'object' ? data : {};
        let result = new RiderService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["riderServiceBranch"] = this.riderServiceBranch;
        if (Array.isArray(this.riderServiceCompanies)) {
            data["riderServiceCompanies"] = [];
            for (let item of this.riderServiceCompanies)
                data["riderServiceCompanies"].push(item.toJSON());
        }
        data["serviceReporterLink"] = this.serviceReporterLink;
        return data;
    }
}

export interface IRiderService {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    title?: string | undefined;
    riderServiceBranch?: RiderServiceBranch;
    riderServiceCompanies?: RiderServiceCompany[] | undefined;
    serviceReporterLink?: string | undefined;
}

/** 0 = Vehicle, 1 = Apartment */
export enum RiderServiceBranch {
    _0 = 0,
    _1 = 1,
}

export class RiderServiceCompany implements IRiderServiceCompany {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riderServiceId?: string;
    riderService?: RiderService;
    riderComapnyId?: string;
    riderComapny?: RiderComapny;
    broadcastCode?: string | undefined;

    constructor(data?: IRiderServiceCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.riderServiceId = _data["riderServiceId"];
            this.riderService = _data["riderService"] ? RiderService.fromJS(_data["riderService"]) : <any>undefined;
            this.riderComapnyId = _data["riderComapnyId"];
            this.riderComapny = _data["riderComapny"] ? RiderComapny.fromJS(_data["riderComapny"]) : <any>undefined;
            this.broadcastCode = _data["broadcastCode"];
        }
    }

    static fromJS(data: any): RiderServiceCompany {
        data = typeof data === 'object' ? data : {};
        let result = new RiderServiceCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["riderServiceId"] = this.riderServiceId;
        data["riderService"] = this.riderService ? this.riderService.toJSON() : <any>undefined;
        data["riderComapnyId"] = this.riderComapnyId;
        data["riderComapny"] = this.riderComapny ? this.riderComapny.toJSON() : <any>undefined;
        data["broadcastCode"] = this.broadcastCode;
        return data;
    }
}

export interface IRiderServiceCompany {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    riderServiceId?: string;
    riderService?: RiderService;
    riderComapnyId?: string;
    riderComapny?: RiderComapny;
    broadcastCode?: string | undefined;
}

export class RiderServiceCompanyModel implements IRiderServiceCompanyModel {
    id?: string;
    riderServiceId?: string;
    riderService?: RiderServiceModel;
    riderComapnyId?: string;
    riderComapny?: RiderComapnyModel;
    broadcastCode?: string | undefined;

    constructor(data?: IRiderServiceCompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.riderServiceId = _data["riderServiceId"];
            this.riderService = _data["riderService"] ? RiderServiceModel.fromJS(_data["riderService"]) : <any>undefined;
            this.riderComapnyId = _data["riderComapnyId"];
            this.riderComapny = _data["riderComapny"] ? RiderComapnyModel.fromJS(_data["riderComapny"]) : <any>undefined;
            this.broadcastCode = _data["broadcastCode"];
        }
    }

    static fromJS(data: any): RiderServiceCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderServiceCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["riderServiceId"] = this.riderServiceId;
        data["riderService"] = this.riderService ? this.riderService.toJSON() : <any>undefined;
        data["riderComapnyId"] = this.riderComapnyId;
        data["riderComapny"] = this.riderComapny ? this.riderComapny.toJSON() : <any>undefined;
        data["broadcastCode"] = this.broadcastCode;
        return data;
    }
}

export interface IRiderServiceCompanyModel {
    id?: string;
    riderServiceId?: string;
    riderService?: RiderServiceModel;
    riderComapnyId?: string;
    riderComapny?: RiderComapnyModel;
    broadcastCode?: string | undefined;
}

export class RiderServiceModel implements IRiderServiceModel {
    id?: string;
    title?: string | undefined;
    riderServiceBranch?: RiderServiceBranch;
    riderServiceCompanies?: RiderServiceCompanyModel[] | undefined;
    allComapnies?: RiderComapnyModel[] | undefined;
    serviceReporterLink?: string | undefined;

    constructor(data?: IRiderServiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.riderServiceBranch = _data["riderServiceBranch"];
            if (Array.isArray(_data["riderServiceCompanies"])) {
                this.riderServiceCompanies = [] as any;
                for (let item of _data["riderServiceCompanies"])
                    this.riderServiceCompanies!.push(RiderServiceCompanyModel.fromJS(item));
            }
            if (Array.isArray(_data["allComapnies"])) {
                this.allComapnies = [] as any;
                for (let item of _data["allComapnies"])
                    this.allComapnies!.push(RiderComapnyModel.fromJS(item));
            }
            this.serviceReporterLink = _data["serviceReporterLink"];
        }
    }

    static fromJS(data: any): RiderServiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderServiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["riderServiceBranch"] = this.riderServiceBranch;
        if (Array.isArray(this.riderServiceCompanies)) {
            data["riderServiceCompanies"] = [];
            for (let item of this.riderServiceCompanies)
                data["riderServiceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.allComapnies)) {
            data["allComapnies"] = [];
            for (let item of this.allComapnies)
                data["allComapnies"].push(item.toJSON());
        }
        data["serviceReporterLink"] = this.serviceReporterLink;
        return data;
    }
}

export interface IRiderServiceModel {
    id?: string;
    title?: string | undefined;
    riderServiceBranch?: RiderServiceBranch;
    riderServiceCompanies?: RiderServiceCompanyModel[] | undefined;
    allComapnies?: RiderComapnyModel[] | undefined;
    serviceReporterLink?: string | undefined;
}

export class RiderServiceSupplier implements IRiderServiceSupplier {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    connectionDetails?: string | undefined;

    constructor(data?: IRiderServiceSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.connectionDetails = _data["connectionDetails"];
        }
    }

    static fromJS(data: any): RiderServiceSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new RiderServiceSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["connectionDetails"] = this.connectionDetails;
        return data;
    }
}

export interface IRiderServiceSupplier {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    connectionDetails?: string | undefined;
}

export class RiderServiceSupplierModel implements IRiderServiceSupplierModel {
    id?: string;
    name?: string | undefined;
    connectionDetails?: string | undefined;

    constructor(data?: IRiderServiceSupplierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.connectionDetails = _data["connectionDetails"];
        }
    }

    static fromJS(data: any): RiderServiceSupplierModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderServiceSupplierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["connectionDetails"] = this.connectionDetails;
        return data;
    }
}

export interface IRiderServiceSupplierModel {
    id?: string;
    name?: string | undefined;
    connectionDetails?: string | undefined;
}

export class RidersList implements IRidersList {
    actionName?: string | undefined;
    allRowsCounter?: number;
    riders?: RiderModel[] | undefined;

    constructor(data?: IRidersList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders!.push(RiderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RidersList {
        data = typeof data === 'object' ? data : {};
        let result = new RidersList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRidersList {
    actionName?: string | undefined;
    allRowsCounter?: number;
    riders?: RiderModel[] | undefined;
}

/** 0 = Active, 1 = Freeze, 2 = Cancel, 3 = NotYetActive */
export enum RiderStatusType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4
}

/** 0 = Active, 1 = Freeze, 2 = Expired, 3 = Cancel, 4 = NotInMemci */
export enum RiderStatusTypeFilter {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class Role implements IRole {
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
    status?: ActivityStatus;
    isDeleted?: boolean;
    roleId?: number;
    roleModulePermissions?: RoleModulePermission[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["roleModulePermissions"])) {
                this.roleModulePermissions = [] as any;
                for (let item of _data["roleModulePermissions"])
                    this.roleModulePermissions!.push(RoleModulePermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["roleId"] = this.roleId;
        if (Array.isArray(this.roleModulePermissions)) {
            data["roleModulePermissions"] = [];
            for (let item of this.roleModulePermissions)
                data["roleModulePermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRole {
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
    status?: ActivityStatus;
    isDeleted?: boolean;
    roleId?: number;
    roleModulePermissions?: RoleModulePermission[] | undefined;
}

export class RoleModel implements IRoleModel {
    id?: string;
    name?: string | undefined;
    status?: ActivityStatus;
    usersInRole?: number;
    roleModulePermission?: RoleModulePermission[] | undefined;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.usersInRole = _data["usersInRole"];
            if (Array.isArray(_data["roleModulePermission"])) {
                this.roleModulePermission = [] as any;
                for (let item of _data["roleModulePermission"])
                    this.roleModulePermission!.push(RoleModulePermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["usersInRole"] = this.usersInRole;
        if (Array.isArray(this.roleModulePermission)) {
            data["roleModulePermission"] = [];
            for (let item of this.roleModulePermission)
                data["roleModulePermission"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleModel {
    id?: string;
    name?: string | undefined;
    status?: ActivityStatus;
    usersInRole?: number;
    roleModulePermission?: RoleModulePermission[] | undefined;
}

export class RoleModulePermission implements IRoleModulePermission {
    moduleName?: string | undefined;
    permissionType?: PermissionType;
    moduleRoleId?: string;

    constructor(data?: IRoleModulePermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleName = _data["moduleName"];
            this.permissionType = _data["permissionType"];
            this.moduleRoleId = _data["moduleRoleId"];
        }
    }

    static fromJS(data: any): RoleModulePermission {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModulePermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleName"] = this.moduleName;
        data["permissionType"] = this.permissionType;
        data["moduleRoleId"] = this.moduleRoleId;
        return data;
    }
}

export interface IRoleModulePermission {
    moduleName?: string | undefined;
    permissionType?: PermissionType;
    moduleRoleId?: string;
}

export class RolesModel implements IRolesModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    roles?: RoleModel[] | undefined;

    constructor(data?: IRolesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolesModel {
        data = typeof data === 'object' ? data : {};
        let result = new RolesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRolesModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    roles?: RoleModel[] | undefined;
}

export class RoleUpsertModel implements IRoleUpsertModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    roleModulePermissions?: RoleModulePermission[] | undefined;

    constructor(data?: IRoleUpsertModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            if (Array.isArray(_data["roleModulePermissions"])) {
                this.roleModulePermissions = [] as any;
                for (let item of _data["roleModulePermissions"])
                    this.roleModulePermissions!.push(RoleModulePermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleUpsertModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUpsertModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        if (Array.isArray(this.roleModulePermissions)) {
            data["roleModulePermissions"] = [];
            for (let item of this.roleModulePermissions)
                data["roleModulePermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleUpsertModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    roleModulePermissions?: RoleModulePermission[] | undefined;
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeFieldHandle {
    value?: IntPtr;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value?: IntPtr;
}

export class RuntimeTypeHandle implements IRuntimeTypeHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeTypeHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeTypeHandle {
    value?: IntPtr;
}

export class SalesPeopleLinksModel implements ISalesPeopleLinksModel {
    renewalPeriodMonth?: number;
    renewalPeriodYear?: number;
    insuranceType?: InsuranceTypes;
    insuranceCompanyId?: string | undefined;
    salesPerson?: string | undefined;
    userId?: string | undefined;
    leadStatusType?: string | undefined;
    renewalsSortingType?: RenewalsSortingType;
    readonly policyEndDate?: Date | undefined;
    renewalsSortingList?: RenewalsSorting[] | undefined;
    renewalsSalespeople?: RenewalsSalesperson[] | undefined;
    fieldName?: string | undefined;

    constructor(data?: ISalesPeopleLinksModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renewalPeriodMonth = _data["renewalPeriodMonth"];
            this.renewalPeriodYear = _data["renewalPeriodYear"];
            this.insuranceType = _data["insuranceType"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.salesPerson = _data["salesPerson"];
            this.userId = _data["userId"];
            this.leadStatusType = _data["leadStatusType"];
            this.renewalsSortingType = _data["renewalsSortingType"];
            (<any>this).policyEndDate = _data["policyEndDate"] ? new Date(_data["policyEndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["renewalsSortingList"])) {
                this.renewalsSortingList = [] as any;
                for (let item of _data["renewalsSortingList"])
                    this.renewalsSortingList!.push(RenewalsSorting.fromJS(item));
            }
            if (Array.isArray(_data["renewalsSalespeople"])) {
                this.renewalsSalespeople = [] as any;
                for (let item of _data["renewalsSalespeople"])
                    this.renewalsSalespeople!.push(RenewalsSalesperson.fromJS(item));
            }
            this.fieldName = _data["fieldName"];
        }
    }

    static fromJS(data: any): SalesPeopleLinksModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesPeopleLinksModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renewalPeriodMonth"] = this.renewalPeriodMonth;
        data["renewalPeriodYear"] = this.renewalPeriodYear;
        data["insuranceType"] = this.insuranceType;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["salesPerson"] = this.salesPerson;
        data["userId"] = this.userId;
        data["leadStatusType"] = this.leadStatusType;
        data["renewalsSortingType"] = this.renewalsSortingType;
        data["policyEndDate"] = this.policyEndDate ? this.policyEndDate.toISOString() : <any>undefined;
        if (Array.isArray(this.renewalsSortingList)) {
            data["renewalsSortingList"] = [];
            for (let item of this.renewalsSortingList)
                data["renewalsSortingList"].push(item.toJSON());
        }
        if (Array.isArray(this.renewalsSalespeople)) {
            data["renewalsSalespeople"] = [];
            for (let item of this.renewalsSalespeople)
                data["renewalsSalespeople"].push(item.toJSON());
        }
        data["fieldName"] = this.fieldName;
        return data;
    }
}

export interface ISalesPeopleLinksModel {
    renewalPeriodMonth?: number;
    renewalPeriodYear?: number;
    insuranceType?: InsuranceTypes;
    insuranceCompanyId?: string | undefined;
    salesPerson?: string | undefined;
    userId?: string | undefined;
    leadStatusType?: string | undefined;
    renewalsSortingType?: RenewalsSortingType;
    policyEndDate?: Date | undefined;
    renewalsSortingList?: RenewalsSorting[] | undefined;
    renewalsSalespeople?: RenewalsSalesperson[] | undefined;
    fieldName?: string | undefined;
}

export class SecureString implements ISecureString {
    length?: number;

    constructor(data?: ISecureString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.length = _data["length"];
        }
    }

    static fromJS(data: any): SecureString {
        data = typeof data === 'object' ? data : {};
        let result = new SecureString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        return data;
    }
}

export interface ISecureString {
    length?: number;
}

/** 0 = None, 1 = Level1, 2 = Level2 */
export enum SecurityRuleSet {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class SelectListGroup implements ISelectListGroup {
    disabled?: boolean;
    name?: string | undefined;

    constructor(data?: ISelectListGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SelectListGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SelectListGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        data["name"] = this.name;
        return data;
    }
}

export interface ISelectListGroup {
    disabled?: boolean;
    name?: string | undefined;
}

export class SelectListItem implements ISelectListItem {
    disabled?: boolean;
    group?: SelectListGroup;
    selected?: boolean;
    text?: string | undefined;
    value?: string | undefined;

    constructor(data?: ISelectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            this.group = _data["group"] ? SelectListGroup.fromJS(_data["group"]) : <any>undefined;
            this.selected = _data["selected"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SelectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["selected"] = this.selected;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }
}

export interface ISelectListItem {
    disabled?: boolean;
    group?: SelectListGroup;
    selected?: boolean;
    text?: string | undefined;
    value?: string | undefined;
}

export class SendMailDataModel implements ISendMailDataModel {
    to?: string[] | undefined;
    cc?: string[] | undefined;
    bcc?: string[] | undefined;
    body?: string | undefined;
    subject?: string | undefined;
    linkedId?: string | undefined;
    folder?: SpecialFolder;
    folderName?: string | undefined;
    attachments?: string[] | undefined;
    documentsAttachments?: string[] | undefined;
    documentsAttachmentsDetails?: CustomerDocument[] | undefined;
    sendMailType?: SendMailType;

    constructor(data?: ISendMailDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(item);
            }
            this.body = _data["body"];
            this.subject = _data["subject"];
            this.linkedId = _data["linkedId"];
            this.folder = _data["folder"];
            this.folderName = _data["folderName"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            if (Array.isArray(_data["documentsAttachments"])) {
                this.documentsAttachments = [] as any;
                for (let item of _data["documentsAttachments"])
                    this.documentsAttachments!.push(item);
            }
            if (Array.isArray(_data["documentsAttachmentsDetails"])) {
                this.documentsAttachmentsDetails = [] as any;
                for (let item of _data["documentsAttachmentsDetails"])
                    this.documentsAttachmentsDetails!.push(CustomerDocument.fromJS(item));
            }
            this.sendMailType = _data["sendMailType"];
        }
    }

    static fromJS(data: any): SendMailDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendMailDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item);
        }
        data["body"] = this.body;
        data["subject"] = this.subject;
        data["linkedId"] = this.linkedId;
        data["folder"] = this.folder;
        data["folderName"] = this.folderName;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        if (Array.isArray(this.documentsAttachments)) {
            data["documentsAttachments"] = [];
            for (let item of this.documentsAttachments)
                data["documentsAttachments"].push(item);
        }
        if (Array.isArray(this.documentsAttachmentsDetails)) {
            data["documentsAttachmentsDetails"] = [];
            for (let item of this.documentsAttachmentsDetails)
                data["documentsAttachmentsDetails"].push(item.toJSON());
        }
        data["sendMailType"] = this.sendMailType;
        return data;
    }
}

export interface ISendMailDataModel {
    to?: string[] | undefined;
    cc?: string[] | undefined;
    bcc?: string[] | undefined;
    body?: string | undefined;
    subject?: string | undefined;
    linkedId?: string | undefined;
    folder?: SpecialFolder;
    folderName?: string | undefined;
    attachments?: string[] | undefined;
    documentsAttachments?: string[] | undefined;
    documentsAttachmentsDetails?: CustomerDocument[] | undefined;
    sendMailType?: SendMailType;
}

/** 0 = REGULAR, 1 = REPLY, 2 = FORWARD */
export enum SendMailType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = start, 1 = ShlomoSixt */
export enum ServicesProvider {
    _0 = 0,
    _1 = 1,
}

export class SetTransfer implements ISetTransfer {
    transferTo?: string | undefined;
    TransferFromUserId?: string | undefined;
    customerPhoneNumber?: string | undefined;
    transferType?: number | undefined;

    constructor(data?: ISetTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transferTo = _data["transferTo"];
            this.TransferFromUserId = _data["TransferFromUserId"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
            this.transferType = _data["transferType"];
        }
    }

    static fromJS(data: any): SetTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new SetTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transferTo"] = this.transferTo;
        data["TransferFromUserId"] = this.TransferFromUserId;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["transferType"] = this.transferType;
        return data;
    }
}

export interface ISetTransfer {
    transferTo?: string | undefined;
    transferToName?: string | undefined;
    customerPhoneNumber?: string | undefined;
}

export class SetWaMessageModel implements ISetWaMessageModel {
    text?: string | undefined;
    customerPhoneNumber?: string | undefined;

    constructor(data?: ISetWaMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
        }
    }

    static fromJS(data: any): SetWaMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetWaMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        return data;
    }
}

export interface ISetWaMessageModel {
    text?: string | undefined;
    customerPhoneNumber?: string | undefined;
}

/** 0 = HANACHAT_AMLA, 1 = HANACHA3, 2 = HANACHA2, 3 = EXCESS_MEKIF */
export enum ShlomoDiscountType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SigningFilterModel implements ISigningFilterModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    page?: number | undefined;
    signingPersonId?: string | undefined;
    leadSource?: LeadSource;
    insuranceType?: InsuranceTypes;
    productionType?: ProductionType;
    handlerId?: string | undefined;
    agentId?: string | undefined;
    insuranceCompanyId?: string | undefined;
    status?: number;
    branchId?: string | undefined;
    stationUserId?: string | undefined;

    constructor(data?: ISigningFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
            this.page = _data["page"];
            this.signingPersonId = _data["signingPersonId"];
            this.leadSource = _data["leadSource"];
            this.insuranceType = _data["insuranceType"];
            this.productionType = _data["productionType"];
            this.handlerId = _data["handlerId"];
            this.agentId = _data["agentId"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.status = _data["status"];
            this.branchId = _data["branchId"];
            this.stationUserId = _data["stationUserId"];
        }
    }

    static fromJS(data: any): SigningFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new SigningFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["signingPersonId"] = this.signingPersonId;
        data["leadSource"] = this.leadSource;
        data["insuranceType"] = this.insuranceType;
        data["productionType"] = this.productionType;
        data["handlerId"] = this.handlerId;
        data["agentId"] = this.agentId;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["status"] = this.status;
        data["branchId"] = this.branchId;
        data["stationUserId"] = this.stationUserId;
        return data;
    }
}

export interface ISigningFilterModel {
    searchTerm?: string | undefined;
    sortBy?: SortModel[] | undefined;
    page?: number | undefined;
    signingPersonId?: string | undefined;
    leadSource?: LeadSource;
    insuranceType?: InsuranceTypes;
    productionType?: ProductionType;
    handlerId?: string | undefined;
    agentId?: string | undefined;
    insuranceCompanyId?: string | undefined;
    status?: number;
    branchId?: string | undefined;
    stationUserId?: string | undefined;
}

export class SigningModel implements ISigningModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    policyId?: string;
    policy?: PolicyModel;
    leadId?: string;
    lead?: LeadModel;
    comment?: string | undefined;
    lien?: boolean;
    protectionCertificate?: boolean;
    lackOfClaims?: boolean;
    payment?: boolean;
    sendUser?: boolean;
    end?: boolean;

    constructor(data?: ISigningModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.policyId = _data["policyId"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            this.leadId = _data["leadId"];
            this.lead = _data["lead"] ? LeadModel.fromJS(_data["lead"]) : <any>undefined;
            this.comment = _data["comment"];
            this.lien = _data["lien"];
            this.protectionCertificate = _data["protectionCertificate"];
            this.lackOfClaims = _data["lackOfClaims"];
            this.payment = _data["payment"];
            this.sendUser = _data["sendUser"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): SigningModel {
        data = typeof data === 'object' ? data : {};
        let result = new SigningModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["policyId"] = this.policyId;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["leadId"] = this.leadId;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["lien"] = this.lien;
        data["protectionCertificate"] = this.protectionCertificate;
        data["lackOfClaims"] = this.lackOfClaims;
        data["payment"] = this.payment;
        data["sendUser"] = this.sendUser;
        data["end"] = this.end;
        return data;
    }
}

export interface ISigningModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    policyId?: string;
    policy?: PolicyModel;
    leadId?: string;
    lead?: LeadModel;
    comment?: string | undefined;
    lien?: boolean;
    protectionCertificate?: boolean;
    lackOfClaims?: boolean;
    payment?: boolean;
    sendUser?: boolean;
    end?: boolean;
}

export class SigningPageModel implements ISigningPageModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    signings?: SigningModel[] | undefined;
    signingPeople?: SelectListItem[] | undefined;
    handlers?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    branches?: BranchesDepartmentsUsersModel;
    roleId?: string | undefined;

    constructor(data?: ISigningPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["signings"])) {
                this.signings = [] as any;
                for (let item of _data["signings"])
                    this.signings!.push(SigningModel.fromJS(item));
            }
            if (Array.isArray(_data["signingPeople"])) {
                this.signingPeople = [] as any;
                for (let item of _data["signingPeople"])
                    this.signingPeople!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["handlers"])) {
                this.handlers = [] as any;
                for (let item of _data["handlers"])
                    this.handlers!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            this.branches = _data["branches"] ? BranchesDepartmentsUsersModel.fromJS(_data["branches"]) : <any>undefined;
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): SigningPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new SigningPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.signings)) {
            data["signings"] = [];
            for (let item of this.signings)
                data["signings"].push(item.toJSON());
        }
        if (Array.isArray(this.signingPeople)) {
            data["signingPeople"] = [];
            for (let item of this.signingPeople)
                data["signingPeople"].push(item.toJSON());
        }
        if (Array.isArray(this.handlers)) {
            data["handlers"] = [];
            for (let item of this.handlers)
                data["handlers"].push(item.toJSON());
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        data["branches"] = this.branches ? this.branches.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ISigningPageModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    signings?: SigningModel[] | undefined;
    signingPeople?: SelectListItem[] | undefined;
    handlers?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    branches?: BranchesDepartmentsUsersModel;
    roleId?: string | undefined;
}

export class Simulator implements ISimulator {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    lead?: Lead;
    startDate?: Date;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    carLicensePlate?: string | undefined;
    carYear?: number;
    modelCode?: string | undefined;
    vehicleSubModelId?: string;
    vehicleSubModel?: VehicleSubModel;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    entryToRoadDate?: Date;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    licenseNumber?: string | undefined;
    customerId?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: boolean;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string;
    involvedAddress?: CustomerAddress;
    offers?: SimulatorOffer[] | undefined;

    constructor(data?: ISimulator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.lead = _data["lead"] ? Lead.fromJS(_data["lead"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.insuranceType = _data["insuranceType"];
            this.authorizedToDrive = _data["authorizedToDrive"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.carLicensePlate = _data["carLicensePlate"];
            this.carYear = _data["carYear"];
            this.modelCode = _data["modelCode"];
            this.vehicleSubModelId = _data["vehicleSubModelId"];
            this.vehicleSubModel = _data["vehicleSubModel"] ? VehicleSubModel.fromJS(_data["vehicleSubModel"]) : <any>undefined;
            this.esp = _data["esp"];
            this.fcw = _data["fcw"];
            this.ldw = _data["ldw"];
            this.entryToRoadDate = _data["entryToRoadDate"] ? new Date(_data["entryToRoadDate"].toString()) : <any>undefined;
            this.passedTypeOfInsurance1 = _data["passedTypeOfInsurance1"];
            this.sueNumber1 = _data["sueNumber1"];
            this.insuranceCompanyId1 = _data["insuranceCompanyId1"];
            this.passedTypeOfInsurance2 = _data["passedTypeOfInsurance2"];
            this.sueNumber2 = _data["sueNumber2"];
            this.insuranceCompanyId2 = _data["insuranceCompanyId2"];
            this.passedTypeOfInsurance3 = _data["passedTypeOfInsurance3"];
            this.sueNumber3 = _data["sueNumber3"];
            this.insuranceCompanyId3 = _data["insuranceCompanyId3"];
            this.passedTypeOfInsurance4 = _data["passedTypeOfInsurance4"];
            this.sueNumber4 = _data["sueNumber4"];
            this.insuranceCompanyId4 = _data["insuranceCompanyId4"];
            this.bodyClaimsAmount = _data["bodyClaimsAmount"];
            this.revocationsAmount = _data["revocationsAmount"];
            this.noInsurance = _data["noInsurance"];
            this.licenseNumber = _data["licenseNumber"];
            this.customerId = _data["customerId"];
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.impairmentDeductible = _data["impairmentDeductible"];
            this.renovationAgentsOffice = _data["renovationAgentsOffice"];
            this.renovationCompany = _data["renovationCompany"];
            this.mainVehicle = _data["mainVehicle"];
            this.autodirection = _data["autodirection"];
            this.driveInShabbat = _data["driveInShabbat"];
            this.newForOld = _data["newForOld"];
            this.automaticInd = _data["automaticInd"];
            this.engineVolume = _data["engineVolume"];
            this.isVehicleEnslaved = _data["isVehicleEnslaved"];
            this.involvedPartyType = _data["involvedPartyType"];
            this.involvedBank = _data["involvedBank"];
            this.involvedBankBranch = _data["involvedBankBranch"];
            this.involvedName = _data["involvedName"];
            this.involvedAddressId = _data["involvedAddressId"];
            this.involvedAddress = _data["involvedAddress"] ? CustomerAddress.fromJS(_data["involvedAddress"]) : <any>undefined;
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(SimulatorOffer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Simulator {
        data = typeof data === 'object' ? data : {};
        let result = new Simulator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["insuranceType"] = this.insuranceType;
        data["authorizedToDrive"] = this.authorizedToDrive;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["carLicensePlate"] = this.carLicensePlate;
        data["carYear"] = this.carYear;
        data["modelCode"] = this.modelCode;
        data["vehicleSubModelId"] = this.vehicleSubModelId;
        data["vehicleSubModel"] = this.vehicleSubModel ? this.vehicleSubModel.toJSON() : <any>undefined;
        data["esp"] = this.esp;
        data["fcw"] = this.fcw;
        data["ldw"] = this.ldw;
        data["entryToRoadDate"] = this.entryToRoadDate ? this.entryToRoadDate.toISOString() : <any>undefined;
        data["passedTypeOfInsurance1"] = this.passedTypeOfInsurance1;
        data["sueNumber1"] = this.sueNumber1;
        data["insuranceCompanyId1"] = this.insuranceCompanyId1;
        data["passedTypeOfInsurance2"] = this.passedTypeOfInsurance2;
        data["sueNumber2"] = this.sueNumber2;
        data["insuranceCompanyId2"] = this.insuranceCompanyId2;
        data["passedTypeOfInsurance3"] = this.passedTypeOfInsurance3;
        data["sueNumber3"] = this.sueNumber3;
        data["insuranceCompanyId3"] = this.insuranceCompanyId3;
        data["passedTypeOfInsurance4"] = this.passedTypeOfInsurance4;
        data["sueNumber4"] = this.sueNumber4;
        data["insuranceCompanyId4"] = this.insuranceCompanyId4;
        data["bodyClaimsAmount"] = this.bodyClaimsAmount;
        data["revocationsAmount"] = this.revocationsAmount;
        data["noInsurance"] = this.noInsurance;
        data["licenseNumber"] = this.licenseNumber;
        data["customerId"] = this.customerId;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["impairmentDeductible"] = this.impairmentDeductible;
        data["renovationAgentsOffice"] = this.renovationAgentsOffice;
        data["renovationCompany"] = this.renovationCompany;
        data["mainVehicle"] = this.mainVehicle;
        data["autodirection"] = this.autodirection;
        data["driveInShabbat"] = this.driveInShabbat;
        data["newForOld"] = this.newForOld;
        data["automaticInd"] = this.automaticInd;
        data["engineVolume"] = this.engineVolume;
        data["isVehicleEnslaved"] = this.isVehicleEnslaved;
        data["involvedPartyType"] = this.involvedPartyType;
        data["involvedBank"] = this.involvedBank;
        data["involvedBankBranch"] = this.involvedBankBranch;
        data["involvedName"] = this.involvedName;
        data["involvedAddressId"] = this.involvedAddressId;
        data["involvedAddress"] = this.involvedAddress ? this.involvedAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimulator {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    lead?: Lead;
    startDate?: Date;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    carLicensePlate?: string | undefined;
    carYear?: number;
    modelCode?: string | undefined;
    vehicleSubModelId?: string;
    vehicleSubModel?: VehicleSubModel;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    entryToRoadDate?: Date;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    licenseNumber?: string | undefined;
    customerId?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: boolean;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string;
    involvedAddress?: CustomerAddress;
    offers?: SimulatorOffer[] | undefined;
}

export class SimulatorDetailsModel implements ISimulatorDetailsModel {
    postalCode?: string | undefined;
    insuranceStartDate?: InsuranceStartDate;
    drivingOnShabbat?: YesNo;

    constructor(data?: ISimulatorDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCode = _data["postalCode"];
            this.insuranceStartDate = _data["insuranceStartDate"];
            this.drivingOnShabbat = _data["drivingOnShabbat"];
        }
    }

    static fromJS(data: any): SimulatorDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCode"] = this.postalCode;
        data["insuranceStartDate"] = this.insuranceStartDate;
        data["drivingOnShabbat"] = this.drivingOnShabbat;
        return data;
    }
}

export interface ISimulatorDetailsModel {
    postalCode?: string | undefined;
    insuranceStartDate?: InsuranceStartDate;
    drivingOnShabbat?: YesNo;
}

export class SimulatorModel implements ISimulatorModel {
    id?: string;
    leadId?: string;
    lead?: Lead;
    startDate?: Date | undefined;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    deductible?: YesNo;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungIdentifier?: string | undefined;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainIdentifier?: string | undefined;
    driverMainBirthDate?: Date | undefined;
    carLicensePlate?: string | undefined;
    carYear?: number;
    modelCode?: string | undefined;
    vehicleSubModelId?: string;
    vehicleSubModel?: VehicleSubModel;
    vehicleModel?: VehicleModelModel;
    vehicleManufacturer?: ManufacturerModel;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    entryToRoadDate?: Date;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    licenseNumber?: string | undefined;
    customerId?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveOnShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    shildaNumber?: string | undefined;
    isVehicleEnslaved?: YesNo;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string;
    involvedAddress?: CustomerAddress;
    ownership?: VehicleOwnership;
    offers?: SimulatorOfferModel[] | undefined;

    constructor(data?: ISimulatorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.lead = _data["lead"] ? Lead.fromJS(_data["lead"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.insuranceType = _data["insuranceType"];
            this.deductible = _data["deductible"];
            this.authorizedToDrive = _data["authorizedToDrive"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungIdentifier = _data["driverYoungIdentifier"];
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.driverMainIdentifier = _data["driverMainIdentifier"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.carLicensePlate = _data["carLicensePlate"];
            this.carYear = _data["carYear"];
            this.modelCode = _data["modelCode"];
            this.vehicleSubModelId = _data["vehicleSubModelId"];
            this.vehicleSubModel = _data["vehicleSubModel"] ? VehicleSubModel.fromJS(_data["vehicleSubModel"]) : <any>undefined;
            this.vehicleModel = _data["vehicleModel"] ? VehicleModelModel.fromJS(_data["vehicleModel"]) : <any>undefined;
            this.vehicleManufacturer = _data["vehicleManufacturer"] ? ManufacturerModel.fromJS(_data["vehicleManufacturer"]) : <any>undefined;
            this.esp = _data["esp"];
            this.fcw = _data["fcw"];
            this.ldw = _data["ldw"];
            this.entryToRoadDate = _data["entryToRoadDate"] ? new Date(_data["entryToRoadDate"].toString()) : <any>undefined;
            this.passedTypeOfInsurance1 = _data["passedTypeOfInsurance1"];
            this.sueNumber1 = _data["sueNumber1"];
            this.insuranceCompanyId1 = _data["insuranceCompanyId1"];
            this.passedTypeOfInsurance2 = _data["passedTypeOfInsurance2"];
            this.sueNumber2 = _data["sueNumber2"];
            this.insuranceCompanyId2 = _data["insuranceCompanyId2"];
            this.passedTypeOfInsurance3 = _data["passedTypeOfInsurance3"];
            this.sueNumber3 = _data["sueNumber3"];
            this.insuranceCompanyId3 = _data["insuranceCompanyId3"];
            this.passedTypeOfInsurance4 = _data["passedTypeOfInsurance4"];
            this.sueNumber4 = _data["sueNumber4"];
            this.insuranceCompanyId4 = _data["insuranceCompanyId4"];
            this.bodyClaimsAmount = _data["bodyClaimsAmount"];
            this.revocationsAmount = _data["revocationsAmount"];
            this.noInsurance = _data["noInsurance"];
            this.licenseNumber = _data["licenseNumber"];
            this.customerId = _data["customerId"];
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.impairmentDeductible = _data["impairmentDeductible"];
            this.renovationAgentsOffice = _data["renovationAgentsOffice"];
            this.renovationCompany = _data["renovationCompany"];
            this.mainVehicle = _data["mainVehicle"];
            this.autodirection = _data["autodirection"];
            this.driveOnShabbat = _data["driveOnShabbat"];
            this.newForOld = _data["newForOld"];
            this.automaticInd = _data["automaticInd"];
            this.engineVolume = _data["engineVolume"];
            this.shildaNumber = _data["shildaNumber"];
            this.isVehicleEnslaved = _data["isVehicleEnslaved"];
            this.involvedPartyType = _data["involvedPartyType"];
            this.involvedBank = _data["involvedBank"];
            this.involvedBankBranch = _data["involvedBankBranch"];
            this.involvedName = _data["involvedName"];
            this.involvedAddressId = _data["involvedAddressId"];
            this.involvedAddress = _data["involvedAddress"] ? CustomerAddress.fromJS(_data["involvedAddress"]) : <any>undefined;
            this.ownership = _data["ownership"];
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(SimulatorOfferModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimulatorModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["insuranceType"] = this.insuranceType;
        data["deductible"] = this.deductible;
        data["authorizedToDrive"] = this.authorizedToDrive;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungIdentifier"] = this.driverYoungIdentifier;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["driverMainIdentifier"] = this.driverMainIdentifier;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["carLicensePlate"] = this.carLicensePlate;
        data["carYear"] = this.carYear;
        data["modelCode"] = this.modelCode;
        data["vehicleSubModelId"] = this.vehicleSubModelId;
        data["vehicleSubModel"] = this.vehicleSubModel ? this.vehicleSubModel.toJSON() : <any>undefined;
        data["vehicleModel"] = this.vehicleModel ? this.vehicleModel.toJSON() : <any>undefined;
        data["vehicleManufacturer"] = this.vehicleManufacturer ? this.vehicleManufacturer.toJSON() : <any>undefined;
        data["esp"] = this.esp;
        data["fcw"] = this.fcw;
        data["ldw"] = this.ldw;
        data["entryToRoadDate"] = this.entryToRoadDate ? this.entryToRoadDate.toISOString() : <any>undefined;
        data["passedTypeOfInsurance1"] = this.passedTypeOfInsurance1;
        data["sueNumber1"] = this.sueNumber1;
        data["insuranceCompanyId1"] = this.insuranceCompanyId1;
        data["passedTypeOfInsurance2"] = this.passedTypeOfInsurance2;
        data["sueNumber2"] = this.sueNumber2;
        data["insuranceCompanyId2"] = this.insuranceCompanyId2;
        data["passedTypeOfInsurance3"] = this.passedTypeOfInsurance3;
        data["sueNumber3"] = this.sueNumber3;
        data["insuranceCompanyId3"] = this.insuranceCompanyId3;
        data["passedTypeOfInsurance4"] = this.passedTypeOfInsurance4;
        data["sueNumber4"] = this.sueNumber4;
        data["insuranceCompanyId4"] = this.insuranceCompanyId4;
        data["bodyClaimsAmount"] = this.bodyClaimsAmount;
        data["revocationsAmount"] = this.revocationsAmount;
        data["noInsurance"] = this.noInsurance;
        data["licenseNumber"] = this.licenseNumber;
        data["customerId"] = this.customerId;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["impairmentDeductible"] = this.impairmentDeductible;
        data["renovationAgentsOffice"] = this.renovationAgentsOffice;
        data["renovationCompany"] = this.renovationCompany;
        data["mainVehicle"] = this.mainVehicle;
        data["autodirection"] = this.autodirection;
        data["driveOnShabbat"] = this.driveOnShabbat;
        data["newForOld"] = this.newForOld;
        data["automaticInd"] = this.automaticInd;
        data["engineVolume"] = this.engineVolume;
        data["shildaNumber"] = this.shildaNumber;
        data["isVehicleEnslaved"] = this.isVehicleEnslaved;
        data["involvedPartyType"] = this.involvedPartyType;
        data["involvedBank"] = this.involvedBank;
        data["involvedBankBranch"] = this.involvedBankBranch;
        data["involvedName"] = this.involvedName;
        data["involvedAddressId"] = this.involvedAddressId;
        data["involvedAddress"] = this.involvedAddress ? this.involvedAddress.toJSON() : <any>undefined;
        data["ownership"] = this.ownership;
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimulatorModel {
    id?: string;
    leadId?: string;
    lead?: Lead;
    startDate?: Date | undefined;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    deductible?: YesNo;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungIdentifier?: string | undefined;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainIdentifier?: string | undefined;
    driverMainBirthDate?: Date | undefined;
    carLicensePlate?: string | undefined;
    carYear?: number;
    modelCode?: string | undefined;
    vehicleSubModelId?: string;
    vehicleSubModel?: VehicleSubModel;
    vehicleModel?: VehicleModelModel;
    vehicleManufacturer?: ManufacturerModel;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    entryToRoadDate?: Date;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    licenseNumber?: string | undefined;
    customerId?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveOnShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    shildaNumber?: string | undefined;
    isVehicleEnslaved?: YesNo;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string;
    involvedAddress?: CustomerAddress;
    ownership?: VehicleOwnership;
    offers?: SimulatorOfferModel[] | undefined;
}

export class SimulatorOffer implements ISimulatorOffer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    offerIdentity?: number;
    lead?: Lead;
    isPolicyOffer?: number;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompany;
    cascoAndDudy?: number;
    finalPremium?: number;
    dudyPremium?: number;
    basicPremium?: number;
    roadServices?: number;
    protection?: number;
    routeId?: number;
    collectiveId?: number;
    comments?: string | undefined;
    cascoPremium?: number | undefined;
    kaskoNumberOfPayments?: number;
    compulsoryPremium?: number | undefined;
    agentDetailsId?: string | undefined;
    agentDetails?: AgentDetails;
    compulsoryNumberOfPayments?: number;
    payerName?: string | undefined;
    payerPhone?: string | undefined;
    coscoExpectedFee?: number;
    coscoExpectedFeePercent?: number;
    discounts?: OfferDiscount[] | undefined;
    clientIp?: string | undefined;
    paymentToken?: string | undefined;
    paymentTokenId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungIdentifier?: string | undefined;
    driverMainIdentifier?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    carLicensePlate?: string | undefined;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    customerId?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: boolean;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string | undefined;
    involvedAddress?: CustomerAddress;
    vehicleId?: string | undefined;
    vehicle?: Vehicle;
    insuranceCompanyRouteId?: string | undefined;
    insuranceCompanyRoute?: InsuranceCompanyRoute;
    riders?: LeadRider[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identifier?: string | undefined;
    identityType?: IdentityType;
    dateOfBirth?: Date | undefined;
    identityCardIssueDate?: Date | undefined;
    city?: string | undefined;
    street?: string | undefined;
    phoneNumber1?: string | undefined;
    email?: string | undefined;
    licenseNumber?: string | undefined;
    houseNumber?: number | undefined;
    ownerIsMainDriver?: boolean | undefined;

    constructor(data?: ISimulatorOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.driveInShabbat = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.offerIdentity = _data["offerIdentity"];
            this.lead = _data["lead"] ? Lead.fromJS(_data["lead"]) : <any>undefined;
            this.isPolicyOffer = _data["isPolicyOffer"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.cascoAndDudy = _data["cascoAndDudy"];
            this.finalPremium = _data["finalPremium"];
            this.dudyPremium = _data["dudyPremium"];
            this.basicPremium = _data["basicPremium"];
            this.roadServices = _data["roadServices"];
            this.protection = _data["protection"];
            this.routeId = _data["routeId"];
            this.collectiveId = _data["collectiveId"];
            this.comments = _data["comments"];
            this.cascoPremium = _data["cascoPremium"];
            this.kaskoNumberOfPayments = _data["kaskoNumberOfPayments"];
            this.compulsoryPremium = _data["compulsoryPremium"];
            this.agentDetailsId = _data["agentDetailsId"];
            this.agentDetails = _data["agentDetails"] ? AgentDetails.fromJS(_data["agentDetails"]) : <any>undefined;
            this.compulsoryNumberOfPayments = _data["compulsoryNumberOfPayments"];
            this.payerName = _data["payerName"];
            this.payerPhone = _data["payerPhone"];
            this.coscoExpectedFee = _data["coscoExpectedFee"];
            this.coscoExpectedFeePercent = _data["coscoExpectedFeePercent"];
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(OfferDiscount.fromJS(item));
            }
            this.clientIp = _data["clientIp"];
            this.paymentToken = _data["paymentToken"];
            this.paymentTokenId = _data["paymentTokenId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.insuranceType = _data["insuranceType"];
            this.authorizedToDrive = _data["authorizedToDrive"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.driverYoungIdentifier = _data["driverYoungIdentifier"];
            this.driverMainIdentifier = _data["driverMainIdentifier"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.carLicensePlate = _data["carLicensePlate"];
            this.passedTypeOfInsurance1 = _data["passedTypeOfInsurance1"];
            this.sueNumber1 = _data["sueNumber1"];
            this.insuranceCompanyId1 = _data["insuranceCompanyId1"];
            this.passedTypeOfInsurance2 = _data["passedTypeOfInsurance2"];
            this.sueNumber2 = _data["sueNumber2"];
            this.insuranceCompanyId2 = _data["insuranceCompanyId2"];
            this.passedTypeOfInsurance3 = _data["passedTypeOfInsurance3"];
            this.sueNumber3 = _data["sueNumber3"];
            this.insuranceCompanyId3 = _data["insuranceCompanyId3"];
            this.passedTypeOfInsurance4 = _data["passedTypeOfInsurance4"];
            this.sueNumber4 = _data["sueNumber4"];
            this.insuranceCompanyId4 = _data["insuranceCompanyId4"];
            this.bodyClaimsAmount = _data["bodyClaimsAmount"];
            this.revocationsAmount = _data["revocationsAmount"];
            this.noInsurance = _data["noInsurance"];
            this.customerId = _data["customerId"];
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.impairmentDeductible = _data["impairmentDeductible"];
            this.renovationAgentsOffice = _data["renovationAgentsOffice"];
            this.renovationCompany = _data["renovationCompany"];
            this.mainVehicle = _data["mainVehicle"];
            this.autodirection = _data["autodirection"];
            this.driveInShabbat = _data["driveInShabbat"] !== undefined ? _data["driveInShabbat"] : true;
            this.newForOld = _data["newForOld"];
            this.automaticInd = _data["automaticInd"];
            this.engineVolume = _data["engineVolume"];
            this.isVehicleEnslaved = _data["isVehicleEnslaved"];
            this.involvedPartyType = _data["involvedPartyType"];
            this.involvedBank = _data["involvedBank"];
            this.involvedBankBranch = _data["involvedBankBranch"];
            this.involvedName = _data["involvedName"];
            this.involvedAddressId = _data["involvedAddressId"];
            this.involvedAddress = _data["involvedAddress"] ? CustomerAddress.fromJS(_data["involvedAddress"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.insuranceCompanyRouteId = _data["insuranceCompanyRouteId"];
            this.insuranceCompanyRoute = _data["insuranceCompanyRoute"] ? InsuranceCompanyRoute.fromJS(_data["insuranceCompanyRoute"]) : <any>undefined;
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders!.push(LeadRider.fromJS(item));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.identifier = _data["identifier"];
            this.identityType = _data["identityType"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.identityCardIssueDate = _data["identityCardIssueDate"] ? new Date(_data["identityCardIssueDate"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.street = _data["street"];
            this.phoneNumber1 = _data["phoneNumber1"];
            this.email = _data["email"];
            this.licenseNumber = _data["licenseNumber"];
            this.houseNumber = _data["houseNumber"];
            this.ownerIsMainDriver = _data["ownerIsMainDriver"];
        }
    }

    static fromJS(data: any): SimulatorOffer {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorOffer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["offerIdentity"] = this.offerIdentity;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["isPolicyOffer"] = this.isPolicyOffer;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["cascoAndDudy"] = this.cascoAndDudy;
        data["finalPremium"] = this.finalPremium;
        data["dudyPremium"] = this.dudyPremium;
        data["basicPremium"] = this.basicPremium;
        data["roadServices"] = this.roadServices;
        data["protection"] = this.protection;
        data["routeId"] = this.routeId;
        data["collectiveId"] = this.collectiveId;
        data["comments"] = this.comments;
        data["cascoPremium"] = this.cascoPremium;
        data["kaskoNumberOfPayments"] = this.kaskoNumberOfPayments;
        data["compulsoryPremium"] = this.compulsoryPremium;
        data["agentDetailsId"] = this.agentDetailsId;
        data["agentDetails"] = this.agentDetails ? this.agentDetails.toJSON() : <any>undefined;
        data["compulsoryNumberOfPayments"] = this.compulsoryNumberOfPayments;
        data["payerName"] = this.payerName;
        data["payerPhone"] = this.payerPhone;
        data["coscoExpectedFee"] = this.coscoExpectedFee;
        data["coscoExpectedFeePercent"] = this.coscoExpectedFeePercent;
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item.toJSON());
        }
        data["clientIp"] = this.clientIp;
        data["paymentToken"] = this.paymentToken;
        data["paymentTokenId"] = this.paymentTokenId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["insuranceType"] = this.insuranceType;
        data["authorizedToDrive"] = this.authorizedToDrive;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["driverYoungIdentifier"] = this.driverYoungIdentifier;
        data["driverMainIdentifier"] = this.driverMainIdentifier;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["carLicensePlate"] = this.carLicensePlate;
        data["passedTypeOfInsurance1"] = this.passedTypeOfInsurance1;
        data["sueNumber1"] = this.sueNumber1;
        data["insuranceCompanyId1"] = this.insuranceCompanyId1;
        data["passedTypeOfInsurance2"] = this.passedTypeOfInsurance2;
        data["sueNumber2"] = this.sueNumber2;
        data["insuranceCompanyId2"] = this.insuranceCompanyId2;
        data["passedTypeOfInsurance3"] = this.passedTypeOfInsurance3;
        data["sueNumber3"] = this.sueNumber3;
        data["insuranceCompanyId3"] = this.insuranceCompanyId3;
        data["passedTypeOfInsurance4"] = this.passedTypeOfInsurance4;
        data["sueNumber4"] = this.sueNumber4;
        data["insuranceCompanyId4"] = this.insuranceCompanyId4;
        data["bodyClaimsAmount"] = this.bodyClaimsAmount;
        data["revocationsAmount"] = this.revocationsAmount;
        data["noInsurance"] = this.noInsurance;
        data["customerId"] = this.customerId;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["impairmentDeductible"] = this.impairmentDeductible;
        data["renovationAgentsOffice"] = this.renovationAgentsOffice;
        data["renovationCompany"] = this.renovationCompany;
        data["mainVehicle"] = this.mainVehicle;
        data["autodirection"] = this.autodirection;
        data["driveInShabbat"] = this.driveInShabbat;
        data["newForOld"] = this.newForOld;
        data["automaticInd"] = this.automaticInd;
        data["engineVolume"] = this.engineVolume;
        data["isVehicleEnslaved"] = this.isVehicleEnslaved;
        data["involvedPartyType"] = this.involvedPartyType;
        data["involvedBank"] = this.involvedBank;
        data["involvedBankBranch"] = this.involvedBankBranch;
        data["involvedName"] = this.involvedName;
        data["involvedAddressId"] = this.involvedAddressId;
        data["involvedAddress"] = this.involvedAddress ? this.involvedAddress.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["insuranceCompanyRouteId"] = this.insuranceCompanyRouteId;
        data["insuranceCompanyRoute"] = this.insuranceCompanyRoute ? this.insuranceCompanyRoute.toJSON() : <any>undefined;
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["identifier"] = this.identifier;
        data["identityType"] = this.identityType;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["identityCardIssueDate"] = this.identityCardIssueDate ? this.identityCardIssueDate.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["street"] = this.street;
        data["phoneNumber1"] = this.phoneNumber1;
        data["email"] = this.email;
        data["licenseNumber"] = this.licenseNumber;
        data["houseNumber"] = this.houseNumber;
        data["ownerIsMainDriver"] = this.ownerIsMainDriver;
        return data;
    }
}

export interface ISimulatorOffer {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    offerIdentity?: number;
    lead?: Lead;
    isPolicyOffer?: number;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompany;
    cascoAndDudy?: number;
    finalPremium?: number;
    dudyPremium?: number;
    basicPremium?: number;
    roadServices?: number;
    protection?: number;
    routeId?: number;
    collectiveId?: number;
    comments?: string | undefined;
    cascoPremium?: number | undefined;
    kaskoNumberOfPayments?: number;
    compulsoryPremium?: number | undefined;
    agentDetailsId?: string | undefined;
    agentDetails?: AgentDetails;
    compulsoryNumberOfPayments?: number;
    payerName?: string | undefined;
    payerPhone?: string | undefined;
    coscoExpectedFee?: number;
    coscoExpectedFeePercent?: number;
    discounts?: OfferDiscount[] | undefined;
    clientIp?: string | undefined;
    paymentToken?: string | undefined;
    paymentTokenId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungIdentifier?: string | undefined;
    driverMainIdentifier?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    carLicensePlate?: string | undefined;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    customerId?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: boolean;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string | undefined;
    involvedAddress?: CustomerAddress;
    vehicleId?: string | undefined;
    vehicle?: Vehicle;
    insuranceCompanyRouteId?: string | undefined;
    insuranceCompanyRoute?: InsuranceCompanyRoute;
    riders?: LeadRider[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identifier?: string | undefined;
    identityType?: IdentityType;
    dateOfBirth?: Date | undefined;
    identityCardIssueDate?: Date | undefined;
    city?: string | undefined;
    street?: string | undefined;
    phoneNumber1?: string | undefined;
    email?: string | undefined;
    licenseNumber?: string | undefined;
    houseNumber?: number | undefined;
    ownerIsMainDriver?: boolean | undefined;
}

export class LeadCommentModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    leadId?: string;
    lead?: LeadModel;
    userId?: string | undefined;
    user?: User;
    text?: string | undefined;
    topic?: string | undefined;

    constructor(data?: LeadCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.lead = _data["lead"] ? LeadModel.fromJS(_data["lead"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.text = _data["text"];
            this.topic = _data["topic"];

        }
    }

    static fromJS(data: any): LeadCommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeadCommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["topic"] = this.topic;

        return data;
    }
}


export class SimulatorOfferModel implements ISimulatorOfferModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    offerIdentity?: number;
    leadId?: string;
    lead?: LeadModel;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompanyModel;
    routeId?: number;
    routeComment?: string | undefined;
    collectiveId?: number;
    comments?: string[] | undefined;
    cascoPremium?: number | undefined;
    kaskoNumberOfPayments?: number;
    compulsoryPremium?: number | undefined;
    compulsoryNumberOfPayments?: number;
    payerFirstName?: string | undefined;
    payerLastName?: string | undefined;
    payerPhone?: string | undefined;
    paymentToken?: string | undefined;
    paymentTokenId?: string | undefined;
    protection?: number | undefined;
    sequenceId?: number;
    suggestionId?: string | undefined;
    agentDetailsId?: string | undefined;
    agentDetails?: AgentDetailsModel;
    cascoAndDudy?: number;
    finalPremium?: number;
    dudyPremium?: number;
    discounts?: OfferDiscountModel[] | undefined;
    activeDiscounts?: DiscountModel[] | undefined;
    riderPackages?: RiderPackageModel[] | undefined;
    coscoExpectedFee?: number;
    coscoExpectedFeePercent?: number;
    simulatorModel?: SimulatorModel;
    messageData?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverYoungIdentifier?: string | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    dateOfBirth?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainIdentifier?: string | undefined;
    carLicensePlate?: string | undefined;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    customerId?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: YesNo;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string | undefined;
    involvedAddress?: CustomerAddress;
    vehicleId?: string | undefined;
    vehicle?: VehicleDataModel;
    riders?: LeadRider[] | undefined;
    protections?: number[] | undefined;
    insuranceCompanyRouteId?: string | undefined;
    insuranceCompanyRoute?: InsuranceCompanyRoute;
    star?: boolean;
    renewalsOffer?: boolean;
    temsAndCovers: string | undefined;
    additionalDetails: string | undefined;
    licenseNumber: string | number | readonly string[] | undefined;
    ownerIsMainDriver: string | number | readonly string[] | undefined;
    ownerIsYoungDriver: string | number | readonly string[] | undefined;

    protectionTxt: string | undefined;

    comprehensivePaymentToken: string | undefined;
    comprehensivePaymentCard: string | undefined;
    comprehensivePaymentCardExp: string | undefined;

    compulsoryPaymentToken: string | undefined;
    compulsoryPaymentCard: string | undefined;
    compulsoryPaymentCardExp: string | undefined;

    identifier: string | undefined;
    identityType?: IdentityType;

    constructor(data?: ISimulatorOfferModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.offerIdentity = _data["offerIdentity"];
            this.leadId = _data["leadId"];
            this.lead = _data["lead"] ? LeadModel.fromJS(_data["lead"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.routeId = _data["routeId"];
            this.routeComment = _data["routeComment"];
            this.collectiveId = _data["collectiveId"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(item);
            }
            this.temsAndCovers = _data["temsAndCovers"];
            this.additionalDetails = _data["additionalDetails"];
            this.cascoPremium = _data["cascoPremium"];
            this.kaskoNumberOfPayments = _data["kaskoNumberOfPayments"];
            this.compulsoryPremium = _data["compulsoryPremium"];
            this.compulsoryNumberOfPayments = _data["compulsoryNumberOfPayments"];
            this.payerFirstName = _data["payerFirstName"];
            this.payerLastName = _data["payerLastName"];
            this.payerPhone = _data["payerPhone"];
            this.paymentToken = _data["paymentToken"];
            this.paymentTokenId = _data["paymentTokenId"];
            this.protection = _data["protection"];
            this.sequenceId = _data["sequenceId"];
            this.suggestionId = _data["suggestionId"];
            this.agentDetailsId = _data["agentDetailsId"];
            this.agentDetails = _data["agentDetails"] ? AgentDetailsModel.fromJS(_data["agentDetails"]) : <any>undefined;
            this.cascoAndDudy = _data["cascoAndDudy"];
            this.finalPremium = _data["finalPremium"];
            this.dudyPremium = _data["dudyPremium"];
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(OfferDiscountModel.fromJS(item));
            }
            if (Array.isArray(_data["activeDiscounts"])) {
                this.activeDiscounts = [] as any;
                for (let item of _data["activeDiscounts"])
                    this.activeDiscounts!.push(DiscountModel.fromJS(item));
            }
            if (Array.isArray(_data["riderPackages"])) {
                this.riderPackages = [] as any;
                for (let item of _data["riderPackages"])
                    this.riderPackages!.push(RiderPackageModel.fromJS(item));
            }
            this.coscoExpectedFee = _data["coscoExpectedFee"];
            this.coscoExpectedFeePercent = _data["coscoExpectedFeePercent"];
            this.simulatorModel = _data["simulatorModel"] ? SimulatorModel.fromJS(_data["simulatorModel"]) : <any>undefined;
            this.messageData = _data["messageData"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.insuranceType = _data["insuranceType"];
            this.authorizedToDrive = _data["authorizedToDrive"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.driverYoungGender = _data["driverYoungGender"];
            this.driverYoungSeniority = _data["driverYoungSeniority"];
            this.driverYoungSeniorityDate = _data["driverYoungSeniorityDate"] ? new Date(_data["driverYoungSeniorityDate"].toString()) : <any>undefined;
            this.driverYoungMaritalStatus = _data["driverYoungMaritalStatus"];
            this.driverYoungAge = _data["driverYoungAge"];
            this.driverYoungBirthDate = _data["driverYoungBirthDate"] ? new Date(_data["driverYoungBirthDate"].toString()) : <any>undefined;
            this.driverYoungIdentifier = _data["driverYoungIdentifier"];
            this.driverMainGender = _data["driverMainGender"];
            this.driverMainSeniority = _data["driverMainSeniority"];
            this.driverMainSeniorityDate = _data["driverMainSeniorityDate"] ? new Date(_data["driverMainSeniorityDate"].toString()) : <any>undefined;
            this.driverMainAge = _data["driverMainAge"];
            this.driverMainBirthDate = _data["driverMainBirthDate"] ? new Date(_data["driverMainBirthDate"].toString()) : <any>undefined;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.driverMainMaritalStatus = _data["driverMainMaritalStatus"];
            this.driverMainIdentifier = _data["driverMainIdentifier"];
            this.carLicensePlate = _data["carLicensePlate"];
            this.passedTypeOfInsurance1 = _data["passedTypeOfInsurance1"];
            this.sueNumber1 = _data["sueNumber1"];
            this.insuranceCompanyId1 = _data["insuranceCompanyId1"];
            this.passedTypeOfInsurance2 = _data["passedTypeOfInsurance2"];
            this.sueNumber2 = _data["sueNumber2"];
            this.insuranceCompanyId2 = _data["insuranceCompanyId2"];
            this.passedTypeOfInsurance3 = _data["passedTypeOfInsurance3"];
            this.sueNumber3 = _data["sueNumber3"];
            this.insuranceCompanyId3 = _data["insuranceCompanyId3"];
            this.passedTypeOfInsurance4 = _data["passedTypeOfInsurance4"];
            this.sueNumber4 = _data["sueNumber4"];
            this.insuranceCompanyId4 = _data["insuranceCompanyId4"];
            this.bodyClaimsAmount = _data["bodyClaimsAmount"];
            this.revocationsAmount = _data["revocationsAmount"];
            this.noInsurance = _data["noInsurance"];
            this.customerId = _data["customerId"];
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.impairmentDeductible = _data["impairmentDeductible"];
            this.renovationAgentsOffice = _data["renovationAgentsOffice"];
            this.renovationCompany = _data["renovationCompany"];
            this.mainVehicle = _data["mainVehicle"];
            this.autodirection = _data["autodirection"];
            this.driveInShabbat = _data["driveInShabbat"];
            this.newForOld = _data["newForOld"];
            this.automaticInd = _data["automaticInd"];
            this.engineVolume = _data["engineVolume"];
            this.isVehicleEnslaved = _data["isVehicleEnslaved"];
            this.involvedPartyType = _data["involvedPartyType"];
            this.involvedBank = _data["involvedBank"];
            this.involvedBankBranch = _data["involvedBankBranch"];
            this.involvedName = _data["involvedName"];
            this.involvedAddressId = _data["involvedAddressId"];
            this.involvedAddress = _data["involvedAddress"] ? CustomerAddress.fromJS(_data["involvedAddress"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? VehicleDataModel.fromJS(_data["vehicle"]) : <any>undefined;
            this.ownerIsMainDriver = _data["ownerIsMainDriver"];
            this.ownerIsYoungDriver = _data["ownerIsYoungDriver"];
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders!.push(LeadRider.fromJS(item));
            }
            if (Array.isArray(_data["protections"])) {
                this.protections = [] as any;
                for (let item of _data["protections"])
                    this.protections!.push(item);
            }
            this.insuranceCompanyRouteId = _data["insuranceCompanyRouteId"];
            this.insuranceCompanyRoute = _data["insuranceCompanyRoute"] ? InsuranceCompanyRoute.fromJS(_data["insuranceCompanyRoute"]) : <any>undefined;
            this.star = _data["star"];
            this.renewalsOffer = _data["renewalsOffer"];
            this.protectionTxt = _data["protectionTxt"];
            this.comprehensivePaymentToken = _data["comprehensivePaymentToken"];
            this.comprehensivePaymentCard = _data["comprehensivePaymentCard"];
            this.comprehensivePaymentCardExp = _data["comprehensivePaymentCardExp"];
            this.compulsoryPaymentToken = _data["compulsoryPaymentToken"];
            this.compulsoryPaymentCard = _data["compulsoryPaymentCard"];
            this.compulsoryPaymentCardExp = _data["compulsoryPaymentCardExp"];
            this.identityType = _data["identityType"];
            this.identifier = _data["identifier"];

        }
    }

    static fromJS(data: any): SimulatorOfferModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorOfferModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["offerIdentity"] = this.offerIdentity;
        data["leadId"] = this.leadId;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? InsuranceCompanyModel.fromJS(this.insuranceCompany).toJSON() : <any>undefined;
        data["routeId"] = this.routeId;
        data["routeComment"] = this.routeComment;
        data["collectiveId"] = this.collectiveId;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item);
        }
        data["temsAndCovers"] = this.temsAndCovers;
        data["additionalDetails"] = this.additionalDetails;
        data["cascoPremium"] = this.cascoPremium;
        data["kaskoNumberOfPayments"] = this.kaskoNumberOfPayments;
        data["compulsoryPremium"] = this.compulsoryPremium;
        data["compulsoryNumberOfPayments"] = this.compulsoryNumberOfPayments;
        data["payerFirstName"] = this.payerFirstName;
        data["payerLastName"] = this.payerLastName;
        data["payerPhone"] = this.payerPhone;
        data["paymentToken"] = this.paymentToken;
        data["paymentTokenId"] = this.paymentTokenId;
        data["protection"] = this.protection;
        data["sequenceId"] = this.sequenceId;
        data["suggestionId"] = this.suggestionId;
        data["agentDetailsId"] = this.agentDetailsId;
        data["agentDetails"] = this.agentDetails ? this.agentDetails.toJSON() : <any>undefined;
        data["cascoAndDudy"] = this.cascoAndDudy;
        data["finalPremium"] = this.finalPremium;
        data["dudyPremium"] = this.dudyPremium;
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item.toJSON());
        }
        if (Array.isArray(this.activeDiscounts)) {
            data["activeDiscounts"] = [];
            for (let item of this.activeDiscounts)
                data["activeDiscounts"].push(item.toJSON());
        }
        if (Array.isArray(this.riderPackages)) {
            data["riderPackages"] = [];
            for (let item of this.riderPackages)
                data["riderPackages"].push(item.toJSON());
        }
        data["coscoExpectedFee"] = this.coscoExpectedFee;
        data["coscoExpectedFeePercent"] = this.coscoExpectedFeePercent;
        data["simulatorModel"] = this.simulatorModel ? this.simulatorModel.toJSON() : <any>undefined;
        data["messageData"] = this.messageData;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["insuranceType"] = this.insuranceType;
        data["authorizedToDrive"] = this.authorizedToDrive;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["driverYoungGender"] = this.driverYoungGender;
        data["driverYoungSeniority"] = this.driverYoungSeniority;
        data["driverYoungSeniorityDate"] = this.driverYoungSeniorityDate ? this.driverYoungSeniorityDate.toISOString() : <any>undefined;
        data["driverYoungMaritalStatus"] = this.driverYoungMaritalStatus;
        data["driverYoungAge"] = this.driverYoungAge;
        data["driverYoungBirthDate"] = this.driverYoungBirthDate ? this.driverYoungBirthDate.toISOString() : <any>undefined;
        data["driverYoungIdentifier"] = this.driverYoungIdentifier;
        data["driverMainGender"] = this.driverMainGender;
        data["driverMainSeniority"] = this.driverMainSeniority;
        data["driverMainSeniorityDate"] = this.driverMainSeniorityDate ? this.driverMainSeniorityDate.toISOString() : <any>undefined;
        data["driverMainAge"] = this.driverMainAge;
        data["driverMainBirthDate"] = this.driverMainBirthDate ? this.driverMainBirthDate.toISOString() : <any>undefined;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["driverMainMaritalStatus"] = this.driverMainMaritalStatus;
        data["driverMainIdentifier"] = this.driverMainIdentifier;
        data["carLicensePlate"] = this.carLicensePlate;
        data["passedTypeOfInsurance1"] = this.passedTypeOfInsurance1;
        data["sueNumber1"] = this.sueNumber1;
        data["insuranceCompanyId1"] = this.insuranceCompanyId1;
        data["passedTypeOfInsurance2"] = this.passedTypeOfInsurance2;
        data["sueNumber2"] = this.sueNumber2;
        data["insuranceCompanyId2"] = this.insuranceCompanyId2;
        data["passedTypeOfInsurance3"] = this.passedTypeOfInsurance3;
        data["sueNumber3"] = this.sueNumber3;
        data["insuranceCompanyId3"] = this.insuranceCompanyId3;
        data["passedTypeOfInsurance4"] = this.passedTypeOfInsurance4;
        data["sueNumber4"] = this.sueNumber4;
        data["insuranceCompanyId4"] = this.insuranceCompanyId4;
        data["bodyClaimsAmount"] = this.bodyClaimsAmount;
        data["revocationsAmount"] = this.revocationsAmount;
        data["noInsurance"] = this.noInsurance;
        data["customerId"] = this.customerId;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["impairmentDeductible"] = this.impairmentDeductible;
        data["renovationAgentsOffice"] = this.renovationAgentsOffice;
        data["renovationCompany"] = this.renovationCompany;
        data["mainVehicle"] = this.mainVehicle;
        data["autodirection"] = this.autodirection;
        data["driveInShabbat"] = this.driveInShabbat;
        data["newForOld"] = this.newForOld;
        data["automaticInd"] = this.automaticInd;
        data["engineVolume"] = this.engineVolume;
        data["isVehicleEnslaved"] = this.isVehicleEnslaved;
        data["involvedPartyType"] = this.involvedPartyType;
        data["involvedBank"] = this.involvedBank;
        data["involvedBankBranch"] = this.involvedBankBranch;
        data["involvedName"] = this.involvedName;
        data["involvedAddressId"] = this.involvedAddressId;
        data["involvedAddress"] = this.involvedAddress ? CustomerAddress.fromJS(this.involvedAddress).toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? VehicleDataModel.fromJS(this.vehicle).toJSON() : <any>undefined;
        data["ownerIsMainDriver"] = this.ownerIsMainDriver;
        data["ownerIsYoungDriver"] = this.ownerIsYoungDriver;
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(LeadRider.fromJS(item).toJSON());
        }
        if (Array.isArray(this.protections)) {
            data["protections"] = [];
            for (let item of this.protections)
                data["protections"].push(item);
        }
        data["insuranceCompanyRouteId"] = this.insuranceCompanyRouteId;
        data["insuranceCompanyRoute"] = this.insuranceCompanyRoute ? this.insuranceCompanyRoute.toJSON() : <any>undefined;
        data["star"] = this.star;
        data["renewalsOffer"] = this.renewalsOffer;
        data["protectionTxt"] = this.protectionTxt;
        data["comprehensivePaymentToken"] = this.comprehensivePaymentToken;
        data["comprehensivePaymentCard"] = this.comprehensivePaymentCard;
        data["comprehensivePaymentCardExp"] = this.comprehensivePaymentCardExp;
        data["compulsoryPaymentToken"] = this.compulsoryPaymentToken;
        data["compulsoryPaymentCard"] = this.compulsoryPaymentCard;
        data["compulsoryPaymentCardExp"] = this.compulsoryPaymentCardExp;
        data["identifier"] = this.identifier;
        data["identityType"] = this.identifier;

        return data;
    }
}

export interface ISimulatorOfferModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    offerIdentity?: number;
    leadId?: string;
    lead?: LeadModel;
    insuranceCompanyId?: string;
    insuranceCompany?: InsuranceCompanyModel;
    routeId?: number;
    routeComment?: string | undefined;
    collectiveId?: number;
    comments?: string[] | undefined;
    cascoPremium?: number | undefined;
    kaskoNumberOfPayments?: number;
    compulsoryPremium?: number | undefined;
    compulsoryNumberOfPayments?: number;
    payerFirstName?: string | undefined;
    payerLastName?: string | undefined;
    payerPhone?: string | undefined;
    paymentToken?: string | undefined;
    paymentTokenId?: string | undefined;
    protection?: number | undefined;
    sequenceId?: number;
    suggestionId?: string | undefined;
    agentDetailsId?: string | undefined;
    agentDetails?: AgentDetailsModel;
    cascoAndDudy?: number;
    finalPremium?: number;
    dudyPremium?: number;
    discounts?: OfferDiscountModel[] | undefined;
    activeDiscounts?: DiscountModel[] | undefined;
    riderPackages?: RiderPackageModel[] | undefined;
    coscoExpectedFee?: number;
    coscoExpectedFeePercent?: number;
    simulatorModel?: SimulatorModel;
    messageData?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date;
    insuranceType?: InsuranceTypes;
    authorizedToDrive?: AuthorizedToDrive;
    postalCode?: string | undefined;
    address?: string | undefined;
    driverYoungGender?: Gender;
    driverYoungSeniority?: number;
    driverYoungSeniorityDate?: Date | undefined;
    driverYoungMaritalStatus?: MaritalStatus;
    driverYoungAge?: number;
    driverYoungBirthDate?: Date | undefined;
    driverYoungIdentifier?: string | undefined;
    driverMainGender?: Gender;
    driverMainSeniority?: number;
    driverMainSeniorityDate?: Date | undefined;
    driverMainAge?: number;
    driverMainBirthDate?: Date | undefined;
    dateOfBirth?: Date | undefined;
    driverMainMaritalStatus?: MaritalStatus;
    driverMainIdentifier?: string | undefined;
    carLicensePlate?: string | undefined;
    passedTypeOfInsurance1?: PassedTypeOfInsurance;
    sueNumber1?: number;
    insuranceCompanyId1?: string;
    passedTypeOfInsurance2?: PassedTypeOfInsurance;
    sueNumber2?: number;
    insuranceCompanyId2?: string;
    passedTypeOfInsurance3?: PassedTypeOfInsurance;
    sueNumber3?: number;
    insuranceCompanyId3?: string;
    passedTypeOfInsurance4?: PassedTypeOfInsurance;
    sueNumber4?: number;
    insuranceCompanyId4?: string;
    bodyClaimsAmount?: number;
    revocationsAmount?: number;
    noInsurance?: boolean;
    customerId?: string | undefined;
    vehicleOwnership?: VehicleOwnership;
    impairmentDeductible?: ImpairmentDeductible;
    renovationAgentsOffice?: RenovationAgentsOffice;
    renovationCompany?: RenovationCompany;
    mainVehicle?: boolean;
    autodirection?: boolean;
    driveInShabbat?: boolean;
    newForOld?: boolean;
    automaticInd?: boolean;
    engineVolume?: number;
    isVehicleEnslaved?: YesNo;
    involvedPartyType?: InvolvedPartyType;
    involvedBank?: string | undefined;
    involvedBankBranch?: string | undefined;
    involvedName?: string | undefined;
    involvedAddressId?: string | undefined;
    involvedAddress?: CustomerAddress;
    vehicleId?: string | undefined;
    vehicle?: VehicleDataModel;
    riders?: LeadRider[] | undefined;
    protections?: number[] | undefined;
    insuranceCompanyRouteId?: string | undefined;
    insuranceCompanyRoute?: InsuranceCompanyRoute;
    star?: boolean;
    renewalsOffer?: boolean;
    temsAndCovers: string | undefined;


    identifier: string | undefined;
    identityType?: IdentityType;

}

export class SimulatorPageModel implements ISimulatorPageModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    offers?: SimulatorOfferModel[] | undefined;
    simulatorDetailsModel?: SimulatorDetailsModel;
    lead?: LeadModel;
    recalcOffer?: SimulatorOfferModel;
    offer?: SimulatorOffer;
    owner?: CustomerModel;
    ownerIsMainDriver?: boolean;
    address?: CustomerAddressModel;
    contactDetails?: CustomerContactDetailsModel;
    insuranceCompanies?: SelectListItem[] | undefined;
    riders?: RiderPackageModel[] | undefined;
    readonly startDateSelect?: SelectListItem[] | undefined;
    singningPeople?: SelectListItem[] | undefined;

    constructor(data?: ISimulatorPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(SimulatorOfferModel.fromJS(item));
            }
            this.simulatorDetailsModel = _data["simulatorDetailsModel"] ? SimulatorDetailsModel.fromJS(_data["simulatorDetailsModel"]) : <any>undefined;
            this.lead = _data["lead"] ? LeadModel.fromJS(_data["lead"]) : <any>undefined;
            this.recalcOffer = _data["recalcOffer"] ? SimulatorOfferModel.fromJS(_data["recalcOffer"]) : <any>undefined;
            this.offer = _data["offer"] ? SimulatorOffer.fromJS(_data["offer"]) : <any>undefined;
            this.owner = _data["owner"] ? CustomerModel.fromJS(_data["owner"]) : <any>undefined;
            this.ownerIsMainDriver = _data["ownerIsMainDriver"];
            this.address = _data["address"] ? CustomerAddressModel.fromJS(_data["address"]) : <any>undefined;
            this.contactDetails = _data["contactDetails"] ? CustomerContactDetailsModel.fromJS(_data["contactDetails"]) : <any>undefined;
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["riders"])) {
                this.riders = [] as any;
                for (let item of _data["riders"])
                    this.riders!.push(RiderPackageModel.fromJS(item));
            }
            if (Array.isArray(_data["startDateSelect"])) {
                (<any>this).startDateSelect = [] as any;
                for (let item of _data["startDateSelect"])
                    (<any>this).startDateSelect!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["singningPeople"])) {
                this.singningPeople = [] as any;
                for (let item of _data["singningPeople"])
                    this.singningPeople!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimulatorPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        data["simulatorDetailsModel"] = this.simulatorDetailsModel ? this.simulatorDetailsModel.toJSON() : <any>undefined;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["recalcOffer"] = this.recalcOffer ? this.recalcOffer.toJSON() : <any>undefined;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["ownerIsMainDriver"] = this.ownerIsMainDriver;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contactDetails"] = this.contactDetails ? this.contactDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.riders)) {
            data["riders"] = [];
            for (let item of this.riders)
                data["riders"].push(item.toJSON());
        }
        if (Array.isArray(this.startDateSelect)) {
            data["startDateSelect"] = [];
            for (let item of this.startDateSelect)
                data["startDateSelect"].push(item.toJSON());
        }
        if (Array.isArray(this.singningPeople)) {
            data["singningPeople"] = [];
            for (let item of this.singningPeople)
                data["singningPeople"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimulatorPageModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    offers?: SimulatorOfferModel[] | undefined;
    simulatorDetailsModel?: SimulatorDetailsModel;
    lead?: LeadModel;
    recalcOffer?: SimulatorOfferModel;
    offer?: SimulatorOffer;
    owner?: CustomerModel;
    ownerIsMainDriver?: boolean;
    address?: CustomerAddressModel;
    contactDetails?: CustomerContactDetailsModel;
    insuranceCompanies?: SelectListItem[] | undefined;
    riders?: RiderPackageModel[] | undefined;
    startDateSelect?: SelectListItem[] | undefined;
    singningPeople?: SelectListItem[] | undefined;
}

export class SimulatorSettingsModel implements ISimulatorSettingsModel {
    agentDetailsList?: AgentDetailsModel[] | undefined;
    routes?: InsuranceCompanyRouteModel[] | undefined;
    discountsList?: DiscountModel[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    agentDetailsSelectList?: SelectListItem[] | undefined;
    users?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    simulatorDetailsModel?: SimulatorDetailsModel;
    user?: UserModel;
    agent?: AgentModel;

    constructor(data?: ISimulatorSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agentDetailsList"])) {
                this.agentDetailsList = [] as any;
                for (let item of _data["agentDetailsList"])
                    this.agentDetailsList!.push(AgentDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(InsuranceCompanyRouteModel.fromJS(item));
            }
            if (Array.isArray(_data["discountsList"])) {
                this.discountsList = [] as any;
                for (let item of _data["discountsList"])
                    this.discountsList!.push(DiscountModel.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agentDetailsSelectList"])) {
                this.agentDetailsSelectList = [] as any;
                for (let item of _data["agentDetailsSelectList"])
                    this.agentDetailsSelectList!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.simulatorDetailsModel = _data["simulatorDetailsModel"] ? SimulatorDetailsModel.fromJS(_data["simulatorDetailsModel"]) : <any>undefined;
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.agent = _data["agent"] ? AgentModel.fromJS(_data["agent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SimulatorSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agentDetailsList)) {
            data["agentDetailsList"] = [];
            for (let item of this.agentDetailsList)
                data["agentDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item.toJSON());
        }
        if (Array.isArray(this.discountsList)) {
            data["discountsList"] = [];
            for (let item of this.discountsList)
                data["discountsList"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.agentDetailsSelectList)) {
            data["agentDetailsSelectList"] = [];
            for (let item of this.agentDetailsSelectList)
                data["agentDetailsSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["simulatorDetailsModel"] = this.simulatorDetailsModel ? this.simulatorDetailsModel.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISimulatorSettingsModel {
    agentDetailsList?: AgentDetailsModel[] | undefined;
    routes?: InsuranceCompanyRouteModel[] | undefined;
    discountsList?: DiscountModel[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    agentDetailsSelectList?: SelectListItem[] | undefined;
    users?: SelectListItem[] | undefined;
    agents?: SelectListItem[] | undefined;
    simulatorDetailsModel?: SimulatorDetailsModel;
    user?: UserModel;
    agent?: AgentModel;
}

export class SmsTemplatesModel implements ISmsTemplatesModel {
    id?: string;
    title?: string | undefined;
    template?: string | undefined;

    constructor(data?: ISmsTemplatesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.template = _data["template"];
        }
    }

    static fromJS(data: any): SmsTemplatesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SmsTemplatesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["template"] = this.template;
        return data;
    }
}

export interface ISmsTemplatesModel {
    id?: string;
    title?: string | undefined;
    template?: string | undefined;
}

export class SmsTreatmentModelForUpsert implements ISmsTreatmentModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    startDate?: Date | undefined;
    startTime?: TimeSpan;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    smsPhone?: string | undefined;
    message?: string | undefined;
    senderId?: string | undefined;
    hours?: SelectListItem[] | undefined;
    templates?: SmsTemplatesModel[] | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;

    constructor(data?: ISmsTreatmentModelForUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.alertHour = _data["alertHour"] ? TimeSpan.fromJS(_data["alertHour"]) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.treatmentType = _data["treatmentType"];
            this.customerId = _data["customerId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(SelectListItem.fromJS(item));
            }
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectListItem.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"]) : <any>undefined;
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.topic = _data["topic"];
            this.note = _data["note"];
            this.smsPhone = _data["smsPhone"];
            this.message = _data["message"];
            this.senderId = _data["senderId"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(SmsTemplatesModel.fromJS(item));
            }
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SmsTreatmentModelForUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new SmsTreatmentModelForUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["alertHour"] = this.alertHour ? this.alertHour.toJSON() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["treatmentType"] = this.treatmentType;
        data["customerId"] = this.customerId;
        data["priority"] = this.priority;
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item.toJSON());
        }
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["topic"] = this.topic;
        data["note"] = this.note;
        data["smsPhone"] = this.smsPhone;
        data["message"] = this.message;
        data["senderId"] = this.senderId;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISmsTreatmentModelForUpsert {
    alertDate?: Date | undefined;
    alertHour?: TimeSpan;
    customers?: SelectListItem[] | undefined;
    treatmentType?: TreatmentType;
    customerId?: string | undefined;
    priority?: Priority;
    priorities?: SelectListItem[] | undefined;
    companyId?: string | undefined;
    companies?: SelectListItem[] | undefined;
    startDate?: Date | undefined;
    startTime?: TimeSpan;
    agentId?: string;
    agents?: SelectListItem[] | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    smsPhone?: string | undefined;
    message?: string | undefined;
    senderId?: string | undefined;
    hours?: SelectListItem[] | undefined;
    templates?: SmsTemplatesModel[] | undefined;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
}

export class SocialLoanP2PInsurancePolicyModel implements ISocialLoanP2PInsurancePolicyModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    lenderName?: string | undefined;
    lenderIdentoty?: string | undefined;
    asOf?: Date;
    prtfolioValuePercentage?: number;
    prtfolioValueAmount?: number;
    totalStrokes?: number;
    yieldSinceTheBeginningOfTheYear?: number;
    extendedProtectionFund?: IncludeNotInclude;
    totalDeposits?: number;
    interestFromTheBeginningOfTheActivity?: number;
    yieldThisMonthLessFees?: number;

    constructor(data?: ISocialLoanP2PInsurancePolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["agentDetailsList"])) {
                this.agentDetailsList = [] as any;
                for (let item of _data["agentDetailsList"])
                    this.agentDetailsList!.push(AgentDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["salespersons"])) {
                this.salespersons = [] as any;
                for (let item of _data["salespersons"])
                    this.salespersons!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(SelectListItem.fromJS(item));
            }
            this.lenderName = _data["lenderName"];
            this.lenderIdentoty = _data["lenderIdentoty"];
            this.asOf = _data["asOf"] ? new Date(_data["asOf"].toString()) : <any>undefined;
            this.prtfolioValuePercentage = _data["prtfolioValuePercentage"];
            this.prtfolioValueAmount = _data["prtfolioValueAmount"];
            this.totalStrokes = _data["totalStrokes"];
            this.yieldSinceTheBeginningOfTheYear = _data["yieldSinceTheBeginningOfTheYear"];
            this.extendedProtectionFund = _data["extendedProtectionFund"];
            this.totalDeposits = _data["totalDeposits"];
            this.interestFromTheBeginningOfTheActivity = _data["interestFromTheBeginningOfTheActivity"];
            this.yieldThisMonthLessFees = _data["yieldThisMonthLessFees"];
        }
    }

    static fromJS(data: any): SocialLoanP2PInsurancePolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocialLoanP2PInsurancePolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.agentDetailsList)) {
            data["agentDetailsList"] = [];
            for (let item of this.agentDetailsList)
                data["agentDetailsList"].push(item.toJSON());
        }
        if (Array.isArray(this.salespersons)) {
            data["salespersons"] = [];
            for (let item of this.salespersons)
                data["salespersons"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        data["lenderName"] = this.lenderName;
        data["lenderIdentoty"] = this.lenderIdentoty;
        data["asOf"] = this.asOf ? this.asOf.toISOString() : <any>undefined;
        data["prtfolioValuePercentage"] = this.prtfolioValuePercentage;
        data["prtfolioValueAmount"] = this.prtfolioValueAmount;
        data["totalStrokes"] = this.totalStrokes;
        data["yieldSinceTheBeginningOfTheYear"] = this.yieldSinceTheBeginningOfTheYear;
        data["extendedProtectionFund"] = this.extendedProtectionFund;
        data["totalDeposits"] = this.totalDeposits;
        data["interestFromTheBeginningOfTheActivity"] = this.interestFromTheBeginningOfTheActivity;
        data["yieldThisMonthLessFees"] = this.yieldThisMonthLessFees;
        return data;
    }
}

export interface ISocialLoanP2PInsurancePolicyModel {
    id?: string;
    policy?: PolicyModel;
    agents?: SelectListItem[] | undefined;
    agentDetailsList?: AgentDetailsModel[] | undefined;
    salespersons?: SelectListItem[] | undefined;
    insuranceCompanies?: SelectListItem[] | undefined;
    employers?: SelectListItem[] | undefined;
    lenderName?: string | undefined;
    lenderIdentoty?: string | undefined;
    asOf?: Date;
    prtfolioValuePercentage?: number;
    prtfolioValueAmount?: number;
    totalStrokes?: number;
    yieldSinceTheBeginningOfTheYear?: number;
    extendedProtectionFund?: IncludeNotInclude;
    totalDeposits?: number;
    interestFromTheBeginningOfTheActivity?: number;
    yieldThisMonthLessFees?: number;
}

/** 0 = Asc, 1 = Desc */
export enum SortDirection {
    _0 = 0,
    _1 = 1,
}

export class SortModel implements ISortModel {
    property?: string | undefined;
    sortDirection?: SortDirection;
    specificValue?: any | undefined;

    constructor(data?: ISortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.sortDirection = _data["sortDirection"];
            this.specificValue = _data["specificValue"];
        }
    }

    static fromJS(data: any): SortModel {
        data = typeof data === 'object' ? data : {};
        let result = new SortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["sortDirection"] = this.sortDirection;
        data["specificValue"] = this.specificValue;
        return data;
    }
}

export interface ISortModel {
    property?: string | undefined;
    sortDirection?: SortDirection;
    specificValue?: any | undefined;
}

export class SpeakComappModel implements ISpeakComappModel {
    items?: SpeakComappModelItem[] | undefined;

    constructor(data?: ISpeakComappModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpeakComappModelItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpeakComappModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakComappModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISpeakComappModel {
    items?: SpeakComappModelItem[] | undefined;
}

export class SpeakComappModelItem implements ISpeakComappModelItem {
    id?: string;
    src?: string | undefined;
    dst?: string | undefined;
    billsec?: number;
    start_stamp?: Date;
    path?: string | undefined;

    constructor(data?: ISpeakComappModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.src = _data["src"];
            this.dst = _data["dst"];
            this.billsec = _data["billsec"];
            this.start_stamp = _data["start_stamp"] ? new Date(_data["start_stamp"].toString()) : <any>undefined;
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): SpeakComappModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakComappModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["src"] = this.src;
        data["dst"] = this.dst;
        data["billsec"] = this.billsec;
        data["start_stamp"] = this.start_stamp ? this.start_stamp.toISOString() : <any>undefined;
        data["path"] = this.path;
        return data;
    }
}

export interface ISpeakComappModelItem {
    id?: string;
    src?: string | undefined;
    dst?: string | undefined;
    billsec?: number;
    start_stamp?: Date;
    path?: string | undefined;
}

export class SpeakComTabModel implements ISpeakComTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: SpeakComappModel[] | undefined;

    constructor(data?: ISpeakComTabModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpeakComappModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpeakComTabModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakComTabModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISpeakComTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: SpeakComappModel[] | undefined;
}

/** 0 = Desktop, 1 = , 2 = Programs, 3 = , 4 = , 5 = MyDocuments, 6 = Favorites, 7 = Startup */
export enum SpecialFolder {
    _0 = 0, // All
    _1 = 1, // Archive
    _2 = 2, // Drafts
    _3 = 3, // Flagged
    _4 = 4, // Important
    _5 = 5, // Junk
    _6 = 6, // Sent
    _7 = 7, // Trash
}

export class SpecificInsuranceCompanyDetails implements ISpecificInsuranceCompanyDetails {
    name?: string | undefined;
    data?: string | undefined;
    title?: string | undefined;

    constructor(data?: ISpecificInsuranceCompanyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.data = _data["data"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SpecificInsuranceCompanyDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SpecificInsuranceCompanyDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["data"] = this.data;
        data["title"] = this.title;
        return data;
    }
}

export interface ISpecificInsuranceCompanyDetails {
    name?: string | undefined;
    data?: string | undefined;
    title?: string | undefined;
}

export class SPLeadModel implements ISPLeadModel {
    lead?: LeadModel;
    statusColor?: number;
    level?: number;
    lastStatusId?: string;
    lastStatusDate?: Date;
    lastStatusName?: string | undefined;
    isStationUser?: boolean;
    branchesPath?: string | undefined;
    leadRole?: boolean;
    offers?: any[];
    checked?: boolean;
    constructor(data?: ISPLeadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lead = _data["lead"] ? LeadModel.fromJS(_data["lead"]) : <any>undefined;
            this.statusColor = _data["statusColor"];
            this.level = _data["level"];

            this.lastStatusId = _data["lastStatusId"];
            this.lastStatusDate = _data["lastStatusDate"] ? new Date(_data["lastStatusDate"].toString()) : <any>undefined;
            this.lastStatusName = _data["lastStatusName"];
            this.isStationUser = _data["isStationUser"];
            this.branchesPath = _data["branchesPath"];
            this.leadRole = _data["leadRole"];
        }
    }

    static fromJS(data: any): SPLeadModel {
        data = typeof data === 'object' ? data : {};
        let result = new SPLeadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["statusColor"] = this.statusColor;
        data["level"] = this.level;

        data["lastStatusId"] = this.lastStatusId;
        data["lastStatusDate"] = this.lastStatusDate ? this.lastStatusDate.toISOString() : <any>undefined;
        data["lastStatusName"] = this.lastStatusName;
        data["isStationUser"] = this.isStationUser;
        data["branchesPath"] = this.branchesPath;
        data["leadRole"] = this.leadRole;
        return data;
    }
}

export interface ISPLeadModel {
    lead?: LeadModel;
    statusColor?: number;
    level?: number;
    lastStatusId?: string;
    lastStatusDate?: Date;
    lastStatusName?: string | undefined;
    isStationUser?: boolean;
    branchesPath?: string | undefined;
    leadRole?: boolean;
    checked?: boolean;
}


export class RiderLeadModel implements IRiderLeadModel {
    id?: number | undefined;
    oldRiderId?: number;
    oldRider?: RiderModel;
    newRiderId?: number;
    newRider?: RiderModel;
    statusId?: number;
    startDate?: Date;
    customerId?: string | undefined;
    customer?: CustomerModel;
    companies?: string;
    constructor(data?: IRiderLeadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oldRiderId = _data["oldRiderId"];
            this.oldRider = _data["oldRider"] ? RiderModel.fromJS(_data["oldRider"]) : <any>undefined;
            this.newRiderId = _data["newRiderId"];
            this.newRider = _data["newRider"] ? RiderModel.fromJS(_data["newRider"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.companies = _data["companies"];
            this.customer = _data["customer"] ? RiderModel.fromJS(_data["customer"]) : <any>undefined;



        }
    }

    static fromJS(data: any): RiderLeadModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiderLeadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oldRiderId"] = this.oldRiderId;
        data["oldRider"] = this.oldRider ? this.oldRider.toJSON() : <any>undefined;
        data["newRiderId"] = this.oldRiderId;
        data["newRider"] = this.oldRider ? this.oldRider.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["lastStatusId"] = this.statusId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["companies"] = this.companies;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRiderLeadModel {
    id?: number | undefined;
    oldRiderId?: number;
    oldRider?: RiderModel;
    newRiderId?: number;
    newRider?: RiderModel;
    statusId?: number;
    startDate?: Date;
    customerId?: string | undefined;
    customer?: CustomerModel;
    companies?: string;
}

/** 0 = None, 12 = Ssl2, 48 = Ssl3, 192 = Tls, 240 = Default, 768 = Tls11, 3072 = Tls12, 12288 = Tls13 */
export enum SslProtocols {
    _0 = 0,
    _12 = 12,
    _48 = 48,
    _192 = 192,
    _240 = 240,
    _768 = 768,
    _3072 = 3072,
    _12288 = 12288,
}

export class Station implements IStation {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    status?: ActivityStatus;
    deviceType?: StationDeviceType;
    stationType?: StationType;
    link?: string | undefined;
    leads?: Lead[] | undefined;
    branchId?: string | undefined;
    branch?: Branch;
    leadsOwnerId?: string | undefined;

    constructor(data?: IStation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.status = _data["status"];
            this.deviceType = _data["deviceType"];
            this.stationType = _data["stationType"];
            this.link = _data["link"];
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(Lead.fromJS(item));
            }
            this.branchId = _data["branchId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.leadsOwnerId = _data["leadsOwnerId"];
        }
    }

    static fromJS(data: any): Station {
        data = typeof data === 'object' ? data : {};
        let result = new Station();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["status"] = this.status;
        data["deviceType"] = this.deviceType;
        data["stationType"] = this.stationType;
        data["link"] = this.link;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        data["branchId"] = this.branchId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["leadsOwnerId"] = this.leadsOwnerId;
        return data;
    }
}

export interface IStation {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    status?: ActivityStatus;
    deviceType?: StationDeviceType;
    stationType?: StationType;
    link?: string | undefined;
    leads?: Lead[] | undefined;
    branchId?: string | undefined;
    branch?: Branch;
    leadsOwnerId?: string | undefined;
}

/** 0 = Desktop, 1 = Tablet */
export enum StationDeviceType {
    _0 = 0,
    _1 = 1,
}

export class StationModel implements IStationModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    deviceType?: StationDeviceType;
    stationType?: StationType;
    link?: string | undefined;
    branchId?: string | undefined;
    branch?: BranchModel;
    leadsOwnerId?: string | undefined;
    showUsersInTablet?: boolean | undefined;

    constructor(data?: IStationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.deviceType = _data["deviceType"];
            this.stationType = _data["stationType"];
            this.link = _data["link"];
            this.branchId = _data["branchId"];
            this.branch = _data["branch"] ? BranchModel.fromJS(_data["branch"]) : <any>undefined;
            this.leadsOwnerId = _data["leadsOwnerId"];
            this.showUsersInTablet = _data["showUsersInTablet"];
        }
    }

    static fromJS(data: any): StationModel {
        data = typeof data === 'object' ? data : {};
        let result = new StationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["deviceType"] = this.deviceType;
        data["stationType"] = this.stationType;
        data["link"] = this.link;
        data["branchId"] = this.branchId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["leadsOwnerId"] = this.leadsOwnerId;
        data["showUsersInTablet"] = this.showUsersInTablet;
        return data;
    }
}

export interface IStationModel {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    deviceType?: StationDeviceType;
    stationType?: StationType;
    link?: string | undefined;
    branchId?: string | undefined;
    branch?: BranchModel;
    leadsOwnerId?: string | undefined;
    showUsersInTablet?: boolean | undefined;
}

export class StationModelForCreate implements IStationModelForCreate {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    deviceType?: StationDeviceType;
    stationType?: StationType;
    link?: string | undefined;
    branchId?: string | undefined;
    branches?: SelectListItem[] | undefined;
    stationTypes?: SelectListItem[] | undefined;
    users?: SelectListItem[] | undefined;

    constructor(data?: IStationModelForCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.deviceType = _data["deviceType"];
            this.stationType = _data["stationType"];
            this.link = _data["link"];
            this.branchId = _data["branchId"];
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["stationTypes"])) {
                this.stationTypes = [] as any;
                for (let item of _data["stationTypes"])
                    this.stationTypes!.push(SelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StationModelForCreate {
        data = typeof data === 'object' ? data : {};
        let result = new StationModelForCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["deviceType"] = this.deviceType;
        data["stationType"] = this.stationType;
        data["link"] = this.link;
        data["branchId"] = this.branchId;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.stationTypes)) {
            data["stationTypes"] = [];
            for (let item of this.stationTypes)
                data["stationTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStationModelForCreate {
    id?: string | undefined;
    name?: string | undefined;
    status?: ActivityStatus;
    deviceType?: StationDeviceType;
    stationType?: StationType;
    link?: string | undefined;
    branchId?: string | undefined;
    branches?: SelectListItem[] | undefined;
    stationTypes?: SelectListItem[] | undefined;
    users?: SelectListItem[] | undefined;
}

/** 0 = New, 1 = Used */
export enum StationType {
    _0 = 0,
    _1 = 1,
}

export class Status implements IStatus {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    leads?: Lead[] | undefined;

    constructor(data?: IStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(Lead.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Status {
        data = typeof data === 'object' ? data : {};
        let result = new Status();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStatus {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    leads?: Lead[] | undefined;
}

export class StringStringValuesKeyValuePair implements IStringStringValuesKeyValuePair {
    key?: string | undefined;
    value?: string[];

    constructor(data?: IStringStringValuesKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): StringStringValuesKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringValuesKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IStringStringValuesKeyValuePair {
    key?: string | undefined;
    value?: string[];
}

export class StructLayoutAttribute implements IStructLayoutAttribute {
    readonly typeId?: any | undefined;
    value?: LayoutKind;

    constructor(data?: IStructLayoutAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).typeId = _data["typeId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["value"] = this.value;
        return data;
    }
}

export interface IStructLayoutAttribute {
    typeId?: any | undefined;
    value?: LayoutKind;
}

export class SubscriberModel implements ISubscriberModel {
    id?: string | undefined;
    subsciberCode?: string | undefined;
    nameOfUser?: string | undefined;
    subsciberIdentifier?: number;
    registrationNumber?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    lastPayment?: number | undefined;
    status?: ActivityStatus;
    paymentStatus?: PaymentStatus;
    costToInsuranceAgent?: number | undefined;
    nameOfInsuranceAgent?: string | undefined;
    nameOfSalesPerson?: string | undefined;
    packageName?: string | undefined;
    solventCode?: number | undefined;
    customerId?: string | undefined;
    customers?: SelectListItem[] | undefined;
    packageId?: string | undefined;
    packages?: SelectListItem[] | undefined;

    constructor(data?: ISubscriberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subsciberCode = _data["subsciberCode"];
            this.nameOfUser = _data["nameOfUser"];
            this.subsciberIdentifier = _data["subsciberIdentifier"];
            this.registrationNumber = _data["registrationNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.lastPayment = _data["lastPayment"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.costToInsuranceAgent = _data["costToInsuranceAgent"];
            this.nameOfInsuranceAgent = _data["nameOfInsuranceAgent"];
            this.nameOfSalesPerson = _data["nameOfSalesPerson"];
            this.packageName = _data["packageName"];
            this.solventCode = _data["solventCode"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SelectListItem.fromJS(item));
            }
            this.packageId = _data["packageId"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(SelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriberModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subsciberCode"] = this.subsciberCode;
        data["nameOfUser"] = this.nameOfUser;
        data["subsciberIdentifier"] = this.subsciberIdentifier;
        data["registrationNumber"] = this.registrationNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["lastPayment"] = this.lastPayment;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["costToInsuranceAgent"] = this.costToInsuranceAgent;
        data["nameOfInsuranceAgent"] = this.nameOfInsuranceAgent;
        data["nameOfSalesPerson"] = this.nameOfSalesPerson;
        data["packageName"] = this.packageName;
        data["solventCode"] = this.solventCode;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["packageId"] = this.packageId;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriberModel {
    id?: string | undefined;
    subsciberCode?: string | undefined;
    nameOfUser?: string | undefined;
    subsciberIdentifier?: number;
    registrationNumber?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    lastPayment?: number | undefined;
    status?: ActivityStatus;
    paymentStatus?: PaymentStatus;
    costToInsuranceAgent?: number | undefined;
    nameOfInsuranceAgent?: string | undefined;
    nameOfSalesPerson?: string | undefined;
    packageName?: string | undefined;
    solventCode?: number | undefined;
    customerId?: string | undefined;
    customers?: SelectListItem[] | undefined;
    packageId?: string | undefined;
    packages?: SelectListItem[] | undefined;
}

export class Sue implements ISue {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    sueNumber?: string | undefined;
    serialNumber?: number;
    internalNumber?: number;
    openingDate?: Date;
    closingDate?: Date;
    sueType?: SueType;
    status?: SueStatus2;
    activityStatus?: ActivityStatus;
    policyId?: string | undefined;
    riderId?: string | undefined;
    rider?: Rider;
    policy?: Policy;
    customerId?: string;
    customer?: Customer;
    handlerId?: string | undefined;
    handler?: User;
    insuranceCompanyId?: string | undefined;
    insuranceCompany?: InsuranceCompany;
    damageAppraiser?: number;
    impairment?: number;
    deductible?: number;
    impairmentPercent?: number;
    appraiserAmount?: number;
    establishmentValue?: number;
    additionalExpenses?: number;
    requestedAmount?: number;
    approvedAmount?: number;
    paymentDate?: Date;
    comments?: string | undefined;
    driverId?: string | undefined;
    driver?: SueCarAndDriverInfo;
    seniorityDate?: Date;
    sueAccidentAndDamageInfoId?: string | undefined;
    sueAccidentAndDamageInfo?: SueAccidentAndDamageInfo;
    participant1Id?: string | undefined;
    participant1?: SueParticipant;
    participant2Id?: string | undefined;
    participant2?: SueParticipant;
    participant3Id?: string | undefined;
    participant3?: SueParticipant;
    participant4Id?: string | undefined;
    participant4?: SueParticipant;
    participant5Id?: string | undefined;
    participant5?: SueParticipant;
    participant6Id?: string | undefined;
    participant6?: SueParticipant;
    sueWitness1Id?: string | undefined;
    sueWitness1?: SueWitness;
    sueWitness2Id?: string | undefined;
    sueWitness2?: SueWitness;
    involvedVehiclesId?: string | undefined;
    involvedVehicles?: SueInvolvedVehicles;
    garageDetailsId?: string | undefined;
    garageDetails?: SueGarageDetails;
    treatments?: Treatment[] | undefined;
    documents?: Document[] | undefined;

    constructor(data?: ISue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.sueNumber = _data["sueNumber"];
            this.serialNumber = _data["serialNumber"];
            this.internalNumber = _data["internalNumber"];
            this.openingDate = _data["openingDate"] ? new Date(_data["openingDate"].toString()) : <any>undefined;
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.sueType = _data["sueType"];
            this.status = _data["status"];
            this.activityStatus = _data["activityStatus"];
            this.policyId = _data["policyId"];
            this.riderId = _data["riderId"];
            this.rider = _data["rider"] ? Rider.fromJS(_data["rider"]) : <any>undefined;
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.handlerId = _data["handlerId"];
            this.handler = _data["handler"] ? User.fromJS(_data["handler"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.damageAppraiser = _data["damageAppraiser"];
            this.impairment = _data["impairment"];
            this.deductible = _data["deductible"];
            this.impairmentPercent = _data["impairmentPercent"];
            this.appraiserAmount = _data["appraiserAmount"];
            this.establishmentValue = _data["establishmentValue"];
            this.additionalExpenses = _data["additionalExpenses"];
            this.requestedAmount = _data["requestedAmount"];
            this.approvedAmount = _data["approvedAmount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.driverId = _data["driverId"];
            this.driver = _data["driver"] ? SueCarAndDriverInfo.fromJS(_data["driver"]) : <any>undefined;
            this.seniorityDate = _data["seniorityDate"] ? new Date(_data["seniorityDate"].toString()) : <any>undefined;
            this.sueAccidentAndDamageInfoId = _data["sueAccidentAndDamageInfoId"];
            this.sueAccidentAndDamageInfo = _data["sueAccidentAndDamageInfo"] ? SueAccidentAndDamageInfo.fromJS(_data["sueAccidentAndDamageInfo"]) : <any>undefined;
            this.participant1Id = _data["participant1Id"];
            this.participant1 = _data["participant1"] ? SueParticipant.fromJS(_data["participant1"]) : <any>undefined;
            this.participant2Id = _data["participant2Id"];
            this.participant2 = _data["participant2"] ? SueParticipant.fromJS(_data["participant2"]) : <any>undefined;
            this.participant3Id = _data["participant3Id"];
            this.participant3 = _data["participant3"] ? SueParticipant.fromJS(_data["participant3"]) : <any>undefined;
            this.participant4Id = _data["participant4Id"];
            this.participant4 = _data["participant4"] ? SueParticipant.fromJS(_data["participant4"]) : <any>undefined;
            this.participant5Id = _data["participant5Id"];
            this.participant5 = _data["participant5"] ? SueParticipant.fromJS(_data["participant5"]) : <any>undefined;
            this.participant6Id = _data["participant6Id"];
            this.participant6 = _data["participant6"] ? SueParticipant.fromJS(_data["participant6"]) : <any>undefined;
            this.sueWitness1Id = _data["sueWitness1Id"];
            this.sueWitness1 = _data["sueWitness1"] ? SueWitness.fromJS(_data["sueWitness1"]) : <any>undefined;
            this.sueWitness2Id = _data["sueWitness2Id"];
            this.sueWitness2 = _data["sueWitness2"] ? SueWitness.fromJS(_data["sueWitness2"]) : <any>undefined;
            this.involvedVehiclesId = _data["involvedVehiclesId"];
            this.involvedVehicles = _data["involvedVehicles"] ? SueInvolvedVehicles.fromJS(_data["involvedVehicles"]) : <any>undefined;
            this.garageDetailsId = _data["garageDetailsId"];
            this.garageDetails = _data["garageDetails"] ? SueGarageDetails.fromJS(_data["garageDetails"]) : <any>undefined;
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(Treatment.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Document.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Sue {
        data = typeof data === 'object' ? data : {};
        let result = new Sue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["sueNumber"] = this.sueNumber;
        data["serialNumber"] = this.serialNumber;
        data["internalNumber"] = this.internalNumber;
        data["openingDate"] = this.openingDate ? this.openingDate.toISOString() : <any>undefined;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["sueType"] = this.sueType;
        data["status"] = this.status;
        data["activityStatus"] = this.activityStatus;
        data["policyId"] = this.policyId;
        data["riderId"] = this.riderId;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["handlerId"] = this.handlerId;
        data["handler"] = this.handler ? this.handler.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["damageAppraiser"] = this.damageAppraiser;
        data["impairment"] = this.impairment;
        data["deductible"] = this.deductible;
        data["impairmentPercent"] = this.impairmentPercent;
        data["appraiserAmount"] = this.appraiserAmount;
        data["establishmentValue"] = this.establishmentValue;
        data["additionalExpenses"] = this.additionalExpenses;
        data["requestedAmount"] = this.requestedAmount;
        data["approvedAmount"] = this.approvedAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["driverId"] = this.driverId;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["seniorityDate"] = this.seniorityDate ? this.seniorityDate.toISOString() : <any>undefined;
        data["sueAccidentAndDamageInfoId"] = this.sueAccidentAndDamageInfoId;
        data["sueAccidentAndDamageInfo"] = this.sueAccidentAndDamageInfo ? this.sueAccidentAndDamageInfo.toJSON() : <any>undefined;
        data["participant1Id"] = this.participant1Id;
        data["participant1"] = this.participant1 ? this.participant1.toJSON() : <any>undefined;
        data["participant2Id"] = this.participant2Id;
        data["participant2"] = this.participant2 ? this.participant2.toJSON() : <any>undefined;
        data["participant3Id"] = this.participant3Id;
        data["participant3"] = this.participant3 ? this.participant3.toJSON() : <any>undefined;
        data["participant4Id"] = this.participant4Id;
        data["participant4"] = this.participant4 ? this.participant4.toJSON() : <any>undefined;
        data["participant5Id"] = this.participant5Id;
        data["participant5"] = this.participant5 ? this.participant5.toJSON() : <any>undefined;
        data["participant6Id"] = this.participant6Id;
        data["participant6"] = this.participant6 ? this.participant6.toJSON() : <any>undefined;
        data["sueWitness1Id"] = this.sueWitness1Id;
        data["sueWitness1"] = this.sueWitness1 ? this.sueWitness1.toJSON() : <any>undefined;
        data["sueWitness2Id"] = this.sueWitness2Id;
        data["sueWitness2"] = this.sueWitness2 ? this.sueWitness2.toJSON() : <any>undefined;
        data["involvedVehiclesId"] = this.involvedVehiclesId;
        data["involvedVehicles"] = this.involvedVehicles ? this.involvedVehicles.toJSON() : <any>undefined;
        data["garageDetailsId"] = this.garageDetailsId;
        data["garageDetails"] = this.garageDetails ? this.garageDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISue {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    sueNumber?: string | undefined;
    serialNumber?: number;
    internalNumber?: number;
    openingDate?: Date;
    closingDate?: Date;
    sueType?: SueType;
    status?: SueStatus2;
    activityStatus?: ActivityStatus;
    policyId?: string | undefined;
    riderId?: string | undefined;
    rider?: Rider;
    policy?: Policy;
    customerId?: string;
    customer?: Customer;
    handlerId?: string | undefined;
    handler?: User;
    insuranceCompanyId?: string | undefined;
    insuranceCompany?: InsuranceCompany;
    damageAppraiser?: number;
    impairment?: number;
    deductible?: number;
    impairmentPercent?: number;
    appraiserAmount?: number;
    establishmentValue?: number;
    additionalExpenses?: number;
    requestedAmount?: number;
    approvedAmount?: number;
    paymentDate?: Date;
    comments?: string | undefined;
    driverId?: string | undefined;
    driver?: SueCarAndDriverInfo;
    seniorityDate?: Date;
    sueAccidentAndDamageInfoId?: string | undefined;
    sueAccidentAndDamageInfo?: SueAccidentAndDamageInfo;
    participant1Id?: string | undefined;
    participant1?: SueParticipant;
    participant2Id?: string | undefined;
    participant2?: SueParticipant;
    participant3Id?: string | undefined;
    participant3?: SueParticipant;
    participant4Id?: string | undefined;
    participant4?: SueParticipant;
    participant5Id?: string | undefined;
    participant5?: SueParticipant;
    participant6Id?: string | undefined;
    participant6?: SueParticipant;
    sueWitness1Id?: string | undefined;
    sueWitness1?: SueWitness;
    sueWitness2Id?: string | undefined;
    sueWitness2?: SueWitness;
    involvedVehiclesId?: string | undefined;
    involvedVehicles?: SueInvolvedVehicles;
    garageDetailsId?: string | undefined;
    garageDetails?: SueGarageDetails;
    treatments?: Treatment[] | undefined;
    documents?: Document[] | undefined;
}

export class SueAccidentAndDamageInfo implements ISueAccidentAndDamageInfo {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    accidentDateTime?: Date;
    isDriverLicensed?: boolean;
    accidentAddress?: string | undefined;
    accidentDetails?: string | undefined;
    isPoliceNotified?: boolean;
    stationName?: string | undefined;
    caseNumber?: string | undefined;
    insuredCarDamageDescription?: string | undefined;
    thirdPartyCarDamageDescription?: string | undefined;

    constructor(data?: ISueAccidentAndDamageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.accidentDateTime = _data["accidentDateTime"] ? new Date(_data["accidentDateTime"].toString()) : <any>undefined;
            this.isDriverLicensed = _data["isDriverLicensed"];
            this.accidentAddress = _data["accidentAddress"];
            this.accidentDetails = _data["accidentDetails"];
            this.isPoliceNotified = _data["isPoliceNotified"];
            this.stationName = _data["stationName"];
            this.caseNumber = _data["caseNumber"];
            this.insuredCarDamageDescription = _data["insuredCarDamageDescription"];
            this.thirdPartyCarDamageDescription = _data["thirdPartyCarDamageDescription"];
        }
    }

    static fromJS(data: any): SueAccidentAndDamageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SueAccidentAndDamageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["accidentDateTime"] = this.accidentDateTime ? this.accidentDateTime.toISOString() : <any>undefined;
        data["isDriverLicensed"] = this.isDriverLicensed;
        data["accidentAddress"] = this.accidentAddress;
        data["accidentDetails"] = this.accidentDetails;
        data["isPoliceNotified"] = this.isPoliceNotified;
        data["stationName"] = this.stationName;
        data["caseNumber"] = this.caseNumber;
        data["insuredCarDamageDescription"] = this.insuredCarDamageDescription;
        data["thirdPartyCarDamageDescription"] = this.thirdPartyCarDamageDescription;
        return data;
    }
}

export interface ISueAccidentAndDamageInfo {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    accidentDateTime?: Date;
    isDriverLicensed?: boolean;
    accidentAddress?: string | undefined;
    accidentDetails?: string | undefined;
    isPoliceNotified?: boolean;
    stationName?: string | undefined;
    caseNumber?: string | undefined;
    insuredCarDamageDescription?: string | undefined;
    thirdPartyCarDamageDescription?: string | undefined;
}

export class SueCarAndDriverInfo implements ISueCarAndDriverInfo {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    sue?: Sue;
    driverFullName?: string | undefined;
    driverIdentity?: string | undefined;
    isDriverVehicleOwner?: boolean;
    driverBirthDate?: Date;
    driverAddress?: string | undefined;
    driverPhoneNumber?: string | undefined;
    driverMobileNumber?: string | undefined;
    driverOwnerRelation?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicensIssueDate?: Date | undefined;
    driverLicenseType?: number;
    isIsraeliLicense?: boolean;
    vehicleId?: string | undefined;
    vehicle?: Vehicle;
    vehicleType?: VehicleType;
    vehicleYearOfProduction?: number;
    vehicleLicensePlate?: string | undefined;
    vehicleGearboxType?: GearboxType;
    vehicleLicenseNumber?: string | undefined;
    vehicleModelCode?: string | undefined;
    vehicleModelName?: string | undefined;
    vehicleAdditions?: string | undefined;

    constructor(data?: ISueCarAndDriverInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.sue = _data["sue"] ? Sue.fromJS(_data["sue"]) : <any>undefined;
            this.driverFullName = _data["driverFullName"];
            this.driverIdentity = _data["driverIdentity"];
            this.isDriverVehicleOwner = _data["isDriverVehicleOwner"];
            this.driverBirthDate = _data["driverBirthDate"] ? new Date(_data["driverBirthDate"].toString()) : <any>undefined;
            this.driverAddress = _data["driverAddress"];
            this.driverPhoneNumber = _data["driverPhoneNumber"];
            this.driverMobileNumber = _data["driverMobileNumber"];
            this.driverOwnerRelation = _data["driverOwnerRelation"];
            this.driverLicenseNumber = _data["driverLicenseNumber"];
            this.driverLicensIssueDate = _data["driverLicensIssueDate"] ? new Date(_data["driverLicensIssueDate"].toString()) : <any>undefined;
            this.driverLicenseType = _data["driverLicenseType"];
            this.isIsraeliLicense = _data["isIsraeliLicense"];
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.vehicleYearOfProduction = _data["vehicleYearOfProduction"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleGearboxType = _data["vehicleGearboxType"];
            this.vehicleLicenseNumber = _data["vehicleLicenseNumber"];
            this.vehicleModelCode = _data["vehicleModelCode"];
            this.vehicleModelName = _data["vehicleModelName"];
            this.vehicleAdditions = _data["vehicleAdditions"];
        }
    }

    static fromJS(data: any): SueCarAndDriverInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SueCarAndDriverInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["sue"] = this.sue ? this.sue.toJSON() : <any>undefined;
        data["driverFullName"] = this.driverFullName;
        data["driverIdentity"] = this.driverIdentity;
        data["isDriverVehicleOwner"] = this.isDriverVehicleOwner;
        data["driverBirthDate"] = this.driverBirthDate ? this.driverBirthDate.toISOString() : <any>undefined;
        data["driverAddress"] = this.driverAddress;
        data["driverPhoneNumber"] = this.driverPhoneNumber;
        data["driverMobileNumber"] = this.driverMobileNumber;
        data["driverOwnerRelation"] = this.driverOwnerRelation;
        data["driverLicenseNumber"] = this.driverLicenseNumber;
        data["driverLicensIssueDate"] = this.driverLicensIssueDate ? this.driverLicensIssueDate.toISOString() : <any>undefined;
        data["driverLicenseType"] = this.driverLicenseType;
        data["isIsraeliLicense"] = this.isIsraeliLicense;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["vehicleYearOfProduction"] = this.vehicleYearOfProduction;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleGearboxType"] = this.vehicleGearboxType;
        data["vehicleLicenseNumber"] = this.vehicleLicenseNumber;
        data["vehicleModelCode"] = this.vehicleModelCode;
        data["vehicleModelName"] = this.vehicleModelName;
        data["vehicleAdditions"] = this.vehicleAdditions;
        return data;
    }
}

export interface ISueCarAndDriverInfo {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    sue?: Sue;
    driverFullName?: string | undefined;
    driverIdentity?: string | undefined;
    isDriverVehicleOwner?: boolean;
    driverBirthDate?: Date;
    driverAddress?: string | undefined;
    driverPhoneNumber?: string | undefined;
    driverMobileNumber?: string | undefined;
    driverOwnerRelation?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicensIssueDate?: Date | undefined;
    driverLicenseType?: number;
    isIsraeliLicense?: boolean;
    vehicleId?: string | undefined;
    vehicle?: Vehicle;
    vehicleType?: VehicleType;
    vehicleYearOfProduction?: number;
    vehicleLicensePlate?: string | undefined;
    vehicleGearboxType?: GearboxType;
    vehicleLicenseNumber?: string | undefined;
    vehicleModelCode?: string | undefined;
    vehicleModelName?: string | undefined;
    vehicleAdditions?: string | undefined;
}

export class SueDetailsModel implements ISueDetailsModel {
    generalTab?: GeneralDetailsTab;
    driverAndVehicleDetailsTab?: DriverAndVehicleDetailsTab;
    accidentAndDamageDetailsTab?: AccidentAndDamageDetailsTab;
    injuredAndWitnessesTab?: InjuredAndWitnessesTab;
    involvedVehiclesTab?: InvolvedVehiclesTab;
    garageDetailsTab?: GarageDetailsTab;
    currentTreatmentsTab?: TreatmentModel[] | undefined;
    documentsTab?: DocumentsTab;

    constructor(data?: ISueDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalTab = _data["generalTab"] ? GeneralDetailsTab.fromJS(_data["generalTab"]) : <any>undefined;
            this.driverAndVehicleDetailsTab = _data["driverAndVehicleDetailsTab"] ? DriverAndVehicleDetailsTab.fromJS(_data["driverAndVehicleDetailsTab"]) : <any>undefined;
            this.accidentAndDamageDetailsTab = _data["accidentAndDamageDetailsTab"] ? AccidentAndDamageDetailsTab.fromJS(_data["accidentAndDamageDetailsTab"]) : <any>undefined;
            this.injuredAndWitnessesTab = _data["injuredAndWitnessesTab"] ? InjuredAndWitnessesTab.fromJS(_data["injuredAndWitnessesTab"]) : <any>undefined;
            this.involvedVehiclesTab = _data["involvedVehiclesTab"] ? InvolvedVehiclesTab.fromJS(_data["involvedVehiclesTab"]) : <any>undefined;
            this.garageDetailsTab = _data["garageDetailsTab"] ? GarageDetailsTab.fromJS(_data["garageDetailsTab"]) : <any>undefined;
            if (Array.isArray(_data["currentTreatmentsTab"])) {
                this.currentTreatmentsTab = [] as any;
                for (let item of _data["currentTreatmentsTab"])
                    this.currentTreatmentsTab!.push(TreatmentModel.fromJS(item));
            }
            this.documentsTab = _data["documentsTab"] ? DocumentsTab.fromJS(_data["documentsTab"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SueDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SueDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalTab"] = this.generalTab ? this.generalTab.toJSON() : <any>undefined;
        data["driverAndVehicleDetailsTab"] = this.driverAndVehicleDetailsTab ? this.driverAndVehicleDetailsTab.toJSON() : <any>undefined;
        data["accidentAndDamageDetailsTab"] = this.accidentAndDamageDetailsTab ? this.accidentAndDamageDetailsTab.toJSON() : <any>undefined;
        data["injuredAndWitnessesTab"] = this.injuredAndWitnessesTab ? this.injuredAndWitnessesTab.toJSON() : <any>undefined;
        data["involvedVehiclesTab"] = this.involvedVehiclesTab ? this.involvedVehiclesTab.toJSON() : <any>undefined;
        data["garageDetailsTab"] = this.garageDetailsTab ? this.garageDetailsTab.toJSON() : <any>undefined;
        if (Array.isArray(this.currentTreatmentsTab)) {
            data["currentTreatmentsTab"] = [];
            for (let item of this.currentTreatmentsTab)
                data["currentTreatmentsTab"].push(item.toJSON());
        }
        data["documentsTab"] = this.documentsTab ? this.documentsTab.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISueDetailsModel {
    generalTab?: GeneralDetailsTab;
    driverAndVehicleDetailsTab?: DriverAndVehicleDetailsTab;
    accidentAndDamageDetailsTab?: AccidentAndDamageDetailsTab;
    injuredAndWitnessesTab?: InjuredAndWitnessesTab;
    involvedVehiclesTab?: InvolvedVehiclesTab;
    garageDetailsTab?: GarageDetailsTab;
    currentTreatmentsTab?: TreatmentModel[] | undefined;
    documentsTab?: DocumentsTab;
}

export class SueDocumentModel implements ISueDocumentModel {
    id?: string | undefined;
    name?: string | undefined;
    createdDate?: Date;
    fileSize?: string | undefined;
    filePath?: string | undefined;
    policyNumber?: string | undefined;

    constructor(data?: ISueDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.fileSize = _data["fileSize"];
            this.filePath = _data["filePath"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): SueDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SueDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["fileSize"] = this.fileSize;
        data["filePath"] = this.filePath;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface ISueDocumentModel {
    id?: string | undefined;
    name?: string | undefined;
    createdDate?: Date;
    fileSize?: string | undefined;
    filePath?: string | undefined;
    policyNumber?: string | undefined;
}

export class SueGarageDetails implements ISueGarageDetails {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    assessorName?: string | undefined;
    assessorPhoneNumber?: string | undefined;
    assessorMobilePhoneNumber?: string | undefined;
    assessorFaxNumber?: string | undefined;
    assessorAddress?: string | undefined;
    assessorEmail?: string | undefined;
    garageDetails?: boolean;
    garageName?: string | undefined;
    garagePhone?: string | undefined;
    garageFaxNumber?: string | undefined;
    garageAddress?: string | undefined;
    garageEmail?: string | undefined;

    constructor(data?: ISueGarageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.assessorName = _data["assessorName"];
            this.assessorPhoneNumber = _data["assessorPhoneNumber"];
            this.assessorMobilePhoneNumber = _data["assessorMobilePhoneNumber"];
            this.assessorFaxNumber = _data["assessorFaxNumber"];
            this.assessorAddress = _data["assessorAddress"];
            this.assessorEmail = _data["assessorEmail"];
            this.garageDetails = _data["garageDetails"];
            this.garageName = _data["garageName"];
            this.garagePhone = _data["garagePhone"];
            this.garageFaxNumber = _data["garageFaxNumber"];
            this.garageAddress = _data["garageAddress"];
            this.garageEmail = _data["garageEmail"];
        }
    }

    static fromJS(data: any): SueGarageDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SueGarageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["assessorName"] = this.assessorName;
        data["assessorPhoneNumber"] = this.assessorPhoneNumber;
        data["assessorMobilePhoneNumber"] = this.assessorMobilePhoneNumber;
        data["assessorFaxNumber"] = this.assessorFaxNumber;
        data["assessorAddress"] = this.assessorAddress;
        data["assessorEmail"] = this.assessorEmail;
        data["garageDetails"] = this.garageDetails;
        data["garageName"] = this.garageName;
        data["garagePhone"] = this.garagePhone;
        data["garageFaxNumber"] = this.garageFaxNumber;
        data["garageAddress"] = this.garageAddress;
        data["garageEmail"] = this.garageEmail;
        return data;
    }
}

export interface ISueGarageDetails {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    assessorName?: string | undefined;
    assessorPhoneNumber?: string | undefined;
    assessorMobilePhoneNumber?: string | undefined;
    assessorFaxNumber?: string | undefined;
    assessorAddress?: string | undefined;
    assessorEmail?: string | undefined;
    garageDetails?: boolean;
    garageName?: string | undefined;
    garagePhone?: string | undefined;
    garageFaxNumber?: string | undefined;
    garageAddress?: string | undefined;
    garageEmail?: string | undefined;
}

export class SueGarageDetailsModel implements ISueGarageDetailsModel {
    id?: string | undefined;
    assessorName?: string | undefined;
    assessorPhoneNumber?: string | undefined;
    assessorMobilePhoneNumber?: string | undefined;
    assessorFaxNumber?: string | undefined;
    assessorAddress?: string | undefined;
    assessorEmail?: string | undefined;
    garageDetails?: boolean;
    garageName?: string | undefined;
    garagePhone?: string | undefined;
    garageFaxNumber?: string | undefined;
    garageAddress?: string | undefined;
    garageEmail?: string | undefined;

    constructor(data?: ISueGarageDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessorName = _data["assessorName"];
            this.assessorPhoneNumber = _data["assessorPhoneNumber"];
            this.assessorMobilePhoneNumber = _data["assessorMobilePhoneNumber"];
            this.assessorFaxNumber = _data["assessorFaxNumber"];
            this.assessorAddress = _data["assessorAddress"];
            this.assessorEmail = _data["assessorEmail"];
            this.garageDetails = _data["garageDetails"];
            this.garageName = _data["garageName"];
            this.garagePhone = _data["garagePhone"];
            this.garageFaxNumber = _data["garageFaxNumber"];
            this.garageAddress = _data["garageAddress"];
            this.garageEmail = _data["garageEmail"];
        }
    }

    static fromJS(data: any): SueGarageDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SueGarageDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessorName"] = this.assessorName;
        data["assessorPhoneNumber"] = this.assessorPhoneNumber;
        data["assessorMobilePhoneNumber"] = this.assessorMobilePhoneNumber;
        data["assessorFaxNumber"] = this.assessorFaxNumber;
        data["assessorAddress"] = this.assessorAddress;
        data["assessorEmail"] = this.assessorEmail;
        data["garageDetails"] = this.garageDetails;
        data["garageName"] = this.garageName;
        data["garagePhone"] = this.garagePhone;
        data["garageFaxNumber"] = this.garageFaxNumber;
        data["garageAddress"] = this.garageAddress;
        data["garageEmail"] = this.garageEmail;
        return data;
    }
}

export interface ISueGarageDetailsModel {
    id?: string | undefined;
    assessorName?: string | undefined;
    assessorPhoneNumber?: string | undefined;
    assessorMobilePhoneNumber?: string | undefined;
    assessorFaxNumber?: string | undefined;
    assessorAddress?: string | undefined;
    assessorEmail?: string | undefined;
    garageDetails?: boolean;
    garageName?: string | undefined;
    garagePhone?: string | undefined;
    garageFaxNumber?: string | undefined;
    garageAddress?: string | undefined;
    garageEmail?: string | undefined;
}

export class SueInvolvedVehicles implements ISueInvolvedVehicles {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    isThirdPartyDefendantCompany?: boolean;
    thirdPartySueNumber?: string | undefined;
    thirdPartyLicensePlateNumber?: string | undefined;
    thirdPartyCarModel?: string | undefined;
    vehicleType?: VehicleType;
    thirdPartyInsuranceCompany?: InsuranceCompany;
    thirdPartyInsuranceCompanyId?: string | undefined;
    thirdPartyPolicynumber?: string | undefined;
    thirdPartyAddress?: string | undefined;
    thirdPartyPhone1?: string | undefined;
    thirdPartyPhone2?: string | undefined;
    thirdPartyAgentName?: string | undefined;
    thirdPartyAgentPhone?: string | undefined;
    thirdPartyAgentAddress?: string | undefined;
    thirdPartyCarOwnerName?: string | undefined;
    thirdPartyOwnerIdentifier?: string | undefined;
    thirdPartyCarOwnerAddress?: string | undefined;
    thirdPartyCarOwnerPhone?: string | undefined;
    thirdPartyCarOwnerMobile?: string | undefined;
    thirdPartyCarOwnerAgentPhone?: string | undefined;
    thirdPartyPolicyName?: string | undefined;
    thirdPartyOwnerAddress?: string | undefined;
    isDriverOwnerOfTheVehicle?: boolean;
    driverName?: string | undefined;
    driverAddress?: string | undefined;
    driverIdentifier?: string | undefined;
    licenseNumber?: string | undefined;
    driverPhone1?: string | undefined;
    driverPhone2?: string | undefined;
    additional1CarLicensePlateNumber?: string | undefined;
    additional1OwnerName?: string | undefined;
    additional1InsuranceCompany?: InsuranceCompany;
    additional1InsuranceCompanyId?: string | undefined;
    additional1PolicyName?: string | undefined;
    additional1Phone1?: string | undefined;
    additiona1lPhone2?: string | undefined;
    additional2CarLicensePlateNumber2?: string | undefined;
    additional2OwnerName2?: string | undefined;
    additional2InsuranceCompany?: InsuranceCompany;
    additional2InsuranceCompanyId?: string | undefined;
    additional2PolicyName2?: string | undefined;
    additional2Phone1?: string | undefined;
    additional2Phone2?: string | undefined;

    constructor(data?: ISueInvolvedVehicles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.isThirdPartyDefendantCompany = _data["isThirdPartyDefendantCompany"];
            this.thirdPartySueNumber = _data["thirdPartySueNumber"];
            this.thirdPartyLicensePlateNumber = _data["thirdPartyLicensePlateNumber"];
            this.thirdPartyCarModel = _data["thirdPartyCarModel"];
            this.vehicleType = _data["vehicleType"];
            this.thirdPartyInsuranceCompany = _data["thirdPartyInsuranceCompany"] ? InsuranceCompany.fromJS(_data["thirdPartyInsuranceCompany"]) : <any>undefined;
            this.thirdPartyInsuranceCompanyId = _data["thirdPartyInsuranceCompanyId"];
            this.thirdPartyPolicynumber = _data["thirdPartyPolicynumber"];
            this.thirdPartyAddress = _data["thirdPartyAddress"];
            this.thirdPartyPhone1 = _data["thirdPartyPhone1"];
            this.thirdPartyPhone2 = _data["thirdPartyPhone2"];
            this.thirdPartyAgentName = _data["thirdPartyAgentName"];
            this.thirdPartyAgentPhone = _data["thirdPartyAgentPhone"];
            this.thirdPartyAgentAddress = _data["thirdPartyAgentAddress"];
            this.thirdPartyCarOwnerName = _data["thirdPartyCarOwnerName"];
            this.thirdPartyOwnerIdentifier = _data["thirdPartyOwnerIdentifier"];
            this.thirdPartyCarOwnerAddress = _data["thirdPartyCarOwnerAddress"];
            this.thirdPartyCarOwnerPhone = _data["thirdPartyCarOwnerPhone"];
            this.thirdPartyCarOwnerMobile = _data["thirdPartyCarOwnerMobile"];
            this.thirdPartyCarOwnerAgentPhone = _data["thirdPartyCarOwnerAgentPhone"];
            this.thirdPartyPolicyName = _data["thirdPartyPolicyName"];
            this.thirdPartyOwnerAddress = _data["thirdPartyOwnerAddress"];
            this.isDriverOwnerOfTheVehicle = _data["isDriverOwnerOfTheVehicle"];
            this.driverName = _data["driverName"];
            this.driverAddress = _data["driverAddress"];
            this.driverIdentifier = _data["driverIdentifier"];
            this.licenseNumber = _data["licenseNumber"];
            this.driverPhone1 = _data["driverPhone1"];
            this.driverPhone2 = _data["driverPhone2"];
            this.additional1CarLicensePlateNumber = _data["additional1CarLicensePlateNumber"];
            this.additional1OwnerName = _data["additional1OwnerName"];
            this.additional1InsuranceCompany = _data["additional1InsuranceCompany"] ? InsuranceCompany.fromJS(_data["additional1InsuranceCompany"]) : <any>undefined;
            this.additional1InsuranceCompanyId = _data["additional1InsuranceCompanyId"];
            this.additional1PolicyName = _data["additional1PolicyName"];
            this.additional1Phone1 = _data["additional1Phone1"];
            this.additiona1lPhone2 = _data["additiona1lPhone2"];
            this.additional2CarLicensePlateNumber2 = _data["additional2CarLicensePlateNumber2"];
            this.additional2OwnerName2 = _data["additional2OwnerName2"];
            this.additional2InsuranceCompany = _data["additional2InsuranceCompany"] ? InsuranceCompany.fromJS(_data["additional2InsuranceCompany"]) : <any>undefined;
            this.additional2InsuranceCompanyId = _data["additional2InsuranceCompanyId"];
            this.additional2PolicyName2 = _data["additional2PolicyName2"];
            this.additional2Phone1 = _data["additional2Phone1"];
            this.additional2Phone2 = _data["additional2Phone2"];
        }
    }

    static fromJS(data: any): SueInvolvedVehicles {
        data = typeof data === 'object' ? data : {};
        let result = new SueInvolvedVehicles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["isThirdPartyDefendantCompany"] = this.isThirdPartyDefendantCompany;
        data["thirdPartySueNumber"] = this.thirdPartySueNumber;
        data["thirdPartyLicensePlateNumber"] = this.thirdPartyLicensePlateNumber;
        data["thirdPartyCarModel"] = this.thirdPartyCarModel;
        data["vehicleType"] = this.vehicleType;
        data["thirdPartyInsuranceCompany"] = this.thirdPartyInsuranceCompany ? this.thirdPartyInsuranceCompany.toJSON() : <any>undefined;
        data["thirdPartyInsuranceCompanyId"] = this.thirdPartyInsuranceCompanyId;
        data["thirdPartyPolicynumber"] = this.thirdPartyPolicynumber;
        data["thirdPartyAddress"] = this.thirdPartyAddress;
        data["thirdPartyPhone1"] = this.thirdPartyPhone1;
        data["thirdPartyPhone2"] = this.thirdPartyPhone2;
        data["thirdPartyAgentName"] = this.thirdPartyAgentName;
        data["thirdPartyAgentPhone"] = this.thirdPartyAgentPhone;
        data["thirdPartyAgentAddress"] = this.thirdPartyAgentAddress;
        data["thirdPartyCarOwnerName"] = this.thirdPartyCarOwnerName;
        data["thirdPartyOwnerIdentifier"] = this.thirdPartyOwnerIdentifier;
        data["thirdPartyCarOwnerAddress"] = this.thirdPartyCarOwnerAddress;
        data["thirdPartyCarOwnerPhone"] = this.thirdPartyCarOwnerPhone;
        data["thirdPartyCarOwnerMobile"] = this.thirdPartyCarOwnerMobile;
        data["thirdPartyCarOwnerAgentPhone"] = this.thirdPartyCarOwnerAgentPhone;
        data["thirdPartyPolicyName"] = this.thirdPartyPolicyName;
        data["thirdPartyOwnerAddress"] = this.thirdPartyOwnerAddress;
        data["isDriverOwnerOfTheVehicle"] = this.isDriverOwnerOfTheVehicle;
        data["driverName"] = this.driverName;
        data["driverAddress"] = this.driverAddress;
        data["driverIdentifier"] = this.driverIdentifier;
        data["licenseNumber"] = this.licenseNumber;
        data["driverPhone1"] = this.driverPhone1;
        data["driverPhone2"] = this.driverPhone2;
        data["additional1CarLicensePlateNumber"] = this.additional1CarLicensePlateNumber;
        data["additional1OwnerName"] = this.additional1OwnerName;
        data["additional1InsuranceCompany"] = this.additional1InsuranceCompany ? this.additional1InsuranceCompany.toJSON() : <any>undefined;
        data["additional1InsuranceCompanyId"] = this.additional1InsuranceCompanyId;
        data["additional1PolicyName"] = this.additional1PolicyName;
        data["additional1Phone1"] = this.additional1Phone1;
        data["additiona1lPhone2"] = this.additiona1lPhone2;
        data["additional2CarLicensePlateNumber2"] = this.additional2CarLicensePlateNumber2;
        data["additional2OwnerName2"] = this.additional2OwnerName2;
        data["additional2InsuranceCompany"] = this.additional2InsuranceCompany ? this.additional2InsuranceCompany.toJSON() : <any>undefined;
        data["additional2InsuranceCompanyId"] = this.additional2InsuranceCompanyId;
        data["additional2PolicyName2"] = this.additional2PolicyName2;
        data["additional2Phone1"] = this.additional2Phone1;
        data["additional2Phone2"] = this.additional2Phone2;
        return data;
    }
}

export interface ISueInvolvedVehicles {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    isThirdPartyDefendantCompany?: boolean;
    thirdPartySueNumber?: string | undefined;
    thirdPartyLicensePlateNumber?: string | undefined;
    thirdPartyCarModel?: string | undefined;
    vehicleType?: VehicleType;
    thirdPartyInsuranceCompany?: InsuranceCompany;
    thirdPartyInsuranceCompanyId?: string | undefined;
    thirdPartyPolicynumber?: string | undefined;
    thirdPartyAddress?: string | undefined;
    thirdPartyPhone1?: string | undefined;
    thirdPartyPhone2?: string | undefined;
    thirdPartyAgentName?: string | undefined;
    thirdPartyAgentPhone?: string | undefined;
    thirdPartyAgentAddress?: string | undefined;
    thirdPartyCarOwnerName?: string | undefined;
    thirdPartyOwnerIdentifier?: string | undefined;
    thirdPartyCarOwnerAddress?: string | undefined;
    thirdPartyCarOwnerPhone?: string | undefined;
    thirdPartyCarOwnerMobile?: string | undefined;
    thirdPartyCarOwnerAgentPhone?: string | undefined;
    thirdPartyPolicyName?: string | undefined;
    thirdPartyOwnerAddress?: string | undefined;
    isDriverOwnerOfTheVehicle?: boolean;
    driverName?: string | undefined;
    driverAddress?: string | undefined;
    driverIdentifier?: string | undefined;
    licenseNumber?: string | undefined;
    driverPhone1?: string | undefined;
    driverPhone2?: string | undefined;
    additional1CarLicensePlateNumber?: string | undefined;
    additional1OwnerName?: string | undefined;
    additional1InsuranceCompany?: InsuranceCompany;
    additional1InsuranceCompanyId?: string | undefined;
    additional1PolicyName?: string | undefined;
    additional1Phone1?: string | undefined;
    additiona1lPhone2?: string | undefined;
    additional2CarLicensePlateNumber2?: string | undefined;
    additional2OwnerName2?: string | undefined;
    additional2InsuranceCompany?: InsuranceCompany;
    additional2InsuranceCompanyId?: string | undefined;
    additional2PolicyName2?: string | undefined;
    additional2Phone1?: string | undefined;
    additional2Phone2?: string | undefined;
}

export class SueInvolvedVehiclesModel implements ISueInvolvedVehiclesModel {
    id?: string | undefined;
    isThirdPartyDefendantCompany?: boolean;
    thirdPartySueNumber?: string | undefined;
    thirdPartyAddress?: string | undefined;
    thirdPartyPhone1?: string | undefined;
    thirdPartyPhone2?: string | undefined;
    thirdPartyAgentName?: string | undefined;
    thirdPartyAgentPhone?: string | undefined;
    thirdPartyAgentAddress?: string | undefined;
    thirdPartyLicensePlateNumber?: string | undefined;
    thirdPartyCarModel?: string | undefined;
    thirdPartyTypeOfVehicle?: VehicleType;
    thirdPartyInsuranceCompany?: InsuranceCompanyModel;
    thirdPartyInsuranceCompanyId?: string | undefined;
    thirdPartyPolicyName?: string | undefined;
    thirdPartyCarOwnerName?: string | undefined;
    thirdPartyOwnerAddress?: string | undefined;
    thirdPartyOwnerIdentifier?: string | undefined;
    thirdPartyCarOwnerPhone?: string | undefined;
    thirdPartyCarOwnerMobile?: string | undefined;
    isDriverOwnerOfTheVehicle?: boolean;
    driverName?: string | undefined;
    driverAddress?: string | undefined;
    driverIdentifier?: string | undefined;
    licenseNumber?: string | undefined;
    driverPhone1?: string | undefined;
    driverPhone2?: string | undefined;
    additional1CarLicensePlateNumber?: string | undefined;
    additional1OwnerName?: string | undefined;
    additional1InsuranceCompany?: InsuranceCompanyModel;
    additional1InsuranceCompanyId?: string | undefined;
    additional1PolicyName?: string | undefined;
    additional1Phone1?: string | undefined;
    additiona1lPhone2?: string | undefined;
    additional2CarLicensePlateNumber2?: string | undefined;
    additional2OwnerName2?: string | undefined;
    additional2InsuranceCompany?: InsuranceCompanyModel;
    additional2InsuranceCompanyId?: string | undefined;
    additional2PolicyName2?: string | undefined;
    additional2Phone1?: string | undefined;
    additional2Phone2?: string | undefined;

    constructor(data?: ISueInvolvedVehiclesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isThirdPartyDefendantCompany = _data["isThirdPartyDefendantCompany"];
            this.thirdPartySueNumber = _data["thirdPartySueNumber"];
            this.thirdPartyAddress = _data["thirdPartyAddress"];
            this.thirdPartyPhone1 = _data["thirdPartyPhone1"];
            this.thirdPartyPhone2 = _data["thirdPartyPhone2"];
            this.thirdPartyAgentName = _data["thirdPartyAgentName"];
            this.thirdPartyAgentPhone = _data["thirdPartyAgentPhone"];
            this.thirdPartyAgentAddress = _data["thirdPartyAgentAddress"];
            this.thirdPartyLicensePlateNumber = _data["thirdPartyLicensePlateNumber"];
            this.thirdPartyCarModel = _data["thirdPartyCarModel"];
            this.thirdPartyTypeOfVehicle = _data["thirdPartyTypeOfVehicle"];
            this.thirdPartyInsuranceCompany = _data["thirdPartyInsuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["thirdPartyInsuranceCompany"]) : <any>undefined;
            this.thirdPartyInsuranceCompanyId = _data["thirdPartyInsuranceCompanyId"];
            this.thirdPartyPolicyName = _data["thirdPartyPolicyName"];
            this.thirdPartyCarOwnerName = _data["thirdPartyCarOwnerName"];
            this.thirdPartyOwnerAddress = _data["thirdPartyOwnerAddress"];
            this.thirdPartyOwnerIdentifier = _data["thirdPartyOwnerIdentifier"];
            this.thirdPartyCarOwnerPhone = _data["thirdPartyCarOwnerPhone"];
            this.thirdPartyCarOwnerMobile = _data["thirdPartyCarOwnerMobile"];
            this.isDriverOwnerOfTheVehicle = _data["isDriverOwnerOfTheVehicle"];
            this.driverName = _data["driverName"];
            this.driverAddress = _data["driverAddress"];
            this.driverIdentifier = _data["driverIdentifier"];
            this.licenseNumber = _data["licenseNumber"];
            this.driverPhone1 = _data["driverPhone1"];
            this.driverPhone2 = _data["driverPhone2"];
            this.additional1CarLicensePlateNumber = _data["additional1CarLicensePlateNumber"];
            this.additional1OwnerName = _data["additional1OwnerName"];
            this.additional1InsuranceCompany = _data["additional1InsuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["additional1InsuranceCompany"]) : <any>undefined;
            this.additional1InsuranceCompanyId = _data["additional1InsuranceCompanyId"];
            this.additional1PolicyName = _data["additional1PolicyName"];
            this.additional1Phone1 = _data["additional1Phone1"];
            this.additiona1lPhone2 = _data["additiona1lPhone2"];
            this.additional2CarLicensePlateNumber2 = _data["additional2CarLicensePlateNumber2"];
            this.additional2OwnerName2 = _data["additional2OwnerName2"];
            this.additional2InsuranceCompany = _data["additional2InsuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["additional2InsuranceCompany"]) : <any>undefined;
            this.additional2InsuranceCompanyId = _data["additional2InsuranceCompanyId"];
            this.additional2PolicyName2 = _data["additional2PolicyName2"];
            this.additional2Phone1 = _data["additional2Phone1"];
            this.additional2Phone2 = _data["additional2Phone2"];
        }
    }

    static fromJS(data: any): SueInvolvedVehiclesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SueInvolvedVehiclesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isThirdPartyDefendantCompany"] = this.isThirdPartyDefendantCompany;
        data["thirdPartySueNumber"] = this.thirdPartySueNumber;
        data["thirdPartyAddress"] = this.thirdPartyAddress;
        data["thirdPartyPhone1"] = this.thirdPartyPhone1;
        data["thirdPartyPhone2"] = this.thirdPartyPhone2;
        data["thirdPartyAgentName"] = this.thirdPartyAgentName;
        data["thirdPartyAgentPhone"] = this.thirdPartyAgentPhone;
        data["thirdPartyAgentAddress"] = this.thirdPartyAgentAddress;
        data["thirdPartyLicensePlateNumber"] = this.thirdPartyLicensePlateNumber;
        data["thirdPartyCarModel"] = this.thirdPartyCarModel;
        data["thirdPartyTypeOfVehicle"] = this.thirdPartyTypeOfVehicle;
        data["thirdPartyInsuranceCompany"] = this.thirdPartyInsuranceCompany ? this.thirdPartyInsuranceCompany.toJSON() : <any>undefined;
        data["thirdPartyInsuranceCompanyId"] = this.thirdPartyInsuranceCompanyId;
        data["thirdPartyPolicyName"] = this.thirdPartyPolicyName;
        data["thirdPartyCarOwnerName"] = this.thirdPartyCarOwnerName;
        data["thirdPartyOwnerAddress"] = this.thirdPartyOwnerAddress;
        data["thirdPartyOwnerIdentifier"] = this.thirdPartyOwnerIdentifier;
        data["thirdPartyCarOwnerPhone"] = this.thirdPartyCarOwnerPhone;
        data["thirdPartyCarOwnerMobile"] = this.thirdPartyCarOwnerMobile;
        data["isDriverOwnerOfTheVehicle"] = this.isDriverOwnerOfTheVehicle;
        data["driverName"] = this.driverName;
        data["driverAddress"] = this.driverAddress;
        data["driverIdentifier"] = this.driverIdentifier;
        data["licenseNumber"] = this.licenseNumber;
        data["driverPhone1"] = this.driverPhone1;
        data["driverPhone2"] = this.driverPhone2;
        data["additional1CarLicensePlateNumber"] = this.additional1CarLicensePlateNumber;
        data["additional1OwnerName"] = this.additional1OwnerName;
        data["additional1InsuranceCompany"] = this.additional1InsuranceCompany ? this.additional1InsuranceCompany.toJSON() : <any>undefined;
        data["additional1InsuranceCompanyId"] = this.additional1InsuranceCompanyId;
        data["additional1PolicyName"] = this.additional1PolicyName;
        data["additional1Phone1"] = this.additional1Phone1;
        data["additiona1lPhone2"] = this.additiona1lPhone2;
        data["additional2CarLicensePlateNumber2"] = this.additional2CarLicensePlateNumber2;
        data["additional2OwnerName2"] = this.additional2OwnerName2;
        data["additional2InsuranceCompany"] = this.additional2InsuranceCompany ? this.additional2InsuranceCompany.toJSON() : <any>undefined;
        data["additional2InsuranceCompanyId"] = this.additional2InsuranceCompanyId;
        data["additional2PolicyName2"] = this.additional2PolicyName2;
        data["additional2Phone1"] = this.additional2Phone1;
        data["additional2Phone2"] = this.additional2Phone2;
        return data;
    }
}

export interface ISueInvolvedVehiclesModel {
    id?: string | undefined;
    isThirdPartyDefendantCompany?: boolean;
    thirdPartySueNumber?: string | undefined;
    thirdPartyAddress?: string | undefined;
    thirdPartyPhone1?: string | undefined;
    thirdPartyPhone2?: string | undefined;
    thirdPartyAgentName?: string | undefined;
    thirdPartyAgentPhone?: string | undefined;
    thirdPartyAgentAddress?: string | undefined;
    thirdPartyLicensePlateNumber?: string | undefined;
    thirdPartyCarModel?: string | undefined;
    thirdPartyTypeOfVehicle?: VehicleType;
    thirdPartyInsuranceCompany?: InsuranceCompanyModel;
    thirdPartyInsuranceCompanyId?: string | undefined;
    thirdPartyPolicyName?: string | undefined;
    thirdPartyCarOwnerName?: string | undefined;
    thirdPartyOwnerAddress?: string | undefined;
    thirdPartyOwnerIdentifier?: string | undefined;
    thirdPartyCarOwnerPhone?: string | undefined;
    thirdPartyCarOwnerMobile?: string | undefined;
    isDriverOwnerOfTheVehicle?: boolean;
    driverName?: string | undefined;
    driverAddress?: string | undefined;
    driverIdentifier?: string | undefined;
    licenseNumber?: string | undefined;
    driverPhone1?: string | undefined;
    driverPhone2?: string | undefined;
    additional1CarLicensePlateNumber?: string | undefined;
    additional1OwnerName?: string | undefined;
    additional1InsuranceCompany?: InsuranceCompanyModel;
    additional1InsuranceCompanyId?: string | undefined;
    additional1PolicyName?: string | undefined;
    additional1Phone1?: string | undefined;
    additiona1lPhone2?: string | undefined;
    additional2CarLicensePlateNumber2?: string | undefined;
    additional2OwnerName2?: string | undefined;
    additional2InsuranceCompany?: InsuranceCompanyModel;
    additional2InsuranceCompanyId?: string | undefined;
    additional2PolicyName2?: string | undefined;
    additional2Phone1?: string | undefined;
    additional2Phone2?: string | undefined;
}

export class SueModel implements ISueModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    sueNumber?: string | undefined;
    serialNumber?: number;
    internalNumber?: number;
    openingDate?: Date;
    closingDate?: Date;
    sueType?: SueType;
    status?: SueStatus2;
    activityStatus?: ActivityStatus;
    policyId?: string | undefined;
    policy?: PolicyModel;
    riderId?: string | undefined;
    rider?: RiderModel;
    customerId?: string;
    customer?: CustomerModel;
    handlerId?: string | undefined;
    handler?: UserModel;
    insuranceCompanyId?: string | undefined;
    insuranceCompany?: InsuranceCompanyModel;
    damageAppraiser?: number;
    impairment?: number;
    deductible?: number;
    impairmentPercent?: number;
    appraiserAmount?: number;
    establishmentValue?: number;
    additionalExpenses?: number;
    requestedAmount?: number;
    approvedAmount?: number;
    paymentDate?: Date;
    comments?: string | undefined;
    vehicleId?: string;
    vehicle?: VehicleDataModel;
    driverId?: string;
    driver?: DriverAndVehicleDetailsTab;
    seniorityDate?: Date;
    sueAccidentAndDamageInfoId?: string | undefined;
    sueAccidentAndDamageInfo?: AccidentAndDamageDetailsTab;
    participant1Id?: string | undefined;
    participant1?: SueParticipantModel;
    participant2Id?: string | undefined;
    participant2?: SueParticipantModel;
    participant3Id?: string | undefined;
    participant3?: SueParticipantModel;
    participant4Id?: string | undefined;
    participant4?: SueParticipantModel;
    participant5Id?: string | undefined;
    participant5?: SueParticipantModel;
    participant6Id?: string | undefined;
    participant6?: SueParticipantModel;
    sueWitness1Id?: string | undefined;
    sueWitness1?: SueWitnessModel;
    sueWitness2Id?: string | undefined;
    sueWitness2?: SueWitnessModel;
    involvedVehiclesId?: string | undefined;
    involvedVehicles?: SueInvolvedVehiclesModel;
    garageDetailsId?: string | undefined;
    garageDetails?: SueGarageDetailsModel;
    documents?: DocumentModel[] | undefined;
    treatments?: TreatmentModel[] | undefined;

    constructor(data?: ISueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.sueNumber = _data["sueNumber"];
            this.serialNumber = _data["serialNumber"];
            this.internalNumber = _data["internalNumber"];
            this.openingDate = _data["openingDate"] ? new Date(_data["openingDate"].toString()) : <any>undefined;
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.sueType = _data["sueType"];
            this.status = _data["status"];
            this.activityStatus = _data["activityStatus"];
            this.policyId = _data["policyId"];
            this.policy = _data["policy"] ? PolicyModel.fromJS(_data["policy"]) : <any>undefined;
            this.riderId = _data["riderId"];
            this.rider = _data["rider"] ? RiderModel.fromJS(_data["rider"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.handlerId = _data["handlerId"];
            this.handler = _data["handler"] ? UserModel.fromJS(_data["handler"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyModel.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.damageAppraiser = _data["damageAppraiser"];
            this.impairment = _data["impairment"];
            this.deductible = _data["deductible"];
            this.impairmentPercent = _data["impairmentPercent"];
            this.appraiserAmount = _data["appraiserAmount"];
            this.establishmentValue = _data["establishmentValue"];
            this.additionalExpenses = _data["additionalExpenses"];
            this.requestedAmount = _data["requestedAmount"];
            this.approvedAmount = _data["approvedAmount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.vehicleId = _data["vehicleId"];
            this.vehicle = _data["vehicle"] ? VehicleDataModel.fromJS(_data["vehicle"]) : <any>undefined;
            this.driverId = _data["driverId"];
            this.driver = _data["driver"] ? DriverAndVehicleDetailsTab.fromJS(_data["driver"]) : <any>undefined;
            this.seniorityDate = _data["seniorityDate"] ? new Date(_data["seniorityDate"].toString()) : <any>undefined;
            this.sueAccidentAndDamageInfoId = _data["sueAccidentAndDamageInfoId"];
            this.sueAccidentAndDamageInfo = _data["sueAccidentAndDamageInfo"] ? AccidentAndDamageDetailsTab.fromJS(_data["sueAccidentAndDamageInfo"]) : <any>undefined;
            this.participant1Id = _data["participant1Id"];
            this.participant1 = _data["participant1"] ? SueParticipantModel.fromJS(_data["participant1"]) : <any>undefined;
            this.participant2Id = _data["participant2Id"];
            this.participant2 = _data["participant2"] ? SueParticipantModel.fromJS(_data["participant2"]) : <any>undefined;
            this.participant3Id = _data["participant3Id"];
            this.participant3 = _data["participant3"] ? SueParticipantModel.fromJS(_data["participant3"]) : <any>undefined;
            this.participant4Id = _data["participant4Id"];
            this.participant4 = _data["participant4"] ? SueParticipantModel.fromJS(_data["participant4"]) : <any>undefined;
            this.participant5Id = _data["participant5Id"];
            this.participant5 = _data["participant5"] ? SueParticipantModel.fromJS(_data["participant5"]) : <any>undefined;
            this.participant6Id = _data["participant6Id"];
            this.participant6 = _data["participant6"] ? SueParticipantModel.fromJS(_data["participant6"]) : <any>undefined;
            this.sueWitness1Id = _data["sueWitness1Id"];
            this.sueWitness1 = _data["sueWitness1"] ? SueWitnessModel.fromJS(_data["sueWitness1"]) : <any>undefined;
            this.sueWitness2Id = _data["sueWitness2Id"];
            this.sueWitness2 = _data["sueWitness2"] ? SueWitnessModel.fromJS(_data["sueWitness2"]) : <any>undefined;
            this.involvedVehiclesId = _data["involvedVehiclesId"];
            this.involvedVehicles = _data["involvedVehicles"] ? SueInvolvedVehiclesModel.fromJS(_data["involvedVehicles"]) : <any>undefined;
            this.garageDetailsId = _data["garageDetailsId"];
            this.garageDetails = _data["garageDetails"] ? SueGarageDetailsModel.fromJS(_data["garageDetails"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentModel.fromJS(item));
            }
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(TreatmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SueModel {
        data = typeof data === 'object' ? data : {};
        let result = new SueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["sueNumber"] = this.sueNumber;
        data["serialNumber"] = this.serialNumber;
        data["internalNumber"] = this.internalNumber;
        data["openingDate"] = this.openingDate ? this.openingDate.toISOString() : <any>undefined;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["sueType"] = this.sueType;
        data["status"] = this.status;
        data["activityStatus"] = this.activityStatus;
        data["policyId"] = this.policyId;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["riderId"] = this.riderId;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["handlerId"] = this.handlerId;
        data["handler"] = this.handler ? this.handler.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["damageAppraiser"] = this.damageAppraiser;
        data["impairment"] = this.impairment;
        data["deductible"] = this.deductible;
        data["impairmentPercent"] = this.impairmentPercent;
        data["appraiserAmount"] = this.appraiserAmount;
        data["establishmentValue"] = this.establishmentValue;
        data["additionalExpenses"] = this.additionalExpenses;
        data["requestedAmount"] = this.requestedAmount;
        data["approvedAmount"] = this.approvedAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["vehicleId"] = this.vehicleId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["driverId"] = this.driverId;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["seniorityDate"] = this.seniorityDate ? this.seniorityDate.toISOString() : <any>undefined;
        data["sueAccidentAndDamageInfoId"] = this.sueAccidentAndDamageInfoId;
        data["sueAccidentAndDamageInfo"] = this.sueAccidentAndDamageInfo ? this.sueAccidentAndDamageInfo.toJSON() : <any>undefined;
        data["participant1Id"] = this.participant1Id;
        data["participant1"] = this.participant1 ? this.participant1.toJSON() : <any>undefined;
        data["participant2Id"] = this.participant2Id;
        data["participant2"] = this.participant2 ? this.participant2.toJSON() : <any>undefined;
        data["participant3Id"] = this.participant3Id;
        data["participant3"] = this.participant3 ? this.participant3.toJSON() : <any>undefined;
        data["participant4Id"] = this.participant4Id;
        data["participant4"] = this.participant4 ? this.participant4.toJSON() : <any>undefined;
        data["participant5Id"] = this.participant5Id;
        data["participant5"] = this.participant5 ? this.participant5.toJSON() : <any>undefined;
        data["participant6Id"] = this.participant6Id;
        data["participant6"] = this.participant6 ? this.participant6.toJSON() : <any>undefined;
        data["sueWitness1Id"] = this.sueWitness1Id;
        data["sueWitness1"] = this.sueWitness1 ? this.sueWitness1.toJSON() : <any>undefined;
        data["sueWitness2Id"] = this.sueWitness2Id;
        data["sueWitness2"] = this.sueWitness2 ? this.sueWitness2.toJSON() : <any>undefined;
        data["involvedVehiclesId"] = this.involvedVehiclesId;
        data["involvedVehicles"] = this.involvedVehicles ? this.involvedVehicles.toJSON() : <any>undefined;
        data["garageDetailsId"] = this.garageDetailsId;
        data["garageDetails"] = this.garageDetails ? this.garageDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISueModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    sueNumber?: string | undefined;
    serialNumber?: number;
    internalNumber?: number;
    openingDate?: Date;
    closingDate?: Date;
    sueType?: SueType;
    status?: SueStatus2;
    activityStatus?: ActivityStatus;
    policyId?: string | undefined;
    policy?: PolicyModel;
    riderId?: string | undefined;
    rider?: RiderModel;
    customerId?: string;
    customer?: CustomerModel;
    handlerId?: string | undefined;
    handler?: UserModel;
    insuranceCompanyId?: string | undefined;
    insuranceCompany?: InsuranceCompanyModel;
    damageAppraiser?: number;
    impairment?: number;
    deductible?: number;
    impairmentPercent?: number;
    appraiserAmount?: number;
    establishmentValue?: number;
    additionalExpenses?: number;
    requestedAmount?: number;
    approvedAmount?: number;
    paymentDate?: Date;
    comments?: string | undefined;
    vehicleId?: string;
    vehicle?: VehicleDataModel;
    driverId?: string;
    driver?: DriverAndVehicleDetailsTab;
    seniorityDate?: Date;
    sueAccidentAndDamageInfoId?: string | undefined;
    sueAccidentAndDamageInfo?: AccidentAndDamageDetailsTab;
    participant1Id?: string | undefined;
    participant1?: SueParticipantModel;
    participant2Id?: string | undefined;
    participant2?: SueParticipantModel;
    participant3Id?: string | undefined;
    participant3?: SueParticipantModel;
    participant4Id?: string | undefined;
    participant4?: SueParticipantModel;
    participant5Id?: string | undefined;
    participant5?: SueParticipantModel;
    participant6Id?: string | undefined;
    participant6?: SueParticipantModel;
    sueWitness1Id?: string | undefined;
    sueWitness1?: SueWitnessModel;
    sueWitness2Id?: string | undefined;
    sueWitness2?: SueWitnessModel;
    involvedVehiclesId?: string | undefined;
    involvedVehicles?: SueInvolvedVehiclesModel;
    garageDetailsId?: string | undefined;
    garageDetails?: SueGarageDetailsModel;
    documents?: DocumentModel[] | undefined;
    treatments?: TreatmentModel[] | undefined;
}

export class SuePageModel implements ISuePageModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    sues?: SueModel[] | undefined;

    constructor(data?: ISuePageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["sues"])) {
                this.sues = [] as any;
                for (let item of _data["sues"])
                    this.sues!.push(SueModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SuePageModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuePageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.sues)) {
            data["sues"] = [];
            for (let item of this.sues)
                data["sues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISuePageModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    sues?: SueModel[] | undefined;
}

export class SueParticipant implements ISueParticipant {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    address?: string | undefined;
    age?: number | undefined;
    phone?: string | undefined;
    hospitalName?: string | undefined;

    constructor(data?: ISueParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.address = _data["address"];
            this.age = _data["age"];
            this.phone = _data["phone"];
            this.hospitalName = _data["hospitalName"];
        }
    }

    static fromJS(data: any): SueParticipant {
        data = typeof data === 'object' ? data : {};
        let result = new SueParticipant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["address"] = this.address;
        data["age"] = this.age;
        data["phone"] = this.phone;
        data["hospitalName"] = this.hospitalName;
        return data;
    }
}

export interface ISueParticipant {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    address?: string | undefined;
    age?: number | undefined;
    phone?: string | undefined;
    hospitalName?: string | undefined;
}

export class SueParticipantModel implements ISueParticipantModel {
    id?: string;
    name?: string | undefined;
    address?: string | undefined;
    age?: number | undefined;
    phone?: string | undefined;
    hospitalName?: string | undefined;

    constructor(data?: ISueParticipantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.age = _data["age"];
            this.phone = _data["phone"];
            this.hospitalName = _data["hospitalName"];
        }
    }

    static fromJS(data: any): SueParticipantModel {
        data = typeof data === 'object' ? data : {};
        let result = new SueParticipantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["age"] = this.age;
        data["phone"] = this.phone;
        data["hospitalName"] = this.hospitalName;
        return data;
    }
}

export interface ISueParticipantModel {
    id?: string;
    name?: string | undefined;
    address?: string | undefined;
    age?: number | undefined;
    phone?: string | undefined;
    hospitalName?: string | undefined;
}

/** 0 = InTheGarage, 1 = WaitForAppraiserReport, 2 = WaitForCompanyCheck, 3 = WaitForCompanyConfirm, 4 = WaitForCustomerDocuments */
export enum SueStatus2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class SueTabModel implements ISueTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: SueModel[] | undefined;
    customerName?: string | undefined;

    constructor(data?: ISueTabModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SueModel.fromJS(item));
            }
            this.customerName = _data["customerName"];
        }
    }

    static fromJS(data: any): SueTabModel {
        data = typeof data === 'object' ? data : {};
        let result = new SueTabModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["customerName"] = this.customerName;
        return data;
    }
}

export interface ISueTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: SueModel[] | undefined;
    customerName?: string | undefined;
}

/** 0 = Accident, 1 = Theft */
export enum SueType {
    _0 = 0,
    _1 = 1,
}

export class SueWitness implements ISueWitness {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    relation?: string | undefined;

    constructor(data?: ISueWitness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.relation = _data["relation"];
        }
    }

    static fromJS(data: any): SueWitness {
        data = typeof data === 'object' ? data : {};
        let result = new SueWitness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["relation"] = this.relation;
        return data;
    }
}

export interface ISueWitness {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    relation?: string | undefined;
}

export class SueWitnessModel implements ISueWitnessModel {
    name?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    relation?: string | undefined;

    constructor(data?: ISueWitnessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.relation = _data["relation"];
        }
    }

    static fromJS(data: any): SueWitnessModel {
        data = typeof data === 'object' ? data : {};
        let result = new SueWitnessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["relation"] = this.relation;
        return data;
    }
}

export interface ISueWitnessModel {
    name?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    relation?: string | undefined;
}

export class SurvivorModel implements ISurvivorModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    relationType?: number;
    identityType?: IdentityType;
    identity?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    previousLastName?: string | undefined;
    dateOfBirth?: Date;

    constructor(data?: ISurvivorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.relationType = _data["relationType"];
            this.identityType = _data["identityType"];
            this.identity = _data["identity"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.previousLastName = _data["previousLastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurvivorModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurvivorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["relationType"] = this.relationType;
        data["identityType"] = this.identityType;
        data["identity"] = this.identity;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["previousLastName"] = this.previousLastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISurvivorModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    relationType?: number;
    identityType?: IdentityType;
    identity?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    previousLastName?: string | undefined;
    dateOfBirth?: Date;
}

export class SystemManagementModel implements ISystemManagementModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    branches?: BranchesModel;
    officeDepartments?: OfficeDepartmentsModel;
    stations?: StationModel[] | undefined;
    packages?: PackageModel[] | undefined;
    riderServices?: RiderServiceModel[] | undefined;
    riderPackages?: RiderPackageModel[] | undefined;
    riderComapnies?: RiderComapnyModel[] | undefined;
    subscribers?: SubscriberModel[] | undefined;
    users?: UsersModel;
    roles?: RolesModel;
    rolesForFilter?: SelectListItem[] | undefined;
    projects?: ProjectsModel;
    apiService?: APIServiceUserModel;
    discountBankManagerData?: DiscountBankManagerData;

    constructor(data?: ISystemManagementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.branches = _data["branches"] ? BranchesModel.fromJS(_data["branches"]) : <any>undefined;
            this.officeDepartments = _data["officeDepartments"] ? OfficeDepartmentsModel.fromJS(_data["officeDepartments"]) : <any>undefined;
            if (Array.isArray(_data["stations"])) {
                this.stations = [] as any;
                for (let item of _data["stations"])
                    this.stations!.push(StationModel.fromJS(item));
            }
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(PackageModel.fromJS(item));
            }
            if (Array.isArray(_data["riderServices"])) {
                this.riderServices = [] as any;
                for (let item of _data["riderServices"])
                    this.riderServices!.push(RiderServiceModel.fromJS(item));
            }
            if (Array.isArray(_data["riderPackages"])) {
                this.riderPackages = [] as any;
                for (let item of _data["riderPackages"])
                    this.riderPackages!.push(RiderPackageModel.fromJS(item));
            }
            if (Array.isArray(_data["riderComapnies"])) {
                this.riderComapnies = [] as any;
                for (let item of _data["riderComapnies"])
                    this.riderComapnies!.push(RiderComapnyModel.fromJS(item));
            }
            if (Array.isArray(_data["subscribers"])) {
                this.subscribers = [] as any;
                for (let item of _data["subscribers"])
                    this.subscribers!.push(SubscriberModel.fromJS(item));
            }
            this.users = _data["users"] ? UsersModel.fromJS(_data["users"]) : <any>undefined;
            this.roles = _data["roles"] ? RolesModel.fromJS(_data["roles"]) : <any>undefined;
            if (Array.isArray(_data["rolesForFilter"])) {
                this.rolesForFilter = [] as any;
                for (let item of _data["rolesForFilter"])
                    this.rolesForFilter!.push(SelectListItem.fromJS(item));
            }
            this.projects = _data["projects"] ? ProjectsModel.fromJS(_data["projects"]) : <any>undefined;
            this.apiService = _data["apiService"] ? APIServiceUserModel.fromJS(_data["apiService"]) : <any>undefined;
            this.discountBankManagerData = _data["discountBankManagerData"] ? DiscountBankManagerData.fromJS(_data["discountBankManagerData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemManagementModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemManagementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["branches"] = this.branches ? this.branches.toJSON() : <any>undefined;
        data["officeDepartments"] = this.officeDepartments ? this.officeDepartments.toJSON() : <any>undefined;
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (let item of this.stations)
                data["stations"].push(item.toJSON());
        }
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        if (Array.isArray(this.riderServices)) {
            data["riderServices"] = [];
            for (let item of this.riderServices)
                data["riderServices"].push(item.toJSON());
        }
        if (Array.isArray(this.riderPackages)) {
            data["riderPackages"] = [];
            for (let item of this.riderPackages)
                data["riderPackages"].push(item.toJSON());
        }
        if (Array.isArray(this.riderComapnies)) {
            data["riderComapnies"] = [];
            for (let item of this.riderComapnies)
                data["riderComapnies"].push(item.toJSON());
        }
        if (Array.isArray(this.subscribers)) {
            data["subscribers"] = [];
            for (let item of this.subscribers)
                data["subscribers"].push(item.toJSON());
        }
        data["users"] = this.users ? this.users.toJSON() : <any>undefined;
        data["roles"] = this.roles ? this.roles.toJSON() : <any>undefined;
        if (Array.isArray(this.rolesForFilter)) {
            data["rolesForFilter"] = [];
            for (let item of this.rolesForFilter)
                data["rolesForFilter"].push(item.toJSON());
        }
        data["projects"] = this.projects ? this.projects.toJSON() : <any>undefined;
        data["apiService"] = this.apiService ? this.apiService.toJSON() : <any>undefined;
        data["discountBankManagerData"] = this.discountBankManagerData ? this.discountBankManagerData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISystemManagementModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    branches?: BranchesModel;
    officeDepartments?: OfficeDepartmentsModel;
    stations?: StationModel[] | undefined;
    packages?: PackageModel[] | undefined;
    riderServices?: RiderServiceModel[] | undefined;
    riderPackages?: RiderPackageModel[] | undefined;
    riderComapnies?: RiderComapnyModel[] | undefined;
    subscribers?: SubscriberModel[] | undefined;
    users?: UsersModel;
    roles?: RolesModel;
    rolesForFilter?: SelectListItem[] | undefined;
    projects?: ProjectsModel;
    apiService?: APIServiceUserModel;
    discountBankManagerData?: DiscountBankManagerData;
}

export class Test3Data implements ITest3Data {
    name?: string | undefined;

    constructor(data?: ITest3Data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Test3Data {
        data = typeof data === 'object' ? data : {};
        let result = new Test3Data();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ITest3Data {
    name?: string | undefined;
}

/** 0 = OrderedSubject, 1 = References */
export enum ThreadingAlgorithm {
    _0 = 0,
    _1 = 1,
}

export class TimeSpan implements ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.milliseconds = _data["milliseconds"];
            this.minutes = _data["minutes"];
            this.seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class Treatment implements ITreatment {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    alertDate?: Date | undefined;
    eventDate?: Date;
    startDate?: Date;
    endDate?: Date;
    treatmentType?: TreatmentType;
    priority?: Priority;
    assignmentStatus?: AssignmentStatus;
    treatmentOutcome?: TreatmentOutcome;
    emailDeliveryType?: EmailDeliveryType;
    address?: string | undefined;
    smsFrom?: string | undefined;
    smsTo?: string | undefined;
    smsMessage?: string | undefined;
    smsPhone?: string | undefined;
    smsSenderId?: string | undefined;
    faxPhone?: string | undefined;
    sentByFax?: string | undefined;
    faxBy?: string | undefined;
    faxInHonorOf?: string | undefined;
    statusChangeEmail?: string | undefined;
    statusChangeSms?: string | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    location?: string | undefined;
    includeLogo?: boolean;
    emailBody?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    filePath?: string | undefined;
    includeCustomerInfo?: boolean;
    isFullDay?: boolean;
    policyRelatedId?: string | undefined;
    policyRelated?: Policy;
    sueRelatedId?: string | undefined;
    sueRelated?: Sue;
    leadRelatedId?: string | undefined;
    leadRelated?: Lead;
    companyId?: string | undefined;
    company?: InsuranceCompany;
    forTreatmentById?: string | undefined;
    forTreatmentBy?: User;
    belongsToId?: string | undefined;
    belongsTo?: User;
    agentId?: string | undefined;
    agent?: User;
    customerId?: string | undefined;
    customer?: Customer;
    employer?: Employer;
    employerId?: string | undefined;
    userId?: string | undefined;
    user?: User;
    riderId?: string | undefined;
    rider?: Rider;
    whatsAppMessageId?: string | undefined;

    constructor(data?: ITreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.treatmentType = _data["treatmentType"];
            this.priority = _data["priority"];
            this.assignmentStatus = _data["assignmentStatus"];
            this.treatmentOutcome = _data["treatmentOutcome"];
            this.emailDeliveryType = _data["emailDeliveryType"];
            this.address = _data["address"];
            this.smsFrom = _data["smsFrom"];
            this.smsTo = _data["smsTo"];
            this.smsMessage = _data["smsMessage"];
            this.smsPhone = _data["smsPhone"];
            this.smsSenderId = _data["smsSenderId"];
            this.faxPhone = _data["faxPhone"];
            this.sentByFax = _data["sentByFax"];
            this.faxBy = _data["faxBy"];
            this.faxInHonorOf = _data["faxInHonorOf"];
            this.statusChangeEmail = _data["statusChangeEmail"];
            this.statusChangeSms = _data["statusChangeSms"];
            this.topic = _data["topic"];
            this.note = _data["note"];
            this.location = _data["location"];
            this.includeLogo = _data["includeLogo"];
            this.emailBody = _data["emailBody"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.filePath = _data["filePath"];
            this.includeCustomerInfo = _data["includeCustomerInfo"];
            this.isFullDay = _data["isFullDay"];
            this.policyRelatedId = _data["policyRelatedId"];
            this.policyRelated = _data["policyRelated"] ? Policy.fromJS(_data["policyRelated"]) : <any>undefined;
            this.sueRelatedId = _data["sueRelatedId"];
            this.sueRelated = _data["sueRelated"] ? Sue.fromJS(_data["sueRelated"]) : <any>undefined;
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? Lead.fromJS(_data["leadRelated"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? InsuranceCompany.fromJS(_data["company"]) : <any>undefined;
            this.forTreatmentById = _data["forTreatmentById"];
            this.forTreatmentBy = _data["forTreatmentBy"] ? User.fromJS(_data["forTreatmentBy"]) : <any>undefined;
            this.belongsToId = _data["belongsToId"];
            this.belongsTo = _data["belongsTo"] ? User.fromJS(_data["belongsTo"]) : <any>undefined;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? User.fromJS(_data["agent"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.employer = _data["employer"] ? Employer.fromJS(_data["employer"]) : <any>undefined;
            this.employerId = _data["employerId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.riderId = _data["riderId"];
            this.rider = _data["rider"] ? Rider.fromJS(_data["rider"]) : <any>undefined;
            this.whatsAppMessageId = _data["whatsAppMessageId"];
        }
    }

    static fromJS(data: any): Treatment {
        data = typeof data === 'object' ? data : {};
        let result = new Treatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["treatmentType"] = this.treatmentType;
        data["priority"] = this.priority;
        data["assignmentStatus"] = this.assignmentStatus;
        data["treatmentOutcome"] = this.treatmentOutcome;
        data["emailDeliveryType"] = this.emailDeliveryType;
        data["address"] = this.address;
        data["smsFrom"] = this.smsFrom;
        data["smsTo"] = this.smsTo;
        data["smsMessage"] = this.smsMessage;
        data["smsPhone"] = this.smsPhone;
        data["smsSenderId"] = this.smsSenderId;
        data["faxPhone"] = this.faxPhone;
        data["sentByFax"] = this.sentByFax;
        data["faxBy"] = this.faxBy;
        data["faxInHonorOf"] = this.faxInHonorOf;
        data["statusChangeEmail"] = this.statusChangeEmail;
        data["statusChangeSms"] = this.statusChangeSms;
        data["topic"] = this.topic;
        data["note"] = this.note;
        data["location"] = this.location;
        data["includeLogo"] = this.includeLogo;
        data["emailBody"] = this.emailBody;
        data["from"] = this.from;
        data["to"] = this.to;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["filePath"] = this.filePath;
        data["includeCustomerInfo"] = this.includeCustomerInfo;
        data["isFullDay"] = this.isFullDay;
        data["policyRelatedId"] = this.policyRelatedId;
        data["policyRelated"] = this.policyRelated ? this.policyRelated.toJSON() : <any>undefined;
        data["sueRelatedId"] = this.sueRelatedId;
        data["sueRelated"] = this.sueRelated ? this.sueRelated.toJSON() : <any>undefined;
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["forTreatmentById"] = this.forTreatmentById;
        data["forTreatmentBy"] = this.forTreatmentBy ? this.forTreatmentBy.toJSON() : <any>undefined;
        data["belongsToId"] = this.belongsToId;
        data["belongsTo"] = this.belongsTo ? this.belongsTo.toJSON() : <any>undefined;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["employerId"] = this.employerId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["riderId"] = this.riderId;
        data["rider"] = this.rider ? this.rider.toJSON() : <any>undefined;
        data["whatsAppMessageId"] = this.whatsAppMessageId;
        return data;
    }
}

export interface ITreatment {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    alertDate?: Date | undefined;
    eventDate?: Date;
    startDate?: Date;
    endDate?: Date;
    treatmentType?: TreatmentType;
    priority?: Priority;
    assignmentStatus?: AssignmentStatus;
    treatmentOutcome?: TreatmentOutcome;
    emailDeliveryType?: EmailDeliveryType;
    address?: string | undefined;
    smsFrom?: string | undefined;
    smsTo?: string | undefined;
    smsMessage?: string | undefined;
    smsPhone?: string | undefined;
    smsSenderId?: string | undefined;
    faxPhone?: string | undefined;
    sentByFax?: string | undefined;
    faxBy?: string | undefined;
    faxInHonorOf?: string | undefined;
    statusChangeEmail?: string | undefined;
    statusChangeSms?: string | undefined;
    topic?: string | undefined;
    note?: string | undefined;
    location?: string | undefined;
    includeLogo?: boolean;
    emailBody?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    filePath?: string | undefined;
    includeCustomerInfo?: boolean;
    isFullDay?: boolean;
    policyRelatedId?: string | undefined;
    policyRelated?: Policy;
    sueRelatedId?: string | undefined;
    sueRelated?: Sue;
    leadRelatedId?: string | undefined;
    leadRelated?: Lead;
    companyId?: string | undefined;
    company?: InsuranceCompany;
    forTreatmentById?: string | undefined;
    forTreatmentBy?: User;
    belongsToId?: string | undefined;
    belongsTo?: User;
    agentId?: string | undefined;
    agent?: User;
    customerId?: string | undefined;
    customer?: Customer;
    employer?: Employer;
    employerId?: string | undefined;
    userId?: string | undefined;
    user?: User;
    riderId?: string | undefined;
    rider?: Rider;
    whatsAppMessageId?: string | undefined;
}

export class TreatmentFilterModel implements ITreatmentFilterModel {
    relationId?: string;
    relationType?: number;
    userId?: string;
    customerId?: string;
    employerId?: string;
    handlerId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    page?: number;
    searchTerm?: string | undefined;
    treatmentType?: number | undefined;
    sortBy?: SortModel[] | undefined;
    policyId?: string;
    leadId?: string;
    sueId?: string;
    riderId?: string;

    constructor(data?: ITreatmentFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.customerId = _data["customerId"];
            this.relationId = _data["relationId"];
            this.relationType = _data["relationType"];
            this.searchTerm = _data["searchTerm"];
            this.treatmentType = _data["treatmentType"];
            this.userId = _data["userId"];
            this.employerId = _data["employerId"];
            this.handlerId = _data["handlerId"];
            this.dateTo = _data['dateTo'];
            this.dateFrom = _data['dateFrom'];
            this.policyId = _data['policyId'];
            this.leadId = _data['leadId'];
            this.sueId = _data['sueId'];
            this.riderId = _data['riderId'];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreatmentFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["customerId"] = this.customerId;
        data["relationId"] = this.relationId;
        data["relationType"] = this.relationType;
        data["searchTerm"] = this.searchTerm;
        data["treatmentType"] = this.treatmentType;
        data["userId"] = this.userId;
        data["employerId"] = this.employerId;
        data["handlerId"] = this.handlerId;
        data['dateTo'] = this.dateTo ? moment(this.dateTo).format('YYYY-MM-DD') : <any>undefined;
        data['dateFrom'] = this.dateFrom ? moment(this.dateFrom).format('YYYY-MM-DD') : <any>undefined;
        data['policyId'] = this.policyId;
        data['leadId'] = this.leadId;
        data['sueId'] = this.sueId;
        data['riderId'] = this.riderId;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITreatmentFilterModel {
    page?: number;
    relationId?: string;
    relationType?: number;
    customerId?: string;
    searchTerm?: string | undefined;
    treatmentType?: number | undefined;
    userId?: string;
    sortBy?: SortModel[] | undefined;
    policyId?: string;
    riderId?: string;
}

export class TreatmentModel implements ITreatmentModel {
    id?: string;
    customerId?: string;
    customer?: CustomerModel;
    agentId?: string;
    agent?: User;
    employer?: any;
    employerId?: string;
    rider?: any;
    riderId?: string;
    belongsTo?: any;
    belongsToId?: string;
    updatedBy?: any;
    updatedById?: string;
    userId?: string;
    user?: User;
    handlerId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    from?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    eventDate?: Date;
    createdDate?: Date;
    alertDate?: Date | undefined;
    updatedDate?: Date;
    treatmentType?: TreatmentType;
    topic?: string | undefined;
    note?: string | undefined;
    filePath?: string | undefined;
    assignmentStatus?: AssignmentStatus;
    policyRelatedId?: string | undefined;
    policyRelated?: PolicyModel;
    sueRelatedId?: string | undefined;
    sueRelated?: SueModel;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
    offerRelatedId?: string | undefined;
    offerRelated?: SimulatorOffer;
    riderRelatedId?: string | undefined;
    riderRelated?: RiderModel;
    relationEntitiesModel?: RelationEntitiesModel;
    readonly treatmentTypeIcon?: string | undefined;
    readonly upsertActionName?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    customersIds?: string[] | undefined;
    leadsIds?: string[] | undefined;
    companyId?: string;
    company?: any;
    priority?: string;
    treatmentOutcome?: any | undefined;
    status?: any;

    emailDeliveryType?: any | undefined;
    address?: string | undefined;
    smsFrom?: string;
    smsTo?: string;
    smsMessage?: string;
    smsPhone?: string;
    smsSenderId?: string;
    faxPhone?: string;
    sentByFax?: string;
    faxBy?: string;
    faxInHonorOf?: string;
    statusChangeEmail?: string;
    statusChangeSms?: string;
    location?: string;
    includeLogo?: boolean;
    emailBody?: string;
    includeCustomerInfo?: boolean;
    isFullDay?: boolean;
    forTreatmentById?: string;
    forTreatmentBy?: string;
    whatsAppMessageId?: string;
    treatmentActivities?: any[];
    treatmentDocuments?: any[];
    seen?: boolean;
    assignmentStatusId?: string;
    fileAttachments?: any[];
    messageId?: string;
    callStatus?: string;




    constructor(data?: ITreatmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.alertDate = _data["alertDate"] ? new Date(_data["alertDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.treatmentType = _data["treatmentType"];
            this.topic = _data["topic"];
            this.note = _data["note"];
            this.filePath = _data["filePath"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"];
            this.employerId = _data["employerId"];
            this.employer = _data["employer"];
            this.riderId = _data["riderId"];
            this.rider = _data["rider"];
            this.belongsToId = _data["belongsToId"];
            this.belongsTo = _data["belongsTo"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.assignmentStatus = _data["assignmentStatus"];
            this.policyRelatedId = _data["policyRelatedId"];
            this.policyRelated = _data["policyRelated"] ? PolicyModel.fromJS(_data["policyRelated"]) : <any>undefined;
            this.sueRelatedId = _data["sueRelatedId"];
            this.sueRelated = _data["sueRelated"] ? SueModel.fromJS(_data["sueRelated"]) : <any>undefined;
            this.leadRelatedId = _data["leadRelatedId"];
            this.leadRelated = _data["leadRelated"] ? LeadModel.fromJS(_data["leadRelated"]) : <any>undefined;
            this.offerRelatedId = _data["offerRelatedId"];
            this.offerRelated = _data["offerRelated"] ? SimulatorOffer.fromJS(_data["offerRelated"]) : <any>undefined;
            this.riderRelatedId = _data["riderRelatedId"];
            this.riderRelated = _data["riderRelated"] ? RiderModel.fromJS(_data["riderRelated"]) : <any>undefined;
            this.relationEntitiesModel = _data["relationEntitiesModel"] ? RelationEntitiesModel.fromJS(_data["relationEntitiesModel"]) : <any>undefined;
            (<any>this).treatmentTypeIcon = _data["treatmentTypeIcon"];
            (<any>this).upsertActionName = _data["upsertActionName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.customersIds = _data["customersIds"] ? _data["customersIds"] : null;
            this.leadsIds = _data["leadsIds"] ? _data["leadsIds"] : null;
            this.companyId = _data["companyId"] ? _data["companyId"] : null;
            this.company = _data["company"] ? _data["company"] : <any>null;
            this.priority = _data["priority"];
            this.treatmentOutcome = _data["treatmentOutcome"] ? _data["treatmentOutcome"] : <any>undefined;
            this.status = _data["status"];
            this.seen = _data["seen"];
            this.emailBody = _data["emailBody"];
            this.user = _data["user"];
            this.assignmentStatusId = _data["assignmentStatusId"];
            this.fileAttachments = _data["fileAttachments"];
            this.messageId = _data["messageId"];
            this.treatmentDocuments = _data["treatmentDocuments"]
            this.isFullDay = _data["isFullDay"];
            this.includeLogo = _data["includeLogo"];
            this.includeCustomerInfo = _data["includeCustomerInfo"];
            this.callStatus = _data["callStatus"];
        }
    }

    static fromJS(data: any): TreatmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["alertDate"] = this.alertDate ? this.alertDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["treatmentType"] = this.treatmentType;
        data["topic"] = this.topic;
        data["note"] = this.note;
        data["filePath"] = this.filePath;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent;
        data["employerId"] = this.employerId;
        data["employer"] = this.employer;
        data["riderId"] = this.riderId;
        data["rider"] = this.rider;
        data["belongsToId"] = this.belongsToId;
        data["belongsTo"] = this.belongsTo;
        data["from"] = this.from;
        data["to"] = this.to;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["assignmentStatus"] = this.assignmentStatus;
        data["policyRelatedId"] = this.policyRelatedId;
        data["policyRelated"] = this.policyRelated ? this.policyRelated.toJSON() : <any>undefined;
        data["sueRelatedId"] = this.sueRelatedId;
        data["sueRelated"] = this.sueRelated ? this.sueRelated.toJSON() : <any>undefined;
        data["leadRelatedId"] = this.leadRelatedId;
        data["leadRelated"] = this.leadRelated ? this.leadRelated.toJSON() : <any>undefined;
        data["offerRelatedId"] = this.offerRelatedId;
        data["offerRelated"] = this.offerRelated ? this.offerRelated.toJSON() : <any>undefined;
        data["riderRelatedId"] = this.riderRelatedId;
        data["riderRelated"] = this.riderRelated ? this.riderRelated.toJSON() : <any>undefined;
        data["relationEntitiesModel"] = this.relationEntitiesModel ? this.relationEntitiesModel.toJSON() : <any>undefined;
        data["treatmentTypeIcon"] = this.treatmentTypeIcon;
        data["upsertActionName"] = this.upsertActionName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["customersIds"] = this.customersIds ? this.customersIds : undefined;
        data["leadsIds"] = this.leadsIds ? this.leadsIds : undefined;
        data["companyId"] = this.companyId ? this.companyId : undefined;
        data["company"] = this.company ? this.company : <any>undefined;
        data["priority"] = this.priority;
        data["status"] = this.status;
        data["seen"] = this.seen;
        data["emailBody"] = this.emailBody;
        data["user"] = this.user;
        data["assignmentStatusId"] = this.assignmentStatusId;
        data["fileAttachments"] = this.fileAttachments;
        data["messageId"] = this.messageId;
        data["treatmentDocuments"] = this.treatmentDocuments;
        data["isFullDay"] = this.isFullDay;
        data["includeLogo"] = this.includeLogo;
        data["includeCustomerInfo"] = this.includeCustomerInfo;
        data["callStatus"] = this.callStatus;
        return data;
    }
}

export interface ITreatmentModel {
    id?: string;
    eventDate?: Date;
    alertDate?: Date | undefined;
    treatmentType?: TreatmentType;
    topic?: string | undefined;
    note?: string | undefined;
    filePath?: string | undefined;
    customerId?: string;
    assignmentStatus?: AssignmentStatus;
    policyRelatedId?: string | undefined;
    policyRelated?: PolicyModel;
    sueRelatedId?: string | undefined;
    sueRelated?: SueModel;
    leadRelatedId?: string | undefined;
    leadRelated?: LeadModel;
    relationEntitiesModel?: RelationEntitiesModel;
    treatmentTypeIcon?: string | undefined;
    upsertActionName?: string | undefined;
}

/** 0 = Sale, 1 = PotentialForSale, 2 = NonPotential, 3 = ScheduleAdditionalMeeting, 4 = CanceledOrRejectedByCustomer, 5 = CanceledOrRejectedByAgent */
export enum TreatmentOutcome {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class TreatmentTabModel implements ITreatmentTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: TreatmentModel[] | undefined;
    agents?: SelectListItem[] | undefined;
    fieldsFilterList?: FieldsFilterListModel;
    policiesAndSuesSearchListModel?: RelationEntitiesModel;

    constructor(data?: ITreatmentTabModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreatmentModel.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(SelectListItem.fromJS(item));
            }
            this.fieldsFilterList = _data["fieldsFilterList"] ? FieldsFilterListModel.fromJS(_data["fieldsFilterList"]) : <any>undefined;
            this.policiesAndSuesSearchListModel = _data["policiesAndSuesSearchListModel"] ? RelationEntitiesModel.fromJS(_data["policiesAndSuesSearchListModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TreatmentTabModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTabModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["fieldsFilterList"] = this.fieldsFilterList ? this.fieldsFilterList.toJSON() : <any>undefined;
        data["policiesAndSuesSearchListModel"] = this.policiesAndSuesSearchListModel ? this.policiesAndSuesSearchListModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITreatmentTabModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    customerId?: string;
    items?: TreatmentModel[] | undefined;
    agents?: SelectListItem[] | undefined;
    fieldsFilterList?: FieldsFilterListModel;
    policiesAndSuesSearchListModel?: RelationEntitiesModel;
}

/** 0 = Call, 1 = Assignment, 2 = Sms, 3 = Email, 4 = Fax, 5 = Meeting, 6 = MeetingSummary, 7 = DocumentationOutbox */
export enum TreatmentType {
    _0 = 0, // Call
    _1 = 1, // Assignment
    _2 = 2, // WhatsApp
    _3 = 3, // Email
    _4 = 4, // Documentation
    _5 = 5, // Note
    _6 = 6, // Letter
}

export class Type implements IType {
    readonly name?: string | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    readonly isInterface?: boolean;
    memberType?: MemberTypes;
    readonly namespace?: string | undefined;
    readonly assemblyQualifiedName?: string | undefined;
    readonly fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    readonly isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    readonly isTypeDefinition?: boolean;
    readonly isArray?: boolean;
    readonly isByRef?: boolean;
    readonly isPointer?: boolean;
    readonly isConstructedGenericType?: boolean;
    readonly isGenericParameter?: boolean;
    readonly isGenericTypeParameter?: boolean;
    readonly isGenericMethodParameter?: boolean;
    readonly isGenericType?: boolean;
    readonly isGenericTypeDefinition?: boolean;
    readonly isSZArray?: boolean;
    readonly isVariableBoundArray?: boolean;
    readonly isByRefLike?: boolean;
    readonly hasElementType?: boolean;
    readonly genericTypeArguments?: Type[] | undefined;
    readonly genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    readonly isAbstract?: boolean;
    readonly isImport?: boolean;
    readonly isSealed?: boolean;
    readonly isSpecialName?: boolean;
    readonly isClass?: boolean;
    readonly isNestedAssembly?: boolean;
    readonly isNestedFamANDAssem?: boolean;
    readonly isNestedFamily?: boolean;
    readonly isNestedFamORAssem?: boolean;
    readonly isNestedPrivate?: boolean;
    readonly isNestedPublic?: boolean;
    readonly isNotPublic?: boolean;
    readonly isPublic?: boolean;
    readonly isAutoLayout?: boolean;
    readonly isExplicitLayout?: boolean;
    readonly isLayoutSequential?: boolean;
    readonly isAnsiClass?: boolean;
    readonly isAutoClass?: boolean;
    readonly isUnicodeClass?: boolean;
    readonly isCOMObject?: boolean;
    readonly isContextful?: boolean;
    readonly isEnum?: boolean;
    readonly isMarshalByRef?: boolean;
    readonly isPrimitive?: boolean;
    readonly isValueType?: boolean;
    readonly isSignatureType?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    readonly guid?: string;
    baseType?: Type;
    readonly isSerializable?: boolean;
    readonly containsGenericParameters?: boolean;
    readonly isVisible?: boolean;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IType {
    name?: string | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    isInterface?: boolean;
    memberType?: MemberTypes;
    namespace?: string | undefined;
    assemblyQualifiedName?: string | undefined;
    fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    isTypeDefinition?: boolean;
    isArray?: boolean;
    isByRef?: boolean;
    isPointer?: boolean;
    isConstructedGenericType?: boolean;
    isGenericParameter?: boolean;
    isGenericTypeParameter?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isSZArray?: boolean;
    isVariableBoundArray?: boolean;
    isByRefLike?: boolean;
    hasElementType?: boolean;
    genericTypeArguments?: Type[] | undefined;
    genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    isAbstract?: boolean;
    isImport?: boolean;
    isSealed?: boolean;
    isSpecialName?: boolean;
    isClass?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPublic?: boolean;
    isAutoLayout?: boolean;
    isExplicitLayout?: boolean;
    isLayoutSequential?: boolean;
    isAnsiClass?: boolean;
    isAutoClass?: boolean;
    isUnicodeClass?: boolean;
    isCOMObject?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isMarshalByRef?: boolean;
    isPrimitive?: boolean;
    isValueType?: boolean;
    isSignatureType?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    guid?: string;
    baseType?: Type;
    isSerializable?: boolean;
    containsGenericParameters?: boolean;
    isVisible?: boolean;
}

/** 0 = Class, 1 = Public, 2 = NestedPublic, 3 = NestedPrivate, 4 = NestedFamily, 5 = NestedAssembly, 6 = NestedFamANDAssem, 7 = VisibilityMask, 8 = SequentialLayout, 16 = ExplicitLayout, 24 = LayoutMask, 32 = Interface, 128 = Abstract, 256 = Sealed, 1024 = SpecialName, 2048 = RTSpecialName, 4096 = Import, 8192 = Serializable, 16384 = WindowsRuntime, 65536 = UnicodeClass, 131072 = AutoClass, 196608 = StringFormatMask, 262144 = HasSecurity, 264192 = ReservedMask, 1048576 = BeforeFieldInit, 12582912 = CustomFormatMask */
export enum TypeAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _24 = 24,
    _32 = 32,
    _128 = 128,
    _256 = 256,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _65536 = 65536,
    _131072 = 131072,
    _196608 = 196608,
    _262144 = 262144,
    _264192 = 264192,
    _1048576 = 1048576,
    _12582912 = 12582912,
}

export class TypeInfo implements ITypeInfo {
    readonly name?: string | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    readonly isInterface?: boolean;
    memberType?: MemberTypes;
    readonly namespace?: string | undefined;
    readonly assemblyQualifiedName?: string | undefined;
    readonly fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    readonly isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    readonly isTypeDefinition?: boolean;
    readonly isArray?: boolean;
    readonly isByRef?: boolean;
    readonly isPointer?: boolean;
    readonly isConstructedGenericType?: boolean;
    readonly isGenericParameter?: boolean;
    readonly isGenericTypeParameter?: boolean;
    readonly isGenericMethodParameter?: boolean;
    readonly isGenericType?: boolean;
    readonly isGenericTypeDefinition?: boolean;
    readonly isSZArray?: boolean;
    readonly isVariableBoundArray?: boolean;
    readonly isByRefLike?: boolean;
    readonly hasElementType?: boolean;
    readonly genericTypeArguments?: Type[] | undefined;
    readonly genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    readonly isAbstract?: boolean;
    readonly isImport?: boolean;
    readonly isSealed?: boolean;
    readonly isSpecialName?: boolean;
    readonly isClass?: boolean;
    readonly isNestedAssembly?: boolean;
    readonly isNestedFamANDAssem?: boolean;
    readonly isNestedFamily?: boolean;
    readonly isNestedFamORAssem?: boolean;
    readonly isNestedPrivate?: boolean;
    readonly isNestedPublic?: boolean;
    readonly isNotPublic?: boolean;
    readonly isPublic?: boolean;
    readonly isAutoLayout?: boolean;
    readonly isExplicitLayout?: boolean;
    readonly isLayoutSequential?: boolean;
    readonly isAnsiClass?: boolean;
    readonly isAutoClass?: boolean;
    readonly isUnicodeClass?: boolean;
    readonly isCOMObject?: boolean;
    readonly isContextful?: boolean;
    readonly isEnum?: boolean;
    readonly isMarshalByRef?: boolean;
    readonly isPrimitive?: boolean;
    readonly isValueType?: boolean;
    readonly isSignatureType?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    readonly guid?: string;
    baseType?: Type;
    readonly isSerializable?: boolean;
    readonly containsGenericParameters?: boolean;
    readonly isVisible?: boolean;
    readonly genericTypeParameters?: Type[] | undefined;
    readonly declaredConstructors?: ConstructorInfo[] | undefined;
    readonly declaredEvents?: EventInfo[] | undefined;
    readonly declaredFields?: FieldInfo[] | undefined;
    readonly declaredMembers?: MemberInfo[] | undefined;
    readonly declaredMethods?: MethodInfo[] | undefined;
    readonly declaredNestedTypes?: TypeInfo[] | undefined;
    readonly declaredProperties?: PropertyInfo[] | undefined;
    readonly implementedInterfaces?: Type[] | undefined;

    constructor(data?: ITypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
            if (Array.isArray(_data["genericTypeParameters"])) {
                (<any>this).genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    (<any>this).genericTypeParameters!.push(Type.fromJS(item));
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                (<any>this).declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    (<any>this).declaredConstructors!.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                (<any>this).declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    (<any>this).declaredEvents!.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                (<any>this).declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    (<any>this).declaredFields!.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                (<any>this).declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    (<any>this).declaredMembers!.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                (<any>this).declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    (<any>this).declaredMethods!.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                (<any>this).declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    (<any>this).declaredNestedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                (<any>this).declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    (<any>this).declaredProperties!.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                (<any>this).implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    (<any>this).implementedInterfaces!.push(Type.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeInfo {
    name?: string | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    isInterface?: boolean;
    memberType?: MemberTypes;
    namespace?: string | undefined;
    assemblyQualifiedName?: string | undefined;
    fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    isTypeDefinition?: boolean;
    isArray?: boolean;
    isByRef?: boolean;
    isPointer?: boolean;
    isConstructedGenericType?: boolean;
    isGenericParameter?: boolean;
    isGenericTypeParameter?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isSZArray?: boolean;
    isVariableBoundArray?: boolean;
    isByRefLike?: boolean;
    hasElementType?: boolean;
    genericTypeArguments?: Type[] | undefined;
    genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    isAbstract?: boolean;
    isImport?: boolean;
    isSealed?: boolean;
    isSpecialName?: boolean;
    isClass?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPublic?: boolean;
    isAutoLayout?: boolean;
    isExplicitLayout?: boolean;
    isLayoutSequential?: boolean;
    isAnsiClass?: boolean;
    isAutoClass?: boolean;
    isUnicodeClass?: boolean;
    isCOMObject?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isMarshalByRef?: boolean;
    isPrimitive?: boolean;
    isValueType?: boolean;
    isSignatureType?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    guid?: string;
    baseType?: Type;
    isSerializable?: boolean;
    containsGenericParameters?: boolean;
    isVisible?: boolean;
    genericTypeParameters?: Type[] | undefined;
    declaredConstructors?: ConstructorInfo[] | undefined;
    declaredEvents?: EventInfo[] | undefined;
    declaredFields?: FieldInfo[] | undefined;
    declaredMembers?: MemberInfo[] | undefined;
    declaredMethods?: MethodInfo[] | undefined;
    declaredNestedTypes?: TypeInfo[] | undefined;
    declaredProperties?: PropertyInfo[] | undefined;
    implementedInterfaces?: Type[] | undefined;
}

export class UniqueId implements IUniqueId {
    id?: number;
    validity?: number;
    readonly isValid?: boolean;

    constructor(data?: IUniqueId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validity = _data["validity"];
            (<any>this).isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): UniqueId {
        data = typeof data === 'object' ? data : {};
        let result = new UniqueId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validity"] = this.validity;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IUniqueId {
    id?: number;
    validity?: number;
    isValid?: boolean;
}

export class UpdatePaymentRequest implements IUpdatePaymentRequest {
    id?: string;
    riderId?: string;
    title?: string | undefined;
    amount?: number | undefined;

    constructor(data?: IUpdatePaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.riderId = _data["riderId"];
            this.title = _data["title"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): UpdatePaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["riderId"] = this.riderId;
        data["title"] = this.title;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IUpdatePaymentRequest {
    id?: string;
    riderId?: string;
    title?: string | undefined;
    amount?: number | undefined;
}

/** 0 = Privacy, 1 = Business */
export enum UsePurposesType {
    _0 = 0,
    _1 = 1,
}

export class User implements IUser {
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    id?: string;
    agentId?: string | undefined;
    agent?: Agent;
    name?: string | undefined;
    emailPass?: string | undefined;
    title?: string | undefined;
    fullName?: string | undefined;
    type?: string | undefined;
    status?: ActivityStatus;
    isDeleted?: boolean;
    ipAddresses?: string | undefined;
    link?: string | undefined;
    stationId?: string | undefined;
    station?: Station;
    branchId?: string | undefined;
    branch?: Branch;
    officeDepartmentId?: string | undefined;
    officeDepartment?: OfficeDepartment;
    roleId?: string | undefined;
    role?: Role;
    offers?: Offer[] | undefined;
    createdDocuments?: CustomerDocument[] | undefined;
    suesAsAgent?: Sue[] | undefined;
    agents?: AgentDetails[] | undefined;
    projectUsers?: ProjectUser[] | undefined;
    salesPersonId?: string | undefined;
    apiToken?: string | undefined;
    newLead?: boolean;
    usedLead?: boolean;
    selectLead?: boolean;
    whatsAppNumber?: string | undefined;
    defaultDiscountBankAlocation?: number;
    lastLogIn?: Date;
    extension?: string | undefined;
    lastLogOut?: Date | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : <any>undefined;
            this.name = _data["name"];
            this.emailPass = _data["emailPass"];
            this.title = _data["title"];
            this.fullName = _data["fullName"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.ipAddresses = _data["ipAddresses"];
            this.link = _data["link"];
            this.stationId = _data["stationId"];
            this.station = _data["station"] ? Station.fromJS(_data["station"]) : <any>undefined;
            this.branchId = _data["branchId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.officeDepartmentId = _data["officeDepartmentId"];
            this.officeDepartment = _data["officeDepartment"] ? OfficeDepartment.fromJS(_data["officeDepartment"]) : <any>undefined;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(Offer.fromJS(item));
            }
            if (Array.isArray(_data["createdDocuments"])) {
                this.createdDocuments = [] as any;
                for (let item of _data["createdDocuments"])
                    this.createdDocuments!.push(CustomerDocument.fromJS(item));
            }
            if (Array.isArray(_data["suesAsAgent"])) {
                this.suesAsAgent = [] as any;
                for (let item of _data["suesAsAgent"])
                    this.suesAsAgent!.push(Sue.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(AgentDetails.fromJS(item));
            }
            if (Array.isArray(_data["projectUsers"])) {
                this.projectUsers = [] as any;
                for (let item of _data["projectUsers"])
                    this.projectUsers!.push(ProjectUser.fromJS(item));
            }
            this.salesPersonId = _data["salesPersonId"];
            this.apiToken = _data["apiToken"];
            this.newLead = _data["newLead"];
            this.usedLead = _data["usedLead"];
            this.selectLead = _data["selectLead"];
            this.whatsAppNumber = _data["whatsAppNumber"];
            this.defaultDiscountBankAlocation = _data["defaultDiscountBankAlocation"];
            this.lastLogIn = _data["lastLogIn"] ? new Date(_data["lastLogIn"].toString()) : <any>undefined;
            this.extension = _data["extension"];
            this.lastLogOut = _data["lastLogOut"] ? new Date(_data["lastLogOut"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["emailPass"] = this.emailPass;
        data["title"] = this.title;
        data["fullName"] = this.fullName;
        data["type"] = this.type;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["ipAddresses"] = this.ipAddresses;
        data["link"] = this.link;
        data["stationId"] = this.stationId;
        data["station"] = this.station ? this.station.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["officeDepartmentId"] = this.officeDepartmentId;
        data["officeDepartment"] = this.officeDepartment ? this.officeDepartment.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        if (Array.isArray(this.createdDocuments)) {
            data["createdDocuments"] = [];
            for (let item of this.createdDocuments)
                data["createdDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.suesAsAgent)) {
            data["suesAsAgent"] = [];
            for (let item of this.suesAsAgent)
                data["suesAsAgent"].push(item.toJSON());
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.projectUsers)) {
            data["projectUsers"] = [];
            for (let item of this.projectUsers)
                data["projectUsers"].push(item.toJSON());
        }
        data["salesPersonId"] = this.salesPersonId;
        data["apiToken"] = this.apiToken;
        data["newLead"] = this.newLead;
        data["usedLead"] = this.usedLead;
        data["selectLead"] = this.selectLead;
        data["whatsAppNumber"] = this.whatsAppNumber;
        data["defaultDiscountBankAlocation"] = this.defaultDiscountBankAlocation;
        data["lastLogIn"] = this.lastLogIn ? this.lastLogIn.toISOString() : <any>undefined;
        data["extension"] = this.extension;
        data["lastLogOut"] = this.lastLogOut ? this.lastLogOut.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUser {
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    id?: string;
    agentId?: string | undefined;
    agent?: Agent;
    name?: string | undefined;
    emailPass?: string | undefined;
    title?: string | undefined;
    fullName?: string | undefined;
    type?: string | undefined;
    status?: ActivityStatus;
    isDeleted?: boolean;
    ipAddresses?: string | undefined;
    link?: string | undefined;
    stationId?: string | undefined;
    station?: Station;
    branchId?: string | undefined;
    branch?: Branch;
    officeDepartmentId?: string | undefined;
    officeDepartment?: OfficeDepartment;
    roleId?: string | undefined;
    role?: Role;
    offers?: Offer[] | undefined;
    createdDocuments?: CustomerDocument[] | undefined;
    suesAsAgent?: Sue[] | undefined;
    agents?: AgentDetails[] | undefined;
    projectUsers?: ProjectUser[] | undefined;
    salesPersonId?: string | undefined;
    apiToken?: string | undefined;
    newLead?: boolean;
    usedLead?: boolean;
    selectLead?: boolean;
    whatsAppNumber?: string | undefined;
    defaultDiscountBankAlocation?: number;
    lastLogIn?: Date;
    extension?: string | undefined;
    lastLogOut?: Date | undefined;
}

export class UserCreateModel implements IUserCreateModel {
    id?: string | undefined;
    name?: string | undefined;
    emailPass?: string | undefined;
    title?: string | undefined;
    fullName!: string;
    type?: string | undefined;
    status?: ActivityStatus;
    password!: string;
    confirmPassword!: string;
    email!: string;
    phoneNumber?: string | undefined;
    ipAddresses?: string | undefined;
    link?: string | undefined;
    branchId?: string | undefined;
    branch?: BranchModel;
    officeDepartmentId?: string | undefined;
    officeDepartment?: OfficeDepartmentModel;
    stationId?: string | undefined;
    stations?: SelectListItem[] | undefined;
    roleId?: string | undefined;
    roles?: SelectListItem[] | undefined;
    salesPersonId?: string | undefined;
    salesPeople?: SelectListItem[] | undefined;
    newLead?: boolean;
    usedLead?: boolean;
    selectLead?: boolean;
    leadTypes?: LeadType[] | undefined;
    branches?: BranchModel[] | undefined;
    officeDepartments?: OfficeDepartmentModel[] | undefined;
    whatsAppNumber?: string | undefined;
    extension?: string | undefined;

    constructor(data?: IUserCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.emailPass = _data["emailPass"];
            this.title = _data["title"];
            this.fullName = _data["fullName"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.ipAddresses = _data["ipAddresses"];
            this.link = _data["link"];
            this.branchId = _data["branchId"];
            this.branch = _data["branch"] ? BranchModel.fromJS(_data["branch"]) : <any>undefined;
            this.officeDepartmentId = _data["officeDepartmentId"];
            this.officeDepartment = _data["officeDepartment"] ? OfficeDepartmentModel.fromJS(_data["officeDepartment"]) : <any>undefined;
            this.stationId = _data["stationId"];
            if (Array.isArray(_data["stations"])) {
                this.stations = [] as any;
                for (let item of _data["stations"])
                    this.stations!.push(SelectListItem.fromJS(item));
            }
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(SelectListItem.fromJS(item));
            }
            this.salesPersonId = _data["salesPersonId"];
            if (Array.isArray(_data["salesPeople"])) {
                this.salesPeople = [] as any;
                for (let item of _data["salesPeople"])
                    this.salesPeople!.push(SelectListItem.fromJS(item));
            }
            this.newLead = _data["newLead"];
            this.usedLead = _data["usedLead"];
            this.selectLead = _data["selectLead"];
            if (Array.isArray(_data["leadTypes"])) {
                this.leadTypes = [] as any;
                for (let item of _data["leadTypes"])
                    this.leadTypes!.push(item);
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchModel.fromJS(item));
            }
            if (Array.isArray(_data["officeDepartments"])) {
                this.officeDepartments = [] as any;
                for (let item of _data["officeDepartments"])
                    this.officeDepartments!.push(OfficeDepartmentModel.fromJS(item));
            }
            this.whatsAppNumber = _data["whatsAppNumber"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): UserCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["emailPass"] = this.emailPass;
        data["title"] = this.title;
        data["fullName"] = this.fullName;
        data["type"] = this.type;
        data["status"] = this.status;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["ipAddresses"] = this.ipAddresses;
        data["link"] = this.link;
        data["branchId"] = this.branchId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["officeDepartmentId"] = this.officeDepartmentId;
        data["officeDepartment"] = this.officeDepartment ? this.officeDepartment.toJSON() : <any>undefined;
        data["stationId"] = this.stationId;
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (let item of this.stations)
                data["stations"].push(item.toJSON());
        }
        data["roleId"] = this.roleId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["salesPersonId"] = this.salesPersonId;
        if (Array.isArray(this.salesPeople)) {
            data["salesPeople"] = [];
            for (let item of this.salesPeople)
                data["salesPeople"].push(item.toJSON());
        }
        data["newLead"] = this.newLead;
        data["usedLead"] = this.usedLead;
        data["selectLead"] = this.selectLead;
        if (Array.isArray(this.leadTypes)) {
            data["leadTypes"] = [];
            for (let item of this.leadTypes)
                data["leadTypes"].push(item);
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.officeDepartments)) {
            data["officeDepartments"] = [];
            for (let item of this.officeDepartments)
                data["officeDepartments"].push(item.toJSON());
        }
        data["whatsAppNumber"] = this.whatsAppNumber;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IUserCreateModel {
    id?: string | undefined;
    name?: string | undefined;
    emailPass?: string | undefined;
    title?: string | undefined;
    fullName: string;
    type?: string | undefined;
    status?: ActivityStatus;
    password: string;
    confirmPassword: string;
    email: string;
    phoneNumber?: string | undefined;
    ipAddresses?: string | undefined;
    link?: string | undefined;
    branchId?: string | undefined;
    branch?: BranchModel;
    officeDepartmentId?: string | undefined;
    officeDepartment?: OfficeDepartmentModel;
    stationId?: string | undefined;
    stations?: SelectListItem[] | undefined;
    roleId?: string | undefined;
    roles?: SelectListItem[] | undefined;
    salesPersonId?: string | undefined;
    salesPeople?: SelectListItem[] | undefined;
    newLead?: boolean;
    usedLead?: boolean;
    selectLead?: boolean;
    leadTypes?: LeadType[] | undefined;
    branches?: BranchModel[] | undefined;
    officeDepartments?: OfficeDepartmentModel[] | undefined;
    whatsAppNumber?: string | undefined;
    extension?: string | undefined;
}

export class UserFieldsFilterModel implements IUserFieldsFilterModel {
    id?: string;
    fieldName?: string | undefined;
    pageName?: string | undefined;
    user?: UserModel;

    constructor(data?: IUserFieldsFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fieldName = _data["fieldName"];
            this.pageName = _data["pageName"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserFieldsFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserFieldsFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fieldName"] = this.fieldName;
        data["pageName"] = this.pageName;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserFieldsFilterModel {
    id?: string;
    fieldName?: string | undefined;
    pageName?: string | undefined;
    user?: UserModel;
}

export class UserModel implements IUserModel {
    id?: string | undefined;
    agentId?: string | undefined;
    agent?: AgentModel;
    name?: string | undefined;
    title?: string | undefined;
    fullName?: string | undefined;
    userName?: string | undefined;
    type?: string | undefined;
    status?: ActivityStatus;
    roleName?: string | undefined;
    branchName?: string | undefined;
    officeDepartmentName?: string | undefined;
    branchId?: string | undefined;
    officeDepartmentId?: string | undefined;
    stationId?: string | undefined;
    roleId?: string | undefined;
    salesPersonId?: string | undefined;
    apiToken?: string | undefined;
    newLead?: boolean;
    usedLead?: boolean;
    selectLead?: boolean;
    leadTypes?: LeadType[] | undefined;
    projectUsers?: ProjectUserModel[] | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? AgentModel.fromJS(_data["agent"]) : <any>undefined;
            this.name = _data["name"];
            this.title = _data["title"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.roleName = _data["roleName"];
            this.branchName = _data["branchName"];
            this.officeDepartmentName = _data["officeDepartmentName"];
            this.branchId = _data["branchId"];
            this.officeDepartmentId = _data["officeDepartmentId"];
            this.stationId = _data["stationId"];
            this.roleId = _data["roleId"];
            this.salesPersonId = _data["salesPersonId"];
            this.apiToken = _data["apiToken"];
            this.newLead = _data["newLead"];
            this.usedLead = _data["usedLead"];
            this.selectLead = _data["selectLead"];
            if (Array.isArray(_data["leadTypes"])) {
                this.leadTypes = [] as any;
                for (let item of _data["leadTypes"])
                    this.leadTypes!.push(item);
            }
            if (Array.isArray(_data["projectUsers"])) {
                this.projectUsers = [] as any;
                for (let item of _data["projectUsers"])
                    this.projectUsers!.push(ProjectUserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["title"] = this.title;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["type"] = this.type;
        data["status"] = this.status;
        data["roleName"] = this.roleName;
        data["branchName"] = this.branchName;
        data["officeDepartmentName"] = this.officeDepartmentName;
        data["branchId"] = this.branchId;
        data["officeDepartmentId"] = this.officeDepartmentId;
        data["stationId"] = this.stationId;
        data["roleId"] = this.roleId;
        data["salesPersonId"] = this.salesPersonId;
        data["apiToken"] = this.apiToken;
        data["newLead"] = this.newLead;
        data["usedLead"] = this.usedLead;
        data["selectLead"] = this.selectLead;
        if (Array.isArray(this.leadTypes)) {
            data["leadTypes"] = [];
            for (let item of this.leadTypes)
                data["leadTypes"].push(item);
        }
        if (Array.isArray(this.projectUsers)) {
            data["projectUsers"] = [];
            for (let item of this.projectUsers)
                data["projectUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserModel {
    id?: string | undefined;
    agentId?: string | undefined;
    agent?: AgentModel;
    name?: string | undefined;
    title?: string | undefined;
    fullName?: string | undefined;
    userName?: string | undefined;
    type?: string | undefined;
    status?: ActivityStatus;
    roleName?: string | undefined;
    branchName?: string | undefined;
    officeDepartmentName?: string | undefined;
    branchId?: string | undefined;
    officeDepartmentId?: string | undefined;
    stationId?: string | undefined;
    roleId?: string | undefined;
    salesPersonId?: string | undefined;
    apiToken?: string | undefined;
    newLead?: boolean;
    usedLead?: boolean;
    selectLead?: boolean;
    leadTypes?: LeadType[] | undefined;
    projectUsers?: ProjectUserModel[] | undefined;
}

export class UsersModel implements IUsersModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    users?: UserModel[] | undefined;

    constructor(data?: IUsersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.allRowsCounter = _data["allRowsCounter"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsersModel {
        data = typeof data === 'object' ? data : {};
        let result = new UsersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["allRowsCounter"] = this.allRowsCounter;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUsersModel {
    actionName?: string | undefined;
    allRowsCounter?: number;
    users?: UserModel[] | undefined;
}

export class VariousBalanceModel implements IVariousBalanceModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    accrualValueDate?: Date;
    accumulationSeveranceFundsPreviousEmployers?: string | undefined;
    revenueValuesSeveranceFundsExemptionPensionPreviousEmployers?: string | undefined;
    accumulationSeveranceFundsPreviousEmployersInAllowanceSequence?: string | undefined;
    accumulationSeveranceFundsPreviousEmployersInRightsSequence?: string | undefined;
    accumulationCompensationAnnuity?: string | undefined;
    redemptionCompensationCurrentEmployer?: string | undefined;
    redemptionCompensationTaxPurposesCurrentEmployer?: string | undefined;
    redemptionMonetaryCompensationPreviousEmployersInRightsSequence?: string | undefined;
    redemptionMonetaryCompensationPreviousEmployersLiquidsCapital?: string | undefined;
    annuityCompensationSequence?: YesNoUnknown;
    sequenceCompensationRights?: YesNoUnknown;

    constructor(data?: IVariousBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeInsurancePolicyId = _data["lifeInsurancePolicyId"];
            this.accrualValueDate = _data["accrualValueDate"] ? new Date(_data["accrualValueDate"].toString()) : <any>undefined;
            this.accumulationSeveranceFundsPreviousEmployers = _data["accumulationSeveranceFundsPreviousEmployers"];
            this.revenueValuesSeveranceFundsExemptionPensionPreviousEmployers = _data["revenueValuesSeveranceFundsExemptionPensionPreviousEmployers"];
            this.accumulationSeveranceFundsPreviousEmployersInAllowanceSequence = _data["accumulationSeveranceFundsPreviousEmployersInAllowanceSequence"];
            this.accumulationSeveranceFundsPreviousEmployersInRightsSequence = _data["accumulationSeveranceFundsPreviousEmployersInRightsSequence"];
            this.accumulationCompensationAnnuity = _data["accumulationCompensationAnnuity"];
            this.redemptionCompensationCurrentEmployer = _data["redemptionCompensationCurrentEmployer"];
            this.redemptionCompensationTaxPurposesCurrentEmployer = _data["redemptionCompensationTaxPurposesCurrentEmployer"];
            this.redemptionMonetaryCompensationPreviousEmployersInRightsSequence = _data["redemptionMonetaryCompensationPreviousEmployersInRightsSequence"];
            this.redemptionMonetaryCompensationPreviousEmployersLiquidsCapital = _data["redemptionMonetaryCompensationPreviousEmployersLiquidsCapital"];
            this.annuityCompensationSequence = _data["annuityCompensationSequence"];
            this.sequenceCompensationRights = _data["sequenceCompensationRights"];
        }
    }

    static fromJS(data: any): VariousBalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new VariousBalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeInsurancePolicyId"] = this.lifeInsurancePolicyId;
        data["accrualValueDate"] = this.accrualValueDate ? this.accrualValueDate.toISOString() : <any>undefined;
        data["accumulationSeveranceFundsPreviousEmployers"] = this.accumulationSeveranceFundsPreviousEmployers;
        data["revenueValuesSeveranceFundsExemptionPensionPreviousEmployers"] = this.revenueValuesSeveranceFundsExemptionPensionPreviousEmployers;
        data["accumulationSeveranceFundsPreviousEmployersInAllowanceSequence"] = this.accumulationSeveranceFundsPreviousEmployersInAllowanceSequence;
        data["accumulationSeveranceFundsPreviousEmployersInRightsSequence"] = this.accumulationSeveranceFundsPreviousEmployersInRightsSequence;
        data["accumulationCompensationAnnuity"] = this.accumulationCompensationAnnuity;
        data["redemptionCompensationCurrentEmployer"] = this.redemptionCompensationCurrentEmployer;
        data["redemptionCompensationTaxPurposesCurrentEmployer"] = this.redemptionCompensationTaxPurposesCurrentEmployer;
        data["redemptionMonetaryCompensationPreviousEmployersInRightsSequence"] = this.redemptionMonetaryCompensationPreviousEmployersInRightsSequence;
        data["redemptionMonetaryCompensationPreviousEmployersLiquidsCapital"] = this.redemptionMonetaryCompensationPreviousEmployersLiquidsCapital;
        data["annuityCompensationSequence"] = this.annuityCompensationSequence;
        data["sequenceCompensationRights"] = this.sequenceCompensationRights;
        return data;
    }
}

export interface IVariousBalanceModel {
    id?: string;
    lifeInsurancePolicyId?: string;
    accrualValueDate?: Date;
    accumulationSeveranceFundsPreviousEmployers?: string | undefined;
    revenueValuesSeveranceFundsExemptionPensionPreviousEmployers?: string | undefined;
    accumulationSeveranceFundsPreviousEmployersInAllowanceSequence?: string | undefined;
    accumulationSeveranceFundsPreviousEmployersInRightsSequence?: string | undefined;
    accumulationCompensationAnnuity?: string | undefined;
    redemptionCompensationCurrentEmployer?: string | undefined;
    redemptionCompensationTaxPurposesCurrentEmployer?: string | undefined;
    redemptionMonetaryCompensationPreviousEmployersInRightsSequence?: string | undefined;
    redemptionMonetaryCompensationPreviousEmployersLiquidsCapital?: string | undefined;
    annuityCompensationSequence?: YesNoUnknown;
    sequenceCompensationRights?: YesNoUnknown;
}

export class Vehicle implements IVehicle {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    carYear?: number;
    licenseNumber?: string | undefined;
    identityCardIssueDate?: Date | undefined;
    carLicenseFilePath?: string | undefined;
    deliveryDate?: Date | undefined;
    modelCode?: string | undefined;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    entryToRoadDate?: Date;
    manufacturerId?: string | undefined;
    manufacturer?: Manufacturer;
    vehicleSubModelId?: string | undefined;
    vehicleSubModel?: VehicleSubModel;
    leads?: Lead[] | undefined;
    customerId?: string | undefined;
    customer?: Customer;
    vehicleOwnership?: VehicleOwnership;
    shieldNumber?: string | undefined;
    weightVolume?: string | undefined;
    vehicleWeight?: number;
    airBags?: number;
    protectionLevel?: string | undefined;
    gearsType?: GearsType;
    passengersNumber?: string | undefined;
    color?: string | undefined;
    usePurposesType?: UsePurposesType;
    vehicleValue?: number;
    vehicleAdditions?: string | undefined;

    constructor(data?: IVehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.carYear = _data["carYear"];
            this.licenseNumber = _data["licenseNumber"];
            this.identityCardIssueDate = _data["identityCardIssueDate"] ? new Date(_data["identityCardIssueDate"].toString()) : <any>undefined;
            this.carLicenseFilePath = _data["carLicenseFilePath"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.modelCode = _data["modelCode"];
            this.esp = _data["esp"];
            this.fcw = _data["fcw"];
            this.ldw = _data["ldw"];
            this.entryToRoadDate = _data["entryToRoadDate"] ? new Date(_data["entryToRoadDate"].toString()) : <any>undefined;
            this.manufacturerId = _data["manufacturerId"];
            this.manufacturer = _data["manufacturer"] ? Manufacturer.fromJS(_data["manufacturer"]) : <any>undefined;
            this.vehicleSubModelId = _data["vehicleSubModelId"];
            this.vehicleSubModel = _data["vehicleSubModel"] ? VehicleSubModel.fromJS(_data["vehicleSubModel"]) : <any>undefined;
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(Lead.fromJS(item));
            }
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.shieldNumber = _data["shieldNumber"];
            this.weightVolume = _data["weightVolume"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.airBags = _data["airBags"];
            this.protectionLevel = _data["protectionLevel"];
            this.gearsType = _data["gearsType"];
            this.passengersNumber = _data["passengersNumber"];
            this.color = _data["color"];
            this.usePurposesType = _data["usePurposesType"];
            this.vehicleValue = _data["vehicleValue"];
            this.vehicleAdditions = _data["vehicleAdditions"];
        }
    }

    static fromJS(data: any): Vehicle {
        data = typeof data === 'object' ? data : {};
        let result = new Vehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["carYear"] = this.carYear;
        data["licenseNumber"] = this.licenseNumber;
        data["identityCardIssueDate"] = this.identityCardIssueDate ? this.identityCardIssueDate.toISOString() : <any>undefined;
        data["carLicenseFilePath"] = this.carLicenseFilePath;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["modelCode"] = this.modelCode;
        data["esp"] = this.esp;
        data["fcw"] = this.fcw;
        data["ldw"] = this.ldw;
        data["entryToRoadDate"] = this.entryToRoadDate ? this.entryToRoadDate.toISOString() : <any>undefined;
        data["manufacturerId"] = this.manufacturerId;
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : <any>undefined;
        data["vehicleSubModelId"] = this.vehicleSubModelId;
        data["vehicleSubModel"] = this.vehicleSubModel ? this.vehicleSubModel.toJSON() : <any>undefined;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["shieldNumber"] = this.shieldNumber;
        data["weightVolume"] = this.weightVolume;
        data["vehicleWeight"] = this.vehicleWeight;
        data["airBags"] = this.airBags;
        data["protectionLevel"] = this.protectionLevel;
        data["gearsType"] = this.gearsType;
        data["passengersNumber"] = this.passengersNumber;
        data["color"] = this.color;
        data["usePurposesType"] = this.usePurposesType;
        data["vehicleValue"] = this.vehicleValue;
        data["vehicleAdditions"] = this.vehicleAdditions;
        return data;
    }
}

export interface IVehicle {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    carYear?: number;
    licenseNumber?: string | undefined;
    identityCardIssueDate?: Date | undefined;
    carLicenseFilePath?: string | undefined;
    deliveryDate?: Date | undefined;
    modelCode?: string | undefined;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    entryToRoadDate?: Date;
    manufacturerId?: string | undefined;
    manufacturer?: Manufacturer;
    vehicleSubModelId?: string | undefined;
    vehicleSubModel?: VehicleSubModel;
    leads?: Lead[] | undefined;
    customerId?: string | undefined;
    customer?: Customer;
    vehicleOwnership?: VehicleOwnership;
    shieldNumber?: string | undefined;
    weightVolume?: string | undefined;
    vehicleWeight?: number;
    airBags?: number;
    protectionLevel?: string | undefined;
    gearsType?: GearsType;
    passengersNumber?: string | undefined;
    color?: string | undefined;
    usePurposesType?: UsePurposesType;
    vehicleValue?: number;
    vehicleAdditions?: string | undefined;
}

export class VehicleDataModel implements IVehicleDataModel {
    id?: string;
    carYear?: number;
    licenseNumber?: string | undefined;
    carLicenseFilePath?: string | undefined;
    hasCarLicenseFile?: boolean;
    modelCode?: string | undefined;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    automaticInd?: boolean;
    entryToRoadDate?: Date;
    vehicleSubModelId?: string | undefined;
    vehicleSubModel?: VehicleSubModelModel;
    vehicleModel?: VehicleModelModel;
    manufacturer?: ManufacturerModel;
    leads?: LeadModel[] | undefined;
    customerId?: string | undefined;
    customer?: CustomerModel;
    vehicleOwnership?: VehicleOwnership;
    shieldNumber?: string | undefined;
    weightVolume?: string | undefined;
    vehicleWeight?: number;
    airBags?: number;
    protectionLevel?: string | undefined;
    gearsType?: GearsType;
    passengersNumber?: string | undefined;
    color?: string | undefined;
    usePurposesType?: UsePurposesType;
    vehicleValue?: number;
    otherVehicalsForEntity?: VehicleDataModel[] | undefined;
    vehicleAdditions?: string | undefined;

    constructor(data?: IVehicleDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carYear = _data["carYear"];
            this.licenseNumber = _data["licenseNumber"];
            this.carLicenseFilePath = _data["carLicenseFilePath"];
            this.hasCarLicenseFile = _data["hasCarLicenseFile"];
            this.modelCode = _data["modelCode"];
            this.esp = _data["esp"];
            this.fcw = _data["fcw"];
            this.ldw = _data["ldw"];
            this.entryToRoadDate = _data["entryToRoadDate"] ? new Date(_data["entryToRoadDate"].toString()) : <any>undefined;
            this.vehicleSubModelId = _data["vehicleSubModelId"];
            try {
                this.vehicleSubModel = _data["vehicleSubModel"] && _data["vehicleSubModel"] ? VehicleSubModelModel.fromJS(_data["vehicleSubModel"]) : <any>undefined;
            }
            catch (ex) { }
            try {
                this.vehicleModel = _data["vehicleModel"] && _data["vehicleModel"] ? VehicleModelModel.fromJS(_data["vehicleModel"]) : <any>undefined;
            }
            catch (ex) { }
            try {
                this.manufacturer = _data["manufacturer"] && _data["manufacturer"] ? ManufacturerModel.fromJS(_data["manufacturer"]) : <any>undefined;
            }
            catch (ex) { }


            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(LeadModel.fromJS(item));
            }
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.vehicleOwnership = _data["vehicleOwnership"];
            this.shieldNumber = _data["shieldNumber"];
            this.weightVolume = _data["weightVolume"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.airBags = _data["airBags"];
            this.protectionLevel = _data["protectionLevel"];
            this.gearsType = _data["gearsType"];
            this.passengersNumber = _data["passengersNumber"];
            this.color = _data["color"];
            this.usePurposesType = _data["usePurposesType"];
            this.vehicleValue = _data["vehicleValue"];
            this.vehicleAdditions = _data["vehicleAdditions"];
            if (Array.isArray(_data["otherVehicalsForEntity"])) {
                this.otherVehicalsForEntity = [] as any;
                for (let item of _data["otherVehicalsForEntity"])
                    this.otherVehicalsForEntity!.push(VehicleDataModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carYear"] = this.carYear;
        data["licenseNumber"] = this.licenseNumber;
        data["carLicenseFilePath"] = this.carLicenseFilePath;
        data["hasCarLicenseFile"] = this.hasCarLicenseFile;
        data["modelCode"] = this.modelCode;
        data["esp"] = this.esp;
        data["fcw"] = this.fcw;
        data["ldw"] = this.ldw;
        data["entryToRoadDate"] = this.entryToRoadDate ? (new Date(this.entryToRoadDate)).toISOString() : <any>undefined;
        data["vehicleSubModelId"] = this.vehicleSubModelId;
        // this.vehicleSubModel instanceof VehicleSubModelModel
        if (this.vehicleSubModel && this.vehicleSubModel instanceof VehicleSubModelModel) {
            data["vehicleSubModel"] = this.vehicleSubModel.toJSON();
        } else {
            if (this.vehicleSubModel) {
                data["vehicleSubModel"] = this.vehicleSubModel;
            } else {
                data["vehicleSubModel"] = <any>undefined;
            }
        }

        data["vehicleModel"] = this.vehicleModel && this.vehicleModel instanceof VehicleModelModel ? this.vehicleModel.toJSON() : <any>undefined;
        data["manufacturer"] = this.manufacturer && this.manufacturer instanceof ManufacturerModel ? this.manufacturer.toJSON() : <any>undefined;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vehicleOwnership"] = this.vehicleOwnership;
        data["shieldNumber"] = this.shieldNumber;
        data["weightVolume"] = this.weightVolume;
        data["vehicleWeight"] = this.vehicleWeight;
        data["airBags"] = this.airBags;
        data["protectionLevel"] = this.protectionLevel;
        data["gearsType"] = this.gearsType;
        data["passengersNumber"] = this.passengersNumber;
        data["color"] = this.color;
        data["usePurposesType"] = this.usePurposesType;
        data["vehicleValue"] = this.vehicleValue;
        data["vehicleAdditions"] = this.vehicleAdditions;
        if (Array.isArray(this.otherVehicalsForEntity)) {
            data["otherVehicalsForEntity"] = [];
            for (let item of this.otherVehicalsForEntity)
                data["otherVehicalsForEntity"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVehicleDataModel {
    id?: string;
    carYear?: number;
    licenseNumber?: string | undefined;
    carLicenseFilePath?: string | undefined;
    hasCarLicenseFile?: boolean;
    modelCode?: string | undefined;
    esp?: boolean;
    fcw?: boolean;
    ldw?: boolean;
    entryToRoadDate?: Date;
    vehicleSubModelId?: string | undefined;
    vehicleSubModel?: VehicleSubModelModel;
    vehicleModel?: VehicleModelModel;
    manufacturer?: ManufacturerModel;
    leads?: LeadModel[] | undefined;
    customerId?: string | undefined;
    customer?: CustomerModel;
    vehicleOwnership?: VehicleOwnership;
    shieldNumber?: string | undefined;
    weightVolume?: string | undefined;
    vehicleWeight?: number;
    airBags?: number;
    protectionLevel?: string | undefined;
    gearsType?: GearsType;
    passengersNumber?: string | undefined;
    color?: string | undefined;
    usePurposesType?: UsePurposesType;
    vehicleValue?: number;
    otherVehicalsForEntity?: VehicleDataModel[] | undefined;
}

export class VehicleModel implements IVehicleModel {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    manufacturerId?: string;
    manufacturer?: Manufacturer;
    vehicleSubModels?: VehicleSubModel[] | undefined;

    constructor(data?: IVehicleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.manufacturerId = _data["manufacturerId"];
            this.manufacturer = _data["manufacturer"] ? Manufacturer.fromJS(_data["manufacturer"]) : <any>undefined;
            if (Array.isArray(_data["vehicleSubModels"])) {
                this.vehicleSubModels = [] as any;
                for (let item of _data["vehicleSubModels"])
                    this.vehicleSubModels!.push(VehicleSubModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["manufacturerId"] = this.manufacturerId;
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : <any>undefined;
        if (Array.isArray(this.vehicleSubModels)) {
            data["vehicleSubModels"] = [];
            for (let item of this.vehicleSubModels)
                data["vehicleSubModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVehicleModel {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    manufacturerId?: string;
    manufacturer?: Manufacturer;
    vehicleSubModels?: VehicleSubModel[] | undefined;
}

export class VehicleModelModel implements IVehicleModelModel {
    id?: string;
    name?: string | undefined;
    checked?: number | undefined;
    manufacturerId?: string;
    manufacturer?: ManufacturerModel;
    vehicleSubModels?: VehicleSubModelModel[] | undefined;

    constructor(data?: IVehicleModelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.checked = _data["checked"];
            this.manufacturerId = _data["manufacturerId"];
            this.manufacturer = _data["manufacturer"] && _data["manufacturer"] instanceof ManufacturerModel ? ManufacturerModel.fromJS(_data["manufacturer"]) : <any>undefined;

            try {
                this.manufacturer = ManufacturerModel.fromJS(_data["manufacturer"]);
            }
            catch (ex) {
                this.manufacturer = <any>undefined;
            }

            if (Array.isArray(_data["vehicleSubModels"])) {
                this.vehicleSubModels = [] as any;
                for (let item of _data["vehicleSubModels"])
                    this.vehicleSubModels!.push(VehicleSubModelModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleModelModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["checked"] = this.checked;
        data["manufacturerId"] = this.manufacturerId;
        data["manufacturer"] = this.manufacturer && this.manufacturer instanceof ManufacturerModel ? this.manufacturer.toJSON() : <any>undefined;
        if (Array.isArray(this.vehicleSubModels)) {
            data["vehicleSubModels"] = [];
            for (let item of this.vehicleSubModels)
                data["vehicleSubModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVehicleModelModel {
    id?: string;
    name?: string | undefined;
    checked?: number | undefined;
    manufacturerId?: string;
    manufacturer?: ManufacturerModel;
    vehicleSubModels?: VehicleSubModelModel[] | undefined;
}

/** 0 = Private, 1 = Company, 2 = PrivateCollectible, 3 = CommercialCollectible, 4 = PersonalImportDetails, 5 = CommercialUpTo3_5Tons, 6 = DesertUpTo3_5Tons, 7 = PublicMinibus, 8 = PrivateMiniBus, 9 = PrivateRental, 10 = CommercialRental, 11 = HeavyMechanicalEquipment, 12 = DesertOver3_5Tons */
export enum VehicleOwnership {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
}

/** 0 = PrivateUpTo4Tons, 1 = CommercialUpTo4Tons, 2 = Truck, 3 = Taxi, 4 = LittleBus, 5 = Tractor, 6 = Dragged, 7 = Motorcycle, 8 = Other, 9 = PrivateCollectible, 10 = CommercialCollectible, 11 = PersonalImportDetails, 12 = CommercialUpTo3_5Tons, 13 = DesertUpTo3_5Tons, 14 = PublicMinibus, 15 = PrivateMiniBus, 16 = PrivateRental, 17 = CommercialRental, 18 = HeavyMechanicalEquipment, 19 = DesertOver3_5Tons */
export enum VehicleOwnership2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
}

export class VehicleSubModel implements IVehicleSubModel {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    vehicleModelId?: string;
    modelCode?: string | undefined;
    year?: number | undefined;
    vehicleModel?: VehicleModel;

    constructor(data?: IVehicleSubModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.vehicleModelId = _data["vehicleModelId"];
            this.modelCode = _data["modelCode"];
            this.year = _data["year"];
            this.vehicleModel = _data["vehicleModel"] ? VehicleModel.fromJS(_data["vehicleModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleSubModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleSubModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["vehicleModelId"] = this.vehicleModelId;
        data["modelCode"] = this.modelCode;
        data["year"] = this.year;
        data["vehicleModel"] = this.vehicleModel ? this.vehicleModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVehicleSubModel {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    name?: string | undefined;
    vehicleModelId?: string;
    modelCode?: string | undefined;
    year?: number | undefined;
    vehicleModel?: VehicleModel;
}

export class VehicleSubModelModel implements IVehicleSubModelModel {
    id?: string;
    name?: string | undefined;
    modelCode?: string | undefined;
    checked?: number | undefined;
    vehicleModelId?: string;
    vehicleModel?: VehicleModelModel;

    constructor(data?: IVehicleSubModelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modelCode = _data["modelCode"];
            this.checked = _data["checked"];
            this.vehicleModelId = _data["vehicleModelId"];
            try {
                this.vehicleModel = VehicleModelModel.fromJS(_data["vehicleModel"]);
            }
            catch (ex) { }
            //this.vehicleModel = _data["vehicleModel"] && _data["vehicleModel"] instanceof VehicleModelModel ? VehicleModelModel.fromJS(_data["vehicleModel"]) :_data["vehicleModel"] && _data["vehicleModel"] instanceof VehicleModel?VehicleModel.fromJS(_data["vehicleModel"]): <any>undefined;
        }
    }

    static fromJS(data: any): VehicleSubModelModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleSubModelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modelCode"] = this.modelCode;
        data["checked"] = this.checked;
        data["vehicleModelId"] = this.vehicleModelId;
        data["vehicleModel"] = this.vehicleModel && this.vehicleModel instanceof VehicleModelModel ? this.vehicleModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVehicleSubModelModel {
    id?: string;
    name?: string | undefined;
    modelCode?: string | undefined;
    checked?: number | undefined;
    vehicleModelId?: string;
    vehicleModel?: VehicleModelModel;
}

export class SubModelWithDegem implements ISubModelWithDegem {
    id?: string;
    name?: string | undefined;
    modelCode?: string | undefined;
    checked?: number | undefined;
    vehicleModelId?: string;
    vehicleModel?: VehicleModelModel;
    tozeretCd?: number;
    degemCd?: number;
    constructor(data?: ISubModelWithDegem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modelCode = _data["modelCode"];
            this.checked = _data["checked"];
            this.vehicleModelId = _data["vehicleModelId"];
            this.vehicleModel = _data["vehicleModel"] ? VehicleModelModel.fromJS(_data["vehicleModel"]) : <any>undefined;
            this.tozeretCd = _data["tozeretCd"];
            this.degemCd = _data["degemCd"];

        }
    }

    static fromJS(data: any): SubModelWithDegem {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleSubModelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modelCode"] = this.modelCode;
        data["checked"] = this.checked;
        data["vehicleModelId"] = this.vehicleModelId;
        data["vehicleModel"] = this.vehicleModel ? this.vehicleModel.toJSON() : <any>undefined;
        data["tozeretCd"] = this.tozeretCd;
        data["degemCd"] = this.degemCd;

        return data;
    }
}

export interface ISubModelWithDegem {
    id?: string;
    name?: string | undefined;
    modelCode?: string | undefined;
    checked?: number | undefined;
    vehicleModelId?: string;
    vehicleModel?: VehicleModelModel;
    tozeretCd?: number;
    degemCd?: number;
}

/** 0 = Private, 1 = Commercial */
export enum VehicleType {
    _0 = 0,
    _1 = 1,
}

export class Version implements IVersion {
    major?: number;
    minor?: number;
    build?: number;
    revision?: number;
    readonly majorRevision?: number;
    readonly minorRevision?: number;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.build = _data["build"];
            this.revision = _data["revision"];
            (<any>this).majorRevision = _data["majorRevision"];
            (<any>this).minorRevision = _data["minorRevision"];
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["build"] = this.build;
        data["revision"] = this.revision;
        data["majorRevision"] = this.majorRevision;
        data["minorRevision"] = this.minorRevision;
        return data;
    }
}

export interface IVersion {
    major?: number;
    minor?: number;
    build?: number;
    revision?: number;
    majorRevision?: number;
    minorRevision?: number;
}

export class WhatsAppManagement implements IWhatsAppManagement {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IWhatsAppManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): WhatsAppManagement {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsAppManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IWhatsAppManagement {
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    key?: string | undefined;
    value?: string | undefined;
}

export class WhatsAppManagementInput implements IWhatsAppManagementInput {
    elementari_newsue_a?: string | undefined;
    elementari_newsue_b?: string | undefined;
    elementari_statusexistsue_a?: string | undefined;
    elementari_statusexistsue_b?: string | undefined;
    elementari_proposenew_a?: string | undefined;
    elementari_proposenew_b?: string | undefined;
    elementari_proposerenew_a?: string | undefined;
    elementari_proposerenew_b?: string | undefined;
    elementari_copypolicy_a?: string | undefined;
    elementari_copypolicy_b?: string | undefined;
    elementari_bondage_a?: string | undefined;
    elementari_bondage_b?: string | undefined;
    elementari_changedrivers_a?: string | undefined;
    elementari_changedrivers_b?: string | undefined;
    elementari_cancel_a?: string | undefined;
    elementari_cancel_b?: string | undefined;
    elementari_payment_a?: string | undefined;
    elementari_payment_b?: string | undefined;
    elementari_chat_a?: string | undefined;
    elementari_chat_b?: string | undefined;
    life_newsue_a?: string | undefined;
    life_newsue_b?: string | undefined;
    life_existsue_a?: string | undefined;
    life_existsue_b?: string | undefined;
    life_newpropose_a?: string | undefined;
    life_newpropose_b?: string | undefined;
    life_existpropose_a?: string | undefined;
    life_existpropose_b?: string | undefined;
    life_copypolicy_a?: string | undefined;
    life_copypolicy_b?: string | undefined;
    life_payment_a?: string | undefined;
    life_payment_b?: string | undefined;
    life_other_a?: string | undefined;
    life_other_b?: string | undefined;
    measef_a?: string | undefined;
    measef_b?: string | undefined;

    constructor(data?: IWhatsAppManagementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementari_newsue_a = _data["elementari_newsue_a"];
            this.elementari_newsue_b = _data["elementari_newsue_b"];
            this.elementari_statusexistsue_a = _data["elementari_statusexistsue_a"];
            this.elementari_statusexistsue_b = _data["elementari_statusexistsue_b"];
            this.elementari_proposenew_a = _data["elementari_proposenew_a"];
            this.elementari_proposenew_b = _data["elementari_proposenew_b"];
            this.elementari_proposerenew_a = _data["elementari_proposerenew_a"];
            this.elementari_proposerenew_b = _data["elementari_proposerenew_b"];
            this.elementari_copypolicy_a = _data["elementari_copypolicy_a"];
            this.elementari_copypolicy_b = _data["elementari_copypolicy_b"];
            this.elementari_bondage_a = _data["elementari_bondage_a"];
            this.elementari_bondage_b = _data["elementari_bondage_b"];
            this.elementari_changedrivers_a = _data["elementari_changedrivers_a"];
            this.elementari_changedrivers_b = _data["elementari_changedrivers_b"];
            this.elementari_cancel_a = _data["elementari_cancel_a"];
            this.elementari_cancel_b = _data["elementari_cancel_b"];
            this.elementari_payment_a = _data["elementari_payment_a"];
            this.elementari_payment_b = _data["elementari_payment_b"];
            this.elementari_chat_a = _data["elementari_chat_a"];
            this.elementari_chat_b = _data["elementari_chat_b"];
            this.life_newsue_a = _data["life_newsue_a"];
            this.life_newsue_b = _data["life_newsue_b"];
            this.life_existsue_a = _data["life_existsue_a"];
            this.life_existsue_b = _data["life_existsue_b"];
            this.life_newpropose_a = _data["life_newpropose_a"];
            this.life_newpropose_b = _data["life_newpropose_b"];
            this.life_existpropose_a = _data["life_existpropose_a"];
            this.life_existpropose_b = _data["life_existpropose_b"];
            this.life_copypolicy_a = _data["life_copypolicy_a"];
            this.life_copypolicy_b = _data["life_copypolicy_b"];
            this.life_payment_a = _data["life_payment_a"];
            this.life_payment_b = _data["life_payment_b"];
            this.life_other_a = _data["life_other_a"];
            this.life_other_b = _data["life_other_b"];
            this.measef_a = _data["measef_a"];
            this.measef_b = _data["measef_b"];
        }
    }

    static fromJS(data: any): WhatsAppManagementInput {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsAppManagementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementari_newsue_a"] = this.elementari_newsue_a;
        data["elementari_newsue_b"] = this.elementari_newsue_b;
        data["elementari_statusexistsue_a"] = this.elementari_statusexistsue_a;
        data["elementari_statusexistsue_b"] = this.elementari_statusexistsue_b;
        data["elementari_proposenew_a"] = this.elementari_proposenew_a;
        data["elementari_proposenew_b"] = this.elementari_proposenew_b;
        data["elementari_proposerenew_a"] = this.elementari_proposerenew_a;
        data["elementari_proposerenew_b"] = this.elementari_proposerenew_b;
        data["elementari_copypolicy_a"] = this.elementari_copypolicy_a;
        data["elementari_copypolicy_b"] = this.elementari_copypolicy_b;
        data["elementari_bondage_a"] = this.elementari_bondage_a;
        data["elementari_bondage_b"] = this.elementari_bondage_b;
        data["elementari_changedrivers_a"] = this.elementari_changedrivers_a;
        data["elementari_changedrivers_b"] = this.elementari_changedrivers_b;
        data["elementari_cancel_a"] = this.elementari_cancel_a;
        data["elementari_cancel_b"] = this.elementari_cancel_b;
        data["elementari_payment_a"] = this.elementari_payment_a;
        data["elementari_payment_b"] = this.elementari_payment_b;
        data["elementari_chat_a"] = this.elementari_chat_a;
        data["elementari_chat_b"] = this.elementari_chat_b;
        data["life_newsue_a"] = this.life_newsue_a;
        data["life_newsue_b"] = this.life_newsue_b;
        data["life_existsue_a"] = this.life_existsue_a;
        data["life_existsue_b"] = this.life_existsue_b;
        data["life_newpropose_a"] = this.life_newpropose_a;
        data["life_newpropose_b"] = this.life_newpropose_b;
        data["life_existpropose_a"] = this.life_existpropose_a;
        data["life_existpropose_b"] = this.life_existpropose_b;
        data["life_copypolicy_a"] = this.life_copypolicy_a;
        data["life_copypolicy_b"] = this.life_copypolicy_b;
        data["life_payment_a"] = this.life_payment_a;
        data["life_payment_b"] = this.life_payment_b;
        data["life_other_a"] = this.life_other_a;
        data["life_other_b"] = this.life_other_b;
        data["measef_a"] = this.measef_a;
        data["measef_b"] = this.measef_b;
        return data;
    }
}

export interface IWhatsAppManagementInput {
    elementari_newsue_a?: string | undefined;
    elementari_newsue_b?: string | undefined;
    elementari_statusexistsue_a?: string | undefined;
    elementari_statusexistsue_b?: string | undefined;
    elementari_proposenew_a?: string | undefined;
    elementari_proposenew_b?: string | undefined;
    elementari_proposerenew_a?: string | undefined;
    elementari_proposerenew_b?: string | undefined;
    elementari_copypolicy_a?: string | undefined;
    elementari_copypolicy_b?: string | undefined;
    elementari_bondage_a?: string | undefined;
    elementari_bondage_b?: string | undefined;
    elementari_changedrivers_a?: string | undefined;
    elementari_changedrivers_b?: string | undefined;
    elementari_cancel_a?: string | undefined;
    elementari_cancel_b?: string | undefined;
    elementari_payment_a?: string | undefined;
    elementari_payment_b?: string | undefined;
    elementari_chat_a?: string | undefined;
    elementari_chat_b?: string | undefined;
    life_newsue_a?: string | undefined;
    life_newsue_b?: string | undefined;
    life_existsue_a?: string | undefined;
    life_existsue_b?: string | undefined;
    life_newpropose_a?: string | undefined;
    life_newpropose_b?: string | undefined;
    life_existpropose_a?: string | undefined;
    life_existpropose_b?: string | undefined;
    life_copypolicy_a?: string | undefined;
    life_copypolicy_b?: string | undefined;
    life_payment_a?: string | undefined;
    life_payment_b?: string | undefined;
    life_other_a?: string | undefined;
    life_other_b?: string | undefined;
    measef_a?: string | undefined;
    measef_b?: string | undefined;
}

export class WhatsAppModel implements IWhatsAppModel {
    currentPage?: number;
    pagE_SIZE?: number;
    allMailsCounter?: number;
    messages?: any[];
    message?: any;
    groupMessages?: any[];

    constructor(data?: IWhatsAppModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pagE_SIZE = _data["pagE_SIZE"];
            this.allMailsCounter = _data["allMailsCounter"];
            this.messages = _data['messages']
            this.message = _data['message']
            this.groupMessages = _data['groupMessages']
        }
    }

    static fromJS(data: any): WhatsAppModel {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsAppModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pagE_SIZE"] = this.pagE_SIZE;
        data["allMailsCounter"] = this.allMailsCounter;
        data["messages"] = this.messages;
        data["message"] = this.message;
        data["groupMessages"] = this.groupMessages;
        return data;
    }
}

export interface IWhatsAppModel {
    currentPage?: number;
    pagE_SIZE?: number;
    allMailsCounter?: number;
}


// export class WhatsAppMessage implements IWhatsAppMessage {
//     text?: string;
//     leadId?: string;
//     senderPhoneNumber?: string;
//     senderUserId?: string;
//     userId?:string;
//     receiverPhoneNumber?: string;
//     receiverUserId?: string;
//     replyToMessageId?:string;
//     isTransfer?:number;
//     customerPhoneNumber?:string;
//     customerName?:string;
//     agentPhoneNumber?:string;
//     reciveOrSent?:boolean;
//     timeStamp?:number;
//     whatsAppMsgId?:number;
//     html?:string;
//     botStage?:string;
//     connectedUserId?:string;
//     isRead?:boolean;
//     innerMsg?:boolean;
//     star?:boolean;
//     identifier?:string;
//     id?: string;
//     isDeleted?: boolean;
//     createdDate?: Date;
//     updatedDate?: Date;

//     constructor(data?: IWhatsAppMessage) {
//         if (data) {
//             for (var property in data) {
//                 if (data.hasOwnProperty(property))
//                     (<any>this)[property] = (<any>data)[property];
//             }
//         }
//     }

//     init(_data?: any) {
//         if (_data) {
//             this.text = _data["text"];
//             this.leadId = _data["leadId"];
//             this.senderPhoneNumber = _data["senderPhoneNumber"];
//             this.senderUserId = _data['senderUserId']
//             this.receiverPhoneNumber = _data['receiverPhoneNumber']
//             this.receiverUserId = _data['receiverUserId']
//             this.replyToMessageId = _data["replyToMessageId"];
//             this.isTransfer = _data["isTransfer"];
//             this.customerPhoneNumber = _data["customerPhoneNumber"];
//             this.customerName = _data['customerName']
//             this.agentPhoneNumber = _data['agentPhoneNumber']
//             this.reciveOrSent = _data['reciveOrSent']
//             this.timeStamp = _data["timeStamp"];
//             this.whatsAppMsgId = _data["whatsAppMsgId"];
//             this.html = _data["html"];
//             this.botStage = _data['botStage']
//             this.connectedUserId = _data['connectedUserId']
//             this.isRead = _data['isRead']
//             this.innerMsg = _data["innerMsg"];
//             this.star = _data["star"];
//             this.identifier = _data["identifier"];
//             this.id = _data["id"];
//             this.isDeleted = _data["isDeleted"];
//             this.createdDate = _data["createdDate"];
//             this.updatedDate = _data["updatedDate"];

//         }
//     }

//     static fromJS(data: any): WhatsAppMessage {
//         data = typeof data === 'object' ? data : {};
//         let result = new WhatsAppMessage();
//         result.init(data);
//         return result;
//     }

//     toJSON(data?: any) {
//         data = typeof data === 'object' ? data : {};
//         data["text"] = this.text;
//         data["leadId"] = this.leadId;
//         data["senderUserId"] = this.senderUserId;
//         data["senderPhoneNumber"] = this.senderPhoneNumber;
//         data["receiverPhoneNumber"] = this.receiverPhoneNumber;
//         data["receiverUserId"] = this.receiverUserId;
//         data["replyToMessageId"] = this.replyToMessageId;
//         data["isTransfer"] = this.isTransfer;
//         data["customerPhoneNumber"] = this.customerPhoneNumber;
//         data["customerName"] = this.customerName;
//         data["agentPhoneNumber"] = this.agentPhoneNumber;
//         data["reciveOrSent"] = this.reciveOrSent;
//         data["timeStamp"] = this.timeStamp;
//         data["whatsAppMsgId"] = this.whatsAppMsgId;
//         data["html"] = this.html;
//         data["botStage"] = this.botStage;
//         data["connectedUserId"] = this.connectedUserId;
//         data["isRead"] = this.isRead;
//         data["innerMsg"] = this.innerMsg;
//         data["star"] = this.star;
//         data["identifier"] = this.identifier;
//         data["id"] = this.id;
//         data["isDeleted"] = this.isDeleted;
//         data["createdDate"] = this.createdDate;
//         data["updatedDate"] = this.updatedDate;


//         return data; 
//     }
// }

// export interface IWhatsAppMessage {
//     Text?: string;
//     LeadId?: string;
//     SenderPhoneNumber?: string;
//     SenderUserId?: string;
//     ReceiverPhoneNumber?: string;
//     ReceiverUserId?: string;
//     ReplyToMessageId?:string;
//     IsTransfer?:number;
//     CustomerPhoneNumber?:string;
//     CustomerName?:string;
//     AgentPhoneNumber?:string;
//     ReciveOrSent?:boolean;
//     TimeStamp?:number;
//     whatsAppMsgId?:number;
//     html?:string;
//     BotStage?:string;
//     ConnectedUserId?:string;
//     IsRead?:boolean;
//     innerMsg?:boolean;
//     star?:boolean;
//     identifier?:string;
//     id?: string;
//     isDeleted?: boolean;
//     createdDate?: Date;
//     updatedDate?: Date;
// }


export class WhatsAppMessage implements IWhatsAppMessage {
    userId?: string;
    Text?: string;
    LeadId?: string;
    SenderPhoneNumber?: string;
    SenderUserId?: string;
    ReceiverPhoneNumber?: string;
    ReceiverUserId?: string;
    ReplyToMessageId?: string;
    IsTransfer?: number;
    CustomerPhoneNumber?: string;
    CustomerName?: string;
    AgentPhoneNumber?: string;
    ReciveOrSent?: boolean;
    TimeStamp?: number;
    whatsAppMsgId?: number;
    html?: string;
    BotStage?: string;
    ConnectedUserId?: string;
    IsRead?: boolean;
    innerMsg?: boolean;
    star?: boolean;
    identifier?: string;
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    transferDate?: Date;
    isTransferMessage?: boolean;

    constructor(data?: IWhatsAppMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Text = _data["Text"];
            this.LeadId = _data["LeadId"];
            this.SenderPhoneNumber = _data["SenderPhoneNumber"];
            this.SenderUserId = _data['SenderUserId']
            this.ReceiverPhoneNumber = _data['ReceiverPhoneNumber']
            this.ReceiverUserId = _data['ReceiverUserId']
            this.ReplyToMessageId = _data["ReplyToMessageId"];
            this.IsTransfer = _data["IsTransfer"];
            this.CustomerPhoneNumber = _data["CustomerPhoneNumber"];
            this.CustomerName = _data['CustomerName']
            this.AgentPhoneNumber = _data['AgentPhoneNumber']
            this.ReciveOrSent = _data['ReciveOrSent']
            this.TimeStamp = _data["TimeStamp"];
            this.whatsAppMsgId = _data["whatsAppMsgId"];
            this.html = _data["html"];
            this.BotStage = _data['BotStage']
            this.ConnectedUserId = _data['ConnectedUserId']
            this.IsRead = _data['IsRead']
            this.innerMsg = _data["innerMsg"];
            this.star = _data["star"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"];
            this.updatedDate = _data["updatedDate"];
            this.transferDate = _data["transferDate"];
            this.isTransferMessage = _data["isTransferMessage"];





        }
    }

    static fromJS(data: any): WhatsAppMessage {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsAppMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.Text;
        data["LeadId"] = this.LeadId;
        data["SenderPhoneNumber"] = this.SenderPhoneNumber;
        data["SenderUserId"] = this.SenderUserId;
        data["ReceiverPhoneNumber"] = this.ReceiverPhoneNumber;
        data["ReceiverUserId"] = this.ReceiverUserId;
        data["ReplyToMessageId"] = this.ReplyToMessageId;
        data["IsTransfer"] = this.IsTransfer;
        data["CustomerPhoneNumber"] = this.CustomerPhoneNumber;
        data["CustomerName"] = this.CustomerName;
        data["AgentPhoneNumber"] = this.AgentPhoneNumber;
        data["ReciveOrSent"] = this.ReciveOrSent;
        data["TimeStamp"] = this.TimeStamp;
        data["whatsAppMsgId"] = this.whatsAppMsgId;
        data["html"] = this.html;
        data["BotStage"] = this.BotStage;
        data["ConnectedUserId"] = this.ConnectedUserId;
        data["IsRead"] = this.IsRead;
        data["innerMsg"] = this.innerMsg;
        data["star"] = this.star;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate;
        data["updatedDate"] = this.updatedDate;
        data["transferDate"] = this.transferDate;
        data["isTransferMessage"] = this.isTransferMessage;


        return data;
    }
}

export interface IWhatsAppMessage {
    Text?: string;
    LeadId?: string;
    SenderPhoneNumber?: string;
    SenderUserId?: string;
    ReceiverPhoneNumber?: string;
    ReceiverUserId?: string;
    ReplyToMessageId?: string;
    IsTransfer?: number;
    CustomerPhoneNumber?: string;
    CustomerName?: string;
    AgentPhoneNumber?: string;
    ReciveOrSent?: boolean;
    TimeStamp?: number;
    whatsAppMsgId?: number;
    html?: string;
    BotStage?: string;
    ConnectedUserId?: string;
    IsRead?: boolean;
    innerMsg?: boolean;
    star?: boolean;
    identifier?: string;
    id?: string;
    isDeleted?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
}

/** 1 = Highest, 2 = High, 3 = Normal, 4 = Low, 5 = Lowest */
export enum XMessagePriority {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** 0 = Yes, 1 = No */
export enum YesNo {
    _0 = 0,
    _1 = 1,
}

/** 0 = Yest, 1 = No, 2 = Irrelevant */
export enum YesNoIrrelevant {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = Yes, 1 = No, 2 = Lag */
export enum YesNoLag {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 0 = Yest, 1 = No, 2 = Unknown */
export enum YesNoUnknown {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }



}

export class ModuleModel implements IModuleModel {
    name?: string;
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;

    constructor(data?: IModuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"]) : undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"]) : undefined;
        }
    }

    static fromJS(data: any): ModuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["createdDate"] = this.createdDate?.toISOString();
        data["updatedDate"] = this.updatedDate?.toISOString();
        return data;
    }
}

export interface IModuleModel {
    name?: string;
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
}

export class DynamicColModel implements IDynamicColModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    moduleId?: string;
    module?: ModuleModel;
    name?: string;
    title?: string;

    constructor(data?: IDynamicColModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"]) : undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"]) : undefined;
            this.moduleId = _data["moduleId"];
            this.module = _data["module"] ? ModuleModel.fromJS(_data["module"]) : undefined;
            this.name = _data["name"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): DynamicColModel {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicColModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate?.toISOString();
        data["updatedDate"] = this.updatedDate?.toISOString();
        data["moduleId"] = this.moduleId;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        data["name"] = this.name;
        data["title"] = this.title;
        return data;
    }
}


export interface IDynamicColModel {
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
    moduleId?: string;
    module?: ModuleModel;
    name?: string;
    title?: string;
}

export class UserDynamicColModel implements IUserDynamicColModel {
    dynamicColId?: string;
    dynamicCol?: DynamicColModel;
    userId?: string;
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;

    constructor(data?: IUserDynamicColModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicColId = _data["dynamicColId"];
            this.dynamicCol = _data["dynamicCol"] ? DynamicColModel.fromJS(_data["dynamicCol"]) : undefined;
            this.userId = _data["userId"];
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"]) : undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"]) : undefined;
        }
    }

    static fromJS(data: any): UserDynamicColModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserDynamicColModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicColId"] = this.dynamicColId;
        data["dynamicCol"] = this.dynamicCol ? this.dynamicCol.toJSON() : undefined;
        data["userId"] = this.userId;
        data["id"] = this.id;
        data["createdDate"] = this.createdDate?.toISOString();
        data["updatedDate"] = this.updatedDate?.toISOString();
        return data;
    }
}

export interface IUserDynamicColModel {
    dynamicColId?: string;
    dynamicCol?: DynamicColModel;
    userId?: string;
    id?: string;
    createdDate?: Date;
    updatedDate?: Date;
}


function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}


function customJSONStringify(obj: any, visited: Set<any> = new Set()): any {
    // Check if the object has already been visited
    // if (visited.has(obj)) {
    //     return '[Circular]';
    // }
    // Add the object to the set of visited objects
    try {
        visited.add(obj);

        // Check if the given object is a Date
        if (obj instanceof Date) {
            // Convert Date to ISO string format

            const currentGMT = (obj.getTimezoneOffset() / 60) * -1;
            obj = new Date(obj.getTime() + currentGMT * 60 * 60 * 1000);

            // obj.setUTCHours(obj.getHours());
            // obj.setUTCMinutes(obj.getMinutes());
            // obj.setUTCSeconds(obj.getSeconds());

            //obj = moment.utc(obj).toDate();
            //obj = moment.tz(obj, "Etc/GMT+0").toDate();
            return obj;
            //         obj.setHours(obj.getHours() + UTC);
            // return obj;
            //return obj.toISOString();
        }
        // If the object is not a Date, iterate over its properties
        else if (typeof obj === 'object' && obj !== null) {
            // Iterate over each property of the object
            const keys = Object.keys(obj);
            keys.forEach((key: string) => {
                if (key == 'treatmentActivities') {
                    // 
                }
                const value = obj[key];
                if (typeof value === 'object' && value !== null) {
                    try {
                        obj[key] = customJSONStringify(value, visited);
                    } catch (error) {
                        obj[key] = JSON.stringify(value);
                    }
                }
                //console.log("customJSONStringify",key, obj[key]);
            })
            for (let key in obj) {
                // Replace circular references with a placeholder
                // const value = obj[key];
                // if (typeof value === 'object' && value !== null) {
                //     obj[key] = customJSONStringify(value, visited);
                // }
                // ////console.log("customJSONStringify",key, obj[key]);
            }
        }
        // Return the modified object
        return obj;
    }
    catch (e: any) {
        // 
        console.log('e', e)
        return null;
    }
}



function JSONStringify(body: any) {
    var obj = null;
    obj = customJSONStringify(body);
    if (obj && typeof obj !== 'undefined') {
        return JSON.stringify(obj);
    } else {
        return '';
    }
    // try{
    //     obj = customJSONStringify(body);
    //     return JSON.stringify(obj);
    // }
    // catch(ex){
    //     for (let key in obj) {
    //         let jsonString = '';
    //         try {
    //           JSON.stringify(obj[key]);
    //         } catch (error:any) {
    //           console.error(`Error in property '${key}':`, error.message);
    //         }
    //       }


    //     return obj == null ? '' : obj;
    // }

}

const originalToISOString = Date.prototype.toISOString;
// Override the toISOString method
Date.prototype.toISOString = function () {

    if (this.getUTCFullYear() === 0 && this.getUTCMonth() === 11 && this.getUTCDate() === 31) {
        return "0001-01-01T00:00:00.000Z";
    }
    return originalToISOString.call(this);
};




